// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3e%3cpath fill=%27none%27 stroke=%27%23323a49%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%272%27 d=%27m2 5 6 6 6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3e%3cpath fill=%27none%27 stroke=%27rgba%28255, 255, 255, 0.87%29%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%272%27 d=%27m2 5 6 6 6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 20 20%27%3e%3cpath fill=%27none%27 stroke=%27rgba%28255, 255, 255, 0.87%29%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%273%27 d=%27m6 10 3 3 6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%272%27 fill=%27rgba%28255, 255, 255, 0.87%29%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 20 20%27%3e%3cpath fill=%27none%27 stroke=%27rgba%28255, 255, 255, 0.87%29%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%273%27 d=%27M6 10h8%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27rgba%288, 10, 12, 0.25%29%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27rgba%28255, 255, 255, 0.87%29%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27rgba%28255, 255, 255, 0.25%29%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 8 8%27%3e%3cpath fill=%27%231b9e3e%27 d=%27M2.3 6.73.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 12 12%27 width=%2712%27 height=%2712%27 fill=%27none%27 stroke=%27%23e55353%27%3e%3ccircle cx=%276%27 cy=%276%27 r=%274.5%27/%3e%3cpath stroke-linejoin=%27round%27 d=%27M5.8 3.6h.4L6 6.5z%27/%3e%3ccircle cx=%276%27 cy=%278.2%27 r=%27.6%27 fill=%27%23e55353%27 stroke=%27none%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 30 30%27%3e%3cpath stroke=%27rgba%28255, 255, 255, 0.55%29%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 stroke-width=%272%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27none%27 stroke=%27%233634a3%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27%3e%3cpath d=%27m2 5 6 6 6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27rgba%28255, 255, 255, 0.87%29%27%3e%3cpath fill-rule=%27evenodd%27 d=%27M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23080a0c%27%3e%3cpath d=%27M.293.293a1 1 0 0 1 1.414 0L8 6.586 14.293.293a1 1 0 1 1 1.414 1.414L9.414 8l6.293 6.293a1 1 0 0 1-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 0 1-1.414-1.414L6.586 8 .293 1.707a1 1 0 0 1 0-1.414%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23fff%27%3e%3cpath d=%27M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23fff%27%3e%3cpath d=%27M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_16___ = new URL("data:image/svg+xml;charset=utf8,%3Csvg viewBox=%270 0 30 30%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Cpath stroke=%27rgba%28var%28--cui-emphasis-color-rgb%29, 0.65%29%27 stroke-width=%272.25%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_17___ = new URL("data:image/svg+xml;charset=utf8,%3Csvg viewBox=%270 0 30 30%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Cpath stroke=%27rgba%28var%28--cui-emphasis-color-rgb%29, 0.8%29%27 stroke-width=%272.25%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_18___ = new URL("data:image/svg+xml,%0A%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 512 512%27%3E%3Cg xmlns=%27http://www.w3.org/2000/svg%27 transform=%27matrix%28-1 0 0 -1 512 512%29%27%3E%3Cpath fill=%27%23000%27 d=%27M472,16H40A24.028,24.028,0,0,0,16,40V200H48V48H464V464H48V304H16V472a24.028,24.028,0,0,0,24,24H472a24.028,24.028,0,0,0,24-24V40A24.028,24.028,0,0,0,472,16Z%27/%3E%3Cpolygon fill=%27%23000%27 points=%27209.377 363.306 232.004 385.933 366.627 251.31 232.004 116.687 209.377 139.313 305.374 235.311 16 235.311 16 267.311 305.372 267.311 209.377 363.306%27/%3E%3C/g%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_19___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3e%3cpath fill-rule=%27evenodd%27 d=%27M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_20___ = new URL("./next2.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_21___ = new URL("./next.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___);
var ___CSS_LOADER_URL_REPLACEMENT_17___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_17___);
var ___CSS_LOADER_URL_REPLACEMENT_18___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_18___);
var ___CSS_LOADER_URL_REPLACEMENT_19___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_19___);
var ___CSS_LOADER_URL_REPLACEMENT_20___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_20___);
var ___CSS_LOADER_URL_REPLACEMENT_21___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_21___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/*!
 * CoreUI  v5.9.1 (https://coreui.io)
 * Copyright (c) 2026 creativeLabs Łukasz Holeczek
 * Licensed under MIT (https://github.com/coreui/coreui/blob/main/LICENSE)
 */
:root,
[data-coreui-theme=light] {
  --cui-blue: #0d6efd;
  --cui-indigo: #6610f2;
  --cui-purple: #6f42c1;
  --cui-pink: #d63384;
  --cui-red: #dc3545;
  --cui-orange: #fd7e14;
  --cui-yellow: #ffc107;
  --cui-green: #198754;
  --cui-teal: #20c997;
  --cui-cyan: #0dcaf0;
  --cui-black: #080a0c;
  --cui-white: #fff;
  --cui-gray: #6d7d9c;
  --cui-gray-dark: #323a49;
  --cui-gray-100: #f3f4f7;
  --cui-gray-200: #e7eaee;
  --cui-gray-300: #dbdfe6;
  --cui-gray-400: #cfd4de;
  --cui-gray-500: #aab3c5;
  --cui-gray-600: #6d7d9c;
  --cui-gray-700: #4a566d;
  --cui-gray-800: #323a49;
  --cui-gray-900: #212631;
  --cui-primary: #5856d6;
  --cui-secondary: #6b7785;
  --cui-success: #1b9e3e;
  --cui-info: #39f;
  --cui-warning: #f9b115;
  --cui-danger: #e55353;
  --cui-light: #f3f4f7;
  --cui-dark: #212631;
  --cui-primary-rgb: 88, 86, 214;
  --cui-secondary-rgb: 107, 119, 133;
  --cui-success-rgb: 27, 158, 62;
  --cui-info-rgb: 51, 153, 255;
  --cui-warning-rgb: 249, 177, 21;
  --cui-danger-rgb: 229, 83, 83;
  --cui-light-rgb: 243, 244, 247;
  --cui-dark-rgb: 33, 38, 49;
  --cui-primary-text-emphasis: #3634a3;
  --cui-secondary-text-emphasis: #212233;
  --cui-success-text-emphasis: #0f5722;
  --cui-info-text-emphasis: #184c77;
  --cui-warning-text-emphasis: #764705;
  --cui-danger-text-emphasis: #671414;
  --cui-light-text-emphasis: #4a566d;
  --cui-dark-text-emphasis: #323a49;
  --cui-primary-bg-subtle: #cfc7f3;
  --cui-secondary-bg-subtle: #ced2d8;
  --cui-success-bg-subtle: #cbedd6;
  --cui-info-bg-subtle: #c0e6ff;
  --cui-warning-bg-subtle: #feecc5;
  --cui-danger-bg-subtle: #f9d4d4;
  --cui-light-bg-subtle: rgb(97.6470588235%, 97.8431372549%, 98.431372549%);
  --cui-dark-bg-subtle: #cfd4de;
  --cui-primary-border-subtle: #9d92e6;
  --cui-secondary-border-subtle: #9da5b1;
  --cui-success-border-subtle: #96dbad;
  --cui-info-border-subtle: #80c6ff;
  --cui-warning-border-subtle: #fcd88a;
  --cui-danger-border-subtle: #f2a9a9;
  --cui-light-border-subtle: #e7eaee;
  --cui-dark-border-subtle: #aab3c5;
  --cui-primary-contrast: #fff;
  --cui-secondary-contrast: #fff;
  --cui-success-contrast: #080a0c;
  --cui-info-contrast: #080a0c;
  --cui-warning-contrast: #080a0c;
  --cui-danger-contrast: #080a0c;
  --cui-light-contrast: #080a0c;
  --cui-dark-contrast: #fff;
  --cui-white-rgb: 255, 255, 255;
  --cui-black-rgb: 8, 10, 12;
  --cui-font-sans-serif: system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", "Noto Sans", "Liberation Sans", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  --cui-font-monospace: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
  --cui-gradient: linear-gradient(180deg, rgba(255, 255, 255, 0.15), rgba(255, 255, 255, 0));
  --cui-body-font-family: var(--cui-font-sans-serif);
  --cui-body-font-size: 1rem;
  --cui-body-font-weight: 400;
  --cui-body-line-height: 1.5;
  --cui-body-color: rgba(14.5098039216%, 16.831372549%, 21.1843137255%, 0.95);
  --cui-body-color-rgb: 37, 42.92, 54.02;
  --cui-body-bg: #fff;
  --cui-body-bg-rgb: 255, 255, 255;
  --cui-emphasis-color: #080a0c;
  --cui-emphasis-color-rgb: 8, 10, 12;
  --cui-secondary-color: rgba(14.5098039216%, 16.831372549%, 21.1843137255%, 0.681);
  --cui-secondary-color-rgb: 37, 42.92, 54.02;
  --cui-secondary-bg: #e7eaee;
  --cui-secondary-bg-rgb: 231, 234, 238;
  --cui-tertiary-color: rgba(14.5098039216%, 16.831372549%, 21.1843137255%, 0.38);
  --cui-tertiary-color-rgb: 37, 42.92, 54.02;
  --cui-tertiary-bg: #f3f4f7;
  --cui-tertiary-bg-rgb: 243, 244, 247;
  --cui-tertiary-bg-translucent: rgba(135, 145, 175, 0.1);
  --cui-body-color-dark: rgba(255, 255, 255, 0.87);
  --cui-body-color-rgb-dark: 255, 255, 255;
  --cui-body-bg-dark: #212631;
  --cui-body-bg-rgb-dark: 33, 38, 49;
  --cui-emphasis-color-dark: #fff;
  --cui-emphasis-color-rgb-dark: 255, 255, 255;
  --cui-secondary-color-dark: rgba(255, 255, 255, 0.6);
  --cui-secondary-color-rgb-dark: 255, 255, 255;
  --cui-secondary-bg-dark: #323a49;
  --cui-secondary-bg-rgb-dark: 50, 58, 73;
  --cui-tertiary-color-dark: rgba(255, 255, 255, 0.38);
  --cui-tertiary-color-rgb-dark: 255, 255, 255;
  --cui-tertiary-bg-dark: rgb(16.2745098039%, 18.8235294118%, 23.9215686275%);
  --cui-tertiary-bg-rgb-dark: 41.5, 48, 61;
  --cui-high-emphasis: rgba(14.5098039216%, 16.831372549%, 21.1843137255%, 0.95);
  --cui-medium-emphasis: rgba(14.5098039216%, 16.831372549%, 21.1843137255%, 0.681);
  --cui-disabled: rgba(14.5098039216%, 16.831372549%, 21.1843137255%, 0.38);
  --cui-high-emphasis-inverse: rgba(255, 255, 255, 0.87);
  --cui-medium-emphasis-inverse: rgba(255, 255, 255, 0.6);
  --cui-disabled-inverse: rgba(255, 255, 255, 0.38);
  --cui-heading-color: inherit;
  --cui-link-color: #5856d6;
  --cui-link-color-rgb: 88, 86, 214;
  --cui-link-decoration: underline;
  --cui-link-hover-color: rgb(27.6078431373%, 26.9803921569%, 67.137254902%);
  --cui-link-hover-color-rgb: 70.4, 68.8, 171.2;
  --cui-code-color: #d63384;
  --cui-highlight-color: rgba(14.5098039216%, 16.831372549%, 21.1843137255%, 0.95);
  --cui-highlight-bg: rgb(100%, 95.137254902%, 80.5490196078%);
  --cui-border-width: 1px;
  --cui-border-style: solid;
  --cui-border-color: #dbdfe6;
  --cui-border-color-translucent: rgba(49, 72, 112, 0.175);
  --cui-border-radius: 0.375rem;
  --cui-border-radius-sm: 0.25rem;
  --cui-border-radius-lg: 0.5rem;
  --cui-border-radius-xl: 1rem;
  --cui-border-radius-xxl: 2rem;
  --cui-border-radius-2xl: var(--cui-border-radius-xxl);
  --cui-border-radius-pill: 50rem;
  --cui-box-shadow: 0 0.5rem 1rem rgba(8, 10, 12, 0.15);
  --cui-box-shadow-sm: 0 0.125rem 0.25rem rgba(8, 10, 12, 0.075);
  --cui-box-shadow-lg: 0 1rem 3rem rgba(8, 10, 12, 0.175);
  --cui-box-shadow-inset: inset 0 1px 2px rgba(8, 10, 12, 0.075);
  --cui-focus-ring-width: 0.25rem;
  --cui-focus-ring-opacity: 0.25;
  --cui-focus-ring-color: rgba(88, 86, 214, 0.25);
  --cui-focus-ring-blur: 0;
  --cui-form-valid-color: #1b9e3e;
  --cui-form-valid-border-color: #1b9e3e;
  --cui-form-invalid-color: #e55353;
  --cui-form-invalid-border-color: #e55353;
}

[data-coreui-theme=dark] {
  color-scheme: dark;
  --cui-body-color: rgba(255, 255, 255, 0.87);
  --cui-body-color-rgb: 255, 255, 255;
  --cui-body-bg: #212631;
  --cui-body-bg-rgb: 33, 38, 49;
  --cui-emphasis-color: #fff;
  --cui-emphasis-color-rgb: 255, 255, 255;
  --cui-secondary-color: rgba(255, 255, 255, 0.6);
  --cui-secondary-color-rgb: 255, 255, 255;
  --cui-secondary-bg: #323a49;
  --cui-secondary-bg-rgb: 50, 58, 73;
  --cui-tertiary-color: rgba(255, 255, 255, 0.38);
  --cui-tertiary-color-rgb: 255, 255, 255;
  --cui-tertiary-bg: rgb(16.2745098039%, 18.8235294118%, 23.9215686275%);
  --cui-tertiary-bg-rgb: 41.5, 48, 61;
  --cui-tertiary-bg-translucent: rgba(118, 138, 169, 0.1);
  --cui-high-emphasis: rgba(255, 255, 255, 0.87);
  --cui-medium-emphasis: rgba(255, 255, 255, 0.6);
  --cui-disabled: rgba(255, 255, 255, 0.38);
  --cui-primary: rgb(36.9411764706%, 36.2352941176%, 81.4117647059%);
  --cui-secondary: #6b7785;
  --cui-success: rgb(13.1568627451%, 59.3921568627%, 25.5098039216%);
  --cui-info: rgb(24%, 60%, 96%);
  --cui-warning: rgb(93.1764705882%, 67.7647058824%, 12.7058823529%);
  --cui-danger: rgb(86.9411764706%, 35.4117647059%, 35.4117647059%);
  --cui-light: #f3f4f7;
  --cui-dark: #212631;
  --cui-gray-100: #f3f4f7;
  --cui-gray-200: #e7eaee;
  --cui-gray-300: #dbdfe6;
  --cui-gray-400: #cfd4de;
  --cui-gray-500: #aab3c5;
  --cui-gray-600: #6d7d9c;
  --cui-gray-700: #4a566d;
  --cui-gray-800: #323a49;
  --cui-gray-900: #212631;
  --cui-primary-rgb: 94.2, 92.4, 207.6;
  --cui-secondary-rgb: 107, 119, 133;
  --cui-success-rgb: 33.55, 151.45, 65.05;
  --cui-info-rgb: 61.2, 153, 244.8;
  --cui-warning-rgb: 237.6, 172.8, 32.4;
  --cui-danger-rgb: 221.7, 90.3, 90.3;
  --cui-light-rgb: 243, 244, 247;
  --cui-dark-rgb: 33, 38, 49;
  --cui-primary-text-emphasis: rgb(23.2745098039%, 22.568627451%, 61.7450980392%);
  --cui-secondary-text-emphasis: #212233;
  --cui-success-text-emphasis: rgb(7.2941176471%, 32.7058823529%, 14%);
  --cui-info-text-emphasis: rgb(11.2745098039%, 29.6274509804%, 44.8039215686%);
  --cui-warning-text-emphasis: rgb(44.0588235294%, 27.4705882353%, 4.1764705882%);
  --cui-danger-text-emphasis: rgb(38.7647058824%, 9.4705882353%, 9.4705882353%);
  --cui-light-text-emphasis: #f3f4f7;
  --cui-dark-text-emphasis: #dbdfe6;
  --cui-primary-bg-subtle: #cfc7f3;
  --cui-secondary-bg-subtle: #ced2d8;
  --cui-success-bg-subtle: #cbedd6;
  --cui-info-bg-subtle: #c0e6ff;
  --cui-warning-bg-subtle: #feecc5;
  --cui-danger-bg-subtle: #f9d4d4;
  --cui-light-bg-subtle: #323a49;
  --cui-dark-bg-subtle: rgb(11.3725490196%, 13.3333333333%, 16.6666666667%);
  --cui-primary-border-subtle: #9d92e6;
  --cui-secondary-border-subtle: #9da5b1;
  --cui-success-border-subtle: #96dbad;
  --cui-info-border-subtle: #80c6ff;
  --cui-warning-border-subtle: #fcd88a;
  --cui-danger-border-subtle: #f2a9a9;
  --cui-light-border-subtle: #4a566d;
  --cui-dark-border-subtle: #323a49;
  --cui-heading-color: inherit;
  --cui-link-color: rgb(36.9411764706%, 36.2352941176%, 81.4117647059%);
  --cui-link-hover-color: rgb(49.5529411765%, 48.9882352941%, 85.1294117647%);
  --cui-link-color-rgb: 94.2, 92.4, 207.6;
  --cui-link-hover-color-rgb: 126.36, 124.92, 217.08;
  --cui-code-color: rgb(90.3529411765%, 52%, 71.0588235294%);
  --cui-highlight-color: rgba(255, 255, 255, 0.87);
  --cui-highlight-bg: rgb(40%, 30.2745098039%, 1.0980392157%);
  --cui-border-color: #323a49;
  --cui-border-color-translucent: rgba(130, 152, 186, 0.175);
  --cui-form-valid-color: rgb(45.8823529412%, 71.7647058824%, 59.7647058824%);
  --cui-form-valid-border-color: rgb(45.8823529412%, 71.7647058824%, 59.7647058824%);
  --cui-form-invalid-color: rgb(91.7647058824%, 52.4705882353%, 56.2352941176%);
  --cui-form-invalid-border-color: rgb(91.7647058824%, 52.4705882353%, 56.2352941176%);
}

*,
*::before,
*::after {
  box-sizing: border-box;
}

@media (prefers-reduced-motion: no-preference) {
  :root {
    scroll-behavior: smooth;
  }
}
body {
  margin: 0;
  font-family: var(--cui-body-font-family);
  font-size: var(--cui-body-font-size);
  font-weight: var(--cui-body-font-weight);
  line-height: var(--cui-body-line-height);
  color: var(--cui-body-color);
  text-align: var(--cui-body-text-align);
  background-color: var(--cui-body-bg);
  -webkit-text-size-adjust: 100%;
  -webkit-tap-highlight-color: rgba(8, 10, 12, 0);
}

hr {
  margin: 1rem 0;
  color: inherit;
  border: 0;
  border-top: var(--cui-border-width) solid;
  opacity: 0.25;
}

h6, .h6, h5, .h5, h4, .h4, h3, .h3, h2, .h2, h1, .h1 {
  margin-top: 0;
  margin-bottom: 0.5rem;
  font-weight: 500;
  line-height: 1.2;
  color: var(--cui-heading-color);
}

h1, .h1 {
  font-size: calc(1.375rem + 1.5vw);
}

@media (min-width: 1200px) {
  h1, .h1 {
    font-size: 2.5rem;
  }
}
h2, .h2 {
  font-size: calc(1.325rem + 0.9vw);
}

@media (min-width: 1200px) {
  h2, .h2 {
    font-size: 2rem;
  }
}
h3, .h3 {
  font-size: calc(1.3rem + 0.6vw);
}

@media (min-width: 1200px) {
  h3, .h3 {
    font-size: 1.75rem;
  }
}
h4, .h4 {
  font-size: calc(1.275rem + 0.3vw);
}

@media (min-width: 1200px) {
  h4, .h4 {
    font-size: 1.5rem;
  }
}
h5, .h5 {
  font-size: 1.25rem;
}

h6, .h6 {
  font-size: 1rem;
}

p {
  margin-top: 0;
  margin-bottom: 1rem;
}

abbr[title] {
  text-decoration: underline dotted;
  cursor: help;
  text-decoration-skip-ink: none;
}

address {
  margin-bottom: 1rem;
  font-style: normal;
  line-height: inherit;
}

ol,
ul {
  padding-inline-start: 2rem;
}

ol,
ul,
dl {
  margin-top: 0;
  margin-bottom: 1rem;
}

ol ol,
ul ul,
ol ul,
ul ol {
  margin-bottom: 0;
}

dt {
  font-weight: 700;
}

dd {
  margin-inline-start: 0;
  margin-bottom: 0.5rem;
}

blockquote {
  margin: 0 0 1rem;
}

b,
strong {
  font-weight: bolder;
}

small, .small {
  font-size: 0.875em;
}

mark, .mark {
  padding: 0.1875em;
  color: var(--cui-highlight-color);
  background-color: var(--cui-highlight-bg);
}

sub,
sup {
  position: relative;
  font-size: 0.75em;
  line-height: 0;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

a {
  color: rgba(var(--cui-link-color-rgb), var(--cui-link-opacity, 1));
  text-decoration: underline;
}

a:hover {
  --cui-link-color-rgb: var(--cui-link-hover-color-rgb);
}

a:not([href]):not([class]), a:not([href]):not([class]):hover {
  color: inherit;
  text-decoration: none;
}

pre,
code,
kbd,
samp {
  font-family: var(--cui-font-monospace);
  font-size: 1em;
}

pre {
  display: block;
  margin-top: 0;
  margin-bottom: 1rem;
  overflow: auto;
  font-size: 0.875em;
  color: var(--cui-pre-color, );
}

pre code {
  font-size: inherit;
  color: inherit;
  word-break: normal;
}

code {
  font-size: 0.875em;
  color: var(--cui-code-color);
  word-wrap: break-word;
}

a > code {
  color: inherit;
}

kbd {
  padding: 0.1875rem 0.375rem;
  font-size: 0.875em;
  color: var(--cui-kbd-color, var(--cui-body-bg));
  background-color: var(--cui-kbd-bg, var(--cui-body-color));
  border-radius: 0.25rem;
}

kbd kbd {
  padding: 0;
  font-size: 1em;
}

figure {
  margin: 0 0 1rem;
}

img,
svg {
  vertical-align: middle;
}

table {
  caption-side: bottom;
  border-collapse: collapse;
}

caption {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  color: var(--cui-table-caption-color, var(--cui-secondary-color));
  text-align: start;
}

th {
  text-align: inherit;
  text-align: -webkit-match-parent;
}

thead,
tbody,
tfoot,
tr,
td,
th {
  border-color: inherit;
  border-style: solid;
  border-width: 0;
}

label {
  display: inline-block;
}

button {
  border-radius: 0;
}

button:focus:not(:focus-visible) {
  outline: 0;
}

input,
button,
select,
optgroup,
textarea {
  margin: 0;
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
}

button,
select {
  text-transform: none;
}

[role=button] {
  cursor: pointer;
}

select {
  word-wrap: normal;
}

select:disabled {
  opacity: 1;
}

[list]:not([type=date]):not([type=datetime-local]):not([type=month]):not([type=week]):not([type=time])::-webkit-calendar-picker-indicator {
  display: none !important;
}

button,
[type=button],
[type=reset],
[type=submit] {
  -webkit-appearance: button;
}

button:not(:disabled),
[type=button]:not(:disabled),
[type=reset]:not(:disabled),
[type=submit]:not(:disabled) {
  cursor: pointer;
}

::-moz-focus-inner {
  padding: 0;
  border-style: none;
}

textarea {
  resize: vertical;
}

fieldset {
  min-width: 0;
  padding: 0;
  margin: 0;
  border: 0;
}

legend {
  float: inline-start;
  width: 100%;
  padding: 0;
  margin-bottom: 0.5rem;
  line-height: inherit;
  font-size: calc(1.275rem + 0.3vw);
}

@media (min-width: 1200px) {
  legend {
    font-size: 1.5rem;
  }
}
legend + * {
  clear: left;
}

::-webkit-datetime-edit-fields-wrapper,
::-webkit-datetime-edit-text,
::-webkit-datetime-edit-minute,
::-webkit-datetime-edit-hour-field,
::-webkit-datetime-edit-day-field,
::-webkit-datetime-edit-month-field,
::-webkit-datetime-edit-year-field {
  padding: 0;
}

::-webkit-inner-spin-button {
  height: auto;
}

[type=search] {
  -webkit-appearance: textfield;
  outline-offset: -2px;
}

[type=search]::-webkit-search-cancel-button {
  cursor: pointer;
  filter: grayscale(1);
}

*[dir=rtl] [type=tel],
*[dir=rtl] [type=url],
*[dir=rtl] [type=email],
*[dir=rtl] [type=number] {
  direction: ltr;
}

::-webkit-search-decoration {
  -webkit-appearance: none;
}

::-webkit-color-swatch-wrapper {
  padding: 0;
}

::file-selector-button {
  font: inherit;
  -webkit-appearance: button;
}

output {
  display: inline-block;
}

iframe {
  color-scheme: light dark;
  border: 0;
}

summary {
  display: list-item;
  cursor: pointer;
}

progress {
  vertical-align: baseline;
}

[hidden] {
  display: none !important;
}

.lead {
  font-size: 1.25rem;
  font-weight: 300;
}

.display-1 {
  font-weight: 300;
  line-height: 1.2;
  font-size: calc(1.625rem + 4.5vw);
}

@media (min-width: 1200px) {
  .display-1 {
    font-size: 5rem;
  }
}
.display-2 {
  font-weight: 300;
  line-height: 1.2;
  font-size: calc(1.575rem + 3.9vw);
}

@media (min-width: 1200px) {
  .display-2 {
    font-size: 4.5rem;
  }
}
.display-3 {
  font-weight: 300;
  line-height: 1.2;
  font-size: calc(1.525rem + 3.3vw);
}

@media (min-width: 1200px) {
  .display-3 {
    font-size: 4rem;
  }
}
.display-4 {
  font-weight: 300;
  line-height: 1.2;
  font-size: calc(1.475rem + 2.7vw);
}

@media (min-width: 1200px) {
  .display-4 {
    font-size: 3.5rem;
  }
}
.display-5 {
  font-weight: 300;
  line-height: 1.2;
  font-size: calc(1.425rem + 2.1vw);
}

@media (min-width: 1200px) {
  .display-5 {
    font-size: 3rem;
  }
}
.display-6 {
  font-weight: 300;
  line-height: 1.2;
  font-size: calc(1.375rem + 1.5vw);
}

@media (min-width: 1200px) {
  .display-6 {
    font-size: 2.5rem;
  }
}
.list-unstyled {
  padding-inline-start: 0;
  list-style: none;
}

.list-inline {
  padding-inline-start: 0;
  list-style: none;
}

.list-inline-item {
  display: inline-block;
}

.list-inline-item:not(:last-child) {
  margin-inline-end: 0.5rem;
}

.initialism {
  font-size: 0.875em;
  text-transform: uppercase;
}

.blockquote {
  margin-bottom: 1rem;
  font-size: 1.25rem;
}

.blockquote > :last-child {
  margin-bottom: 0;
}

.blockquote-footer {
  margin-top: -1rem;
  margin-bottom: 1rem;
  font-size: 0.875em;
  color: #6d7d9c;
}

.blockquote-footer::before {
  content: "— ";
}

.img-fluid {
  max-width: 100%;
  height: auto;
}

.img-thumbnail {
  padding: 0.25rem;
  background-color: var(--cui-thumbnail-bg, var(--cui-body-bg));
  border: var(--cui-border-width) solid var(--cui-thumbnail-border-color, var(--cui-border-color));
  border-radius: var(--cui-border-radius);
  max-width: 100%;
  height: auto;
}

.figure {
  display: inline-block;
}

.figure-img {
  margin-bottom: 0.5rem;
  line-height: 1;
}

.figure-caption {
  font-size: 0.875em;
  color: var(--cui-figure-caption-color, var(--cui-secondary-color));
}

.container,
.container-fluid,
.container-xxl,
.container-xl,
.container-lg,
.container-md,
.container-sm {
  --cui-gutter-x: 1.5rem;
  --cui-gutter-y: 0;
  width: 100%;
  padding-right: calc(var(--cui-gutter-x) * 0.5);
  padding-left: calc(var(--cui-gutter-x) * 0.5);
  margin-right: auto;
  margin-left: auto;
}

@media (min-width: 576px) {
  .container-sm, .container {
    max-width: 540px;
  }
}
@media (min-width: 768px) {
  .container-md, .container-sm, .container {
    max-width: 720px;
  }
}
@media (min-width: 992px) {
  .container-lg, .container-md, .container-sm, .container {
    max-width: 960px;
  }
}
@media (min-width: 1200px) {
  .container-xl, .container-lg, .container-md, .container-sm, .container {
    max-width: 1140px;
  }
}
@media (min-width: 1400px) {
  .container-xxl, .container-xl, .container-lg, .container-md, .container-sm, .container {
    max-width: 1320px;
  }
}
:root {
  --cui-breakpoint-xs: 0;
  --cui-breakpoint-sm: 576px;
  --cui-breakpoint-md: 768px;
  --cui-breakpoint-lg: 992px;
  --cui-breakpoint-xl: 1200px;
  --cui-breakpoint-xxl: 1400px;
  --cui-mobile-breakpoint: lg;
}

.row {
  --cui-gutter-x: 1.5rem;
  --cui-gutter-y: 0;
  display: flex;
  flex-wrap: wrap;
  margin-top: calc(-1 * var(--cui-gutter-y));
  margin-right: calc(-0.5 * var(--cui-gutter-x));
  margin-left: calc(-0.5 * var(--cui-gutter-x));
}

.row > * {
  flex-shrink: 0;
  width: 100%;
  max-width: 100%;
  padding-right: calc(var(--cui-gutter-x) * 0.5);
  padding-left: calc(var(--cui-gutter-x) * 0.5);
  margin-top: var(--cui-gutter-y);
}

.col {
  flex: 1 0;
}

.row-cols-auto > * {
  flex: 0 0 auto;
  width: auto;
}

.row-cols-1 > * {
  flex: 0 0 auto;
  width: 100%;
}

.row-cols-2 > * {
  flex: 0 0 auto;
  width: 50%;
}

.row-cols-3 > * {
  flex: 0 0 auto;
  width: 33.33333333%;
}

.row-cols-4 > * {
  flex: 0 0 auto;
  width: 25%;
}

.row-cols-5 > * {
  flex: 0 0 auto;
  width: 20%;
}

.row-cols-6 > * {
  flex: 0 0 auto;
  width: 16.66666667%;
}

.col-auto {
  flex: 0 0 auto;
  width: auto;
}

.col-1 {
  flex: 0 0 auto;
  width: 8.33333333%;
}

.col-2 {
  flex: 0 0 auto;
  width: 16.66666667%;
}

.col-3 {
  flex: 0 0 auto;
  width: 25%;
}

.col-4 {
  flex: 0 0 auto;
  width: 33.33333333%;
}

.col-5 {
  flex: 0 0 auto;
  width: 41.66666667%;
}

.col-6 {
  flex: 0 0 auto;
  width: 50%;
}

.col-7 {
  flex: 0 0 auto;
  width: 58.33333333%;
}

.col-8 {
  flex: 0 0 auto;
  width: 66.66666667%;
}

.col-9 {
  flex: 0 0 auto;
  width: 75%;
}

.col-10 {
  flex: 0 0 auto;
  width: 83.33333333%;
}

.col-11 {
  flex: 0 0 auto;
  width: 91.66666667%;
}

.col-12 {
  flex: 0 0 auto;
  width: 100%;
}

.offset-1 {
  margin-inline-start: 8.33333333%;
}

.offset-2 {
  margin-inline-start: 16.66666667%;
}

.offset-3 {
  margin-inline-start: 25%;
}

.offset-4 {
  margin-inline-start: 33.33333333%;
}

.offset-5 {
  margin-inline-start: 41.66666667%;
}

.offset-6 {
  margin-inline-start: 50%;
}

.offset-7 {
  margin-inline-start: 58.33333333%;
}

.offset-8 {
  margin-inline-start: 66.66666667%;
}

.offset-9 {
  margin-inline-start: 75%;
}

.offset-10 {
  margin-inline-start: 83.33333333%;
}

.offset-11 {
  margin-inline-start: 91.66666667%;
}

.g-0,
.gx-0 {
  --cui-gutter-x: 0;
}

.g-0,
.gy-0 {
  --cui-gutter-y: 0;
}

.g-1,
.gx-1 {
  --cui-gutter-x: 0.25rem;
}

.g-1,
.gy-1 {
  --cui-gutter-y: 0.25rem;
}

.g-2,
.gx-2 {
  --cui-gutter-x: 0.5rem;
}

.g-2,
.gy-2 {
  --cui-gutter-y: 0.5rem;
}

.g-3,
.gx-3 {
  --cui-gutter-x: 1rem;
}

.g-3,
.gy-3 {
  --cui-gutter-y: 1rem;
}

.g-4,
.gx-4 {
  --cui-gutter-x: 1.5rem;
}

.g-4,
.gy-4 {
  --cui-gutter-y: 1.5rem;
}

.g-5,
.gx-5 {
  --cui-gutter-x: 3rem;
}

.g-5,
.gy-5 {
  --cui-gutter-y: 3rem;
}

@media (min-width: 576px) {
  .col-sm {
    flex: 1 0;
  }
  .row-cols-sm-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-sm-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-sm-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-sm-3 > * {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .row-cols-sm-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-sm-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-sm-6 > * {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-sm-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-sm-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-sm-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-sm-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-sm-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-sm-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-sm-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-sm-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-sm-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-sm-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-sm-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-sm-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-sm-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-sm-0 {
    margin-inline-start: 0;
  }
  .offset-sm-1 {
    margin-inline-start: 8.33333333%;
  }
  .offset-sm-2 {
    margin-inline-start: 16.66666667%;
  }
  .offset-sm-3 {
    margin-inline-start: 25%;
  }
  .offset-sm-4 {
    margin-inline-start: 33.33333333%;
  }
  .offset-sm-5 {
    margin-inline-start: 41.66666667%;
  }
  .offset-sm-6 {
    margin-inline-start: 50%;
  }
  .offset-sm-7 {
    margin-inline-start: 58.33333333%;
  }
  .offset-sm-8 {
    margin-inline-start: 66.66666667%;
  }
  .offset-sm-9 {
    margin-inline-start: 75%;
  }
  .offset-sm-10 {
    margin-inline-start: 83.33333333%;
  }
  .offset-sm-11 {
    margin-inline-start: 91.66666667%;
  }
  .g-sm-0,
  .gx-sm-0 {
    --cui-gutter-x: 0;
  }
  .g-sm-0,
  .gy-sm-0 {
    --cui-gutter-y: 0;
  }
  .g-sm-1,
  .gx-sm-1 {
    --cui-gutter-x: 0.25rem;
  }
  .g-sm-1,
  .gy-sm-1 {
    --cui-gutter-y: 0.25rem;
  }
  .g-sm-2,
  .gx-sm-2 {
    --cui-gutter-x: 0.5rem;
  }
  .g-sm-2,
  .gy-sm-2 {
    --cui-gutter-y: 0.5rem;
  }
  .g-sm-3,
  .gx-sm-3 {
    --cui-gutter-x: 1rem;
  }
  .g-sm-3,
  .gy-sm-3 {
    --cui-gutter-y: 1rem;
  }
  .g-sm-4,
  .gx-sm-4 {
    --cui-gutter-x: 1.5rem;
  }
  .g-sm-4,
  .gy-sm-4 {
    --cui-gutter-y: 1.5rem;
  }
  .g-sm-5,
  .gx-sm-5 {
    --cui-gutter-x: 3rem;
  }
  .g-sm-5,
  .gy-sm-5 {
    --cui-gutter-y: 3rem;
  }
}
@media (min-width: 768px) {
  .col-md {
    flex: 1 0;
  }
  .row-cols-md-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-md-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-md-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-md-3 > * {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .row-cols-md-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-md-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-md-6 > * {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-md-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-md-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-md-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-md-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-md-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-md-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-md-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-md-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-md-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-md-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-md-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-md-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-md-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-md-0 {
    margin-inline-start: 0;
  }
  .offset-md-1 {
    margin-inline-start: 8.33333333%;
  }
  .offset-md-2 {
    margin-inline-start: 16.66666667%;
  }
  .offset-md-3 {
    margin-inline-start: 25%;
  }
  .offset-md-4 {
    margin-inline-start: 33.33333333%;
  }
  .offset-md-5 {
    margin-inline-start: 41.66666667%;
  }
  .offset-md-6 {
    margin-inline-start: 50%;
  }
  .offset-md-7 {
    margin-inline-start: 58.33333333%;
  }
  .offset-md-8 {
    margin-inline-start: 66.66666667%;
  }
  .offset-md-9 {
    margin-inline-start: 75%;
  }
  .offset-md-10 {
    margin-inline-start: 83.33333333%;
  }
  .offset-md-11 {
    margin-inline-start: 91.66666667%;
  }
  .g-md-0,
  .gx-md-0 {
    --cui-gutter-x: 0;
  }
  .g-md-0,
  .gy-md-0 {
    --cui-gutter-y: 0;
  }
  .g-md-1,
  .gx-md-1 {
    --cui-gutter-x: 0.25rem;
  }
  .g-md-1,
  .gy-md-1 {
    --cui-gutter-y: 0.25rem;
  }
  .g-md-2,
  .gx-md-2 {
    --cui-gutter-x: 0.5rem;
  }
  .g-md-2,
  .gy-md-2 {
    --cui-gutter-y: 0.5rem;
  }
  .g-md-3,
  .gx-md-3 {
    --cui-gutter-x: 1rem;
  }
  .g-md-3,
  .gy-md-3 {
    --cui-gutter-y: 1rem;
  }
  .g-md-4,
  .gx-md-4 {
    --cui-gutter-x: 1.5rem;
  }
  .g-md-4,
  .gy-md-4 {
    --cui-gutter-y: 1.5rem;
  }
  .g-md-5,
  .gx-md-5 {
    --cui-gutter-x: 3rem;
  }
  .g-md-5,
  .gy-md-5 {
    --cui-gutter-y: 3rem;
  }
}
@media (min-width: 992px) {
  .col-lg {
    flex: 1 0;
  }
  .row-cols-lg-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-lg-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-lg-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-lg-3 > * {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .row-cols-lg-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-lg-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-lg-6 > * {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-lg-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-lg-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-lg-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-lg-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-lg-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-lg-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-lg-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-lg-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-lg-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-lg-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-lg-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-lg-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-lg-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-lg-0 {
    margin-inline-start: 0;
  }
  .offset-lg-1 {
    margin-inline-start: 8.33333333%;
  }
  .offset-lg-2 {
    margin-inline-start: 16.66666667%;
  }
  .offset-lg-3 {
    margin-inline-start: 25%;
  }
  .offset-lg-4 {
    margin-inline-start: 33.33333333%;
  }
  .offset-lg-5 {
    margin-inline-start: 41.66666667%;
  }
  .offset-lg-6 {
    margin-inline-start: 50%;
  }
  .offset-lg-7 {
    margin-inline-start: 58.33333333%;
  }
  .offset-lg-8 {
    margin-inline-start: 66.66666667%;
  }
  .offset-lg-9 {
    margin-inline-start: 75%;
  }
  .offset-lg-10 {
    margin-inline-start: 83.33333333%;
  }
  .offset-lg-11 {
    margin-inline-start: 91.66666667%;
  }
  .g-lg-0,
  .gx-lg-0 {
    --cui-gutter-x: 0;
  }
  .g-lg-0,
  .gy-lg-0 {
    --cui-gutter-y: 0;
  }
  .g-lg-1,
  .gx-lg-1 {
    --cui-gutter-x: 0.25rem;
  }
  .g-lg-1,
  .gy-lg-1 {
    --cui-gutter-y: 0.25rem;
  }
  .g-lg-2,
  .gx-lg-2 {
    --cui-gutter-x: 0.5rem;
  }
  .g-lg-2,
  .gy-lg-2 {
    --cui-gutter-y: 0.5rem;
  }
  .g-lg-3,
  .gx-lg-3 {
    --cui-gutter-x: 1rem;
  }
  .g-lg-3,
  .gy-lg-3 {
    --cui-gutter-y: 1rem;
  }
  .g-lg-4,
  .gx-lg-4 {
    --cui-gutter-x: 1.5rem;
  }
  .g-lg-4,
  .gy-lg-4 {
    --cui-gutter-y: 1.5rem;
  }
  .g-lg-5,
  .gx-lg-5 {
    --cui-gutter-x: 3rem;
  }
  .g-lg-5,
  .gy-lg-5 {
    --cui-gutter-y: 3rem;
  }
}
@media (min-width: 1200px) {
  .col-xl {
    flex: 1 0;
  }
  .row-cols-xl-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-xl-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-xl-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-xl-3 > * {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .row-cols-xl-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-xl-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-xl-6 > * {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-xl-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-xl-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-xl-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-xl-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-xl-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-xl-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-xl-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-xl-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-xl-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-xl-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-xl-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-xl-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-xl-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-xl-0 {
    margin-inline-start: 0;
  }
  .offset-xl-1 {
    margin-inline-start: 8.33333333%;
  }
  .offset-xl-2 {
    margin-inline-start: 16.66666667%;
  }
  .offset-xl-3 {
    margin-inline-start: 25%;
  }
  .offset-xl-4 {
    margin-inline-start: 33.33333333%;
  }
  .offset-xl-5 {
    margin-inline-start: 41.66666667%;
  }
  .offset-xl-6 {
    margin-inline-start: 50%;
  }
  .offset-xl-7 {
    margin-inline-start: 58.33333333%;
  }
  .offset-xl-8 {
    margin-inline-start: 66.66666667%;
  }
  .offset-xl-9 {
    margin-inline-start: 75%;
  }
  .offset-xl-10 {
    margin-inline-start: 83.33333333%;
  }
  .offset-xl-11 {
    margin-inline-start: 91.66666667%;
  }
  .g-xl-0,
  .gx-xl-0 {
    --cui-gutter-x: 0;
  }
  .g-xl-0,
  .gy-xl-0 {
    --cui-gutter-y: 0;
  }
  .g-xl-1,
  .gx-xl-1 {
    --cui-gutter-x: 0.25rem;
  }
  .g-xl-1,
  .gy-xl-1 {
    --cui-gutter-y: 0.25rem;
  }
  .g-xl-2,
  .gx-xl-2 {
    --cui-gutter-x: 0.5rem;
  }
  .g-xl-2,
  .gy-xl-2 {
    --cui-gutter-y: 0.5rem;
  }
  .g-xl-3,
  .gx-xl-3 {
    --cui-gutter-x: 1rem;
  }
  .g-xl-3,
  .gy-xl-3 {
    --cui-gutter-y: 1rem;
  }
  .g-xl-4,
  .gx-xl-4 {
    --cui-gutter-x: 1.5rem;
  }
  .g-xl-4,
  .gy-xl-4 {
    --cui-gutter-y: 1.5rem;
  }
  .g-xl-5,
  .gx-xl-5 {
    --cui-gutter-x: 3rem;
  }
  .g-xl-5,
  .gy-xl-5 {
    --cui-gutter-y: 3rem;
  }
}
@media (min-width: 1400px) {
  .col-xxl {
    flex: 1 0;
  }
  .row-cols-xxl-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-xxl-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-xxl-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-xxl-3 > * {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .row-cols-xxl-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-xxl-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-xxl-6 > * {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-xxl-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-xxl-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-xxl-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-xxl-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-xxl-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-xxl-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-xxl-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-xxl-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-xxl-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-xxl-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-xxl-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-xxl-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-xxl-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-xxl-0 {
    margin-inline-start: 0;
  }
  .offset-xxl-1 {
    margin-inline-start: 8.33333333%;
  }
  .offset-xxl-2 {
    margin-inline-start: 16.66666667%;
  }
  .offset-xxl-3 {
    margin-inline-start: 25%;
  }
  .offset-xxl-4 {
    margin-inline-start: 33.33333333%;
  }
  .offset-xxl-5 {
    margin-inline-start: 41.66666667%;
  }
  .offset-xxl-6 {
    margin-inline-start: 50%;
  }
  .offset-xxl-7 {
    margin-inline-start: 58.33333333%;
  }
  .offset-xxl-8 {
    margin-inline-start: 66.66666667%;
  }
  .offset-xxl-9 {
    margin-inline-start: 75%;
  }
  .offset-xxl-10 {
    margin-inline-start: 83.33333333%;
  }
  .offset-xxl-11 {
    margin-inline-start: 91.66666667%;
  }
  .g-xxl-0,
  .gx-xxl-0 {
    --cui-gutter-x: 0;
  }
  .g-xxl-0,
  .gy-xxl-0 {
    --cui-gutter-y: 0;
  }
  .g-xxl-1,
  .gx-xxl-1 {
    --cui-gutter-x: 0.25rem;
  }
  .g-xxl-1,
  .gy-xxl-1 {
    --cui-gutter-y: 0.25rem;
  }
  .g-xxl-2,
  .gx-xxl-2 {
    --cui-gutter-x: 0.5rem;
  }
  .g-xxl-2,
  .gy-xxl-2 {
    --cui-gutter-y: 0.5rem;
  }
  .g-xxl-3,
  .gx-xxl-3 {
    --cui-gutter-x: 1rem;
  }
  .g-xxl-3,
  .gy-xxl-3 {
    --cui-gutter-y: 1rem;
  }
  .g-xxl-4,
  .gx-xxl-4 {
    --cui-gutter-x: 1.5rem;
  }
  .g-xxl-4,
  .gy-xxl-4 {
    --cui-gutter-y: 1.5rem;
  }
  .g-xxl-5,
  .gx-xxl-5 {
    --cui-gutter-x: 3rem;
  }
  .g-xxl-5,
  .gy-xxl-5 {
    --cui-gutter-y: 3rem;
  }
}
.table {
  --cui-table-color-type: initial;
  --cui-table-bg-type: initial;
  --cui-table-color-state: initial;
  --cui-table-bg-state: initial;
  --cui-table-color: var(--cui-emphasis-color);
  --cui-table-bg: var(--cui-body-bg);
  --cui-table-border-color: var(--cui-border-color);
  --cui-table-accent-bg: transparent;
  --cui-table-striped-color: var(--cui-emphasis-color);
  --cui-table-striped-bg: rgba(var(--cui-emphasis-color-rgb), 0.05);
  --cui-table-active-color: var(--cui-emphasis-color);
  --cui-table-active-bg: rgba(var(--cui-emphasis-color-rgb), 0.1);
  --cui-table-hover-color: var(--cui-emphasis-color);
  --cui-table-hover-bg: rgba(var(--cui-emphasis-color-rgb), 0.075);
  width: 100%;
  margin-bottom: 1rem;
  vertical-align: top;
  border-color: var(--cui-table-border-color);
}

.table > :not(caption) > * > * {
  padding: 0.5rem 0.5rem;
  color: var(--cui-table-color-state, var(--cui-table-color-type, var(--cui-table-color)));
  background-color: var(--cui-table-bg);
  border-bottom-width: var(--cui-border-width);
  box-shadow: inset 0 0 0 9999px var(--cui-table-bg-state, var(--cui-table-bg-type, var(--cui-table-accent-bg)));
}

.table > tbody {
  vertical-align: inherit;
}

.table > thead {
  vertical-align: bottom;
}

.table-group-divider {
  border-top: calc(var(--cui-border-width) * 2) solid currentcolor;
}

.caption-top {
  caption-side: top;
}

.table-sm > :not(caption) > * > * {
  padding: 0.25rem 0.25rem;
}

.table-bordered > :not(caption) > * {
  border-width: var(--cui-border-width) 0;
}

.table-bordered > :not(caption) > * > * {
  border-width: 0 var(--cui-border-width);
}

.table-borderless > :not(caption) > * > * {
  border-bottom-width: 0;
}

.table-borderless > :not(:first-child) {
  border-top-width: 0;
}

.table-striped > tbody > tr:nth-of-type(odd) > * {
  --cui-table-color-type: var(--cui-table-striped-color);
  --cui-table-bg-type: var(--cui-table-striped-bg);
}

.table-striped-columns > :not(caption) > tr > :nth-child(even) {
  --cui-table-color-type: var(--cui-table-striped-color);
  --cui-table-bg-type: var(--cui-table-striped-bg);
}

.table-active {
  --cui-table-color-state: var(--cui-table-active-color);
  --cui-table-bg-state: var(--cui-table-active-bg);
}

.table-hover > tbody > tr:hover > * {
  --cui-table-color-state: var(--cui-table-hover-color);
  --cui-table-bg-state: var(--cui-table-hover-bg);
}

.table-primary {
  --cui-table-color: #080a0c;
  --cui-table-bg: rgb(86.9019607843%, 86.7450980392%, 96.7843137255%);
  --cui-table-border-color: rgb(70.1490196078%, 70.1803921569%, 78.368627451%);
  --cui-table-striped-bg: rgb(82.7137254902%, 82.6039215686%, 92.1803921569%);
  --cui-table-striped-color: #080a0c;
  --cui-table-active-bg: rgb(78.5254901961%, 78.462745098%, 87.5764705882%);
  --cui-table-active-color: #080a0c;
  --cui-table-hover-bg: rgb(80.6196078431%, 80.5333333333%, 89.8784313725%);
  --cui-table-hover-color: #080a0c;
  color: var(--cui-table-color);
  border-color: var(--cui-table-border-color);
}

.table-secondary {
  --cui-table-color: #080a0c;
  --cui-table-bg: rgb(88.3921568627%, 89.3333333333%, 90.431372549%);
  --cui-table-border-color: rgb(71.3411764706%, 72.2509803922%, 73.2862745098%);
  --cui-table-striped-bg: rgb(84.1294117647%, 85.062745098%, 86.1450980392%);
  --cui-table-striped-color: #080a0c;
  --cui-table-active-bg: rgb(79.8666666667%, 80.7921568627%, 81.8588235294%);
  --cui-table-active-color: #080a0c;
  --cui-table-hover-bg: rgb(81.9980392157%, 82.9274509804%, 84.0019607843%);
  --cui-table-hover-color: #080a0c;
  color: var(--cui-table-color);
  border-color: var(--cui-table-border-color);
}

.table-success {
  --cui-table-color: #080a0c;
  --cui-table-bg: rgb(82.1176470588%, 92.3921568627%, 84.862745098%);
  --cui-table-border-color: rgb(66.3215686275%, 74.6980392157%, 68.831372549%);
  --cui-table-striped-bg: rgb(78.168627451%, 87.968627451%, 80.8549019608%);
  --cui-table-striped-color: #080a0c;
  --cui-table-active-bg: rgb(74.2196078431%, 83.5450980392%, 76.8470588235%);
  --cui-table-active-color: #080a0c;
  --cui-table-hover-bg: rgb(76.1941176471%, 85.7568627451%, 78.8509803922%);
  --cui-table-hover-color: #080a0c;
  color: var(--cui-table-color);
  border-color: var(--cui-table-border-color);
}

.table-info {
  --cui-table-color: #080a0c;
  --cui-table-bg: rgb(84%, 92%, 100%);
  --cui-table-border-color: rgb(67.8274509804%, 74.3843137255%, 80.9411764706%);
  --cui-table-striped-bg: rgb(79.9568627451%, 87.5960784314%, 95.2352941176%);
  --cui-table-striped-color: #080a0c;
  --cui-table-active-bg: rgb(75.9137254902%, 83.1921568627%, 90.4705882353%);
  --cui-table-active-color: #080a0c;
  --cui-table-hover-bg: rgb(77.9352941176%, 85.3941176471%, 92.8529411765%);
  --cui-table-hover-color: #080a0c;
  color: var(--cui-table-color);
  border-color: var(--cui-table-border-color);
}

.table-warning {
  --cui-table-color: #080a0c;
  --cui-table-bg: rgb(99.5294117647%, 93.8823529412%, 81.6470588235%);
  --cui-table-border-color: rgb(80.2509803922%, 75.8901960784%, 66.2588235294%);
  --cui-table-striped-bg: rgb(94.7098039216%, 89.3843137255%, 77.8%);
  --cui-table-striped-color: #080a0c;
  --cui-table-active-bg: rgb(89.8901960784%, 84.8862745098%, 73.9529411765%);
  --cui-table-active-color: #080a0c;
  --cui-table-hover-bg: rgb(92.3%, 87.1352941176%, 75.8764705882%);
  --cui-table-hover-color: #080a0c;
  color: var(--cui-table-color);
  border-color: var(--cui-table-border-color);
}

.table-danger {
  --cui-table-color: #080a0c;
  --cui-table-bg: rgb(97.9607843137%, 86.5098039216%, 86.5098039216%);
  --cui-table-border-color: rgb(78.9960784314%, 69.9921568627%, 70.1490196078%);
  --cui-table-striped-bg: rgb(93.2196078431%, 82.3803921569%, 82.4196078431%);
  --cui-table-striped-color: #080a0c;
  --cui-table-active-bg: rgb(88.4784313725%, 78.2509803922%, 78.3294117647%);
  --cui-table-active-color: #080a0c;
  --cui-table-hover-bg: rgb(90.8490196078%, 80.3156862745%, 80.3745098039%);
  --cui-table-hover-color: #080a0c;
  color: var(--cui-table-color);
  border-color: var(--cui-table-border-color);
}

.table-light {
  --cui-table-color: #080a0c;
  --cui-table-bg: #f3f4f7;
  --cui-table-border-color: rgb(76.862745098%, 77.3333333333%, 78.431372549%);
  --cui-table-striped-bg: rgb(90.6862745098%, 91.0980392157%, 92.2549019608%);
  --cui-table-striped-color: #080a0c;
  --cui-table-active-bg: rgb(86.0784313725%, 86.5098039216%, 87.6470588235%);
  --cui-table-active-color: #080a0c;
  --cui-table-hover-bg: rgb(88.3823529412%, 88.8039215686%, 89.9509803922%);
  --cui-table-hover-color: #080a0c;
  color: var(--cui-table-color);
  border-color: var(--cui-table-border-color);
}

.table-dark {
  --cui-table-color: #fff;
  --cui-table-bg: #212631;
  --cui-table-border-color: rgb(30.3529411765%, 31.9215686275%, 35.3725490196%);
  --cui-table-striped-bg: rgb(17.2941176471%, 19.1568627451%, 23.2549019608%);
  --cui-table-striped-color: #fff;
  --cui-table-active-bg: rgb(21.6470588235%, 23.4117647059%, 27.2941176471%);
  --cui-table-active-color: #fff;
  --cui-table-hover-bg: rgb(19.4705882353%, 21.2843137255%, 25.2745098039%);
  --cui-table-hover-color: #fff;
  color: var(--cui-table-color);
  border-color: var(--cui-table-border-color);
}

.table-responsive {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

@media (max-width: 575.98px) {
  .table-responsive-sm {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
@media (max-width: 767.98px) {
  .table-responsive-md {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
@media (max-width: 991.98px) {
  .table-responsive-lg {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
@media (max-width: 1199.98px) {
  .table-responsive-xl {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
@media (max-width: 1399.98px) {
  .table-responsive-xxl {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
.chip-input {
  --cui-chip-input-min-height: calc(1.5em + 0.75rem + calc(var(--cui-border-width) * 2));
  --cui-chip-input-padding-y: 0.25rem;
  --cui-chip-input-padding-x: 0.75rem;
  --cui-chip-input-font-size: 1rem;
  --cui-chip-input-bg: var(--cui-body-bg);
  --cui-chip-input-color: var(--cui-body-color);
  --cui-chip-input-border-width: var(--cui-border-width);
  --cui-chip-input-border-color: var(--cui-border-color);
  --cui-chip-input-border-radius: var(--cui-border-radius);
  --cui-chip-input-gap: 0.375rem;
  --cui-chip-input-transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  display: flex;
  flex-wrap: wrap;
  gap: var(--cui-chip-input-gap);
  align-items: center;
  min-height: var(--cui-chip-input-min-height);
  padding: var(--cui-chip-input-padding-y) var(--cui-chip-input-padding-x);
  font-size: var(--cui-chip-input-font-size);
  color: var(--cui-chip-input-color);
  background-color: var(--cui-chip-input-bg);
  border: var(--cui-chip-input-border-width) solid var(--cui-chip-input-border-color);
  border-radius: var(--cui-chip-input-border-radius);
  transition: var(--cui-chip-input-transition);
}

@media (prefers-reduced-motion: reduce) {
  .chip-input {
    transition: none;
  }
}
.chip-input:focus-within {
  border-color: rgb(67.2549019608%, 66.862745098%, 91.9607843137%);
  outline: 0;
  box-shadow: 0 0 var(--cui-focus-ring-blur) var(--cui-focus-ring-width) var(--cui-focus-ring-color);
}

.chip-input.disabled {
  background-color: var(--cui-secondary-bg);
  opacity: 1;
}

.chip-input.disabled > .chip {
  opacity: 0.65;
}

.chip-input.disabled > .chip .chip-dismiss {
  pointer-events: none;
}

.chip-input-field {
  flex: 1 1 auto;
  margin: 0;
  border: 0;
  outline: 0;
}

.chip-input-lg {
  --cui-chip-input-min-height: calc(1.5em + 1rem + calc(var(--cui-border-width) * 2));
  --cui-chip-input-padding-y: 0.375rem;
  --cui-chip-input-padding-x: 1rem;
  --cui-chip-input-border-radius: var(--cui-border-radius-lg);
  --cui-chip-input-font-size: 1.25rem;
  --cui-chip-input-gap: 0.5rem;
}

.chip-input-sm {
  --cui-chip-input-min-height: calc(1.5em + 0.5rem + calc(var(--cui-border-width) * 2));
  --cui-chip-input-padding-y: 0.125rem;
  --cui-chip-input-padding-x: 0.5rem;
  --cui-chip-input-border-radius: var(--cui-border-radius-sm);
  --cui-chip-input-font-size: 0.875rem;
  --cui-chip-input-gap: 0.125rem;
}

.form-label {
  margin-bottom: 0.5rem;
}

.col-form-label {
  padding-top: calc(0.375rem + var(--cui-border-width));
  padding-bottom: calc(0.375rem + var(--cui-border-width));
  margin-bottom: 0;
  font-size: inherit;
  line-height: 1.5;
}

.col-form-label-lg {
  padding-top: calc(0.5rem + var(--cui-border-width));
  padding-bottom: calc(0.5rem + var(--cui-border-width));
  font-size: 1.25rem;
}

.col-form-label-sm {
  padding-top: calc(0.25rem + var(--cui-border-width));
  padding-bottom: calc(0.25rem + var(--cui-border-width));
  font-size: 0.875rem;
}

.form-text {
  margin-top: 0.25rem;
  font-size: 0.875em;
  color: var(--cui-secondary-color);
}

.form-control {
  display: block;
  width: 100%;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: var(--cui-body-color);
  appearance: none;
  background-color: var(--cui-body-bg);
  background-clip: padding-box;
  border: var(--cui-border-width) solid var(--cui-border-color);
  border-radius: var(--cui-border-radius);
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

@media (prefers-reduced-motion: reduce) {
  .form-control {
    transition: none;
  }
}
.form-control[type=file] {
  overflow: hidden;
}

.form-control[type=file]:not(:disabled):not([readonly]) {
  cursor: pointer;
}

.form-control:focus {
  color: var(--cui-body-color);
  background-color: var(--cui-body-bg);
  border-color: rgb(67.2549019608%, 66.862745098%, 91.9607843137%);
  outline: 0;
  box-shadow: 0 0 0 0.25rem rgba(88, 86, 214, 0.25);
}

.form-control::-webkit-date-and-time-value {
  min-width: 85px;
  height: 1.5em;
  margin: 0;
}

.form-control::-webkit-datetime-edit {
  display: block;
  padding: 0;
}

.form-control::placeholder {
  color: var(--cui-input-placeholder-color, var(--cui-secondary-color));
  opacity: 1;
}

.form-control:disabled {
  background-color: var(--cui-secondary-bg);
  opacity: 1;
}

.form-control::file-selector-button {
  padding: 0.375rem 0.75rem;
  margin: -0.375rem -0.75rem;
  margin-inline-end: 0.75rem;
  color: var(--cui-body-color);
  background-color: var(--cui-tertiary-bg);
  pointer-events: none;
  border-color: inherit;
  border-style: solid;
  border-width: 0;
  border-inline-end-width: var(--cui-border-width);
  border-radius: 0;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

@media (prefers-reduced-motion: reduce) {
  .form-control::file-selector-button {
    transition: none;
  }
}
.form-control:hover:not(:disabled):not([readonly])::file-selector-button {
  background-color: var(--cui-secondary-bg);
}

.form-control-plaintext {
  display: block;
  width: 100%;
  padding: 0.375rem 0;
  margin-bottom: 0;
  line-height: 1.5;
  color: var(--cui-body-color);
  background-color: transparent;
  border: solid transparent;
  border-width: var(--cui-border-width) 0;
}

.form-control-plaintext:focus {
  outline: 0;
}

.form-control-plaintext.form-control-sm, .form-control-plaintext.form-control-lg {
  padding-right: 0;
  padding-left: 0;
}

.form-control-sm {
  min-height: calc(1.5em + 0.5rem + calc(var(--cui-border-width) * 2));
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
  border-radius: var(--cui-border-radius-sm);
}

.form-control-sm::file-selector-button {
  padding: 0.25rem 0.5rem;
  margin: -0.25rem -0.5rem;
  margin-inline-end: 0.5rem;
}

.form-control-lg {
  min-height: calc(1.5em + 1rem + calc(var(--cui-border-width) * 2));
  padding: 0.5rem 1rem;
  font-size: 1.25rem;
  border-radius: var(--cui-border-radius-lg);
}

.form-control-lg::file-selector-button {
  padding: 0.5rem 1rem;
  margin: -0.5rem -1rem;
  margin-inline-end: 1rem;
}

textarea.form-control {
  min-height: calc(1.5em + 0.75rem + calc(var(--cui-border-width) * 2));
}

textarea.form-control-sm {
  min-height: calc(1.5em + 0.5rem + calc(var(--cui-border-width) * 2));
}

textarea.form-control-lg {
  min-height: calc(1.5em + 1rem + calc(var(--cui-border-width) * 2));
}

.form-control-color {
  width: 3rem;
  height: calc(1.5em + 0.75rem + calc(var(--cui-border-width) * 2));
  padding: 0.375rem;
}

.form-control-color:not(:disabled):not([readonly]) {
  cursor: pointer;
}

.form-control-color::-moz-color-swatch {
  border: 0 !important;
  border-radius: var(--cui-border-radius);
}

.form-control-color::-webkit-color-swatch {
  border: 0 !important;
  border-radius: var(--cui-border-radius);
}

.form-control-color.form-control-sm {
  height: calc(1.5em + 0.5rem + calc(var(--cui-border-width) * 2));
}

.form-control-color.form-control-lg {
  height: calc(1.5em + 1rem + calc(var(--cui-border-width) * 2));
}

.form-select {
  --cui-form-select-bg-img: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  display: block;
  width: 100%;
  padding-inline-start: 0.75rem;
  padding-inline-end: 2.25rem;
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: var(--cui-body-color);
  appearance: none;
  background-color: var(--cui-body-bg);
  background-image: var(--cui-form-select-bg-img), var(--cui-form-select-bg-icon, none);
  background-repeat: no-repeat;
  background-position: right 0.75rem center;
  background-size: 16px 12px;
  border: var(--cui-border-width) solid var(--cui-border-color);
  border-radius: var(--cui-border-radius);
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

@media (prefers-reduced-motion: reduce) {
  .form-select {
    transition: none;
  }
}
.form-select:focus {
  border-color: rgb(67.2549019608%, 66.862745098%, 91.9607843137%);
  outline: 0;
  box-shadow: 0 0 0 0.25rem rgba(88, 86, 214, 0.25);
}

.form-select[multiple], .form-select[size]:not([size="1"]) {
  padding-inline-end: 0.75rem;
  background-image: none;
}

.form-select:disabled {
  background-color: var(--cui-secondary-bg);
}

.form-select:-moz-focusring {
  color: transparent;
  text-shadow: 0 0 0 var(--cui-body-color);
}

.form-select-sm {
  padding-inline-start: 0.5rem;
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
  font-size: 0.875rem;
  border-radius: var(--cui-border-radius-sm);
}

.form-select-lg {
  padding-inline-start: 1rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  font-size: 1.25rem;
  border-radius: var(--cui-border-radius-lg);
}

[data-coreui-theme=dark] .form-select {
  --cui-form-select-bg-img: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

.form-check {
  display: block;
  min-height: 1.5rem;
  padding-inline-start: 1.5em;
  margin-bottom: 0.125rem;
}

.form-check .form-check-input {
  float: inline-start;
  margin-inline-start: -1.5em;
}

.form-check-reverse {
  padding-inline: 0 1.5em;
  text-align: end;
}

.form-check-reverse .form-check-input {
  float: inline-end;
  margin-inline: 0 -1.5em;
}

.form-check-input {
  --cui-form-check-bg: var(--cui-body-bg);
  flex-shrink: 0;
  width: 1em;
  height: 1em;
  margin-top: 0.25em;
  vertical-align: top;
  appearance: none;
  background-color: var(--cui-form-check-bg);
  background-image: var(--cui-form-check-bg-image);
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  border: var(--cui-border-width) solid var(--cui-border-color);
  print-color-adjust: exact;
}

.form-check-input[type=checkbox] {
  border-radius: 0.25em;
}

.form-check-input[type=radio] {
  border-radius: 50%;
}

.form-check-input:active {
  filter: brightness(90%);
}

.form-check-input:focus {
  border-color: rgb(67.2549019608%, 66.862745098%, 91.9607843137%);
  outline: 0;
  box-shadow: 0 0 0 0.25rem rgba(88, 86, 214, 0.25);
}

.form-check-input:checked {
  background-color: var(--cui-form-check-input-checked-bg-color, var(--cui-primary));
  border-color: var(--cui-form-check-input-checked-border-color, var(--cui-primary));
}

.form-check-input:checked[type=checkbox] {
  --cui-form-check-bg-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}

.form-check-input:checked[type=radio] {
  --cui-form-check-bg-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}

.form-check-input[type=checkbox]:indeterminate {
  background-color: var(--cui-primary);
  border-color: var(--cui-primary);
  --cui-form-check-bg-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
}

.form-check-input:disabled {
  pointer-events: none;
  filter: none;
  opacity: 0.5;
}

.form-check-input[disabled] ~ .form-check-label, .form-check-input:disabled ~ .form-check-label {
  cursor: default;
  opacity: 0.5;
}

.form-check-label {
  color: var(--cui-form-check-label-color, );
}

.form-switch {
  padding-inline-start: 2.5em;
}

.form-switch .form-check-input {
  --cui-form-switch-bg: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
  width: 2em;
  margin-inline-start: -2.5em;
  background-image: var(--cui-form-switch-bg);
  background-position: left center;
  border-radius: 2em;
  transition: background-position 0.15s ease-in-out;
}

@media (prefers-reduced-motion: reduce) {
  .form-switch .form-check-input {
    transition: none;
  }
}
.form-switch .form-check-input:focus {
  --cui-form-switch-bg: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='rgb%2867.2549019608%, 66.862745098%, 91.9607843137%%29'/%3e%3c/svg%3e");
}

.form-switch .form-check-input:checked {
  background-position: right center;
  --cui-form-switch-bg: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
}

.form-switch.form-check-reverse {
  padding-inline: 0 2.5em;
}

.form-switch.form-check-reverse .form-check-input {
  margin-inline: 0 -2.5em;
}

.form-switch-lg {
  min-height: 1.25em;
  padding-inline-start: 3em;
}

.form-switch-lg .form-check-input {
  width: 2.5em;
  height: 1.25em;
  margin-inline-start: -3em;
}

.form-switch-lg .form-check-label {
  padding-top: calc((1.25em - 1rem) / 2);
}

.form-switch-xl {
  min-height: 1.5em;
  padding-inline-start: 3.5em;
}

.form-switch-xl .form-check-input {
  width: 3em;
  height: 1.5em;
  margin-inline-start: -3.5em;
}

.form-switch-xl .form-check-label {
  padding-top: calc((1.5em - 1rem) / 2);
}

.form-check-inline {
  display: inline-block;
  margin-inline-end: 1rem;
}

.btn-check {
  position: absolute;
  clip: rect(0, 0, 0, 0);
  pointer-events: none;
}

.btn-check[disabled] + .btn, .btn-check:disabled + .btn {
  pointer-events: none;
  filter: none;
  opacity: 0.65;
}

[data-coreui-theme=dark] .form-switch .form-check-input:not(:checked):not(:focus) {
  --cui-form-switch-bg: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
}

.form-range {
  width: 100%;
  height: 1.5rem;
  padding: 0;
  appearance: none;
  background-color: transparent;
}

.form-range:focus {
  outline: 0;
}

.form-range:focus::-webkit-slider-thumb {
  box-shadow: 0 0 0 1px #fff, 0 0 0 0.25rem rgba(88, 86, 214, 0.25);
}

.form-range:focus::-moz-range-thumb {
  box-shadow: 0 0 0 1px #fff, 0 0 0 0.25rem rgba(88, 86, 214, 0.25);
}

.form-range::-moz-focus-outer {
  border: 0;
}

.form-range::-webkit-slider-thumb {
  width: 1rem;
  height: 1rem;
  margin-top: -0.25rem;
  appearance: none;
  background-color: var(--cui-primary);
  border: 0;
  border-radius: 1rem;
  -webkit-transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

@media (prefers-reduced-motion: reduce) {
  .form-range::-webkit-slider-thumb {
    -webkit-transition: none;
    transition: none;
  }
}
.form-range::-webkit-slider-thumb:active {
  background-color: rgb(80.3529411765%, 80.1176470588%, 95.1764705882%);
}

.form-range::-webkit-slider-runnable-track {
  width: 100%;
  height: 0.5rem;
  color: transparent;
  cursor: pointer;
  background-color: var(--cui-secondary-bg);
  border-color: transparent;
  border-radius: 1rem;
}

.form-range::-moz-range-thumb {
  width: 1rem;
  height: 1rem;
  appearance: none;
  background-color: var(--cui-primary);
  border: 0;
  border-radius: 1rem;
  -moz-transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

@media (prefers-reduced-motion: reduce) {
  .form-range::-moz-range-thumb {
    -moz-transition: none;
    transition: none;
  }
}
.form-range::-moz-range-thumb:active {
  background-color: rgb(80.3529411765%, 80.1176470588%, 95.1764705882%);
}

.form-range::-moz-range-track {
  width: 100%;
  height: 0.5rem;
  color: transparent;
  cursor: pointer;
  background-color: var(--cui-secondary-bg);
  border-color: transparent;
  border-radius: 1rem;
}

.form-range:disabled {
  pointer-events: none;
}

.form-range:disabled::-webkit-slider-thumb {
  background-color: var(--cui-secondary-color);
}

.form-range:disabled::-moz-range-thumb {
  background-color: var(--cui-secondary-color);
}

.form-floating {
  position: relative;
}

.form-floating > .form-control,
.form-floating > .form-control-plaintext,
.form-floating > .form-select {
  height: calc(3.5rem + calc(var(--cui-border-width) * 2));
  min-height: calc(3.5rem + calc(var(--cui-border-width) * 2));
  line-height: 1.25;
}

.form-floating > label {
  position: absolute;
  inset-inline-start: 0;
  top: 0;
  z-index: 2;
  max-width: 100%;
  height: 100%;
  padding: 1rem 0.75rem;
  overflow: hidden;
  color: rgba(var(--cui-body-color-rgb), 0.65);
  text-align: start;
  text-overflow: ellipsis;
  white-space: nowrap;
  pointer-events: none;
  border: var(--cui-border-width) solid transparent;
  transform-origin: 0 0;
  transition: opacity 0.1s ease-in-out, transform 0.1s ease-in-out;
}

@media (prefers-reduced-motion: reduce) {
  .form-floating > label {
    transition: none;
  }
}
.form-floating > .form-control,
.form-floating > .form-control-plaintext {
  padding: 1rem 0.75rem;
}

.form-floating > .form-control::placeholder,
.form-floating > .form-control-plaintext::placeholder {
  color: transparent;
}

.form-floating > .form-control:focus, .form-floating > .form-control:not(:placeholder-shown),
.form-floating > .form-control-plaintext:focus,
.form-floating > .form-control-plaintext:not(:placeholder-shown) {
  padding-top: 1.625rem;
  padding-bottom: 0.625rem;
}

.form-floating > .form-control:-webkit-autofill,
.form-floating > .form-control-plaintext:-webkit-autofill {
  padding-top: 1.625rem;
  padding-bottom: 0.625rem;
}

.form-floating > .form-select {
  padding-inline-start: 0.75rem;
  padding-top: 1.625rem;
  padding-bottom: 0.625rem;
}

.form-floating > .form-control:focus ~ label,
.form-floating > .form-control:not(:placeholder-shown) ~ label,
.form-floating > .form-control-plaintext ~ label,
.form-floating > .form-select ~ label {
  transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem);
}

.form-floating > .form-control:-webkit-autofill ~ label {
  transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem);
}

.form-floating > textarea:focus ~ label::after,
.form-floating > textarea:not(:placeholder-shown) ~ label::after {
  position: absolute;
  inset: 1rem 0.375rem;
  z-index: -1;
  height: 1.5em;
  content: "";
  background-color: var(--cui-body-bg);
  border-radius: var(--cui-border-radius);
}

.form-floating > textarea:disabled ~ label::after {
  background-color: var(--cui-secondary-bg);
}

.form-floating > .form-control-plaintext ~ label {
  border-width: var(--cui-border-width) 0;
}

.form-floating > :disabled ~ label,
.form-floating > .form-control:disabled ~ label {
  color: #6d7d9c;
}

.input-group {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  width: 100%;
}

.input-group > .form-control,
.input-group > .form-select,
.input-group > .form-floating {
  position: relative;
  flex: 1 1 auto;
  width: 1%;
  min-width: 0;
}

.input-group > .form-control:focus,
.input-group > .form-select:focus,
.input-group > .form-floating:focus-within {
  z-index: 5;
}

.input-group .btn {
  position: relative;
  z-index: 2;
}

.input-group .btn:focus {
  z-index: 5;
}

.input-group-text {
  display: flex;
  align-items: center;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: var(--cui-input-group-addon-color, var(--cui-body-color));
  text-align: center;
  white-space: nowrap;
  background-color: var(--cui-input-group-addon-bg, var(--cui-tertiary-bg));
  border: var(--cui-border-width) solid var(--cui-input-group-addon-border-color, var(--cui-border-color));
  border-radius: var(--cui-border-radius);
}

.input-group-lg > .form-control,
.input-group-lg > .form-select,
.input-group-lg > .input-group-text,
.input-group-lg > .btn {
  padding: 0.5rem 1rem;
  font-size: 1.25rem;
  border-radius: var(--cui-border-radius-lg);
}

.input-group-sm > .form-control,
.input-group-sm > .form-select,
.input-group-sm > .input-group-text,
.input-group-sm > .btn {
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
  border-radius: var(--cui-border-radius-sm);
}

.input-group-lg > .form-select,
.input-group-sm > .form-select {
  padding-inline-end: 3rem;
}

.input-group:not(.has-validation) > :not(:last-child):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),
.input-group:not(.has-validation) > .dropdown-toggle:nth-last-child(n+3),
.input-group:not(.has-validation) > .form-floating:not(:last-child) > .form-control,
.input-group:not(.has-validation) > .form-floating:not(:last-child) > .form-select {
  border-start-end-radius: 0;
  border-end-end-radius: 0;
}

.input-group.has-validation > :nth-last-child(n+3):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),
.input-group.has-validation > .dropdown-toggle:nth-last-child(n+4),
.input-group.has-validation > .form-floating:nth-last-child(n+3) > .form-control,
.input-group.has-validation > .form-floating:nth-last-child(n+3) > .form-select {
  border-start-end-radius: 0;
  border-end-end-radius: 0;
}

.input-group > :not(:first-child):not(.dropdown-menu):not(.valid-tooltip):not(.valid-feedback):not(.invalid-tooltip):not(.invalid-feedback) {
  margin-inline-start: calc(-1 * var(--cui-border-width));
  border-start-start-radius: 0;
  border-end-start-radius: 0;
}

.input-group > .form-floating:not(:first-child) > .form-control,
.input-group > .form-floating:not(:first-child) > .form-select {
  border-start-start-radius: 0;
  border-end-start-radius: 0;
}

.valid-feedback {
  display: none;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 0.875em;
  color: var(--cui-form-valid-color);
}

.valid-tooltip {
  position: absolute;
  top: 100%;
  z-index: 5;
  display: none;
  max-width: 100%;
  padding: 0.25rem 0.5rem;
  margin-top: 0.1rem;
  font-size: 0.875rem;
  color: #fff;
  background-color: var(--cui-success);
  border-radius: var(--cui-border-radius);
}

.was-validated :valid ~ .valid-feedback,
.was-validated :valid ~ .valid-tooltip,
.is-valid ~ .valid-feedback,
.is-valid ~ .valid-tooltip {
  display: block;
}

.was-validated .form-control:valid, .form-control.is-valid {
  border-color: var(--cui-form-valid-border-color);
  padding-inline-end: calc(1.5em + 0.75rem);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
  background-repeat: no-repeat;
  background-position: right calc(0.375em + 0.1875rem) center;
  background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
}

.was-validated .form-control:valid:focus, .form-control.is-valid:focus {
  border-color: var(--cui-form-valid-border-color);
  box-shadow: 0 0 0 0.25rem rgba(var(--cui-success-rgb), 0.25);
}

.was-validated textarea.form-control:valid, textarea.form-control.is-valid {
  padding-inline-end: calc(1.5em + 0.75rem);
  background-position: top calc(0.375em + 0.1875rem) right calc(0.375em + 0.1875rem);
}

.was-validated .form-select:valid, .form-select.is-valid {
  border-color: var(--cui-form-valid-border-color);
}

.was-validated .form-select:valid:not([multiple]):not([size]), .was-validated .form-select:valid:not([multiple])[size="1"], .form-select.is-valid:not([multiple]):not([size]), .form-select.is-valid:not([multiple])[size="1"] {
  --cui-form-select-bg-icon: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
  padding-inline-end: 4.125rem;
  background-position: right 0.75rem center, center right 2.25rem;
  background-size: 16px 12px, calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
}

.was-validated .form-select:valid:focus, .form-select.is-valid:focus {
  border-color: var(--cui-form-valid-border-color);
  box-shadow: 0 0 0 0.25rem rgba(var(--cui-success-rgb), 0.25);
}

.was-validated .form-control-color:valid, .form-control-color.is-valid {
  width: calc(3rem + calc(1.5em + 0.75rem));
}

.was-validated .form-check-input:valid, .form-check-input.is-valid {
  border-color: var(--cui-form-valid-border-color);
}

.was-validated .form-check-input:valid:checked, .form-check-input.is-valid:checked {
  background-color: var(--cui-form-valid-color);
}

.was-validated .form-check-input:valid:focus, .form-check-input.is-valid:focus {
  box-shadow: 0 0 0 0.25rem rgba(var(--cui-success-rgb), 0.25);
}

.was-validated .form-check-input:valid ~ .form-check-label, .form-check-input.is-valid ~ .form-check-label {
  color: var(--cui-form-valid-color);
}

.form-check-inline .form-check-input ~ .valid-feedback {
  margin-inline-start: 0.5em;
}

.was-validated .input-group > .form-control:not(:focus):valid, .input-group > .form-control:not(:focus).is-valid,
.was-validated .input-group > .form-select:not(:focus):valid,
.input-group > .form-select:not(:focus).is-valid,
.was-validated .input-group > .form-floating:not(:focus-within):valid,
.input-group > .form-floating:not(:focus-within).is-valid {
  z-index: 3;
}

.invalid-feedback {
  display: none;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 0.875em;
  color: var(--cui-form-invalid-color);
}

.invalid-tooltip {
  position: absolute;
  top: 100%;
  z-index: 5;
  display: none;
  max-width: 100%;
  padding: 0.25rem 0.5rem;
  margin-top: 0.1rem;
  font-size: 0.875rem;
  color: #fff;
  background-color: var(--cui-danger);
  border-radius: var(--cui-border-radius);
}

.was-validated :invalid ~ .invalid-feedback,
.was-validated :invalid ~ .invalid-tooltip,
.is-invalid ~ .invalid-feedback,
.is-invalid ~ .invalid-tooltip {
  display: block;
}

.was-validated .form-control:invalid, .form-control.is-invalid {
  border-color: var(--cui-form-invalid-border-color);
  padding-inline-end: calc(1.5em + 0.75rem);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
  background-repeat: no-repeat;
  background-position: right calc(0.375em + 0.1875rem) center;
  background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
}

.was-validated .form-control:invalid:focus, .form-control.is-invalid:focus {
  border-color: var(--cui-form-invalid-border-color);
  box-shadow: 0 0 0 0.25rem rgba(var(--cui-danger-rgb), 0.25);
}

.was-validated textarea.form-control:invalid, textarea.form-control.is-invalid {
  padding-inline-end: calc(1.5em + 0.75rem);
  background-position: top calc(0.375em + 0.1875rem) right calc(0.375em + 0.1875rem);
}

.was-validated .form-select:invalid, .form-select.is-invalid {
  border-color: var(--cui-form-invalid-border-color);
}

.was-validated .form-select:invalid:not([multiple]):not([size]), .was-validated .form-select:invalid:not([multiple])[size="1"], .form-select.is-invalid:not([multiple]):not([size]), .form-select.is-invalid:not([multiple])[size="1"] {
  --cui-form-select-bg-icon: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
  padding-inline-end: 4.125rem;
  background-position: right 0.75rem center, center right 2.25rem;
  background-size: 16px 12px, calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
}

.was-validated .form-select:invalid:focus, .form-select.is-invalid:focus {
  border-color: var(--cui-form-invalid-border-color);
  box-shadow: 0 0 0 0.25rem rgba(var(--cui-danger-rgb), 0.25);
}

.was-validated .form-control-color:invalid, .form-control-color.is-invalid {
  width: calc(3rem + calc(1.5em + 0.75rem));
}

.was-validated .form-check-input:invalid, .form-check-input.is-invalid {
  border-color: var(--cui-form-invalid-border-color);
}

.was-validated .form-check-input:invalid:checked, .form-check-input.is-invalid:checked {
  background-color: var(--cui-form-invalid-color);
}

.was-validated .form-check-input:invalid:focus, .form-check-input.is-invalid:focus {
  box-shadow: 0 0 0 0.25rem rgba(var(--cui-danger-rgb), 0.25);
}

.was-validated .form-check-input:invalid ~ .form-check-label, .form-check-input.is-invalid ~ .form-check-label {
  color: var(--cui-form-invalid-color);
}

.form-check-inline .form-check-input ~ .invalid-feedback {
  margin-inline-start: 0.5em;
}

.was-validated .input-group > .form-control:not(:focus):invalid, .input-group > .form-control:not(:focus).is-invalid,
.was-validated .input-group > .form-select:not(:focus):invalid,
.input-group > .form-select:not(:focus).is-invalid,
.was-validated .input-group > .form-floating:not(:focus-within):invalid,
.input-group > .form-floating:not(:focus-within).is-invalid {
  z-index: 4;
}

.btn {
  --cui-btn-padding-x: 0.75rem;
  --cui-btn-padding-y: 0.375rem;
  --cui-btn-font-family: ;
  --cui-btn-font-size: 1rem;
  --cui-btn-font-weight: 400;
  --cui-btn-line-height: 1.5;
  --cui-btn-color: var(--cui-body-color);
  --cui-btn-bg: transparent;
  --cui-btn-border-width: var(--cui-border-width);
  --cui-btn-border-color: transparent;
  --cui-btn-border-radius: var(--cui-border-radius);
  --cui-btn-hover-border-color: transparent;
  --cui-btn-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(8, 10, 12, 0.075);
  --cui-btn-disabled-opacity: 0.65;
  --cui-btn-focus-box-shadow: 0 0 0 0.25rem rgba(var(--cui-btn-focus-shadow-rgb), .5);
  display: inline-block;
  padding: var(--cui-btn-padding-y) var(--cui-btn-padding-x);
  font-family: var(--cui-btn-font-family);
  font-size: var(--cui-btn-font-size);
  font-weight: var(--cui-btn-font-weight);
  line-height: var(--cui-btn-line-height);
  color: var(--cui-btn-color);
  text-align: center;
  text-decoration: none;
  vertical-align: middle;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  border: var(--cui-btn-border-width) solid var(--cui-btn-border-color);
  border-radius: var(--cui-btn-border-radius);
  background-color: var(--cui-btn-bg);
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

@media (prefers-reduced-motion: reduce) {
  .btn {
    transition: none;
  }
}
.btn:hover {
  color: var(--cui-btn-hover-color);
  background-color: var(--cui-btn-hover-bg);
  border-color: var(--cui-btn-hover-border-color);
}

.btn-check + .btn:hover {
  color: var(--cui-btn-color);
  background-color: var(--cui-btn-bg);
  border-color: var(--cui-btn-border-color);
}

.btn:focus-visible {
  color: var(--cui-btn-hover-color);
  background-color: var(--cui-btn-hover-bg);
  border-color: var(--cui-btn-hover-border-color);
  outline: 0;
  box-shadow: var(--cui-btn-focus-box-shadow);
}

.btn-check:focus-visible + .btn {
  border-color: var(--cui-btn-hover-border-color);
  outline: 0;
  box-shadow: var(--cui-btn-focus-box-shadow);
}

.btn-check:checked + .btn, :not(.btn-check) + .btn:active, .btn:first-child:active, .btn.active, .btn.show {
  color: var(--cui-btn-active-color);
  background-color: var(--cui-btn-active-bg);
  border-color: var(--cui-btn-active-border-color);
}

.btn-check:checked + .btn:focus-visible, :not(.btn-check) + .btn:active:focus-visible, .btn:first-child:active:focus-visible, .btn.active:focus-visible, .btn.show:focus-visible {
  box-shadow: var(--cui-btn-focus-box-shadow);
}

.btn-check:checked:focus-visible + .btn {
  box-shadow: var(--cui-btn-focus-box-shadow);
}

.btn:disabled, .btn.disabled, fieldset:disabled .btn {
  color: var(--cui-btn-disabled-color);
  pointer-events: none;
  background-color: var(--cui-btn-disabled-bg);
  border-color: var(--cui-btn-disabled-border-color);
  opacity: var(--cui-btn-disabled-opacity);
}

.btn-ghost {
  --cui-btn-color: var(--cui-secondary-color);
  --cui-btn-border-color: transparent;
  --cui-btn-active-color: var(--cui-body-color);
  --cui-btn-active-bg: var(--cui-tertiary-bg);
  --cui-btn-active-border-color: var(--cui-tertiary-bg);
  --cui-btn-disabled-color: var(--cui-secondary-color);
  --cui-btn-disabled-border-color: transparent;
  --cui-btn-hover-color: var(--cui-body-color);
  --cui-btn-hover-bg: var(--cui-tertiary-bg);
  --cui-btn-hover-border-color: var(--cui-tertiary-bg);
  --cui-btn-focus-box-shadow: 0 0 0 0.25rem rgba(var(--cui-tertiary-bg-rgb), .5);
}

.btn-outline {
  --cui-btn-color: var(--cui-secondary-color);
  --cui-btn-border-color: var(--cui-border-color);
  --cui-btn-active-color: var(--cui-body-color);
  --cui-btn-active-bg: var(--cui-tertiary-bg);
  --cui-btn-active-border-color: var(--cui-border-color);
  --cui-btn-disabled-color: var(--cui-secondary-color);
  --cui-btn-disabled-border-color: var(--cui-border-color);
  --cui-btn-hover-color: var(--cui-body-color);
  --cui-btn-hover-bg: var(--cui-tertiary-bg);
  --cui-btn-hover-border-color: var(--cui-border-color);
  --cui-btn-focus-box-shadow: 0 0 0 0.25rem rgba(var(--cui-tertiary-bg-rgb), .5);
}

.btn-transparent {
  --cui-btn-active-border-color: transparent;
  --cui-btn-disabled-border-color: transparent;
  --cui-btn-hover-border-color: transparent;
}

.btn-primary {
  --cui-btn-color: #fff;
  --cui-btn-bg: #5856d6;
  --cui-btn-border-color: #5856d6;
  --cui-btn-hover-color: #fff;
  --cui-btn-hover-bg: rgb(29.3333333333%, 28.6666666667%, 71.3333333333%);
  --cui-btn-hover-border-color: rgb(27.6078431373%, 26.9803921569%, 67.137254902%);
  --cui-btn-focus-shadow-rgb: 113.05, 111.35, 220.15;
  --cui-btn-active-color: #fff;
  --cui-btn-active-bg: rgb(27.6078431373%, 26.9803921569%, 67.137254902%);
  --cui-btn-active-border-color: rgb(25.8823529412%, 25.2941176471%, 62.9411764706%);
  --cui-btn-active-shadow: inset 0 3px 5px rgba(8, 10, 12, 0.125);
  --cui-btn-disabled-color: #fff;
  --cui-btn-disabled-bg: #5856d6;
  --cui-btn-disabled-border-color: #5856d6;
}

.btn-secondary {
  --cui-btn-color: #fff;
  --cui-btn-bg: #6b7785;
  --cui-btn-border-color: #6b7785;
  --cui-btn-hover-color: #fff;
  --cui-btn-hover-bg: rgb(35.6666666667%, 39.6666666667%, 44.3333333333%);
  --cui-btn-hover-border-color: rgb(33.568627451%, 37.3333333333%, 41.7254901961%);
  --cui-btn-focus-shadow-rgb: 129.2, 139.4, 151.3;
  --cui-btn-active-color: #fff;
  --cui-btn-active-bg: rgb(33.568627451%, 37.3333333333%, 41.7254901961%);
  --cui-btn-active-border-color: rgb(31.4705882353%, 35%, 39.1176470588%);
  --cui-btn-active-shadow: inset 0 3px 5px rgba(8, 10, 12, 0.125);
  --cui-btn-disabled-color: #fff;
  --cui-btn-disabled-bg: #6b7785;
  --cui-btn-disabled-border-color: #6b7785;
}

.btn-success {
  --cui-btn-color: #080a0c;
  --cui-btn-bg: #1b9e3e;
  --cui-btn-border-color: #1b9e3e;
  --cui-btn-hover-color: #080a0c;
  --cui-btn-hover-bg: rgb(24%, 67.6666666667%, 35.6666666667%);
  --cui-btn-hover-border-color: rgb(19.5294117647%, 65.7647058824%, 31.8823529412%);
  --cui-btn-focus-shadow-rgb: 24.15, 135.8, 54.5;
  --cui-btn-active-color: #080a0c;
  --cui-btn-active-bg: rgb(28.4705882353%, 69.568627451%, 39.4509803922%);
  --cui-btn-active-border-color: rgb(19.5294117647%, 65.7647058824%, 31.8823529412%);
  --cui-btn-active-shadow: inset 0 3px 5px rgba(8, 10, 12, 0.125);
  --cui-btn-disabled-color: #080a0c;
  --cui-btn-disabled-bg: #1b9e3e;
  --cui-btn-disabled-border-color: #1b9e3e;
}

.btn-info {
  --cui-btn-color: #080a0c;
  --cui-btn-bg: #39f;
  --cui-btn-border-color: #39f;
  --cui-btn-hover-color: #080a0c;
  --cui-btn-hover-bg: rgb(32%, 66%, 100%);
  --cui-btn-hover-border-color: rgb(28%, 64%, 100%);
  --cui-btn-focus-shadow-rgb: 44.55, 131.55, 218.55;
  --cui-btn-active-color: #080a0c;
  --cui-btn-active-bg: rgb(36%, 68%, 100%);
  --cui-btn-active-border-color: rgb(28%, 64%, 100%);
  --cui-btn-active-shadow: inset 0 3px 5px rgba(8, 10, 12, 0.125);
  --cui-btn-disabled-color: #080a0c;
  --cui-btn-disabled-bg: #39f;
  --cui-btn-disabled-border-color: #39f;
}

.btn-warning {
  --cui-btn-color: #080a0c;
  --cui-btn-bg: #f9b115;
  --cui-btn-border-color: #f9b115;
  --cui-btn-hover-color: #080a0c;
  --cui-btn-hover-bg: rgb(98%, 74%, 22%);
  --cui-btn-hover-border-color: rgb(97.8823529412%, 72.4705882353%, 17.4117647059%);
  --cui-btn-focus-shadow-rgb: 212.85, 151.95, 19.65;
  --cui-btn-active-color: #080a0c;
  --cui-btn-active-bg: rgb(98.1176470588%, 75.5294117647%, 26.5882352941%);
  --cui-btn-active-border-color: rgb(97.8823529412%, 72.4705882353%, 17.4117647059%);
  --cui-btn-active-shadow: inset 0 3px 5px rgba(8, 10, 12, 0.125);
  --cui-btn-disabled-color: #080a0c;
  --cui-btn-disabled-bg: #f9b115;
  --cui-btn-disabled-border-color: #f9b115;
}

.btn-danger {
  --cui-btn-color: #080a0c;
  --cui-btn-bg: #e55353;
  --cui-btn-border-color: #e55353;
  --cui-btn-hover-color: #080a0c;
  --cui-btn-hover-bg: rgb(91.3333333333%, 42.6666666667%, 42.6666666667%);
  --cui-btn-hover-border-color: rgb(90.8235294118%, 39.2941176471%, 39.2941176471%);
  --cui-btn-focus-shadow-rgb: 195.85, 72.05, 72.35;
  --cui-btn-active-color: #080a0c;
  --cui-btn-active-bg: rgb(91.8431372549%, 46.0392156863%, 46.0392156863%);
  --cui-btn-active-border-color: rgb(90.8235294118%, 39.2941176471%, 39.2941176471%);
  --cui-btn-active-shadow: inset 0 3px 5px rgba(8, 10, 12, 0.125);
  --cui-btn-disabled-color: #080a0c;
  --cui-btn-disabled-bg: #e55353;
  --cui-btn-disabled-border-color: #e55353;
}

.btn-light {
  --cui-btn-color: #080a0c;
  --cui-btn-bg: #f3f4f7;
  --cui-btn-border-color: #f3f4f7;
  --cui-btn-hover-color: #080a0c;
  --cui-btn-hover-bg: rgb(81%, 81.3333333333%, 82.3333333333%);
  --cui-btn-hover-border-color: rgb(76.2352941176%, 76.5490196078%, 77.4901960784%);
  --cui-btn-focus-shadow-rgb: 207.75, 208.9, 211.75;
  --cui-btn-active-color: #080a0c;
  --cui-btn-active-bg: rgb(76.2352941176%, 76.5490196078%, 77.4901960784%);
  --cui-btn-active-border-color: rgb(71.4705882353%, 71.7647058824%, 72.6470588235%);
  --cui-btn-active-shadow: inset 0 3px 5px rgba(8, 10, 12, 0.125);
  --cui-btn-disabled-color: #080a0c;
  --cui-btn-disabled-bg: #f3f4f7;
  --cui-btn-disabled-border-color: #f3f4f7;
}

.btn-dark {
  --cui-btn-color: #fff;
  --cui-btn-bg: #212631;
  --cui-btn-border-color: #212631;
  --cui-btn-hover-color: #fff;
  --cui-btn-hover-bg: rgb(26%, 27.6666666667%, 31.3333333333%);
  --cui-btn-hover-border-color: rgb(21.6470588235%, 23.4117647059%, 27.2941176471%);
  --cui-btn-focus-shadow-rgb: 66.3, 70.55, 79.9;
  --cui-btn-active-color: #fff;
  --cui-btn-active-bg: rgb(30.3529411765%, 31.9215686275%, 35.3725490196%);
  --cui-btn-active-border-color: rgb(21.6470588235%, 23.4117647059%, 27.2941176471%);
  --cui-btn-active-shadow: inset 0 3px 5px rgba(8, 10, 12, 0.125);
  --cui-btn-disabled-color: #fff;
  --cui-btn-disabled-bg: #212631;
  --cui-btn-disabled-border-color: #212631;
}

.btn-outline-primary {
  --cui-btn-color: #5856d6;
  --cui-btn-border-color: #5856d6;
  --cui-btn-hover-color: #fff;
  --cui-btn-hover-bg: #5856d6;
  --cui-btn-hover-border-color: #5856d6;
  --cui-btn-focus-shadow-rgb: 88, 86, 214;
  --cui-btn-active-color: #fff;
  --cui-btn-active-bg: #5856d6;
  --cui-btn-active-border-color: #5856d6;
  --cui-btn-active-shadow: inset 0 3px 5px rgba(8, 10, 12, 0.125);
  --cui-btn-disabled-color: #5856d6;
  --cui-btn-disabled-bg: transparent;
  --cui-btn-disabled-border-color: #5856d6;
  --cui-gradient: none;
}

.btn-outline-secondary {
  --cui-btn-color: #6b7785;
  --cui-btn-border-color: #6b7785;
  --cui-btn-hover-color: #fff;
  --cui-btn-hover-bg: #6b7785;
  --cui-btn-hover-border-color: #6b7785;
  --cui-btn-focus-shadow-rgb: 107, 119, 133;
  --cui-btn-active-color: #fff;
  --cui-btn-active-bg: #6b7785;
  --cui-btn-active-border-color: #6b7785;
  --cui-btn-active-shadow: inset 0 3px 5px rgba(8, 10, 12, 0.125);
  --cui-btn-disabled-color: #6b7785;
  --cui-btn-disabled-bg: transparent;
  --cui-btn-disabled-border-color: #6b7785;
  --cui-gradient: none;
}

.btn-outline-success {
  --cui-btn-color: #1b9e3e;
  --cui-btn-border-color: #1b9e3e;
  --cui-btn-hover-color: #080a0c;
  --cui-btn-hover-bg: #1b9e3e;
  --cui-btn-hover-border-color: #1b9e3e;
  --cui-btn-focus-shadow-rgb: 27, 158, 62;
  --cui-btn-active-color: #080a0c;
  --cui-btn-active-bg: #1b9e3e;
  --cui-btn-active-border-color: #1b9e3e;
  --cui-btn-active-shadow: inset 0 3px 5px rgba(8, 10, 12, 0.125);
  --cui-btn-disabled-color: #1b9e3e;
  --cui-btn-disabled-bg: transparent;
  --cui-btn-disabled-border-color: #1b9e3e;
  --cui-gradient: none;
}

.btn-outline-info {
  --cui-btn-color: #39f;
  --cui-btn-border-color: #39f;
  --cui-btn-hover-color: #080a0c;
  --cui-btn-hover-bg: #39f;
  --cui-btn-hover-border-color: #39f;
  --cui-btn-focus-shadow-rgb: 51, 153, 255;
  --cui-btn-active-color: #080a0c;
  --cui-btn-active-bg: #39f;
  --cui-btn-active-border-color: #39f;
  --cui-btn-active-shadow: inset 0 3px 5px rgba(8, 10, 12, 0.125);
  --cui-btn-disabled-color: #39f;
  --cui-btn-disabled-bg: transparent;
  --cui-btn-disabled-border-color: #39f;
  --cui-gradient: none;
}

.btn-outline-warning {
  --cui-btn-color: #f9b115;
  --cui-btn-border-color: #f9b115;
  --cui-btn-hover-color: #080a0c;
  --cui-btn-hover-bg: #f9b115;
  --cui-btn-hover-border-color: #f9b115;
  --cui-btn-focus-shadow-rgb: 249, 177, 21;
  --cui-btn-active-color: #080a0c;
  --cui-btn-active-bg: #f9b115;
  --cui-btn-active-border-color: #f9b115;
  --cui-btn-active-shadow: inset 0 3px 5px rgba(8, 10, 12, 0.125);
  --cui-btn-disabled-color: #f9b115;
  --cui-btn-disabled-bg: transparent;
  --cui-btn-disabled-border-color: #f9b115;
  --cui-gradient: none;
}

.btn-outline-danger {
  --cui-btn-color: #e55353;
  --cui-btn-border-color: #e55353;
  --cui-btn-hover-color: #080a0c;
  --cui-btn-hover-bg: #e55353;
  --cui-btn-hover-border-color: #e55353;
  --cui-btn-focus-shadow-rgb: 229, 83, 83;
  --cui-btn-active-color: #080a0c;
  --cui-btn-active-bg: #e55353;
  --cui-btn-active-border-color: #e55353;
  --cui-btn-active-shadow: inset 0 3px 5px rgba(8, 10, 12, 0.125);
  --cui-btn-disabled-color: #e55353;
  --cui-btn-disabled-bg: transparent;
  --cui-btn-disabled-border-color: #e55353;
  --cui-gradient: none;
}

.btn-outline-light {
  --cui-btn-color: #f3f4f7;
  --cui-btn-border-color: #f3f4f7;
  --cui-btn-hover-color: #080a0c;
  --cui-btn-hover-bg: #f3f4f7;
  --cui-btn-hover-border-color: #f3f4f7;
  --cui-btn-focus-shadow-rgb: 243, 244, 247;
  --cui-btn-active-color: #080a0c;
  --cui-btn-active-bg: #f3f4f7;
  --cui-btn-active-border-color: #f3f4f7;
  --cui-btn-active-shadow: inset 0 3px 5px rgba(8, 10, 12, 0.125);
  --cui-btn-disabled-color: #f3f4f7;
  --cui-btn-disabled-bg: transparent;
  --cui-btn-disabled-border-color: #f3f4f7;
  --cui-gradient: none;
}

.btn-outline-dark {
  --cui-btn-color: #212631;
  --cui-btn-border-color: #212631;
  --cui-btn-hover-color: #fff;
  --cui-btn-hover-bg: #212631;
  --cui-btn-hover-border-color: #212631;
  --cui-btn-focus-shadow-rgb: 33, 38, 49;
  --cui-btn-active-color: #fff;
  --cui-btn-active-bg: #212631;
  --cui-btn-active-border-color: #212631;
  --cui-btn-active-shadow: inset 0 3px 5px rgba(8, 10, 12, 0.125);
  --cui-btn-disabled-color: #212631;
  --cui-btn-disabled-bg: transparent;
  --cui-btn-disabled-border-color: #212631;
  --cui-gradient: none;
}

.btn-ghost-primary {
  --cui-btn-color: #5856d6;
  --cui-btn-border-color: transparent;
  --cui-btn-hover-bg: #5856d6;
  --cui-btn-hover-border-color: #5856d6;
  --cui-btn-hover-color: #fff;
  --cui-btn-active-bg: #5856d6;
  --cui-btn-active-border-color: #5856d6;
  --cui-btn-active-color: #fff;
  --cui-btn-disabled-color: #5856d6;
  --cui-btn-disabled-bg: transparent;
  --cui-btn-disabled-border-color: transparent;
}

.btn-ghost-secondary {
  --cui-btn-color: #6b7785;
  --cui-btn-border-color: transparent;
  --cui-btn-hover-bg: #6b7785;
  --cui-btn-hover-border-color: #6b7785;
  --cui-btn-hover-color: #fff;
  --cui-btn-active-bg: #6b7785;
  --cui-btn-active-border-color: #6b7785;
  --cui-btn-active-color: #fff;
  --cui-btn-disabled-color: #6b7785;
  --cui-btn-disabled-bg: transparent;
  --cui-btn-disabled-border-color: transparent;
}

.btn-ghost-success {
  --cui-btn-color: #1b9e3e;
  --cui-btn-border-color: transparent;
  --cui-btn-hover-bg: #1b9e3e;
  --cui-btn-hover-border-color: #1b9e3e;
  --cui-btn-hover-color: #080a0c;
  --cui-btn-active-bg: #1b9e3e;
  --cui-btn-active-border-color: #1b9e3e;
  --cui-btn-active-color: #080a0c;
  --cui-btn-disabled-color: #1b9e3e;
  --cui-btn-disabled-bg: transparent;
  --cui-btn-disabled-border-color: transparent;
}

.btn-ghost-info {
  --cui-btn-color: #39f;
  --cui-btn-border-color: transparent;
  --cui-btn-hover-bg: #39f;
  --cui-btn-hover-border-color: #39f;
  --cui-btn-hover-color: #080a0c;
  --cui-btn-active-bg: #39f;
  --cui-btn-active-border-color: #39f;
  --cui-btn-active-color: #080a0c;
  --cui-btn-disabled-color: #39f;
  --cui-btn-disabled-bg: transparent;
  --cui-btn-disabled-border-color: transparent;
}

.btn-ghost-warning {
  --cui-btn-color: #f9b115;
  --cui-btn-border-color: transparent;
  --cui-btn-hover-bg: #f9b115;
  --cui-btn-hover-border-color: #f9b115;
  --cui-btn-hover-color: #080a0c;
  --cui-btn-active-bg: #f9b115;
  --cui-btn-active-border-color: #f9b115;
  --cui-btn-active-color: #080a0c;
  --cui-btn-disabled-color: #f9b115;
  --cui-btn-disabled-bg: transparent;
  --cui-btn-disabled-border-color: transparent;
}

.btn-ghost-danger {
  --cui-btn-color: #e55353;
  --cui-btn-border-color: transparent;
  --cui-btn-hover-bg: #e55353;
  --cui-btn-hover-border-color: #e55353;
  --cui-btn-hover-color: #080a0c;
  --cui-btn-active-bg: #e55353;
  --cui-btn-active-border-color: #e55353;
  --cui-btn-active-color: #080a0c;
  --cui-btn-disabled-color: #e55353;
  --cui-btn-disabled-bg: transparent;
  --cui-btn-disabled-border-color: transparent;
}

.btn-ghost-light {
  --cui-btn-color: #f3f4f7;
  --cui-btn-border-color: transparent;
  --cui-btn-hover-bg: #f3f4f7;
  --cui-btn-hover-border-color: #f3f4f7;
  --cui-btn-hover-color: #080a0c;
  --cui-btn-active-bg: #f3f4f7;
  --cui-btn-active-border-color: #f3f4f7;
  --cui-btn-active-color: #080a0c;
  --cui-btn-disabled-color: #f3f4f7;
  --cui-btn-disabled-bg: transparent;
  --cui-btn-disabled-border-color: transparent;
}

.btn-ghost-dark {
  --cui-btn-color: #212631;
  --cui-btn-border-color: transparent;
  --cui-btn-hover-bg: #212631;
  --cui-btn-hover-border-color: #212631;
  --cui-btn-hover-color: #fff;
  --cui-btn-active-bg: #212631;
  --cui-btn-active-border-color: #212631;
  --cui-btn-active-color: #fff;
  --cui-btn-disabled-color: #212631;
  --cui-btn-disabled-bg: transparent;
  --cui-btn-disabled-border-color: transparent;
}

.btn-link {
  --cui-btn-font-weight: 400;
  --cui-btn-color: var(--cui-link-color);
  --cui-btn-bg: transparent;
  --cui-btn-border-color: transparent;
  --cui-btn-hover-color: var(--cui-link-hover-color);
  --cui-btn-hover-border-color: transparent;
  --cui-btn-active-border-color: transparent;
  --cui-btn-disabled-color: #6d7d9c;
  --cui-btn-disabled-border-color: transparent;
  --cui-btn-box-shadow: none;
  --cui-btn-focus-shadow-rgb: 113.05, 111.35, 220.15;
  text-decoration: underline;
}

.btn-link:focus-visible {
  color: var(--cui-btn-color);
}

.btn-lg, .btn-group-lg > .btn {
  --cui-btn-padding-y: 0.5rem;
  --cui-btn-padding-x: 1rem;
  --cui-btn-font-size: 1.25rem;
  --cui-btn-border-radius: var(--cui-border-radius-lg);
}

.btn-sm, .btn-group-sm > .btn {
  --cui-btn-padding-y: 0.25rem;
  --cui-btn-padding-x: 0.5rem;
  --cui-btn-font-size: 0.875rem;
  --cui-btn-border-radius: var(--cui-border-radius-sm);
}

[data-coreui-theme=dark] .btn-primary {
  --cui-btn-color: #fff;
  --cui-btn-bg: rgb(36.9411764706%, 36.2352941176%, 81.4117647059%);
  --cui-btn-border-color: rgb(36.9411764706%, 36.2352941176%, 81.4117647059%);
  --cui-btn-hover-color: #fff;
  --cui-btn-hover-bg: rgb(31.4%, 30.8%, 69.2%);
  --cui-btn-hover-border-color: rgb(29.5529411765%, 28.9882352941%, 65.1294117647%);
  --cui-btn-focus-shadow-rgb: 118.32, 116.79, 214.71;
  --cui-btn-active-color: #fff;
  --cui-btn-active-bg: rgb(29.5529411765%, 28.9882352941%, 65.1294117647%);
  --cui-btn-active-border-color: rgb(27.7058823529%, 27.1764705882%, 61.0588235294%);
  --cui-btn-active-shadow: inset 0 3px 5px rgba(8, 10, 12, 0.125);
  --cui-btn-disabled-color: #fff;
  --cui-btn-disabled-bg: rgb(36.9411764706%, 36.2352941176%, 81.4117647059%);
  --cui-btn-disabled-border-color: rgb(36.9411764706%, 36.2352941176%, 81.4117647059%);
}

[data-coreui-theme=dark] .btn-secondary {
  --cui-btn-color: #fff;
  --cui-btn-bg: #6b7785;
  --cui-btn-border-color: #6b7785;
  --cui-btn-hover-color: #fff;
  --cui-btn-hover-bg: rgb(35.6666666667%, 39.6666666667%, 44.3333333333%);
  --cui-btn-hover-border-color: rgb(33.568627451%, 37.3333333333%, 41.7254901961%);
  --cui-btn-focus-shadow-rgb: 129.2, 139.4, 151.3;
  --cui-btn-active-color: #fff;
  --cui-btn-active-bg: rgb(33.568627451%, 37.3333333333%, 41.7254901961%);
  --cui-btn-active-border-color: rgb(31.4705882353%, 35%, 39.1176470588%);
  --cui-btn-active-shadow: inset 0 3px 5px rgba(8, 10, 12, 0.125);
  --cui-btn-disabled-color: #fff;
  --cui-btn-disabled-bg: #6b7785;
  --cui-btn-disabled-border-color: #6b7785;
}

[data-coreui-theme=dark] .btn-success {
  --cui-btn-color: #080a0c;
  --cui-btn-bg: rgb(13.1568627451%, 59.3921568627%, 25.5098039216%);
  --cui-btn-border-color: rgb(13.1568627451%, 59.3921568627%, 25.5098039216%);
  --cui-btn-hover-color: #080a0c;
  --cui-btn-hover-bg: rgb(26.1833333333%, 65.4833333333%, 36.6833333333%);
  --cui-btn-hover-border-color: rgb(21.8411764706%, 63.4529411765%, 32.9588235294%);
  --cui-btn-focus-shadow-rgb: 29.7175, 130.2325, 57.0925;
  --cui-btn-active-color: #080a0c;
  --cui-btn-active-bg: rgb(30.5254901961%, 67.5137254902%, 40.4078431373%);
  --cui-btn-active-border-color: rgb(21.8411764706%, 63.4529411765%, 32.9588235294%);
  --cui-btn-active-shadow: inset 0 3px 5px rgba(8, 10, 12, 0.125);
  --cui-btn-disabled-color: #080a0c;
  --cui-btn-disabled-bg: rgb(13.1568627451%, 59.3921568627%, 25.5098039216%);
  --cui-btn-disabled-border-color: rgb(13.1568627451%, 59.3921568627%, 25.5098039216%);
}

[data-coreui-theme=dark] .btn-info {
  --cui-btn-color: #080a0c;
  --cui-btn-bg: rgb(24%, 60%, 96%);
  --cui-btn-border-color: rgb(24%, 60%, 96%);
  --cui-btn-hover-color: #080a0c;
  --cui-btn-hover-bg: rgb(35.4%, 66%, 96.6%);
  --cui-btn-hover-border-color: rgb(31.6%, 64%, 96.4%);
  --cui-btn-focus-shadow-rgb: 53.22, 131.55, 209.88;
  --cui-btn-active-color: #080a0c;
  --cui-btn-active-bg: rgb(39.2%, 68%, 96.8%);
  --cui-btn-active-border-color: rgb(31.6%, 64%, 96.4%);
  --cui-btn-active-shadow: inset 0 3px 5px rgba(8, 10, 12, 0.125);
  --cui-btn-disabled-color: #080a0c;
  --cui-btn-disabled-bg: rgb(24%, 60%, 96%);
  --cui-btn-disabled-border-color: rgb(24%, 60%, 96%);
}

[data-coreui-theme=dark] .btn-warning {
  --cui-btn-color: #080a0c;
  --cui-btn-bg: rgb(93.1764705882%, 67.7647058824%, 12.7058823529%);
  --cui-btn-border-color: rgb(93.1764705882%, 67.7647058824%, 12.7058823529%);
  --cui-btn-hover-color: #080a0c;
  --cui-btn-hover-bg: rgb(94.2%, 72.6%, 25.8%);
  --cui-btn-hover-border-color: rgb(93.8588235294%, 70.9882352941%, 21.4352941176%);
  --cui-btn-focus-shadow-rgb: 203.16, 148.38, 29.34;
  --cui-btn-active-color: #080a0c;
  --cui-btn-active-bg: rgb(94.5411764706%, 74.2117647059%, 30.1647058824%);
  --cui-btn-active-border-color: rgb(93.8588235294%, 70.9882352941%, 21.4352941176%);
  --cui-btn-active-shadow: inset 0 3px 5px rgba(8, 10, 12, 0.125);
  --cui-btn-disabled-color: #080a0c;
  --cui-btn-disabled-bg: rgb(93.1764705882%, 67.7647058824%, 12.7058823529%);
  --cui-btn-disabled-border-color: rgb(93.1764705882%, 67.7647058824%, 12.7058823529%);
}

[data-coreui-theme=dark] .btn-danger {
  --cui-btn-color: #080a0c;
  --cui-btn-bg: rgb(86.9411764706%, 35.4117647059%, 35.4117647059%);
  --cui-btn-border-color: rgb(86.9411764706%, 35.4117647059%, 35.4117647059%);
  --cui-btn-hover-color: #080a0c;
  --cui-btn-hover-bg: rgb(88.9%, 45.1%, 45.1%);
  --cui-btn-hover-border-color: rgb(88.2470588235%, 41.8705882353%, 41.8705882353%);
  --cui-btn-focus-shadow-rgb: 189.645, 78.255, 78.555;
  --cui-btn-active-color: #080a0c;
  --cui-btn-active-bg: rgb(89.5529411765%, 48.3294117647%, 48.3294117647%);
  --cui-btn-active-border-color: rgb(88.2470588235%, 41.8705882353%, 41.8705882353%);
  --cui-btn-active-shadow: inset 0 3px 5px rgba(8, 10, 12, 0.125);
  --cui-btn-disabled-color: #080a0c;
  --cui-btn-disabled-bg: rgb(86.9411764706%, 35.4117647059%, 35.4117647059%);
  --cui-btn-disabled-border-color: rgb(86.9411764706%, 35.4117647059%, 35.4117647059%);
}

[data-coreui-theme=dark] .btn-light {
  --cui-btn-color: #080a0c;
  --cui-btn-bg: #f3f4f7;
  --cui-btn-border-color: #f3f4f7;
  --cui-btn-hover-color: #080a0c;
  --cui-btn-hover-bg: rgb(96%, 96.3333333333%, 97.3333333333%);
  --cui-btn-hover-border-color: rgb(95.7647058824%, 96.1176470588%, 97.1764705882%);
  --cui-btn-focus-shadow-rgb: 207.75, 208.9, 211.75;
  --cui-btn-active-color: #080a0c;
  --cui-btn-active-bg: rgb(96.2352941176%, 96.5490196078%, 97.4901960784%);
  --cui-btn-active-border-color: rgb(95.7647058824%, 96.1176470588%, 97.1764705882%);
  --cui-btn-active-shadow: inset 0 3px 5px rgba(8, 10, 12, 0.125);
  --cui-btn-disabled-color: #080a0c;
  --cui-btn-disabled-bg: #f3f4f7;
  --cui-btn-disabled-border-color: #f3f4f7;
}

[data-coreui-theme=dark] .btn-dark {
  --cui-btn-color: #fff;
  --cui-btn-bg: #212631;
  --cui-btn-border-color: #212631;
  --cui-btn-hover-color: #fff;
  --cui-btn-hover-bg: rgb(11%, 12.6666666667%, 16.3333333333%);
  --cui-btn-hover-border-color: rgb(10.3529411765%, 11.9215686275%, 15.3725490196%);
  --cui-btn-focus-shadow-rgb: 66.3, 70.55, 79.9;
  --cui-btn-active-color: #fff;
  --cui-btn-active-bg: rgb(10.3529411765%, 11.9215686275%, 15.3725490196%);
  --cui-btn-active-border-color: rgb(9.7058823529%, 11.1764705882%, 14.4117647059%);
  --cui-btn-active-shadow: inset 0 3px 5px rgba(8, 10, 12, 0.125);
  --cui-btn-disabled-color: #fff;
  --cui-btn-disabled-bg: #212631;
  --cui-btn-disabled-border-color: #212631;
}

[data-coreui-theme=dark] .btn-outline-primary {
  --cui-btn-color: rgb(36.9411764706%, 36.2352941176%, 81.4117647059%);
  --cui-btn-border-color: rgb(36.9411764706%, 36.2352941176%, 81.4117647059%);
  --cui-btn-hover-color: #fff;
  --cui-btn-hover-bg: rgb(36.9411764706%, 36.2352941176%, 81.4117647059%);
  --cui-btn-hover-border-color: rgb(36.9411764706%, 36.2352941176%, 81.4117647059%);
  --cui-btn-focus-shadow-rgb: 94.2, 92.4, 207.6;
  --cui-btn-active-color: #fff;
  --cui-btn-active-bg: rgb(36.9411764706%, 36.2352941176%, 81.4117647059%);
  --cui-btn-active-border-color: rgb(36.9411764706%, 36.2352941176%, 81.4117647059%);
  --cui-btn-active-shadow: inset 0 3px 5px rgba(8, 10, 12, 0.125);
  --cui-btn-disabled-color: rgb(36.9411764706%, 36.2352941176%, 81.4117647059%);
  --cui-btn-disabled-bg: transparent;
  --cui-btn-disabled-border-color: rgb(36.9411764706%, 36.2352941176%, 81.4117647059%);
  --cui-gradient: none;
}

[data-coreui-theme=dark] .btn-outline-secondary {
  --cui-btn-color: #6b7785;
  --cui-btn-border-color: #6b7785;
  --cui-btn-hover-color: #fff;
  --cui-btn-hover-bg: #6b7785;
  --cui-btn-hover-border-color: #6b7785;
  --cui-btn-focus-shadow-rgb: 107, 119, 133;
  --cui-btn-active-color: #fff;
  --cui-btn-active-bg: #6b7785;
  --cui-btn-active-border-color: #6b7785;
  --cui-btn-active-shadow: inset 0 3px 5px rgba(8, 10, 12, 0.125);
  --cui-btn-disabled-color: #6b7785;
  --cui-btn-disabled-bg: transparent;
  --cui-btn-disabled-border-color: #6b7785;
  --cui-gradient: none;
}

[data-coreui-theme=dark] .btn-outline-success {
  --cui-btn-color: rgb(13.1568627451%, 59.3921568627%, 25.5098039216%);
  --cui-btn-border-color: rgb(13.1568627451%, 59.3921568627%, 25.5098039216%);
  --cui-btn-hover-color: #080a0c;
  --cui-btn-hover-bg: rgb(13.1568627451%, 59.3921568627%, 25.5098039216%);
  --cui-btn-hover-border-color: rgb(13.1568627451%, 59.3921568627%, 25.5098039216%);
  --cui-btn-focus-shadow-rgb: 33.55, 151.45, 65.05;
  --cui-btn-active-color: #080a0c;
  --cui-btn-active-bg: rgb(13.1568627451%, 59.3921568627%, 25.5098039216%);
  --cui-btn-active-border-color: rgb(13.1568627451%, 59.3921568627%, 25.5098039216%);
  --cui-btn-active-shadow: inset 0 3px 5px rgba(8, 10, 12, 0.125);
  --cui-btn-disabled-color: rgb(13.1568627451%, 59.3921568627%, 25.5098039216%);
  --cui-btn-disabled-bg: transparent;
  --cui-btn-disabled-border-color: rgb(13.1568627451%, 59.3921568627%, 25.5098039216%);
  --cui-gradient: none;
}

[data-coreui-theme=dark] .btn-outline-info {
  --cui-btn-color: rgb(24%, 60%, 96%);
  --cui-btn-border-color: rgb(24%, 60%, 96%);
  --cui-btn-hover-color: #080a0c;
  --cui-btn-hover-bg: rgb(24%, 60%, 96%);
  --cui-btn-hover-border-color: rgb(24%, 60%, 96%);
  --cui-btn-focus-shadow-rgb: 61.2, 153, 244.8;
  --cui-btn-active-color: #080a0c;
  --cui-btn-active-bg: rgb(24%, 60%, 96%);
  --cui-btn-active-border-color: rgb(24%, 60%, 96%);
  --cui-btn-active-shadow: inset 0 3px 5px rgba(8, 10, 12, 0.125);
  --cui-btn-disabled-color: rgb(24%, 60%, 96%);
  --cui-btn-disabled-bg: transparent;
  --cui-btn-disabled-border-color: rgb(24%, 60%, 96%);
  --cui-gradient: none;
}

[data-coreui-theme=dark] .btn-outline-warning {
  --cui-btn-color: rgb(93.1764705882%, 67.7647058824%, 12.7058823529%);
  --cui-btn-border-color: rgb(93.1764705882%, 67.7647058824%, 12.7058823529%);
  --cui-btn-hover-color: #080a0c;
  --cui-btn-hover-bg: rgb(93.1764705882%, 67.7647058824%, 12.7058823529%);
  --cui-btn-hover-border-color: rgb(93.1764705882%, 67.7647058824%, 12.7058823529%);
  --cui-btn-focus-shadow-rgb: 237.6, 172.8, 32.4;
  --cui-btn-active-color: #080a0c;
  --cui-btn-active-bg: rgb(93.1764705882%, 67.7647058824%, 12.7058823529%);
  --cui-btn-active-border-color: rgb(93.1764705882%, 67.7647058824%, 12.7058823529%);
  --cui-btn-active-shadow: inset 0 3px 5px rgba(8, 10, 12, 0.125);
  --cui-btn-disabled-color: rgb(93.1764705882%, 67.7647058824%, 12.7058823529%);
  --cui-btn-disabled-bg: transparent;
  --cui-btn-disabled-border-color: rgb(93.1764705882%, 67.7647058824%, 12.7058823529%);
  --cui-gradient: none;
}

[data-coreui-theme=dark] .btn-outline-danger {
  --cui-btn-color: rgb(86.9411764706%, 35.4117647059%, 35.4117647059%);
  --cui-btn-border-color: rgb(86.9411764706%, 35.4117647059%, 35.4117647059%);
  --cui-btn-hover-color: #080a0c;
  --cui-btn-hover-bg: rgb(86.9411764706%, 35.4117647059%, 35.4117647059%);
  --cui-btn-hover-border-color: rgb(86.9411764706%, 35.4117647059%, 35.4117647059%);
  --cui-btn-focus-shadow-rgb: 221.7, 90.3, 90.3;
  --cui-btn-active-color: #080a0c;
  --cui-btn-active-bg: rgb(86.9411764706%, 35.4117647059%, 35.4117647059%);
  --cui-btn-active-border-color: rgb(86.9411764706%, 35.4117647059%, 35.4117647059%);
  --cui-btn-active-shadow: inset 0 3px 5px rgba(8, 10, 12, 0.125);
  --cui-btn-disabled-color: rgb(86.9411764706%, 35.4117647059%, 35.4117647059%);
  --cui-btn-disabled-bg: transparent;
  --cui-btn-disabled-border-color: rgb(86.9411764706%, 35.4117647059%, 35.4117647059%);
  --cui-gradient: none;
}

[data-coreui-theme=dark] .btn-outline-light {
  --cui-btn-color: #f3f4f7;
  --cui-btn-border-color: #f3f4f7;
  --cui-btn-hover-color: #080a0c;
  --cui-btn-hover-bg: #f3f4f7;
  --cui-btn-hover-border-color: #f3f4f7;
  --cui-btn-focus-shadow-rgb: 243, 244, 247;
  --cui-btn-active-color: #080a0c;
  --cui-btn-active-bg: #f3f4f7;
  --cui-btn-active-border-color: #f3f4f7;
  --cui-btn-active-shadow: inset 0 3px 5px rgba(8, 10, 12, 0.125);
  --cui-btn-disabled-color: #f3f4f7;
  --cui-btn-disabled-bg: transparent;
  --cui-btn-disabled-border-color: #f3f4f7;
  --cui-gradient: none;
}

[data-coreui-theme=dark] .btn-outline-dark {
  --cui-btn-color: #212631;
  --cui-btn-border-color: #212631;
  --cui-btn-hover-color: #fff;
  --cui-btn-hover-bg: #212631;
  --cui-btn-hover-border-color: #212631;
  --cui-btn-focus-shadow-rgb: 33, 38, 49;
  --cui-btn-active-color: #fff;
  --cui-btn-active-bg: #212631;
  --cui-btn-active-border-color: #212631;
  --cui-btn-active-shadow: inset 0 3px 5px rgba(8, 10, 12, 0.125);
  --cui-btn-disabled-color: #212631;
  --cui-btn-disabled-bg: transparent;
  --cui-btn-disabled-border-color: #212631;
  --cui-gradient: none;
}

[data-coreui-theme=dark] .btn-ghost-primary {
  --cui-btn-color: rgb(36.9411764706%, 36.2352941176%, 81.4117647059%);
  --cui-btn-border-color: transparent;
  --cui-btn-hover-bg: rgb(36.9411764706%, 36.2352941176%, 81.4117647059%);
  --cui-btn-hover-border-color: rgb(36.9411764706%, 36.2352941176%, 81.4117647059%);
  --cui-btn-hover-color: #fff;
  --cui-btn-active-bg: rgb(36.9411764706%, 36.2352941176%, 81.4117647059%);
  --cui-btn-active-border-color: rgb(36.9411764706%, 36.2352941176%, 81.4117647059%);
  --cui-btn-active-color: #fff;
  --cui-btn-disabled-color: rgb(36.9411764706%, 36.2352941176%, 81.4117647059%);
  --cui-btn-disabled-bg: transparent;
  --cui-btn-disabled-border-color: transparent;
}

[data-coreui-theme=dark] .btn-ghost-secondary {
  --cui-btn-color: #6b7785;
  --cui-btn-border-color: transparent;
  --cui-btn-hover-bg: #6b7785;
  --cui-btn-hover-border-color: #6b7785;
  --cui-btn-hover-color: #fff;
  --cui-btn-active-bg: #6b7785;
  --cui-btn-active-border-color: #6b7785;
  --cui-btn-active-color: #fff;
  --cui-btn-disabled-color: #6b7785;
  --cui-btn-disabled-bg: transparent;
  --cui-btn-disabled-border-color: transparent;
}

[data-coreui-theme=dark] .btn-ghost-success {
  --cui-btn-color: rgb(13.1568627451%, 59.3921568627%, 25.5098039216%);
  --cui-btn-border-color: transparent;
  --cui-btn-hover-bg: rgb(13.1568627451%, 59.3921568627%, 25.5098039216%);
  --cui-btn-hover-border-color: rgb(13.1568627451%, 59.3921568627%, 25.5098039216%);
  --cui-btn-hover-color: #080a0c;
  --cui-btn-active-bg: rgb(13.1568627451%, 59.3921568627%, 25.5098039216%);
  --cui-btn-active-border-color: rgb(13.1568627451%, 59.3921568627%, 25.5098039216%);
  --cui-btn-active-color: #080a0c;
  --cui-btn-disabled-color: rgb(13.1568627451%, 59.3921568627%, 25.5098039216%);
  --cui-btn-disabled-bg: transparent;
  --cui-btn-disabled-border-color: transparent;
}

[data-coreui-theme=dark] .btn-ghost-info {
  --cui-btn-color: rgb(24%, 60%, 96%);
  --cui-btn-border-color: transparent;
  --cui-btn-hover-bg: rgb(24%, 60%, 96%);
  --cui-btn-hover-border-color: rgb(24%, 60%, 96%);
  --cui-btn-hover-color: #080a0c;
  --cui-btn-active-bg: rgb(24%, 60%, 96%);
  --cui-btn-active-border-color: rgb(24%, 60%, 96%);
  --cui-btn-active-color: #080a0c;
  --cui-btn-disabled-color: rgb(24%, 60%, 96%);
  --cui-btn-disabled-bg: transparent;
  --cui-btn-disabled-border-color: transparent;
}

[data-coreui-theme=dark] .btn-ghost-warning {
  --cui-btn-color: rgb(93.1764705882%, 67.7647058824%, 12.7058823529%);
  --cui-btn-border-color: transparent;
  --cui-btn-hover-bg: rgb(93.1764705882%, 67.7647058824%, 12.7058823529%);
  --cui-btn-hover-border-color: rgb(93.1764705882%, 67.7647058824%, 12.7058823529%);
  --cui-btn-hover-color: #080a0c;
  --cui-btn-active-bg: rgb(93.1764705882%, 67.7647058824%, 12.7058823529%);
  --cui-btn-active-border-color: rgb(93.1764705882%, 67.7647058824%, 12.7058823529%);
  --cui-btn-active-color: #080a0c;
  --cui-btn-disabled-color: rgb(93.1764705882%, 67.7647058824%, 12.7058823529%);
  --cui-btn-disabled-bg: transparent;
  --cui-btn-disabled-border-color: transparent;
}

[data-coreui-theme=dark] .btn-ghost-danger {
  --cui-btn-color: rgb(86.9411764706%, 35.4117647059%, 35.4117647059%);
  --cui-btn-border-color: transparent;
  --cui-btn-hover-bg: rgb(86.9411764706%, 35.4117647059%, 35.4117647059%);
  --cui-btn-hover-border-color: rgb(86.9411764706%, 35.4117647059%, 35.4117647059%);
  --cui-btn-hover-color: #080a0c;
  --cui-btn-active-bg: rgb(86.9411764706%, 35.4117647059%, 35.4117647059%);
  --cui-btn-active-border-color: rgb(86.9411764706%, 35.4117647059%, 35.4117647059%);
  --cui-btn-active-color: #080a0c;
  --cui-btn-disabled-color: rgb(86.9411764706%, 35.4117647059%, 35.4117647059%);
  --cui-btn-disabled-bg: transparent;
  --cui-btn-disabled-border-color: transparent;
}

[data-coreui-theme=dark] .btn-ghost-light {
  --cui-btn-color: #f3f4f7;
  --cui-btn-border-color: transparent;
  --cui-btn-hover-bg: #f3f4f7;
  --cui-btn-hover-border-color: #f3f4f7;
  --cui-btn-hover-color: #080a0c;
  --cui-btn-active-bg: #f3f4f7;
  --cui-btn-active-border-color: #f3f4f7;
  --cui-btn-active-color: #080a0c;
  --cui-btn-disabled-color: #f3f4f7;
  --cui-btn-disabled-bg: transparent;
  --cui-btn-disabled-border-color: transparent;
}

[data-coreui-theme=dark] .btn-ghost-dark {
  --cui-btn-color: #212631;
  --cui-btn-border-color: transparent;
  --cui-btn-hover-bg: #212631;
  --cui-btn-hover-border-color: #212631;
  --cui-btn-hover-color: #fff;
  --cui-btn-active-bg: #212631;
  --cui-btn-active-border-color: #212631;
  --cui-btn-active-color: #fff;
  --cui-btn-disabled-color: #212631;
  --cui-btn-disabled-bg: transparent;
  --cui-btn-disabled-border-color: transparent;
}

.fade {
  transition: opacity 0.15s linear;
}

@media (prefers-reduced-motion: reduce) {
  .fade {
    transition: none;
  }
}
.fade:not(.show) {
  opacity: 0;
}

.collapse:not(.show) {
  display: none;
}

.collapsing {
  height: 0;
  overflow: hidden;
  transition: height 0.35s ease;
}

@media (prefers-reduced-motion: reduce) {
  .collapsing {
    transition: none;
  }
}
.collapsing.collapse-horizontal {
  width: 0;
  height: auto;
  transition: width 0.35s ease;
}

@media (prefers-reduced-motion: reduce) {
  .collapsing.collapse-horizontal {
    transition: none;
  }
}
.dropup,
.dropend,
.dropdown,
.dropstart,
.dropup-center,
.dropdown-center {
  position: relative;
}

.dropdown-toggle {
  white-space: nowrap;
}

.dropdown-toggle::after {
  display: inline-block;
  margin-inline-start: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid;
  border-right: 0.3em solid transparent;
  border-bottom: 0;
  border-left: 0.3em solid transparent;
}

.dropdown-toggle:empty::after {
  margin-inline-start: 0;
}

.dropdown-menu {
  --cui-dropdown-zindex: 1000;
  --cui-dropdown-min-width: 10rem;
  --cui-dropdown-padding-x: 0;
  --cui-dropdown-padding-y: 0.5rem;
  --cui-dropdown-spacer: 0.125rem;
  --cui-dropdown-font-size: 1rem;
  --cui-dropdown-color: var(--cui-body-color);
  --cui-dropdown-bg: var(--cui-body-bg);
  --cui-dropdown-border-color: var(--cui-border-color-translucent);
  --cui-dropdown-border-radius: var(--cui-border-radius);
  --cui-dropdown-border-width: var(--cui-border-width);
  --cui-dropdown-inner-border-radius: calc(var(--cui-dropdown-border-radius) - var(--cui-dropdown-border-width));
  --cui-dropdown-divider-bg: var(--cui-border-color-translucent);
  --cui-dropdown-divider-margin-y: 0.5rem;
  --cui-dropdown-box-shadow: var(--cui-box-shadow);
  --cui-dropdown-link-color: var(--cui-body-color);
  --cui-dropdown-link-hover-color: var(--cui-body-color);
  --cui-dropdown-link-hover-bg: var(--cui-tertiary-bg);
  --cui-dropdown-link-active-color: rgba(255, 255, 255, 0.87);
  --cui-dropdown-link-active-bg: var(--cui-primary);
  --cui-dropdown-link-disabled-color: var(--cui-tertiary-color);
  --cui-dropdown-item-padding-x: 1rem;
  --cui-dropdown-item-padding-y: 0.25rem;
  --cui-dropdown-header-color: #6d7d9c;
  --cui-dropdown-header-padding-x: 1rem;
  --cui-dropdown-header-padding-y: 0.5rem;
  position: absolute;
  z-index: var(--cui-dropdown-zindex);
  display: none;
  min-width: var(--cui-dropdown-min-width);
  padding: var(--cui-dropdown-padding-y) var(--cui-dropdown-padding-x);
  margin: 0;
  font-size: var(--cui-dropdown-font-size);
  color: var(--cui-dropdown-color);
  text-align: start;
  list-style: none;
  background-color: var(--cui-dropdown-bg);
  background-clip: padding-box;
  border: var(--cui-dropdown-border-width) solid var(--cui-dropdown-border-color);
  border-radius: var(--cui-dropdown-border-radius);
}

.dropdown-menu[data-coreui-popper] {
  inset-inline-start: 0;
  top: 100%;
  margin-top: var(--cui-dropdown-spacer);
}

.dropdown-menu-start {
  --cui-position: start;
}

.dropdown-menu-start[data-coreui-popper] {
  inset-inline-start: 0;
  inset-inline-end: auto;
}

.dropdown-menu-end {
  --cui-position: end;
}

.dropdown-menu-end[data-coreui-popper] {
  inset-inline-start: auto;
  inset-inline-end: 0;
}

@media (min-width: 576px) {
  .dropdown-menu-sm-start {
    --cui-position: start;
  }
  .dropdown-menu-sm-start[data-coreui-popper] {
    inset-inline-start: 0;
    inset-inline-end: auto;
  }
  .dropdown-menu-sm-end {
    --cui-position: end;
  }
  .dropdown-menu-sm-end[data-coreui-popper] {
    inset-inline-start: auto;
    inset-inline-end: 0;
  }
}
@media (min-width: 768px) {
  .dropdown-menu-md-start {
    --cui-position: start;
  }
  .dropdown-menu-md-start[data-coreui-popper] {
    inset-inline-start: 0;
    inset-inline-end: auto;
  }
  .dropdown-menu-md-end {
    --cui-position: end;
  }
  .dropdown-menu-md-end[data-coreui-popper] {
    inset-inline-start: auto;
    inset-inline-end: 0;
  }
}
@media (min-width: 992px) {
  .dropdown-menu-lg-start {
    --cui-position: start;
  }
  .dropdown-menu-lg-start[data-coreui-popper] {
    inset-inline-start: 0;
    inset-inline-end: auto;
  }
  .dropdown-menu-lg-end {
    --cui-position: end;
  }
  .dropdown-menu-lg-end[data-coreui-popper] {
    inset-inline-start: auto;
    inset-inline-end: 0;
  }
}
@media (min-width: 1200px) {
  .dropdown-menu-xl-start {
    --cui-position: start;
  }
  .dropdown-menu-xl-start[data-coreui-popper] {
    inset-inline-start: 0;
    inset-inline-end: auto;
  }
  .dropdown-menu-xl-end {
    --cui-position: end;
  }
  .dropdown-menu-xl-end[data-coreui-popper] {
    inset-inline-start: auto;
    inset-inline-end: 0;
  }
}
@media (min-width: 1400px) {
  .dropdown-menu-xxl-start {
    --cui-position: start;
  }
  .dropdown-menu-xxl-start[data-coreui-popper] {
    inset-inline-start: 0;
    inset-inline-end: auto;
  }
  .dropdown-menu-xxl-end {
    --cui-position: end;
  }
  .dropdown-menu-xxl-end[data-coreui-popper] {
    inset-inline-start: auto;
    inset-inline-end: 0;
  }
}
.dropup .dropdown-menu[data-coreui-popper] {
  top: auto;
  bottom: 100%;
  margin-top: 0;
  margin-bottom: var(--cui-dropdown-spacer);
}

.dropup .dropdown-toggle::after {
  display: inline-block;
  margin-inline-start: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0;
  border-right: 0.3em solid transparent;
  border-bottom: 0.3em solid;
  border-left: 0.3em solid transparent;
}

.dropup .dropdown-toggle:empty::after {
  margin-inline-start: 0;
}

.dropend .dropdown-menu[data-coreui-popper] {
  inset-inline-start: 100%;
  inset-inline-end: auto;
  top: 0;
  margin-inline-start: var(--cui-dropdown-spacer);
  margin-top: 0;
}

.dropend .dropdown-toggle::after {
  display: inline-block;
  margin-inline-start: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid transparent;
  border-right: 0;
  border-bottom: 0.3em solid transparent;
  border-left: 0.3em solid;
}

.dropend .dropdown-toggle:empty::after {
  margin-inline-start: 0;
}

.dropend .dropdown-toggle::after {
  vertical-align: 0;
}

.dropstart .dropdown-menu[data-coreui-popper] {
  inset-inline-start: auto;
  inset-inline-end: 100%;
  top: 0;
  margin-inline-end: var(--cui-dropdown-spacer);
  margin-top: 0;
}

.dropstart .dropdown-toggle::after {
  display: inline-block;
  margin-inline-start: 0.255em;
  vertical-align: 0.255em;
  content: "";
}

.dropstart .dropdown-toggle::after {
  display: none;
}

.dropstart .dropdown-toggle::before {
  display: inline-block;
  margin-inline-end: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid transparent;
  border-right: 0.3em solid;
  border-bottom: 0.3em solid transparent;
}

.dropstart .dropdown-toggle:empty::after {
  margin-inline-start: 0;
}

.dropstart .dropdown-toggle::before {
  vertical-align: 0;
}

.dropdown-divider {
  height: 0;
  margin: var(--cui-dropdown-divider-margin-y) 0;
  overflow: hidden;
  border-top: 1px solid var(--cui-dropdown-divider-bg);
  opacity: 1;
}

.dropdown-item {
  display: block;
  width: 100%;
  padding: var(--cui-dropdown-item-padding-y) var(--cui-dropdown-item-padding-x);
  clear: both;
  font-weight: 400;
  color: var(--cui-dropdown-link-color);
  text-align: inherit;
  text-decoration: none;
  white-space: nowrap;
  background-color: transparent;
  border: 0;
  border-radius: var(--cui-dropdown-item-border-radius, 0);
}

.dropdown-item:hover, .dropdown-item:focus {
  color: var(--cui-dropdown-link-hover-color);
  background-color: var(--cui-dropdown-link-hover-bg);
}

.dropdown-item.active, .dropdown-item:active {
  color: var(--cui-dropdown-link-active-color);
  text-decoration: none;
  background-color: var(--cui-dropdown-link-active-bg);
}

.dropdown-item.disabled, .dropdown-item:disabled {
  color: var(--cui-dropdown-link-disabled-color);
  pointer-events: none;
  background-color: transparent;
}

.dropdown-menu.show {
  display: block;
}

.dropdown-header {
  display: block;
  padding: var(--cui-dropdown-header-padding-y) var(--cui-dropdown-header-padding-x);
  margin-bottom: 0;
  font-size: 0.875rem;
  color: var(--cui-dropdown-header-color);
  white-space: nowrap;
}

.dropdown-item-text {
  display: block;
  padding: var(--cui-dropdown-item-padding-y) var(--cui-dropdown-item-padding-x);
  color: var(--cui-dropdown-link-color);
}

.dropdown-menu-dark {
  --cui-dropdown-color: #dbdfe6;
  --cui-dropdown-bg: #323a49;
  --cui-dropdown-border-color: var(--cui-border-color-translucent);
  --cui-dropdown-box-shadow: ;
  --cui-dropdown-link-color: #dbdfe6;
  --cui-dropdown-link-hover-color: #fff;
  --cui-dropdown-divider-bg: var(--cui-border-color-translucent);
  --cui-dropdown-link-hover-bg: rgba(255, 255, 255, 0.15);
  --cui-dropdown-link-active-color: rgba(255, 255, 255, 0.87);
  --cui-dropdown-link-active-bg: var(--cui-primary);
  --cui-dropdown-link-disabled-color: #aab3c5;
  --cui-dropdown-header-color: #aab3c5;
}

.btn-group,
.btn-group-vertical {
  position: relative;
  display: inline-flex;
  vertical-align: middle;
}

.btn-group > .btn,
.btn-group-vertical > .btn {
  position: relative;
  flex: 1 1 auto;
}

.btn-group > .btn-check:checked + .btn,
.btn-group > .btn-check:focus + .btn,
.btn-group > .btn:hover,
.btn-group > .btn:focus,
.btn-group > .btn:active,
.btn-group > .btn.active,
.btn-group-vertical > .btn-check:checked + .btn,
.btn-group-vertical > .btn-check:focus + .btn,
.btn-group-vertical > .btn:hover,
.btn-group-vertical > .btn:focus,
.btn-group-vertical > .btn:active,
.btn-group-vertical > .btn.active {
  z-index: 1;
}

.btn-toolbar {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
}

.btn-toolbar .input-group {
  width: auto;
}

.btn-group {
  border-radius: var(--cui-border-radius);
}

.btn-group > :not(.btn-check:first-child) + .btn,
.btn-group > .btn-group:not(:first-child) {
  margin-inline-start: calc(-1 * var(--cui-border-width));
}

.btn-group > .btn:not(:last-child):not(.dropdown-toggle),
.btn-group > .btn.dropdown-toggle-split:first-child,
.btn-group > .btn-group:not(:last-child) > .btn {
  border-start-end-radius: 0;
  border-end-end-radius: 0;
}

.btn-group > .btn:nth-child(n+3),
.btn-group > :not(.btn-check) + .btn,
.btn-group > .btn-group:not(:first-child) > .btn {
  border-start-start-radius: 0;
  border-end-start-radius: 0;
}

.dropdown-toggle-split {
  padding-right: 0.5625rem;
  padding-left: 0.5625rem;
}

.dropdown-toggle-split::after, .dropup .dropdown-toggle-split::after, .dropend .dropdown-toggle-split::after {
  margin-inline-start: 0;
}

.dropstart .dropdown-toggle-split::before {
  margin-inline-end: 0;
}

.btn-sm + .dropdown-toggle-split, .btn-group-sm > .btn + .dropdown-toggle-split {
  padding-right: 0.375rem;
  padding-left: 0.375rem;
}

.btn-lg + .dropdown-toggle-split, .btn-group-lg > .btn + .dropdown-toggle-split {
  padding-right: 0.75rem;
  padding-left: 0.75rem;
}

.btn-group-vertical {
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
}

.btn-group-vertical > .btn,
.btn-group-vertical > .btn-group {
  width: 100%;
}

.btn-group-vertical > .btn:not(:first-child),
.btn-group-vertical > .btn-group:not(:first-child) {
  margin-top: calc(-1 * var(--cui-border-width));
}

.btn-group-vertical > .btn:not(:last-child):not(.dropdown-toggle),
.btn-group-vertical > .btn-group:not(:last-child) > .btn {
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}

.btn-group-vertical > .btn:nth-child(n+3),
.btn-group-vertical > :not(.btn-check) + .btn,
.btn-group-vertical > .btn-group:not(:first-child) > .btn {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.nav {
  --cui-nav-link-padding-x: 1rem;
  --cui-nav-link-padding-y: 0.5rem;
  --cui-nav-link-font-weight: ;
  --cui-nav-link-color: var(--cui-link-color);
  --cui-nav-link-hover-color: var(--cui-link-hover-color);
  --cui-nav-link-disabled-color: var(--cui-secondary-color);
  display: flex;
  flex-wrap: wrap;
  padding-inline-start: 0;
  margin-bottom: 0;
  list-style: none;
}

.nav-link {
  display: block;
  padding: var(--cui-nav-link-padding-y) var(--cui-nav-link-padding-x);
  font-size: var(--cui-nav-link-font-size);
  font-weight: var(--cui-nav-link-font-weight);
  color: var(--cui-nav-link-color);
  text-decoration: none;
  background: none;
  border: 0;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out;
}

@media (prefers-reduced-motion: reduce) {
  .nav-link {
    transition: none;
  }
}
.nav-link:hover, .nav-link:focus {
  color: var(--cui-nav-link-hover-color);
}

.nav-link:focus-visible {
  outline: 0;
  box-shadow: 0 0 0 0.25rem rgba(88, 86, 214, 0.25);
}

.nav-link.disabled, .nav-link:disabled {
  color: var(--cui-nav-link-disabled-color);
  pointer-events: none;
  cursor: default;
}

.nav-tabs {
  --cui-nav-tabs-border-width: var(--cui-border-width);
  --cui-nav-tabs-border-color: var(--cui-border-color);
  --cui-nav-tabs-border-radius: var(--cui-border-radius);
  --cui-nav-tabs-link-hover-border-color: var(--cui-secondary-bg) var(--cui-secondary-bg) var(--cui-border-color);
  --cui-nav-tabs-link-active-color: var(--cui-emphasis-color);
  --cui-nav-tabs-link-active-bg: var(--cui-body-bg);
  --cui-nav-tabs-link-active-border-color: var(--cui-border-color) var(--cui-border-color) var(--cui-body-bg);
  border-bottom: var(--cui-nav-tabs-border-width) solid var(--cui-nav-tabs-border-color);
}

.nav-tabs .nav-link {
  margin-bottom: calc(-1 * var(--cui-nav-tabs-border-width));
  border: var(--cui-nav-tabs-border-width) solid transparent;
  border-top-left-radius: var(--cui-nav-tabs-border-radius);
  border-top-right-radius: var(--cui-nav-tabs-border-radius);
}

.nav-tabs .nav-link:hover, .nav-tabs .nav-link:focus {
  isolation: isolate;
  border-color: var(--cui-nav-tabs-link-hover-border-color);
}

.nav-tabs .nav-link.active,
.nav-tabs .nav-item.show .nav-link {
  color: var(--cui-nav-tabs-link-active-color);
  background-color: var(--cui-nav-tabs-link-active-bg);
  border-color: var(--cui-nav-tabs-link-active-border-color);
}

.nav-tabs .dropdown-menu {
  margin-top: calc(-1 * var(--cui-nav-tabs-border-width));
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.nav-pills {
  --cui-nav-pills-border-radius: var(--cui-border-radius);
  --cui-nav-pills-link-active-color: rgba(255, 255, 255, 0.87);
  --cui-nav-pills-link-active-bg: var(--cui-primary);
}

.nav-pills .nav-link {
  border-radius: var(--cui-nav-pills-border-radius);
}

.nav-pills .nav-link.active,
.nav-pills .show > .nav-link {
  color: var(--cui-nav-pills-link-active-color);
  background-color: var(--cui-nav-pills-link-active-bg);
}

.nav-underline {
  --cui-nav-underline-gap: 1rem;
  --cui-nav-underline-border-width: 0.125rem;
  --cui-nav-underline-link-active-color: var(--cui-emphasis-color);
  gap: var(--cui-nav-underline-gap);
}

.nav-underline .nav-link {
  padding-right: 0;
  padding-left: 0;
  border-bottom: var(--cui-nav-underline-border-width) solid transparent;
}

.nav-underline .nav-link:hover, .nav-underline .nav-link:focus {
  border-bottom-color: currentcolor;
}

.nav-underline .nav-link.active,
.nav-underline .show > .nav-link {
  font-weight: 700;
  color: var(--cui-nav-underline-link-active-color);
  border-bottom-color: currentcolor;
}

.nav-underline-border {
  --cui-nav-underline-border-gap: 0.5rem;
  --cui-nav-underline-border-border-color: var(--cui-border-color);
  --cui-nav-underline-border-border-width: 0.125rem;
  --cui-nav-underline-border-link-padding-x: 0.5rem;
  --cui-nav-underline-border-link-padding-y: 0.5rem;
  --cui-nav-underline-border-link-color: var(--cui-secondary-color);
  --cui-nav-underline-border-link-active-color: var(--cui-primary);
  --cui-nav-underline-border-link-disabled-color: var(--cui-tertiary-color);
  --cui-nav-link-color: var(--cui-nav-underline-border-link-color);
  --cui-nav-link-disabled-color: var(--cui-nav-underline-border-link-disabled-color);
  gap: var(--cui-nav-underline-border-gap);
  border-bottom: var(--cui-nav-underline-border-border-width) solid var(--cui-nav-underline-border-border-color);
}

.nav-underline-border .nav-link {
  padding: var(--cui-nav-underline-border-link-padding-y) var(--cui-nav-underline-border-link-padding-x);
  margin-bottom: calc(-1 * var(--cui-nav-underline-border-border-width));
  border-bottom: var(--cui-nav-underline-border-border-width) solid transparent;
}

.nav-underline-border .nav-link:hover, .nav-underline-border .nav-link:focus {
  border-bottom-color: currentcolor;
}

.nav-underline-border .nav-link.active,
.nav-underline-border .show > .nav-link {
  font-weight: 700;
  color: var(--cui-nav-underline-border-link-active-color);
  border-bottom-color: currentcolor;
}

.nav-enclosed {
  --cui-nav-enclosed-padding: 0.125rem;
  --cui-nav-enclosed-bg: var(--cui-tertiary-bg);
  --cui-nav-enclosed-border-radius: 0.5rem;
  --cui-nav-enclosed-link-padding-x: 0.875rem;
  --cui-nav-enclosed-link-padding-y: 0.375rem;
  --cui-nav-enclosed-link-color: var(--cui-body-color);
  --cui-nav-enclosed-link-border-width: 1px;
  --cui-nav-enclosed-link-active-color: var(--cui-body-color);
  --cui-nav-enclosed-link-active-bg: var(--cui-body-bg);
  --cui-nav-enclosed-link-active-border-color: var(--cui-border-color);
  --cui-nav-enclosed-link-hover-box-shadow: var(--cui-box-shadow-sm);
  --cui-nav-enclosed-link-disabled-color: var(--cui-secondary-color);
  display: inline-flex;
  padding: var(--cui-nav-enclosed-padding);
  background-color: var(--cui-nav-enclosed-bg);
  border-radius: var(--cui-nav-enclosed-border-radius);
}

.nav-enclosed .nav-link {
  padding: calc(var(--cui-nav-enclosed-link-padding-y) - var(--cui-nav-enclosed-link-border-width)) calc(var(--cui-nav-enclosed-link-padding-x) - var(--cui-nav-enclosed-link-border-width));
  color: var(--cui-nav-enclosed-link-color);
  border: var(--cui-nav-enclosed-link-border-width) solid transparent;
  border-radius: calc(var(--cui-nav-enclosed-border-radius) - var(--cui-nav-enclosed-padding));
}

.nav-enclosed .nav-link.disabled, .nav-enclosed .nav-link:disabled {
  color: var(--cui-nav-enclosed-link-disabled-color);
}

.nav-enclosed .nav-link.active,
.nav-enclosed .show > .nav-link {
  color: var(--cui-nav-enclosed-link-active-color);
  background-color: var(--cui-nav-enclosed-link-active-bg);
  border: 1px solid var(--cui-nav-enclosed-link-active-border-color);
}

.nav-enclosed .nav-link.active:not(:focus-visible),
.nav-enclosed .show > .nav-link:not(:focus-visible) {
  box-shadow: var(--cui-nav-enclosed-link-hover-box-shadow);
}

.nav-enclosed-pills {
  --cui-nav-enclosed-border-radius: 50rem;
}

.nav-fill > .nav-link,
.nav-fill .nav-item {
  flex: 1 1 auto;
  text-align: center;
}

.nav-justified > .nav-link,
.nav-justified .nav-item {
  flex-grow: 1;
  flex-basis: 0;
  text-align: center;
}

.nav-fill .nav-item .nav-link,
.nav-justified .nav-item .nav-link {
  width: 100%;
}

.tab-content > .tab-pane {
  display: none;
}

.tab-content > .active {
  display: block;
}

.navbar {
  --cui-navbar-padding-x: 0;
  --cui-navbar-padding-y: 0.5rem;
  --cui-navbar-color: rgba(var(--cui-emphasis-color-rgb), 0.65);
  --cui-navbar-hover-color: rgba(var(--cui-emphasis-color-rgb), 0.8);
  --cui-navbar-disabled-color: rgba(var(--cui-emphasis-color-rgb), 0.3);
  --cui-navbar-active-color: rgba(var(--cui-emphasis-color-rgb), 1);
  --cui-navbar-brand-padding-y: 0.3125rem;
  --cui-navbar-brand-margin-end: 1rem;
  --cui-navbar-brand-font-size: 1.25rem;
  --cui-navbar-brand-color: rgba(var(--cui-emphasis-color-rgb), 1);
  --cui-navbar-brand-hover-color: rgba(var(--cui-emphasis-color-rgb), 1);
  --cui-navbar-nav-link-padding-x: 0.5rem;
  --cui-navbar-toggler-padding-y: 0.25rem;
  --cui-navbar-toggler-padding-x: 0.75rem;
  --cui-navbar-toggler-font-size: 1.25rem;
  --cui-navbar-toggler-icon-bg: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'%3e%3cpath stroke='rgba%2814.5098039216%, 16.831372549%, 21.1843137255%, 0.75%29' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e");
  --cui-navbar-toggler-border-color: rgba(var(--cui-emphasis-color-rgb), 0.15);
  --cui-navbar-toggler-border-radius: var(--cui-border-radius);
  --cui-navbar-toggler-focus-width: 0.25rem;
  --cui-navbar-toggler-transition: box-shadow 0.15s ease-in-out;
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  padding: var(--cui-navbar-padding-y) var(--cui-navbar-padding-x);
}

.navbar > .container-xxl, .navbar > .container-xl, .navbar > .container-lg, .navbar > .container-md, .navbar > .container-sm, .navbar > .container,
.navbar > .container-fluid {
  display: flex;
  flex-wrap: inherit;
  align-items: center;
  justify-content: space-between;
}

.navbar-brand {
  padding-top: var(--cui-navbar-brand-padding-y);
  padding-bottom: var(--cui-navbar-brand-padding-y);
  margin-inline-end: var(--cui-navbar-brand-margin-end);
  font-size: var(--cui-navbar-brand-font-size);
  color: var(--cui-navbar-brand-color);
  text-decoration: none;
  white-space: nowrap;
}

.navbar-brand:hover, .navbar-brand:focus {
  color: var(--cui-navbar-brand-hover-color);
}

.navbar-nav {
  --cui-nav-link-padding-x: 0;
  --cui-nav-link-padding-y: 0.5rem;
  --cui-nav-link-font-weight: ;
  --cui-nav-link-color: var(--cui-navbar-color);
  --cui-nav-link-hover-color: var(--cui-navbar-hover-color);
  --cui-nav-link-disabled-color: var(--cui-navbar-disabled-color);
  display: flex;
  flex-direction: column;
  padding-inline-start: 0;
  margin-bottom: 0;
  list-style: none;
}

.navbar-nav .nav-link.active, .navbar-nav .nav-link.show {
  color: var(--cui-navbar-active-color);
}

.navbar-nav .dropdown-menu {
  position: static;
}

.navbar-text {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  color: var(--cui-navbar-color);
}

.navbar-text a,
.navbar-text a:hover,
.navbar-text a:focus {
  color: var(--cui-navbar-active-color);
}

.navbar-collapse {
  flex-grow: 1;
  flex-basis: 100%;
  align-items: center;
}

.navbar-toggler {
  padding: var(--cui-navbar-toggler-padding-y) var(--cui-navbar-toggler-padding-x);
  font-size: var(--cui-navbar-toggler-font-size);
  line-height: 1;
  color: var(--cui-navbar-color);
  background-color: transparent;
  border: var(--cui-border-width) solid var(--cui-navbar-toggler-border-color);
  border-radius: var(--cui-navbar-toggler-border-radius);
  transition: var(--cui-navbar-toggler-transition);
}

@media (prefers-reduced-motion: reduce) {
  .navbar-toggler {
    transition: none;
  }
}
.navbar-toggler:hover {
  text-decoration: none;
}

.navbar-toggler:focus {
  text-decoration: none;
  outline: 0;
  box-shadow: 0 0 0 var(--cui-navbar-toggler-focus-width);
}

.navbar-toggler-icon {
  display: inline-block;
  width: 1.5em;
  height: 1.5em;
  vertical-align: middle;
  background-image: var(--cui-navbar-toggler-icon-bg);
  background-repeat: no-repeat;
  background-position: center;
  background-size: 100%;
}

.navbar-nav-scroll {
  max-height: var(--cui-scroll-height, 75vh);
  overflow-y: auto;
}

@media (min-width: 576px) {
  .navbar-expand-sm {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-sm .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-sm .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-sm .navbar-nav .nav-link {
    padding-right: var(--cui-navbar-nav-link-padding-x);
    padding-left: var(--cui-navbar-nav-link-padding-x);
  }
  .navbar-expand-sm .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-sm .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-sm .navbar-toggler {
    display: none;
  }
  .navbar-expand-sm .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }
  .navbar-expand-sm .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-sm .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
@media (min-width: 768px) {
  .navbar-expand-md {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-md .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-md .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-md .navbar-nav .nav-link {
    padding-right: var(--cui-navbar-nav-link-padding-x);
    padding-left: var(--cui-navbar-nav-link-padding-x);
  }
  .navbar-expand-md .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-md .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-md .navbar-toggler {
    display: none;
  }
  .navbar-expand-md .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }
  .navbar-expand-md .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-md .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
@media (min-width: 992px) {
  .navbar-expand-lg {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-lg .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-lg .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-lg .navbar-nav .nav-link {
    padding-right: var(--cui-navbar-nav-link-padding-x);
    padding-left: var(--cui-navbar-nav-link-padding-x);
  }
  .navbar-expand-lg .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-lg .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-lg .navbar-toggler {
    display: none;
  }
  .navbar-expand-lg .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }
  .navbar-expand-lg .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-lg .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
@media (min-width: 1200px) {
  .navbar-expand-xl {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-xl .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-xl .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-xl .navbar-nav .nav-link {
    padding-right: var(--cui-navbar-nav-link-padding-x);
    padding-left: var(--cui-navbar-nav-link-padding-x);
  }
  .navbar-expand-xl .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-xl .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-xl .navbar-toggler {
    display: none;
  }
  .navbar-expand-xl .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }
  .navbar-expand-xl .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-xl .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
@media (min-width: 1400px) {
  .navbar-expand-xxl {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-xxl .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-xxl .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-xxl .navbar-nav .nav-link {
    padding-right: var(--cui-navbar-nav-link-padding-x);
    padding-left: var(--cui-navbar-nav-link-padding-x);
  }
  .navbar-expand-xxl .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-xxl .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-xxl .navbar-toggler {
    display: none;
  }
  .navbar-expand-xxl .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }
  .navbar-expand-xxl .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-xxl .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
.navbar-expand {
  flex-wrap: nowrap;
  justify-content: flex-start;
}

.navbar-expand .navbar-nav {
  flex-direction: row;
}

.navbar-expand .navbar-nav .dropdown-menu {
  position: absolute;
}

.navbar-expand .navbar-nav .nav-link {
  padding-right: var(--cui-navbar-nav-link-padding-x);
  padding-left: var(--cui-navbar-nav-link-padding-x);
}

.navbar-expand .navbar-nav-scroll {
  overflow: visible;
}

.navbar-expand .navbar-collapse {
  display: flex !important;
  flex-basis: auto;
}

.navbar-expand .navbar-toggler {
  display: none;
}

.navbar-expand .offcanvas {
  position: static;
  z-index: auto;
  flex-grow: 1;
  width: auto !important;
  height: auto !important;
  visibility: visible !important;
  background-color: transparent !important;
  border: 0 !important;
  transform: none !important;
  transition: none;
}

.navbar-expand .offcanvas .offcanvas-header {
  display: none;
}

.navbar-expand .offcanvas .offcanvas-body {
  display: flex;
  flex-grow: 0;
  padding: 0;
  overflow-y: visible;
}

.navbar-dark,
.navbar[data-coreui-theme=dark] {
  --cui-navbar-color: rgba(255, 255, 255, 0.55);
  --cui-navbar-hover-color: rgba(255, 255, 255, 0.75);
  --cui-navbar-disabled-color: rgba(255, 255, 255, 0.25);
  --cui-navbar-active-color: #fff;
  --cui-navbar-brand-color: #fff;
  --cui-navbar-brand-hover-color: #fff;
  --cui-navbar-toggler-border-color: rgba(255, 255, 255, 0.1);
  --cui-navbar-toggler-icon-bg: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
}

[data-coreui-theme=dark] .navbar-toggler-icon {
  --cui-navbar-toggler-icon-bg: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
}

.card {
  --cui-card-spacer-y: 1rem;
  --cui-card-spacer-x: 1rem;
  --cui-card-title-spacer-y: 0.5rem;
  --cui-card-title-color: ;
  --cui-card-subtitle-color: ;
  --cui-card-border-width: var(--cui-border-width);
  --cui-card-border-color: var(--cui-border-color-translucent);
  --cui-card-border-radius: var(--cui-border-radius);
  --cui-card-box-shadow: ;
  --cui-card-inner-border-radius: calc(var(--cui-card-border-radius) - var(--cui-card-border-width));
  --cui-card-cap-padding-y: 0.5rem;
  --cui-card-cap-padding-x: 1rem;
  --cui-card-cap-bg: rgba(var(--cui-body-color-rgb), 0.03);
  --cui-card-cap-color: ;
  --cui-card-height: ;
  --cui-card-color: ;
  --cui-card-bg: var(--cui-body-bg);
  --cui-card-img-overlay-padding: 1rem;
  --cui-card-group-margin: 0.75rem;
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 0;
  height: var(--cui-card-height);
  color: var(--cui-body-color);
  word-wrap: break-word;
  background-color: var(--cui-card-bg);
  background-clip: border-box;
  border: var(--cui-card-border-width) solid var(--cui-card-border-color);
  border-radius: var(--cui-card-border-radius);
}

.card > hr {
  margin-right: 0;
  margin-left: 0;
}

.card > .list-group {
  border-top: inherit;
  border-bottom: inherit;
}

.card > .list-group:first-child {
  border-top-width: 0;
  border-top-left-radius: var(--cui-card-inner-border-radius);
  border-top-right-radius: var(--cui-card-inner-border-radius);
}

.card > .list-group:last-child {
  border-bottom-width: 0;
  border-bottom-right-radius: var(--cui-card-inner-border-radius);
  border-bottom-left-radius: var(--cui-card-inner-border-radius);
}

.card > .card-header + .list-group,
.card > .list-group + .card-footer {
  border-top: 0;
}

.card-body {
  flex: 1 1 auto;
  padding: var(--cui-card-spacer-y) var(--cui-card-spacer-x);
  color: var(--cui-card-color);
}

.card-title {
  margin-bottom: var(--cui-card-title-spacer-y);
  color: var(--cui-card-title-color);
}

.card-subtitle {
  margin-top: calc(-0.5 * var(--cui-card-title-spacer-y));
  margin-bottom: 0;
  color: var(--cui-card-subtitle-color);
}

.card-text:last-child {
  margin-bottom: 0;
}

.card-link + .card-link {
  margin-inline-start: var(--cui-card-spacer-x);
}

.card-header {
  padding: var(--cui-card-cap-padding-y) var(--cui-card-cap-padding-x);
  margin-bottom: 0;
  color: var(--cui-card-cap-color);
  background-color: var(--cui-card-cap-bg);
  border-bottom: var(--cui-card-border-width) solid var(--cui-card-border-color);
}

.card-header:first-child {
  border-radius: var(--cui-card-inner-border-radius) var(--cui-card-inner-border-radius) 0 0;
}

.card-footer {
  padding: var(--cui-card-cap-padding-y) var(--cui-card-cap-padding-x);
  color: var(--cui-card-cap-color);
  background-color: var(--cui-card-cap-bg);
  border-top: var(--cui-card-border-width) solid var(--cui-card-border-color);
}

.card-footer:last-child {
  border-radius: 0 0 var(--cui-card-inner-border-radius) var(--cui-card-inner-border-radius);
}

.card-header-tabs {
  margin-right: calc(-0.5 * var(--cui-card-cap-padding-x));
  margin-bottom: calc(-1 * var(--cui-card-cap-padding-y));
  margin-left: calc(-0.5 * var(--cui-card-cap-padding-x));
  border-bottom: 0;
}

.card-header-tabs .nav-link.active {
  background-color: var(--cui-card-bg);
  border-bottom-color: var(--cui-card-bg);
}

.card-header-pills {
  margin-right: calc(-0.5 * var(--cui-card-cap-padding-x));
  margin-left: calc(-0.5 * var(--cui-card-cap-padding-x));
}

.card-img-overlay {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  padding: var(--cui-card-img-overlay-padding);
  border-radius: var(--cui-card-inner-border-radius);
}

.card-img,
.card-img-top,
.card-img-bottom {
  width: 100%;
}

.card-img,
.card-img-top {
  border-top-left-radius: var(--cui-card-inner-border-radius);
  border-top-right-radius: var(--cui-card-inner-border-radius);
}

.card-img,
.card-img-bottom {
  border-bottom-right-radius: var(--cui-card-inner-border-radius);
  border-bottom-left-radius: var(--cui-card-inner-border-radius);
}

.card-group > .card {
  margin-bottom: var(--cui-card-group-margin);
}

@media (min-width: 576px) {
  .card-group {
    display: flex;
    flex-flow: row wrap;
  }
  .card-group > .card {
    flex: 1 0;
    margin-bottom: 0;
  }
  .card-group > .card + .card {
    margin-inline-start: 0;
    border-inline-start: 0;
  }
  .card-group > .card:not(:last-child) {
    border-start-end-radius: 0;
    border-end-end-radius: 0;
  }
  .card-group > .card:not(:last-child) > .card-img-top,
  .card-group > .card:not(:last-child) > .card-header {
    border-top-right-radius: 0;
  }
  .card-group > .card:not(:last-child) > .card-img-bottom,
  .card-group > .card:not(:last-child) > .card-footer {
    border-bottom-right-radius: 0;
  }
  .card-group > .card:not(:first-child) {
    border-start-start-radius: 0;
    border-end-start-radius: 0;
  }
  .card-group > .card:not(:first-child) > .card-img-top,
  .card-group > .card:not(:first-child) > .card-header {
    border-top-left-radius: 0;
  }
  .card-group > .card:not(:first-child) > .card-img-bottom,
  .card-group > .card:not(:first-child) > .card-footer {
    border-bottom-left-radius: 0;
  }
}
.accordion {
  --cui-accordion-color: var(--cui-body-color);
  --cui-accordion-bg: var(--cui-body-bg);
  --cui-accordion-transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out, border-radius 0.15s ease;
  --cui-accordion-border-color: var(--cui-border-color);
  --cui-accordion-border-width: var(--cui-border-width);
  --cui-accordion-border-radius: var(--cui-border-radius);
  --cui-accordion-inner-border-radius: calc(var(--cui-accordion-border-radius) - var(--cui-accordion-border-width));
  --cui-accordion-btn-padding-x: 1.25rem;
  --cui-accordion-btn-padding-y: 1rem;
  --cui-accordion-btn-color: var(--cui-body-color);
  --cui-accordion-btn-bg: var(--cui-accordion-bg);
  --cui-accordion-btn-icon: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='none' stroke='rgba%2814.5098039216%, 16.831372549%, 21.1843137255%, 0.95%29' stroke-linecap='round' stroke-linejoin='round'%3e%3cpath d='m2 5 6 6 6-6'/%3e%3c/svg%3e");
  --cui-accordion-btn-icon-width: 1.25rem;
  --cui-accordion-btn-icon-transform: rotate(-180deg);
  --cui-accordion-btn-icon-transition: transform 0.2s ease-in-out;
  --cui-accordion-btn-active-icon: url(${___CSS_LOADER_URL_REPLACEMENT_11___});
  --cui-accordion-btn-focus-box-shadow: 0 0 0 0.25rem rgba(88, 86, 214, 0.25);
  --cui-accordion-body-padding-x: 1.25rem;
  --cui-accordion-body-padding-y: 1rem;
  --cui-accordion-active-color: var(--cui-primary-text-emphasis);
  --cui-accordion-active-bg: var(--cui-primary-bg-subtle);
}

.accordion-button {
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
  padding: var(--cui-accordion-btn-padding-y) var(--cui-accordion-btn-padding-x);
  font-size: 1rem;
  color: var(--cui-accordion-btn-color);
  text-align: start;
  background-color: var(--cui-accordion-btn-bg);
  border: 0;
  border-radius: 0;
  overflow-anchor: none;
  transition: var(--cui-accordion-transition);
}

@media (prefers-reduced-motion: reduce) {
  .accordion-button {
    transition: none;
  }
}
.accordion-button:not(.collapsed) {
  color: var(--cui-accordion-active-color);
  background-color: var(--cui-accordion-active-bg);
  box-shadow: inset 0 calc(-1 * var(--cui-accordion-border-width)) 0 var(--cui-accordion-border-color);
}

.accordion-button:not(.collapsed)::after {
  background-image: var(--cui-accordion-btn-active-icon);
  transform: var(--cui-accordion-btn-icon-transform);
}

.accordion-button::after {
  flex-shrink: 0;
  width: var(--cui-accordion-btn-icon-width);
  height: var(--cui-accordion-btn-icon-width);
  margin-inline-start: auto;
  content: "";
  background-image: var(--cui-accordion-btn-icon);
  background-repeat: no-repeat;
  background-size: var(--cui-accordion-btn-icon-width);
  transition: var(--cui-accordion-btn-icon-transition);
}

@media (prefers-reduced-motion: reduce) {
  .accordion-button::after {
    transition: none;
  }
}
.accordion-button:hover {
  z-index: 2;
}

.accordion-button:focus {
  z-index: 3;
  outline: 0;
  box-shadow: var(--cui-accordion-btn-focus-box-shadow);
}

.accordion-header {
  margin-bottom: 0;
}

.accordion-item {
  color: var(--cui-accordion-color);
  background-color: var(--cui-accordion-bg);
  border: var(--cui-accordion-border-width) solid var(--cui-accordion-border-color);
}

.accordion-item:first-of-type {
  border-top-left-radius: var(--cui-accordion-border-radius);
  border-top-right-radius: var(--cui-accordion-border-radius);
}

.accordion-item:first-of-type > .accordion-header .accordion-button {
  border-top-left-radius: var(--cui-accordion-inner-border-radius);
  border-top-right-radius: var(--cui-accordion-inner-border-radius);
}

.accordion-item:not(:first-of-type) {
  border-top: 0;
}

.accordion-item:last-of-type {
  border-bottom-right-radius: var(--cui-accordion-border-radius);
  border-bottom-left-radius: var(--cui-accordion-border-radius);
}

.accordion-item:last-of-type > .accordion-header .accordion-button.collapsed {
  border-bottom-right-radius: var(--cui-accordion-inner-border-radius);
  border-bottom-left-radius: var(--cui-accordion-inner-border-radius);
}

.accordion-item:last-of-type > .accordion-collapse {
  border-bottom-right-radius: var(--cui-accordion-border-radius);
  border-bottom-left-radius: var(--cui-accordion-border-radius);
}

.accordion-body {
  padding: var(--cui-accordion-body-padding-y) var(--cui-accordion-body-padding-x);
}

.accordion-flush > .accordion-item {
  border-right: 0;
  border-left: 0;
  border-radius: 0;
}

.accordion-flush > .accordion-item:first-child {
  border-top: 0;
}

.accordion-flush > .accordion-item:last-child {
  border-bottom: 0;
}

.accordion-flush > .accordion-item > .accordion-collapse,
.accordion-flush > .accordion-item > .accordion-header .accordion-button,
.accordion-flush > .accordion-item > .accordion-header .accordion-button.collapsed {
  border-radius: 0;
}

[data-coreui-theme=dark] .accordion-button::after {
  --cui-accordion-btn-icon: url(${___CSS_LOADER_URL_REPLACEMENT_12___});
  --cui-accordion-btn-active-icon: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='rgb%2823.2745098039%, 22.568627451%, 61.7450980392%%29'%3e%3cpath fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708'/%3e%3c/svg%3e");
}

.breadcrumb {
  --cui-breadcrumb-padding-x: 0;
  --cui-breadcrumb-padding-y: 0;
  --cui-breadcrumb-margin-bottom: 1rem;
  --cui-breadcrumb-bg: ;
  --cui-breadcrumb-border-radius: ;
  --cui-breadcrumb-divider-color: var(--cui-secondary-color);
  --cui-breadcrumb-item-padding-x: 0.5rem;
  --cui-breadcrumb-item-active-color: var(--cui-secondary-color);
  display: flex;
  flex-wrap: wrap;
  padding: var(--cui-breadcrumb-padding-y) var(--cui-breadcrumb-padding-x);
  margin-bottom: var(--cui-breadcrumb-margin-bottom);
  font-size: var(--cui-breadcrumb-font-size);
  list-style: none;
  background-color: var(--cui-breadcrumb-bg);
  border-radius: var(--cui-breadcrumb-border-radius);
}

.breadcrumb-item + .breadcrumb-item {
  padding-inline-start: var(--cui-breadcrumb-item-padding-x);
}

.breadcrumb-item + .breadcrumb-item::before {
  float: inline-start;
  padding-inline-end: var(--cui-breadcrumb-item-padding-x);
  color: var(--cui-breadcrumb-divider-color);
  content: var(--cui-breadcrumb-divider, "/");
}

.breadcrumb-item.active {
  color: var(--cui-breadcrumb-item-active-color);
}

.pagination {
  --cui-pagination-padding-x: 0.75rem;
  --cui-pagination-padding-y: 0.375rem;
  --cui-pagination-font-size: 1rem;
  --cui-pagination-color: var(--cui-link-color);
  --cui-pagination-bg: var(--cui-body-bg);
  --cui-pagination-border-width: var(--cui-border-width);
  --cui-pagination-border-color: var(--cui-border-color);
  --cui-pagination-border-radius: var(--cui-border-radius);
  --cui-pagination-hover-color: var(--cui-link-hover-color);
  --cui-pagination-hover-bg: var(--cui-tertiary-bg);
  --cui-pagination-hover-border-color: var(--cui-border-color);
  --cui-pagination-focus-color: var(--cui-link-hover-color);
  --cui-pagination-focus-bg: var(--cui-secondary-bg);
  --cui-pagination-focus-box-shadow: 0 0 0 0.25rem rgba(88, 86, 214, 0.25);
  --cui-pagination-active-color: rgba(255, 255, 255, 0.87);
  --cui-pagination-active-bg: var(--cui-primary);
  --cui-pagination-active-border-color: var(--cui-primary);
  --cui-pagination-disabled-color: var(--cui-secondary-color);
  --cui-pagination-disabled-bg: var(--cui-secondary-bg);
  --cui-pagination-disabled-border-color: var(--cui-border-color);
  display: flex;
  padding-inline-start: 0;
  list-style: none;
}

.page-link {
  position: relative;
  display: block;
  padding: var(--cui-pagination-padding-y) var(--cui-pagination-padding-x);
  font-size: var(--cui-pagination-font-size);
  color: var(--cui-pagination-color);
  text-decoration: none;
  background-color: var(--cui-pagination-bg);
  border: var(--cui-pagination-border-width) solid var(--cui-pagination-border-color);
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

@media (prefers-reduced-motion: reduce) {
  .page-link {
    transition: none;
  }
}
.page-link:hover {
  z-index: 2;
  color: var(--cui-pagination-hover-color);
  background-color: var(--cui-pagination-hover-bg);
  border-color: var(--cui-pagination-hover-border-color);
}

.page-link:focus {
  z-index: 3;
  color: var(--cui-pagination-focus-color);
  background-color: var(--cui-pagination-focus-bg);
  outline: 0;
  box-shadow: var(--cui-pagination-focus-box-shadow);
}

.page-link.active, .active > .page-link {
  z-index: 3;
  color: var(--cui-pagination-active-color);
  background-color: var(--cui-pagination-active-bg);
  border-color: var(--cui-pagination-active-border-color);
}

.page-link.disabled, .disabled > .page-link {
  color: var(--cui-pagination-disabled-color);
  pointer-events: none;
  background-color: var(--cui-pagination-disabled-bg);
  border-color: var(--cui-pagination-disabled-border-color);
}

.page-item:not(:first-child) .page-link {
  margin-inline-start: calc(-1 * var(--cui-border-width));
}

.page-item:first-child .page-link {
  border-start-start-radius: var(--cui-pagination-border-radius);
  border-end-start-radius: var(--cui-pagination-border-radius);
}

.page-item:last-child .page-link {
  border-start-end-radius: var(--cui-pagination-border-radius);
  border-end-end-radius: var(--cui-pagination-border-radius);
}

.pagination-lg {
  --cui-pagination-padding-x: 1.5rem;
  --cui-pagination-padding-y: 0.75rem;
  --cui-pagination-font-size: 1.25rem;
  --cui-pagination-border-radius: var(--cui-border-radius-lg);
}

.pagination-sm {
  --cui-pagination-padding-x: 0.5rem;
  --cui-pagination-padding-y: 0.25rem;
  --cui-pagination-font-size: 0.875rem;
  --cui-pagination-border-radius: var(--cui-border-radius-sm);
}

.badge {
  --cui-badge-padding-x: 0.65em;
  --cui-badge-padding-y: 0.35em;
  --cui-badge-font-size: 0.75em;
  --cui-badge-font-weight: 700;
  --cui-badge-color: #fff;
  --cui-badge-border-radius: var(--cui-border-radius);
  display: inline-block;
  padding: var(--cui-badge-padding-y) var(--cui-badge-padding-x);
  font-size: var(--cui-badge-font-size);
  font-weight: var(--cui-badge-font-weight);
  line-height: 1;
  color: var(--cui-badge-color);
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: var(--cui-badge-border-radius, 0);
}

.badge:empty {
  display: none;
}

.btn .badge {
  position: relative;
  top: -1px;
}

.badge-sm {
  --cui-badge-padding-x: 0.5em;
  --cui-badge-padding-y: 0.3em;
  font-size: 0.65em;
}

.alert {
  --cui-alert-bg: transparent;
  --cui-alert-padding-x: 1rem;
  --cui-alert-padding-y: 1rem;
  --cui-alert-margin-bottom: 1rem;
  --cui-alert-color: inherit;
  --cui-alert-border-color: transparent;
  --cui-alert-border: var(--cui-border-width) solid var(--cui-alert-border-color);
  --cui-alert-border-radius: var(--cui-border-radius);
  --cui-alert-link-color: inherit;
  position: relative;
  padding: var(--cui-alert-padding-y) var(--cui-alert-padding-x);
  margin-bottom: var(--cui-alert-margin-bottom);
  color: var(--cui-alert-color);
  background-color: var(--cui-alert-bg);
  border: var(--cui-alert-border);
  border-radius: var(--cui-alert-border-radius);
}

.alert-heading {
  color: inherit;
}

.alert-link {
  font-weight: 700;
  color: var(--cui-alert-link-color);
}

.alert-dismissible {
  padding-inline-end: 3rem;
}

.alert-dismissible .btn-close {
  position: absolute;
  inset-inline-end: 0;
  top: 0;
  z-index: 2;
  padding: 1.25rem 1rem;
}

.alert-primary {
  --cui-alert-color: var(--cui-primary-text-emphasis);
  --cui-alert-bg: var(--cui-primary-bg-subtle);
  --cui-alert-border-color: var(--cui-primary-border-subtle);
  --cui-alert-link-color: var(--cui-primary-text-emphasis);
}

.alert-secondary {
  --cui-alert-color: var(--cui-secondary-text-emphasis);
  --cui-alert-bg: var(--cui-secondary-bg-subtle);
  --cui-alert-border-color: var(--cui-secondary-border-subtle);
  --cui-alert-link-color: var(--cui-secondary-text-emphasis);
}

.alert-success {
  --cui-alert-color: var(--cui-success-text-emphasis);
  --cui-alert-bg: var(--cui-success-bg-subtle);
  --cui-alert-border-color: var(--cui-success-border-subtle);
  --cui-alert-link-color: var(--cui-success-text-emphasis);
}

.alert-info {
  --cui-alert-color: var(--cui-info-text-emphasis);
  --cui-alert-bg: var(--cui-info-bg-subtle);
  --cui-alert-border-color: var(--cui-info-border-subtle);
  --cui-alert-link-color: var(--cui-info-text-emphasis);
}

.alert-warning {
  --cui-alert-color: var(--cui-warning-text-emphasis);
  --cui-alert-bg: var(--cui-warning-bg-subtle);
  --cui-alert-border-color: var(--cui-warning-border-subtle);
  --cui-alert-link-color: var(--cui-warning-text-emphasis);
}

.alert-danger {
  --cui-alert-color: var(--cui-danger-text-emphasis);
  --cui-alert-bg: var(--cui-danger-bg-subtle);
  --cui-alert-border-color: var(--cui-danger-border-subtle);
  --cui-alert-link-color: var(--cui-danger-text-emphasis);
}

.alert-light {
  --cui-alert-color: var(--cui-light-text-emphasis);
  --cui-alert-bg: var(--cui-light-bg-subtle);
  --cui-alert-border-color: var(--cui-light-border-subtle);
  --cui-alert-link-color: var(--cui-light-text-emphasis);
}

.alert-dark {
  --cui-alert-color: var(--cui-dark-text-emphasis);
  --cui-alert-bg: var(--cui-dark-bg-subtle);
  --cui-alert-border-color: var(--cui-dark-border-subtle);
  --cui-alert-link-color: var(--cui-dark-text-emphasis);
}

@keyframes progress-bar-stripes {
  0% {
    background-position-x: var(--cui-progress-height);
  }
}
.progress,
.progress-stacked {
  --cui-progress-height: 1rem;
  --cui-progress-font-size: 0.75rem;
  --cui-progress-bg: var(--cui-secondary-bg);
  --cui-progress-border-radius: var(--cui-border-radius);
  --cui-progress-box-shadow: var(--cui-box-shadow-inset);
  --cui-progress-bar-color: #fff;
  --cui-progress-bar-bg: var(--cui-primary);
  --cui-progress-bar-transition: width 0.6s ease;
  display: flex;
  height: var(--cui-progress-height);
  overflow: hidden;
  font-size: var(--cui-progress-font-size);
  background-color: var(--cui-progress-bg);
  border-radius: var(--cui-progress-border-radius);
}

.progress-bar {
  display: flex;
  flex-direction: column;
  justify-content: center;
  overflow: hidden;
  color: var(--cui-progress-bar-color);
  text-align: center;
  white-space: nowrap;
  background-color: var(--cui-progress-bar-bg);
  transition: var(--cui-progress-bar-transition);
}

@media (prefers-reduced-motion: reduce) {
  .progress-bar {
    transition: none;
  }
}
.progress-bar-striped {
  background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);
  background-size: var(--cui-progress-height) var(--cui-progress-height);
}

.progress-stacked > .progress {
  overflow: visible;
}

.progress-stacked > .progress > .progress-bar {
  width: 100%;
}

.progress-bar-animated {
  animation: 1s linear infinite progress-bar-stripes;
}

@media (prefers-reduced-motion: reduce) {
  .progress-bar-animated {
    animation: none;
  }
}
.progress-thin {
  height: 4px;
}

.progress.progress-white {
  background-color: rgba(255, 255, 255, 0.2);
}

.progress.progress-white .progress-bar {
  background-color: #fff;
}

.progress-group {
  display: flex;
  flex-flow: row wrap;
  margin-bottom: 1rem;
}

.progress-group-prepend {
  flex: 0 0 100px;
  align-self: center;
}

.progress-group-header {
  display: flex;
  flex-basis: 100%;
  align-items: center;
  margin-bottom: 0.25rem;
}

.progress-group-bars {
  flex-grow: 1;
  align-self: center;
}

.progress-group-bars .progress:not(:last-child) {
  margin-bottom: 2px;
}

.progress-group-header + .progress-group-bars {
  flex-basis: 100%;
}

.list-group {
  --cui-list-group-color: var(--cui-body-color);
  --cui-list-group-bg: var(--cui-body-bg);
  --cui-list-group-border-color: var(--cui-border-color);
  --cui-list-group-border-width: var(--cui-border-width);
  --cui-list-group-border-radius: var(--cui-border-radius);
  --cui-list-group-item-padding-x: 1rem;
  --cui-list-group-item-padding-y: 0.5rem;
  --cui-list-group-action-color: var(--cui-secondary-color);
  --cui-list-group-action-hover-color: var(--cui-emphasis-color);
  --cui-list-group-action-hover-bg: var(--cui-tertiary-bg);
  --cui-list-group-action-active-color: var(--cui-body-color);
  --cui-list-group-action-active-bg: var(--cui-secondary-bg);
  --cui-list-group-disabled-color: var(--cui-secondary-color);
  --cui-list-group-disabled-bg: var(--cui-body-bg);
  --cui-list-group-active-color: rgba(255, 255, 255, 0.87);
  --cui-list-group-active-bg: var(--cui-primary);
  --cui-list-group-active-border-color: var(--cui-primary);
  display: flex;
  flex-direction: column;
  padding-inline-start: 0;
  margin-bottom: 0;
  border-radius: var(--cui-list-group-border-radius);
}

.list-group-numbered {
  list-style-type: none;
  counter-reset: section;
}

.list-group-numbered > .list-group-item::before {
  content: counters(section, ".") ". ";
  counter-increment: section;
}

.list-group-item {
  position: relative;
  display: block;
  padding: var(--cui-list-group-item-padding-y) var(--cui-list-group-item-padding-x);
  color: var(--cui-list-group-color);
  text-decoration: none;
  background-color: var(--cui-list-group-bg);
  border: var(--cui-list-group-border-width) solid var(--cui-list-group-border-color);
}

.list-group-item:first-child {
  border-top-left-radius: inherit;
  border-top-right-radius: inherit;
}

.list-group-item:last-child {
  border-bottom-right-radius: inherit;
  border-bottom-left-radius: inherit;
}

.list-group-item.disabled, .list-group-item:disabled {
  color: var(--cui-list-group-disabled-color);
  pointer-events: none;
  background-color: var(--cui-list-group-disabled-bg);
}

.list-group-item.active {
  z-index: 2;
  color: var(--cui-list-group-active-color);
  background-color: var(--cui-list-group-active-bg);
  border-color: var(--cui-list-group-active-border-color);
}

.list-group-item + .list-group-item {
  border-top-width: 0;
}

.list-group-item + .list-group-item.active {
  margin-top: calc(-1 * var(--cui-list-group-border-width));
  border-top-width: var(--cui-list-group-border-width);
}

.list-group-item-action {
  width: 100%;
  color: var(--cui-list-group-action-color);
  text-align: inherit;
}

.list-group-item-action:not(.active):hover, .list-group-item-action:not(.active):focus {
  z-index: 1;
  color: var(--cui-list-group-action-hover-color);
  text-decoration: none;
  background-color: var(--cui-list-group-action-hover-bg);
}

.list-group-item-action:not(.active):active {
  color: var(--cui-list-group-action-active-color);
  background-color: var(--cui-list-group-action-active-bg);
}

.list-group-horizontal {
  flex-direction: row;
}

.list-group-horizontal > .list-group-item:first-child:not(:last-child) {
  border-end-start-radius: var(--cui-list-group-border-radius);
  border-start-end-radius: 0;
}

.list-group-horizontal > .list-group-item:last-child:not(:first-child) {
  border-start-end-radius: var(--cui-list-group-border-radius);
  border-end-start-radius: 0;
}

.list-group-horizontal > .list-group-item.active {
  margin-top: 0;
}

.list-group-horizontal > .list-group-item + .list-group-item {
  border-inline-start-width: 0;
  border-top-width: var(--cui-list-group-border-width);
}

.list-group-horizontal > .list-group-item + .list-group-item.active {
  margin-inline-start: calc(-1 * var(--cui-list-group-border-width));
  border-inline-start-width: var(--cui-list-group-border-width);
}

@media (min-width: 576px) {
  .list-group-horizontal-sm {
    flex-direction: row;
  }
  .list-group-horizontal-sm > .list-group-item:first-child:not(:last-child) {
    border-end-start-radius: var(--cui-list-group-border-radius);
    border-start-end-radius: 0;
  }
  .list-group-horizontal-sm > .list-group-item:last-child:not(:first-child) {
    border-start-end-radius: var(--cui-list-group-border-radius);
    border-end-start-radius: 0;
  }
  .list-group-horizontal-sm > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-sm > .list-group-item + .list-group-item {
    border-inline-start-width: 0;
    border-top-width: var(--cui-list-group-border-width);
  }
  .list-group-horizontal-sm > .list-group-item + .list-group-item.active {
    margin-inline-start: calc(-1 * var(--cui-list-group-border-width));
    border-inline-start-width: var(--cui-list-group-border-width);
  }
}
@media (min-width: 768px) {
  .list-group-horizontal-md {
    flex-direction: row;
  }
  .list-group-horizontal-md > .list-group-item:first-child:not(:last-child) {
    border-end-start-radius: var(--cui-list-group-border-radius);
    border-start-end-radius: 0;
  }
  .list-group-horizontal-md > .list-group-item:last-child:not(:first-child) {
    border-start-end-radius: var(--cui-list-group-border-radius);
    border-end-start-radius: 0;
  }
  .list-group-horizontal-md > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-md > .list-group-item + .list-group-item {
    border-inline-start-width: 0;
    border-top-width: var(--cui-list-group-border-width);
  }
  .list-group-horizontal-md > .list-group-item + .list-group-item.active {
    margin-inline-start: calc(-1 * var(--cui-list-group-border-width));
    border-inline-start-width: var(--cui-list-group-border-width);
  }
}
@media (min-width: 992px) {
  .list-group-horizontal-lg {
    flex-direction: row;
  }
  .list-group-horizontal-lg > .list-group-item:first-child:not(:last-child) {
    border-end-start-radius: var(--cui-list-group-border-radius);
    border-start-end-radius: 0;
  }
  .list-group-horizontal-lg > .list-group-item:last-child:not(:first-child) {
    border-start-end-radius: var(--cui-list-group-border-radius);
    border-end-start-radius: 0;
  }
  .list-group-horizontal-lg > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-lg > .list-group-item + .list-group-item {
    border-inline-start-width: 0;
    border-top-width: var(--cui-list-group-border-width);
  }
  .list-group-horizontal-lg > .list-group-item + .list-group-item.active {
    margin-inline-start: calc(-1 * var(--cui-list-group-border-width));
    border-inline-start-width: var(--cui-list-group-border-width);
  }
}
@media (min-width: 1200px) {
  .list-group-horizontal-xl {
    flex-direction: row;
  }
  .list-group-horizontal-xl > .list-group-item:first-child:not(:last-child) {
    border-end-start-radius: var(--cui-list-group-border-radius);
    border-start-end-radius: 0;
  }
  .list-group-horizontal-xl > .list-group-item:last-child:not(:first-child) {
    border-start-end-radius: var(--cui-list-group-border-radius);
    border-end-start-radius: 0;
  }
  .list-group-horizontal-xl > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-xl > .list-group-item + .list-group-item {
    border-inline-start-width: 0;
    border-top-width: var(--cui-list-group-border-width);
  }
  .list-group-horizontal-xl > .list-group-item + .list-group-item.active {
    margin-inline-start: calc(-1 * var(--cui-list-group-border-width));
    border-inline-start-width: var(--cui-list-group-border-width);
  }
}
@media (min-width: 1400px) {
  .list-group-horizontal-xxl {
    flex-direction: row;
  }
  .list-group-horizontal-xxl > .list-group-item:first-child:not(:last-child) {
    border-end-start-radius: var(--cui-list-group-border-radius);
    border-start-end-radius: 0;
  }
  .list-group-horizontal-xxl > .list-group-item:last-child:not(:first-child) {
    border-start-end-radius: var(--cui-list-group-border-radius);
    border-end-start-radius: 0;
  }
  .list-group-horizontal-xxl > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-xxl > .list-group-item + .list-group-item {
    border-inline-start-width: 0;
    border-top-width: var(--cui-list-group-border-width);
  }
  .list-group-horizontal-xxl > .list-group-item + .list-group-item.active {
    margin-inline-start: calc(-1 * var(--cui-list-group-border-width));
    border-inline-start-width: var(--cui-list-group-border-width);
  }
}
.list-group-flush {
  border-radius: 0;
}

.list-group-flush > .list-group-item {
  border-width: 0 0 var(--cui-list-group-border-width);
}

.list-group-flush > .list-group-item:last-child {
  border-bottom-width: 0;
}

.list-group-item-primary {
  --cui-list-group-color: var(--cui-primary-text-emphasis);
  --cui-list-group-bg: var(--cui-primary-bg-subtle);
  --cui-list-group-border-color: var(--cui-primary-border-subtle);
  --cui-list-group-action-hover-color: var(--cui-emphasis-color);
  --cui-list-group-action-hover-bg: var(--cui-primary-border-subtle);
  --cui-list-group-action-active-color: var(--cui-emphasis-color);
  --cui-list-group-action-active-bg: var(--cui-primary-border-subtle);
  --cui-list-group-active-color: var(--cui-primary-bg-subtle);
  --cui-list-group-active-bg: var(--cui-primary-text-emphasis);
  --cui-list-group-active-border-color: var(--cui-primary-text-emphasis);
}

.list-group-item-secondary {
  --cui-list-group-color: var(--cui-secondary-text-emphasis);
  --cui-list-group-bg: var(--cui-secondary-bg-subtle);
  --cui-list-group-border-color: var(--cui-secondary-border-subtle);
  --cui-list-group-action-hover-color: var(--cui-emphasis-color);
  --cui-list-group-action-hover-bg: var(--cui-secondary-border-subtle);
  --cui-list-group-action-active-color: var(--cui-emphasis-color);
  --cui-list-group-action-active-bg: var(--cui-secondary-border-subtle);
  --cui-list-group-active-color: var(--cui-secondary-bg-subtle);
  --cui-list-group-active-bg: var(--cui-secondary-text-emphasis);
  --cui-list-group-active-border-color: var(--cui-secondary-text-emphasis);
}

.list-group-item-success {
  --cui-list-group-color: var(--cui-success-text-emphasis);
  --cui-list-group-bg: var(--cui-success-bg-subtle);
  --cui-list-group-border-color: var(--cui-success-border-subtle);
  --cui-list-group-action-hover-color: var(--cui-emphasis-color);
  --cui-list-group-action-hover-bg: var(--cui-success-border-subtle);
  --cui-list-group-action-active-color: var(--cui-emphasis-color);
  --cui-list-group-action-active-bg: var(--cui-success-border-subtle);
  --cui-list-group-active-color: var(--cui-success-bg-subtle);
  --cui-list-group-active-bg: var(--cui-success-text-emphasis);
  --cui-list-group-active-border-color: var(--cui-success-text-emphasis);
}

.list-group-item-info {
  --cui-list-group-color: var(--cui-info-text-emphasis);
  --cui-list-group-bg: var(--cui-info-bg-subtle);
  --cui-list-group-border-color: var(--cui-info-border-subtle);
  --cui-list-group-action-hover-color: var(--cui-emphasis-color);
  --cui-list-group-action-hover-bg: var(--cui-info-border-subtle);
  --cui-list-group-action-active-color: var(--cui-emphasis-color);
  --cui-list-group-action-active-bg: var(--cui-info-border-subtle);
  --cui-list-group-active-color: var(--cui-info-bg-subtle);
  --cui-list-group-active-bg: var(--cui-info-text-emphasis);
  --cui-list-group-active-border-color: var(--cui-info-text-emphasis);
}

.list-group-item-warning {
  --cui-list-group-color: var(--cui-warning-text-emphasis);
  --cui-list-group-bg: var(--cui-warning-bg-subtle);
  --cui-list-group-border-color: var(--cui-warning-border-subtle);
  --cui-list-group-action-hover-color: var(--cui-emphasis-color);
  --cui-list-group-action-hover-bg: var(--cui-warning-border-subtle);
  --cui-list-group-action-active-color: var(--cui-emphasis-color);
  --cui-list-group-action-active-bg: var(--cui-warning-border-subtle);
  --cui-list-group-active-color: var(--cui-warning-bg-subtle);
  --cui-list-group-active-bg: var(--cui-warning-text-emphasis);
  --cui-list-group-active-border-color: var(--cui-warning-text-emphasis);
}

.list-group-item-danger {
  --cui-list-group-color: var(--cui-danger-text-emphasis);
  --cui-list-group-bg: var(--cui-danger-bg-subtle);
  --cui-list-group-border-color: var(--cui-danger-border-subtle);
  --cui-list-group-action-hover-color: var(--cui-emphasis-color);
  --cui-list-group-action-hover-bg: var(--cui-danger-border-subtle);
  --cui-list-group-action-active-color: var(--cui-emphasis-color);
  --cui-list-group-action-active-bg: var(--cui-danger-border-subtle);
  --cui-list-group-active-color: var(--cui-danger-bg-subtle);
  --cui-list-group-active-bg: var(--cui-danger-text-emphasis);
  --cui-list-group-active-border-color: var(--cui-danger-text-emphasis);
}

.list-group-item-light {
  --cui-list-group-color: var(--cui-light-text-emphasis);
  --cui-list-group-bg: var(--cui-light-bg-subtle);
  --cui-list-group-border-color: var(--cui-light-border-subtle);
  --cui-list-group-action-hover-color: var(--cui-emphasis-color);
  --cui-list-group-action-hover-bg: var(--cui-light-border-subtle);
  --cui-list-group-action-active-color: var(--cui-emphasis-color);
  --cui-list-group-action-active-bg: var(--cui-light-border-subtle);
  --cui-list-group-active-color: var(--cui-light-bg-subtle);
  --cui-list-group-active-bg: var(--cui-light-text-emphasis);
  --cui-list-group-active-border-color: var(--cui-light-text-emphasis);
}

.list-group-item-dark {
  --cui-list-group-color: var(--cui-dark-text-emphasis);
  --cui-list-group-bg: var(--cui-dark-bg-subtle);
  --cui-list-group-border-color: var(--cui-dark-border-subtle);
  --cui-list-group-action-hover-color: var(--cui-emphasis-color);
  --cui-list-group-action-hover-bg: var(--cui-dark-border-subtle);
  --cui-list-group-action-active-color: var(--cui-emphasis-color);
  --cui-list-group-action-active-bg: var(--cui-dark-border-subtle);
  --cui-list-group-active-color: var(--cui-dark-bg-subtle);
  --cui-list-group-active-bg: var(--cui-dark-text-emphasis);
  --cui-list-group-active-border-color: var(--cui-dark-text-emphasis);
}

.btn-close {
  --cui-btn-close-color: #080a0c;
  --cui-btn-close-bg: url(${___CSS_LOADER_URL_REPLACEMENT_13___});
  --cui-btn-close-opacity: 0.5;
  --cui-btn-close-hover-opacity: 0.75;
  --cui-btn-close-focus-shadow: 0 0 0 0.25rem rgba(88, 86, 214, 0.25);
  --cui-btn-close-focus-opacity: 1;
  --cui-btn-close-disabled-opacity: 0.25;
  box-sizing: content-box;
  width: 1em;
  height: 1em;
  padding: 0.25em 0.25em;
  color: var(--cui-btn-close-color);
  background: transparent var(--cui-btn-close-bg) center/1em auto no-repeat;
  filter: var(--cui-btn-close-filter);
  border: 0;
  border-radius: 0.375rem;
  opacity: var(--cui-btn-close-opacity);
}

.btn-close:hover {
  color: var(--cui-btn-close-color);
  text-decoration: none;
  opacity: var(--cui-btn-close-hover-opacity);
}

.btn-close:focus {
  outline: 0;
  box-shadow: var(--cui-btn-close-focus-shadow);
  opacity: var(--cui-btn-close-focus-opacity);
}

.btn-close:disabled, .btn-close.disabled {
  pointer-events: none;
  -webkit-user-select: none;
          user-select: none;
  opacity: var(--cui-btn-close-disabled-opacity);
}

.btn-close-white {
  --cui-btn-close-filter: invert(1) grayscale(100%) brightness(200%);
}

:root,
[data-coreui-theme=light] {
  --cui-btn-close-filter: ;
}

[data-coreui-theme=dark] {
  --cui-btn-close-filter: invert(1) grayscale(100%) brightness(200%);
}

.toast {
  --cui-toast-zindex: 1090;
  --cui-toast-padding-x: 0.75rem;
  --cui-toast-padding-y: 0.5rem;
  --cui-toast-spacing: 1.5rem;
  --cui-toast-max-width: 350px;
  --cui-toast-font-size: 0.875rem;
  --cui-toast-color: ;
  --cui-toast-bg: rgba(var(--cui-body-bg-rgb), 0.85);
  --cui-toast-border-width: var(--cui-border-width);
  --cui-toast-border-color: var(--cui-border-color-translucent);
  --cui-toast-border-radius: var(--cui-border-radius);
  --cui-toast-box-shadow: var(--cui-box-shadow);
  --cui-toast-header-color: var(--cui-secondary-color);
  --cui-toast-header-bg: rgba(var(--cui-body-bg-rgb), 0.85);
  --cui-toast-header-border-color: var(--cui-border-color-translucent);
  width: var(--cui-toast-max-width);
  max-width: 100%;
  font-size: var(--cui-toast-font-size);
  color: var(--cui-toast-color);
  pointer-events: auto;
  background-color: var(--cui-toast-bg);
  background-clip: padding-box;
  border: var(--cui-toast-border-width) solid var(--cui-toast-border-color);
  box-shadow: var(--cui-toast-box-shadow);
  border-radius: var(--cui-toast-border-radius);
}

.toast.showing {
  opacity: 0;
}

.toast:not(.show) {
  display: none;
}

.toast-container {
  --cui-toast-zindex: 1090;
  position: absolute;
  z-index: var(--cui-toast-zindex);
  width: max-content;
  max-width: 100%;
  pointer-events: none;
}

.toast-container > :not(:last-child) {
  margin-bottom: var(--cui-toast-spacing);
}

.toast-header {
  display: flex;
  align-items: center;
  padding: var(--cui-toast-padding-y) var(--cui-toast-padding-x);
  color: var(--cui-toast-header-color);
  background-color: var(--cui-toast-header-bg);
  background-clip: padding-box;
  border-bottom: var(--cui-toast-border-width) solid var(--cui-toast-header-border-color);
  border-top-left-radius: calc(var(--cui-toast-border-radius) - var(--cui-toast-border-width));
  border-top-right-radius: calc(var(--cui-toast-border-radius) - var(--cui-toast-border-width));
}

.toast-header .btn-close {
  margin-inline: var(--cui-toast-padding-x) calc(-0.5 * var(--cui-toast-padding-x));
}

.toast-body {
  padding: var(--cui-toast-padding-x);
  word-wrap: break-word;
}

.modal {
  --cui-modal-zindex: 1055;
  --cui-modal-width: 500px;
  --cui-modal-padding: 1rem;
  --cui-modal-margin: 0.5rem;
  --cui-modal-color: var(--cui-body-color);
  --cui-modal-bg: var(--cui-body-bg);
  --cui-modal-border-color: var(--cui-border-color-translucent);
  --cui-modal-border-width: var(--cui-border-width);
  --cui-modal-border-radius: var(--cui-border-radius-lg);
  --cui-modal-box-shadow: var(--cui-box-shadow-sm);
  --cui-modal-inner-border-radius: calc(var(--cui-modal-border-radius) - var(--cui-modal-border-width));
  --cui-modal-header-padding-x: 1rem;
  --cui-modal-header-padding-y: 1rem;
  --cui-modal-header-padding: 1rem 1rem;
  --cui-modal-header-border-color: var(--cui-border-color);
  --cui-modal-header-border-width: var(--cui-border-width);
  --cui-modal-title-line-height: 1.5;
  --cui-modal-footer-gap: 0.5rem;
  --cui-modal-footer-bg: ;
  --cui-modal-footer-border-color: var(--cui-border-color);
  --cui-modal-footer-border-width: var(--cui-border-width);
  position: fixed;
  inset-inline-start: 0;
  top: 0;
  z-index: var(--cui-modal-zindex);
  display: none;
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  outline: 0;
}

.modal-dialog {
  position: relative;
  width: auto;
  margin: var(--cui-modal-margin);
  pointer-events: none;
}

.modal.fade .modal-dialog {
  transform: translate(0, -50px);
  transition: transform 0.3s ease-out;
}

@media (prefers-reduced-motion: reduce) {
  .modal.fade .modal-dialog {
    transition: none;
  }
}
.modal.show .modal-dialog {
  transform: none;
}

.modal.modal-static .modal-dialog {
  transform: scale(1.02);
}

.modal-dialog-scrollable {
  height: calc(100% - var(--cui-modal-margin) * 2);
}

.modal-dialog-scrollable .modal-content {
  max-height: 100%;
  overflow: hidden;
}

.modal-dialog-scrollable .modal-body {
  overflow-y: auto;
}

.modal-dialog-centered {
  display: flex;
  align-items: center;
  min-height: calc(100% - var(--cui-modal-margin) * 2);
}

.modal-content {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  color: var(--cui-modal-color);
  pointer-events: auto;
  background-color: var(--cui-modal-bg);
  background-clip: padding-box;
  border: var(--cui-modal-border-width) solid var(--cui-modal-border-color);
  border-radius: var(--cui-modal-border-radius);
  outline: 0;
}

.modal-backdrop {
  --cui-backdrop-zindex: 1050;
  --cui-backdrop-bg: #080a0c;
  --cui-backdrop-opacity: 0.5;
  position: fixed;
  top: 0;
  left: 0;
  z-index: var(--cui-backdrop-zindex);
  width: 100vw;
  height: 100vh;
  background-color: var(--cui-backdrop-bg);
}

.modal-backdrop.fade {
  opacity: 0;
}

.modal-backdrop.show {
  opacity: var(--cui-backdrop-opacity);
}

.modal-header {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  padding: var(--cui-modal-header-padding);
  border-bottom: var(--cui-modal-header-border-width) solid var(--cui-modal-header-border-color);
  border-top-left-radius: var(--cui-modal-inner-border-radius);
  border-top-right-radius: var(--cui-modal-inner-border-radius);
}

.modal-header .btn-close {
  padding: calc(var(--cui-modal-header-padding-y) * 0.5) calc(var(--cui-modal-header-padding-x) * 0.5);
  margin-inline-start: auto;
  margin-inline-end: calc(-0.5 * var(--cui-modal-header-padding-x));
  margin-top: calc(-0.5 * var(--cui-modal-header-padding-y));
  margin-bottom: calc(-0.5 * var(--cui-modal-header-padding-y));
}

.modal-title {
  margin-bottom: 0;
  line-height: var(--cui-modal-title-line-height);
}

.modal-body {
  position: relative;
  flex: 1 1 auto;
  padding: var(--cui-modal-padding);
}

.modal-footer {
  display: flex;
  flex-shrink: 0;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  padding: calc(var(--cui-modal-padding) - var(--cui-modal-footer-gap) * 0.5);
  background-color: var(--cui-modal-footer-bg);
  border-top: var(--cui-modal-footer-border-width) solid var(--cui-modal-footer-border-color);
  border-bottom-right-radius: var(--cui-modal-inner-border-radius);
  border-bottom-left-radius: var(--cui-modal-inner-border-radius);
}

.modal-footer > * {
  margin: calc(var(--cui-modal-footer-gap) * 0.5);
}

@media (min-width: 576px) {
  .modal {
    --cui-modal-margin: 1.75rem;
    --cui-modal-box-shadow: var(--cui-box-shadow);
  }
  .modal-dialog {
    max-width: var(--cui-modal-width);
    margin-right: auto;
    margin-left: auto;
  }
  .modal-sm {
    --cui-modal-width: 300px;
  }
}
@media (min-width: 992px) {
  .modal-lg,
  .modal-xl {
    --cui-modal-width: 800px;
  }
}
@media (min-width: 1200px) {
  .modal-xl {
    --cui-modal-width: 1140px;
  }
}
.modal-fullscreen {
  width: 100vw;
  max-width: none;
  height: 100%;
  margin: 0;
}

.modal-fullscreen .modal-content {
  height: 100%;
  border: 0;
  border-radius: 0;
}

.modal-fullscreen .modal-header,
.modal-fullscreen .modal-footer {
  border-radius: 0;
}

.modal-fullscreen .modal-body {
  overflow-y: auto;
}

@media (max-width: 575.98px) {
  .modal-fullscreen-sm-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-sm-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-sm-down .modal-header,
  .modal-fullscreen-sm-down .modal-footer {
    border-radius: 0;
  }
  .modal-fullscreen-sm-down .modal-body {
    overflow-y: auto;
  }
}
@media (max-width: 767.98px) {
  .modal-fullscreen-md-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-md-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-md-down .modal-header,
  .modal-fullscreen-md-down .modal-footer {
    border-radius: 0;
  }
  .modal-fullscreen-md-down .modal-body {
    overflow-y: auto;
  }
}
@media (max-width: 991.98px) {
  .modal-fullscreen-lg-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-lg-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-lg-down .modal-header,
  .modal-fullscreen-lg-down .modal-footer {
    border-radius: 0;
  }
  .modal-fullscreen-lg-down .modal-body {
    overflow-y: auto;
  }
}
@media (max-width: 1199.98px) {
  .modal-fullscreen-xl-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-xl-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-xl-down .modal-header,
  .modal-fullscreen-xl-down .modal-footer {
    border-radius: 0;
  }
  .modal-fullscreen-xl-down .modal-body {
    overflow-y: auto;
  }
}
@media (max-width: 1399.98px) {
  .modal-fullscreen-xxl-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-xxl-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-xxl-down .modal-header,
  .modal-fullscreen-xxl-down .modal-footer {
    border-radius: 0;
  }
  .modal-fullscreen-xxl-down .modal-body {
    overflow-y: auto;
  }
}
.tooltip {
  --cui-tooltip-zindex: 1080;
  --cui-tooltip-max-width: 200px;
  --cui-tooltip-padding-x: 0.5rem;
  --cui-tooltip-padding-y: 0.25rem;
  --cui-tooltip-margin: ;
  --cui-tooltip-font-size: 0.875rem;
  --cui-tooltip-color: var(--cui-body-bg);
  --cui-tooltip-bg: var(--cui-emphasis-color);
  --cui-tooltip-border-radius: var(--cui-border-radius);
  --cui-tooltip-opacity: 0.9;
  --cui-tooltip-arrow-width: 0.8rem;
  --cui-tooltip-arrow-height: 0.4rem;
  z-index: var(--cui-tooltip-zindex);
  display: block;
  margin: var(--cui-tooltip-margin);
  font-family: var(--cui-font-sans-serif);
  font-style: normal;
  font-weight: 400;
  line-height: 1.5;
  text-align: start;
  text-decoration: none;
  text-shadow: none;
  text-transform: none;
  letter-spacing: normal;
  word-break: normal;
  white-space: normal;
  word-spacing: normal;
  line-break: auto;
  font-size: var(--cui-tooltip-font-size);
  word-wrap: break-word;
  opacity: 0;
}

.tooltip.show {
  opacity: var(--cui-tooltip-opacity);
}

.tooltip .tooltip-arrow {
  display: block;
  width: var(--cui-tooltip-arrow-width);
  height: var(--cui-tooltip-arrow-height);
}

.tooltip .tooltip-arrow::before {
  position: absolute;
  content: "";
  border-color: transparent;
  border-style: solid;
}

.bs-tooltip-top .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow {
  bottom: calc(-1 * var(--cui-tooltip-arrow-height));
}

.bs-tooltip-top .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow::before {
  top: -1px;
  border-width: var(--cui-tooltip-arrow-height) calc(var(--cui-tooltip-arrow-width) * 0.5) 0;
  border-top-color: var(--cui-tooltip-bg);
}

/* rtl:begin:ignore */
.bs-tooltip-end .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow {
  left: calc(-1 * var(--cui-tooltip-arrow-height));
  width: var(--cui-tooltip-arrow-height);
  height: var(--cui-tooltip-arrow-width);
}

.bs-tooltip-end .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow::before {
  right: -1px;
  border-width: calc(var(--cui-tooltip-arrow-width) * 0.5) var(--cui-tooltip-arrow-height) calc(var(--cui-tooltip-arrow-width) * 0.5) 0;
  border-right-color: var(--cui-tooltip-bg);
}

/* rtl:end:ignore */
.bs-tooltip-bottom .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow {
  top: calc(-1 * var(--cui-tooltip-arrow-height));
}

.bs-tooltip-bottom .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow::before {
  bottom: -1px;
  border-width: 0 calc(var(--cui-tooltip-arrow-width) * 0.5) var(--cui-tooltip-arrow-height);
  border-bottom-color: var(--cui-tooltip-bg);
}

/* rtl:begin:ignore */
.bs-tooltip-start .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow {
  right: calc(-1 * var(--cui-tooltip-arrow-height));
  width: var(--cui-tooltip-arrow-height);
  height: var(--cui-tooltip-arrow-width);
}

.bs-tooltip-start .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow::before {
  left: -1px;
  border-width: calc(var(--cui-tooltip-arrow-width) * 0.5) 0 calc(var(--cui-tooltip-arrow-width) * 0.5) var(--cui-tooltip-arrow-height);
  border-left-color: var(--cui-tooltip-bg);
}

/* rtl:end:ignore */
.tooltip-inner {
  max-width: var(--cui-tooltip-max-width);
  padding: var(--cui-tooltip-padding-y) var(--cui-tooltip-padding-x);
  color: var(--cui-tooltip-color);
  text-align: center;
  background-color: var(--cui-tooltip-bg);
  border-radius: var(--cui-tooltip-border-radius);
}

.popover {
  --cui-popover-zindex: 1070;
  --cui-popover-max-width: 276px;
  --cui-popover-font-size: 0.875rem;
  --cui-popover-bg: var(--cui-body-bg);
  --cui-popover-border-width: var(--cui-border-width);
  --cui-popover-border-color: var(--cui-border-color-translucent);
  --cui-popover-border-radius: var(--cui-border-radius-lg);
  --cui-popover-inner-border-radius: calc(var(--cui-popover-border-radius) - var(--cui-popover-border-width));
  --cui-popover-box-shadow: var(--cui-box-shadow);
  --cui-popover-header-padding-x: 1rem;
  --cui-popover-header-padding-y: 0.5rem;
  --cui-popover-header-font-size: 1rem;
  --cui-popover-header-color: inherit;
  --cui-popover-header-bg: var(--cui-secondary-bg);
  --cui-popover-body-padding-x: 1rem;
  --cui-popover-body-padding-y: 1rem;
  --cui-popover-body-color: var(--cui-body-color);
  --cui-popover-arrow-width: 1rem;
  --cui-popover-arrow-height: 0.5rem;
  --cui-popover-arrow-border: var(--cui-popover-border-color);
  z-index: var(--cui-popover-zindex);
  display: block;
  max-width: var(--cui-popover-max-width);
  font-family: var(--cui-font-sans-serif);
  font-style: normal;
  font-weight: 400;
  line-height: 1.5;
  text-align: start;
  text-decoration: none;
  text-shadow: none;
  text-transform: none;
  letter-spacing: normal;
  word-break: normal;
  white-space: normal;
  word-spacing: normal;
  line-break: auto;
  font-size: var(--cui-popover-font-size);
  word-wrap: break-word;
  background-color: var(--cui-popover-bg);
  background-clip: padding-box;
  border: var(--cui-popover-border-width) solid var(--cui-popover-border-color);
  border-radius: var(--cui-popover-border-radius);
}

.popover .popover-arrow {
  display: block;
  width: var(--cui-popover-arrow-width);
  height: var(--cui-popover-arrow-height);
}

.popover .popover-arrow::before, .popover .popover-arrow::after {
  position: absolute;
  display: block;
  content: "";
  border-color: transparent;
  border-style: solid;
  border-width: 0;
}

.bs-popover-top > .popover-arrow, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow {
  bottom: calc(-1 * (var(--cui-popover-arrow-height)) - var(--cui-popover-border-width));
}

.bs-popover-top > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::before, .bs-popover-top > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::after {
  border-width: var(--cui-popover-arrow-height) calc(var(--cui-popover-arrow-width) * 0.5) 0;
}

.bs-popover-top > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::before {
  bottom: 0;
  border-top-color: var(--cui-popover-arrow-border);
}

.bs-popover-top > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::after {
  bottom: var(--cui-popover-border-width);
  border-top-color: var(--cui-popover-bg);
}

/* rtl:begin:ignore */
.bs-popover-end > .popover-arrow, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow {
  left: calc(-1 * (var(--cui-popover-arrow-height)) - var(--cui-popover-border-width));
  width: var(--cui-popover-arrow-height);
  height: var(--cui-popover-arrow-width);
}

.bs-popover-end > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::before, .bs-popover-end > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::after {
  border-width: calc(var(--cui-popover-arrow-width) * 0.5) var(--cui-popover-arrow-height) calc(var(--cui-popover-arrow-width) * 0.5) 0;
}

.bs-popover-end > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::before {
  left: 0;
  border-right-color: var(--cui-popover-arrow-border);
}

.bs-popover-end > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::after {
  left: var(--cui-popover-border-width);
  border-right-color: var(--cui-popover-bg);
}

/* rtl:end:ignore */
.bs-popover-bottom > .popover-arrow, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow {
  top: calc(-1 * (var(--cui-popover-arrow-height)) - var(--cui-popover-border-width));
}

.bs-popover-bottom > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::before, .bs-popover-bottom > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after {
  border-width: 0 calc(var(--cui-popover-arrow-width) * 0.5) var(--cui-popover-arrow-height);
}

.bs-popover-bottom > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::before {
  top: 0;
  border-bottom-color: var(--cui-popover-arrow-border);
}

.bs-popover-bottom > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after {
  top: var(--cui-popover-border-width);
  border-bottom-color: var(--cui-popover-bg);
}

.bs-popover-bottom .popover-header::before, .bs-popover-auto[data-popper-placement^=bottom] .popover-header::before {
  position: absolute;
  top: 0;
  left: 50%;
  display: block;
  width: var(--cui-popover-arrow-width);
  margin-left: calc(-0.5 * var(--cui-popover-arrow-width));
  content: "";
  border-bottom: var(--cui-popover-border-width) solid var(--cui-popover-header-bg);
}

/* rtl:begin:ignore */
.bs-popover-start > .popover-arrow, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow {
  right: calc(-1 * (var(--cui-popover-arrow-height)) - var(--cui-popover-border-width));
  width: var(--cui-popover-arrow-height);
  height: var(--cui-popover-arrow-width);
}

.bs-popover-start > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::before, .bs-popover-start > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::after {
  border-width: calc(var(--cui-popover-arrow-width) * 0.5) 0 calc(var(--cui-popover-arrow-width) * 0.5) var(--cui-popover-arrow-height);
}

.bs-popover-start > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::before {
  right: 0;
  border-left-color: var(--cui-popover-arrow-border);
}

.bs-popover-start > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::after {
  right: var(--cui-popover-border-width);
  border-left-color: var(--cui-popover-bg);
}

/* rtl:end:ignore */
.popover-header {
  padding: var(--cui-popover-header-padding-y) var(--cui-popover-header-padding-x);
  margin-bottom: 0;
  font-size: var(--cui-popover-header-font-size);
  color: var(--cui-popover-header-color);
  background-color: var(--cui-popover-header-bg);
  border-bottom: var(--cui-popover-border-width) solid var(--cui-popover-border-color);
  border-top-left-radius: var(--cui-popover-inner-border-radius);
  border-top-right-radius: var(--cui-popover-inner-border-radius);
}

.popover-header:empty {
  display: none;
}

.popover-body {
  padding: var(--cui-popover-body-padding-y) var(--cui-popover-body-padding-x);
  color: var(--cui-popover-body-color);
}

.carousel {
  position: relative;
}

.carousel.pointer-event {
  touch-action: pan-y;
}

.carousel-inner {
  position: relative;
  width: 100%;
  overflow: hidden;
}

.carousel-inner::after {
  display: block;
  clear: both;
  content: "";
}

.carousel-item {
  position: relative;
  display: none;
  float: left;
  width: 100%;
  margin-right: -100%;
  backface-visibility: hidden;
  transition: transform 0.6s ease-in-out;
}

@media (prefers-reduced-motion: reduce) {
  .carousel-item {
    transition: none;
  }
}
.carousel-item.active,
.carousel-item-next,
.carousel-item-prev {
  display: block;
}

.carousel-item-next:not(.carousel-item-start),
.active.carousel-item-end {
  transform: translateX(100%);
}

.carousel-item-prev:not(.carousel-item-end),
.active.carousel-item-start {
  transform: translateX(-100%);
}

.carousel-fade .carousel-item {
  opacity: 0;
  transition-property: opacity;
  transform: none;
}

.carousel-fade .carousel-item.active,
.carousel-fade .carousel-item-next.carousel-item-start,
.carousel-fade .carousel-item-prev.carousel-item-end {
  z-index: 1;
  opacity: 1;
}

.carousel-fade .active.carousel-item-start,
.carousel-fade .active.carousel-item-end {
  z-index: 0;
  opacity: 0;
  transition: opacity 0s 0.6s;
}

@media (prefers-reduced-motion: reduce) {
  .carousel-fade .active.carousel-item-start,
  .carousel-fade .active.carousel-item-end {
    transition: none;
  }
}
.carousel-control-prev,
.carousel-control-next {
  position: absolute;
  top: 0;
  bottom: 0;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 15%;
  padding: 0;
  color: #fff;
  text-align: center;
  background: none;
  filter: var(--cui-carousel-control-icon-filter);
  border: 0;
  opacity: 0.5;
  transition: opacity 0.15s ease;
}

@media (prefers-reduced-motion: reduce) {
  .carousel-control-prev,
  .carousel-control-next {
    transition: none;
  }
}
.carousel-control-prev:hover, .carousel-control-prev:focus,
.carousel-control-next:hover,
.carousel-control-next:focus {
  color: #fff;
  text-decoration: none;
  outline: 0;
  opacity: 0.9;
}

.carousel-control-prev {
  left: 0;
}

.carousel-control-next {
  right: 0;
}

.carousel-control-prev-icon,
.carousel-control-next-icon {
  display: inline-block;
  width: 2rem;
  height: 2rem;
  background-repeat: no-repeat;
  background-position: 50%;
  background-size: 100% 100%;
}

.carousel-control-prev-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_14___});
}

.carousel-control-next-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_15___});
}

.carousel-indicators {
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 2;
  display: flex;
  justify-content: center;
  padding: 0;
  margin-right: 15%;
  margin-bottom: 1rem;
  margin-left: 15%;
}

.carousel-indicators [data-coreui-target] {
  box-sizing: content-box;
  flex: 0 1 auto;
  width: 30px;
  height: 3px;
  padding: 0;
  margin-right: 3px;
  margin-left: 3px;
  text-indent: -999px;
  cursor: pointer;
  background-color: #fff;
  background-clip: padding-box;
  border: 0;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
  opacity: 0.5;
  transition: opacity 0.6s ease;
}

@media (prefers-reduced-motion: reduce) {
  .carousel-indicators [data-coreui-target] {
    transition: none;
  }
}
.carousel-indicators .active {
  opacity: 1;
}

.carousel-caption {
  position: absolute;
  right: 15%;
  bottom: 1.25rem;
  left: 15%;
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
  color: var(--cui-carousel-caption-color);
  text-align: center;
}

.carousel-dark {
  --cui-carousel-indicator-active-bg: #080a0c;
  --cui-carousel-caption-color: #080a0c;
  --cui-carousel-control-icon-filter: invert(1) grayscale(100);
}

:root,
[data-coreui-theme=light] {
  --cui-carousel-indicator-active-bg: #fff;
  --cui-carousel-caption-color: #fff;
  --cui-carousel-control-icon-filter: ;
}

[data-coreui-theme=dark] {
  --cui-carousel-indicator-active-bg: #080a0c;
  --cui-carousel-caption-color: #080a0c;
  --cui-carousel-control-icon-filter: invert(1) grayscale(100);
}

.spinner-grow,
.spinner-border {
  display: inline-block;
  flex-shrink: 0;
  width: var(--cui-spinner-width);
  height: var(--cui-spinner-height);
  vertical-align: var(--cui-spinner-vertical-align);
  border-radius: 50%;
  animation: var(--cui-spinner-animation-speed) linear infinite var(--cui-spinner-animation-name);
}

@keyframes spinner-border {
  to {
    transform: rotate(360deg) /* rtl:ignore */;
  }
}
.spinner-border {
  --cui-spinner-width: 2rem;
  --cui-spinner-height: 2rem;
  --cui-spinner-vertical-align: -0.125em;
  --cui-spinner-border-width: 0.25em;
  --cui-spinner-animation-speed: 0.75s;
  --cui-spinner-animation-name: spinner-border;
  border: var(--cui-spinner-border-width) solid currentcolor;
  border-right-color: transparent;
}

.spinner-border-sm {
  --cui-spinner-width: 1rem;
  --cui-spinner-height: 1rem;
  --cui-spinner-border-width: 0.2em;
}

@keyframes spinner-grow {
  0% {
    transform: scale(0);
  }
  50% {
    opacity: 1;
    transform: none;
  }
}
.spinner-grow {
  --cui-spinner-width: 2rem;
  --cui-spinner-height: 2rem;
  --cui-spinner-vertical-align: -0.125em;
  --cui-spinner-animation-speed: 0.75s;
  --cui-spinner-animation-name: spinner-grow;
  background-color: currentcolor;
  opacity: 0;
}

.spinner-grow-sm {
  --cui-spinner-width: 1rem;
  --cui-spinner-height: 1rem;
}

@media (prefers-reduced-motion: reduce) {
  .spinner-border,
  .spinner-grow {
    --cui-spinner-animation-speed: 1.5s;
  }
}
.offcanvas, .offcanvas-xxl, .offcanvas-xl, .offcanvas-lg, .offcanvas-md, .offcanvas-sm {
  --cui-offcanvas-zindex: 1045;
  --cui-offcanvas-width: 400px;
  --cui-offcanvas-height: 30vh;
  --cui-offcanvas-padding-x: 1rem;
  --cui-offcanvas-padding-y: 1rem;
  --cui-offcanvas-color: var(--cui-body-color);
  --cui-offcanvas-bg: var(--cui-body-bg);
  --cui-offcanvas-border-width: var(--cui-border-width);
  --cui-offcanvas-border-color: var(--cui-border-color-translucent);
  --cui-offcanvas-box-shadow: var(--cui-box-shadow-sm);
  --cui-offcanvas-transition: transform 0.3s ease-in-out;
  --cui-offcanvas-title-line-height: 1.5;
}

@media (max-width: 575.98px) {
  .offcanvas-sm {
    position: fixed;
    bottom: 0;
    z-index: var(--cui-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--cui-offcanvas-color);
    visibility: hidden;
    background-color: var(--cui-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--cui-offcanvas-transition);
  }
}
@media (max-width: 575.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-sm {
    transition: none;
  }
}
@media (max-width: 575.98px) {
  .offcanvas-sm.offcanvas-start {
    inset-inline-start: 0;
    top: 0;
    width: var(--cui-offcanvas-width);
    border-inline-end: var(--cui-offcanvas-border-width) solid var(--cui-offcanvas-border-color);
    transform: translateX(-100%);
  }
  .offcanvas-sm.offcanvas-end {
    inset-inline-end: 0;
    top: 0;
    width: var(--cui-offcanvas-width);
    border-inline-start: var(--cui-offcanvas-border-width) solid var(--cui-offcanvas-border-color);
    transform: translateX(100%);
  }
  .offcanvas-sm.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--cui-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--cui-offcanvas-border-width) solid var(--cui-offcanvas-border-color);
    transform: translateY(-100%);
  }
  .offcanvas-sm.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--cui-offcanvas-height);
    max-height: 100%;
    border-top: var(--cui-offcanvas-border-width) solid var(--cui-offcanvas-border-color);
    transform: translateY(100%);
  }
  .offcanvas-sm.showing, .offcanvas-sm.show:not(.hiding) {
    transform: none !important;
  }
  .offcanvas-sm.showing, .offcanvas-sm.hiding, .offcanvas-sm.show {
    visibility: visible;
  }
}
@media (min-width: 576px) {
  .offcanvas-sm {
    --cui-offcanvas-height: auto;
    --cui-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .offcanvas-sm .offcanvas-header {
    display: none;
  }
  .offcanvas-sm .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}
@media (max-width: 767.98px) {
  .offcanvas-md {
    position: fixed;
    bottom: 0;
    z-index: var(--cui-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--cui-offcanvas-color);
    visibility: hidden;
    background-color: var(--cui-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--cui-offcanvas-transition);
  }
}
@media (max-width: 767.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-md {
    transition: none;
  }
}
@media (max-width: 767.98px) {
  .offcanvas-md.offcanvas-start {
    inset-inline-start: 0;
    top: 0;
    width: var(--cui-offcanvas-width);
    border-inline-end: var(--cui-offcanvas-border-width) solid var(--cui-offcanvas-border-color);
    transform: translateX(-100%);
  }
  .offcanvas-md.offcanvas-end {
    inset-inline-end: 0;
    top: 0;
    width: var(--cui-offcanvas-width);
    border-inline-start: var(--cui-offcanvas-border-width) solid var(--cui-offcanvas-border-color);
    transform: translateX(100%);
  }
  .offcanvas-md.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--cui-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--cui-offcanvas-border-width) solid var(--cui-offcanvas-border-color);
    transform: translateY(-100%);
  }
  .offcanvas-md.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--cui-offcanvas-height);
    max-height: 100%;
    border-top: var(--cui-offcanvas-border-width) solid var(--cui-offcanvas-border-color);
    transform: translateY(100%);
  }
  .offcanvas-md.showing, .offcanvas-md.show:not(.hiding) {
    transform: none !important;
  }
  .offcanvas-md.showing, .offcanvas-md.hiding, .offcanvas-md.show {
    visibility: visible;
  }
}
@media (min-width: 768px) {
  .offcanvas-md {
    --cui-offcanvas-height: auto;
    --cui-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .offcanvas-md .offcanvas-header {
    display: none;
  }
  .offcanvas-md .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}
@media (max-width: 991.98px) {
  .offcanvas-lg {
    position: fixed;
    bottom: 0;
    z-index: var(--cui-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--cui-offcanvas-color);
    visibility: hidden;
    background-color: var(--cui-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--cui-offcanvas-transition);
  }
}
@media (max-width: 991.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-lg {
    transition: none;
  }
}
@media (max-width: 991.98px) {
  .offcanvas-lg.offcanvas-start {
    inset-inline-start: 0;
    top: 0;
    width: var(--cui-offcanvas-width);
    border-inline-end: var(--cui-offcanvas-border-width) solid var(--cui-offcanvas-border-color);
    transform: translateX(-100%);
  }
  .offcanvas-lg.offcanvas-end {
    inset-inline-end: 0;
    top: 0;
    width: var(--cui-offcanvas-width);
    border-inline-start: var(--cui-offcanvas-border-width) solid var(--cui-offcanvas-border-color);
    transform: translateX(100%);
  }
  .offcanvas-lg.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--cui-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--cui-offcanvas-border-width) solid var(--cui-offcanvas-border-color);
    transform: translateY(-100%);
  }
  .offcanvas-lg.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--cui-offcanvas-height);
    max-height: 100%;
    border-top: var(--cui-offcanvas-border-width) solid var(--cui-offcanvas-border-color);
    transform: translateY(100%);
  }
  .offcanvas-lg.showing, .offcanvas-lg.show:not(.hiding) {
    transform: none !important;
  }
  .offcanvas-lg.showing, .offcanvas-lg.hiding, .offcanvas-lg.show {
    visibility: visible;
  }
}
@media (min-width: 992px) {
  .offcanvas-lg {
    --cui-offcanvas-height: auto;
    --cui-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .offcanvas-lg .offcanvas-header {
    display: none;
  }
  .offcanvas-lg .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}
@media (max-width: 1199.98px) {
  .offcanvas-xl {
    position: fixed;
    bottom: 0;
    z-index: var(--cui-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--cui-offcanvas-color);
    visibility: hidden;
    background-color: var(--cui-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--cui-offcanvas-transition);
  }
}
@media (max-width: 1199.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-xl {
    transition: none;
  }
}
@media (max-width: 1199.98px) {
  .offcanvas-xl.offcanvas-start {
    inset-inline-start: 0;
    top: 0;
    width: var(--cui-offcanvas-width);
    border-inline-end: var(--cui-offcanvas-border-width) solid var(--cui-offcanvas-border-color);
    transform: translateX(-100%);
  }
  .offcanvas-xl.offcanvas-end {
    inset-inline-end: 0;
    top: 0;
    width: var(--cui-offcanvas-width);
    border-inline-start: var(--cui-offcanvas-border-width) solid var(--cui-offcanvas-border-color);
    transform: translateX(100%);
  }
  .offcanvas-xl.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--cui-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--cui-offcanvas-border-width) solid var(--cui-offcanvas-border-color);
    transform: translateY(-100%);
  }
  .offcanvas-xl.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--cui-offcanvas-height);
    max-height: 100%;
    border-top: var(--cui-offcanvas-border-width) solid var(--cui-offcanvas-border-color);
    transform: translateY(100%);
  }
  .offcanvas-xl.showing, .offcanvas-xl.show:not(.hiding) {
    transform: none !important;
  }
  .offcanvas-xl.showing, .offcanvas-xl.hiding, .offcanvas-xl.show {
    visibility: visible;
  }
}
@media (min-width: 1200px) {
  .offcanvas-xl {
    --cui-offcanvas-height: auto;
    --cui-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .offcanvas-xl .offcanvas-header {
    display: none;
  }
  .offcanvas-xl .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}
@media (max-width: 1399.98px) {
  .offcanvas-xxl {
    position: fixed;
    bottom: 0;
    z-index: var(--cui-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--cui-offcanvas-color);
    visibility: hidden;
    background-color: var(--cui-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--cui-offcanvas-transition);
  }
}
@media (max-width: 1399.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-xxl {
    transition: none;
  }
}
@media (max-width: 1399.98px) {
  .offcanvas-xxl.offcanvas-start {
    inset-inline-start: 0;
    top: 0;
    width: var(--cui-offcanvas-width);
    border-inline-end: var(--cui-offcanvas-border-width) solid var(--cui-offcanvas-border-color);
    transform: translateX(-100%);
  }
  .offcanvas-xxl.offcanvas-end {
    inset-inline-end: 0;
    top: 0;
    width: var(--cui-offcanvas-width);
    border-inline-start: var(--cui-offcanvas-border-width) solid var(--cui-offcanvas-border-color);
    transform: translateX(100%);
  }
  .offcanvas-xxl.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--cui-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--cui-offcanvas-border-width) solid var(--cui-offcanvas-border-color);
    transform: translateY(-100%);
  }
  .offcanvas-xxl.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--cui-offcanvas-height);
    max-height: 100%;
    border-top: var(--cui-offcanvas-border-width) solid var(--cui-offcanvas-border-color);
    transform: translateY(100%);
  }
  .offcanvas-xxl.showing, .offcanvas-xxl.show:not(.hiding) {
    transform: none !important;
  }
  .offcanvas-xxl.showing, .offcanvas-xxl.hiding, .offcanvas-xxl.show {
    visibility: visible;
  }
}
@media (min-width: 1400px) {
  .offcanvas-xxl {
    --cui-offcanvas-height: auto;
    --cui-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .offcanvas-xxl .offcanvas-header {
    display: none;
  }
  .offcanvas-xxl .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}
.offcanvas {
  position: fixed;
  bottom: 0;
  z-index: var(--cui-offcanvas-zindex);
  display: flex;
  flex-direction: column;
  max-width: 100%;
  color: var(--cui-offcanvas-color);
  visibility: hidden;
  background-color: var(--cui-offcanvas-bg);
  background-clip: padding-box;
  outline: 0;
  transition: var(--cui-offcanvas-transition);
}

@media (prefers-reduced-motion: reduce) {
  .offcanvas {
    transition: none;
  }
}
.offcanvas.offcanvas-start {
  inset-inline-start: 0;
  top: 0;
  width: var(--cui-offcanvas-width);
  border-inline-end: var(--cui-offcanvas-border-width) solid var(--cui-offcanvas-border-color);
  transform: translateX(-100%);
}

.offcanvas.offcanvas-end {
  inset-inline-end: 0;
  top: 0;
  width: var(--cui-offcanvas-width);
  border-inline-start: var(--cui-offcanvas-border-width) solid var(--cui-offcanvas-border-color);
  transform: translateX(100%);
}

.offcanvas.offcanvas-top {
  top: 0;
  right: 0;
  left: 0;
  height: var(--cui-offcanvas-height);
  max-height: 100%;
  border-bottom: var(--cui-offcanvas-border-width) solid var(--cui-offcanvas-border-color);
  transform: translateY(-100%);
}

.offcanvas.offcanvas-bottom {
  right: 0;
  left: 0;
  height: var(--cui-offcanvas-height);
  max-height: 100%;
  border-top: var(--cui-offcanvas-border-width) solid var(--cui-offcanvas-border-color);
  transform: translateY(100%);
}

.offcanvas.showing, .offcanvas.show:not(.hiding) {
  transform: none !important;
}

.offcanvas.showing, .offcanvas.hiding, .offcanvas.show {
  visibility: visible;
}

.offcanvas-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1040;
  width: 100vw;
  height: 100vh;
  background-color: var(--cui-offcanvas-backdrop-bg, #080a0c);
}

.offcanvas-backdrop.fade {
  opacity: 0;
}

.offcanvas-backdrop.show {
  opacity: 0.5;
}

.offcanvas-header {
  display: flex;
  align-items: center;
  padding: var(--cui-offcanvas-padding-y) var(--cui-offcanvas-padding-x);
}

.offcanvas-header .btn-close {
  padding: calc(var(--cui-offcanvas-padding-y) * 0.5) calc(var(--cui-offcanvas-padding-x) * 0.5);
  margin-inline-start: auto;
  margin-inline-end: calc(-0.5 * var(--cui-offcanvas-padding-x));
  margin-top: calc(-0.5 * var(--cui-offcanvas-padding-y));
  margin-bottom: calc(-0.5 * var(--cui-offcanvas-padding-y));
}

.offcanvas-title {
  margin-bottom: 0;
  line-height: var(--cui-offcanvas-title-line-height);
}

.offcanvas-body {
  flex-grow: 1;
  padding: var(--cui-offcanvas-padding-y) var(--cui-offcanvas-padding-x);
  overflow-y: auto;
}

.placeholder {
  display: inline-block;
  min-height: 1em;
  vertical-align: middle;
  cursor: wait;
  background-color: currentcolor;
  opacity: 0.5;
}

.placeholder.btn::before {
  display: inline-block;
  content: "";
}

.placeholder-xs {
  min-height: 0.6em;
}

.placeholder-sm {
  min-height: 0.8em;
}

.placeholder-lg {
  min-height: 1.2em;
}

.placeholder-glow .placeholder {
  animation: placeholder-glow 2s ease-in-out infinite;
}

@media (prefers-reduced-motion: reduce) {
  .placeholder-glow .placeholder {
    animation: none;
  }
}
@keyframes placeholder-glow {
  50% {
    opacity: 0.2;
  }
}
.placeholder-wave {
  mask-image: linear-gradient(130deg, #080a0c 55%, rgba(0, 0, 0, 0.8) 75%, #080a0c 95%);
  mask-size: 200% 100%;
  animation: placeholder-wave 2s linear infinite;
}

@media (prefers-reduced-motion: reduce) {
  .placeholder-wave {
    animation: none;
  }
}
@keyframes placeholder-wave {
  100% {
    mask-position: -200% 0%;
  }
}
.chip {
  --cui-chip-height: 1.75rem;
  --cui-chip-padding-x: 0.625rem;
  --cui-chip-gap: 0.3125rem;
  --cui-chip-font-size: 0.875rem;
  --cui-chip-font-weight: 400;
  --cui-chip-border-radius: var(--cui-border-radius-pill);
  --cui-chip-img-size: 1.25rem;
  --cui-chip-img-border-radius: 50%;
  --cui-chip-icon-size: 1rem;
  --cui-chip-remove-size: 1rem;
  --cui-chip-remove-opacity: 0.65;
  --cui-chip-remove-hover-opacity: 1;
  --cui-chip-transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out, color 0.15s ease-in-out;
  --cui-chip-color: var(--cui-text-emphasis, var(--cui-body-color));
  --cui-chip-bg: var(--cui-bg-subtle, var(--cui-secondary-bg));
  --cui-chip-border-width: var(--cui-border-width);
  --cui-chip-border-color: transparent;
  --cui-chip-active-color: var(--cui-contrast, rgba(255, 255, 255, 0.87));
  --cui-chip-active-bg: var(--cui-color, var(--cui-primary));
  --cui-chip-active-border-color: transparent;
  --cui-chip-hover-color: var(--cui-contrast, var(--cui-body-color));
  --cui-chip-hover-bg: var(--cui-color, color-mix(in srgb, var(--cui-secondary-bg) 95%, #000));
  --cui-chip-hover-border-color: transparent;
  display: inline-flex;
  gap: var(--cui-chip-gap);
  align-items: center;
  height: var(--cui-chip-height);
  padding-inline: var(--cui-chip-padding-x);
  font-size: var(--cui-chip-font-size);
  font-weight: var(--cui-chip-font-weight);
  color: var(--cui-chip-color);
  text-decoration: none;
  white-space: nowrap;
  vertical-align: middle;
  background-color: var(--cui-chip-bg);
  border: var(--cui-chip-border-width) solid var(--cui-chip-border-color);
  border-radius: var(--cui-chip-border-radius);
  transition: var(--cui-chip-transition);
}

@media (prefers-reduced-motion: reduce) {
  .chip {
    transition: none;
  }
}
.chip.active {
  color: var(--cui-chip-active-color);
  background-color: var(--cui-chip-active-bg);
  border-color: var(--cui-chip-active-border-color);
}

.chip.disabled, .chip:disabled {
  pointer-events: none;
  opacity: 0.65;
}

.chip:focus-visible {
  outline: 0;
  box-shadow: 0 0 var(--cui-focus-ring-blur) var(--cui-focus-ring-width) var(--cui-focus-ring-color);
}

.chip .avatar {
  --cui-avatar-width: var(--cui-chip-img-size);
  --cui-avatar-height: var(--cui-chip-img-size);
  font-size: inherit;
}

.chip .avatar:first-child {
  margin-inline-start: -0.375rem;
}

.chip-outline {
  --cui-chip-color: var(--cui-color, var(--cui-body-color));
  --cui-chip-bg: transparent;
  --cui-chip-border-color: var(--cui-color, var(--cui-border-color));
  --cui-chip-hover-bg: var(--cui-bg-subtle, color-mix(in srgb, var(--cui-secondary-bg) 95%, #000));
  --cui-chip-hover-color: var(--cui-text-emphasis, var(--cui-body-color));
  --cui-chip-hover-border-color: var(--cui-color, var(--cui-border-color));
  --cui-chip-active-bg: var(--cui-color, var(--cui-primary));
  --cui-chip-active-color: var(--cui-contrast, rgba(255, 255, 255, 0.87));
}

.chip-clickable {
  cursor: pointer;
}

.chip-clickable:hover {
  color: var(--cui-chip-hover-color);
  background-color: var(--cui-chip-hover-bg);
  border-color: var(--cui-chip-hover-border-color);
}

.chip-clickable.active:hover {
  color: var(--cui-chip-active-color);
  background-color: var(--cui-chip-active-bg);
  opacity: 0.9;
}

.chip-img {
  width: var(--cui-chip-img-size);
  height: var(--cui-chip-img-size);
  border-radius: var(--cui-chip-img-border-radius);
}

.chip-img:first-child {
  margin-inline-start: -0.375rem;
}

.chip-icon {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  margin-inline-start: calc(var(--cui-chip-gap) * -0.25);
}

.chip-icon > svg {
  display: block;
  width: var(--cui-chip-icon-size);
  height: var(--cui-chip-icon-size);
}

.chip-icon > img {
  width: var(--cui-chip-icon-size);
  height: var(--cui-chip-icon-size);
  object-fit: cover;
  border-radius: var(--cui-chip-img-border-radius);
}

.chip-check {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  margin-inline-start: calc(var(--cui-chip-gap) * -0.25);
}

.chip-check > svg {
  display: block;
  width: var(--cui-chip-icon-size);
  height: var(--cui-chip-icon-size);
}

.chip-remove {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  width: var(--cui-chip-min-height);
  height: var(--cui-chip-min-height);
  padding: 0;
  margin-inline-end: calc(var(--cui-chip-padding-x) * -0.25);
  color: inherit;
  cursor: pointer;
  background: transparent;
  border: 0;
  opacity: var(--cui-chip-remove-opacity);
  transition: opacity 0.15s ease-in-out;
}

@media (prefers-reduced-motion: reduce) {
  .chip-remove {
    transition: none;
  }
}
.chip-remove:hover {
  opacity: var(--cui-chip-remove-hover-opacity);
}

.chip-remove:focus-visible {
  outline: 0;
  opacity: 1;
  outline: 0;
  box-shadow: 0 0 var(--cui-focus-ring-blur) var(--cui-focus-ring-width) var(--cui-focus-ring-color);
}

.chip-remove > svg {
  display: block;
  width: var(--cui-chip-remove-size);
  height: var(--cui-chip-remove-size);
}

.chip-lg,
.chip-input-lg .chip {
  --cui-chip-height: 2rem;
  --cui-chip-padding-x: 0.75rem;
  --cui-chip-gap: 0.375rem;
  --cui-chip-font-size: 1rem;
  --cui-chip-img-size: 1.25rem;
  --cui-chip-icon-size: 1.5rem;
  --cui-chip-dismiss-size: 1.25rem;
}

.chip-sm,
.chip-input-sm .chip {
  --cui-chip-height: 1.5rem;
  --cui-chip-padding-x: 0.625rem;
  --cui-chip-gap: 0.25rem;
  --cui-chip-font-size: 0.75rem;
  --cui-chip-img-size: 0.875rem;
  --cui-chip-icon-size: 1rem;
  --cui-chip-dismiss-size: 0.875rem;
}

.chip-primary {
  --cui-bg-subtle: var(--cui-primary-bg-subtle);
  --cui-color: var(--cui-primary);
  --cui-color-rgb: var(--cui-primary-rgb);
  --cui-contrast: var(--cui-primary-contrast);
  --cui-text-emphasis: var(--cui-primary-text-emphasis);
  --cui-focus-ring-color: rgba(var(--cui-primary-rgb), var(--cui-focus-ring-opacity));
}

.chip-secondary {
  --cui-bg-subtle: var(--cui-secondary-bg-subtle);
  --cui-color: var(--cui-secondary);
  --cui-color-rgb: var(--cui-secondary-rgb);
  --cui-contrast: var(--cui-secondary-contrast);
  --cui-text-emphasis: var(--cui-secondary-text-emphasis);
  --cui-focus-ring-color: rgba(var(--cui-secondary-rgb), var(--cui-focus-ring-opacity));
}

.chip-success {
  --cui-bg-subtle: var(--cui-success-bg-subtle);
  --cui-color: var(--cui-success);
  --cui-color-rgb: var(--cui-success-rgb);
  --cui-contrast: var(--cui-success-contrast);
  --cui-text-emphasis: var(--cui-success-text-emphasis);
  --cui-focus-ring-color: rgba(var(--cui-success-rgb), var(--cui-focus-ring-opacity));
}

.chip-info {
  --cui-bg-subtle: var(--cui-info-bg-subtle);
  --cui-color: var(--cui-info);
  --cui-color-rgb: var(--cui-info-rgb);
  --cui-contrast: var(--cui-info-contrast);
  --cui-text-emphasis: var(--cui-info-text-emphasis);
  --cui-focus-ring-color: rgba(var(--cui-info-rgb), var(--cui-focus-ring-opacity));
}

.chip-warning {
  --cui-bg-subtle: var(--cui-warning-bg-subtle);
  --cui-color: var(--cui-warning);
  --cui-color-rgb: var(--cui-warning-rgb);
  --cui-contrast: var(--cui-warning-contrast);
  --cui-text-emphasis: var(--cui-warning-text-emphasis);
  --cui-focus-ring-color: rgba(var(--cui-warning-rgb), var(--cui-focus-ring-opacity));
}

.chip-danger {
  --cui-bg-subtle: var(--cui-danger-bg-subtle);
  --cui-color: var(--cui-danger);
  --cui-color-rgb: var(--cui-danger-rgb);
  --cui-contrast: var(--cui-danger-contrast);
  --cui-text-emphasis: var(--cui-danger-text-emphasis);
  --cui-focus-ring-color: rgba(var(--cui-danger-rgb), var(--cui-focus-ring-opacity));
}

.chip-light {
  --cui-bg-subtle: var(--cui-light-bg-subtle);
  --cui-color: var(--cui-light);
  --cui-color-rgb: var(--cui-light-rgb);
  --cui-contrast: var(--cui-light-contrast);
  --cui-text-emphasis: var(--cui-light-text-emphasis);
  --cui-focus-ring-color: rgba(var(--cui-light-rgb), var(--cui-focus-ring-opacity));
}

.chip-dark {
  --cui-bg-subtle: var(--cui-dark-bg-subtle);
  --cui-color: var(--cui-dark);
  --cui-color-rgb: var(--cui-dark-rgb);
  --cui-contrast: var(--cui-dark-contrast);
  --cui-text-emphasis: var(--cui-dark-text-emphasis);
  --cui-focus-ring-color: rgba(var(--cui-dark-rgb), var(--cui-focus-ring-opacity));
}

.chip-set {
  --cui-chip-set-gap: 0.25rem;
  display: flex;
  flex-wrap: wrap;
  gap: var(--cui-chip-set-gap);
}

.avatar {
  --cui-avatar-width: 2rem;
  --cui-avatar-height: 2rem;
  --cui-avatar-font-size: 0.8rem;
  --cui-avatar-border-radius: 50em;
  --cui-avatar-status-width: 0.5rem;
  --cui-avatar-status-height: 0.5rem;
  --cui-avatar-status-border-radius: 50em;
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: var(--cui-avatar-width);
  height: var(--cui-avatar-height);
  font-size: var(--cui-avatar-font-size);
  vertical-align: middle;
  border-radius: var(--cui-avatar-border-radius);
  transition: margin 0.15s;
}

@media (prefers-reduced-motion: reduce) {
  .avatar {
    transition: none;
  }
}
.avatar-img {
  width: 100%;
  height: auto;
  border-radius: var(--cui-avatar-border-radius);
}

.avatar-status {
  position: absolute;
  inset-inline-end: 0;
  bottom: 0;
  display: block;
  width: var(--cui-avatar-status-width);
  height: var(--cui-avatar-status-height);
  border: 1px solid #fff;
  border-radius: var(--cui-avatar-status-border-radius);
}

.avatar-sm {
  --cui-avatar-width: 1.5rem;
  --cui-avatar-height: 1.5rem;
  --cui-avatar-font-size: 0.6rem;
  --cui-avatar-status-width: 0.4rem;
  --cui-avatar-status-height: 0.4rem;
}

.avatar-md {
  --cui-avatar-width: 2.5rem;
  --cui-avatar-height: 2.5rem;
  --cui-avatar-font-size: 1rem;
  --cui-avatar-status-width: 0.7rem;
  --cui-avatar-status-height: 0.7rem;
}

.avatar-lg {
  --cui-avatar-width: 3rem;
  --cui-avatar-height: 3rem;
  --cui-avatar-font-size: 1.2rem;
  --cui-avatar-status-width: 0.8rem;
  --cui-avatar-status-height: 0.8rem;
}

.avatar-xl {
  --cui-avatar-width: 4rem;
  --cui-avatar-height: 4rem;
  --cui-avatar-font-size: 1.6rem;
  --cui-avatar-status-width: 1rem;
  --cui-avatar-status-height: 1rem;
}

.avatars-stack {
  display: flex;
}

.avatars-stack .avatar {
  margin-inline-end: calc(-0.4 * var(--cui-avatar-width));
}

.avatars-stack .avatar:last-child {
  margin-inline-end: 0;
}

.avatars-stack .avatar:hover {
  margin-inline-end: 0;
}

.callout {
  --cui-callout-padding-x: 1rem;
  --cui-callout-padding-y: 1rem;
  --cui-callout-margin-x: 0;
  --cui-callout-margin-y: 1rem;
  --cui-callout-border-width: var(--cui-border-width);
  --cui-callout-border-color: var(--cui-border-color);
  --cui-callout-border-left-width: calc(var(--cui-border-width) * 4);
  --cui-callout-border-radius: var(--cui-border-radius);
  padding: var(--cui-callout-padding-y) var(--cui-callout-padding-x);
  margin: var(--cui-callout-margin-y) var(--cui-callout-margin-x);
  border: var(--cui-callout-border-width) solid var(--cui-callout-border-color);
  border-inline-start-color: var(--cui-callout-border-left-color);
  border-inline-start-width: var(--cui-callout-border-left-width);
  border-radius: var(--cui-callout-border-radius);
}

.callout-primary {
  --cui-callout-border-left-color: #5856d6;
}

.callout-secondary {
  --cui-callout-border-left-color: #6b7785;
}

.callout-success {
  --cui-callout-border-left-color: #1b9e3e;
}

.callout-danger {
  --cui-callout-border-left-color: #e55353;
}

.callout-warning {
  --cui-callout-border-left-color: #f9b115;
}

.callout-info {
  --cui-callout-border-left-color: #39f;
}

.callout-light {
  --cui-callout-border-left-color: #f3f4f7;
}

.callout-dark {
  --cui-callout-border-left-color: #212631;
}

.footer {
  --cui-footer-min-height: 3rem;
  --cui-footer-padding-x: 1rem;
  --cui-footer-padding-y: 0.5rem;
  --cui-footer-color: var(--cui-body-color);
  --cui-footer-bg: var(--cui-tertiary-bg);
  --cui-footer-border-color: var(--cui-border-color);
  --cui-footer-border: var(--cui-border-width) solid var(--cui-footer-border-color);
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  min-height: var(--cui-footer-min-height);
  padding: var(--cui-footer-padding-y) var(--cui-footer-padding-x);
  color: var(--cui-footer-color);
  background: var(--cui-footer-bg);
  border-top: var(--cui-footer-border);
}

.footer-fixed {
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1030;
}

.footer-sticky {
  position: sticky;
  bottom: 0;
  z-index: 1030;
}

.header {
  --cui-header-padding-x: 0.5rem;
  --cui-header-padding-y: 0.5rem;
  --cui-header-bg: var(--cui-body-bg);
  --cui-header-color: rgba(var(--cui-emphasis-color-rgb), 0.65);
  --cui-header-border-color: var(--cui-border-color);
  --cui-header-border: var(--cui-border-width) solid var(--cui-header-border-color);
  --cui-header-hover-color: rgba(var(--cui-emphasis-color-rgb), 0.8);
  --cui-header-disabled-color: rgba(var(--cui-emphasis-color-rgb), 0.3);
  --cui-header-active-color: rgba(var(--cui-emphasis-color-rgb), 1);
  --cui-header-transition: box-shadow 0.15s ease-in-out;
  --cui-header-brand-padding-y: 0.3125rem;
  --cui-header-brand-color: #212631;
  --cui-header-brand-hover-color: rgb(11.6470588235%, 13.4117647059%, 17.2941176471%);
  --cui-header-toggler-padding-x: 0.75rem;
  --cui-header-toggler-padding-y: 0.25rem;
  --cui-header-toggler-bg: transparent;
  --cui-header-toggler-color: rgba(var(--cui-emphasis-color-rgb), 0.65);
  --cui-header-toggler-border-radius: var(--cui-border-radius);
  --cui-header-toggler-hover-color: rgba(var(--cui-emphasis-color-rgb), 1);
  --cui-header-toggler-icon-bg: url(${___CSS_LOADER_URL_REPLACEMENT_16___});
  --cui-header-toggler-hover-icon-bg: url(${___CSS_LOADER_URL_REPLACEMENT_17___});
  --cui-header-nav-link-padding-x: 0.5rem;
  --cui-header-nav-link-padding-y: 0.5rem;
  --cui-header-divider-border-color: var(--cui-border-color);
  --cui-header-divider-border: var(--cui-border-width) solid var(--cui-header-divider-border-color);
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  padding: var(--cui-header-padding-y) var(--cui-header-padding-x);
  background: var(--cui-header-bg);
  border-bottom: var(--cui-header-border);
  transition: var(--cui-header-transition);
}

@media (prefers-reduced-motion: reduce) {
  .header {
    transition: none;
  }
}
.header > .container-xxl, .header > .container-xl, .header > .container-lg, .header > .container-md, .header > .container-sm, .header > .container,
.header > .container-fluid {
  display: flex;
  flex-wrap: inherit;
  align-items: center;
  justify-content: space-between;
}

.header.header-sticky {
  position: sticky;
  top: 0;
  z-index: 1020;
}

.header-divider {
  flex-basis: calc(100% + 2 * var(--cui-header-padding-x));
  height: 0;
  margin: var(--cui-header-padding-y) calc(-1 * var(--cui-header-padding-x));
  border-top: var(--cui-header-divider-border);
}

.header-brand {
  padding-top: var(--cui-header-brand-padding-y);
  padding-bottom: var(--cui-header-brand-padding-y);
  margin-inline-end: 1rem;
  font-size: 1.25rem;
  color: var(--cui-header-brand-color);
  text-decoration: none;
  white-space: nowrap;
}

.header-brand:hover, .header-brand:focus {
  color: var(--cui-header-brand-hover-color);
}

.header-nav {
  display: flex;
  flex-direction: row;
  padding-inline-start: 0;
  margin-bottom: 0;
  list-style: none;
}

.header-nav .nav-link {
  padding: var(--cui-header-nav-link-padding-y) var(--cui-header-nav-link-padding-x);
  color: var(--cui-header-color);
}

.header-nav .nav-link:hover, .header-nav .nav-link:focus {
  color: var(--cui-header-hover-color);
}

.header-nav .nav-link.disabled {
  color: var(--cui-header-disabled-color);
}

.header-nav .show > .nav-link,
.header-nav .nav-link.active {
  color: var(--cui-header-active-color);
}

.header-nav .dropdown-menu {
  position: absolute;
}

.header-text {
  padding-top: var(--cui-header-nav-link-padding-y);
  padding-bottom: var(--cui-header-nav-link-padding-y);
  color: var(--cui-header-color);
}

.header-text a {
  color: var(--cui-header-active-color);
}

.header-text a:hover, .header-text a:focus {
  color: var(--cui-header-active-color);
}

.header-toggler {
  padding: var(--cui-header-toggler-padding-y) var(--cui-header-toggler-padding-x);
  font-size: 1.25rem;
  color: var(--cui-header-toggler-color);
  background-color: var(--cui-header-toggler-bg);
  border: 0;
  border-radius: var(--cui-header-toggler-border-radius);
}

.header-toggler:hover {
  color: var(--cui-header-toggler-hover-color);
  text-decoration: none;
}

.header-toggler:focus {
  outline: 0;
}

.header-toggler:not(:disabled) {
  cursor: pointer;
}

.header-toggler-icon {
  display: block;
  height: 1.5625rem;
  background-image: var(--cui-header-toggler-icon-bg);
  background-repeat: no-repeat;
  background-position: center center;
  background-size: 100% 100%;
}

.header-toggler-icon:hover {
  background-image: var(--cui-header-toggler-hover-icon-bg);
}

.icon {
  display: inline-block;
  color: inherit;
  text-align: center;
  vertical-align: -0.125rem;
  fill: currentcolor;
}

.icon:not(.icon-c-s):not(.icon-custom-size) {
  width: 1rem;
  height: 1rem;
  font-size: 1rem;
}

.icon:not(.icon-c-s):not(.icon-custom-size).icon-xxl {
  width: 2rem;
  height: 2rem;
  font-size: 2rem;
}

.icon:not(.icon-c-s):not(.icon-custom-size).icon-xl {
  width: 1.5rem;
  height: 1.5rem;
  font-size: 1.5rem;
}

.icon:not(.icon-c-s):not(.icon-custom-size).icon-lg {
  width: 1.25rem;
  height: 1.25rem;
  font-size: 1.25rem;
}

.icon:not(.icon-c-s):not(.icon-custom-size).icon-sm {
  width: 0.875rem;
  height: 0.875rem;
  font-size: 0.875rem;
}

.icon:not(.icon-c-s):not(.icon-custom-size).icon-3xl {
  width: 3rem;
  height: 3rem;
  font-size: 3rem;
}

.icon:not(.icon-c-s):not(.icon-custom-size).icon-4xl {
  width: 4rem;
  height: 4rem;
  font-size: 4rem;
}

.icon:not(.icon-c-s):not(.icon-custom-size).icon-5xl {
  width: 5rem;
  height: 5rem;
  font-size: 5rem;
}

.icon:not(.icon-c-s):not(.icon-custom-size).icon-6xl {
  width: 6rem;
  height: 6rem;
  font-size: 6rem;
}

.icon:not(.icon-c-s):not(.icon-custom-size).icon-7xl {
  width: 7rem;
  height: 7rem;
  font-size: 7rem;
}

.icon:not(.icon-c-s):not(.icon-custom-size).icon-8xl {
  width: 8rem;
  height: 8rem;
  font-size: 8rem;
}

.icon:not(.icon-c-s):not(.icon-custom-size).icon-9xl {
  width: 9rem;
  height: 9rem;
  font-size: 9rem;
}

.search-button {
  --cui-search-button-height: calc(1.5em + 0.75rem + calc(var(--cui-border-width) * 2));
  --cui-search-button-padding-x: 0.75rem;
  --cui-search-button-font-family: ;
  --cui-search-button-font-size: 1rem;
  --cui-search-button-font-weight: 400;
  --cui-search-button-color: var(--cui-secondary-color);
  --cui-search-button-bg: var(--cui-body-bg);
  --cui-search-button-border-width: var(--cui-border-width);
  --cui-search-button-border-color: var(--cui-border-color);
  --cui-search-button-border-radius: var(--cui-border-radius);
  --cui-search-button-box-shadow: var(--cui-box-shadow-inset);
  --cui-search-button-transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  --cui-search-button-focus-color: var(--cui-body-color);
  --cui-search-button-focus-bg: var(--cui-body-bg);
  --cui-search-button-focus-border-color: rgb(67.2549019608%, 66.862745098%, 91.9607843137%);
  --cui-search-button-focus-box-shadow: 0 0 0 0.25rem rgba(88, 86, 214, 0.25);
  --cui-search-button-icon-size: 1.125rem;
  --cui-search-button-keys-gap: 0.25rem;
  --cui-search-button-key-width: 1.5rem;
  --cui-search-button-key-height: 1.5rem;
  --cui-search-button-key-padding-inline: 0.25rem;
  --cui-search-button-key-font-size: 0.75rem;
  --cui-search-button-key-bg: var(--cui-tertiary-bg);
  --cui-search-button-key-border-radius: var(--cui-border-radius-sm);
  --cui-search-button-key-active-bg: var(--cui-secondary-bg);
  --cui-search-button-placeholder-margin-inline: 0.55rem 2rem;
  display: flex;
  align-items: center;
  height: var(--cui-search-button-height);
  padding-inline: var(--cui-search-button-padding-x);
  font-family: var(--cui-search-button-font-family);
  font-size: var(--cui-search-button-font-size);
  font-weight: var(--cui-search-button-font-weight);
  color: var(--cui-search-button-color);
  background-color: var(--cui-search-button-bg);
  border: var(--cui-search-button-border-width) solid var(--cui-search-button-border-color);
  border-radius: var(--cui-search-button-border-radius);
  transition: var(--cui-search-button-transition);
}

@media (prefers-reduced-motion: reduce) {
  .search-button {
    transition: none;
  }
}
.search-button:focus {
  color: var(--cui-search-button-focus-color);
  background-color: var(--cui-search-button-focus-bg);
  border-color: var(--cui-search-button-focus-border-color);
  outline: 0;
  box-shadow: var(--cui-search-button-focus-box-shadow);
}

.search-button-icon {
  width: var(--cui-search-button-icon-size);
  height: var(--cui-search-button-icon-size);
}

.search-button-keys {
  display: inline-flex;
  gap: var(--cui-search-button-keys-gap);
  margin-inline-start: auto;
}

.search-button-key {
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: var(--cui-search-button-key-width);
  height: var(--cui-search-button-key-height);
  padding-inline: var(--cui-search-button-key-padding-inline);
  font-size: var(--cui-search-button-key-font-size);
  background-color: var(--cui-search-button-key-bg);
  border-radius: var(--cui-search-button-key-border-radius);
}

.search-button-key.active {
  background-color: var(--cui-search-button-key-active-bg);
}

.search-button-placeholder {
  margin-inline: var(--cui-search-button-placeholder-margin-inline);
}

.sidebar {
  --cui-sidebar-zindex: 1035;
  --cui-sidebar-width: 16rem;
  --cui-sidebar-bg: var(--cui-body-bg);
  --cui-sidebar-padding-x: 1rem;
  --cui-sidebar-padding-y: 1rem;
  --cui-sidebar-color: var(--cui-body-color);
  --cui-sidebar-brand-color: var(--cui-body-color);
  --cui-sidebar-brand-bg: rgba(8, 10, 12, 0.2);
  --cui-sidebar-toggler-height: 0.5rem;
  position: relative;
  display: flex;
  flex: 0 0 var(--cui-sidebar-width);
  flex-direction: column;
  order: -1;
  width: var(--cui-sidebar-width);
  color: var(--cui-sidebar-color);
  background: var(--cui-sidebar-bg);
  box-shadow: none;
  transition: margin-left 0.15s, margin-right 0.15s, box-shadow 0.075s, transform 0.15s, width 0.15s, z-index 0s ease 0.15s;
}

@media (prefers-reduced-motion: reduce) {
  .sidebar {
    transition: none;
  }
}
.sidebar:not(.sidebar-end) {
  margin-inline-start: 0;
}

.sidebar.sidebar-end {
  order: 99;
  margin-inline-end: 0;
}

@media (min-width: 992px) {
  .sidebar:not(.hide):not(.sidebar-narrow):not(.sidebar-narrow-unfoldable:not(:hover)):not(.sidebar-narrow-unfoldable):not(.sidebar-overlaid):not(.sidebar-end) ~ * {
    --cui-sidebar-occupy-start: 16rem;
  }
  .sidebar:not(.hide):not(.sidebar-narrow):not(.sidebar-narrow-unfoldable:not(:hover)):not(.sidebar-narrow-unfoldable):not(.sidebar-overlaid).sidebar-end ~ * {
    --cui-sidebar-occupy-end: 16rem;
  }
  .sidebar.hide:not(.sidebar-end) {
    margin-inline-start: calc(-1 * var(--cui-sidebar-width));
  }
  .sidebar.hide.sidebar-end {
    margin-inline-end: calc(-1 * var(--cui-sidebar-width));
  }
}
@media (max-width: 991.98px) {
  .sidebar {
    --cui-is-mobile: true;
    position: fixed;
    top: 0;
    bottom: 0;
    z-index: var(--cui-sidebar-zindex);
  }
  .sidebar:not(.sidebar-end) {
    inset-inline-start: 0;
  }
  .sidebar:not(.sidebar-end):not(.show) {
    margin-inline-start: calc(-1 * var(--cui-sidebar-width));
  }
  .sidebar.sidebar-end {
    inset-inline-end: 0;
  }
  .sidebar.sidebar-end:not(.show) {
    margin-inline-end: calc(-1 * var(--cui-sidebar-width));
  }
}
.sidebar-fixed, .sidebar-narrow-unfoldable, .sidebar-overlaid {
  position: fixed;
  top: 0;
  bottom: 0;
  z-index: var(--cui-sidebar-zindex);
}

.sidebar-fixed:not(.sidebar-end), .sidebar-narrow-unfoldable:not(.sidebar-end), .sidebar-overlaid:not(.sidebar-end) {
  inset-inline-start: 0;
}

.sidebar-fixed.sidebar-end, .sidebar-end.sidebar-narrow-unfoldable, .sidebar-end.sidebar-overlaid {
  inset-inline-end: 0;
}

.sidebar-overlaid {
  --cui-sidebar-overlaid-box-shadow: var(--cui-box-shadow);
}

.sidebar-overlaid:not(.sidebar-end) {
  margin-inline-start: calc(-1 * var(--cui-sidebar-width));
}

.sidebar-overlaid.sidebar-end {
  margin-inline-end: calc(-1 * var(--cui-sidebar-width));
}

.sidebar-overlaid.show {
  box-shadow: var(--cui-sidebar-overlaid-box-shadow);
}

.sidebar-overlaid.show:not(.sidebar-end) {
  margin-inline-start: 0;
}

.sidebar-overlaid.show.sidebar-end {
  margin-inline-end: 0;
}

.sidebar-sm {
  --cui-sidebar-width: 12rem;
}

@media (min-width: 992px) {
  .sidebar-sm:not(.hide):not(.sidebar-narrow):not(.sidebar-narrow-unfoldable:not(:hover)):not(.sidebar-narrow-unfoldable):not(.sidebar-overlaid):not(.sidebar-end) ~ * {
    --cui-sidebar-occupy-start: 12rem;
  }
  .sidebar-sm:not(.hide):not(.sidebar-narrow):not(.sidebar-narrow-unfoldable:not(:hover)):not(.sidebar-narrow-unfoldable):not(.sidebar-overlaid).sidebar-end ~ * {
    --cui-sidebar-occupy-end: 12rem;
  }
}
.sidebar-lg {
  --cui-sidebar-width: 20rem;
}

@media (min-width: 992px) {
  .sidebar-lg:not(.hide):not(.sidebar-narrow):not(.sidebar-narrow-unfoldable:not(:hover)):not(.sidebar-narrow-unfoldable):not(.sidebar-overlaid):not(.sidebar-end) ~ * {
    --cui-sidebar-occupy-start: 20rem;
  }
  .sidebar-lg:not(.hide):not(.sidebar-narrow):not(.sidebar-narrow-unfoldable:not(:hover)):not(.sidebar-narrow-unfoldable):not(.sidebar-overlaid).sidebar-end ~ * {
    --cui-sidebar-occupy-end: 20rem;
  }
}
.sidebar-xl {
  --cui-sidebar-width: 24rem;
}

@media (min-width: 992px) {
  .sidebar-xl:not(.hide):not(.sidebar-narrow):not(.sidebar-narrow-unfoldable:not(:hover)):not(.sidebar-narrow-unfoldable):not(.sidebar-overlaid):not(.sidebar-end) ~ * {
    --cui-sidebar-occupy-start: 24rem;
  }
  .sidebar-xl:not(.hide):not(.sidebar-narrow):not(.sidebar-narrow-unfoldable:not(:hover)):not(.sidebar-narrow-unfoldable):not(.sidebar-overlaid).sidebar-end ~ * {
    --cui-sidebar-occupy-end: 24rem;
  }
}
.sidebar-brand {
  color: var(--cui-sidebar-brand-color);
  white-space: nowrap;
}

.sidebar-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: var(--cui-sidebar-padding-y) var(--cui-sidebar-padding-x);
}

.sidebar-header .btn-close {
  padding: calc(var(--cui-sidebar-padding-y) * 0.5) calc(var(--cui-sidebar-padding-x) * 0.5);
  margin-inline-end: calc(-0.5 * var(--cui-sidebar-padding-x));
  margin-top: calc(-0.5 * var(--cui-sidebar-padding-y));
  margin-bottom: calc(-0.5 * var(--cui-sidebar-padding-y));
}

.sidebar-body {
  padding: var(--cui-sidebar-padding-y) var(--cui-sidebar-padding-x);
}

.sidebar-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: var(--cui-sidebar-padding-y) var(--cui-sidebar-padding-x);
}

.sidebar-toggler {
  --cui-sidebar-toggler-width: 0.5rem;
  --cui-sidebar-toggler-bg: transparent;
  --cui-sidebar-toggler-color: var(--cui-tertiary-color);
  --cui-sidebar-toggler-icon: url(${___CSS_LOADER_URL_REPLACEMENT_18___});
  --cui-sidebar-toggler-hover-color: var(--cui-secondary-color);
  --cui-sidebar-toggler-focus-shadow: 0 0 0 0.25rem rgba(88, 86, 214, 0.25);
  --cui-sidebar-toggler-focus-color: var(--cui-secondary-color);
  --cui-sidebar-toggler-transition: transform 0.15s;
  position: relative;
  box-sizing: content-box;
  width: var(--cui-sidebar-toggler-width);
  height: var(--cui-sidebar-toggler-height);
  padding: 0.25rem 0.25rem;
  background-color: var(--cui-sidebar-toggler-bg);
  border: 0;
  border-radius: 0.375rem;
}

.sidebar-toggler::before {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  content: "";
  background-color: var(--cui-sidebar-toggler-color);
  mask: var(--cui-sidebar-toggler-icon) no-repeat center;
  transition: var(--cui-sidebar-toggler-transition);
}

@media (prefers-reduced-motion: reduce) {
  .sidebar-toggler::before {
    transition: none;
  }
}
.sidebar-toggler:hover {
  text-decoration: none;
}

.sidebar-toggler:hover::before {
  background-color: var(--cui-sidebar-toggler-hover-color);
}

.sidebar-toggler:focus {
  outline: 0;
  box-shadow: var(--cui-sidebar-toggler-focus-shadow);
}

.sidebar-toggler:focus::before {
  background-color: var(--cui-sidebar-toggler-focus-color);
}

@media (max-width: 991.98px) {
  .sidebar-toggler {
    display: none;
  }
}
.sidebar-backdrop {
  --cui-backdrop-zindex: 1034;
  --cui-backdrop-bg: #080a0c;
  --cui-backdrop-opacity: 0.5;
}

@media (max-width: 991.98px) {
  .sidebar-backdrop {
    position: fixed;
    top: 0;
    left: 0;
    z-index: var(--cui-backdrop-zindex);
    width: 100vw;
    height: 100vh;
    background-color: var(--cui-backdrop-bg);
  }
  .sidebar-backdrop.fade {
    opacity: 0;
  }
  .sidebar-backdrop.show {
    opacity: var(--cui-backdrop-opacity);
  }
}
.sidebar-dark {
  --cui-body-color: rgba(255, 255, 255, 0.87);
  --cui-body-bg: #212631;
  --cui-emphasis-color: #fff;
  --cui-secondary-color: rgba(255, 255, 255, 0.6);
  --cui-secondary-bg: #323a49;
  --cui-tertiary-color: rgba(255, 255, 255, 0.38);
  --cui-tertiary-bg: rgb(16.2745098039%, 18.8235294118%, 23.9215686275%);
  --cui-border-color: #323a49;
}

.sidebar-nav {
  --cui-sidebar-nav-padding-x: 0.5rem;
  --cui-sidebar-nav-padding-y: 0.5rem;
  --cui-sidebar-nav-gap: 1px;
  --cui-sidebar-nav-title-padding-x: 1rem;
  --cui-sidebar-nav-title-padding-y: 0.75rem;
  --cui-sidebar-nav-title-margin-top: 1rem;
  --cui-sidebar-nav-title-color: var(--cui-tertiary-color);
  --cui-sidebar-nav-link-padding-x: 1rem;
  --cui-sidebar-nav-link-padding-y: 0.75rem;
  --cui-sidebar-nav-link-color: var(--cui-body-color);
  --cui-sidebar-nav-link-bg: transparent;
  --cui-sidebar-nav-link-border-color: transparent;
  --cui-sidebar-nav-link-border-radius: var(--cui-border-radius);
  --cui-sidebar-nav-link-border-width: 0;
  --cui-sidebar-nav-link-active-color: var(--cui-emphasis-color);
  --cui-sidebar-nav-link-active-bg: var(--cui-tertiary-bg-translucent);
  --cui-sidebar-nav-link-disabled-color: var(--cui-tertiary-color);
  --cui-sidebar-nav-link-hover-color: var(--cui-emphasis-color);
  --cui-sidebar-nav-link-hover-bg: var(--cui-tertiary-bg-translucent);
  --cui-sidebar-nav-link-icon-margin: 0.75rem;
  --cui-sidebar-nav-link-icon-color: var(--cui-tertiary-color);
  --cui-sidebar-nav-link-icon-width: 1.25rem;
  --cui-sidebar-nav-link-icon-height: 1.25rem;
  --cui-sidebar-nav-link-icon-font-size: 1.25rem;
  --cui-sidebar-nav-link-active-icon-color: var(--cui-emphasis-color);
  --cui-sidebar-nav-link-disabled-icon-color: var(--cui-tertiary-color);
  --cui-sidebar-nav-link-hover-icon-color: var(--cui-body-color);
  --cui-sidebar-nav-link-icon-bullet-size: 0.3125rem;
  --cui-sidebar-nav-link-icon-bullet-bg: transparent;
  --cui-sidebar-nav-link-icon-bullet-border-width: 1px;
  --cui-sidebar-nav-link-icon-bullet-border-radius: 50rem;
  --cui-sidebar-nav-link-icon-bullet-border-color: var(--cui-tertiary-color);
  --cui-sidebar-nav-link-active-icon-bullet-bg: transparent;
  --cui-sidebar-nav-link-active-icon-bullet-border-color: var(--cui-emphasis-color);
  --cui-sidebar-nav-link-disabled-icon-bullet-bg: transparent;
  --cui-sidebar-nav-link-disabled-icon-bullet-border-color: var(--cui-tertiary-color);
  --cui-sidebar-nav-link-hover-icon-bullet-bg: transparent;
  --cui-sidebar-nav-link-hover-icon-bullet-border-color: var(--cui-body-color);
  --cui-sidebar-nav-group-bg: transparent;
  --cui-sidebar-nav-group-border-width: 0;
  --cui-sidebar-nav-group-border-radius: var(--cui-border-radius);
  --cui-sidebar-nav-group-border-color: transparent;
  --cui-sidebar-nav-group-items-padding-y: 0;
  --cui-sidebar-nav-group-items-padding-x: 0;
  --cui-sidebar-nav-group-indicator-color: var(--cui-tertiary-color);
  --cui-sidebar-nav-group-indicator-icon: url(${___CSS_LOADER_URL_REPLACEMENT_19___});
  --cui-sidebar-nav-group-indicator-hover-color: var(--cui-emphasis-color);
  --cui-sidebar-nav-group-indicator-hover-icon: url(${___CSS_LOADER_URL_REPLACEMENT_19___});
  --cui-sidebar-nav-group-toggle-show-color: var(--cui-body-color);
  position: relative;
  display: flex;
  flex: 1 1;
  flex-direction: column;
  padding: var(--cui-sidebar-nav-padding-y) var(--cui-sidebar-nav-padding-x);
  margin-bottom: 0;
  overflow-x: hidden;
  overflow-y: auto;
  list-style: none;
}

.sidebar-nav .nav-item + .nav-item,
.sidebar-nav .nav-item + .nav-group,
.sidebar-nav .nav-group + .nav-item,
.sidebar-nav .nav-group + .nav-group,
.sidebar-nav .nav-group-items {
  margin-top: var(--cui-sidebar-nav-gap);
}

.sidebar-nav .nav-title {
  padding: var(--cui-sidebar-nav-title-padding-y) var(--cui-sidebar-nav-title-padding-x);
  margin-top: var(--cui-sidebar-nav-title-margin-top);
  font-size: 80%;
  font-weight: 700;
  color: var(--cui-sidebar-nav-title-color);
  text-transform: uppercase;
  transition: height 0.15s, margin 0.15s;
}

@media (prefers-reduced-motion: reduce) {
  .sidebar-nav .nav-title {
    transition: none;
  }
}
.sidebar-nav .nav-link {
  display: flex;
  flex: 1 1;
  align-items: center;
  padding: var(--cui-sidebar-nav-link-padding-y) var(--cui-sidebar-nav-link-padding-x);
  color: var(--cui-sidebar-nav-link-color);
  text-decoration: none;
  white-space: nowrap;
  background: var(--cui-sidebar-nav-link-bg);
  border: var(--cui-sidebar-nav-link-border-width) solid var(--cui-sidebar-nav-link-border-color);
  border-radius: var(--cui-sidebar-nav-link-border-radius);
  transition: background 0.15s ease, color 0.15s ease, gap 0.15s ease;
}

@media (prefers-reduced-motion: reduce) {
  .sidebar-nav .nav-link {
    transition: none;
  }
}
.sidebar-nav .nav-link.active {
  color: var(--cui-sidebar-nav-link-active-color);
  background: var(--cui-sidebar-nav-link-active-bg);
}

.sidebar-nav .nav-link.active .nav-icon {
  color: var(--cui-sidebar-nav-link-active-icon-color);
}

.sidebar-nav .nav-link.active .nav-icon-bullet {
  background: var(--cui-sidebar-nav-link-active-icon-bullet-bg);
  border-color: var(--cui-sidebar-nav-link-active-icon-bullet-border-color);
}

.sidebar-nav .nav-link.disabled {
  color: var(--cui-sidebar-nav-link-disabled-color);
  pointer-events: none;
  cursor: not-allowed;
  background: transparent;
}

.sidebar-nav .nav-link.disabled .nav-icon {
  color: var(--cui-sidebar-nav-link-disabled-icon-color);
}

.sidebar-nav .nav-link.disabled .nav-icon-bullet {
  background: var(--cui-sidebar-nav-link-disabled-icon-bullet-bg);
  border-color: var(--cui-sidebar-nav-link-disabled-icon-bullet-border-color);
}

@media (hover: hover), (-ms-high-contrast: none) {
  .sidebar-nav .nav-link:hover {
    color: var(--cui-sidebar-nav-link-hover-color);
    text-decoration: none;
    background: var(--cui-sidebar-nav-link-hover-bg);
  }
  .sidebar-nav .nav-link:hover .nav-icon {
    color: var(--cui-sidebar-nav-link-hover-icon-color);
  }
  .sidebar-nav .nav-link:hover .nav-icon-bullet {
    background: var(--cui-sidebar-nav-link-hover-icon-bullet-bg);
    border-color: var(--cui-sidebar-nav-link-hover-icon-bullet-border-color);
  }
}
.sidebar-nav .nav-icon {
  display: flex;
  flex: 0 0 var(--cui-sidebar-nav-link-icon-width);
  align-items: center;
  justify-content: center;
  height: var(--cui-sidebar-nav-link-icon-height);
  margin-inline-end: var(--cui-sidebar-nav-link-icon-margin);
  font-size: var(--cui-sidebar-nav-link-icon-font-size);
  color: var(--cui-sidebar-nav-link-icon-color);
  text-align: center;
  pointer-events: none;
  fill: currentcolor;
  transition: inherit;
}

@media (prefers-reduced-motion: reduce) {
  .sidebar-nav .nav-icon {
    transition: none;
  }
}
.sidebar-nav .nav-icon-bullet {
  display: inline-block;
  width: var(--cui-sidebar-nav-link-icon-bullet-size);
  height: var(--cui-sidebar-nav-link-icon-bullet-size);
  background: var(--cui-sidebar-nav-link-icon-bullet-bg);
  border: var(--cui-sidebar-nav-link-icon-bullet-border-width) solid var(--cui-sidebar-nav-link-icon-bullet-border-color);
  border-radius: var(--cui-sidebar-nav-link-icon-bullet-border-radius);
}

.sidebar-nav svg.nav-icon {
  overflow: hidden;
}

.sidebar-nav .nav-group {
  border: var(--cui-sidebar-nav-group-border-width) solid var(--cui-sidebar-nav-group-border-color);
  border-radius: var(--cui-sidebar-nav-group-border-radius);
  transition: background 0.15s ease-in-out;
}

@media (prefers-reduced-motion: reduce) {
  .sidebar-nav .nav-group {
    transition: none;
  }
}
.sidebar-nav .nav-group:not(.show) .nav-group-items,
.sidebar-nav .nav-group:not(.show) .nav-group-toggle-indicator .show {
  display: none;
}

.sidebar-nav .nav-group.show {
  background: var(--cui-sidebar-nav-group-bg);
}

.sidebar-nav .nav-group.show .nav-group-toggle {
  color: var(--cui-sidebar-nav-group-toggle-show-color);
}

.sidebar-nav .nav-group.show > .nav-group-toggle:not(:has(.nav-group-toggle-indicator))::after {
  transform: rotate(180deg);
}

.sidebar-nav .nav-group.show > .nav-group-toggle .nav-group-toggle-indicator .hide {
  display: none;
}

.sidebar-nav .nav-group-toggle {
  cursor: pointer;
}

.sidebar-nav .nav-group-toggle:not(:has(.nav-group-toggle-indicator))::after {
  display: block;
  flex: 0 1 12px;
  height: 12px;
  margin-inline-start: auto;
  content: "";
  background-color: var(--cui-sidebar-nav-group-indicator-color);
  mask-image: var(--cui-sidebar-nav-group-indicator-icon);
  transition: transform 0.15s;
}

@media (prefers-reduced-motion: reduce) {
  .sidebar-nav .nav-group-toggle:not(:has(.nav-group-toggle-indicator))::after {
    transition: none;
  }
}
@media (hover: hover), (-ms-high-contrast: none) {
  .sidebar-nav .nav-group-toggle:hover:not(:has(.nav-group-toggle-indicator))::after {
    background-color: var(--cui-sidebar-nav-group-indicator-hover-color);
    mask-image: var(--cui-sidebar-nav-group-indicator-hover-icon);
  }
}
.sidebar-nav .nav-group-toggle-indicator {
  margin-inline-start: auto;
  color: var(--cui-sidebar-nav-group-indicator-color);
}

.sidebar-nav .nav-group-items {
  padding: var(--cui-sidebar-nav-group-items-padding-y) var(--cui-sidebar-nav-group-items-padding-x);
  overflow: hidden;
  list-style: none;
  transition: height 0.15s ease;
}

@media (prefers-reduced-motion: reduce) {
  .sidebar-nav .nav-group-items {
    transition: none;
  }
}
.sidebar-nav .nav-group-items .nav-link {
  padding-inline-start: calc(var(--cui-sidebar-nav-link-padding-x) + var(--cui-sidebar-nav-link-icon-width) + var(--cui-sidebar-nav-link-icon-margin));
}

.sidebar-nav .nav-group-items .nav-icon {
  margin-inline-start: calc(-1 * (var(--cui-sidebar-nav-link-icon-width) + var(--cui-sidebar-nav-link-icon-margin)));
}

.sidebar-nav.compact .nav-link,
.sidebar-nav .compact .nav-link {
  --cui-sidebar-nav-link-padding-y: 0.5625rem;
}

.sidebar-nav.sidebar-nav-tree {
  --cui-sidebar-nav-tree-group-border-color: var(--cui-border-color);
  --cui-sidebar-nav-link-icon-bullet-bg: var(--cui-border-color);
  --cui-sidebar-nav-link-hover-icon-bullet-bg: var(--cui-border-color);
  --cui-sidebar-nav-link-active-icon-bullet-bg: var(--cui-border-color);
}

.sidebar-nav.sidebar-nav-tree .nav-group .nav-group-items {
  position: relative;
  z-index: 0;
  padding-inline-start: calc((var(--cui-sidebar-nav-link-padding-x) + var(--cui-sidebar-nav-link-icon-width) + var(--cui-sidebar-nav-link-icon-margin)) / 2);
}

.sidebar-nav.sidebar-nav-tree .nav-group .nav-group-items::before {
  position: absolute;
  inset-inline-start: calc((var(--cui-sidebar-nav-link-padding-x) + var(--cui-sidebar-nav-link-icon-width) + var(--cui-sidebar-nav-link-icon-margin)) / 2 + 1.5px);
  top: 0;
  z-index: -1;
  height: 100%;
  content: "";
  border-inline-start: 1px solid var(--cui-sidebar-nav-tree-group-border-color);
}

.sidebar-nav.sidebar-nav-tree .nav-group .nav-group-items .nav-link {
  margin-inline-start: calc(-1 * (var(--cui-sidebar-nav-link-padding-x) + var(--cui-sidebar-nav-link-icon-width) + var(--cui-sidebar-nav-link-icon-margin)) / 2);
}

.sidebar-narrow, .sidebar-narrow-unfoldable:not(:hover) {
  --cui-sidebar-narrow-width: 4rem;
  --cui-sidebar-padding-x: 0.5rem;
}

@media (min-width: 992px) {
  .sidebar-narrow, .sidebar-narrow-unfoldable:not(:hover) {
    flex: 0 0 var(--cui-sidebar-narrow-width);
    width: var(--cui-sidebar-narrow-width);
    padding-bottom: var(--cui-sidebar-toggler-height);
    overflow: visible;
  }
  .sidebar-narrow .sidebar-header, .sidebar-narrow-unfoldable:not(:hover) .sidebar-header {
    justify-content: center;
    padding-inline: 0;
  }
  .sidebar-narrow .sidebar-nav, .sidebar-narrow-unfoldable:not(:hover) .sidebar-nav {
    --cui-sidebar-nav-link-padding-x: 0.5rem;
    --cui-sidebar-nav-link-padding-y: 0.75rem;
  }
  .sidebar-narrow .nav-link, .sidebar-narrow-unfoldable:not(:hover) .nav-link {
    overflow: hidden;
  }
  .sidebar-narrow .nav-icon, .sidebar-narrow-unfoldable:not(:hover) .nav-icon {
    flex: 0 0 calc(var(--cui-sidebar-narrow-width) - var(--cui-sidebar-nav-padding-x) * 2 - var(--cui-sidebar-nav-link-padding-x) * 2);
  }
  .sidebar-narrow .nav-label, .sidebar-narrow-unfoldable:not(:hover) .nav-label,
  .sidebar-narrow .nav-title,
  .sidebar-narrow-unfoldable:not(:hover) .nav-title,
  .sidebar-narrow .nav-group-items,
  .sidebar-narrow-unfoldable:not(:hover) .nav-group-items,
  .sidebar-narrow .sidebar-form,
  .sidebar-narrow-unfoldable:not(:hover) .sidebar-form {
    height: 0 !important;
    padding: 0 !important;
    margin: 0 !important;
    visibility: hidden;
    opacity: 0;
  }
  .sidebar-narrow .d-narrow-none, .sidebar-narrow-unfoldable:not(:hover) .d-narrow-none,
  .sidebar-narrow .sidebar-brand-full,
  .sidebar-narrow-unfoldable:not(:hover) .sidebar-brand-full,
  .sidebar-narrow .d-sidebar-narrow-none,
  .sidebar-narrow-unfoldable:not(:hover) .d-sidebar-narrow-none {
    display: none !important;
  }
  .sidebar-narrow .sidebar-toggler::before, .sidebar-narrow-unfoldable:not(:hover) .sidebar-toggler::before {
    transform: rotate(-180deg);
  }
  .sidebar-narrow.sidebar-end .sidebar-toggler::before, .sidebar-end.sidebar-narrow-unfoldable:not(:hover) .sidebar-toggler::before {
    transform: rotate(0deg);
  }
}
.sidebar-narrow-unfoldable {
  --cui-sidebar-narrow-unfoldable-box-shadow: var(--cui-box-shadow);
}

.sidebar-narrow-unfoldable .d-sidebar-narrow-unfoldable-none {
  display: none !important;
}

.sidebar-narrow-unfoldable:hover {
  box-shadow: var(--cui-sidebar-narrow-unfoldable-box-shadow);
}

.sidebar-narrow-unfoldable:hover .sidebar-toggler::before {
  transform: rotate(-180deg);
}

.sidebar-narrow-unfoldable:hover.sidebar-end .sidebar-toggler::before {
  transform: rotate(0deg);
}

@media (min-width: 992px) {
  .sidebar-narrow:not(.sidebar-end):not(.hide) ~ *,
  .sidebar-narrow-unfoldable:not(.sidebar-end):not(.hide) ~ * {
    --cui-sidebar-occupy-start: 4rem;
  }
  .sidebar-narrow.sidebar-end:not(.hide) ~ *,
  .sidebar-narrow-unfoldable.sidebar-end:not(.hide) ~ * {
    --cui-sidebar-occupy-end: 4rem;
  }
}
.sidebar:not(.sidebar-narrow):not(.sidebar-narrow-unfoldable:not(:hover)) .sidebar-brand-narrow,
.sidebar:not(.sidebar-narrow):not(.sidebar-narrow-unfoldable:not(:hover)) .d-sidebar-narrow {
  display: none !important;
}

.sidebar:not(.sidebar-narrow-unfoldable) .d-sidebar-narrow-unfoldable {
  display: none !important;
}

.clearfix::after {
  display: block;
  clear: both;
  content: "";
}

.text-bg-primary {
  color: #fff !important;
  background-color: rgba(var(--cui-primary-rgb), var(--cui-bg-opacity, 1)) !important;
}

.text-bg-secondary {
  color: #fff !important;
  background-color: rgba(var(--cui-secondary-rgb), var(--cui-bg-opacity, 1)) !important;
}

.text-bg-success {
  color: #080a0c !important;
  background-color: rgba(var(--cui-success-rgb), var(--cui-bg-opacity, 1)) !important;
}

.text-bg-info {
  color: #080a0c !important;
  background-color: rgba(var(--cui-info-rgb), var(--cui-bg-opacity, 1)) !important;
}

.text-bg-warning {
  color: #080a0c !important;
  background-color: rgba(var(--cui-warning-rgb), var(--cui-bg-opacity, 1)) !important;
}

.text-bg-danger {
  color: #080a0c !important;
  background-color: rgba(var(--cui-danger-rgb), var(--cui-bg-opacity, 1)) !important;
}

.text-bg-light {
  color: #080a0c !important;
  background-color: rgba(var(--cui-light-rgb), var(--cui-bg-opacity, 1)) !important;
}

.text-bg-dark {
  color: #fff !important;
  background-color: rgba(var(--cui-dark-rgb), var(--cui-bg-opacity, 1)) !important;
}

[data-coreui-theme=dark] .text-bg-primary {
  color: #fff !important;
  background-color: rgba(94.2, 92.4, 207.6, var(--cui-bg-opacity, 1)) !important;
}

[data-coreui-theme=dark] .text-bg-secondary {
  color: #fff !important;
  background-color: rgba(107, 119, 133, var(--cui-bg-opacity, 1)) !important;
}

[data-coreui-theme=dark] .text-bg-success {
  color: #080a0c !important;
  background-color: rgba(33.55, 151.45, 65.05, var(--cui-bg-opacity, 1)) !important;
}

[data-coreui-theme=dark] .text-bg-info {
  color: #080a0c !important;
  background-color: rgba(61.2, 153, 244.8, var(--cui-bg-opacity, 1)) !important;
}

[data-coreui-theme=dark] .text-bg-warning {
  color: #080a0c !important;
  background-color: rgba(237.6, 172.8, 32.4, var(--cui-bg-opacity, 1)) !important;
}

[data-coreui-theme=dark] .text-bg-danger {
  color: #080a0c !important;
  background-color: rgba(221.7, 90.3, 90.3, var(--cui-bg-opacity, 1)) !important;
}

[data-coreui-theme=dark] .text-bg-light {
  color: #080a0c !important;
  background-color: rgba(243, 244, 247, var(--cui-bg-opacity, 1)) !important;
}

[data-coreui-theme=dark] .text-bg-dark {
  color: #fff !important;
  background-color: rgba(33, 38, 49, var(--cui-bg-opacity, 1)) !important;
}

.link-primary {
  color: rgba(var(--cui-primary-rgb), var(--cui-link-opacity, 1)) !important;
  text-decoration-color: rgba(var(--cui-primary-rgb), var(--cui-link-underline-opacity, 1)) !important;
}

.link-primary:hover, .link-primary:focus {
  color: rgba(70.4, 68.8, 171.2, var(--cui-link-opacity, 1)) !important;
  text-decoration-color: rgba(70.4, 68.8, 171.2, var(--cui-link-underline-opacity, 1)) !important;
}

.link-secondary {
  color: rgba(var(--cui-secondary-rgb), var(--cui-link-opacity, 1)) !important;
  text-decoration-color: rgba(var(--cui-secondary-rgb), var(--cui-link-underline-opacity, 1)) !important;
}

.link-secondary:hover, .link-secondary:focus {
  color: rgba(85.6, 95.2, 106.4, var(--cui-link-opacity, 1)) !important;
  text-decoration-color: rgba(85.6, 95.2, 106.4, var(--cui-link-underline-opacity, 1)) !important;
}

.link-success {
  color: rgba(var(--cui-success-rgb), var(--cui-link-opacity, 1)) !important;
  text-decoration-color: rgba(var(--cui-success-rgb), var(--cui-link-underline-opacity, 1)) !important;
}

.link-success:hover, .link-success:focus {
  color: rgba(72.6, 177.4, 100.6, var(--cui-link-opacity, 1)) !important;
  text-decoration-color: rgba(72.6, 177.4, 100.6, var(--cui-link-underline-opacity, 1)) !important;
}

.link-info {
  color: rgba(var(--cui-info-rgb), var(--cui-link-opacity, 1)) !important;
  text-decoration-color: rgba(var(--cui-info-rgb), var(--cui-link-underline-opacity, 1)) !important;
}

.link-info:hover, .link-info:focus {
  color: rgba(91.8, 173.4, 255, var(--cui-link-opacity, 1)) !important;
  text-decoration-color: rgba(91.8, 173.4, 255, var(--cui-link-underline-opacity, 1)) !important;
}

.link-warning {
  color: rgba(var(--cui-warning-rgb), var(--cui-link-opacity, 1)) !important;
  text-decoration-color: rgba(var(--cui-warning-rgb), var(--cui-link-underline-opacity, 1)) !important;
}

.link-warning:hover, .link-warning:focus {
  color: rgba(250.2, 192.6, 67.8, var(--cui-link-opacity, 1)) !important;
  text-decoration-color: rgba(250.2, 192.6, 67.8, var(--cui-link-underline-opacity, 1)) !important;
}

.link-danger {
  color: rgba(var(--cui-danger-rgb), var(--cui-link-opacity, 1)) !important;
  text-decoration-color: rgba(var(--cui-danger-rgb), var(--cui-link-underline-opacity, 1)) !important;
}

.link-danger:hover, .link-danger:focus {
  color: rgba(234.2, 117.4, 117.4, var(--cui-link-opacity, 1)) !important;
  text-decoration-color: rgba(234.2, 117.4, 117.4, var(--cui-link-underline-opacity, 1)) !important;
}

.link-light {
  color: rgba(var(--cui-light-rgb), var(--cui-link-opacity, 1)) !important;
  text-decoration-color: rgba(var(--cui-light-rgb), var(--cui-link-underline-opacity, 1)) !important;
}

.link-light:hover, .link-light:focus {
  color: rgba(245.4, 246.2, 248.6, var(--cui-link-opacity, 1)) !important;
  text-decoration-color: rgba(245.4, 246.2, 248.6, var(--cui-link-underline-opacity, 1)) !important;
}

.link-dark {
  color: rgba(var(--cui-dark-rgb), var(--cui-link-opacity, 1)) !important;
  text-decoration-color: rgba(var(--cui-dark-rgb), var(--cui-link-underline-opacity, 1)) !important;
}

.link-dark:hover, .link-dark:focus {
  color: rgba(26.4, 30.4, 39.2, var(--cui-link-opacity, 1)) !important;
  text-decoration-color: rgba(26.4, 30.4, 39.2, var(--cui-link-underline-opacity, 1)) !important;
}

.link-body-emphasis {
  color: rgba(var(--cui-emphasis-color-rgb), var(--cui-link-opacity, 1)) !important;
  text-decoration-color: rgba(var(--cui-emphasis-color-rgb), var(--cui-link-underline-opacity, 1)) !important;
}

.link-body-emphasis:hover, .link-body-emphasis:focus {
  color: rgba(var(--cui-emphasis-color-rgb), var(--cui-link-opacity, 0.75)) !important;
  text-decoration-color: rgba(var(--cui-emphasis-color-rgb), var(--cui-link-underline-opacity, 0.75)) !important;
}

.focus-ring:focus {
  outline: 0;
  box-shadow: var(--cui-focus-ring-x, 0) var(--cui-focus-ring-y, 0) var(--cui-focus-ring-blur, 0) var(--cui-focus-ring-width) var(--cui-focus-ring-color);
}

.icon-link {
  display: inline-flex;
  gap: 0.375rem;
  align-items: center;
  text-decoration-color: rgba(var(--cui-link-color-rgb), var(--cui-link-opacity, 0.5));
  text-underline-offset: 0.25em;
  backface-visibility: hidden;
}

.icon-link > .bi {
  flex-shrink: 0;
  width: 1em;
  height: 1em;
  fill: currentcolor;
  transition: 0.2s ease-in-out transform;
}

@media (prefers-reduced-motion: reduce) {
  .icon-link > .bi {
    transition: none;
  }
}
.icon-link-hover:hover > .bi, .icon-link-hover:focus-visible > .bi {
  transform: var(--cui-icon-link-transform, translate3d(0.25em, 0, 0));
}

.ratio {
  position: relative;
  width: 100%;
}

.ratio::before {
  display: block;
  padding-top: var(--cui-aspect-ratio);
  content: "";
}

.ratio > * {
  position: absolute;
  inset-inline-start: 0;
  top: 0;
  width: 100%;
  height: 100%;
}

.ratio-1x1 {
  --cui-aspect-ratio: 100%;
}

.ratio-4x3 {
  --cui-aspect-ratio: 75%;
}

.ratio-16x9 {
  --cui-aspect-ratio: 56.25%;
}

.ratio-21x9 {
  --cui-aspect-ratio: 42.8571428571%;
}

.fixed-top {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: 1030;
}

.fixed-bottom {
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1030;
}

.sticky-top {
  position: sticky;
  top: 0;
  z-index: 1020;
}

.sticky-bottom {
  position: sticky;
  bottom: 0;
  z-index: 1020;
}

@media (min-width: 576px) {
  .sticky-sm-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-sm-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
@media (min-width: 768px) {
  .sticky-md-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-md-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
@media (min-width: 992px) {
  .sticky-lg-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-lg-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
@media (min-width: 1200px) {
  .sticky-xl-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-xl-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
@media (min-width: 1400px) {
  .sticky-xxl-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-xxl-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
.hstack {
  display: flex;
  flex-direction: row;
  align-items: center;
  align-self: stretch;
}

.vstack {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  align-self: stretch;
}

.visually-hidden,
.visually-hidden-focusable:not(:focus):not(:focus-within) {
  width: 1px !important;
  height: 1px !important;
  padding: 0 !important;
  margin: -1px !important;
  overflow: hidden !important;
  clip: rect(0, 0, 0, 0) !important;
  white-space: nowrap !important;
  border: 0 !important;
}

.visually-hidden:not(caption),
.visually-hidden-focusable:not(:focus):not(:focus-within):not(caption) {
  position: absolute !important;
}

.visually-hidden *,
.visually-hidden-focusable:not(:focus):not(:focus-within) * {
  overflow: hidden !important;
}

.stretched-link::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1;
  content: "";
}

.text-truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.vr {
  display: inline-block;
  align-self: stretch;
  width: var(--cui-border-width);
  min-height: 1em;
  padding: 0;
  background-color: currentcolor;
  opacity: 0.25;
}

.align-baseline {
  vertical-align: baseline !important;
}

.align-top {
  vertical-align: top !important;
}

.align-middle {
  vertical-align: middle !important;
}

.align-bottom {
  vertical-align: bottom !important;
}

.align-text-bottom {
  vertical-align: text-bottom !important;
}

.align-text-top {
  vertical-align: text-top !important;
}

.float-start {
  float: inline-start !important;
}

.float-end {
  float: inline-end !important;
}

.float-none {
  float: none !important;
}

.object-fit-contain {
  object-fit: contain !important;
}

.object-fit-cover {
  object-fit: cover !important;
}

.object-fit-fill {
  object-fit: fill !important;
}

.object-fit-scale {
  object-fit: scale-down !important;
}

.object-fit-none {
  object-fit: none !important;
}

.opacity-0 {
  opacity: 0 !important;
}

.opacity-25 {
  opacity: 0.25 !important;
}

.opacity-50 {
  opacity: 0.5 !important;
}

.opacity-75 {
  opacity: 0.75 !important;
}

.opacity-100 {
  opacity: 1 !important;
}

.overflow-auto {
  overflow: auto !important;
}

.overflow-hidden {
  overflow: hidden !important;
}

.overflow-visible {
  overflow: visible !important;
}

.overflow-scroll {
  overflow: scroll !important;
}

.overflow-x-auto {
  overflow-x: auto !important;
}

.overflow-x-hidden {
  overflow-x: hidden !important;
}

.overflow-x-visible {
  overflow-x: visible !important;
}

.overflow-x-scroll {
  overflow-x: scroll !important;
}

.overflow-y-auto {
  overflow-y: auto !important;
}

.overflow-y-hidden {
  overflow-y: hidden !important;
}

.overflow-y-visible {
  overflow-y: visible !important;
}

.overflow-y-scroll {
  overflow-y: scroll !important;
}

.d-inline {
  display: inline !important;
}

.d-inline-block {
  display: inline-block !important;
}

.d-block {
  display: block !important;
}

.d-grid {
  display: grid !important;
}

.d-inline-grid {
  display: inline-grid !important;
}

.d-table {
  display: table !important;
}

.d-table-row {
  display: table-row !important;
}

.d-table-cell {
  display: table-cell !important;
}

.d-flex {
  display: flex !important;
}

.d-inline-flex {
  display: inline-flex !important;
}

.d-none {
  display: none !important;
}

.shadow {
  box-shadow: var(--cui-box-shadow) !important;
}

.shadow-sm {
  box-shadow: var(--cui-box-shadow-sm) !important;
}

.shadow-lg {
  box-shadow: var(--cui-box-shadow-lg) !important;
}

.shadow-none {
  box-shadow: none !important;
}

.focus-ring-primary {
  --cui-focus-ring-color: rgba(var(--cui-primary-rgb), var(--cui-focus-ring-opacity));
}

.focus-ring-secondary {
  --cui-focus-ring-color: rgba(var(--cui-secondary-rgb), var(--cui-focus-ring-opacity));
}

.focus-ring-success {
  --cui-focus-ring-color: rgba(var(--cui-success-rgb), var(--cui-focus-ring-opacity));
}

.focus-ring-info {
  --cui-focus-ring-color: rgba(var(--cui-info-rgb), var(--cui-focus-ring-opacity));
}

.focus-ring-warning {
  --cui-focus-ring-color: rgba(var(--cui-warning-rgb), var(--cui-focus-ring-opacity));
}

.focus-ring-danger {
  --cui-focus-ring-color: rgba(var(--cui-danger-rgb), var(--cui-focus-ring-opacity));
}

.focus-ring-light {
  --cui-focus-ring-color: rgba(var(--cui-light-rgb), var(--cui-focus-ring-opacity));
}

.focus-ring-dark {
  --cui-focus-ring-color: rgba(var(--cui-dark-rgb), var(--cui-focus-ring-opacity));
}

.position-static {
  position: static !important;
}

.position-relative {
  position: relative !important;
}

.position-absolute {
  position: absolute !important;
}

.position-fixed {
  position: fixed !important;
}

.position-sticky {
  position: sticky !important;
}

.top-0 {
  top: 0 !important;
}

.top-50 {
  top: 50% !important;
}

.top-100 {
  top: 100% !important;
}

.bottom-0 {
  bottom: 0 !important;
}

.bottom-50 {
  bottom: 50% !important;
}

.bottom-100 {
  bottom: 100% !important;
}

.start-0 {
  inset-inline-start: 0 !important;
}

.start-50 {
  inset-inline-start: 50% !important;
}

.start-100 {
  inset-inline-start: 100% !important;
}

.end-0 {
  inset-inline-end: 0 !important;
}

.end-50 {
  inset-inline-end: 50% !important;
}

.end-100 {
  inset-inline-end: 100% !important;
}

.translate-middle {
  transform: translate(-50%, -50%) !important;
}

.translate-middle-x {
  transform: translateX(-50%) !important;
}

.translate-middle-y {
  transform: translateY(-50%) !important;
}

.border {
  border: var(--cui-border-width) var(--cui-border-style) var(--cui-border-color) !important;
}

.border-0 {
  border: 0 !important;
}

.border-top {
  border-top: var(--cui-border-width) var(--cui-border-style) var(--cui-border-color) !important;
}

.border-top-0 {
  border-top: 0 !important;
}

.border-end {
  border-inline-end: var(--cui-border-width) var(--cui-border-style) var(--cui-border-color) !important;
}

.border-end-0 {
  border-inline-end: 0 !important;
}

.border-bottom {
  border-bottom: var(--cui-border-width) var(--cui-border-style) var(--cui-border-color) !important;
}

.border-bottom-0 {
  border-bottom: 0 !important;
}

.border-start {
  border-inline-start: var(--cui-border-width) var(--cui-border-style) var(--cui-border-color) !important;
}

.border-start-0 {
  border-inline-start: 0 !important;
}

.border-primary {
  --cui-border-opacity: 1;
  border-color: rgba(var(--cui-primary-rgb), var(--cui-border-opacity)) !important;
}

.border-secondary {
  --cui-border-opacity: 1;
  border-color: rgba(var(--cui-secondary-rgb), var(--cui-border-opacity)) !important;
}

.border-success {
  --cui-border-opacity: 1;
  border-color: rgba(var(--cui-success-rgb), var(--cui-border-opacity)) !important;
}

.border-info {
  --cui-border-opacity: 1;
  border-color: rgba(var(--cui-info-rgb), var(--cui-border-opacity)) !important;
}

.border-warning {
  --cui-border-opacity: 1;
  border-color: rgba(var(--cui-warning-rgb), var(--cui-border-opacity)) !important;
}

.border-danger {
  --cui-border-opacity: 1;
  border-color: rgba(var(--cui-danger-rgb), var(--cui-border-opacity)) !important;
}

.border-light {
  --cui-border-opacity: 1;
  border-color: rgba(var(--cui-light-rgb), var(--cui-border-opacity)) !important;
}

.border-dark {
  --cui-border-opacity: 1;
  border-color: rgba(var(--cui-dark-rgb), var(--cui-border-opacity)) !important;
}

.border-black {
  --cui-border-opacity: 1;
  border-color: rgba(var(--cui-black-rgb), var(--cui-border-opacity)) !important;
}

.border-white {
  --cui-border-opacity: 1;
  border-color: rgba(var(--cui-white-rgb), var(--cui-border-opacity)) !important;
}

.border-top-primary {
  border-top-color: #5856d6 !important;
}

.border-top-secondary {
  border-top-color: #6b7785 !important;
}

.border-top-success {
  border-top-color: #1b9e3e !important;
}

.border-top-info {
  border-top-color: #39f !important;
}

.border-top-warning {
  border-top-color: #f9b115 !important;
}

.border-top-danger {
  border-top-color: #e55353 !important;
}

.border-top-light {
  border-top-color: #f3f4f7 !important;
}

.border-top-dark {
  border-top-color: #212631 !important;
}

.border-top-white {
  border-top-color: #fff !important;
}

.border-end-primary {
  border-inline-end-color: #5856d6 !important;
}

.border-end-secondary {
  border-inline-end-color: #6b7785 !important;
}

.border-end-success {
  border-inline-end-color: #1b9e3e !important;
}

.border-end-info {
  border-inline-end-color: #39f !important;
}

.border-end-warning {
  border-inline-end-color: #f9b115 !important;
}

.border-end-danger {
  border-inline-end-color: #e55353 !important;
}

.border-end-light {
  border-inline-end-color: #f3f4f7 !important;
}

.border-end-dark {
  border-inline-end-color: #212631 !important;
}

.border-end-white {
  border-inline-end-color: #fff !important;
}

.border-bottom-primary {
  border-bottom-color: #5856d6 !important;
}

.border-bottom-secondary {
  border-bottom-color: #6b7785 !important;
}

.border-bottom-success {
  border-bottom-color: #1b9e3e !important;
}

.border-bottom-info {
  border-bottom-color: #39f !important;
}

.border-bottom-warning {
  border-bottom-color: #f9b115 !important;
}

.border-bottom-danger {
  border-bottom-color: #e55353 !important;
}

.border-bottom-light {
  border-bottom-color: #f3f4f7 !important;
}

.border-bottom-dark {
  border-bottom-color: #212631 !important;
}

.border-bottom-white {
  border-bottom-color: #fff !important;
}

.border-start-primary {
  border-inline-start-color: #5856d6 !important;
}

.border-start-secondary {
  border-inline-start-color: #6b7785 !important;
}

.border-start-success {
  border-inline-start-color: #1b9e3e !important;
}

.border-start-info {
  border-inline-start-color: #39f !important;
}

.border-start-warning {
  border-inline-start-color: #f9b115 !important;
}

.border-start-danger {
  border-inline-start-color: #e55353 !important;
}

.border-start-light {
  border-inline-start-color: #f3f4f7 !important;
}

.border-start-dark {
  border-inline-start-color: #212631 !important;
}

.border-start-white {
  border-inline-start-color: #fff !important;
}

.border-1 {
  border-width: 1px !important;
}

.border-2 {
  border-width: 2px !important;
}

.border-3 {
  border-width: 3px !important;
}

.border-4 {
  border-width: 4px !important;
}

.border-5 {
  border-width: 5px !important;
}

.border-top-1 {
  border-top-width: 1px !important;
}

.border-top-2 {
  border-top-width: 2px !important;
}

.border-top-3 {
  border-top-width: 3px !important;
}

.border-top-4 {
  border-top-width: 4px !important;
}

.border-top-5 {
  border-top-width: 5px !important;
}

.border-end-1 {
  border-inline-end-width: 1px !important;
}

.border-end-2 {
  border-inline-end-width: 2px !important;
}

.border-end-3 {
  border-inline-end-width: 3px !important;
}

.border-end-4 {
  border-inline-end-width: 4px !important;
}

.border-end-5 {
  border-inline-end-width: 5px !important;
}

.border-bottom-1 {
  border-bottom-width: 1px !important;
}

.border-bottom-2 {
  border-bottom-width: 2px !important;
}

.border-bottom-3 {
  border-bottom-width: 3px !important;
}

.border-bottom-4 {
  border-bottom-width: 4px !important;
}

.border-bottom-5 {
  border-bottom-width: 5px !important;
}

.border-start-1 {
  border-inline-start-width: 1px !important;
}

.border-start-2 {
  border-inline-start-width: 2px !important;
}

.border-start-3 {
  border-inline-start-width: 3px !important;
}

.border-start-4 {
  border-inline-start-width: 4px !important;
}

.border-start-5 {
  border-inline-start-width: 5px !important;
}

.border-primary-subtle {
  border-color: var(--cui-primary-border-subtle) !important;
}

.border-secondary-subtle {
  border-color: var(--cui-secondary-border-subtle) !important;
}

.border-success-subtle {
  border-color: var(--cui-success-border-subtle) !important;
}

.border-info-subtle {
  border-color: var(--cui-info-border-subtle) !important;
}

.border-warning-subtle {
  border-color: var(--cui-warning-border-subtle) !important;
}

.border-danger-subtle {
  border-color: var(--cui-danger-border-subtle) !important;
}

.border-light-subtle {
  border-color: var(--cui-light-border-subtle) !important;
}

.border-dark-subtle {
  border-color: var(--cui-dark-border-subtle) !important;
}

.border-opacity-10 {
  --cui-border-opacity: 0.1;
}

.border-opacity-25 {
  --cui-border-opacity: 0.25;
}

.border-opacity-50 {
  --cui-border-opacity: 0.5;
}

.border-opacity-75 {
  --cui-border-opacity: 0.75;
}

.border-opacity-100 {
  --cui-border-opacity: 1;
}

.w-25 {
  width: 25% !important;
}

.w-50 {
  width: 50% !important;
}

.w-75 {
  width: 75% !important;
}

.w-100 {
  width: 100% !important;
}

.w-auto {
  width: auto !important;
}

.mw-100 {
  max-width: 100% !important;
}

.vw-100 {
  width: 100vw !important;
}

.min-vw-100 {
  min-width: 100vw !important;
}

.h-25 {
  height: 25% !important;
}

.h-50 {
  height: 50% !important;
}

.h-75 {
  height: 75% !important;
}

.h-100 {
  height: 100% !important;
}

.h-auto {
  height: auto !important;
}

.mh-100 {
  max-height: 100% !important;
}

.vh-100 {
  height: 100vh !important;
}

.min-vh-100 {
  min-height: 100vh !important;
}

.flex-fill {
  flex: 1 1 auto !important;
}

.flex-row {
  flex-direction: row !important;
}

.flex-column {
  flex-direction: column !important;
}

.flex-row-reverse {
  flex-direction: row-reverse !important;
}

.flex-column-reverse {
  flex-direction: column-reverse !important;
}

.flex-grow-0 {
  flex-grow: 0 !important;
}

.flex-grow-1 {
  flex-grow: 1 !important;
}

.flex-shrink-0 {
  flex-shrink: 0 !important;
}

.flex-shrink-1 {
  flex-shrink: 1 !important;
}

.flex-wrap {
  flex-wrap: wrap !important;
}

.flex-nowrap {
  flex-wrap: nowrap !important;
}

.flex-wrap-reverse {
  flex-wrap: wrap-reverse !important;
}

.justify-content-start {
  justify-content: flex-start !important;
}

.justify-content-end {
  justify-content: flex-end !important;
}

.justify-content-center {
  justify-content: center !important;
}

.justify-content-between {
  justify-content: space-between !important;
}

.justify-content-around {
  justify-content: space-around !important;
}

.justify-content-evenly {
  justify-content: space-evenly !important;
}

.align-items-start {
  align-items: flex-start !important;
}

.align-items-end {
  align-items: flex-end !important;
}

.align-items-center {
  align-items: center !important;
}

.align-items-baseline {
  align-items: baseline !important;
}

.align-items-stretch {
  align-items: stretch !important;
}

.align-content-start {
  align-content: flex-start !important;
}

.align-content-end {
  align-content: flex-end !important;
}

.align-content-center {
  align-content: center !important;
}

.align-content-between {
  align-content: space-between !important;
}

.align-content-around {
  align-content: space-around !important;
}

.align-content-stretch {
  align-content: stretch !important;
}

.align-self-auto {
  align-self: auto !important;
}

.align-self-start {
  align-self: flex-start !important;
}

.align-self-end {
  align-self: flex-end !important;
}

.align-self-center {
  align-self: center !important;
}

.align-self-baseline {
  align-self: baseline !important;
}

.align-self-stretch {
  align-self: stretch !important;
}

.order-first {
  order: -1 !important;
}

.order-0 {
  order: 0 !important;
}

.order-1 {
  order: 1 !important;
}

.order-2 {
  order: 2 !important;
}

.order-3 {
  order: 3 !important;
}

.order-4 {
  order: 4 !important;
}

.order-5 {
  order: 5 !important;
}

.order-last {
  order: 6 !important;
}

.m-0 {
  margin: 0 !important;
}

.m-1 {
  margin: 0.25rem !important;
}

.m-2 {
  margin: 0.5rem !important;
}

.m-3 {
  margin: 1rem !important;
}

.m-4 {
  margin: 1.5rem !important;
}

.m-5 {
  margin: 3rem !important;
}

.m-auto {
  margin: auto !important;
}

.mx-0 {
  margin-right: 0 !important;
  margin-left: 0 !important;
}

.mx-1 {
  margin-right: 0.25rem !important;
  margin-left: 0.25rem !important;
}

.mx-2 {
  margin-right: 0.5rem !important;
  margin-left: 0.5rem !important;
}

.mx-3 {
  margin-right: 1rem !important;
  margin-left: 1rem !important;
}

.mx-4 {
  margin-right: 1.5rem !important;
  margin-left: 1.5rem !important;
}

.mx-5 {
  margin-right: 3rem !important;
  margin-left: 3rem !important;
}

.mx-auto {
  margin-right: auto !important;
  margin-left: auto !important;
}

.my-0 {
  margin-top: 0 !important;
  margin-bottom: 0 !important;
}

.my-1 {
  margin-top: 0.25rem !important;
  margin-bottom: 0.25rem !important;
}

.my-2 {
  margin-top: 0.5rem !important;
  margin-bottom: 0.5rem !important;
}

.my-3 {
  margin-top: 1rem !important;
  margin-bottom: 1rem !important;
}

.my-4 {
  margin-top: 1.5rem !important;
  margin-bottom: 1.5rem !important;
}

.my-5 {
  margin-top: 3rem !important;
  margin-bottom: 3rem !important;
}

.my-auto {
  margin-top: auto !important;
  margin-bottom: auto !important;
}

.mt-0 {
  margin-top: 0 !important;
}

.mt-1 {
  margin-top: 0.25rem !important;
}

.mt-2 {
  margin-top: 0.5rem !important;
}

.mt-3 {
  margin-top: 1rem !important;
}

.mt-4 {
  margin-top: 1.5rem !important;
}

.mt-5 {
  margin-top: 3rem !important;
}

.mt-auto {
  margin-top: auto !important;
}

.me-0 {
  margin-inline-end: 0 !important;
}

.me-1 {
  margin-inline-end: 0.25rem !important;
}

.me-2 {
  margin-inline-end: 0.5rem !important;
}

.me-3 {
  margin-inline-end: 1rem !important;
}

.me-4 {
  margin-inline-end: 1.5rem !important;
}

.me-5 {
  margin-inline-end: 3rem !important;
}

.me-auto {
  margin-inline-end: auto !important;
}

.mb-0 {
  margin-bottom: 0 !important;
}

.mb-1 {
  margin-bottom: 0.25rem !important;
}

.mb-2 {
  margin-bottom: 0.5rem !important;
}

.mb-3 {
  margin-bottom: 1rem !important;
}

.mb-4 {
  margin-bottom: 1.5rem !important;
}

.mb-5 {
  margin-bottom: 3rem !important;
}

.mb-auto {
  margin-bottom: auto !important;
}

.ms-0 {
  margin-inline-start: 0 !important;
}

.ms-1 {
  margin-inline-start: 0.25rem !important;
}

.ms-2 {
  margin-inline-start: 0.5rem !important;
}

.ms-3 {
  margin-inline-start: 1rem !important;
}

.ms-4 {
  margin-inline-start: 1.5rem !important;
}

.ms-5 {
  margin-inline-start: 3rem !important;
}

.ms-auto {
  margin-inline-start: auto !important;
}

.p-0 {
  padding: 0 !important;
}

.p-1 {
  padding: 0.25rem !important;
}

.p-2 {
  padding: 0.5rem !important;
}

.p-3 {
  padding: 1rem !important;
}

.p-4 {
  padding: 1.5rem !important;
}

.p-5 {
  padding: 3rem !important;
}

.px-0 {
  padding-right: 0 !important;
  padding-left: 0 !important;
}

.px-1 {
  padding-right: 0.25rem !important;
  padding-left: 0.25rem !important;
}

.px-2 {
  padding-right: 0.5rem !important;
  padding-left: 0.5rem !important;
}

.px-3 {
  padding-right: 1rem !important;
  padding-left: 1rem !important;
}

.px-4 {
  padding-right: 1.5rem !important;
  padding-left: 1.5rem !important;
}

.px-5 {
  padding-right: 3rem !important;
  padding-left: 3rem !important;
}

.py-0 {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}

.py-1 {
  padding-top: 0.25rem !important;
  padding-bottom: 0.25rem !important;
}

.py-2 {
  padding-top: 0.5rem !important;
  padding-bottom: 0.5rem !important;
}

.py-3 {
  padding-top: 1rem !important;
  padding-bottom: 1rem !important;
}

.py-4 {
  padding-top: 1.5rem !important;
  padding-bottom: 1.5rem !important;
}

.py-5 {
  padding-top: 3rem !important;
  padding-bottom: 3rem !important;
}

.pt-0 {
  padding-top: 0 !important;
}

.pt-1 {
  padding-top: 0.25rem !important;
}

.pt-2 {
  padding-top: 0.5rem !important;
}

.pt-3 {
  padding-top: 1rem !important;
}

.pt-4 {
  padding-top: 1.5rem !important;
}

.pt-5 {
  padding-top: 3rem !important;
}

.pe-0 {
  padding-inline-end: 0 !important;
}

.pe-1 {
  padding-inline-end: 0.25rem !important;
}

.pe-2 {
  padding-inline-end: 0.5rem !important;
}

.pe-3 {
  padding-inline-end: 1rem !important;
}

.pe-4 {
  padding-inline-end: 1.5rem !important;
}

.pe-5 {
  padding-inline-end: 3rem !important;
}

.pb-0 {
  padding-bottom: 0 !important;
}

.pb-1 {
  padding-bottom: 0.25rem !important;
}

.pb-2 {
  padding-bottom: 0.5rem !important;
}

.pb-3 {
  padding-bottom: 1rem !important;
}

.pb-4 {
  padding-bottom: 1.5rem !important;
}

.pb-5 {
  padding-bottom: 3rem !important;
}

.ps-0 {
  padding-inline-start: 0 !important;
}

.ps-1 {
  padding-inline-start: 0.25rem !important;
}

.ps-2 {
  padding-inline-start: 0.5rem !important;
}

.ps-3 {
  padding-inline-start: 1rem !important;
}

.ps-4 {
  padding-inline-start: 1.5rem !important;
}

.ps-5 {
  padding-inline-start: 3rem !important;
}

.gap-0 {
  gap: 0 !important;
}

.gap-1 {
  gap: 0.25rem !important;
}

.gap-2 {
  gap: 0.5rem !important;
}

.gap-3 {
  gap: 1rem !important;
}

.gap-4 {
  gap: 1.5rem !important;
}

.gap-5 {
  gap: 3rem !important;
}

.row-gap-0 {
  row-gap: 0 !important;
}

.row-gap-1 {
  row-gap: 0.25rem !important;
}

.row-gap-2 {
  row-gap: 0.5rem !important;
}

.row-gap-3 {
  row-gap: 1rem !important;
}

.row-gap-4 {
  row-gap: 1.5rem !important;
}

.row-gap-5 {
  row-gap: 3rem !important;
}

.column-gap-0 {
  column-gap: 0 !important;
}

.column-gap-1 {
  column-gap: 0.25rem !important;
}

.column-gap-2 {
  column-gap: 0.5rem !important;
}

.column-gap-3 {
  column-gap: 1rem !important;
}

.column-gap-4 {
  column-gap: 1.5rem !important;
}

.column-gap-5 {
  column-gap: 3rem !important;
}

.font-monospace {
  font-family: var(--cui-font-monospace) !important;
}

.fs-1 {
  font-size: calc(1.375rem + 1.5vw) !important;
}

.fs-2 {
  font-size: calc(1.325rem + 0.9vw) !important;
}

.fs-3 {
  font-size: calc(1.3rem + 0.6vw) !important;
}

.fs-4 {
  font-size: calc(1.275rem + 0.3vw) !important;
}

.fs-5 {
  font-size: 1.25rem !important;
}

.fs-6 {
  font-size: 1rem !important;
}

.fst-italic {
  font-style: italic !important;
}

.fst-normal {
  font-style: normal !important;
}

.fw-lighter {
  font-weight: lighter !important;
}

.fw-light {
  font-weight: 300 !important;
}

.fw-normal {
  font-weight: 400 !important;
}

.fw-medium {
  font-weight: 500 !important;
}

.fw-semibold {
  font-weight: 600 !important;
}

.fw-bold {
  font-weight: 700 !important;
}

.fw-bolder {
  font-weight: bolder !important;
}

.lh-1 {
  line-height: 1 !important;
}

.lh-sm {
  line-height: 1.25 !important;
}

.lh-base {
  line-height: 1.5 !important;
}

.lh-lg {
  line-height: 2 !important;
}

.text-start {
  text-align: start !important;
}

.text-end {
  text-align: end !important;
}

.text-center {
  text-align: center !important;
}

.text-decoration-none {
  text-decoration: none !important;
}

.text-decoration-underline {
  text-decoration: underline !important;
}

.text-decoration-line-through {
  text-decoration: line-through !important;
}

.text-lowercase {
  text-transform: lowercase !important;
}

.text-uppercase {
  text-transform: uppercase !important;
}

.text-capitalize {
  text-transform: capitalize !important;
}

.text-wrap {
  white-space: normal !important;
}

.text-nowrap {
  white-space: nowrap !important;
}

/* rtl:begin:remove */
.text-break {
  word-wrap: break-word !important;
  word-break: break-word !important;
}

/* rtl:end:remove */
[data-coreui-theme=dark] .dark\\:text-primary, [data-coreui-theme=dark] .dark\\:text-primary:not([class*="dark:"]),
.text-primary {
  --cui-text-opacity: 1;
  color: rgba(var(--cui-primary-rgb), var(--cui-text-opacity)) !important;
}

[data-coreui-theme=dark] .dark\\:text-secondary, [data-coreui-theme=dark] .dark\\:text-secondary:not([class*="dark:"]),
.text-secondary {
  --cui-text-opacity: 1;
  color: rgba(var(--cui-secondary-rgb), var(--cui-text-opacity)) !important;
}

[data-coreui-theme=dark] .dark\\:text-success, [data-coreui-theme=dark] .dark\\:text-success:not([class*="dark:"]),
.text-success {
  --cui-text-opacity: 1;
  color: rgba(var(--cui-success-rgb), var(--cui-text-opacity)) !important;
}

[data-coreui-theme=dark] .dark\\:text-info, [data-coreui-theme=dark] .dark\\:text-info:not([class*="dark:"]),
.text-info {
  --cui-text-opacity: 1;
  color: rgba(var(--cui-info-rgb), var(--cui-text-opacity)) !important;
}

[data-coreui-theme=dark] .dark\\:text-warning, [data-coreui-theme=dark] .dark\\:text-warning:not([class*="dark:"]),
.text-warning {
  --cui-text-opacity: 1;
  color: rgba(var(--cui-warning-rgb), var(--cui-text-opacity)) !important;
}

[data-coreui-theme=dark] .dark\\:text-danger, [data-coreui-theme=dark] .dark\\:text-danger:not([class*="dark:"]),
.text-danger {
  --cui-text-opacity: 1;
  color: rgba(var(--cui-danger-rgb), var(--cui-text-opacity)) !important;
}

[data-coreui-theme=dark] .dark\\:text-light, [data-coreui-theme=dark] .dark\\:text-light:not([class*="dark:"]),
.text-light {
  --cui-text-opacity: 1;
  color: rgba(var(--cui-light-rgb), var(--cui-text-opacity)) !important;
}

[data-coreui-theme=dark] .dark\\:text-dark, [data-coreui-theme=dark] .dark\\:text-dark:not([class*="dark:"]),
.text-dark {
  --cui-text-opacity: 1;
  color: rgba(var(--cui-dark-rgb), var(--cui-text-opacity)) !important;
}

[data-coreui-theme=dark] .dark\\:text-black, [data-coreui-theme=dark] .dark\\:text-black:not([class*="dark:"]),
.text-black {
  --cui-text-opacity: 1;
  color: rgba(var(--cui-black-rgb), var(--cui-text-opacity)) !important;
}

[data-coreui-theme=dark] .dark\\:text-white, [data-coreui-theme=dark] .dark\\:text-white:not([class*="dark:"]),
.text-white {
  --cui-text-opacity: 1;
  color: rgba(var(--cui-white-rgb), var(--cui-text-opacity)) !important;
}

[data-coreui-theme=dark] .dark\\:text-body, [data-coreui-theme=dark] .dark\\:text-body:not([class*="dark:"]),
.text-body {
  --cui-text-opacity: 1;
  color: rgba(var(--cui-body-color-rgb), var(--cui-text-opacity)) !important;
}

[data-coreui-theme=dark] .dark\\:text-muted, [data-coreui-theme=dark] .dark\\:text-muted:not([class*="dark:"]),
.text-muted {
  --cui-text-opacity: 1;
  color: var(--cui-secondary-color) !important;
}

[data-coreui-theme=dark] .dark\\:text-black-50, [data-coreui-theme=dark] .dark\\:text-black-50:not([class*="dark:"]),
.text-black-50 {
  --cui-text-opacity: 1;
  color: rgba(8, 10, 12, 0.5) !important;
}

[data-coreui-theme=dark] .dark\\:text-white-50, [data-coreui-theme=dark] .dark\\:text-white-50:not([class*="dark:"]),
.text-white-50 {
  --cui-text-opacity: 1;
  color: rgba(255, 255, 255, 0.5) !important;
}

[data-coreui-theme=dark] .dark\\:text-body-secondary, [data-coreui-theme=dark] .dark\\:text-body-secondary:not([class*="dark:"]),
.text-body-secondary {
  --cui-text-opacity: 1;
  color: var(--cui-secondary-color) !important;
}

[data-coreui-theme=dark] .dark\\:text-body-tertiary, [data-coreui-theme=dark] .dark\\:text-body-tertiary:not([class*="dark:"]),
.text-body-tertiary {
  --cui-text-opacity: 1;
  color: var(--cui-tertiary-color) !important;
}

[data-coreui-theme=dark] .dark\\:text-body-emphasis, [data-coreui-theme=dark] .dark\\:text-body-emphasis:not([class*="dark:"]),
.text-body-emphasis {
  --cui-text-opacity: 1;
  color: var(--cui-emphasis-color) !important;
}

[data-coreui-theme=dark] .dark\\:text-reset, [data-coreui-theme=dark] .dark\\:text-reset:not([class*="dark:"]),
.text-reset {
  --cui-text-opacity: 1;
  color: inherit !important;
}

[data-coreui-theme=dark] .dark\\:text-high-emphasis-inverse, [data-coreui-theme=dark] .dark\\:text-high-emphasis-inverse:not([class*="dark:"]),
.text-high-emphasis-inverse {
  --cui-text-opacity: 1;
  color: var(--cui-high-emphasis-inverse) !important;
}

[data-coreui-theme=dark] .dark\\:text-medium-emphasis-inverse, [data-coreui-theme=dark] .dark\\:text-medium-emphasis-inverse:not([class*="dark:"]),
.text-medium-emphasis-inverse {
  --cui-text-opacity: 1;
  color: var(--cui-medium-emphasis-inverse) !important;
}

[data-coreui-theme=dark] .dark\\:text-disabled-inverse, [data-coreui-theme=dark] .dark\\:text-disabled-inverse:not([class*="dark:"]),
.text-disabled-inverse {
  --cui-text-opacity: 1;
  color: var(--cui-disabled-inverse) !important;
}

[data-coreui-theme=dark] .dark\\:text-high-emphasis, [data-coreui-theme=dark] .dark\\:text-high-emphasis:not([class*="dark:"]),
.text-high-emphasis {
  --cui-text-opacity: 1;
  color: var(--cui-high-emphasis) !important;
}

[data-coreui-theme=dark] .dark\\:text-medium-emphasis, [data-coreui-theme=dark] .dark\\:text-medium-emphasis:not([class*="dark:"]),
.text-medium-emphasis {
  --cui-text-opacity: 1;
  color: var(--cui-medium-emphasis) !important;
}

[data-coreui-theme=dark] .dark\\:text-disabled, [data-coreui-theme=dark] .dark\\:text-disabled:not([class*="dark:"]),
.text-disabled {
  --cui-text-opacity: 1;
  color: var(--cui-disabled) !important;
}

.text-opacity-25 {
  --cui-text-opacity: 0.25;
}

.text-opacity-50 {
  --cui-text-opacity: 0.5;
}

.text-opacity-75 {
  --cui-text-opacity: 0.75;
}

.text-opacity-100 {
  --cui-text-opacity: 1;
}

.text-primary-emphasis {
  color: var(--cui-primary-text-emphasis) !important;
}

.text-secondary-emphasis {
  color: var(--cui-secondary-text-emphasis) !important;
}

.text-success-emphasis {
  color: var(--cui-success-text-emphasis) !important;
}

.text-info-emphasis {
  color: var(--cui-info-text-emphasis) !important;
}

.text-warning-emphasis {
  color: var(--cui-warning-text-emphasis) !important;
}

.text-danger-emphasis {
  color: var(--cui-danger-text-emphasis) !important;
}

.text-light-emphasis {
  color: var(--cui-light-text-emphasis) !important;
}

.text-dark-emphasis {
  color: var(--cui-dark-text-emphasis) !important;
}

.link-opacity-10 {
  --cui-link-opacity: 0.1;
}

.link-opacity-10-hover:hover {
  --cui-link-opacity: 0.1;
}

.link-opacity-25 {
  --cui-link-opacity: 0.25;
}

.link-opacity-25-hover:hover {
  --cui-link-opacity: 0.25;
}

.link-opacity-50 {
  --cui-link-opacity: 0.5;
}

.link-opacity-50-hover:hover {
  --cui-link-opacity: 0.5;
}

.link-opacity-75 {
  --cui-link-opacity: 0.75;
}

.link-opacity-75-hover:hover {
  --cui-link-opacity: 0.75;
}

.link-opacity-100 {
  --cui-link-opacity: 1;
}

.link-opacity-100-hover:hover {
  --cui-link-opacity: 1;
}

.link-offset-1 {
  text-underline-offset: 0.125em !important;
}

.link-offset-1-hover:hover {
  text-underline-offset: 0.125em !important;
}

.link-offset-2 {
  text-underline-offset: 0.25em !important;
}

.link-offset-2-hover:hover {
  text-underline-offset: 0.25em !important;
}

.link-offset-3 {
  text-underline-offset: 0.375em !important;
}

.link-offset-3-hover:hover {
  text-underline-offset: 0.375em !important;
}

.link-underline-primary {
  --cui-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--cui-primary-rgb), var(--cui-link-underline-opacity)) !important;
}

.link-underline-secondary {
  --cui-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--cui-secondary-rgb), var(--cui-link-underline-opacity)) !important;
}

.link-underline-success {
  --cui-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--cui-success-rgb), var(--cui-link-underline-opacity)) !important;
}

.link-underline-info {
  --cui-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--cui-info-rgb), var(--cui-link-underline-opacity)) !important;
}

.link-underline-warning {
  --cui-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--cui-warning-rgb), var(--cui-link-underline-opacity)) !important;
}

.link-underline-danger {
  --cui-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--cui-danger-rgb), var(--cui-link-underline-opacity)) !important;
}

.link-underline-light {
  --cui-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--cui-light-rgb), var(--cui-link-underline-opacity)) !important;
}

.link-underline-dark {
  --cui-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--cui-dark-rgb), var(--cui-link-underline-opacity)) !important;
}

.link-underline {
  --cui-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--cui-link-color-rgb), var(--cui-link-underline-opacity, 1)) !important;
}

.link-underline-opacity-0 {
  --cui-link-underline-opacity: 0;
}

.link-underline-opacity-0-hover:hover {
  --cui-link-underline-opacity: 0;
}

.link-underline-opacity-10 {
  --cui-link-underline-opacity: 0.1;
}

.link-underline-opacity-10-hover:hover {
  --cui-link-underline-opacity: 0.1;
}

.link-underline-opacity-25 {
  --cui-link-underline-opacity: 0.25;
}

.link-underline-opacity-25-hover:hover {
  --cui-link-underline-opacity: 0.25;
}

.link-underline-opacity-50 {
  --cui-link-underline-opacity: 0.5;
}

.link-underline-opacity-50-hover:hover {
  --cui-link-underline-opacity: 0.5;
}

.link-underline-opacity-75 {
  --cui-link-underline-opacity: 0.75;
}

.link-underline-opacity-75-hover:hover {
  --cui-link-underline-opacity: 0.75;
}

.link-underline-opacity-100 {
  --cui-link-underline-opacity: 1;
}

.link-underline-opacity-100-hover:hover {
  --cui-link-underline-opacity: 1;
}

[data-coreui-theme=dark] .dark\\:bg-primary, [data-coreui-theme=dark] .dark\\:bg-primary:not([class*="dark:"]),
.bg-primary {
  --cui-bg-opacity: 1;
  background-color: rgba(var(--cui-primary-rgb), var(--cui-bg-opacity)) !important;
}

[data-coreui-theme=dark] .dark\\:bg-secondary, [data-coreui-theme=dark] .dark\\:bg-secondary:not([class*="dark:"]),
.bg-secondary {
  --cui-bg-opacity: 1;
  background-color: rgba(var(--cui-secondary-rgb), var(--cui-bg-opacity)) !important;
}

[data-coreui-theme=dark] .dark\\:bg-success, [data-coreui-theme=dark] .dark\\:bg-success:not([class*="dark:"]),
.bg-success {
  --cui-bg-opacity: 1;
  background-color: rgba(var(--cui-success-rgb), var(--cui-bg-opacity)) !important;
}

[data-coreui-theme=dark] .dark\\:bg-info, [data-coreui-theme=dark] .dark\\:bg-info:not([class*="dark:"]),
.bg-info {
  --cui-bg-opacity: 1;
  background-color: rgba(var(--cui-info-rgb), var(--cui-bg-opacity)) !important;
}

[data-coreui-theme=dark] .dark\\:bg-warning, [data-coreui-theme=dark] .dark\\:bg-warning:not([class*="dark:"]),
.bg-warning {
  --cui-bg-opacity: 1;
  background-color: rgba(var(--cui-warning-rgb), var(--cui-bg-opacity)) !important;
}

[data-coreui-theme=dark] .dark\\:bg-danger, [data-coreui-theme=dark] .dark\\:bg-danger:not([class*="dark:"]),
.bg-danger {
  --cui-bg-opacity: 1;
  background-color: rgba(var(--cui-danger-rgb), var(--cui-bg-opacity)) !important;
}

[data-coreui-theme=dark] .dark\\:bg-light, [data-coreui-theme=dark] .dark\\:bg-light:not([class*="dark:"]),
.bg-light {
  --cui-bg-opacity: 1;
  background-color: rgba(var(--cui-light-rgb), var(--cui-bg-opacity)) !important;
}

[data-coreui-theme=dark] .dark\\:bg-dark, [data-coreui-theme=dark] .dark\\:bg-dark:not([class*="dark:"]),
.bg-dark {
  --cui-bg-opacity: 1;
  background-color: rgba(var(--cui-dark-rgb), var(--cui-bg-opacity)) !important;
}

[data-coreui-theme=dark] .dark\\:bg-black, [data-coreui-theme=dark] .dark\\:bg-black:not([class*="dark:"]),
.bg-black {
  --cui-bg-opacity: 1;
  background-color: rgba(var(--cui-black-rgb), var(--cui-bg-opacity)) !important;
}

[data-coreui-theme=dark] .dark\\:bg-white, [data-coreui-theme=dark] .dark\\:bg-white:not([class*="dark:"]),
.bg-white {
  --cui-bg-opacity: 1;
  background-color: rgba(var(--cui-white-rgb), var(--cui-bg-opacity)) !important;
}

[data-coreui-theme=dark] .dark\\:bg-body, [data-coreui-theme=dark] .dark\\:bg-body:not([class*="dark:"]),
.bg-body {
  --cui-bg-opacity: 1;
  background-color: rgba(var(--cui-body-bg-rgb), var(--cui-bg-opacity)) !important;
}

[data-coreui-theme=dark] .dark\\:bg-transparent, [data-coreui-theme=dark] .dark\\:bg-transparent:not([class*="dark:"]),
.bg-transparent {
  --cui-bg-opacity: 1;
  background-color: transparent !important;
}

[data-coreui-theme=dark] .dark\\:bg-body-secondary, [data-coreui-theme=dark] .dark\\:bg-body-secondary:not([class*="dark:"]),
.bg-body-secondary {
  --cui-bg-opacity: 1;
  background-color: rgba(var(--cui-secondary-bg-rgb), var(--cui-bg-opacity)) !important;
}

[data-coreui-theme=dark] .dark\\:bg-body-tertiary, [data-coreui-theme=dark] .dark\\:bg-body-tertiary:not([class*="dark:"]),
.bg-body-tertiary {
  --cui-bg-opacity: 1;
  background-color: rgba(var(--cui-tertiary-bg-rgb), var(--cui-bg-opacity)) !important;
}

.bg-opacity-10 {
  --cui-bg-opacity: 0.1;
}

.bg-opacity-25 {
  --cui-bg-opacity: 0.25;
}

.bg-opacity-50 {
  --cui-bg-opacity: 0.5;
}

.bg-opacity-75 {
  --cui-bg-opacity: 0.75;
}

.bg-opacity-100 {
  --cui-bg-opacity: 1;
}

[data-coreui-theme=dark] .dark\\:bg-primary-subtle, [data-coreui-theme=dark] .dark\\:bg-primary-subtle:not([class*="dark:"]),
.bg-primary-subtle {
  background-color: var(--cui-primary-bg-subtle) !important;
}

[data-coreui-theme=dark] .dark\\:bg-secondary-subtle, [data-coreui-theme=dark] .dark\\:bg-secondary-subtle:not([class*="dark:"]),
.bg-secondary-subtle {
  background-color: var(--cui-secondary-bg-subtle) !important;
}

[data-coreui-theme=dark] .dark\\:bg-success-subtle, [data-coreui-theme=dark] .dark\\:bg-success-subtle:not([class*="dark:"]),
.bg-success-subtle {
  background-color: var(--cui-success-bg-subtle) !important;
}

[data-coreui-theme=dark] .dark\\:bg-info-subtle, [data-coreui-theme=dark] .dark\\:bg-info-subtle:not([class*="dark:"]),
.bg-info-subtle {
  background-color: var(--cui-info-bg-subtle) !important;
}

[data-coreui-theme=dark] .dark\\:bg-warning-subtle, [data-coreui-theme=dark] .dark\\:bg-warning-subtle:not([class*="dark:"]),
.bg-warning-subtle {
  background-color: var(--cui-warning-bg-subtle) !important;
}

[data-coreui-theme=dark] .dark\\:bg-danger-subtle, [data-coreui-theme=dark] .dark\\:bg-danger-subtle:not([class*="dark:"]),
.bg-danger-subtle {
  background-color: var(--cui-danger-bg-subtle) !important;
}

[data-coreui-theme=dark] .dark\\:bg-light-subtle, [data-coreui-theme=dark] .dark\\:bg-light-subtle:not([class*="dark:"]),
.bg-light-subtle {
  background-color: var(--cui-light-bg-subtle) !important;
}

[data-coreui-theme=dark] .dark\\:bg-dark-subtle, [data-coreui-theme=dark] .dark\\:bg-dark-subtle:not([class*="dark:"]),
.bg-dark-subtle {
  background-color: var(--cui-dark-bg-subtle) !important;
}

.bg-gradient {
  background-image: var(--cui-gradient) !important;
}

.user-select-all {
  -webkit-user-select: all !important;
          user-select: all !important;
}

.user-select-auto {
  -webkit-user-select: auto !important;
          user-select: auto !important;
}

.user-select-none {
  -webkit-user-select: none !important;
          user-select: none !important;
}

.pe-none {
  pointer-events: none !important;
}

.pe-auto {
  pointer-events: auto !important;
}

.rounded {
  border-radius: var(--cui-border-radius) !important;
}

.rounded-0 {
  border-radius: 0 !important;
}

.rounded-1 {
  border-radius: var(--cui-border-radius-sm) !important;
}

.rounded-2 {
  border-radius: var(--cui-border-radius) !important;
}

.rounded-3 {
  border-radius: var(--cui-border-radius-lg) !important;
}

.rounded-4 {
  border-radius: var(--cui-border-radius-xl) !important;
}

.rounded-5 {
  border-radius: var(--cui-border-radius-xxl) !important;
}

.rounded-circle {
  border-radius: 50% !important;
}

.rounded-pill {
  border-radius: var(--cui-border-radius-pill) !important;
}

.rounded-top {
  border-top-left-radius: var(--cui-border-radius) !important;
  border-top-right-radius: var(--cui-border-radius) !important;
}

.rounded-top-0 {
  border-top-left-radius: 0 !important;
  border-top-right-radius: 0 !important;
}

.rounded-top-1 {
  border-top-left-radius: var(--cui-border-radius-sm) !important;
  border-top-right-radius: var(--cui-border-radius-sm) !important;
}

.rounded-top-2 {
  border-top-left-radius: var(--cui-border-radius) !important;
  border-top-right-radius: var(--cui-border-radius) !important;
}

.rounded-top-3 {
  border-top-left-radius: var(--cui-border-radius-lg) !important;
  border-top-right-radius: var(--cui-border-radius-lg) !important;
}

.rounded-top-4 {
  border-top-left-radius: var(--cui-border-radius-xl) !important;
  border-top-right-radius: var(--cui-border-radius-xl) !important;
}

.rounded-top-5 {
  border-top-left-radius: var(--cui-border-radius-xxl) !important;
  border-top-right-radius: var(--cui-border-radius-xxl) !important;
}

.rounded-top-circle {
  border-top-left-radius: 50% !important;
  border-top-right-radius: 50% !important;
}

.rounded-top-pill {
  border-top-left-radius: var(--cui-border-radius-pill) !important;
  border-top-right-radius: var(--cui-border-radius-pill) !important;
}

.rounded-end {
  border-start-end-radius: var(--cui-border-radius) !important;
  border-end-end-radius: var(--cui-border-radius) !important;
}

.rounded-end-0 {
  border-start-end-radius: 0 !important;
  border-end-end-radius: 0 !important;
}

.rounded-end-1 {
  border-start-end-radius: var(--cui-border-radius-sm) !important;
  border-end-end-radius: var(--cui-border-radius-sm) !important;
}

.rounded-end-2 {
  border-start-end-radius: var(--cui-border-radius) !important;
  border-end-end-radius: var(--cui-border-radius) !important;
}

.rounded-end-3 {
  border-start-end-radius: var(--cui-border-radius-lg) !important;
  border-end-end-radius: var(--cui-border-radius-lg) !important;
}

.rounded-end-4 {
  border-start-end-radius: var(--cui-border-radius-xl) !important;
  border-end-end-radius: var(--cui-border-radius-xl) !important;
}

.rounded-end-5 {
  border-start-end-radius: var(--cui-border-radius-xxl) !important;
  border-end-end-radius: var(--cui-border-radius-xxl) !important;
}

.rounded-end-circle {
  border-start-end-radius: 50% !important;
  border-end-end-radius: 50% !important;
}

.rounded-end-pill {
  border-start-end-radius: var(--cui-border-radius-pill) !important;
  border-end-end-radius: var(--cui-border-radius-pill) !important;
}

.rounded-bottom {
  border-bottom-right-radius: var(--cui-border-radius) !important;
  border-bottom-left-radius: var(--cui-border-radius) !important;
}

.rounded-bottom-0 {
  border-bottom-right-radius: 0 !important;
  border-bottom-left-radius: 0 !important;
}

.rounded-bottom-1 {
  border-bottom-right-radius: var(--cui-border-radius-sm) !important;
  border-bottom-left-radius: var(--cui-border-radius-sm) !important;
}

.rounded-bottom-2 {
  border-bottom-right-radius: var(--cui-border-radius) !important;
  border-bottom-left-radius: var(--cui-border-radius) !important;
}

.rounded-bottom-3 {
  border-bottom-right-radius: var(--cui-border-radius-lg) !important;
  border-bottom-left-radius: var(--cui-border-radius-lg) !important;
}

.rounded-bottom-4 {
  border-bottom-right-radius: var(--cui-border-radius-xl) !important;
  border-bottom-left-radius: var(--cui-border-radius-xl) !important;
}

.rounded-bottom-5 {
  border-bottom-right-radius: var(--cui-border-radius-xxl) !important;
  border-bottom-left-radius: var(--cui-border-radius-xxl) !important;
}

.rounded-bottom-circle {
  border-bottom-right-radius: 50% !important;
  border-bottom-left-radius: 50% !important;
}

.rounded-bottom-pill {
  border-bottom-right-radius: var(--cui-border-radius-pill) !important;
  border-bottom-left-radius: var(--cui-border-radius-pill) !important;
}

.rounded-start {
  border-end-start-radius: var(--cui-border-radius) !important;
  border-start-start-radius: var(--cui-border-radius) !important;
}

.rounded-start-0 {
  border-end-start-radius: 0 !important;
  border-start-start-radius: 0 !important;
}

.rounded-start-1 {
  border-end-start-radius: var(--cui-border-radius-sm) !important;
  border-start-start-radius: var(--cui-border-radius-sm) !important;
}

.rounded-start-2 {
  border-end-start-radius: var(--cui-border-radius) !important;
  border-start-start-radius: var(--cui-border-radius) !important;
}

.rounded-start-3 {
  border-end-start-radius: var(--cui-border-radius-lg) !important;
  border-start-start-radius: var(--cui-border-radius-lg) !important;
}

.rounded-start-4 {
  border-end-start-radius: var(--cui-border-radius-xl) !important;
  border-start-start-radius: var(--cui-border-radius-xl) !important;
}

.rounded-start-5 {
  border-end-start-radius: var(--cui-border-radius-xxl) !important;
  border-start-start-radius: var(--cui-border-radius-xxl) !important;
}

.rounded-start-circle {
  border-end-start-radius: 50% !important;
  border-start-start-radius: 50% !important;
}

.rounded-start-pill {
  border-end-start-radius: var(--cui-border-radius-pill) !important;
  border-start-start-radius: var(--cui-border-radius-pill) !important;
}

.visible {
  visibility: visible !important;
}

.invisible {
  visibility: hidden !important;
}

.z-n1 {
  z-index: -1 !important;
}

.z-0 {
  z-index: 0 !important;
}

.z-1 {
  z-index: 1 !important;
}

.z-2 {
  z-index: 2 !important;
}

.z-3 {
  z-index: 3 !important;
}

@media (min-width: 576px) {
  .float-sm-start {
    float: inline-start !important;
  }
  .float-sm-end {
    float: inline-end !important;
  }
  .float-sm-none {
    float: none !important;
  }
  .object-fit-sm-contain {
    object-fit: contain !important;
  }
  .object-fit-sm-cover {
    object-fit: cover !important;
  }
  .object-fit-sm-fill {
    object-fit: fill !important;
  }
  .object-fit-sm-scale {
    object-fit: scale-down !important;
  }
  .object-fit-sm-none {
    object-fit: none !important;
  }
  .d-sm-inline {
    display: inline !important;
  }
  .d-sm-inline-block {
    display: inline-block !important;
  }
  .d-sm-block {
    display: block !important;
  }
  .d-sm-grid {
    display: grid !important;
  }
  .d-sm-inline-grid {
    display: inline-grid !important;
  }
  .d-sm-table {
    display: table !important;
  }
  .d-sm-table-row {
    display: table-row !important;
  }
  .d-sm-table-cell {
    display: table-cell !important;
  }
  .d-sm-flex {
    display: flex !important;
  }
  .d-sm-inline-flex {
    display: inline-flex !important;
  }
  .d-sm-none {
    display: none !important;
  }
  .flex-sm-fill {
    flex: 1 1 auto !important;
  }
  .flex-sm-row {
    flex-direction: row !important;
  }
  .flex-sm-column {
    flex-direction: column !important;
  }
  .flex-sm-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-sm-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-sm-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-sm-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-sm-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-sm-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-sm-wrap {
    flex-wrap: wrap !important;
  }
  .flex-sm-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-sm-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-sm-start {
    justify-content: flex-start !important;
  }
  .justify-content-sm-end {
    justify-content: flex-end !important;
  }
  .justify-content-sm-center {
    justify-content: center !important;
  }
  .justify-content-sm-between {
    justify-content: space-between !important;
  }
  .justify-content-sm-around {
    justify-content: space-around !important;
  }
  .justify-content-sm-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-sm-start {
    align-items: flex-start !important;
  }
  .align-items-sm-end {
    align-items: flex-end !important;
  }
  .align-items-sm-center {
    align-items: center !important;
  }
  .align-items-sm-baseline {
    align-items: baseline !important;
  }
  .align-items-sm-stretch {
    align-items: stretch !important;
  }
  .align-content-sm-start {
    align-content: flex-start !important;
  }
  .align-content-sm-end {
    align-content: flex-end !important;
  }
  .align-content-sm-center {
    align-content: center !important;
  }
  .align-content-sm-between {
    align-content: space-between !important;
  }
  .align-content-sm-around {
    align-content: space-around !important;
  }
  .align-content-sm-stretch {
    align-content: stretch !important;
  }
  .align-self-sm-auto {
    align-self: auto !important;
  }
  .align-self-sm-start {
    align-self: flex-start !important;
  }
  .align-self-sm-end {
    align-self: flex-end !important;
  }
  .align-self-sm-center {
    align-self: center !important;
  }
  .align-self-sm-baseline {
    align-self: baseline !important;
  }
  .align-self-sm-stretch {
    align-self: stretch !important;
  }
  .order-sm-first {
    order: -1 !important;
  }
  .order-sm-0 {
    order: 0 !important;
  }
  .order-sm-1 {
    order: 1 !important;
  }
  .order-sm-2 {
    order: 2 !important;
  }
  .order-sm-3 {
    order: 3 !important;
  }
  .order-sm-4 {
    order: 4 !important;
  }
  .order-sm-5 {
    order: 5 !important;
  }
  .order-sm-last {
    order: 6 !important;
  }
  .m-sm-0 {
    margin: 0 !important;
  }
  .m-sm-1 {
    margin: 0.25rem !important;
  }
  .m-sm-2 {
    margin: 0.5rem !important;
  }
  .m-sm-3 {
    margin: 1rem !important;
  }
  .m-sm-4 {
    margin: 1.5rem !important;
  }
  .m-sm-5 {
    margin: 3rem !important;
  }
  .m-sm-auto {
    margin: auto !important;
  }
  .mx-sm-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-sm-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-sm-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-sm-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-sm-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-sm-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-sm-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-sm-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-sm-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-sm-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-sm-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-sm-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-sm-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-sm-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-sm-0 {
    margin-top: 0 !important;
  }
  .mt-sm-1 {
    margin-top: 0.25rem !important;
  }
  .mt-sm-2 {
    margin-top: 0.5rem !important;
  }
  .mt-sm-3 {
    margin-top: 1rem !important;
  }
  .mt-sm-4 {
    margin-top: 1.5rem !important;
  }
  .mt-sm-5 {
    margin-top: 3rem !important;
  }
  .mt-sm-auto {
    margin-top: auto !important;
  }
  .me-sm-0 {
    margin-inline-end: 0 !important;
  }
  .me-sm-1 {
    margin-inline-end: 0.25rem !important;
  }
  .me-sm-2 {
    margin-inline-end: 0.5rem !important;
  }
  .me-sm-3 {
    margin-inline-end: 1rem !important;
  }
  .me-sm-4 {
    margin-inline-end: 1.5rem !important;
  }
  .me-sm-5 {
    margin-inline-end: 3rem !important;
  }
  .me-sm-auto {
    margin-inline-end: auto !important;
  }
  .mb-sm-0 {
    margin-bottom: 0 !important;
  }
  .mb-sm-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-sm-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-sm-3 {
    margin-bottom: 1rem !important;
  }
  .mb-sm-4 {
    margin-bottom: 1.5rem !important;
  }
  .mb-sm-5 {
    margin-bottom: 3rem !important;
  }
  .mb-sm-auto {
    margin-bottom: auto !important;
  }
  .ms-sm-0 {
    margin-inline-start: 0 !important;
  }
  .ms-sm-1 {
    margin-inline-start: 0.25rem !important;
  }
  .ms-sm-2 {
    margin-inline-start: 0.5rem !important;
  }
  .ms-sm-3 {
    margin-inline-start: 1rem !important;
  }
  .ms-sm-4 {
    margin-inline-start: 1.5rem !important;
  }
  .ms-sm-5 {
    margin-inline-start: 3rem !important;
  }
  .ms-sm-auto {
    margin-inline-start: auto !important;
  }
  .p-sm-0 {
    padding: 0 !important;
  }
  .p-sm-1 {
    padding: 0.25rem !important;
  }
  .p-sm-2 {
    padding: 0.5rem !important;
  }
  .p-sm-3 {
    padding: 1rem !important;
  }
  .p-sm-4 {
    padding: 1.5rem !important;
  }
  .p-sm-5 {
    padding: 3rem !important;
  }
  .px-sm-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-sm-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-sm-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-sm-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-sm-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-sm-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .py-sm-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-sm-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-sm-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-sm-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-sm-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-sm-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .pt-sm-0 {
    padding-top: 0 !important;
  }
  .pt-sm-1 {
    padding-top: 0.25rem !important;
  }
  .pt-sm-2 {
    padding-top: 0.5rem !important;
  }
  .pt-sm-3 {
    padding-top: 1rem !important;
  }
  .pt-sm-4 {
    padding-top: 1.5rem !important;
  }
  .pt-sm-5 {
    padding-top: 3rem !important;
  }
  .pe-sm-0 {
    padding-inline-end: 0 !important;
  }
  .pe-sm-1 {
    padding-inline-end: 0.25rem !important;
  }
  .pe-sm-2 {
    padding-inline-end: 0.5rem !important;
  }
  .pe-sm-3 {
    padding-inline-end: 1rem !important;
  }
  .pe-sm-4 {
    padding-inline-end: 1.5rem !important;
  }
  .pe-sm-5 {
    padding-inline-end: 3rem !important;
  }
  .pb-sm-0 {
    padding-bottom: 0 !important;
  }
  .pb-sm-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-sm-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-sm-3 {
    padding-bottom: 1rem !important;
  }
  .pb-sm-4 {
    padding-bottom: 1.5rem !important;
  }
  .pb-sm-5 {
    padding-bottom: 3rem !important;
  }
  .ps-sm-0 {
    padding-inline-start: 0 !important;
  }
  .ps-sm-1 {
    padding-inline-start: 0.25rem !important;
  }
  .ps-sm-2 {
    padding-inline-start: 0.5rem !important;
  }
  .ps-sm-3 {
    padding-inline-start: 1rem !important;
  }
  .ps-sm-4 {
    padding-inline-start: 1.5rem !important;
  }
  .ps-sm-5 {
    padding-inline-start: 3rem !important;
  }
  .gap-sm-0 {
    gap: 0 !important;
  }
  .gap-sm-1 {
    gap: 0.25rem !important;
  }
  .gap-sm-2 {
    gap: 0.5rem !important;
  }
  .gap-sm-3 {
    gap: 1rem !important;
  }
  .gap-sm-4 {
    gap: 1.5rem !important;
  }
  .gap-sm-5 {
    gap: 3rem !important;
  }
  .row-gap-sm-0 {
    row-gap: 0 !important;
  }
  .row-gap-sm-1 {
    row-gap: 0.25rem !important;
  }
  .row-gap-sm-2 {
    row-gap: 0.5rem !important;
  }
  .row-gap-sm-3 {
    row-gap: 1rem !important;
  }
  .row-gap-sm-4 {
    row-gap: 1.5rem !important;
  }
  .row-gap-sm-5 {
    row-gap: 3rem !important;
  }
  .column-gap-sm-0 {
    column-gap: 0 !important;
  }
  .column-gap-sm-1 {
    column-gap: 0.25rem !important;
  }
  .column-gap-sm-2 {
    column-gap: 0.5rem !important;
  }
  .column-gap-sm-3 {
    column-gap: 1rem !important;
  }
  .column-gap-sm-4 {
    column-gap: 1.5rem !important;
  }
  .column-gap-sm-5 {
    column-gap: 3rem !important;
  }
  .text-sm-start {
    text-align: start !important;
  }
  .text-sm-end {
    text-align: end !important;
  }
  .text-sm-center {
    text-align: center !important;
  }
}
@media (min-width: 768px) {
  .float-md-start {
    float: inline-start !important;
  }
  .float-md-end {
    float: inline-end !important;
  }
  .float-md-none {
    float: none !important;
  }
  .object-fit-md-contain {
    object-fit: contain !important;
  }
  .object-fit-md-cover {
    object-fit: cover !important;
  }
  .object-fit-md-fill {
    object-fit: fill !important;
  }
  .object-fit-md-scale {
    object-fit: scale-down !important;
  }
  .object-fit-md-none {
    object-fit: none !important;
  }
  .d-md-inline {
    display: inline !important;
  }
  .d-md-inline-block {
    display: inline-block !important;
  }
  .d-md-block {
    display: block !important;
  }
  .d-md-grid {
    display: grid !important;
  }
  .d-md-inline-grid {
    display: inline-grid !important;
  }
  .d-md-table {
    display: table !important;
  }
  .d-md-table-row {
    display: table-row !important;
  }
  .d-md-table-cell {
    display: table-cell !important;
  }
  .d-md-flex {
    display: flex !important;
  }
  .d-md-inline-flex {
    display: inline-flex !important;
  }
  .d-md-none {
    display: none !important;
  }
  .flex-md-fill {
    flex: 1 1 auto !important;
  }
  .flex-md-row {
    flex-direction: row !important;
  }
  .flex-md-column {
    flex-direction: column !important;
  }
  .flex-md-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-md-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-md-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-md-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-md-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-md-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-md-wrap {
    flex-wrap: wrap !important;
  }
  .flex-md-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-md-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-md-start {
    justify-content: flex-start !important;
  }
  .justify-content-md-end {
    justify-content: flex-end !important;
  }
  .justify-content-md-center {
    justify-content: center !important;
  }
  .justify-content-md-between {
    justify-content: space-between !important;
  }
  .justify-content-md-around {
    justify-content: space-around !important;
  }
  .justify-content-md-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-md-start {
    align-items: flex-start !important;
  }
  .align-items-md-end {
    align-items: flex-end !important;
  }
  .align-items-md-center {
    align-items: center !important;
  }
  .align-items-md-baseline {
    align-items: baseline !important;
  }
  .align-items-md-stretch {
    align-items: stretch !important;
  }
  .align-content-md-start {
    align-content: flex-start !important;
  }
  .align-content-md-end {
    align-content: flex-end !important;
  }
  .align-content-md-center {
    align-content: center !important;
  }
  .align-content-md-between {
    align-content: space-between !important;
  }
  .align-content-md-around {
    align-content: space-around !important;
  }
  .align-content-md-stretch {
    align-content: stretch !important;
  }
  .align-self-md-auto {
    align-self: auto !important;
  }
  .align-self-md-start {
    align-self: flex-start !important;
  }
  .align-self-md-end {
    align-self: flex-end !important;
  }
  .align-self-md-center {
    align-self: center !important;
  }
  .align-self-md-baseline {
    align-self: baseline !important;
  }
  .align-self-md-stretch {
    align-self: stretch !important;
  }
  .order-md-first {
    order: -1 !important;
  }
  .order-md-0 {
    order: 0 !important;
  }
  .order-md-1 {
    order: 1 !important;
  }
  .order-md-2 {
    order: 2 !important;
  }
  .order-md-3 {
    order: 3 !important;
  }
  .order-md-4 {
    order: 4 !important;
  }
  .order-md-5 {
    order: 5 !important;
  }
  .order-md-last {
    order: 6 !important;
  }
  .m-md-0 {
    margin: 0 !important;
  }
  .m-md-1 {
    margin: 0.25rem !important;
  }
  .m-md-2 {
    margin: 0.5rem !important;
  }
  .m-md-3 {
    margin: 1rem !important;
  }
  .m-md-4 {
    margin: 1.5rem !important;
  }
  .m-md-5 {
    margin: 3rem !important;
  }
  .m-md-auto {
    margin: auto !important;
  }
  .mx-md-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-md-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-md-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-md-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-md-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-md-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-md-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-md-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-md-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-md-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-md-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-md-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-md-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-md-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-md-0 {
    margin-top: 0 !important;
  }
  .mt-md-1 {
    margin-top: 0.25rem !important;
  }
  .mt-md-2 {
    margin-top: 0.5rem !important;
  }
  .mt-md-3 {
    margin-top: 1rem !important;
  }
  .mt-md-4 {
    margin-top: 1.5rem !important;
  }
  .mt-md-5 {
    margin-top: 3rem !important;
  }
  .mt-md-auto {
    margin-top: auto !important;
  }
  .me-md-0 {
    margin-inline-end: 0 !important;
  }
  .me-md-1 {
    margin-inline-end: 0.25rem !important;
  }
  .me-md-2 {
    margin-inline-end: 0.5rem !important;
  }
  .me-md-3 {
    margin-inline-end: 1rem !important;
  }
  .me-md-4 {
    margin-inline-end: 1.5rem !important;
  }
  .me-md-5 {
    margin-inline-end: 3rem !important;
  }
  .me-md-auto {
    margin-inline-end: auto !important;
  }
  .mb-md-0 {
    margin-bottom: 0 !important;
  }
  .mb-md-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-md-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-md-3 {
    margin-bottom: 1rem !important;
  }
  .mb-md-4 {
    margin-bottom: 1.5rem !important;
  }
  .mb-md-5 {
    margin-bottom: 3rem !important;
  }
  .mb-md-auto {
    margin-bottom: auto !important;
  }
  .ms-md-0 {
    margin-inline-start: 0 !important;
  }
  .ms-md-1 {
    margin-inline-start: 0.25rem !important;
  }
  .ms-md-2 {
    margin-inline-start: 0.5rem !important;
  }
  .ms-md-3 {
    margin-inline-start: 1rem !important;
  }
  .ms-md-4 {
    margin-inline-start: 1.5rem !important;
  }
  .ms-md-5 {
    margin-inline-start: 3rem !important;
  }
  .ms-md-auto {
    margin-inline-start: auto !important;
  }
  .p-md-0 {
    padding: 0 !important;
  }
  .p-md-1 {
    padding: 0.25rem !important;
  }
  .p-md-2 {
    padding: 0.5rem !important;
  }
  .p-md-3 {
    padding: 1rem !important;
  }
  .p-md-4 {
    padding: 1.5rem !important;
  }
  .p-md-5 {
    padding: 3rem !important;
  }
  .px-md-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-md-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-md-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-md-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-md-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-md-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .py-md-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-md-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-md-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-md-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-md-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-md-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .pt-md-0 {
    padding-top: 0 !important;
  }
  .pt-md-1 {
    padding-top: 0.25rem !important;
  }
  .pt-md-2 {
    padding-top: 0.5rem !important;
  }
  .pt-md-3 {
    padding-top: 1rem !important;
  }
  .pt-md-4 {
    padding-top: 1.5rem !important;
  }
  .pt-md-5 {
    padding-top: 3rem !important;
  }
  .pe-md-0 {
    padding-inline-end: 0 !important;
  }
  .pe-md-1 {
    padding-inline-end: 0.25rem !important;
  }
  .pe-md-2 {
    padding-inline-end: 0.5rem !important;
  }
  .pe-md-3 {
    padding-inline-end: 1rem !important;
  }
  .pe-md-4 {
    padding-inline-end: 1.5rem !important;
  }
  .pe-md-5 {
    padding-inline-end: 3rem !important;
  }
  .pb-md-0 {
    padding-bottom: 0 !important;
  }
  .pb-md-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-md-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-md-3 {
    padding-bottom: 1rem !important;
  }
  .pb-md-4 {
    padding-bottom: 1.5rem !important;
  }
  .pb-md-5 {
    padding-bottom: 3rem !important;
  }
  .ps-md-0 {
    padding-inline-start: 0 !important;
  }
  .ps-md-1 {
    padding-inline-start: 0.25rem !important;
  }
  .ps-md-2 {
    padding-inline-start: 0.5rem !important;
  }
  .ps-md-3 {
    padding-inline-start: 1rem !important;
  }
  .ps-md-4 {
    padding-inline-start: 1.5rem !important;
  }
  .ps-md-5 {
    padding-inline-start: 3rem !important;
  }
  .gap-md-0 {
    gap: 0 !important;
  }
  .gap-md-1 {
    gap: 0.25rem !important;
  }
  .gap-md-2 {
    gap: 0.5rem !important;
  }
  .gap-md-3 {
    gap: 1rem !important;
  }
  .gap-md-4 {
    gap: 1.5rem !important;
  }
  .gap-md-5 {
    gap: 3rem !important;
  }
  .row-gap-md-0 {
    row-gap: 0 !important;
  }
  .row-gap-md-1 {
    row-gap: 0.25rem !important;
  }
  .row-gap-md-2 {
    row-gap: 0.5rem !important;
  }
  .row-gap-md-3 {
    row-gap: 1rem !important;
  }
  .row-gap-md-4 {
    row-gap: 1.5rem !important;
  }
  .row-gap-md-5 {
    row-gap: 3rem !important;
  }
  .column-gap-md-0 {
    column-gap: 0 !important;
  }
  .column-gap-md-1 {
    column-gap: 0.25rem !important;
  }
  .column-gap-md-2 {
    column-gap: 0.5rem !important;
  }
  .column-gap-md-3 {
    column-gap: 1rem !important;
  }
  .column-gap-md-4 {
    column-gap: 1.5rem !important;
  }
  .column-gap-md-5 {
    column-gap: 3rem !important;
  }
  .text-md-start {
    text-align: start !important;
  }
  .text-md-end {
    text-align: end !important;
  }
  .text-md-center {
    text-align: center !important;
  }
}
@media (min-width: 992px) {
  .float-lg-start {
    float: inline-start !important;
  }
  .float-lg-end {
    float: inline-end !important;
  }
  .float-lg-none {
    float: none !important;
  }
  .object-fit-lg-contain {
    object-fit: contain !important;
  }
  .object-fit-lg-cover {
    object-fit: cover !important;
  }
  .object-fit-lg-fill {
    object-fit: fill !important;
  }
  .object-fit-lg-scale {
    object-fit: scale-down !important;
  }
  .object-fit-lg-none {
    object-fit: none !important;
  }
  .d-lg-inline {
    display: inline !important;
  }
  .d-lg-inline-block {
    display: inline-block !important;
  }
  .d-lg-block {
    display: block !important;
  }
  .d-lg-grid {
    display: grid !important;
  }
  .d-lg-inline-grid {
    display: inline-grid !important;
  }
  .d-lg-table {
    display: table !important;
  }
  .d-lg-table-row {
    display: table-row !important;
  }
  .d-lg-table-cell {
    display: table-cell !important;
  }
  .d-lg-flex {
    display: flex !important;
  }
  .d-lg-inline-flex {
    display: inline-flex !important;
  }
  .d-lg-none {
    display: none !important;
  }
  .flex-lg-fill {
    flex: 1 1 auto !important;
  }
  .flex-lg-row {
    flex-direction: row !important;
  }
  .flex-lg-column {
    flex-direction: column !important;
  }
  .flex-lg-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-lg-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-lg-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-lg-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-lg-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-lg-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-lg-wrap {
    flex-wrap: wrap !important;
  }
  .flex-lg-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-lg-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-lg-start {
    justify-content: flex-start !important;
  }
  .justify-content-lg-end {
    justify-content: flex-end !important;
  }
  .justify-content-lg-center {
    justify-content: center !important;
  }
  .justify-content-lg-between {
    justify-content: space-between !important;
  }
  .justify-content-lg-around {
    justify-content: space-around !important;
  }
  .justify-content-lg-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-lg-start {
    align-items: flex-start !important;
  }
  .align-items-lg-end {
    align-items: flex-end !important;
  }
  .align-items-lg-center {
    align-items: center !important;
  }
  .align-items-lg-baseline {
    align-items: baseline !important;
  }
  .align-items-lg-stretch {
    align-items: stretch !important;
  }
  .align-content-lg-start {
    align-content: flex-start !important;
  }
  .align-content-lg-end {
    align-content: flex-end !important;
  }
  .align-content-lg-center {
    align-content: center !important;
  }
  .align-content-lg-between {
    align-content: space-between !important;
  }
  .align-content-lg-around {
    align-content: space-around !important;
  }
  .align-content-lg-stretch {
    align-content: stretch !important;
  }
  .align-self-lg-auto {
    align-self: auto !important;
  }
  .align-self-lg-start {
    align-self: flex-start !important;
  }
  .align-self-lg-end {
    align-self: flex-end !important;
  }
  .align-self-lg-center {
    align-self: center !important;
  }
  .align-self-lg-baseline {
    align-self: baseline !important;
  }
  .align-self-lg-stretch {
    align-self: stretch !important;
  }
  .order-lg-first {
    order: -1 !important;
  }
  .order-lg-0 {
    order: 0 !important;
  }
  .order-lg-1 {
    order: 1 !important;
  }
  .order-lg-2 {
    order: 2 !important;
  }
  .order-lg-3 {
    order: 3 !important;
  }
  .order-lg-4 {
    order: 4 !important;
  }
  .order-lg-5 {
    order: 5 !important;
  }
  .order-lg-last {
    order: 6 !important;
  }
  .m-lg-0 {
    margin: 0 !important;
  }
  .m-lg-1 {
    margin: 0.25rem !important;
  }
  .m-lg-2 {
    margin: 0.5rem !important;
  }
  .m-lg-3 {
    margin: 1rem !important;
  }
  .m-lg-4 {
    margin: 1.5rem !important;
  }
  .m-lg-5 {
    margin: 3rem !important;
  }
  .m-lg-auto {
    margin: auto !important;
  }
  .mx-lg-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-lg-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-lg-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-lg-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-lg-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-lg-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-lg-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-lg-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-lg-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-lg-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-lg-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-lg-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-lg-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-lg-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-lg-0 {
    margin-top: 0 !important;
  }
  .mt-lg-1 {
    margin-top: 0.25rem !important;
  }
  .mt-lg-2 {
    margin-top: 0.5rem !important;
  }
  .mt-lg-3 {
    margin-top: 1rem !important;
  }
  .mt-lg-4 {
    margin-top: 1.5rem !important;
  }
  .mt-lg-5 {
    margin-top: 3rem !important;
  }
  .mt-lg-auto {
    margin-top: auto !important;
  }
  .me-lg-0 {
    margin-inline-end: 0 !important;
  }
  .me-lg-1 {
    margin-inline-end: 0.25rem !important;
  }
  .me-lg-2 {
    margin-inline-end: 0.5rem !important;
  }
  .me-lg-3 {
    margin-inline-end: 1rem !important;
  }
  .me-lg-4 {
    margin-inline-end: 1.5rem !important;
  }
  .me-lg-5 {
    margin-inline-end: 3rem !important;
  }
  .me-lg-auto {
    margin-inline-end: auto !important;
  }
  .mb-lg-0 {
    margin-bottom: 0 !important;
  }
  .mb-lg-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-lg-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-lg-3 {
    margin-bottom: 1rem !important;
  }
  .mb-lg-4 {
    margin-bottom: 1.5rem !important;
  }
  .mb-lg-5 {
    margin-bottom: 3rem !important;
  }
  .mb-lg-auto {
    margin-bottom: auto !important;
  }
  .ms-lg-0 {
    margin-inline-start: 0 !important;
  }
  .ms-lg-1 {
    margin-inline-start: 0.25rem !important;
  }
  .ms-lg-2 {
    margin-inline-start: 0.5rem !important;
  }
  .ms-lg-3 {
    margin-inline-start: 1rem !important;
  }
  .ms-lg-4 {
    margin-inline-start: 1.5rem !important;
  }
  .ms-lg-5 {
    margin-inline-start: 3rem !important;
  }
  .ms-lg-auto {
    margin-inline-start: auto !important;
  }
  .p-lg-0 {
    padding: 0 !important;
  }
  .p-lg-1 {
    padding: 0.25rem !important;
  }
  .p-lg-2 {
    padding: 0.5rem !important;
  }
  .p-lg-3 {
    padding: 1rem !important;
  }
  .p-lg-4 {
    padding: 1.5rem !important;
  }
  .p-lg-5 {
    padding: 3rem !important;
  }
  .px-lg-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-lg-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-lg-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-lg-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-lg-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-lg-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .py-lg-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-lg-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-lg-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-lg-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-lg-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-lg-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .pt-lg-0 {
    padding-top: 0 !important;
  }
  .pt-lg-1 {
    padding-top: 0.25rem !important;
  }
  .pt-lg-2 {
    padding-top: 0.5rem !important;
  }
  .pt-lg-3 {
    padding-top: 1rem !important;
  }
  .pt-lg-4 {
    padding-top: 1.5rem !important;
  }
  .pt-lg-5 {
    padding-top: 3rem !important;
  }
  .pe-lg-0 {
    padding-inline-end: 0 !important;
  }
  .pe-lg-1 {
    padding-inline-end: 0.25rem !important;
  }
  .pe-lg-2 {
    padding-inline-end: 0.5rem !important;
  }
  .pe-lg-3 {
    padding-inline-end: 1rem !important;
  }
  .pe-lg-4 {
    padding-inline-end: 1.5rem !important;
  }
  .pe-lg-5 {
    padding-inline-end: 3rem !important;
  }
  .pb-lg-0 {
    padding-bottom: 0 !important;
  }
  .pb-lg-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-lg-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-lg-3 {
    padding-bottom: 1rem !important;
  }
  .pb-lg-4 {
    padding-bottom: 1.5rem !important;
  }
  .pb-lg-5 {
    padding-bottom: 3rem !important;
  }
  .ps-lg-0 {
    padding-inline-start: 0 !important;
  }
  .ps-lg-1 {
    padding-inline-start: 0.25rem !important;
  }
  .ps-lg-2 {
    padding-inline-start: 0.5rem !important;
  }
  .ps-lg-3 {
    padding-inline-start: 1rem !important;
  }
  .ps-lg-4 {
    padding-inline-start: 1.5rem !important;
  }
  .ps-lg-5 {
    padding-inline-start: 3rem !important;
  }
  .gap-lg-0 {
    gap: 0 !important;
  }
  .gap-lg-1 {
    gap: 0.25rem !important;
  }
  .gap-lg-2 {
    gap: 0.5rem !important;
  }
  .gap-lg-3 {
    gap: 1rem !important;
  }
  .gap-lg-4 {
    gap: 1.5rem !important;
  }
  .gap-lg-5 {
    gap: 3rem !important;
  }
  .row-gap-lg-0 {
    row-gap: 0 !important;
  }
  .row-gap-lg-1 {
    row-gap: 0.25rem !important;
  }
  .row-gap-lg-2 {
    row-gap: 0.5rem !important;
  }
  .row-gap-lg-3 {
    row-gap: 1rem !important;
  }
  .row-gap-lg-4 {
    row-gap: 1.5rem !important;
  }
  .row-gap-lg-5 {
    row-gap: 3rem !important;
  }
  .column-gap-lg-0 {
    column-gap: 0 !important;
  }
  .column-gap-lg-1 {
    column-gap: 0.25rem !important;
  }
  .column-gap-lg-2 {
    column-gap: 0.5rem !important;
  }
  .column-gap-lg-3 {
    column-gap: 1rem !important;
  }
  .column-gap-lg-4 {
    column-gap: 1.5rem !important;
  }
  .column-gap-lg-5 {
    column-gap: 3rem !important;
  }
  .text-lg-start {
    text-align: start !important;
  }
  .text-lg-end {
    text-align: end !important;
  }
  .text-lg-center {
    text-align: center !important;
  }
}
@media (min-width: 1200px) {
  .float-xl-start {
    float: inline-start !important;
  }
  .float-xl-end {
    float: inline-end !important;
  }
  .float-xl-none {
    float: none !important;
  }
  .object-fit-xl-contain {
    object-fit: contain !important;
  }
  .object-fit-xl-cover {
    object-fit: cover !important;
  }
  .object-fit-xl-fill {
    object-fit: fill !important;
  }
  .object-fit-xl-scale {
    object-fit: scale-down !important;
  }
  .object-fit-xl-none {
    object-fit: none !important;
  }
  .d-xl-inline {
    display: inline !important;
  }
  .d-xl-inline-block {
    display: inline-block !important;
  }
  .d-xl-block {
    display: block !important;
  }
  .d-xl-grid {
    display: grid !important;
  }
  .d-xl-inline-grid {
    display: inline-grid !important;
  }
  .d-xl-table {
    display: table !important;
  }
  .d-xl-table-row {
    display: table-row !important;
  }
  .d-xl-table-cell {
    display: table-cell !important;
  }
  .d-xl-flex {
    display: flex !important;
  }
  .d-xl-inline-flex {
    display: inline-flex !important;
  }
  .d-xl-none {
    display: none !important;
  }
  .flex-xl-fill {
    flex: 1 1 auto !important;
  }
  .flex-xl-row {
    flex-direction: row !important;
  }
  .flex-xl-column {
    flex-direction: column !important;
  }
  .flex-xl-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-xl-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-xl-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-xl-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-xl-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-xl-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-xl-wrap {
    flex-wrap: wrap !important;
  }
  .flex-xl-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-xl-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-xl-start {
    justify-content: flex-start !important;
  }
  .justify-content-xl-end {
    justify-content: flex-end !important;
  }
  .justify-content-xl-center {
    justify-content: center !important;
  }
  .justify-content-xl-between {
    justify-content: space-between !important;
  }
  .justify-content-xl-around {
    justify-content: space-around !important;
  }
  .justify-content-xl-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-xl-start {
    align-items: flex-start !important;
  }
  .align-items-xl-end {
    align-items: flex-end !important;
  }
  .align-items-xl-center {
    align-items: center !important;
  }
  .align-items-xl-baseline {
    align-items: baseline !important;
  }
  .align-items-xl-stretch {
    align-items: stretch !important;
  }
  .align-content-xl-start {
    align-content: flex-start !important;
  }
  .align-content-xl-end {
    align-content: flex-end !important;
  }
  .align-content-xl-center {
    align-content: center !important;
  }
  .align-content-xl-between {
    align-content: space-between !important;
  }
  .align-content-xl-around {
    align-content: space-around !important;
  }
  .align-content-xl-stretch {
    align-content: stretch !important;
  }
  .align-self-xl-auto {
    align-self: auto !important;
  }
  .align-self-xl-start {
    align-self: flex-start !important;
  }
  .align-self-xl-end {
    align-self: flex-end !important;
  }
  .align-self-xl-center {
    align-self: center !important;
  }
  .align-self-xl-baseline {
    align-self: baseline !important;
  }
  .align-self-xl-stretch {
    align-self: stretch !important;
  }
  .order-xl-first {
    order: -1 !important;
  }
  .order-xl-0 {
    order: 0 !important;
  }
  .order-xl-1 {
    order: 1 !important;
  }
  .order-xl-2 {
    order: 2 !important;
  }
  .order-xl-3 {
    order: 3 !important;
  }
  .order-xl-4 {
    order: 4 !important;
  }
  .order-xl-5 {
    order: 5 !important;
  }
  .order-xl-last {
    order: 6 !important;
  }
  .m-xl-0 {
    margin: 0 !important;
  }
  .m-xl-1 {
    margin: 0.25rem !important;
  }
  .m-xl-2 {
    margin: 0.5rem !important;
  }
  .m-xl-3 {
    margin: 1rem !important;
  }
  .m-xl-4 {
    margin: 1.5rem !important;
  }
  .m-xl-5 {
    margin: 3rem !important;
  }
  .m-xl-auto {
    margin: auto !important;
  }
  .mx-xl-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-xl-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-xl-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-xl-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-xl-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-xl-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-xl-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-xl-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-xl-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-xl-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-xl-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-xl-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-xl-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-xl-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-xl-0 {
    margin-top: 0 !important;
  }
  .mt-xl-1 {
    margin-top: 0.25rem !important;
  }
  .mt-xl-2 {
    margin-top: 0.5rem !important;
  }
  .mt-xl-3 {
    margin-top: 1rem !important;
  }
  .mt-xl-4 {
    margin-top: 1.5rem !important;
  }
  .mt-xl-5 {
    margin-top: 3rem !important;
  }
  .mt-xl-auto {
    margin-top: auto !important;
  }
  .me-xl-0 {
    margin-inline-end: 0 !important;
  }
  .me-xl-1 {
    margin-inline-end: 0.25rem !important;
  }
  .me-xl-2 {
    margin-inline-end: 0.5rem !important;
  }
  .me-xl-3 {
    margin-inline-end: 1rem !important;
  }
  .me-xl-4 {
    margin-inline-end: 1.5rem !important;
  }
  .me-xl-5 {
    margin-inline-end: 3rem !important;
  }
  .me-xl-auto {
    margin-inline-end: auto !important;
  }
  .mb-xl-0 {
    margin-bottom: 0 !important;
  }
  .mb-xl-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-xl-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-xl-3 {
    margin-bottom: 1rem !important;
  }
  .mb-xl-4 {
    margin-bottom: 1.5rem !important;
  }
  .mb-xl-5 {
    margin-bottom: 3rem !important;
  }
  .mb-xl-auto {
    margin-bottom: auto !important;
  }
  .ms-xl-0 {
    margin-inline-start: 0 !important;
  }
  .ms-xl-1 {
    margin-inline-start: 0.25rem !important;
  }
  .ms-xl-2 {
    margin-inline-start: 0.5rem !important;
  }
  .ms-xl-3 {
    margin-inline-start: 1rem !important;
  }
  .ms-xl-4 {
    margin-inline-start: 1.5rem !important;
  }
  .ms-xl-5 {
    margin-inline-start: 3rem !important;
  }
  .ms-xl-auto {
    margin-inline-start: auto !important;
  }
  .p-xl-0 {
    padding: 0 !important;
  }
  .p-xl-1 {
    padding: 0.25rem !important;
  }
  .p-xl-2 {
    padding: 0.5rem !important;
  }
  .p-xl-3 {
    padding: 1rem !important;
  }
  .p-xl-4 {
    padding: 1.5rem !important;
  }
  .p-xl-5 {
    padding: 3rem !important;
  }
  .px-xl-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-xl-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-xl-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-xl-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-xl-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-xl-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .py-xl-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-xl-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-xl-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-xl-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-xl-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-xl-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .pt-xl-0 {
    padding-top: 0 !important;
  }
  .pt-xl-1 {
    padding-top: 0.25rem !important;
  }
  .pt-xl-2 {
    padding-top: 0.5rem !important;
  }
  .pt-xl-3 {
    padding-top: 1rem !important;
  }
  .pt-xl-4 {
    padding-top: 1.5rem !important;
  }
  .pt-xl-5 {
    padding-top: 3rem !important;
  }
  .pe-xl-0 {
    padding-inline-end: 0 !important;
  }
  .pe-xl-1 {
    padding-inline-end: 0.25rem !important;
  }
  .pe-xl-2 {
    padding-inline-end: 0.5rem !important;
  }
  .pe-xl-3 {
    padding-inline-end: 1rem !important;
  }
  .pe-xl-4 {
    padding-inline-end: 1.5rem !important;
  }
  .pe-xl-5 {
    padding-inline-end: 3rem !important;
  }
  .pb-xl-0 {
    padding-bottom: 0 !important;
  }
  .pb-xl-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-xl-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-xl-3 {
    padding-bottom: 1rem !important;
  }
  .pb-xl-4 {
    padding-bottom: 1.5rem !important;
  }
  .pb-xl-5 {
    padding-bottom: 3rem !important;
  }
  .ps-xl-0 {
    padding-inline-start: 0 !important;
  }
  .ps-xl-1 {
    padding-inline-start: 0.25rem !important;
  }
  .ps-xl-2 {
    padding-inline-start: 0.5rem !important;
  }
  .ps-xl-3 {
    padding-inline-start: 1rem !important;
  }
  .ps-xl-4 {
    padding-inline-start: 1.5rem !important;
  }
  .ps-xl-5 {
    padding-inline-start: 3rem !important;
  }
  .gap-xl-0 {
    gap: 0 !important;
  }
  .gap-xl-1 {
    gap: 0.25rem !important;
  }
  .gap-xl-2 {
    gap: 0.5rem !important;
  }
  .gap-xl-3 {
    gap: 1rem !important;
  }
  .gap-xl-4 {
    gap: 1.5rem !important;
  }
  .gap-xl-5 {
    gap: 3rem !important;
  }
  .row-gap-xl-0 {
    row-gap: 0 !important;
  }
  .row-gap-xl-1 {
    row-gap: 0.25rem !important;
  }
  .row-gap-xl-2 {
    row-gap: 0.5rem !important;
  }
  .row-gap-xl-3 {
    row-gap: 1rem !important;
  }
  .row-gap-xl-4 {
    row-gap: 1.5rem !important;
  }
  .row-gap-xl-5 {
    row-gap: 3rem !important;
  }
  .column-gap-xl-0 {
    column-gap: 0 !important;
  }
  .column-gap-xl-1 {
    column-gap: 0.25rem !important;
  }
  .column-gap-xl-2 {
    column-gap: 0.5rem !important;
  }
  .column-gap-xl-3 {
    column-gap: 1rem !important;
  }
  .column-gap-xl-4 {
    column-gap: 1.5rem !important;
  }
  .column-gap-xl-5 {
    column-gap: 3rem !important;
  }
  .text-xl-start {
    text-align: start !important;
  }
  .text-xl-end {
    text-align: end !important;
  }
  .text-xl-center {
    text-align: center !important;
  }
}
@media (min-width: 1400px) {
  .float-xxl-start {
    float: inline-start !important;
  }
  .float-xxl-end {
    float: inline-end !important;
  }
  .float-xxl-none {
    float: none !important;
  }
  .object-fit-xxl-contain {
    object-fit: contain !important;
  }
  .object-fit-xxl-cover {
    object-fit: cover !important;
  }
  .object-fit-xxl-fill {
    object-fit: fill !important;
  }
  .object-fit-xxl-scale {
    object-fit: scale-down !important;
  }
  .object-fit-xxl-none {
    object-fit: none !important;
  }
  .d-xxl-inline {
    display: inline !important;
  }
  .d-xxl-inline-block {
    display: inline-block !important;
  }
  .d-xxl-block {
    display: block !important;
  }
  .d-xxl-grid {
    display: grid !important;
  }
  .d-xxl-inline-grid {
    display: inline-grid !important;
  }
  .d-xxl-table {
    display: table !important;
  }
  .d-xxl-table-row {
    display: table-row !important;
  }
  .d-xxl-table-cell {
    display: table-cell !important;
  }
  .d-xxl-flex {
    display: flex !important;
  }
  .d-xxl-inline-flex {
    display: inline-flex !important;
  }
  .d-xxl-none {
    display: none !important;
  }
  .flex-xxl-fill {
    flex: 1 1 auto !important;
  }
  .flex-xxl-row {
    flex-direction: row !important;
  }
  .flex-xxl-column {
    flex-direction: column !important;
  }
  .flex-xxl-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-xxl-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-xxl-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-xxl-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-xxl-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-xxl-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-xxl-wrap {
    flex-wrap: wrap !important;
  }
  .flex-xxl-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-xxl-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-xxl-start {
    justify-content: flex-start !important;
  }
  .justify-content-xxl-end {
    justify-content: flex-end !important;
  }
  .justify-content-xxl-center {
    justify-content: center !important;
  }
  .justify-content-xxl-between {
    justify-content: space-between !important;
  }
  .justify-content-xxl-around {
    justify-content: space-around !important;
  }
  .justify-content-xxl-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-xxl-start {
    align-items: flex-start !important;
  }
  .align-items-xxl-end {
    align-items: flex-end !important;
  }
  .align-items-xxl-center {
    align-items: center !important;
  }
  .align-items-xxl-baseline {
    align-items: baseline !important;
  }
  .align-items-xxl-stretch {
    align-items: stretch !important;
  }
  .align-content-xxl-start {
    align-content: flex-start !important;
  }
  .align-content-xxl-end {
    align-content: flex-end !important;
  }
  .align-content-xxl-center {
    align-content: center !important;
  }
  .align-content-xxl-between {
    align-content: space-between !important;
  }
  .align-content-xxl-around {
    align-content: space-around !important;
  }
  .align-content-xxl-stretch {
    align-content: stretch !important;
  }
  .align-self-xxl-auto {
    align-self: auto !important;
  }
  .align-self-xxl-start {
    align-self: flex-start !important;
  }
  .align-self-xxl-end {
    align-self: flex-end !important;
  }
  .align-self-xxl-center {
    align-self: center !important;
  }
  .align-self-xxl-baseline {
    align-self: baseline !important;
  }
  .align-self-xxl-stretch {
    align-self: stretch !important;
  }
  .order-xxl-first {
    order: -1 !important;
  }
  .order-xxl-0 {
    order: 0 !important;
  }
  .order-xxl-1 {
    order: 1 !important;
  }
  .order-xxl-2 {
    order: 2 !important;
  }
  .order-xxl-3 {
    order: 3 !important;
  }
  .order-xxl-4 {
    order: 4 !important;
  }
  .order-xxl-5 {
    order: 5 !important;
  }
  .order-xxl-last {
    order: 6 !important;
  }
  .m-xxl-0 {
    margin: 0 !important;
  }
  .m-xxl-1 {
    margin: 0.25rem !important;
  }
  .m-xxl-2 {
    margin: 0.5rem !important;
  }
  .m-xxl-3 {
    margin: 1rem !important;
  }
  .m-xxl-4 {
    margin: 1.5rem !important;
  }
  .m-xxl-5 {
    margin: 3rem !important;
  }
  .m-xxl-auto {
    margin: auto !important;
  }
  .mx-xxl-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-xxl-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-xxl-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-xxl-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-xxl-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-xxl-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-xxl-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-xxl-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-xxl-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-xxl-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-xxl-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-xxl-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-xxl-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-xxl-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-xxl-0 {
    margin-top: 0 !important;
  }
  .mt-xxl-1 {
    margin-top: 0.25rem !important;
  }
  .mt-xxl-2 {
    margin-top: 0.5rem !important;
  }
  .mt-xxl-3 {
    margin-top: 1rem !important;
  }
  .mt-xxl-4 {
    margin-top: 1.5rem !important;
  }
  .mt-xxl-5 {
    margin-top: 3rem !important;
  }
  .mt-xxl-auto {
    margin-top: auto !important;
  }
  .me-xxl-0 {
    margin-inline-end: 0 !important;
  }
  .me-xxl-1 {
    margin-inline-end: 0.25rem !important;
  }
  .me-xxl-2 {
    margin-inline-end: 0.5rem !important;
  }
  .me-xxl-3 {
    margin-inline-end: 1rem !important;
  }
  .me-xxl-4 {
    margin-inline-end: 1.5rem !important;
  }
  .me-xxl-5 {
    margin-inline-end: 3rem !important;
  }
  .me-xxl-auto {
    margin-inline-end: auto !important;
  }
  .mb-xxl-0 {
    margin-bottom: 0 !important;
  }
  .mb-xxl-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-xxl-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-xxl-3 {
    margin-bottom: 1rem !important;
  }
  .mb-xxl-4 {
    margin-bottom: 1.5rem !important;
  }
  .mb-xxl-5 {
    margin-bottom: 3rem !important;
  }
  .mb-xxl-auto {
    margin-bottom: auto !important;
  }
  .ms-xxl-0 {
    margin-inline-start: 0 !important;
  }
  .ms-xxl-1 {
    margin-inline-start: 0.25rem !important;
  }
  .ms-xxl-2 {
    margin-inline-start: 0.5rem !important;
  }
  .ms-xxl-3 {
    margin-inline-start: 1rem !important;
  }
  .ms-xxl-4 {
    margin-inline-start: 1.5rem !important;
  }
  .ms-xxl-5 {
    margin-inline-start: 3rem !important;
  }
  .ms-xxl-auto {
    margin-inline-start: auto !important;
  }
  .p-xxl-0 {
    padding: 0 !important;
  }
  .p-xxl-1 {
    padding: 0.25rem !important;
  }
  .p-xxl-2 {
    padding: 0.5rem !important;
  }
  .p-xxl-3 {
    padding: 1rem !important;
  }
  .p-xxl-4 {
    padding: 1.5rem !important;
  }
  .p-xxl-5 {
    padding: 3rem !important;
  }
  .px-xxl-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-xxl-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-xxl-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-xxl-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-xxl-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-xxl-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .py-xxl-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-xxl-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-xxl-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-xxl-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-xxl-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-xxl-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .pt-xxl-0 {
    padding-top: 0 !important;
  }
  .pt-xxl-1 {
    padding-top: 0.25rem !important;
  }
  .pt-xxl-2 {
    padding-top: 0.5rem !important;
  }
  .pt-xxl-3 {
    padding-top: 1rem !important;
  }
  .pt-xxl-4 {
    padding-top: 1.5rem !important;
  }
  .pt-xxl-5 {
    padding-top: 3rem !important;
  }
  .pe-xxl-0 {
    padding-inline-end: 0 !important;
  }
  .pe-xxl-1 {
    padding-inline-end: 0.25rem !important;
  }
  .pe-xxl-2 {
    padding-inline-end: 0.5rem !important;
  }
  .pe-xxl-3 {
    padding-inline-end: 1rem !important;
  }
  .pe-xxl-4 {
    padding-inline-end: 1.5rem !important;
  }
  .pe-xxl-5 {
    padding-inline-end: 3rem !important;
  }
  .pb-xxl-0 {
    padding-bottom: 0 !important;
  }
  .pb-xxl-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-xxl-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-xxl-3 {
    padding-bottom: 1rem !important;
  }
  .pb-xxl-4 {
    padding-bottom: 1.5rem !important;
  }
  .pb-xxl-5 {
    padding-bottom: 3rem !important;
  }
  .ps-xxl-0 {
    padding-inline-start: 0 !important;
  }
  .ps-xxl-1 {
    padding-inline-start: 0.25rem !important;
  }
  .ps-xxl-2 {
    padding-inline-start: 0.5rem !important;
  }
  .ps-xxl-3 {
    padding-inline-start: 1rem !important;
  }
  .ps-xxl-4 {
    padding-inline-start: 1.5rem !important;
  }
  .ps-xxl-5 {
    padding-inline-start: 3rem !important;
  }
  .gap-xxl-0 {
    gap: 0 !important;
  }
  .gap-xxl-1 {
    gap: 0.25rem !important;
  }
  .gap-xxl-2 {
    gap: 0.5rem !important;
  }
  .gap-xxl-3 {
    gap: 1rem !important;
  }
  .gap-xxl-4 {
    gap: 1.5rem !important;
  }
  .gap-xxl-5 {
    gap: 3rem !important;
  }
  .row-gap-xxl-0 {
    row-gap: 0 !important;
  }
  .row-gap-xxl-1 {
    row-gap: 0.25rem !important;
  }
  .row-gap-xxl-2 {
    row-gap: 0.5rem !important;
  }
  .row-gap-xxl-3 {
    row-gap: 1rem !important;
  }
  .row-gap-xxl-4 {
    row-gap: 1.5rem !important;
  }
  .row-gap-xxl-5 {
    row-gap: 3rem !important;
  }
  .column-gap-xxl-0 {
    column-gap: 0 !important;
  }
  .column-gap-xxl-1 {
    column-gap: 0.25rem !important;
  }
  .column-gap-xxl-2 {
    column-gap: 0.5rem !important;
  }
  .column-gap-xxl-3 {
    column-gap: 1rem !important;
  }
  .column-gap-xxl-4 {
    column-gap: 1.5rem !important;
  }
  .column-gap-xxl-5 {
    column-gap: 3rem !important;
  }
  .text-xxl-start {
    text-align: start !important;
  }
  .text-xxl-end {
    text-align: end !important;
  }
  .text-xxl-center {
    text-align: center !important;
  }
}
@media (min-width: 1200px) {
  .fs-1 {
    font-size: 2.5rem !important;
  }
  .fs-2 {
    font-size: 2rem !important;
  }
  .fs-3 {
    font-size: 1.75rem !important;
  }
  .fs-4 {
    font-size: 1.5rem !important;
  }
}
@media print {
  .d-print-inline {
    display: inline !important;
  }
  .d-print-inline-block {
    display: inline-block !important;
  }
  .d-print-block {
    display: block !important;
  }
  .d-print-grid {
    display: grid !important;
  }
  .d-print-inline-grid {
    display: inline-grid !important;
  }
  .d-print-table {
    display: table !important;
  }
  .d-print-table-row {
    display: table-row !important;
  }
  .d-print-table-cell {
    display: table-cell !important;
  }
  .d-print-flex {
    display: flex !important;
  }
  .d-print-inline-flex {
    display: inline-flex !important;
  }
  .d-print-none {
    display: none !important;
  }
}
.chartjs-tooltip {
  --cui-chartjs-tooltip-zindex: 1080;
  --cui-chartjs-tooltip-padding-x: 0.5rem;
  --cui-chartjs-tooltip-padding-y: 0.25rem;
  --cui-chartjs-tooltip-color: var(--cui-body-bg);
  --cui-chartjs-tooltip-bg: rgba(var(--cui-emphasis-color-rgb), 0.8);
  --cui-chartjs-tooltip-border-radius: var(--cui-border-radius);
  --cui-chartjs-tooltip-transition: all 0.15s ease;
  --cui-chartjs-tooltip-header-margin: 0.5rem;
  --cui-chartjs-tooltip-header-font-size: 0.875rem;
  --cui-chartjs-tooltip-header-font-weight: 700;
  --cui-chartjs-tooltip-body-font-size: 0.875rem;
  --cui-chartjs-tooltip-body-font-weight: 400;
  position: absolute;
  z-index: var(--cui-chartjs-tooltip-zindex);
  padding: var(--cui-chartjs-tooltip-padding-y) var(--cui-chartjs-tooltip-padding-x);
  color: var(--cui-chartjs-tooltip-color);
  pointer-events: none;
  background: var(--cui-chartjs-tooltip-bg);
  opacity: 0;
  transform: translate(-50%, 0);
  border-radius: var(--cui-chartjs-tooltip-border-radius);
  transition: var(--cui-chartjs-tooltip-transition);
}

@media (prefers-reduced-motion: reduce) {
  .chartjs-tooltip {
    transition: none;
  }
}
.chartjs-tooltip-header {
  margin-bottom: var(--cui-chartjs-tooltip-header-margin);
}

.chartjs-tooltip-header-item {
  font-size: var(--cui-chartjs-tooltip-header-font-size);
  font-weight: var(--cui-chartjs-tooltip-header-font-weight);
}

.chartjs-tooltip-body-item {
  align-items: center;
  font-size: var(--cui-chartjs-tooltip-body-font-size);
  font-weight: var(--cui-chartjs-tooltip-body-font-weight);
  white-space: nowrap;
}

.simplebar-content {
  display: flex;
  flex-direction: column;
  min-height: 100%;
}

body {
  background-color: var(--cui-tertiary-bg);
}

.wrapper {
  width: 100%;
  padding-left: var(--cui-sidebar-occupy-start, 0);
  padding-right: var(--cui-sidebar-occupy-end, 0);
  will-change: auto;
  transition: padding 0.15s;
}
@media (prefers-reduced-motion: reduce) {
  .wrapper {
    transition: none;
  }
}

.header > .container-fluid,
.sidebar-header {
  min-height: calc(4rem + 1px);
}

.sidebar-brand-full {
  margin-left: 3px;
}

.sidebar-header .nav-underline-border {
  --cui-nav-underline-border-link-padding-x: 1rem;
  --cui-nav-underline-border-gap: 0;
}
.sidebar-header .nav-link {
  display: flex;
  align-items: center;
  min-height: calc(4rem + 1px);
}

.sidebar-toggler {
  margin-left: auto;
}

.sidebar-narrow .sidebar-toggler,
.sidebar-narrow-unfoldable:not(:hover) .sidebar-toggler {
  margin-right: auto;
}

.header > .container-fluid + .container-fluid {
  min-height: 3rem;
}

.footer {
  min-height: calc(3rem + 1px);
}

[data-coreui-theme=dark] body {
  background-color: var(--cui-dark-bg-subtle);
}
[data-coreui-theme=dark] .footer {
  --cui-footer-bg: var(--cui-body-bg);
}

.detail-index-main-wrapper {
  background: linear-gradient(180deg, #f8f9fc 0%, #ffffff 100%);
  min-height: 100vh;
}

.modern-back-button {
  border-radius: 10px !important;
  font-size: 0.8rem !important;
  padding: 6px 16px !important;
  transition: all 0.2s ease !important;
}
.modern-back-button:hover {
  transform: translateX(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08) !important;
}

.grid-container .leaflet-container {
  border-radius: 12px !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}

.video-container-card {
  background: #fff;
  border-radius: 12px !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04) !important;
  overflow: hidden;
}

.stats-cards-container .stats-card-premium {
  background: #fff;
  border: 1px solid #eef0f4;
  border-radius: 12px;
  padding: 12px 16px;
  cursor: pointer;
  transition: all 0.2s ease;
  min-width: 130px;
  flex: 1 1;
}
.stats-cards-container .stats-card-premium:hover {
  transform: translateY(-3px);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.06);
  border-color: #d0d4dd;
}
.stats-cards-container .stats-card-premium.active {
  border-color: #5856D6;
  background: linear-gradient(135deg, #f8f6ff 0%, #fff 100%);
  box-shadow: 0 4px 12px rgba(88, 86, 214, 0.1);
}
.stats-cards-container .stats-card-premium.disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.stats-cards-container .stats-card-premium.disabled:hover {
  transform: none;
  box-shadow: none;
}
.stats-cards-container .stats-card-icon-wrapper {
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.stats-cards-container .stats-card-icon-wrapper img {
  width: 22px;
  height: 22px;
  object-fit: contain;
}
.stats-cards-container .stats-card-label {
  font-size: 0.65rem;
  font-weight: 600;
  color: #6c757d;
  letter-spacing: 0.3px;
}
.stats-cards-container .stats-card-value {
  font-size: 1.1rem;
  font-weight: 700;
  color: #131133;
}
.stats-cards-container .stats-card-value .total-label {
  font-size: 0.6rem;
  font-weight: 400;
  color: #adb5bd;
}

.tab-list-container .tablist-map-component {
  border-bottom: 1px solid #e9ecef !important;
}
.tab-list-container .tablist-map-component .nav-link {
  font-size: 0.75rem !important;
  font-weight: 600;
  color: #6c757d !important;
  padding: 8px 20px !important;
  border: none !important;
  position: relative;
  transition: color 0.2s ease;
}
.tab-list-container .tablist-map-component .nav-link:hover {
  color: #131133 !important;
}
.tab-list-container .tablist-map-component .nav-link.active {
  color: #5856D6 !important;
  background: transparent !important;
}
.tab-list-container .tablist-map-component .nav-link.active::after {
  content: "";
  position: absolute;
  bottom: -1px;
  left: 0;
  right: 0;
  height: 2px;
  background: #5856D6;
  border-radius: 2px 2px 0 0;
}

.buscador-senales-container .search-input-custom {
  border-radius: 8px !important;
  border: 1px solid #e0e3e8 !important;
  font-size: 0.75rem !important;
  padding: 6px 12px !important;
}
.buscador-senales-container .search-input-custom:focus {
  border-color: #5856D6 !important;
  box-shadow: 0 0 0 2px rgba(88, 86, 214, 0.1) !important;
}
.buscador-senales-container .btn-sub-filter-pill {
  border: 1px solid #dee2e6;
  background: #fff;
  border-radius: 20px;
  padding: 4px 14px;
  font-size: 0.65rem;
  font-weight: 500;
  color: #495057;
  cursor: pointer;
  transition: all 0.2s ease;
}
.buscador-senales-container .btn-sub-filter-pill:hover {
  border-color: #5856D6;
  color: #5856D6;
  background: #f8f6ff;
}
.buscador-senales-container .btn-sub-filter-pill.active {
  background: #5856D6;
  color: #fff;
  border-color: #5856D6;
}

.ctable-list thead th {
  background: #f8f9fc !important;
  font-size: 0.65rem !important;
  letter-spacing: 0.3px;
  text-transform: uppercase;
  color: #6c757d !important;
  border-bottom: 2px solid #e9ecef !important;
}
.ctable-list tbody tr {
  transition: background 0.15s ease;
}
.ctable-list tbody tr:hover {
  background: #f8f6ff !important;
}
.ctable-list tbody tr.row-viewed-highlight {
  background: #eef2ff !important;
  border-left: 3px solid #5856D6;
}

.backgroundcolor-toast-exito {
  background: #2eb85c !important;
  border-radius: 10px !important;
  box-shadow: 0 8px 24px rgba(46, 184, 92, 0.3) !important;
}

.backgroundcolor-toast-error {
  background: #e55353 !important;
  border-radius: 10px !important;
  box-shadow: 0 8px 24px rgba(229, 83, 83, 0.3) !important;
}

.premium-card, .stats-card {
  border-radius: 12px;
  border: none;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
  background: #fff;
}

.stats-card {
  cursor: pointer;
  padding: 15px;
  border-left: 6px solid transparent !important;
}
.stats-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);
}
.stats-card.active {
  border-left-color: #fe5000 !important;
}

.info-item {
  display: flex;
  align-items: center;
  margin-bottom: 12px;
}
.info-item .info-label {
  min-width: 150px;
  font-weight: 600;
  color: #131133;
  font-size: 0.85rem;
}
.info-item .info-value {
  color: #666;
  font-size: 0.85rem;
}

.modern-table-container {
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  background: white;
}

.btn-action-round {
  width: 32px;
  height: 32px;
  border-radius: 50% !important;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  transition: all 0.2s;
}
.btn-action-round:hover {
  background: #f8f9fa;
}

.btn-collapse-orange {
  background-color: #ffffff;
  border-radius: 5rem;
  width: 1.3rem;
  height: 1.3rem;
  display: flex;
  justify-content: center;
  /* Centra el contenido horizontalmente */
  align-items: center;
  /* Centra el contenido verticalmente */
  padding: 0.1rem;
}

.btn-collapse-orange:active {
  background-color: #ffffff;
  border-radius: 5rem;
  padding: 0.1rem;
}

.btn-collapse-orange:hover {
  background-color: #ffffff;
  border-radius: 5rem;
}

.bg-primary-orange {
  background-color: #fe5000;
}

.btn-primary-orange-center {
  background-color: #fe5000;
}

.btn-primary-orange {
  background-color: #131133;
  display: flex;
  justify-content: center;
  align-items: center;
  border-color: #131133;
  color: #ffffff;
  font-size: 0.9em;
}

.btn-primary-orange:hover {
  background-color: #131133;
  border-color: #131133;
  color: #ffffff;
}

.btn-primary-orange:focus {
  background-color: #131133;
  display: flex;
  justify-content: center;
  align-items: center;
  border-color: #131133;
  color: #ffffff;
}

.btn-primary-orange2 {
  background-color: #ab3000 !important;
}

.btn-primary-login {
  background-color: #1D3354;
  display: flex;
  justify-content: center;
  align-items: center;
  border-color: #1D3354;
  color: #ffffff;
  font-size: 0.9em;
}

.btn-primary-login:hover {
  background-color: #1D3354;
  border-color: #1D3354;
  color: #ffffff;
}

.btn-primary-login:focus {
  background-color: #1D3354;
  display: flex;
  justify-content: center;
  align-items: center;
  border-color: #1D3354;
  color: #ffffff;
}

.btn-search-list {
  background-color: #ffffff;
  border-color: #131133;
  font-size: 0.9em;
  border-width: 2px;
}

.btn-search-list:hover {
  background-color: #ffffff;
  border-color: #131133;
  border-width: 2px;
}

.btn-search-list:focus {
  background-color: #ffffff;
  border-color: #131133;
  border-width: 2px;
}

.btn-descargar-list {
  background-color: #ffffff;
  border-color: #131133;
  font-size: 0.9em;
  border-width: 2px;
}

.btn-descargar-list:hover {
  background-color: #ffffff;
  border-color: #131133;
  border-width: 2px;
}

.btn-descargar-list:focus {
  background-color: #ffffff;
  border-color: #131133;
  border-width: 2px;
}

.btn-salir-footer {
  background-color: #ffffff;
  border-color: #131133;
  font-size: 0.9em;
  width: 120px;
  border-width: 1px;
  font-weight: bold;
}

.btn-salir-footer:hover {
  background-color: #ffffff;
  border-color: #131133;
  width: 120px;
  border-width: 1px;
  font-weight: bold;
}

.btn-guardar-footer {
  background-color: #ffffff;
  font-size: 0.9em;
  width: 160px;
  font-weight: bold;
}

.btn-guardar-footer:hover {
  background-color: #ffffff;
  width: 160px;
  font-weight: bold;
}

.btn-next-footer {
  background-color: #131133;
  display: flex;
  justify-content: center;
  align-items: center;
  border-color: #131133;
  color: #ffffff;
  font-size: 0.9em;
  width: 120px;
  border-width: 1px;
  font-weight: bold;
}

.btn-next-footer:hover {
  background-color: #131133;
  border-color: #131133;
  color: #ffffff;
  width: 120px;
  border-width: 1px;
  font-weight: bold;
}

.btn-next-footer:focus {
  background-color: #131133;
  display: flex;
  justify-content: center;
  align-items: center;
  border-color: #131133;
  color: #ffffff;
  width: 120px;
}

.btn-formulario-ftp {
  background-color: #131133;
  display: flex;
  justify-content: center;
  align-items: center;
  border-color: #131133;
  color: #ffffff;
  font-size: 0.9em;
  width: 180px;
  border-width: 1px;
  font-weight: bold;
}

.btn-formulario-ftp:hover {
  background-color: #131133;
  border-color: #131133;
  color: #ffffff;
  width: 180px;
  border-width: 1px;
  font-weight: bold;
}

.btn-formulario-ftp:focus {
  background-color: #131133;
  display: flex;
  justify-content: center;
  align-items: center;
  border-color: #131133;
  color: #ffffff;
  width: 180px;
}

.btn-next-footer-model {
  background-color: #131133;
  display: flex;
  justify-content: center;
  align-items: center;
  border-color: #131133;
  color: #ffffff;
  font-size: 0.9em;
  width: 120px;
  border-width: 1px;
  font-weight: bold;
  margin: auto;
  /* Centra horizontalmente el botón */
}

.btn-next-footer-model:hover {
  background-color: #131133;
  border-color: #131133;
  color: #ffffff;
  width: 120px;
  border-width: 1px;
  font-weight: bold;
}

.btn-next-footer-model:focus {
  background-color: #131133;
  display: flex;
  justify-content: center;
  align-items: center;
  border-color: #131133;
  color: #ffffff;
  width: 120px;
}

.btn-model-procesar {
  background-color: #131133;
  display: flex;
  justify-content: center;
  align-items: center;
  border-color: #131133;
  color: #ffffff;
  font-size: 0.9em;
  border-width: 1px;
  font-weight: bold;
}

.btn-model-procesar:hover {
  background-color: #131133;
  border-color: #131133;
  color: #ffffff;
  border-width: 1px;
  font-weight: bold;
}

.btn-model-procesar:focus {
  background-color: #131133;
  display: flex;
  justify-content: center;
  align-items: center;
  border-color: #131133;
  color: #ffffff;
}

.btn-form-user {
  background-color: #ffffff;
  border-color: #131133;
  font-size: 0.8em;
  width: 180px;
  border-width: 2px;
  font-weight: bold;
  margin-top: 14px;
}

.btn-form-user:hover {
  background-color: #ffffff;
  border-color: #131133;
  width: 180px;
  border-width: 2px;
  font-weight: bold;
  margin-top: 14px;
}

.btn-form-video {
  background-color: #ffffff;
  border-color: #ffffff;
  font-size: 0.9em;
}

.btn-form-video:hover {
  background-color: #ffffff;
  border-color: #ffffff;
}

.btn-form-video:focus {
  background-color: #ffffff;
  border-color: #ffffff;
}

.btn-dropdown-list {
  border-style: none;
  border-color: #e9e6e6;
}

.sidebar-bg-orange {
  background-color: #131133;
}

.sidebar-icono-recoger {
  padding-top: 5% !important;
  padding-left: 5% !important;
  padding-right: 5% !important;
  padding-bottom: 0% !important;
}

.sidebar-nav .nav-link.active {
  background-color: #fe5000 !important;
}

.sidebar-toggler-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_20___}) !important;
  /* Reemplaza con la ruta a tu SVG */
  background-size: contain;
  /* Ajusta el tamaño del icono al contenedor */
  background-repeat: no-repeat;
  /* Agrega otros estilos para el icono */
}

.sidebar-narrow .sidebar-toggler-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_21___}) !important;
  /* Reemplaza con la ruta a tu SVG */
  background-size: contain;
  /* Ajusta el tamaño del icono al contenedor */
  background-repeat: no-repeat;
}

.sidebar-narrow .sidebar-icono-recoger {
  padding-top: 30% !important;
}

.sidebar-narrow .sidebar-toggler,
.sidebar-narrow-unfoldable:not(:hover) .sidebar-toggle {
  padding-top: 15%;
}

.sidebar-toggler-color {
  background-color: #cbc9c9;
}

.sidebar-toggler-focus-color {
  background-color: #db0c0c;
}

.sidebar-toggler-focus-shadow {
  background-color: #f31010;
}

.image-container {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100% !important;
  padding-bottom: 10%;
  border-style: none !important;
  margin-top: 8%;
}

.image-container-img {
  max-width: 60%;
  /* Ajusta el porcentaje según tus necesidades */
  max-height: 60%;
  /* Ajusta el porcentaje según tus necesidades */
}

@media (min-width: 1200px) {
  .card-image-login {
    height: 560px !important;
  }
}
@media (max-width: 1200px) {
  .card-image-login {
    height: 510px !important;
  }
}
@media (min-width: 1200px) {
  .cardgroup-image-login {
    height: 100px !important;
  }
}
@media (max-width: 992px) {
  .card-image-login {
    height: 441px !important;
  }
}
@media (max-width: 1200px) {
  .cardgroup-image-login {
    height: 451px !important;
  }
}
.padding-car-login-externo {
  padding-left: 10px;
  padding-right: 10px;
}

/* Estilos base para la imagen */
/* Media queries para diferentes tamaños de pantalla */
.currentImage {
  display: flex;
  justify-content: center;
  align-items: center;
}

.alert-acya {
  padding-top: 0.3rem;
  padding-bottom: 0.3rem;
}

.row-center {
  display: flex;
  justify-content: center;
  align-items: center;
}

.row-center-login-btn {
  padding-top: 3%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding-right: 5px;
}

.titulo-card-center {
  text-align: center;
  background-color: #fe5000;
}

.row-list-field {
  margin: 0.1%;
  padding-top: 2%;
}

.row-map {
  height: 50px;
}

.grid-container {
  display: grid;
  grid-template-columns: 1fr 0.35fr;
  grid-template-rows: auto;
  gap: 20px;
  align-items: start;
}

@media (max-width: 1200px) {
  .grid-container {
    grid-template-columns: 1fr;
  }
}
.grid-container-2 {
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: auto;
  gap: 20px;
}

.grid-container-3 {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  /* O la cantidad de columnas que uses */
  grid-gap: 15px;
  /* Ajusta este valor a tu gusto */
  padding: 10px;
  /* Ajusta este valor a tu gusto */
  display: flex;
  flex-wrap: wrap;
}

.grid-item {
  background-color: #ffffff;
  text-align: center;
}

.video-container {
  background-color: #ffffff;
  width: 80%;
  margin: 0 auto;
}

.video-container-card {
  background-color: #ffffff;
  border-style: none;
}

.video-grande {
  width: 100%;
  height: 150px;
}

.btn-list {
  padding-top: 1rem;
  padding-left: 2.5rem;
}

.container-card-list {
  border-style: none;
  font-size: 0.7em;
}

.ctable-list {
  font-size: 0.7em;
}

.my-tall-cell {
  height: 1vh !important;
  padding-top: 0px !important;
}

.tab-list-container {
  background-color: #ffffff;
  width: 95%;
  max-width: 100%;
  margin: 0 auto;
  padding-top: 2%;
  font-size: 0.8em;
}
@media (max-width: 768px) {
  .tab-list-container {
    width: 100%;
    padding: 10px;
  }
}

.list-tab-group {
  font-size: 0.9em;
}

.list-group-2 {
  padding-top: 12%;
}

.list-group-item-2 {
  background-color: #ffffff !important;
  background-color: #ffffff;
  border-style: none;
  padding-top: 10%;
  padding-left: 10%;
}

.titulo-grid-3 {
  font-size: 0.8 !important;
  padding-bottom: 0.1em;
  margin-bottom: 0.3em;
}

.list-group-grid-4 {
  background-color: #ffffff;
  border-style: none;
}

.titulo-grid-4 {
  padding-top: 12%;
  background-color: #ffffff;
  border-style: none;
}

.titulo-grid-4-2 {
  padding-top: 0.5em;
  padding-left: 0.3em;
}

.p-grid-4-2 {
  padding-top: 0.3em;
  padding-left: 1em;
}

.text-grid-4-2 {
  font-size: 0.8em;
}

.row-items-grid-4-1 {
  margin: 0px;
  border-style: none;
  font-size: 0.8em;
}

.row-items-grid-4-2 {
  margin: 0px;
  border-style: none;
  font-size: 0.8em;
}

.icon-grid-4 {
  padding-right: 5%;
}

.separator {
  border-bottom: 1px solid #cbc9c9;
  margin: 20px 0;
}

/* Responsive adjustments for project detail items */
@media (max-width: 768px) {
  .tablist-map-component {
    flex-direction: column !important;
  }
  .stats-card {
    padding: 10px !important;
  }
  .h4 {
    font-size: 1.25rem !important;
  }
}
.container-card-grip-4 {
  background-color: #ffffff;
  border-style: none;
  padding-top: 0.8em;
  padding-left: 1.2em;
  padding-right: 1.2em;
}

.sidebar-footer-content {
  display: flex;
  justify-content: space-between;
  /* Espaciado entre las secciones */
  align-items: center;
  /* Alineación vertical */
  padding: 10px;
  /* Espacio interno */
}

.sidebar-footer-right {
  text-align: right;
  /* Alineación del texto a la derecha */
}

.sidebar-footer-name {
  font-size: 1em;
  /* Tamaño de letra del nombre */
  margin-left: 6px;
}

.sidebar-footer-email {
  font-size: 0.8em;
  /* Tamaño de letra del correo */
  color: #d8d8d8;
  /* Color del correo (opcional) */
  margin-left: 5px;
}

.sidebar-nav-link-hover-bg {
  background-color: #fe5000;
}

.margin-row-contenedor {
  margin: 22px;
}

.padding-titulo-list-contenedor {
  padding-bottom: 15px;
}

.margin-bottom-h5 {
  margin-bottom: 0.1em !important;
  padding-left: 0.5em;
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
  color: #131133;
}

.solid-col-list {
  border-color: #fe5000;
  font-weight: bold;
  padding: 0.2em;
}

.solid-col-list-2 {
  padding-right: 0.2em;
}

.solid-col-list-3 {
  margin-top: 2em;
  padding-left: 1px;
}

.solid-col-list-4 {
  margin-top: 0.9em;
  padding-left: 1px;
}

.form-select-list-estado {
  font-size: 1em;
}

.form-select-list-estado-2 {
  font-size: 1em;
}

.form-select-list-estado-3 {
  font-size: 1em;
}

.icon-background-orange {
  background-color: #fe5000;
  padding: 0.3em;
}

.contenedor-table-list-titulo {
  padding-bottom: 0.6em;
}

.contenedor-table-list {
  padding-top: 0.1em;
}

.scroll-contenedor-new-proyect {
  width: 100%;
  height: 800px;
  overflow-y: scroll;
  /* Add the ability to scroll */
}

.container-tabla {
  /* Nombre de la clase del contenedor de tu tabla */
  width: 100%;
  height: 60%;
  overflow: scroll;
  /* Add the ability to scroll */
  scrollbar-width: none;
}

/* Hide scrollbar for Chrome, Safari and Opera */
.container-tabla::-webkit-scrollbar {
  display: none;
}

/* Hide scrollbar for IE, Edge and Firefox */
.container-tabla {
  -ms-overflow-style: none;
  /* IE and Edge */
  scrollbar-width: none;
  /* Firefox */
}

.container-tabla::-webkit-scrollbar {
  display: none;
  /* Chrome, Safari, Opera */
}

.dropdown-toggle-list::after {
  border: 0.1em;
  margin-left: 0.1em;
}

.dropdown-menu-list {
  font-size: 0.7rem;
  min-width: 7rem;
}

.dropdown-item:active {
  background-color: #f0f0f0;
}

.fuente-letra-oscura {
  color: #0c0c0c;
}

.fuente-letra-gris {
  color: rgba(123, 128, 137, 0.9490196078);
}

.inner-addon {
  position: relative;
  padding-top: 1.2rem;
}

.inner-addon .glyphicon {
  position: absolute;
  padding: 10px;
  pointer-events: none;
}

.left-addon .glyphicon {
  left: 0px;
}

.right-addon .glyphicon {
  right: 75%;
}

.left-addon input {
  padding-left: 30px;
}

.right-addon input {
  padding-right: 30px;
}

.quitar-padding {
  padding: 0px !important;
}

.quitar-padding-with {
  padding: 0px !important;
  width: 50%;
}

.quitar-padding-with-2 {
  padding: 0px !important;
  width: 53%;
}

.quitar-padding-map {
  padding-top: 0px !important;
  padding-left: 0px !important;
  padding-right: 0px !important;
  padding-bottom: 3px !important;
}

.padding-botoom-1 {
  padding-top: 0px !important;
  padding-left: 0px !important;
  padding-right: 0px !important;
  padding-bottom: 3px !important;
}

.padding-botones-model {
  padding-left: 2rem;
}

.tablist-map-component {
  margin-top: 1.1rem;
}

.asb:active {
  border-bottom-color: #fe5000 !important;
}

.asb {
  color: rgba(0, 0, 0, 0.6823529412) !important;
}

.asb:hover {
  color: rgba(11, 11, 11, 0.6823529412) !important;
  border-bottom-color: #fe5000 !important;
}

.text-card-frame {
  font-size: 0.75rem;
}

.margin-bottom-table {
  margin-bottom: 0.4rem;
}

.tabpanel-aling-content {
  text-align: start !important;
}

.button-modal-frame {
  border-radius: 1rem;
  background-color: rgba(0, 117, 255, 0.0509803922);
  border-color: rgba(0, 117, 255, 0.0509803922);
}

.titulo-formulario-new-proyect {
  margin-top: 1.5rem;
  margin-left: 1rem;
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
  font-weight: bold;
  color: #1D3354;
  font-size: 18px;
}

.titulo-formulario-new-carretera {
  margin-top: 0.1rem;
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
  font-weight: bold;
  color: #1D3354;
  font-size: 17px;
}

.titulo-formulario-new-user {
  margin-top: 1.5rem;
  margin-left: 1rem;
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
  font-weight: bold;
  color: #1D3354;
  font-size: 15px;
}

.titulo-formulario-new-video {
  margin-top: 1.5rem;
  margin-left: 1rem;
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
  font-weight: bold;
  color: #1D3354;
  font-size: 18px;
}

.delete-border-color {
  border-color: rgba(255, 255, 255, 0) !important;
}

.footer-form-video-estilo {
  position: absolute;
  /* Por defecto, el pie de página no estará fijo */
  bottom: 0;
  left: 0;
  width: 100%;
  background-color: white;
  border: 2px orange;
  padding: 1rem;
  text-align: center;
  z-index: 90;
}

/* Estilo para el pie de página fijo */
.footer-form-video-estilo.fixed {
  position: fixed;
  /* Fija el pie de página cuando se aplica la clase 'fixed' */
}

.footer-text-save-leave {
  padding-right: 25rem;
}

.icon-save-leave {
  background-color: #52CCA7;
  border-radius: 40px;
  padding: 0.3rem;
  width: 1.7rem !important;
  height: 1.7rem !important;
  margin-right: 0.5rem;
  vertical-align: middle;
}

.icon-add-item {
  background-color: #1D3354;
  border-radius: 40px;
  padding: 0.35rem;
  width: 1.3rem !important;
  height: 1.3rem !important;
  margin-right: 0.5rem;
  vertical-align: middle;
}

.icon-button-upload {
  padding-right: 0.35rem;
}

.image-uploader {
  display: flex;
  flex-direction: column;
  /* Ordena elementos verticalmente */
  align-items: center;
  /* Centra horizontalmente los elementos */
  padding-top: 3rem;
  padding-bottom: 3rem;
}

.image-uploader-form-user {
  display: flex;
  flex-direction: column;
  /* Ordena elementos verticalmente */
  align-items: center;
  /* Centra horizontalmente los elementos */
  padding-top: 2rem;
  padding-bottom: 2rem;
}

.image-uploader-form-video {
  display: flex;
  flex-direction: column;
  /* Ordena elementos verticalmente */
  align-items: center;
  /* Centra horizontalmente los elementos */
  padding-top: 1rem;
  padding-bottom: 2rem;
}

.avatar-container {
  width: 100px;
  /* Ajusta el tamaño del avatar */
  height: 100px;
  border-radius: 50%;
  /* Crea un avatar circular */
  overflow: hidden;
  /* Oculta el exceso de imagen */
  margin-bottom: 3rem;
  /* Espacio entre avatar y botón */
}

.avatar2 {
  width: 15%;
  /* Ajusta el tamaño de la imagen al contenedor */
  height: 15%;
  object-fit: cover;
  /* Ajusta la imagen para que cubra todo el contenedor */
  border-radius: 50%;
  /* Crea un avatar circular */
}

.avatar2-video {
  width: 30%;
  height: 30%;
  object-fit: cover;
  /* Ajusta la imagen para que cubra todo el contenedor */
  border-radius: 50%;
  /* Crea un avatar circular */
}

.avatar3 {
  width: 50%;
  /* Ajusta el tamaño de la imagen al contenedor */
  height: 50%;
  object-fit: cover;
  /* Ajusta la imagen para que cubra todo el contenedor */
  border-radius: 50%;
  /* Crea un avatar circular */
}

.image-uploader-avatar3 {
  display: flex;
  flex-direction: column;
  /* Ordena elementos verticalmente */
  align-items: center;
  /* Centra horizontalmente los elementos */
  padding-top: 1rem;
  padding-bottom: 1rem;
  font-size: 12px;
  color: #131133;
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
}

.image-uploader-avatar3 strong {
  display: flex;
  flex-direction: column;
  /* Ordena elementos verticalmente */
  align-items: center;
  /* Centra horizontalmente los elementos */
  padding-top: 0.1rem;
  padding-bottom: 0.1rem;
  font-size: 14px;
}

.avatar-placeholder {
  width: 15%;
  height: 15%;
  background-color: #ff0000;
  /* Color de fondo del placeholder */
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 20px;
  color: #666;
}

.icon-check {
  width: 17%;
  height: 17%;
  object-fit: cover;
  /* Ajusta la imagen para que cubra todo el contenedor */
  border-radius: 50%;
  /* Crea un avatar circular */
}

.icon-arrow-down {
  vertical-align: middle;
  /* Centra verticalmente la imagen */
}

.icon-arrow-collapse {
  width: 120%;
  height: 120%;
  object-fit: cover;
  /* Ajusta la imagen para que cubra todo el contenedor */
  border-radius: 50%;
  /* Crea un avatar circular */
}

.icon-delete-collapse {
  width: 70%;
  height: 80%;
  object-fit: cover;
  /* Ajusta la imagen para que cubra todo el contenedor */
  border-radius: 50%;
  /* Crea un avatar circular */
  margin-bottom: 8px;
}

.icon-add-form {
  width: 15%;
  height: 15%;
}

.file-input {
  display: none;
  /* Oculta el campo de entrada de archivos */
  font-size: small;
  background-color: #ab3000 !important;
}

.container-upload-file {
  margin: 20px;
  padding-right: 5px !important;
  padding-left: 5px !important;
  border-style: dotted;
  border-width: 2px;
  /* Aumenta el ancho del borde */
}

.container-upload-video {
  margin: 5px;
}

.text-right-aling {
  text-align: right;
}

.margin-button-forgot-pass {
  margin-right: 20px;
  font-size: 0.8rem;
}

.modal-backdrop {
  opacity: 0.8 !important;
}

.letra-login {
  font-size: 12px;
  color: #1D3354;
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
}

.letra-titulo-1 {
  color: #1D3354 !important;
  font-size: 15px !important;
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
  font-weight: bold;
}

.letra-titulo-2 {
  color: #1D3354 !important;
  font-size: 12px !important;
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
}

.letra-titulo-3 {
  color: #131133 !important;
  font-size: 12px !important;
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
}

.letra-contenido {
  color: #1D3354 !important;
  font-size: 12px !important;
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
}

.letra-contenido-2 {
  color: #1D3354 !important;
  font-size: 12px !important;
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
  font-weight: bold;
}

.letra-contenido-3 {
  color: #1D3354 !important;
  font-size: 11px !important;
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
  font-weight: normal;
}

.letra-contenido-4 {
  color: #1D3354 !important;
  font-size: 14px !important;
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
  font-weight: bold;
}

.letra-contenido-5 {
  color: #1D3354 !important;
  font-size: 13px !important;
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
  font-weight: normal;
}

.letra-contenido-6 {
  color: #e55353 !important;
  font-size: 12px !important;
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
  font-weight: bold;
  padding-right: 1rem;
}

.letra-contenido-7 {
  color: #0fe016 !important;
  font-size: 12px !important;
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
  font-weight: bold;
  padding-right: 1rem;
}

.letra-titulo-modal {
  color: #1D3354 !important;
  font-size: 18px !important;
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
}

.letra-contenido-modal {
  color: #1D3354 !important;
  font-size: 15px !important;
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
}

.letra-contenido-modal-input {
  color: #1D3354 !important;
  font-size: 12px !important;
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
  font-style: italic;
}

.letra-btn-agregar {
  color: #1D3354 !important;
  font-size: 12px !important;
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
  font-weight: bold;
}

.with-column-dateuser {
  width: 30% !important;
}

.titulo-table-padding {
  padding-top: 0px !important;
  padding-left: 0px !important;
  padding-right: 0px !important;
  padding-bottom: 7px !important;
  font-size: 15px;
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
  color: #1D3354 !important;
}

.titulo-table-padding-password {
  padding-top: 0px !important;
  padding-left: 40px !important;
  padding-right: 0px !important;
  padding-bottom: 7px !important;
  font-size: 15px;
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
  color: #1D3354 !important;
}

.padding-left-footer-next {
  padding-left: 3rem;
}

.modal-width-content-img {
  width: 1200px;
}

.width-hr-form-new-proyect {
  width: 83%;
}

.quitar-margin-hr {
  margin-top: 0;
}

.width-card-anotaciones {
  width: 110% !important;
  margin-right: 30px;
  /* Elimina el margin */
}

.rsd {
  padding-top: 15px;
  padding-left: 30px;
  padding-right: 30px;
}

.rsd2 {
  padding-bottom: 1px;
}

.sticky-header {
  position: sticky;
  top: 0;
  background-color: white;
  /* O el color que desees */
  z-index: 1;
  /* Asegura que esté por encima del contenido */
  transform: translateY(-10px);
  /* Ajusta el valor según sea necesario */
}

.sticky-header-modal {
  position: sticky;
  top: 0;
  background-color: white;
  /* O el color que desees */
  z-index: 1;
  /* Asegura que esté por encima del contenido */
  transform: translateY(-18px);
  /* Ajusta el valor según sea necesario */
}

.sticky-header-detail {
  position: sticky;
  top: 0;
  background-color: white;
  /* O el color que desees */
  z-index: 1;
  /* Asegura que esté por encima del contenido */
}

.width-img-search {
  width: 85%;
}

.btn-movie-nf {
  background-color: #FD4F00 !important;
  padding: 0.1rem;
  font-size: 0.5rem;
}

.spam-file-movie {
  padding-left: 0.5rem;
}

.table-spam-movie {
  border-style: solid !important;
  border: #d2d7e8;
  border-width: 2px;
  border-radius: 40px;
}

.my-tall-cell {
  height: 10px;
  padding: 0px !important;
  margin: 0px;
}

.datePicker-container {
  display: flex;
  flex-direction: column;
  /* Coloca los elementos uno encima del otro */
}

.card-detalles-map {
  margin-left: 40px;
}

.btn-round-small-find {
  border-radius: 50%;
  /* Crea un círculo */
  font-size: 10px;
  /* Ajusta el tamaño de la fuente */
  background-color: #ffffff;
  border-color: #131133;
}

.btn-round-small-find:focus {
  border-radius: 50%;
  /* Crea un círculo */
  font-size: 10px;
  /* Ajusta el tamaño de la fuente */
  background-color: #ffffff;
  border-color: #131133;
}

.btn-round-small-find:hover {
  border-radius: 50%;
  /* Crea un círculo */
  font-size: 10px;
  /* Ajusta el tamaño de la fuente */
  background-color: #ffffff;
  border-color: #131133;
}

.padding-tooltip {
  padding-left: 15px;
}

.btn-ocultar-password {
  background-color: transparent !important;
  /* Eliminar el fondo */
  border: none !important;
  /* Eliminar el borde */
  padding: 0 !important;
  /* Eliminar el padding */
}

.btn-ocultar-password:hover {
  background-color: transparent !important;
}

.btn-ocultar-password:focus {
  outline: none !important;
  /* Eliminar el contorno */
}

.btn-modal-process {
  background-color: transparent !important;
  /* Eliminar el fondo */
  padding-left: 0.1rem;
  /* Estilos del botón */
  border: none;
  /* Elimina el borde */
  border-radius: 5px;
  /* Bordes redondeados */
  cursor: pointer;
  /* Cursor de mano al pasar el mouse */
  transition: background-color 0.3s ease;
  /* Transición suave al pasar el mouse */
}

.btn-modal-process:hover {
  background-color: transparent !important;
  /* Estilo al pasar el mouse */
  background-color: #f00505;
}

.btn-modal-process:focus {
  outline: none !important;
  /* Eliminar el contorno */
}

.no-padding-x {
  --cui-btn-padding-x: 0 !important;
}

.btn-modal-process img {
  width: 35px;
  height: 35px;
  display: block;
  margin: 0 auto;
  transition: transform 0.2s ease;
  /* Añade una transición suave */
}

.btn-modal-process:active img {
  transform: scale(1.1);
  /* Aumenta el tamaño de la imagen en 10% */
}

@media (min-width: 1200px) {
  .card-image-login {
    height: 560px !important;
  }
}
@media (max-width: 1200px) {
  .card-image-login {
    height: 510px !important;
  }
}
@media (min-width: 1200px) {
  .cardgroup-image-login {
    height: 100px !important;
  }
}
@media (max-width: 992px) {
  .card-image-login {
    height: 441px !important;
  }
}
@media (max-width: 1200px) {
  .cardgroup-image-login {
    height: 451px !important;
  }
}
.tooltip-container {
  position: absolute;
  background-color: white;
  padding: 5px;
  border-radius: 5px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
  display: none;
  z-index: 10;
  /* Asegúrate de que el tooltip esté arriba de otros elementos */
}

.truncate-cell .truncate-text:hover .tooltip-container {
  display: block;
  /* Muestra el tooltip solo cuando está truncado */
}

.truncate-cell .truncate-text::before {
  content: "";
  display: none;
  width: 0;
  height: 0;
  visibility: hidden;
}

.is-truncated .tooltip-container {
  display: block;
  /* Muestra el tooltip solo cuando está truncado */
}

.backgroundcolor-toast-exito {
  background-color: #131133 !important;
}

.backgroundcolor-toast-error {
  background-color: #e40101 !important;
}

.form-check-input:checked {
  background-color: #131133 !important;
  border-color: #131133 !important;
}

.page-link {
  color: #ffffff !important;
  background-color: #131133 !important;
  border-color: #131133 !important;
}

.page-link:active {
  color: #ffffff !important;
  background-color: #fe5000 !important;
  border-color: #131133 !important;
}

.page-link.active,
.active > .page-link {
  background-color: #fe5000 !important;
}

.padding-separar-boton {
  padding-left: 0.4rem;
}

.padding-separar-boton-descargar {
  padding-left: 0.25rem;
  line-height: 1.5;
}

.texto-desplazado {
  margin-left: 1rem;
  /* Ajusta el valor según sea necesario */
}

.align-inicio {
  align-items: start;
  padding-left: 0px;
  margin-left: 0px;
}

.with-hr-form {
  width: 50%;
}

.cursor-pointer {
  cursor: pointer;
}

.grid-container-4-cards {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 10px;
  height: 100%;
  padding: 10px;
  width: 97.5%;
  /* Ajusta el ancho del contenedor general al 80% */
}

.card-4-cards {
  display: flex;
  flex-direction: column;
  /* Para que las tarjetas ocupen todo el alto */
}

.grid-container-3-4-card {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  /* Repite 4 columnas, cada una con un tamaño igual */
  gap: 1px;
  /* Espacio entre las tarjetas */
  width: 100%;
  /* Ocupa todo el ancho de la tarjeta */
}

.width-card-anotaciones {
  height: 100%;
  /*  Ajusta el alto para que se ajuste a la columna  */
}

.loading-overlay {
  position: fixed !important;
  /* Posición fija para que esté siempre en la página */
  top: 0 !important;
  left: 0 !important;
  width: 100% !important;
  height: 100% !important;
  display: flex !important;
  /* Usar flexbox para centrar el spinner */
  justify-content: center !important;
  /* Centrar horizontalmente */
  align-items: center !important;
  /* Centrar verticalmente */
  background-color: rgba(0, 0, 0, 0.5) !important;
  /* Fondo semi-transparente */
  z-index: 1000 !important;
  /* Asegurar que el spinner esté al frente de todo */
}

.display-flex-icon {
  display: flex;
  align-items: center;
}

.customSpan {
  margin: 0 0 4px 4px;
}

.texto-status-modal-procesar {
  padding-left: 2rem;
}

.btns-modal-procesar {
  padding-right: 2rem;
}

.icon-trash-collapse {
  width: 80%;
  height: 80%;
  object-fit: cover;
  /* Ajusta la imagen para que cubra todo el contenedor */
  border-radius: 50%;
  /* Crea un avatar circular */
}

.center {
  display: grid;
  place-items: center;
  /* Centra horizontal y verticalmente */
  padding-top: 2rem;
}

.modal-button-wrapper {
  justify-content: center;
}

.letra-contenido-8 {
  font-size: 1.25rem;
  color: #1D3354 !important;
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
  font-weight: bold;
  padding-top: 5%;
}

.padding-right-card-detail {
  padding-right: 3px !important;
}

.btn-color {
  background-color: #131133 !important;
  border-color: #131133 !important;
  color: #ffffff !important;
}

.btn-color-secundario {
  background-color: #ffffff !important;
  border-color: #131133 !important;
  color: #131133 !important;
}

/* Estilos para el resaltado de filas visitadas */
.row-viewed-highlight {
  background-color: rgba(254, 80, 0, 0.08) !important;
  border-left: 4px solid #fe5000 !important;
  transition: all 0.2s ease;
}

.transition-all {
  transition: all 0.2s ease-in-out;
}

/* Modal Detalle Unificado Premium */
.premium-modal-unified .modal-content {
  border-radius: 16px;
  overflow: hidden;
  border: none;
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
}

.detalle-info-grid {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.info-modern-item {
  display: flex;
  flex-direction: column;
  line-height: 1.4;
}
.info-modern-item .info-modern-label {
  font-size: 0.75rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: #6c757d;
  font-weight: 600;
  margin-bottom: 2px;
}
.info-modern-item .info-modern-value {
  font-size: 1rem;
  color: #1d3354;
  font-weight: 500;
}

.btn-action-round {
  width: 32px;
  height: 32px;
  padding: 0 !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  border-radius: 50% !important;
  background: white !important;
  border: 1px solid #dee2e6 !important;
  transition: all 0.2s !important;
}
.btn-action-round:hover {
  background: #f8f9fa !important;
  border-color: #fe5000 !important;
  transform: translateY(-2px) !important;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1) !important;
}

.border-orange-soft {
  border-color: rgba(254, 80, 0, 0.2) !important;
}

.badge-status {
  padding: 4px 8px;
  border-radius: 6px;
  font-size: 0.7rem;
  font-weight: 600;
  background: #f1f3f5;
  color: #adb5bd;
  margin-bottom: 4px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border: 1px solid transparent;
}
.badge-status.active {
  background: rgba(25, 135, 84, 0.1) !important;
  color: #198754 !important;
  border-color: rgba(25, 135, 84, 0.2) !important;
}

.detail-options-grid hr {
  opacity: 0.1;
}`, "",{"version":3,"sources":["webpack://./src/scss/style.scss","webpack://./node_modules/@coreui/coreui/scss/_banner.scss","webpack://./node_modules/@coreui/coreui/scss/_root.scss","webpack://./node_modules/@coreui/coreui/scss/vendor/_rfs.scss","webpack://./node_modules/@coreui/coreui/scss/mixins/_color-mode.scss","webpack://./node_modules/@coreui/coreui/scss/_reboot.scss","webpack://./node_modules/@coreui/coreui/scss/_variables.scss","webpack://./node_modules/@coreui/coreui/scss/mixins/_border-radius.scss","webpack://./node_modules/@coreui/coreui/scss/_type.scss","webpack://./node_modules/@coreui/coreui/scss/mixins/_lists.scss","webpack://./node_modules/@coreui/coreui/scss/_images.scss","webpack://./node_modules/@coreui/coreui/scss/mixins/_image.scss","webpack://./node_modules/@coreui/coreui/scss/_containers.scss","webpack://./node_modules/@coreui/coreui/scss/mixins/_container.scss","webpack://./node_modules/@coreui/coreui/scss/mixins/_breakpoints.scss","webpack://./node_modules/@coreui/coreui/scss/_grid.scss","webpack://./node_modules/@coreui/coreui/scss/mixins/_grid.scss","webpack://./node_modules/@coreui/coreui/scss/_tables.scss","webpack://./node_modules/@coreui/coreui/scss/mixins/_table-variants.scss","webpack://./node_modules/@coreui/coreui/scss/forms/_chip-input.scss","webpack://./node_modules/@coreui/coreui/scss/mixins/_transition.scss","webpack://./node_modules/@coreui/coreui/scss/mixins/_focus-ring.scss","webpack://./node_modules/@coreui/coreui/scss/forms/_labels.scss","webpack://./node_modules/@coreui/coreui/scss/forms/_form-text.scss","webpack://./node_modules/@coreui/coreui/scss/forms/_form-control.scss","webpack://./node_modules/@coreui/coreui/scss/mixins/_gradients.scss","webpack://./node_modules/@coreui/coreui/scss/forms/_form-select.scss","webpack://./node_modules/@coreui/coreui/scss/mixins/_ltr-rtl.scss","webpack://./node_modules/@coreui/coreui/scss/forms/_form-check.scss","webpack://./node_modules/@coreui/coreui/scss/forms/_form-range.scss","webpack://./node_modules/@coreui/coreui/scss/forms/_floating-labels.scss","webpack://./node_modules/@coreui/coreui/scss/forms/_input-group.scss","webpack://./node_modules/@coreui/coreui/scss/mixins/_forms.scss","webpack://./node_modules/@coreui/coreui/scss/_buttons.scss","webpack://./node_modules/@coreui/coreui/scss/mixins/_buttons.scss","webpack://./node_modules/@coreui/coreui/scss/_transitions.scss","webpack://./node_modules/@coreui/coreui/scss/_dropdown.scss","webpack://./node_modules/@coreui/coreui/scss/mixins/_caret.scss","webpack://./node_modules/@coreui/coreui/scss/_button-group.scss","webpack://./node_modules/@coreui/coreui/scss/_nav.scss","webpack://./node_modules/@coreui/coreui/scss/_navbar.scss","webpack://./node_modules/@coreui/coreui/scss/_card.scss","webpack://./node_modules/@coreui/coreui/scss/_accordion.scss","webpack://./node_modules/@coreui/coreui/scss/_breadcrumb.scss","webpack://./node_modules/@coreui/coreui/scss/_pagination.scss","webpack://./node_modules/@coreui/coreui/scss/mixins/_pagination.scss","webpack://./node_modules/@coreui/coreui/scss/_badge.scss","webpack://./node_modules/@coreui/coreui/scss/_alert.scss","webpack://./node_modules/@coreui/coreui/scss/_progress.scss","webpack://./node_modules/@coreui/coreui/scss/_list-group.scss","webpack://./node_modules/@coreui/coreui/scss/_close.scss","webpack://./node_modules/@coreui/coreui/scss/_toasts.scss","webpack://./node_modules/@coreui/coreui/scss/_modal.scss","webpack://./node_modules/@coreui/coreui/scss/mixins/_backdrop.scss","webpack://./node_modules/@coreui/coreui/scss/_tooltip.scss","webpack://./node_modules/@coreui/coreui/scss/mixins/_reset-text.scss","webpack://./node_modules/@coreui/coreui/scss/_popover.scss","webpack://./node_modules/@coreui/coreui/scss/_carousel.scss","webpack://./node_modules/@coreui/coreui/scss/mixins/_clearfix.scss","webpack://./node_modules/@coreui/coreui/scss/_spinners.scss","webpack://./node_modules/@coreui/coreui/scss/_offcanvas.scss","webpack://./node_modules/@coreui/coreui/scss/_placeholders.scss","webpack://./node_modules/@coreui/coreui/scss/_chip.scss","webpack://./node_modules/@coreui/coreui/scss/mixins/_chip.scss","webpack://./node_modules/@coreui/coreui/scss/_chip-set.scss","webpack://./node_modules/@coreui/coreui/scss/_avatar.scss","webpack://./node_modules/@coreui/coreui/scss/_callout.scss","webpack://./node_modules/@coreui/coreui/scss/_footer.scss","webpack://./node_modules/@coreui/coreui/scss/_header.scss","webpack://./node_modules/@coreui/coreui/scss/_icon.scss","webpack://./node_modules/@coreui/coreui/scss/mixins/_icon.scss","webpack://./node_modules/@coreui/coreui/scss/_search-button.scss","webpack://./node_modules/@coreui/coreui/scss/sidebar/_sidebar.scss","webpack://./node_modules/@coreui/coreui/scss/sidebar/_sidebar-nav.scss","webpack://./node_modules/@coreui/coreui/scss/sidebar/_sidebar-narrow.scss","webpack://./node_modules/@coreui/coreui/scss/helpers/_color-bg.scss","webpack://./node_modules/@coreui/coreui/scss/helpers/_colored-links.scss","webpack://./node_modules/@coreui/coreui/scss/helpers/_focus-ring.scss","webpack://./node_modules/@coreui/coreui/scss/helpers/_icon-link.scss","webpack://./node_modules/@coreui/coreui/scss/helpers/_ratio.scss","webpack://./node_modules/@coreui/coreui/scss/helpers/_position.scss","webpack://./node_modules/@coreui/coreui/scss/helpers/_stacks.scss","webpack://./node_modules/@coreui/coreui/scss/helpers/_visually-hidden.scss","webpack://./node_modules/@coreui/coreui/scss/mixins/_visually-hidden.scss","webpack://./node_modules/@coreui/coreui/scss/helpers/_stretched-link.scss","webpack://./node_modules/@coreui/coreui/scss/helpers/_text-truncation.scss","webpack://./node_modules/@coreui/coreui/scss/mixins/_text-truncate.scss","webpack://./node_modules/@coreui/coreui/scss/helpers/_vr.scss","webpack://./node_modules/@coreui/coreui/scss/mixins/_utilities.scss","webpack://./node_modules/@coreui/coreui/scss/utilities/_api.scss","webpack://./node_modules/@coreui/chartjs/scss/_tooltips.scss","webpack://./src/scss/vendors/simplebar.scss","webpack://./src/scss/_theme.scss"],"names":[],"mappings":"AAAA,gBAAgB;ACEhB;;;;EAAA;ACQA;;EASI,mBAAA;EAAA,qBAAA;EAAA,qBAAA;EAAA,mBAAA;EAAA,kBAAA;EAAA,qBAAA;EAAA,qBAAA;EAAA,oBAAA;EAAA,mBAAA;EAAA,mBAAA;EAAA,oBAAA;EAAA,iBAAA;EAAA,mBAAA;EAAA,wBAAA;EAIA,uBAAA;EAAA,uBAAA;EAAA,uBAAA;EAAA,uBAAA;EAAA,uBAAA;EAAA,uBAAA;EAAA,uBAAA;EAAA,uBAAA;EAAA,uBAAA;EAIA,sBAAA;EAAA,wBAAA;EAAA,sBAAA;EAAA,gBAAA;EAAA,sBAAA;EAAA,qBAAA;EAAA,oBAAA;EAAA,mBAAA;EAIA,8BAAA;EAAA,kCAAA;EAAA,8BAAA;EAAA,4BAAA;EAAA,+BAAA;EAAA,6BAAA;EAAA,8BAAA;EAAA,0BAAA;EAIA,oCAAA;EAAA,sCAAA;EAAA,oCAAA;EAAA,iCAAA;EAAA,oCAAA;EAAA,mCAAA;EAAA,kCAAA;EAAA,iCAAA;EAIA,gCAAA;EAAA,kCAAA;EAAA,gCAAA;EAAA,6BAAA;EAAA,gCAAA;EAAA,+BAAA;EAAA,yEAAA;EAAA,6BAAA;EAIA,oCAAA;EAAA,sCAAA;EAAA,oCAAA;EAAA,iCAAA;EAAA,oCAAA;EAAA,mCAAA;EAAA,kCAAA;EAAA,iCAAA;EAIA,4BAAA;EAAA,8BAAA;EAAA,+BAAA;EAAA,4BAAA;EAAA,+BAAA;EAAA,8BAAA;EAAA,6BAAA;EAAA,yBAAA;EAGF,8BAAA;EACA,0BAAA;EAMA,sNAAA;EACA,0GAAA;EACA,0FAAA;EAOA,kDAAA;EC2OI,0BALI;EDpOR,2BAAA;EACA,2BAAA;EAKA,2EAAA;EACA,sCAAA;EACA,mBAAA;EACA,gCAAA;EAEA,6BAAA;EACA,mCAAA;EAEA,iFAAA;EACA,2CAAA;EACA,2BAAA;EACA,qCAAA;EAEA,+EAAA;EACA,0CAAA;EACA,0BAAA;EACA,oCAAA;EACA,uDAAA;EAEA,gDAAA;EACA,wCAAA;EACA,2BAAA;EACA,kCAAA;EAEA,+BAAA;EACA,4CAAA;EAEA,oDAAA;EACA,6CAAA;EACA,gCAAA;EACA,uCAAA;EAEA,oDAAA;EACA,4CAAA;EACA,2EAAA;EACA,wCAAA;EAEA,8EAAA;EACA,iFAAA;EACA,yEAAA;EAEA,sDAAA;EACA,uDAAA;EACA,iDAAA;EAGA,4BAAA;EAEA,yBAAA;EACA,iCAAA;EACA,gCAAA;EAEA,0EAAA;EACA,6CAAA;EAMA,yBAAA;EACA,gFAAA;EACA,4DAAA;EAGA,uBAAA;EACA,yBAAA;EACA,2BAAA;EACA,wDAAA;EAEA,6BAAA;EACA,+BAAA;EACA,8BAAA;EACA,4BAAA;EACA,6BAAA;EACA,qDAAA;EACA,+BAAA;EAGA,qDAAA;EACA,8DAAA;EACA,uDAAA;EACA,8DAAA;EAIA,+BAAA;EACA,8BAAA;EACA,+CAAA;EACA,wBAAA;EAIA,+BAAA;EACA,sCAAA;EACA,iCAAA;EACA,wCAAA;AFdF;;AI1II;EF8JA,kBAAA;EAGA,2CAAA;EACA,mCAAA;EACA,sBAAA;EACA,6BAAA;EAEA,0BAAA;EACA,uCAAA;EAEA,+CAAA;EACA,wCAAA;EACA,2BAAA;EACA,kCAAA;EAEA,+CAAA;EACA,uCAAA;EACA,sEAAA;EACA,mCAAA;EACA,uDAAA;EAEA,8CAAA;EACA,+CAAA;EACA,yCAAA;EAGE,kEAAA;EAAA,wBAAA;EAAA,kEAAA;EAAA,8BAAA;EAAA,kEAAA;EAAA,iEAAA;EAAA,oBAAA;EAAA,mBAAA;EAIA,uBAAA;EAAA,uBAAA;EAAA,uBAAA;EAAA,uBAAA;EAAA,uBAAA;EAAA,uBAAA;EAAA,uBAAA;EAAA,uBAAA;EAAA,uBAAA;EAIA,oCAAA;EAAA,kCAAA;EAAA,uCAAA;EAAA,gCAAA;EAAA,qCAAA;EAAA,mCAAA;EAAA,8BAAA;EAAA,0BAAA;EAIA,+EAAA;EAAA,sCAAA;EAAA,oEAAA;EAAA,6EAAA;EAAA,+EAAA;EAAA,6EAAA;EAAA,kCAAA;EAAA,iCAAA;EAIA,gCAAA;EAAA,kCAAA;EAAA,gCAAA;EAAA,6BAAA;EAAA,gCAAA;EAAA,+BAAA;EAAA,8BAAA;EAAA,yEAAA;EAIA,oCAAA;EAAA,sCAAA;EAAA,oCAAA;EAAA,iCAAA;EAAA,oCAAA;EAAA,mCAAA;EAAA,kCAAA;EAAA,iCAAA;EAGF,4BAAA;EAEA,qEAAA;EACA,2EAAA;EACA,uCAAA;EACA,kDAAA;EAEA,0DAAA;EACA,gDAAA;EACA,2DAAA;EAEA,2BAAA;EACA,0DAAA;EAEA,2EAAA;EACA,kFAAA;EACA,6EAAA;EACA,oFAAA;AFFJ;;AK7NA;;;EAGE,sBAAA;ALgOF;;AKjNI;EANJ;IAOM,uBAAA;ELqNJ;AACF;AKxMA;EACE,SAAA;EACA,wCAAA;EFuPI,oCALI;EEhPR,wCAAA;EACA,wCAAA;EACA,4BAAA;EACA,sCAAA;EACA,oCAAA;EACA,8BAAA;EACA,+CAAA;AL0MF;;AKjMA;EACE,cAAA;EACA,cC8pB4B;ED7pB5B,SAAA;EACA,yCAAA;EACA,aCoqB4B;ANhe9B;;AK1LA;EACE,aAAA;EACA,qBCmmB4B;EDhmB5B,gBCmmB4B;EDlmB5B,gBCmmB4B;EDlmB5B,+BAAA;AL2LF;;AKxLA;EFiNQ,iCAAA;AHrBR;;AG/II;EE7CJ;IFwNQ,iBAAA;EHvBN;AACF;AK7LA;EF4MQ,iCAAA;AHZR;;AGxJI;EExCJ;IFmNQ,eAAA;EHdN;AACF;AKjMA;EFuMQ,+BAAA;AHHR;;AGjKI;EEnCJ;IF8MQ,kBAAA;EHLN;AACF;AKrMA;EFkMQ,iCAAA;AHMR;;AG1KI;EE9BJ;IFyMQ,iBAAA;EHIN;AACF;AKzMA;EFyLM,kBALI;AHwBV;;AKvMA;EFoLM,eALI;AH4BV;;AKhMA;EACE,aAAA;EACA,mBCqX0B;ANlL5B;;AKzLA;EACE,iCAAA;EACA,YAAA;EACA,8BAAA;AL4LF;;AKtLA;EACE,mBAAA;EACA,kBAAA;EACA,oBAAA;ALyLF;;AKnLA;;EAEE,0BAAA;ALsLF;;AKnLA;;;EAGE,aAAA;EACA,mBAAA;ALsLF;;AKnLA;;;;EAIE,gBAAA;ALsLF;;AKnLA;EACE,gBCwe4B;ANlT9B;;AKjLA;EACE,sBAAA;EACA,qBAAA;ALoLF;;AK9KA;EACE,gBAAA;ALiLF;;AKzKA;;EAEE,mBCid4B;ANrS9B;;AKpKA;EFuFM,kBALI;AHsFV;;AKjKA;EACE,iBCgiB4B;ED/hB5B,iCAAA;EACA,yCAAA;ALoKF;;AK3JA;;EAEE,kBAAA;EFkEI,iBALI;EE3DR,cAAA;EACA,wBAAA;AL8JF;;AK3JA;EAAM,eAAA;AL+JN;;AK9JA;EAAM,WAAA;ALkKN;;AK7JA;EACE,kEAAA;EACA,0BC6OwC;AN7E1C;;AK9JE;EACE,qDAAA;ALiKJ;;AKvJE;EAEE,cAAA;EACA,qBAAA;ALyJJ;;AKlJA;;;;EAIE,sCC4X4B;EHnWxB,cALI;AHkIV;;AK9IA;EACE,cAAA;EACA,aAAA;EACA,mBAAA;EACA,cAAA;EFaI,kBALI;EENR,6BAAA;ALiJF;;AK9IE;EFQI,kBALI;EEDN,cAAA;EACA,kBAAA;ALiJJ;;AK7IA;EFCM,kBALI;EEMR,4BAAA;EACA,qBAAA;ALgJF;;AK7IE;EACE,cAAA;ALgJJ;;AK5IA;EACE,2BAAA;EFXI,kBALI;EEkBR,+CAAA;EACA,0DAAA;EEpSE,sBAAA;APobJ;;AK7IE;EACE,UAAA;EFlBE,cALI;AHwKV;;AKtIA;EACE,gBAAA;ALyIF;;AKnIA;;EAEE,sBAAA;ALsIF;;AK9HA;EACE,oBAAA;EACA,yBAAA;ALiIF;;AK9HA;EACE,mBC+a4B;ED9a5B,sBC8a4B;ED7a5B,iEAAA;EACA,iBAAA;ALiIF;;AK1HA;EAEE,mBAAA;EACA,gCAAA;AL4HF;;AKzHA;;;;;;EAME,qBAAA;EACA,mBAAA;EACA,eAAA;AL4HF;;AKpHA;EACE,qBAAA;ALuHF;;AKjHA;EAEE,gBAAA;ALmHF;;AK3GA;EACE,UAAA;AL8GF;;AKzGA;;;;;EAKE,SAAA;EACA,oBAAA;EFjHI,kBALI;EEwHR,oBAAA;AL4GF;;AKxGA;;EAEE,oBAAA;AL2GF;;AKtGA;EACE,eAAA;ALyGF;;AKtGA;EAGE,iBAAA;ALuGF;;AKpGE;EACE,UAAA;ALuGJ;;AKhGA;EACE,wBAAA;ALmGF;;AK3FA;;;;EAIE,0BAAA;AL8FF;;AK3FI;;;;EACE,eAAA;ALiGN;;AK1FA;EACE,UAAA;EACA,kBAAA;AL6FF;;AKxFA;EACE,gBAAA;AL2FF;;AKjFA;EACE,YAAA;EACA,UAAA;EACA,SAAA;EACA,SAAA;ALoFF;;AK5EA;EACE,mBAAA;EACA,WAAA;EACA,UAAA;EACA,qBC+P4B;ED7P5B,oBAAA;EFxMM,iCAAA;AHuRR;;AG3bI;EEsWJ;IF3LQ,iBAAA;EHqRN;AACF;AKlFE;EACE,WAAA;ALoFJ;;AK7EA;;;;;;;EAOE,UAAA;ALgFF;;AK7EA;EACE,YAAA;ALgFF;;AKvEA;EACE,6BAAA;EACA,oBAAA;AL0EF;;AKvEE;EACE,eAAA;EACA,oBAAA;AL0EJ;;AKlEE;;;;EAIE,cAAA;ALqEJ;;AK9DA;EACE,wBAAA;ALiEF;;AK5DA;EACE,UAAA;AL+DF;;AKxDA;EACE,aAAA;EACA,0BAAA;AL2DF;;AKtDA;EACE,qBAAA;ALyDF;;AKhDA;EACE,wBAAA;EACA,SAAA;ALmDF;;AK5CA;EACE,kBAAA;EACA,eAAA;AL+CF;;AKvCA;EACE,wBAAA;AL0CF;;AKlCA;EACE,wBAAA;ALqCF;;AQlnBA;EL4QM,kBALI;EKrQR,gBFkrB8B;AN7DhC;;AQhnBE;EAGE,gBFoqBkB;EEnqBlB,gBFmpB0B;EH9YtB,iCAAA;AH6WR;;AGjhBI;EKrGF;ILgRM,eAAA;EH2WN;AACF;AQ5nBE;EAGE,gBFoqBkB;EEnqBlB,gBFmpB0B;EH9YtB,iCAAA;AHwXR;;AG5hBI;EKrGF;ILgRM,iBAAA;EHsXN;AACF;AQvoBE;EAGE,gBFoqBkB;EEnqBlB,gBFmpB0B;EH9YtB,iCAAA;AHmYR;;AGviBI;EKrGF;ILgRM,eAAA;EHiYN;AACF;AQlpBE;EAGE,gBFoqBkB;EEnqBlB,gBFmpB0B;EH9YtB,iCAAA;AH8YR;;AGljBI;EKrGF;ILgRM,iBAAA;EH4YN;AACF;AQ7pBE;EAGE,gBFoqBkB;EEnqBlB,gBFmpB0B;EH9YtB,iCAAA;AHyZR;;AG7jBI;EKrGF;ILgRM,eAAA;EHuZN;AACF;AQxqBE;EAGE,gBFoqBkB;EEnqBlB,gBFmpB0B;EH9YtB,iCAAA;AHoaR;;AGxkBI;EKrGF;ILgRM,iBAAA;EHkaN;AACF;AQ3pBA;EC5DE,uBAAA;EACA,gBAAA;AT0tBF;;AQ1pBA;ECjEE,uBAAA;EACA,gBAAA;AT+tBF;;AQ5pBA;EACE,qBAAA;AR+pBF;;AQ7pBE;EACE,yBFgrB0B;ANhB9B;;AQtpBA;ELuNM,kBALI;EKhNR,yBAAA;ARypBF;;AQrpBA;EACE,mBF6VO;EH7IH,kBALI;AH8cV;;AQtpBE;EACE,gBAAA;ARypBJ;;AQrpBA;EACE,iBAAA;EACA,mBFmVO;EH7IH,kBALI;EK/LR,cFhFU;ANwuBZ;;AQtpBE;EACE,aAAA;ARypBJ;;AUxvBA;ECFE,eAAA;EAGA,YAAA;AX4vBF;;AUvvBA;EACE,gBJwyDkC;EIvyDlC,6DAAA;EACA,gGAAA;EHCE,uCAAA;EIZF,eAAA;EAGA,YAAA;AXqwBF;;AUjvBA;EAEE,qBAAA;AVmvBF;;AUhvBA;EACE,qBAAA;EACA,cAAA;AVmvBF;;AUhvBA;EPiQM,kBALI;EO1PR,kEAAA;AVmvBF;;AYvxBE;;;;;;;ECLA,sBAAA;EACA,iBAAA;EACA,WAAA;EACA,8CAAA;EACA,6CAAA;EACA,kBAAA;EACA,iBAAA;AbsyBF;;AczuBI;EFjDE;IACE,gBN4gBe;ENkRrB;AACF;Ac/uBI;EFjDE;IACE,gBN4gBe;ENuRrB;AACF;AcpvBI;EFjDE;IACE,gBN4gBe;EN4RrB;AACF;AczvBI;EFjDE;IACE,iBN4gBe;ENiSrB;AACF;Ac9vBI;EFjDE;IACE,iBN4gBe;ENsSrB;AACF;Ael0BA;EAEI,sBAAA;EAAA,0BAAA;EAAA,0BAAA;EAAA,0BAAA;EAAA,2BAAA;EAAA,4BAAA;EAGF,2BAAA;Afs0BF;;Ael0BE;ECLA,sBAAA;EACA,iBAAA;EACA,aAAA;EACA,eAAA;EAEA,0CAAA;EACA,8CAAA;EACA,6CAAA;AhB00BF;;Aez0BI;ECSF,cAAA;EACA,WAAA;EACA,eAAA;EACA,8CAAA;EACA,6CAAA;EACA,+BAAA;AhBo0BF;;AgBpxBM;EACE,SAAA;AhBuxBR;;AgBpxBM;EArCJ,cAAA;EACA,WAAA;AhB6zBF;;AgB9yBE;EACE,cAAA;EACA,WAAA;AhBizBJ;;AgBnzBE;EACE,cAAA;EACA,UAAA;AhBszBJ;;AgBxzBE;EACE,cAAA;EACA,mBAAA;AhB2zBJ;;AgB7zBE;EACE,cAAA;EACA,UAAA;AhBg0BJ;;AgBl0BE;EACE,cAAA;EACA,UAAA;AhBq0BJ;;AgBv0BE;EACE,cAAA;EACA,mBAAA;AhB00BJ;;AgB3yBM;EAjDJ,cAAA;EACA,WAAA;AhBg2BF;;AgB1yBU;EAjEN,cAAA;EACA,kBAAA;AhB+2BJ;;AgB/yBU;EAjEN,cAAA;EACA,mBAAA;AhBo3BJ;;AgBpzBU;EAjEN,cAAA;EACA,UAAA;AhBy3BJ;;AgBzzBU;EAjEN,cAAA;EACA,mBAAA;AhB83BJ;;AgB9zBU;EAjEN,cAAA;EACA,mBAAA;AhBm4BJ;;AgBn0BU;EAjEN,cAAA;EACA,UAAA;AhBw4BJ;;AgBx0BU;EAjEN,cAAA;EACA,mBAAA;AhB64BJ;;AgB70BU;EAjEN,cAAA;EACA,mBAAA;AhBk5BJ;;AgBl1BU;EAjEN,cAAA;EACA,UAAA;AhBu5BJ;;AgBv1BU;EAjEN,cAAA;EACA,mBAAA;AhB45BJ;;AgB51BU;EAjEN,cAAA;EACA,mBAAA;AhBi6BJ;;AgBj2BU;EAjEN,cAAA;EACA,WAAA;AhBs6BJ;;AgB91BY;EAxDV,gCAAA;AhB05BF;;AgBl2BY;EAxDV,iCAAA;AhB85BF;;AgBt2BY;EAxDV,wBAAA;AhBk6BF;;AgB12BY;EAxDV,iCAAA;AhBs6BF;;AgB92BY;EAxDV,iCAAA;AhB06BF;;AgBl3BY;EAxDV,wBAAA;AhB86BF;;AgBt3BY;EAxDV,iCAAA;AhBk7BF;;AgB13BY;EAxDV,iCAAA;AhBs7BF;;AgB93BY;EAxDV,wBAAA;AhB07BF;;AgBl4BY;EAxDV,iCAAA;AhB87BF;;AgBt4BY;EAxDV,iCAAA;AhBk8BF;;AgB/3BQ;;EAEE,iBAAA;AhBk4BV;;AgB/3BQ;;EAEE,iBAAA;AhBk4BV;;AgBz4BQ;;EAEE,uBAAA;AhB44BV;;AgBz4BQ;;EAEE,uBAAA;AhB44BV;;AgBn5BQ;;EAEE,sBAAA;AhBs5BV;;AgBn5BQ;;EAEE,sBAAA;AhBs5BV;;AgB75BQ;;EAEE,oBAAA;AhBg6BV;;AgB75BQ;;EAEE,oBAAA;AhBg6BV;;AgBv6BQ;;EAEE,sBAAA;AhB06BV;;AgBv6BQ;;EAEE,sBAAA;AhB06BV;;AgBj7BQ;;EAEE,oBAAA;AhBo7BV;;AgBj7BQ;;EAEE,oBAAA;AhBo7BV;;Ac/+BI;EEWE;IACE,SAAA;EhBw+BN;EgBr+BI;IArCJ,cAAA;IACA,WAAA;EhB6gCA;EgB9/BA;IACE,cAAA;IACA,WAAA;EhBggCF;EgBlgCA;IACE,cAAA;IACA,UAAA;EhBogCF;EgBtgCA;IACE,cAAA;IACA,mBAAA;EhBwgCF;EgB1gCA;IACE,cAAA;IACA,UAAA;EhB4gCF;EgB9gCA;IACE,cAAA;IACA,UAAA;EhBghCF;EgBlhCA;IACE,cAAA;IACA,mBAAA;EhBohCF;EgBr/BI;IAjDJ,cAAA;IACA,WAAA;EhByiCA;EgBn/BQ;IAjEN,cAAA;IACA,kBAAA;EhBujCF;EgBv/BQ;IAjEN,cAAA;IACA,mBAAA;EhB2jCF;EgB3/BQ;IAjEN,cAAA;IACA,UAAA;EhB+jCF;EgB//BQ;IAjEN,cAAA;IACA,mBAAA;EhBmkCF;EgBngCQ;IAjEN,cAAA;IACA,mBAAA;EhBukCF;EgBvgCQ;IAjEN,cAAA;IACA,UAAA;EhB2kCF;EgB3gCQ;IAjEN,cAAA;IACA,mBAAA;EhB+kCF;EgB/gCQ;IAjEN,cAAA;IACA,mBAAA;EhBmlCF;EgBnhCQ;IAjEN,cAAA;IACA,UAAA;EhBulCF;EgBvhCQ;IAjEN,cAAA;IACA,mBAAA;EhB2lCF;EgB3hCQ;IAjEN,cAAA;IACA,mBAAA;EhB+lCF;EgB/hCQ;IAjEN,cAAA;IACA,WAAA;EhBmmCF;EgB3hCU;IAxDV,sBAAA;EhBslCA;EgB9hCU;IAxDV,gCAAA;EhBylCA;EgBjiCU;IAxDV,iCAAA;EhB4lCA;EgBpiCU;IAxDV,wBAAA;EhB+lCA;EgBviCU;IAxDV,iCAAA;EhBkmCA;EgB1iCU;IAxDV,iCAAA;EhBqmCA;EgB7iCU;IAxDV,wBAAA;EhBwmCA;EgBhjCU;IAxDV,iCAAA;EhB2mCA;EgBnjCU;IAxDV,iCAAA;EhB8mCA;EgBtjCU;IAxDV,wBAAA;EhBinCA;EgBzjCU;IAxDV,iCAAA;EhBonCA;EgB5jCU;IAxDV,iCAAA;EhBunCA;EgBpjCM;;IAEE,iBAAA;EhBsjCR;EgBnjCM;;IAEE,iBAAA;EhBqjCR;EgB5jCM;;IAEE,uBAAA;EhB8jCR;EgB3jCM;;IAEE,uBAAA;EhB6jCR;EgBpkCM;;IAEE,sBAAA;EhBskCR;EgBnkCM;;IAEE,sBAAA;EhBqkCR;EgB5kCM;;IAEE,oBAAA;EhB8kCR;EgB3kCM;;IAEE,oBAAA;EhB6kCR;EgBplCM;;IAEE,sBAAA;EhBslCR;EgBnlCM;;IAEE,sBAAA;EhBqlCR;EgB5lCM;;IAEE,oBAAA;EhB8lCR;EgB3lCM;;IAEE,oBAAA;EhB6lCR;AACF;AczpCI;EEWE;IACE,SAAA;EhBipCN;EgB9oCI;IArCJ,cAAA;IACA,WAAA;EhBsrCA;EgBvqCA;IACE,cAAA;IACA,WAAA;EhByqCF;EgB3qCA;IACE,cAAA;IACA,UAAA;EhB6qCF;EgB/qCA;IACE,cAAA;IACA,mBAAA;EhBirCF;EgBnrCA;IACE,cAAA;IACA,UAAA;EhBqrCF;EgBvrCA;IACE,cAAA;IACA,UAAA;EhByrCF;EgB3rCA;IACE,cAAA;IACA,mBAAA;EhB6rCF;EgB9pCI;IAjDJ,cAAA;IACA,WAAA;EhBktCA;EgB5pCQ;IAjEN,cAAA;IACA,kBAAA;EhBguCF;EgBhqCQ;IAjEN,cAAA;IACA,mBAAA;EhBouCF;EgBpqCQ;IAjEN,cAAA;IACA,UAAA;EhBwuCF;EgBxqCQ;IAjEN,cAAA;IACA,mBAAA;EhB4uCF;EgB5qCQ;IAjEN,cAAA;IACA,mBAAA;EhBgvCF;EgBhrCQ;IAjEN,cAAA;IACA,UAAA;EhBovCF;EgBprCQ;IAjEN,cAAA;IACA,mBAAA;EhBwvCF;EgBxrCQ;IAjEN,cAAA;IACA,mBAAA;EhB4vCF;EgB5rCQ;IAjEN,cAAA;IACA,UAAA;EhBgwCF;EgBhsCQ;IAjEN,cAAA;IACA,mBAAA;EhBowCF;EgBpsCQ;IAjEN,cAAA;IACA,mBAAA;EhBwwCF;EgBxsCQ;IAjEN,cAAA;IACA,WAAA;EhB4wCF;EgBpsCU;IAxDV,sBAAA;EhB+vCA;EgBvsCU;IAxDV,gCAAA;EhBkwCA;EgB1sCU;IAxDV,iCAAA;EhBqwCA;EgB7sCU;IAxDV,wBAAA;EhBwwCA;EgBhtCU;IAxDV,iCAAA;EhB2wCA;EgBntCU;IAxDV,iCAAA;EhB8wCA;EgBttCU;IAxDV,wBAAA;EhBixCA;EgBztCU;IAxDV,iCAAA;EhBoxCA;EgB5tCU;IAxDV,iCAAA;EhBuxCA;EgB/tCU;IAxDV,wBAAA;EhB0xCA;EgBluCU;IAxDV,iCAAA;EhB6xCA;EgBruCU;IAxDV,iCAAA;EhBgyCA;EgB7tCM;;IAEE,iBAAA;EhB+tCR;EgB5tCM;;IAEE,iBAAA;EhB8tCR;EgBruCM;;IAEE,uBAAA;EhBuuCR;EgBpuCM;;IAEE,uBAAA;EhBsuCR;EgB7uCM;;IAEE,sBAAA;EhB+uCR;EgB5uCM;;IAEE,sBAAA;EhB8uCR;EgBrvCM;;IAEE,oBAAA;EhBuvCR;EgBpvCM;;IAEE,oBAAA;EhBsvCR;EgB7vCM;;IAEE,sBAAA;EhB+vCR;EgB5vCM;;IAEE,sBAAA;EhB8vCR;EgBrwCM;;IAEE,oBAAA;EhBuwCR;EgBpwCM;;IAEE,oBAAA;EhBswCR;AACF;Acl0CI;EEWE;IACE,SAAA;EhB0zCN;EgBvzCI;IArCJ,cAAA;IACA,WAAA;EhB+1CA;EgBh1CA;IACE,cAAA;IACA,WAAA;EhBk1CF;EgBp1CA;IACE,cAAA;IACA,UAAA;EhBs1CF;EgBx1CA;IACE,cAAA;IACA,mBAAA;EhB01CF;EgB51CA;IACE,cAAA;IACA,UAAA;EhB81CF;EgBh2CA;IACE,cAAA;IACA,UAAA;EhBk2CF;EgBp2CA;IACE,cAAA;IACA,mBAAA;EhBs2CF;EgBv0CI;IAjDJ,cAAA;IACA,WAAA;EhB23CA;EgBr0CQ;IAjEN,cAAA;IACA,kBAAA;EhBy4CF;EgBz0CQ;IAjEN,cAAA;IACA,mBAAA;EhB64CF;EgB70CQ;IAjEN,cAAA;IACA,UAAA;EhBi5CF;EgBj1CQ;IAjEN,cAAA;IACA,mBAAA;EhBq5CF;EgBr1CQ;IAjEN,cAAA;IACA,mBAAA;EhBy5CF;EgBz1CQ;IAjEN,cAAA;IACA,UAAA;EhB65CF;EgB71CQ;IAjEN,cAAA;IACA,mBAAA;EhBi6CF;EgBj2CQ;IAjEN,cAAA;IACA,mBAAA;EhBq6CF;EgBr2CQ;IAjEN,cAAA;IACA,UAAA;EhBy6CF;EgBz2CQ;IAjEN,cAAA;IACA,mBAAA;EhB66CF;EgB72CQ;IAjEN,cAAA;IACA,mBAAA;EhBi7CF;EgBj3CQ;IAjEN,cAAA;IACA,WAAA;EhBq7CF;EgB72CU;IAxDV,sBAAA;EhBw6CA;EgBh3CU;IAxDV,gCAAA;EhB26CA;EgBn3CU;IAxDV,iCAAA;EhB86CA;EgBt3CU;IAxDV,wBAAA;EhBi7CA;EgBz3CU;IAxDV,iCAAA;EhBo7CA;EgB53CU;IAxDV,iCAAA;EhBu7CA;EgB/3CU;IAxDV,wBAAA;EhB07CA;EgBl4CU;IAxDV,iCAAA;EhB67CA;EgBr4CU;IAxDV,iCAAA;EhBg8CA;EgBx4CU;IAxDV,wBAAA;EhBm8CA;EgB34CU;IAxDV,iCAAA;EhBs8CA;EgB94CU;IAxDV,iCAAA;EhBy8CA;EgBt4CM;;IAEE,iBAAA;EhBw4CR;EgBr4CM;;IAEE,iBAAA;EhBu4CR;EgB94CM;;IAEE,uBAAA;EhBg5CR;EgB74CM;;IAEE,uBAAA;EhB+4CR;EgBt5CM;;IAEE,sBAAA;EhBw5CR;EgBr5CM;;IAEE,sBAAA;EhBu5CR;EgB95CM;;IAEE,oBAAA;EhBg6CR;EgB75CM;;IAEE,oBAAA;EhB+5CR;EgBt6CM;;IAEE,sBAAA;EhBw6CR;EgBr6CM;;IAEE,sBAAA;EhBu6CR;EgB96CM;;IAEE,oBAAA;EhBg7CR;EgB76CM;;IAEE,oBAAA;EhB+6CR;AACF;Ac3+CI;EEWE;IACE,SAAA;EhBm+CN;EgBh+CI;IArCJ,cAAA;IACA,WAAA;EhBwgDA;EgBz/CA;IACE,cAAA;IACA,WAAA;EhB2/CF;EgB7/CA;IACE,cAAA;IACA,UAAA;EhB+/CF;EgBjgDA;IACE,cAAA;IACA,mBAAA;EhBmgDF;EgBrgDA;IACE,cAAA;IACA,UAAA;EhBugDF;EgBzgDA;IACE,cAAA;IACA,UAAA;EhB2gDF;EgB7gDA;IACE,cAAA;IACA,mBAAA;EhB+gDF;EgBh/CI;IAjDJ,cAAA;IACA,WAAA;EhBoiDA;EgB9+CQ;IAjEN,cAAA;IACA,kBAAA;EhBkjDF;EgBl/CQ;IAjEN,cAAA;IACA,mBAAA;EhBsjDF;EgBt/CQ;IAjEN,cAAA;IACA,UAAA;EhB0jDF;EgB1/CQ;IAjEN,cAAA;IACA,mBAAA;EhB8jDF;EgB9/CQ;IAjEN,cAAA;IACA,mBAAA;EhBkkDF;EgBlgDQ;IAjEN,cAAA;IACA,UAAA;EhBskDF;EgBtgDQ;IAjEN,cAAA;IACA,mBAAA;EhB0kDF;EgB1gDQ;IAjEN,cAAA;IACA,mBAAA;EhB8kDF;EgB9gDQ;IAjEN,cAAA;IACA,UAAA;EhBklDF;EgBlhDQ;IAjEN,cAAA;IACA,mBAAA;EhBslDF;EgBthDQ;IAjEN,cAAA;IACA,mBAAA;EhB0lDF;EgB1hDQ;IAjEN,cAAA;IACA,WAAA;EhB8lDF;EgBthDU;IAxDV,sBAAA;EhBilDA;EgBzhDU;IAxDV,gCAAA;EhBolDA;EgB5hDU;IAxDV,iCAAA;EhBulDA;EgB/hDU;IAxDV,wBAAA;EhB0lDA;EgBliDU;IAxDV,iCAAA;EhB6lDA;EgBriDU;IAxDV,iCAAA;EhBgmDA;EgBxiDU;IAxDV,wBAAA;EhBmmDA;EgB3iDU;IAxDV,iCAAA;EhBsmDA;EgB9iDU;IAxDV,iCAAA;EhBymDA;EgBjjDU;IAxDV,wBAAA;EhB4mDA;EgBpjDU;IAxDV,iCAAA;EhB+mDA;EgBvjDU;IAxDV,iCAAA;EhBknDA;EgB/iDM;;IAEE,iBAAA;EhBijDR;EgB9iDM;;IAEE,iBAAA;EhBgjDR;EgBvjDM;;IAEE,uBAAA;EhByjDR;EgBtjDM;;IAEE,uBAAA;EhBwjDR;EgB/jDM;;IAEE,sBAAA;EhBikDR;EgB9jDM;;IAEE,sBAAA;EhBgkDR;EgBvkDM;;IAEE,oBAAA;EhBykDR;EgBtkDM;;IAEE,oBAAA;EhBwkDR;EgB/kDM;;IAEE,sBAAA;EhBilDR;EgB9kDM;;IAEE,sBAAA;EhBglDR;EgBvlDM;;IAEE,oBAAA;EhBylDR;EgBtlDM;;IAEE,oBAAA;EhBwlDR;AACF;AcppDI;EEWE;IACE,SAAA;EhB4oDN;EgBzoDI;IArCJ,cAAA;IACA,WAAA;EhBirDA;EgBlqDA;IACE,cAAA;IACA,WAAA;EhBoqDF;EgBtqDA;IACE,cAAA;IACA,UAAA;EhBwqDF;EgB1qDA;IACE,cAAA;IACA,mBAAA;EhB4qDF;EgB9qDA;IACE,cAAA;IACA,UAAA;EhBgrDF;EgBlrDA;IACE,cAAA;IACA,UAAA;EhBorDF;EgBtrDA;IACE,cAAA;IACA,mBAAA;EhBwrDF;EgBzpDI;IAjDJ,cAAA;IACA,WAAA;EhB6sDA;EgBvpDQ;IAjEN,cAAA;IACA,kBAAA;EhB2tDF;EgB3pDQ;IAjEN,cAAA;IACA,mBAAA;EhB+tDF;EgB/pDQ;IAjEN,cAAA;IACA,UAAA;EhBmuDF;EgBnqDQ;IAjEN,cAAA;IACA,mBAAA;EhBuuDF;EgBvqDQ;IAjEN,cAAA;IACA,mBAAA;EhB2uDF;EgB3qDQ;IAjEN,cAAA;IACA,UAAA;EhB+uDF;EgB/qDQ;IAjEN,cAAA;IACA,mBAAA;EhBmvDF;EgBnrDQ;IAjEN,cAAA;IACA,mBAAA;EhBuvDF;EgBvrDQ;IAjEN,cAAA;IACA,UAAA;EhB2vDF;EgB3rDQ;IAjEN,cAAA;IACA,mBAAA;EhB+vDF;EgB/rDQ;IAjEN,cAAA;IACA,mBAAA;EhBmwDF;EgBnsDQ;IAjEN,cAAA;IACA,WAAA;EhBuwDF;EgB/rDU;IAxDV,sBAAA;EhB0vDA;EgBlsDU;IAxDV,gCAAA;EhB6vDA;EgBrsDU;IAxDV,iCAAA;EhBgwDA;EgBxsDU;IAxDV,wBAAA;EhBmwDA;EgB3sDU;IAxDV,iCAAA;EhBswDA;EgB9sDU;IAxDV,iCAAA;EhBywDA;EgBjtDU;IAxDV,wBAAA;EhB4wDA;EgBptDU;IAxDV,iCAAA;EhB+wDA;EgBvtDU;IAxDV,iCAAA;EhBkxDA;EgB1tDU;IAxDV,wBAAA;EhBqxDA;EgB7tDU;IAxDV,iCAAA;EhBwxDA;EgBhuDU;IAxDV,iCAAA;EhB2xDA;EgBxtDM;;IAEE,iBAAA;EhB0tDR;EgBvtDM;;IAEE,iBAAA;EhBytDR;EgBhuDM;;IAEE,uBAAA;EhBkuDR;EgB/tDM;;IAEE,uBAAA;EhBiuDR;EgBxuDM;;IAEE,sBAAA;EhB0uDR;EgBvuDM;;IAEE,sBAAA;EhByuDR;EgBhvDM;;IAEE,oBAAA;EhBkvDR;EgB/uDM;;IAEE,oBAAA;EhBivDR;EgBxvDM;;IAEE,sBAAA;EhB0vDR;EgBvvDM;;IAEE,sBAAA;EhByvDR;EgBhwDM;;IAEE,oBAAA;EhBkwDR;EgB/vDM;;IAEE,oBAAA;EhBiwDR;AACF;AiB53DA;EAEE,+BAAA;EACA,4BAAA;EACA,gCAAA;EACA,6BAAA;EAEA,4CAAA;EACA,kCAAA;EACA,iDAAA;EACA,kCAAA;EACA,oDAAA;EACA,iEAAA;EACA,mDAAA;EACA,+DAAA;EACA,kDAAA;EACA,gEAAA;EAEA,WAAA;EACA,mBX8ZO;EW7ZP,mBXwvB4B;EWvvB5B,2CAAA;AjB23DF;;AiBp3DE;EACE,sBAAA;EAEA,wFAAA;EACA,qCAAA;EACA,4CXgwB0B;EW/vB1B,8GAAA;AjBs3DJ;;AiBn3DE;EACE,uBAAA;AjBs3DJ;;AiBn3DE;EACE,sBAAA;AjBs3DJ;;AiBl3DA;EACE,gEAAA;AjBq3DF;;AiB92DA;EACE,iBAAA;AjBi3DF;;AiBv2DE;EACE,wBAAA;AjB02DJ;;AiB31DE;EACE,uCAAA;AjB81DJ;;AiB31DI;EACE,uCAAA;AjB81DN;;AiBv1DE;EACE,sBAAA;AjB01DJ;;AiBv1DE;EACE,mBAAA;AjB01DJ;;AiBh1DE;EACE,sDAAA;EACA,gDAAA;AjBm1DJ;;AiB70DE;EACE,sDAAA;EACA,gDAAA;AjBg1DJ;;AiBx0DA;EACE,sDAAA;EACA,gDAAA;AjB20DF;;AiBn0DE;EACE,qDAAA;EACA,+CAAA;AjBs0DJ;;AkBj9DE;EAUE,0BAAA;EACA,mEAAA;EACA,4EAAA;EACA,2EAAA;EACA,kCAAA;EACA,yEAAA;EACA,iCAAA;EACA,yEAAA;EACA,gCAAA;EACA,6BAAA;EACA,2CAAA;AlB28DJ;;AkB/9DE;EAUE,0BAAA;EACA,kEAAA;EACA,6EAAA;EACA,0EAAA;EACA,kCAAA;EACA,0EAAA;EACA,iCAAA;EACA,yEAAA;EACA,gCAAA;EACA,6BAAA;EACA,2CAAA;AlBy9DJ;;AkB7+DE;EAUE,0BAAA;EACA,kEAAA;EACA,4EAAA;EACA,yEAAA;EACA,kCAAA;EACA,0EAAA;EACA,iCAAA;EACA,yEAAA;EACA,gCAAA;EACA,6BAAA;EACA,2CAAA;AlBu+DJ;;AkB3/DE;EAUE,0BAAA;EACA,mCAAA;EACA,6EAAA;EACA,2EAAA;EACA,kCAAA;EACA,0EAAA;EACA,iCAAA;EACA,yEAAA;EACA,gCAAA;EACA,6BAAA;EACA,2CAAA;AlBq/DJ;;AkBzgEE;EAUE,0BAAA;EACA,mEAAA;EACA,6EAAA;EACA,kEAAA;EACA,kCAAA;EACA,0EAAA;EACA,iCAAA;EACA,gEAAA;EACA,gCAAA;EACA,6BAAA;EACA,2CAAA;AlBmgEJ;;AkBvhEE;EAUE,0BAAA;EACA,mEAAA;EACA,6EAAA;EACA,2EAAA;EACA,kCAAA;EACA,0EAAA;EACA,iCAAA;EACA,yEAAA;EACA,gCAAA;EACA,6BAAA;EACA,2CAAA;AlBihEJ;;AkBriEE;EAUE,0BAAA;EACA,uBAAA;EACA,2EAAA;EACA,2EAAA;EACA,kCAAA;EACA,0EAAA;EACA,iCAAA;EACA,yEAAA;EACA,gCAAA;EACA,6BAAA;EACA,2CAAA;AlB+hEJ;;AkBnjEE;EAUE,uBAAA;EACA,uBAAA;EACA,6EAAA;EACA,2EAAA;EACA,+BAAA;EACA,0EAAA;EACA,8BAAA;EACA,yEAAA;EACA,6BAAA;EACA,6BAAA;EACA,2CAAA;AlB6iEJ;;AiB/5DI;EACE,gBAAA;EACA,iCAAA;AjBk6DN;;Acz/DI;EGqFA;IACE,gBAAA;IACA,iCAAA;EjBw6DJ;AACF;AchgEI;EGqFA;IACE,gBAAA;IACA,iCAAA;EjB86DJ;AACF;ActgEI;EGqFA;IACE,gBAAA;IACA,iCAAA;EjBo7DJ;AACF;Ac5gEI;EGqFA;IACE,gBAAA;IACA,iCAAA;EjB07DJ;AACF;AclhEI;EGqFA;IACE,gBAAA;IACA,iCAAA;EjBg8DJ;AACF;AmB1kEA;EAEE,sFAAA;EACA,mCAAA;EACA,mCAAA;EACA,gCAAA;EACA,uCAAA;EACA,6CAAA;EACA,sDAAA;EACA,sDAAA;EACA,wDAAA;EACA,8BAAA;EACA,yFAAA;EAGA,aAAA;EACA,eAAA;EACA,8BAAA;EACA,mBAAA;EACA,4CAAA;EACA,wEAAA;EhBsPI,0CALI;EgB/OR,kCAAA;EACA,0CAAA;EACA,mFAAA;EZpCE,kDAAA;EaJE,4CD0CJ;AnBykEF;;AoB/mEM;EDYN;ICXQ,gBAAA;EpBmnEN;AACF;AmB5kEE;EACE,gEb85BoC;Eez9BtC,UAAA;EACA,kGAAA;ArB0oEF;;AmB3kEE;EACE,yCb24BoC;Ea14BpC,UAAA;AnB8kEJ;;AmB5kEI;EACE,aAAA;AnB+kEN;;AmB7kEM;EACE,oBAAA;AnBglER;;AmB1kEA;EACE,cAAA;EACA,SAAA;EACA,SAAA;EACA,UAAA;AnB6kEF;;AmBzkEA;EACE,mFAAA;EACA,oCAAA;EACA,gCAAA;EACA,2DAAA;EACA,mCAAA;EACA,4BAAA;AnB4kEF;;AmBzkEA;EACE,qFAAA;EACA,oCAAA;EACA,kCAAA;EACA,2DAAA;EACA,oCAAA;EACA,8BAAA;AnB4kEF;;AsB/qEA;EACE,qBhBg7BsC;ANkwCxC;;AsBzqEA;EACE,qDAAA;EACA,wDAAA;EACA,gBAAA;EnBwRI,kBALI;EmB/QR,gBhB0oB4B;ANgiD9B;;AsBtqEA;EACE,mDAAA;EACA,sDAAA;EnB8QI,kBALI;AHi6DV;;AsBtqEA;EACE,oDAAA;EACA,uDAAA;EnBwQI,mBALI;AHu6DV;;AuBxsEA;EACE,mBjBy6BsC;EHpoBlC,kBALI;EoB5RR,iCjBy6BsC;ANgyCxC;;AwBzsEA;EACE,cAAA;EACA,WAAA;EACA,yBAAA;ErB8RI,eALI;EqBtRR,gBlByoB4B;EkBxoB5B,gBlBgpB4B;EkB/oB5B,4BlBi8BsC;EkBh8BtC,gBAAA;EACA,oClB07BsC;EkBz7BtC,4BAAA;EACA,6DAAA;EjBDE,uCAAA;EaJE,wEIWJ;AxBusEF;;AoB9sEM;EIXN;IJYQ,gBAAA;EpBktEN;AACF;AwB3sEE;EACE,gBAAA;AxB6sEJ;;AwB3sEI;EACE,eAAA;AxB8sEN;;AwBzsEE;EACE,4BlB26BoC;EkB16BpC,oClBq6BoC;EkBp6BpC,gElBm7BoC;EkBl7BpC,UAAA;EAKE,iDlByjBkB;AN+oDxB;;AwBpsEE;EAME,eAAA;EAOA,aAAA;EAKA,SAAA;AxBwrEJ;;AwBnrEE;EACE,cAAA;EACA,UAAA;AxBsrEJ;;AwBlrEE;EACE,qEAAA;EAEA,UAAA;AxBorEJ;;AwB5qEE;EAEE,yClBk3BoC;EkB/2BpC,UAAA;AxB4qEJ;;AwBxqEE;EACE,yBAAA;EACA,0BAAA;EACA,0BlBiuB0B;EkBhuB1B,4BlB02BoC;EmB/8BtC,wCnB6nCgC;EkBthC9B,oBAAA;EACA,qBAAA;EACA,mBAAA;EACA,eAAA;EACA,gDlB6uB0B;EkB5uB1B,gBAAA;EJ/FE,qIIgGF;AxB2qEJ;;AoBvwEM;EIgFJ;IJ/EM,gBAAA;EpB2wEN;AACF;AwB9qEE;EACE,yClB6gC8B;ANmqClC;;AwBvqEA;EACE,cAAA;EACA,WAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBlB8hB4B;EkB7hB5B,4BlB+1BsC;EkB91BtC,6BAAA;EACA,yBAAA;EACA,uCAAA;AxB0qEF;;AwBxqEE;EACE,UAAA;AxB2qEJ;;AwBxqEE;EAEE,gBAAA;EACA,eAAA;AxB0qEJ;;AwB/pEA;EACE,oElBg1BsC;EkB/0BtC,uBAAA;ErB8II,mBALI;EIjRN,0CAAA;AP4yEJ;;AwBhqEE;EACE,uBAAA;EACA,wBAAA;EACA,yBlBirB0B;ANk/C9B;;AwB/pEA;EACE,kElBo0BsC;EkBn0BtC,oBAAA;ErBiII,kBALI;EIjRN,0CAAA;APyzEJ;;AwBhqEE;EACE,oBAAA;EACA,qBAAA;EACA,uBlBwqB0B;AN2/C9B;;AwB3pEE;EACE,qElBizBoC;AN62CxC;;AwB3pEE;EACE,oElB8yBoC;ANg3CxC;;AwB3pEE;EACE,kElB2yBoC;ANm3CxC;;AwBzpEA;EACE,WlByyBsC;EkBxyBtC,iElBkyBsC;EkBjyBtC,iBlB8nB4B;AN8hD9B;;AwB1pEE;EACE,eAAA;AxB6pEJ;;AwB1pEE;EACE,oBAAA;EjB5LA,uCAAA;AP01EJ;;AwB1pEE;EACE,oBAAA;EjBjMA,uCAAA;AP+1EJ;;AwB1pEE;EAAoB,gElBkxBkB;AN44CxC;;AwB7pEE;EAAoB,8DlBkxBkB;AN+4CxC;;A0B/2EA;EACE,iEAAA;EAEA,cAAA;EACA,WAAA;EACA,6BpBuzB4B;EoBtzB5B,2BpBgjCkC;EoB/iClC,qBpBozB4B;EoBnzB5B,wBpBmzB4B;EH7hBxB,eALI;EuB9QR,gBpBioB4B;EoBhoB5B,gBpBwoB4B;EoBvoB5B,4BpBy7BsC;EoBx7BtC,gBAAA;EACA,oCpBk7BsC;EoBj7BtC,qFAAA;EACA,4BAAA;EC8FI,yCAAA;ED5FJ,0BpB4iCkC;EoB3iClC,6DAAA;EnBZE,uCAAA;EaJE,wEMmBJ;A1B+2EF;;AoB93EM;EMRN;INSQ,gBAAA;EpBk4EN;AACF;A0Bn3EE;EACE,gEpBs7BoC;EoBr7BpC,UAAA;EAKE,iDpB8iC4B;ANm0ClC;;A0B72EE;EAEE,2BpBsxB0B;EoBrxB1B,sBAAA;A1B+2EJ;;A0B52EE;EAEE,yCpBu5BoC;ANu9CxC;;A0Bz2EE;EACE,kBAAA;EACA,wCAAA;A1B42EJ;;A0Bx2EA;EACE,4BpBgxB4B;EoB/wB5B,oBpB8wB4B;EoB7wB5B,uBpB6wB4B;EHziBxB,mBALI;EIjRN,0CAAA;AP+5EJ;;A0Bx2EA;EACE,0BpB4wB4B;EoB3wB5B,mBpB0wB4B;EoBzwB5B,sBpBywB4B;EH7iBxB,kBALI;EIjRN,0CAAA;APu6EJ;;A0Bt2EI;EACE,iEAAA;A1By2EN;;A4Bt7EA;EACE,cAAA;EACA,kBtB0+BwC;EsBz+BxC,2BtB0+BwC;EsBz+BxC,uBtB0+BwC;AN+8C1C;;A4Bv7EE;EACE,mBAAA;EACA,2BAAA;A5B07EJ;;A4Bt7EA;EACE,uBAAA;EACA,eAAA;A5By7EF;;A4Bv7EE;EACE,iBAAA;EACA,uBAAA;A5B07EJ;;A4Bt7EA;EACE,uCAAA;EAEA,cAAA;EACA,UtBi9BwC;EsBh9BxC,WtBg9BwC;EsB/8BxC,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,0CAAA;EACA,gDAAA;EACA,4BAAA;EACA,2BAAA;EACA,wBAAA;EACA,6DtBk9BwC;EsBj9BxC,yBAAA;A5Bw7EF;;A4Br7EE;ErB7BE,qBAAA;APs9EJ;;A4Br7EE;EAEE,kBtB08BsC;AN6+C1C;;A4Bp7EE;EACE,uBtBi8BsC;ANs/C1C;;A4Bp7EE;EACE,gEtB65BoC;EsB55BpC,UAAA;EACA,iDtBuiBoB;ANg5DxB;;A4Bp7EE;EACE,kFAAA;EACA,kFAAA;A5Bu7EJ;;A4Br7EI;EAII,kEAAA;A5Bq7ER;;A4Bj7EI;EAII,kEAAA;A5Bi7ER;;A4B56EE;EACE,oCtBugB0B;EsBtgB1B,gCtBsgB0B;EsBjgBxB,kEAAA;A5B26EN;;A4Bv6EE;EACE,oBAAA;EACA,YAAA;EACA,YtBy6BuC;ANigD3C;;A4Bn6EI;EACE,eAAA;EACA,YtBg6BqC;ANsgD3C;;A4Bj6EA;EACE,0CAAA;A5Bo6EF;;A4B55EA;EACE,2BtB25BgC;ANogDlC;;A4B75EE;EACE,6DAAA;EAEA,UtBq5B8B;EsBp5B9B,2BAAA;EACA,2CAAA;EACA,gCAAA;ErBnHA,kBAAA;EaJE,iDQyHF;A5B+5EJ;;AoBphFM;EQ6GJ;IR5GM,gBAAA;EpBwhFN;AACF;A4Bn6EI;EACE,2MAAA;A5Bq6EN;;A4Bl6EI;EACE,iCtBo5B4B;EsB/4B1B,6DAAA;A5Bi6ER;;A4B55EE;EACE,uBAAA;A5B+5EJ;;A4B75EI;EACE,uBAAA;A5Bg6EN;;A4Bv5EE;EACE,kBAHO;EAIP,yBAAA;A5B05EJ;;A4Bx5EI;EACE,YARI;EASJ,cARK;EASL,yBAAA;A5B25EN;;A4Bx5EI;EAEE,sCAAA;A5B05EN;;A4Bt6EE;EACE,iBAHO;EAIP,2BAAA;A5By6EJ;;A4Bv6EI;EACE,UARI;EASJ,aARK;EASL,2BAAA;A5B06EN;;A4Bv6EI;EAEE,qCAAA;A5By6EN;;A4Bp6EA;EACE,qBAAA;EACA,uBtB01BgC;AN6kDlC;;A4Bp6EA;EACE,kBAAA;EACA,sBAAA;EACA,oBAAA;A5Bu6EF;;A4Bn6EI;EACE,oBAAA;EACA,YAAA;EACA,atBmrBwB;ANmvD9B;;A4B/5EI;EACE,6DAAA;A5Bk6EN;;A6BvmFA;EACE,WAAA;EACA,cAAA;EACA,UAAA;EACA,gBAAA;EACA,6BAAA;A7B0mFF;;A6BxmFE;EACE,UAAA;A7B2mFJ;;A6BvmFI;EAA0B,iEvBimCa;AN0gD3C;;A6B1mFI;EAA0B,iEvBgmCa;AN8gD3C;;A6B3mFE;EACE,SAAA;A7B8mFJ;;A6B3mFE;EACE,WvBklCuC;EuBjlCvC,YvBilCuC;EuBhlCvC,oBAAA;EACA,gBAAA;EJ/BF,oCnB8lB4B;EuB7jB1B,SvBglCuC;EChmCvC,mBAAA;EaJE,oHSuBF;ETvBE,4GSuBF;A7B6mFJ;;AoBhoFM;ESUJ;ITTM,wBAAA;IAAA,gBAAA;EpBooFN;AACF;A6BjnFI;EJtCF,qEnBsnCyC;ANoiD3C;;A6B/mFE;EACE,WvB2jC8B;EuB1jC9B,cvB2jC8B;EuB1jC9B,kBAAA;EACA,evB0jC8B;EuBzjC9B,yCvB0jC8B;EuBzjC9B,yBAAA;EtBhCA,mBAAA;APmpFJ;;A6B9mFE;EACE,WvBujCuC;EuBtjCvC,YvBsjCuC;EuBrjCvC,gBAAA;EJzDF,oCnB8lB4B;EuBniB1B,SvBsjCuC;EChmCvC,mBAAA;EaJE,iHSiDF;ETjDE,4GSiDF;A7BgnFJ;;AoB7pFM;ESqCJ;ITpCM,qBAAA;IAAA,gBAAA;EpBiqFN;AACF;A6BpnFI;EJhEF,qEnBsnCyC;ANikD3C;;A6BlnFE;EACE,WvBiiC8B;EuBhiC9B,cvBiiC8B;EuBhiC9B,kBAAA;EACA,evBgiC8B;EuB/hC9B,yCvBgiC8B;EuB/hC9B,yBAAA;EtB1DA,mBAAA;APgrFJ;;A6BjnFE;EACE,oBAAA;A7BonFJ;;A6BlnFI;EACE,4CvBmiCqC;ANklD3C;;A6BlnFI;EACE,4CvB+hCqC;ANslD3C;;A8B/sFA;EACE,kBAAA;A9BktFF;;A8BhtFE;;;EAGE,wDxB8nCoC;EwB7nCpC,4DxB6nCoC;EwB5nCpC,iBxB6nCoC;ANslDxC;;A8BhtFE;EACE,kBAAA;EACA,qBAAA;EACA,MAAA;EACA,UAAA;EACA,eAAA;EACA,YAAA;EACA,qBAAA;EACA,gBAAA;EACA,4CAAA;EACA,iBAAA;EACA,uBAAA;EACA,mBAAA;EACA,oBAAA;EACA,iDAAA;EACA,qBAAA;EVXE,gEUYF;A9BmtFJ;;AoB3tFM;EURJ;IVSM,gBAAA;EpB+tFN;AACF;A8BttFE;;EAEE,qBAAA;A9BwtFJ;;A8BttFI;;EACE,kBAAA;A9B0tFN;;A8BvtFI;;;EAEE,qBxBgmCkC;EwB/lClC,wBxBgmCkC;AN2nDxC;;A8BxtFI;;EACE,qBxB2lCkC;EwB1lClC,wBxB2lCkC;ANioDxC;;A8BxtFE;EACE,6BxBoxB0B;EwBnxB1B,qBxBolCoC;EwBnlCpC,wBxBolCoC;ANuoDxC;;A8BptFI;;;;EACE,8DxB+kCkC;AN2oDxC;;A8BrtFI;EACE,8DxBykCkC;AN+oDxC;;A8BntFI;;EACE,kBAAA;EACA,oBAAA;EACA,WAAA;EACA,axB8jCkC;EwB7jClC,WAAA;EACA,oCxB83BkC;ECz7BpC,uCAAA;APmxFJ;;A8BptFE;EACE,yCxB23BoC;AN41DxC;;A8BntFI;EACE,uCAAA;A9BstFN;;A8BltFE;;EAEE,cxBzEQ;AN8xFZ;;A+B7yFA;EACE,kBAAA;EACA,aAAA;EACA,eAAA;EACA,oBAAA;EACA,WAAA;A/BgzFF;;A+B9yFE;;;EAGE,kBAAA;EACA,cAAA;EACA,SAAA;EACA,YAAA;A/BizFJ;;A+B7yFE;;;EAGE,UAAA;A/BgzFJ;;A+B1yFE;EACE,kBAAA;EACA,UAAA;A/B6yFJ;;A+B3yFI;EACE,UAAA;A/B8yFN;;A+BnyFA;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;E5BsPI,eALI;E4B/OR,gBzBkmB4B;EyBjmB5B,gBzBymB4B;EyBxmB5B,gEAAA;EACA,kBAAA;EACA,mBAAA;EACA,yEAAA;EACA,wGAAA;ExBxCE,uCAAA;AP+0FJ;;A+B7xFA;;;;EAIE,oBAAA;E5BgOI,kBALI;EIjRN,0CAAA;APw1FJ;;A+B7xFA;;;;EAIE,uBAAA;E5BuNI,mBALI;EIjRN,0CAAA;APi2FJ;;A+B7xFA;;EAEE,wBAAA;A/BgyFF;;A+BnxFI;;;;ExBnEA,0BAAA;EACA,wBAAA;AP61FJ;;A+BlxFI;;;;ExB5EA,0BAAA;EACA,wBAAA;APq2FJ;;A+B7wFE;EACE,uDAAA;ExB5EA,4BAAA;EACA,0BAAA;AP61FJ;;A+B9wFE;;ExBhFE,4BAAA;EACA,0BAAA;APm2FJ;;AgCv3FE;EACE,aAAA;EACA,WAAA;EACA,mB1B44BoC;EHpoBlC,kBALI;E6BhQN,kC1BooCqB;ANqvDzB;;AgCt3FE;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,eAAA;EACA,uBAAA;EACA,kBAAA;E7B2PE,mBALI;E6BnPN,W1BunCqB;E0BtnCrB,oC1BsnCqB;ECrpCrB,uCAAA;APw5FJ;;AgCp3FI;;;;EAEE,cAAA;AhCy3FN;;AgCx6FI;EAqDE,gD1BymCmB;E0BtmCjB,yC1Bm6BgC;E0Bl6BhC,yDAAA;EACA,4BAAA;ELsDF,2DAAA;EKpDE,gEAAA;AhCq3FR;;AgCl3FM;EACE,gD1B8lCiB;E0BzlCf,4D1BylCe;ANwxDzB;;AgCt7FI;EA+EI,yC1B44BgC;EqB32BlC,kFAAA;A3B20FN;;AgC37FI;EAuFE,gD1BukCmB;ANiyDzB;;AgCr2FQ;EAEE,kEAAA;EACA,4B1Bu+B8B;EqBp9BlC,+DAAA;EKjBI,2EAAA;AhCu2FV;;AgCn2FM;EACE,gD1B0jCiB;E0BrjCf,4D1BqjCe;AN6yDzB;;AgC38FI;EAkHI,yCAAA;AhC61FR;;AgC/8FI;EAyHE,gD1BqiCmB;ANqzDzB;;AgCx1FM;EACE,6C1BkiCiB;ANyzDzB;;AgCx1FM;EACE,4D1B8hCiB;AN6zDzB;;AgCx1FM;EACE,kC1B0hCiB;ANi0DzB;;AgCt1FI;EACE,0BAAA;AhCy1FN;;AgCn+FI;;;;;EAoJM,UAAA;AhCu1FV;;AgCv9FE;EACE,aAAA;EACA,WAAA;EACA,mB1B44BoC;EHpoBlC,kBALI;E6BhQN,oC1BooCqB;ANq1DzB;;AgCt9FE;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,eAAA;EACA,uBAAA;EACA,kBAAA;E7B2PE,mBALI;E6BnPN,W1BunCqB;E0BtnCrB,mC1BsnCqB;ECrpCrB,uCAAA;APw/FJ;;AgCp9FI;;;;EAEE,cAAA;AhCy9FN;;AgCxgGI;EAqDE,kD1BymCmB;E0BtmCjB,yC1Bm6BgC;E0Bl6BhC,yDAAA;EACA,4BAAA;ELsDF,2DAAA;EKpDE,gEAAA;AhCq9FR;;AgCl9FM;EACE,kD1B8lCiB;E0BzlCf,2D1BylCe;ANw3DzB;;AgCthGI;EA+EI,yC1B44BgC;EqB32BlC,kFAAA;A3B26FN;;AgC3hGI;EAuFE,kD1BukCmB;ANi4DzB;;AgCr8FQ;EAEE,kEAAA;EACA,4B1Bu+B8B;EqBp9BlC,+DAAA;EKjBI,2EAAA;AhCu8FV;;AgCn8FM;EACE,kD1B0jCiB;E0BrjCf,2D1BqjCe;AN64DzB;;AgC3iGI;EAkHI,yCAAA;AhC67FR;;AgC/iGI;EAyHE,kD1BqiCmB;ANq5DzB;;AgCx7FM;EACE,+C1BkiCiB;ANy5DzB;;AgCx7FM;EACE,2D1B8hCiB;AN65DzB;;AgCx7FM;EACE,oC1B0hCiB;ANi6DzB;;AgCt7FI;EACE,0BAAA;AhCy7FN;;AgCnkGI;;;;;EAsJM,UAAA;AhCq7FV;;AiC1kGA;EAEE,4BAAA;EACA,6BAAA;EACA,uBAAA;E9B0RI,yBALI;E8BnRR,0BAAA;EACA,0BAAA;EACA,sCAAA;EACA,yBAAA;EACA,+CAAA;EACA,mCAAA;EACA,iDAAA;EACA,yCAAA;EACA,+FAAA;EACA,gCAAA;EACA,mFAAA;EAGA,qBAAA;EACA,0DAAA;EACA,uCAAA;E9ByQI,mCALI;E8BlQR,uCAAA;EACA,uCAAA;EACA,2BAAA;EACA,kBAAA;EACA,qBAAA;EAEA,sBAAA;EAEA,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,qEAAA;E1BzBE,2CAAA;EkBjBF,mCQ4CqB;Eb/BjB,qIaiCJ;AjCukGF;;AoBpmGM;EaRN;IbSQ,gBAAA;EpBwmGN;AACF;AiC3kGE;EACE,iCAAA;EAGA,yCAAA;EACA,+CAAA;AjC2kGJ;;AiCxkGE;EAEE,2BAAA;EACA,mCAAA;EACA,yCAAA;AjC0kGJ;;AiCvkGE;EACE,iCAAA;ERhEF,yCQiEuB;EACrB,+CAAA;EACA,UAAA;EAKE,2CAAA;AjCskGN;;AiClkGE;EACE,+CAAA;EACA,UAAA;EAKE,2CAAA;AjCikGN;;AiC7jGE;EAKE,kCAAA;EACA,0CAAA;EAIA,gDAAA;AjCyjGJ;;AiCtjGI;EAKI,2CAAA;AjCqjGR;;AiChjGE;EAKI,2CAAA;AjC+iGN;;AiC3iGE;EAGE,oCAAA;EACA,oBAAA;EACA,4CAAA;EAGA,kDAAA;EACA,wCAAA;AjC0iGJ;;AiChiGA;EAEE,2CAAA;EACA,mCAAA;EACA,6CAAA;EACA,2CAAA;EACA,qDAAA;EACA,oDAAA;EACA,4CAAA;EACA,4CAAA;EACA,0CAAA;EACA,oDAAA;EACA,8EAAA;AjCkiGF;;AiC9hGA;EAEE,2CAAA;EACA,+CAAA;EACA,6CAAA;EACA,2CAAA;EACA,sDAAA;EACA,oDAAA;EACA,wDAAA;EACA,4CAAA;EACA,0CAAA;EACA,qDAAA;EACA,8EAAA;AjCgiGF;;AiC5hGA;EACE,0CAAA;EACA,4CAAA;EACA,yCAAA;AjC+hGF;;AiC1hGE;EC7JA,qBAAA;EACA,qBAAA;EACA,+BAAA;EACA,2BAAA;EACA,uEAAA;EACA,gFAAA;EACA,kDAAA;EACA,4BAAA;EACA,uEAAA;EACA,kFAAA;EACA,+DAAA;EACA,8BAAA;EACA,8BAAA;EACA,wCAAA;AlC2rGF;;AiC3iGE;EC7JA,qBAAA;EACA,qBAAA;EACA,+BAAA;EACA,2BAAA;EACA,uEAAA;EACA,gFAAA;EACA,+CAAA;EACA,4BAAA;EACA,uEAAA;EACA,uEAAA;EACA,+DAAA;EACA,8BAAA;EACA,8BAAA;EACA,wCAAA;AlC4sGF;;AiC5jGE;EC7JA,wBAAA;EACA,qBAAA;EACA,+BAAA;EACA,8BAAA;EACA,4DAAA;EACA,iFAAA;EACA,8CAAA;EACA,+BAAA;EACA,uEAAA;EACA,kFAAA;EACA,+DAAA;EACA,iCAAA;EACA,8BAAA;EACA,wCAAA;AlC6tGF;;AiC7kGE;EC7JA,wBAAA;EACA,kBAAA;EACA,4BAAA;EACA,8BAAA;EACA,uCAAA;EACA,iDAAA;EACA,iDAAA;EACA,+BAAA;EACA,wCAAA;EACA,kDAAA;EACA,+DAAA;EACA,iCAAA;EACA,2BAAA;EACA,qCAAA;AlC8uGF;;AiC9lGE;EC7JA,wBAAA;EACA,qBAAA;EACA,+BAAA;EACA,8BAAA;EACA,sCAAA;EACA,iFAAA;EACA,iDAAA;EACA,+BAAA;EACA,wEAAA;EACA,kFAAA;EACA,+DAAA;EACA,iCAAA;EACA,8BAAA;EACA,wCAAA;AlC+vGF;;AiC/mGE;EC7JA,wBAAA;EACA,qBAAA;EACA,+BAAA;EACA,8BAAA;EACA,uEAAA;EACA,iFAAA;EACA,gDAAA;EACA,+BAAA;EACA,wEAAA;EACA,kFAAA;EACA,+DAAA;EACA,iCAAA;EACA,8BAAA;EACA,wCAAA;AlCgxGF;;AiChoGE;EC7JA,wBAAA;EACA,qBAAA;EACA,+BAAA;EACA,8BAAA;EACA,4DAAA;EACA,iFAAA;EACA,iDAAA;EACA,+BAAA;EACA,wEAAA;EACA,kFAAA;EACA,+DAAA;EACA,iCAAA;EACA,8BAAA;EACA,wCAAA;AlCiyGF;;AiCjpGE;EC7JA,qBAAA;EACA,qBAAA;EACA,+BAAA;EACA,2BAAA;EACA,4DAAA;EACA,iFAAA;EACA,6CAAA;EACA,4BAAA;EACA,wEAAA;EACA,kFAAA;EACA,+DAAA;EACA,8BAAA;EACA,8BAAA;EACA,wCAAA;AlCkzGF;;AiCxoGE;EC9JA,wBAAA;EACA,+BAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,uCAAA;EACA,4BAAA;EACA,4BAAA;EACA,sCAAA;EACA,+DAAA;EACA,iCAAA;EACA,kCAAA;EACA,wCAAA;EACA,oBAAA;AlC0yGF;;AiCzpGE;EC9JA,wBAAA;EACA,+BAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,yCAAA;EACA,4BAAA;EACA,4BAAA;EACA,sCAAA;EACA,+DAAA;EACA,iCAAA;EACA,kCAAA;EACA,wCAAA;EACA,oBAAA;AlC2zGF;;AiC1qGE;EC9JA,wBAAA;EACA,+BAAA;EACA,8BAAA;EACA,2BAAA;EACA,qCAAA;EACA,uCAAA;EACA,+BAAA;EACA,4BAAA;EACA,sCAAA;EACA,+DAAA;EACA,iCAAA;EACA,kCAAA;EACA,wCAAA;EACA,oBAAA;AlC40GF;;AiC3rGE;EC9JA,qBAAA;EACA,4BAAA;EACA,8BAAA;EACA,wBAAA;EACA,kCAAA;EACA,wCAAA;EACA,+BAAA;EACA,yBAAA;EACA,mCAAA;EACA,+DAAA;EACA,8BAAA;EACA,kCAAA;EACA,qCAAA;EACA,oBAAA;AlC61GF;;AiC5sGE;EC9JA,wBAAA;EACA,+BAAA;EACA,8BAAA;EACA,2BAAA;EACA,qCAAA;EACA,wCAAA;EACA,+BAAA;EACA,4BAAA;EACA,sCAAA;EACA,+DAAA;EACA,iCAAA;EACA,kCAAA;EACA,wCAAA;EACA,oBAAA;AlC82GF;;AiC7tGE;EC9JA,wBAAA;EACA,+BAAA;EACA,8BAAA;EACA,2BAAA;EACA,qCAAA;EACA,uCAAA;EACA,+BAAA;EACA,4BAAA;EACA,sCAAA;EACA,+DAAA;EACA,iCAAA;EACA,kCAAA;EACA,wCAAA;EACA,oBAAA;AlC+3GF;;AiC9uGE;EC9JA,wBAAA;EACA,+BAAA;EACA,8BAAA;EACA,2BAAA;EACA,qCAAA;EACA,yCAAA;EACA,+BAAA;EACA,4BAAA;EACA,sCAAA;EACA,+DAAA;EACA,iCAAA;EACA,kCAAA;EACA,wCAAA;EACA,oBAAA;AlCg5GF;;AiC/vGE;EC9JA,wBAAA;EACA,+BAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,sCAAA;EACA,4BAAA;EACA,4BAAA;EACA,sCAAA;EACA,+DAAA;EACA,iCAAA;EACA,kCAAA;EACA,wCAAA;EACA,oBAAA;AlCi6GF;;AiC1wGE;ECxIA,wBAAA;EACA,mCAAA;EACA,2BAAA;EACA,qCAAA;EACA,2BAAA;EACA,4BAAA;EACA,sCAAA;EACA,4BAAA;EACA,iCAAA;EACA,kCAAA;EACA,4CAAA;AlCs5GF;;AiCxxGE;ECxIA,wBAAA;EACA,mCAAA;EACA,2BAAA;EACA,qCAAA;EACA,2BAAA;EACA,4BAAA;EACA,sCAAA;EACA,4BAAA;EACA,iCAAA;EACA,kCAAA;EACA,4CAAA;AlCo6GF;;AiCtyGE;ECxIA,wBAAA;EACA,mCAAA;EACA,2BAAA;EACA,qCAAA;EACA,8BAAA;EACA,4BAAA;EACA,sCAAA;EACA,+BAAA;EACA,iCAAA;EACA,kCAAA;EACA,4CAAA;AlCk7GF;;AiCpzGE;ECxIA,qBAAA;EACA,mCAAA;EACA,wBAAA;EACA,kCAAA;EACA,8BAAA;EACA,yBAAA;EACA,mCAAA;EACA,+BAAA;EACA,8BAAA;EACA,kCAAA;EACA,4CAAA;AlCg8GF;;AiCl0GE;ECxIA,wBAAA;EACA,mCAAA;EACA,2BAAA;EACA,qCAAA;EACA,8BAAA;EACA,4BAAA;EACA,sCAAA;EACA,+BAAA;EACA,iCAAA;EACA,kCAAA;EACA,4CAAA;AlC88GF;;AiCh1GE;ECxIA,wBAAA;EACA,mCAAA;EACA,2BAAA;EACA,qCAAA;EACA,8BAAA;EACA,4BAAA;EACA,sCAAA;EACA,+BAAA;EACA,iCAAA;EACA,kCAAA;EACA,4CAAA;AlC49GF;;AiC91GE;ECxIA,wBAAA;EACA,mCAAA;EACA,2BAAA;EACA,qCAAA;EACA,8BAAA;EACA,4BAAA;EACA,sCAAA;EACA,+BAAA;EACA,iCAAA;EACA,kCAAA;EACA,4CAAA;AlC0+GF;;AiC52GE;ECxIA,wBAAA;EACA,mCAAA;EACA,2BAAA;EACA,qCAAA;EACA,2BAAA;EACA,4BAAA;EACA,sCAAA;EACA,4BAAA;EACA,iCAAA;EACA,kCAAA;EACA,4CAAA;AlCw/GF;;AiC92GA;EACE,0BAAA;EACA,sCAAA;EACA,yBAAA;EACA,mCAAA;EACA,kDAAA;EACA,yCAAA;EACA,0CAAA;EACA,iCAAA;EACA,4CAAA;EACA,0BAAA;EACA,kDAAA;EAEA,0B3BqPwC;AN2nG1C;;AiCt2GE;EACE,2BAAA;AjCy2GJ;;AiC91GA;ECtKE,2BAAA;EACA,yBAAA;E/B2MI,4BALI;E+BpMR,oDAAA;AlCwgHF;;AiCj2GA;EC1KE,4BAAA;EACA,2BAAA;E/B2MI,6BALI;E+BpMR,oDAAA;AlC+gHF;;AiCj2GM;ECvPJ,qBAAA;EACA,iEAAA;EACA,2EAAA;EACA,2BAAA;EACA,4CAAA;EACA,iFAAA;EACA,kDAAA;EACA,4BAAA;EACA,wEAAA;EACA,kFAAA;EACA,+DAAA;EACA,8BAAA;EACA,0EAAA;EACA,oFAAA;AlC4lHF;;AiCl3GM;ECvPJ,qBAAA;EACA,qBAAA;EACA,+BAAA;EACA,2BAAA;EACA,uEAAA;EACA,gFAAA;EACA,+CAAA;EACA,4BAAA;EACA,uEAAA;EACA,uEAAA;EACA,+DAAA;EACA,8BAAA;EACA,8BAAA;EACA,wCAAA;AlC6mHF;;AiCn4GM;ECvPJ,wBAAA;EACA,iEAAA;EACA,2EAAA;EACA,8BAAA;EACA,uEAAA;EACA,iFAAA;EACA,sDAAA;EACA,+BAAA;EACA,wEAAA;EACA,kFAAA;EACA,+DAAA;EACA,iCAAA;EACA,0EAAA;EACA,oFAAA;AlC8nHF;;AiCp5GM;ECvPJ,wBAAA;EACA,gCAAA;EACA,0CAAA;EACA,8BAAA;EACA,0CAAA;EACA,oDAAA;EACA,iDAAA;EACA,+BAAA;EACA,2CAAA;EACA,qDAAA;EACA,+DAAA;EACA,iCAAA;EACA,yCAAA;EACA,mDAAA;AlC+oHF;;AiCr6GM;ECvPJ,wBAAA;EACA,iEAAA;EACA,2EAAA;EACA,8BAAA;EACA,4CAAA;EACA,iFAAA;EACA,iDAAA;EACA,+BAAA;EACA,wEAAA;EACA,kFAAA;EACA,+DAAA;EACA,iCAAA;EACA,0EAAA;EACA,oFAAA;AlCgqHF;;AiCt7GM;ECvPJ,wBAAA;EACA,iEAAA;EACA,2EAAA;EACA,8BAAA;EACA,4CAAA;EACA,iFAAA;EACA,mDAAA;EACA,+BAAA;EACA,wEAAA;EACA,kFAAA;EACA,+DAAA;EACA,iCAAA;EACA,0EAAA;EACA,oFAAA;AlCirHF;;AiCv8GM;ECvPJ,wBAAA;EACA,qBAAA;EACA,+BAAA;EACA,8BAAA;EACA,4DAAA;EACA,iFAAA;EACA,iDAAA;EACA,+BAAA;EACA,wEAAA;EACA,kFAAA;EACA,+DAAA;EACA,iCAAA;EACA,8BAAA;EACA,wCAAA;AlCksHF;;AiCx9GM;ECvPJ,qBAAA;EACA,qBAAA;EACA,+BAAA;EACA,2BAAA;EACA,4DAAA;EACA,iFAAA;EACA,6CAAA;EACA,4BAAA;EACA,wEAAA;EACA,iFAAA;EACA,+DAAA;EACA,8BAAA;EACA,8BAAA;EACA,wCAAA;AlCmtHF;;AiCn+GM;ECpOJ,oEAAA;EACA,2EAAA;EACA,2BAAA;EACA,uEAAA;EACA,iFAAA;EACA,6CAAA;EACA,4BAAA;EACA,wEAAA;EACA,kFAAA;EACA,+DAAA;EACA,6EAAA;EACA,kCAAA;EACA,oFAAA;EACA,oBAAA;AlC2sHF;;AiCp/GM;ECpOJ,wBAAA;EACA,+BAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,yCAAA;EACA,4BAAA;EACA,4BAAA;EACA,sCAAA;EACA,+DAAA;EACA,iCAAA;EACA,kCAAA;EACA,wCAAA;EACA,oBAAA;AlC4tHF;;AiCrgHM;ECpOJ,oEAAA;EACA,2EAAA;EACA,8BAAA;EACA,uEAAA;EACA,iFAAA;EACA,gDAAA;EACA,+BAAA;EACA,wEAAA;EACA,kFAAA;EACA,+DAAA;EACA,6EAAA;EACA,kCAAA;EACA,oFAAA;EACA,oBAAA;AlC6uHF;;AiCthHM;ECpOJ,mCAAA;EACA,0CAAA;EACA,8BAAA;EACA,sCAAA;EACA,gDAAA;EACA,4CAAA;EACA,+BAAA;EACA,uCAAA;EACA,iDAAA;EACA,+DAAA;EACA,4CAAA;EACA,kCAAA;EACA,mDAAA;EACA,oBAAA;AlC8vHF;;AiCviHM;ECpOJ,oEAAA;EACA,2EAAA;EACA,8BAAA;EACA,uEAAA;EACA,iFAAA;EACA,8CAAA;EACA,+BAAA;EACA,wEAAA;EACA,kFAAA;EACA,+DAAA;EACA,6EAAA;EACA,kCAAA;EACA,oFAAA;EACA,oBAAA;AlC+wHF;;AiCxjHM;ECpOJ,oEAAA;EACA,2EAAA;EACA,8BAAA;EACA,uEAAA;EACA,iFAAA;EACA,6CAAA;EACA,+BAAA;EACA,wEAAA;EACA,kFAAA;EACA,+DAAA;EACA,6EAAA;EACA,kCAAA;EACA,oFAAA;EACA,oBAAA;AlCgyHF;;AiCzkHM;ECpOJ,wBAAA;EACA,+BAAA;EACA,8BAAA;EACA,2BAAA;EACA,qCAAA;EACA,yCAAA;EACA,+BAAA;EACA,4BAAA;EACA,sCAAA;EACA,+DAAA;EACA,iCAAA;EACA,kCAAA;EACA,wCAAA;EACA,oBAAA;AlCizHF;;AiC1lHM;ECpOJ,wBAAA;EACA,+BAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,sCAAA;EACA,4BAAA;EACA,4BAAA;EACA,sCAAA;EACA,+DAAA;EACA,iCAAA;EACA,kCAAA;EACA,wCAAA;EACA,oBAAA;AlCk0HF;;AiCrmHM;EC9MJ,oEAAA;EACA,mCAAA;EACA,uEAAA;EACA,iFAAA;EACA,2BAAA;EACA,wEAAA;EACA,kFAAA;EACA,4BAAA;EACA,6EAAA;EACA,kCAAA;EACA,4CAAA;AlCuzHF;;AiCnnHM;EC9MJ,wBAAA;EACA,mCAAA;EACA,2BAAA;EACA,qCAAA;EACA,2BAAA;EACA,4BAAA;EACA,sCAAA;EACA,4BAAA;EACA,iCAAA;EACA,kCAAA;EACA,4CAAA;AlCq0HF;;AiCjoHM;EC9MJ,oEAAA;EACA,mCAAA;EACA,uEAAA;EACA,iFAAA;EACA,8BAAA;EACA,wEAAA;EACA,kFAAA;EACA,+BAAA;EACA,6EAAA;EACA,kCAAA;EACA,4CAAA;AlCm1HF;;AiC/oHM;EC9MJ,mCAAA;EACA,mCAAA;EACA,sCAAA;EACA,gDAAA;EACA,8BAAA;EACA,uCAAA;EACA,iDAAA;EACA,+BAAA;EACA,4CAAA;EACA,kCAAA;EACA,4CAAA;AlCi2HF;;AiC7pHM;EC9MJ,oEAAA;EACA,mCAAA;EACA,uEAAA;EACA,iFAAA;EACA,8BAAA;EACA,wEAAA;EACA,kFAAA;EACA,+BAAA;EACA,6EAAA;EACA,kCAAA;EACA,4CAAA;AlC+2HF;;AiC3qHM;EC9MJ,oEAAA;EACA,mCAAA;EACA,uEAAA;EACA,iFAAA;EACA,8BAAA;EACA,wEAAA;EACA,kFAAA;EACA,+BAAA;EACA,6EAAA;EACA,kCAAA;EACA,4CAAA;AlC63HF;;AiCzrHM;EC9MJ,wBAAA;EACA,mCAAA;EACA,2BAAA;EACA,qCAAA;EACA,8BAAA;EACA,4BAAA;EACA,sCAAA;EACA,+BAAA;EACA,iCAAA;EACA,kCAAA;EACA,4CAAA;AlC24HF;;AiCvsHM;EC9MJ,wBAAA;EACA,mCAAA;EACA,2BAAA;EACA,qCAAA;EACA,2BAAA;EACA,4BAAA;EACA,sCAAA;EACA,4BAAA;EACA,iCAAA;EACA,kCAAA;EACA,4CAAA;AlCy5HF;;AmCh/HA;EfgBM,gCefJ;AnCm/HF;;AoBh+HM;EepBN;IfqBQ,gBAAA;EpBo+HN;AACF;AmCv/HE;EACE,UAAA;AnCy/HJ;;AmCn/HE;EACE,aAAA;AnCs/HJ;;AmCl/HA;EACE,SAAA;EACA,gBAAA;EfDI,6BeEJ;AnCq/HF;;AoBn/HM;EeLN;IfMQ,gBAAA;EpBu/HN;AACF;AmCz/HE;EACE,QAAA;EACA,YAAA;EfNE,4BeOF;AnC2/HJ;;AoB9/HM;EeAJ;IfCM,gBAAA;EpBkgIN;AACF;AoCjhIA;;;;;;EAME,kBAAA;ApCmhIF;;AoChhIA;EACE,mBAAA;ApCmhIF;;AqClgII;EACE,qBAAA;EACA,4B/B0kBwB;E+BzkBxB,uB/BwkBwB;E+BvkBxB,WAAA;EArCJ,uBAAA;EACA,qCAAA;EACA,gBAAA;EACA,oCAAA;ArC2iIF;;AqCj/HI;EACE,sBAAA;ArCo/HN;;AoC3hIA;EAEE,2BAAA;EACA,+BAAA;EACA,2BAAA;EACA,gCAAA;EACA,+BAAA;EjC4QI,8BALI;EiCrQR,2CAAA;EACA,qCAAA;EACA,gEAAA;EACA,sDAAA;EACA,oDAAA;EACA,8GAAA;EACA,8DAAA;EACA,uCAAA;EACA,gDAAA;EACA,gDAAA;EACA,sDAAA;EACA,oDAAA;EACA,2DAAA;EACA,iDAAA;EACA,6DAAA;EACA,mCAAA;EACA,sCAAA;EACA,oCAAA;EACA,qCAAA;EACA,uCAAA;EAGA,kBAAA;EACA,mCAAA;EACA,aAAA;EACA,wCAAA;EACA,oEAAA;EACA,SAAA;EjC+OI,wCALI;EiCxOR,gCAAA;EACA,iBAAA;EACA,gBAAA;EACA,wCAAA;EACA,4BAAA;EACA,+EAAA;E7B9CE,gDAAA;AP0kIJ;;AoCxhIE;EACE,qBAAA;EACA,SAAA;EACA,sCAAA;ApC2hIJ;;AoCngII;EACE,qBAAA;ApCsgIN;;AoCpgIM;EACE,qBAAA;EACA,sBAAA;ApCugIR;;AoCngII;EACE,mBAAA;ApCsgIN;;AoCpgIM;EACE,wBAAA;EACA,mBAAA;ApCugIR;;AcjjII;EsB4BA;IACE,qBAAA;EpCyhIJ;EoCvhII;IACE,qBAAA;IACA,sBAAA;EpCyhIN;EoCrhIE;IACE,mBAAA;EpCuhIJ;EoCrhII;IACE,wBAAA;IACA,mBAAA;EpCuhIN;AACF;AclkII;EsB4BA;IACE,qBAAA;EpCyiIJ;EoCviII;IACE,qBAAA;IACA,sBAAA;EpCyiIN;EoCriIE;IACE,mBAAA;EpCuiIJ;EoCriII;IACE,wBAAA;IACA,mBAAA;EpCuiIN;AACF;AcllII;EsB4BA;IACE,qBAAA;EpCyjIJ;EoCvjII;IACE,qBAAA;IACA,sBAAA;EpCyjIN;EoCrjIE;IACE,mBAAA;EpCujIJ;EoCrjII;IACE,wBAAA;IACA,mBAAA;EpCujIN;AACF;AclmII;EsB4BA;IACE,qBAAA;EpCykIJ;EoCvkII;IACE,qBAAA;IACA,sBAAA;EpCykIN;EoCrkIE;IACE,mBAAA;EpCukIJ;EoCrkII;IACE,wBAAA;IACA,mBAAA;EpCukIN;AACF;AclnII;EsB4BA;IACE,qBAAA;EpCylIJ;EoCvlII;IACE,qBAAA;IACA,sBAAA;EpCylIN;EoCrlIE;IACE,mBAAA;EpCulIJ;EoCrlII;IACE,wBAAA;IACA,mBAAA;EpCulIN;AACF;AoC9kIE;EACE,SAAA;EACA,YAAA;EACA,aAAA;EACA,yCAAA;ApCglIJ;;AqC3qII;EACE,qBAAA;EACA,4B/B0kBwB;E+BzkBxB,uB/BwkBwB;E+BvkBxB,WAAA;EA9BJ,aAAA;EACA,qCAAA;EACA,0BAAA;EACA,oCAAA;ArC6sIF;;AqC1pII;EACE,sBAAA;ArC6pIN;;AoCtlIE;EACE,wBAAA;EACA,sBAAA;EACA,MAAA;EACA,+CAAA;EACA,aAAA;ApCylIJ;;AqClsII;EACE,qBAAA;EACA,4B/B0kBwB;E+BzkBxB,uB/BwkBwB;E+BvkBxB,WAAA;EAvBJ,mCAAA;EACA,eAAA;EACA,sCAAA;EACA,wBAAA;ArC6tIF;;AqCjrII;EACE,sBAAA;ArCorIN;;AoCnmII;EACE,iBAAA;ApCsmIN;;AoChmIE;EACE,wBAAA;EACA,sBAAA;EACA,MAAA;EACA,6CAAA;EACA,aAAA;ApCmmIJ;;AqC7tII;EACE,qBAAA;EACA,4B/B0kBwB;E+BzkBxB,uB/BwkBwB;E+BvkBxB,WAAA;ArCguIN;;AqCrtIM;EACE,aAAA;ArCwtIR;;AqCrtIM;EACE,qBAAA;EACA,0B/BujBsB;E+BtjBtB,uB/BqjBsB;E+BpjBtB,WAAA;EAnCN,mCAAA;EACA,yBAAA;EACA,sCAAA;ArC4vIF;;AqCttII;EACE,sBAAA;ArCytIN;;AoCvnII;EACE,iBAAA;ApC0nIN;;AoCnnIA;EACE,SAAA;EACA,8CAAA;EACA,gBAAA;EACA,oDAAA;EACA,UAAA;ApCsnIF;;AoChnIA;EACE,cAAA;EACA,WAAA;EACA,8EAAA;EACA,WAAA;EACA,gB9B+d4B;E8B9d5B,qCAAA;EACA,mBAAA;EACA,qBAAA;EACA,mBAAA;EACA,6BAAA;EACA,SAAA;E7B3KE,wDAAA;AP+xIJ;;AoCjnIE;EAEE,2CAAA;EXjMF,mDWoMuB;ApCinIzB;;AoC9mIE;EAEE,4CAAA;EACA,qBAAA;EX1MF,oDW2MuB;ApCgnIzB;;AoC7mIE;EAEE,8CAAA;EACA,oBAAA;EACA,6BAAA;ApC+mIJ;;AoCxmIA;EACE,cAAA;ApC2mIF;;AoCvmIA;EACE,cAAA;EACA,kFAAA;EACA,gBAAA;EjCsEI,mBALI;EiC/DR,uCAAA;EACA,mBAAA;ApC0mIF;;AoCtmIA;EACE,cAAA;EACA,8EAAA;EACA,qCAAA;ApCymIF;;AoCrmIA;EAEE,6BAAA;EACA,0BAAA;EACA,gEAAA;EACA,2BAAA;EACA,kCAAA;EACA,qCAAA;EACA,8DAAA;EACA,uDAAA;EACA,2DAAA;EACA,iDAAA;EACA,2CAAA;EACA,oCAAA;ApCumIF;;AsCn2IA;;EAEE,kBAAA;EACA,oBAAA;EACA,sBAAA;AtCs2IF;;AsCp2IE;;EACE,kBAAA;EACA,cAAA;AtCw2IJ;;AsCn2IE;;;;;;;;;;;;EAME,UAAA;AtC42IJ;;AsCv2IA;EACE,aAAA;EACA,eAAA;EACA,2BAAA;AtC02IF;;AsCx2IE;EACE,WAAA;AtC22IJ;;AsCv2IA;E/BjBI,uCAAA;AP43IJ;;AsCv2IE;;EAEE,uDAAA;AtC02IJ;;AsCt2IE;;;E/BXE,0BAAA;EACA,wBAAA;APu3IJ;;AsCn2IE;;;E/BPE,4BAAA;EACA,0BAAA;APg3IJ;;AsCv1IA;EACE,wBAAA;EACA,uBAAA;AtC01IF;;AsCx1IE;EAGE,sBAAA;AtCy1IJ;;AsCt1IE;EACE,oBAAA;AtCy1IJ;;AsCr1IA;EACE,uBAAA;EACA,sBAAA;AtCw1IF;;AsCr1IA;EACE,sBAAA;EACA,qBAAA;AtCw1IF;;AsCp0IA;EACE,sBAAA;EACA,uBAAA;EACA,uBAAA;AtCu0IF;;AsCr0IE;;EAEE,WAAA;AtCw0IJ;;AsCr0IE;;EAEE,8CAAA;AtCw0IJ;;AsCp0IE;;E/B3FE,6BAAA;EACA,4BAAA;APo6IJ;;AsCj0IE;;;E/BlHE,yBAAA;EACA,0BAAA;APy7IJ;;AuC/8IA;EAEE,8BAAA;EACA,gCAAA;EAEA,4BAAA;EACA,2CAAA;EACA,uDAAA;EACA,yDAAA;EAGA,aAAA;EACA,eAAA;EACA,uBAAA;EACA,gBAAA;EACA,gBAAA;AvC88IF;;AuC38IA;EACE,cAAA;EACA,oEAAA;EpC8QI,wCALI;EoCvQR,4CAAA;EACA,gCAAA;EACA,qBAAA;EACA,gBAAA;EACA,SAAA;EnBlBI,uGmBmBJ;AvC88IF;;AoB79IM;EmBMN;InBLQ,gBAAA;EpBi+IN;AACF;AuCl9IE;EAEE,sCAAA;AvCm9IJ;;AuC98IE;EACE,UAAA;EACA,iDjC0jBoB;ANu5HxB;;AuC78IE;EAEE,yCAAA;EACA,oBAAA;EACA,eAAA;AvC+8IJ;;AuCv8IA;EAEE,oDAAA;EACA,oDAAA;EACA,sDAAA;EACA,+GAAA;EACA,2DAAA;EACA,iDAAA;EACA,2GAAA;EAGA,sFAAA;AvCu8IF;;AuCr8IE;EACE,0DAAA;EACA,0DAAA;EhChDA,yDAAA;EACA,0DAAA;APy/IJ;;AuCv8II;EAGE,kBAAA;EACA,yDAAA;AvCw8IN;;AuCp8IE;;EAEE,4CAAA;EACA,oDAAA;EACA,0DAAA;AvCu8IJ;;AuCp8IE;EAEE,uDAAA;EhCpEA,yBAAA;EACA,0BAAA;AP2gJJ;;AuC77IA;EAEE,uDAAA;EACA,4DAAA;EACA,kDAAA;AvC+7IF;;AuC57IE;EhC/FE,iDAAA;AP+hJJ;;AuC57IE;;EAEE,6CAAA;EdtHF,qDcuHuB;AvC+7IzB;;AuCt7IA;EAEE,6BAAA;EACA,0CAAA;EACA,gEAAA;EAGA,iCAAA;AvCs7IF;;AuCp7IE;EACE,gBAAA;EACA,eAAA;EACA,sEAAA;AvCu7IJ;;AuCr7II;EAEE,iCAAA;AvCu7IN;;AuCn7IE;;EAEE,gBjCkgB0B;EiCjgB1B,iDAAA;EACA,iCAAA;AvCs7IJ;;AuC76IA;EAEE,sCAAA;EACA,gEAAA;EACA,iDAAA;EACA,iDAAA;EACA,iDAAA;EACA,iEAAA;EACA,gEAAA;EACA,yEAAA;EAGA,gEAAA;EACA,kFAAA;EAEA,wCAAA;EACA,8GAAA;AvC46IF;;AuC16IE;EACE,sGAAA;EACA,sEAAA;EACA,6EAAA;AvC66IJ;;AuC36II;EAEE,iCAAA;AvC66IN;;AuCz6IE;;EAEE,gBjCwd0B;EiCvd1B,wDAAA;EACA,iCAAA;AvC46IJ;;AuCn6IA;EACE,oCAAA;EACA,6CAAA;EACA,wCAAA;EACA,2CAAA;EACA,2CAAA;EACA,oDAAA;EACA,yCAAA;EACA,2DAAA;EACA,qDAAA;EACA,oEAAA;EACA,kEAAA;EACA,kEAAA;EAEA,oBAAA;EACA,wCAAA;EACA,4CAAA;EhC1ME,oDAAA;APgnJJ;;AuCn6IE;EACE,0LAAA;EACA,yCAAA;EACA,mEAAA;EhChNA,4FAAA;APunJJ;;AuCp6II;EAEE,kDAAA;AvCs6IN;;AuCl6IE;;EAEE,gDAAA;EACA,wDAAA;EACA,kEAAA;AvCq6IJ;;AuCn6II;;EACE,yDAAA;AvCu6IN;;AuCh6IA;EACE,uCAAA;AvCm6IF;;AuC15IE;;EAEE,cAAA;EACA,kBAAA;AvC65IJ;;AuCx5IE;;EAEE,YAAA;EACA,aAAA;EACA,kBAAA;AvC25IJ;;AuCr5IE;;EACE,WAAA;AvCy5IJ;;AuC/4IE;EACE,aAAA;AvCk5IJ;;AuCh5IE;EACE,cAAA;AvCm5IJ;;AwC3qJA;EAGE,yBAAA;EACA,8BAAA;EACA,6DAAA;EACA,kEAAA;EACA,qEAAA;EACA,iEAAA;EACA,uCAAA;EACA,mCAAA;EACA,qCAAA;EACA,gEAAA;EACA,sEAAA;EACA,uCAAA;EACA,uCAAA;EACA,uCAAA;EACA,uCAAA;EACA,+SAAA;EACA,4EAAA;EACA,4DAAA;EACA,yCAAA;EACA,6DAAA;EAGA,kBAAA;EACA,aAAA;EACA,eAAA;EACA,mBAAA;EACA,8BAAA;EACA,gEAAA;AxC0qJF;;AwCpqJE;;EACE,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,8BAAA;AxCwqJJ;;AwCppJA;EACE,8CAAA;EACA,iDAAA;EACA,qDAAA;ErC6NI,4CALI;EqCtNR,oCAAA;EACA,qBAAA;EACA,mBAAA;AxCupJF;;AwCrpJE;EAEE,0CAAA;AxCupJJ;;AwC5oJA;EAEE,2BAAA;EACA,gCAAA;EAEA,4BAAA;EACA,6CAAA;EACA,yDAAA;EACA,+DAAA;EAGA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,gBAAA;EACA,gBAAA;AxC2oJF;;AwCxoJI;EAEE,qCAAA;AxC0oJN;;AwCtoJE;EACE,gBAAA;AxCyoJJ;;AwChoJA;EACE,mBlC4lCkC;EkC3lClC,sBlC2lCkC;EkC1lClC,8BAAA;AxCmoJF;;AwCjoJE;;;EAGE,qCAAA;AxCooJJ;;AwCvnJA;EACE,YAAA;EACA,gBAAA;EAGA,mBAAA;AxCwnJF;;AwCpnJA;EACE,gFAAA;ErCyII,8CALI;EqClIR,cAAA;EACA,8BAAA;EACA,6BAAA;EACA,4EAAA;EjClJE,sDAAA;EaJE,gDoBwJJ;AxCunJF;;AoB3wJM;EoB4IN;IpB3IQ,gBAAA;EpB+wJN;AACF;AwC3nJE;EACE,qBAAA;AxC6nJJ;;AwC1nJE;EACE,qBAAA;EACA,UAAA;EACA,uDAAA;AxC6nJJ;;AwCvnJA;EACE,qBAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,mDAAA;EACA,4BAAA;EACA,2BAAA;EACA,qBAAA;AxC0nJF;;AwCvnJA;EACE,0CAAA;EACA,gBAAA;AxC0nJF;;AczvJI;E0B2IA;IAEI,iBAAA;IACA,2BAAA;ExCinJN;EwC/mJM;IACE,mBAAA;ExCinJR;EwC/mJQ;IACE,kBAAA;ExCinJV;EwC9mJQ;IACE,mDAAA;IACA,kDAAA;ExCgnJV;EwC5mJM;IACE,iBAAA;ExC8mJR;EwC3mJM;IACE,wBAAA;IACA,gBAAA;ExC6mJR;EwC1mJM;IACE,aAAA;ExC4mJR;EwCzmJM;IAEE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;IpBzOJ,gBoB2OI;ExCymJR;EwCtmJQ;IACE,aAAA;ExCwmJV;EwCrmJQ;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;ExCumJV;AACF;AczyJI;E0B2IA;IAEI,iBAAA;IACA,2BAAA;ExCgqJN;EwC9pJM;IACE,mBAAA;ExCgqJR;EwC9pJQ;IACE,kBAAA;ExCgqJV;EwC7pJQ;IACE,mDAAA;IACA,kDAAA;ExC+pJV;EwC3pJM;IACE,iBAAA;ExC6pJR;EwC1pJM;IACE,wBAAA;IACA,gBAAA;ExC4pJR;EwCzpJM;IACE,aAAA;ExC2pJR;EwCxpJM;IAEE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;IpBzOJ,gBoB2OI;ExCwpJR;EwCrpJQ;IACE,aAAA;ExCupJV;EwCppJQ;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;ExCspJV;AACF;Acx1JI;E0B2IA;IAEI,iBAAA;IACA,2BAAA;ExC+sJN;EwC7sJM;IACE,mBAAA;ExC+sJR;EwC7sJQ;IACE,kBAAA;ExC+sJV;EwC5sJQ;IACE,mDAAA;IACA,kDAAA;ExC8sJV;EwC1sJM;IACE,iBAAA;ExC4sJR;EwCzsJM;IACE,wBAAA;IACA,gBAAA;ExC2sJR;EwCxsJM;IACE,aAAA;ExC0sJR;EwCvsJM;IAEE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;IpBzOJ,gBoB2OI;ExCusJR;EwCpsJQ;IACE,aAAA;ExCssJV;EwCnsJQ;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;ExCqsJV;AACF;Acv4JI;E0B2IA;IAEI,iBAAA;IACA,2BAAA;ExC8vJN;EwC5vJM;IACE,mBAAA;ExC8vJR;EwC5vJQ;IACE,kBAAA;ExC8vJV;EwC3vJQ;IACE,mDAAA;IACA,kDAAA;ExC6vJV;EwCzvJM;IACE,iBAAA;ExC2vJR;EwCxvJM;IACE,wBAAA;IACA,gBAAA;ExC0vJR;EwCvvJM;IACE,aAAA;ExCyvJR;EwCtvJM;IAEE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;IpBzOJ,gBoB2OI;ExCsvJR;EwCnvJQ;IACE,aAAA;ExCqvJV;EwClvJQ;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;ExCovJV;AACF;Act7JI;E0B2IA;IAEI,iBAAA;IACA,2BAAA;ExC6yJN;EwC3yJM;IACE,mBAAA;ExC6yJR;EwC3yJQ;IACE,kBAAA;ExC6yJV;EwC1yJQ;IACE,mDAAA;IACA,kDAAA;ExC4yJV;EwCxyJM;IACE,iBAAA;ExC0yJR;EwCvyJM;IACE,wBAAA;IACA,gBAAA;ExCyyJR;EwCtyJM;IACE,aAAA;ExCwyJR;EwCryJM;IAEE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;IpBzOJ,gBoB2OI;ExCqyJR;EwClyJQ;IACE,aAAA;ExCoyJV;EwCjyJQ;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;ExCmyJV;AACF;AwC11JI;EAEI,iBAAA;EACA,2BAAA;AxC21JR;;AwCz1JQ;EACE,mBAAA;AxC41JV;;AwC11JU;EACE,kBAAA;AxC61JZ;;AwC11JU;EACE,mDAAA;EACA,kDAAA;AxC61JZ;;AwCz1JQ;EACE,iBAAA;AxC41JV;;AwCz1JQ;EACE,wBAAA;EACA,gBAAA;AxC41JV;;AwCz1JQ;EACE,aAAA;AxC41JV;;AwCz1JQ;EAEE,gBAAA;EACA,aAAA;EACA,YAAA;EACA,sBAAA;EACA,uBAAA;EACA,8BAAA;EACA,wCAAA;EACA,oBAAA;EACA,0BAAA;EpBzOJ,gBoB2OI;AxC01JV;;AwCv1JU;EACE,aAAA;AxC01JZ;;AwCv1JU;EACE,aAAA;EACA,YAAA;EACA,UAAA;EACA,mBAAA;AxC01JZ;;AwCz0JA;;EAGE,6CAAA;EACA,mDAAA;EACA,sDAAA;EACA,+BAAA;EACA,8BAAA;EACA,oCAAA;EACA,2DAAA;EACA,sEAAA;AxC20JF;;AwCr0JI;EACE,sEAAA;AxCw0JN;;AyC1mKA;EAEE,yBAAA;EACA,yBAAA;EACA,iCAAA;EACA,wBAAA;EACA,2BAAA;EACA,gDAAA;EACA,4DAAA;EACA,kDAAA;EACA,uBAAA;EACA,kGAAA;EACA,gCAAA;EACA,8BAAA;EACA,wDAAA;EACA,sBAAA;EACA,mBAAA;EACA,kBAAA;EACA,iCAAA;EACA,oCAAA;EACA,gCAAA;EAGA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;EACA,8BAAA;EACA,4BAAA;EACA,qBAAA;EACA,oCAAA;EACA,2BAAA;EACA,uEAAA;ElClBE,4CAAA;AP6nKJ;;AyCvmKE;EACE,eAAA;EACA,cAAA;AzC0mKJ;;AyCvmKE;EACE,mBAAA;EACA,sBAAA;AzC0mKJ;;AyCxmKI;EACE,mBAAA;ElCvBF,2DAAA;EACA,4DAAA;APmoKJ;;AyCzmKI;EACE,sBAAA;ElCdF,+DAAA;EACA,8DAAA;AP2nKJ;;AyCvmKE;;EAEE,aAAA;AzC0mKJ;;AyCtmKA;EAGE,cAAA;EACA,0DAAA;EACA,4BAAA;AzCumKF;;AyCpmKA;EACE,6CAAA;EACA,kCAAA;AzCumKF;;AyCpmKA;EACE,uDAAA;EACA,gBAAA;EACA,qCAAA;AzCumKF;;AyCpmKA;EACE,gBAAA;AzCumKF;;AyC9lKE;EACE,6CAAA;AzCimKJ;;AyCzlKA;EACE,oEAAA;EACA,gBAAA;EACA,gCAAA;EACA,wCAAA;EACA,8EAAA;AzC4lKF;;AyC1lKE;ElC/FE,0FAAA;AP6rKJ;;AyCzlKA;EACE,oEAAA;EACA,gCAAA;EACA,wCAAA;EACA,2EAAA;AzC4lKF;;AyC1lKE;ElC1GE,0FAAA;APwsKJ;;AyCplKA;EACE,wDAAA;EACA,uDAAA;EACA,uDAAA;EACA,gBAAA;AzCulKF;;AyCrlKE;EACE,oCAAA;EACA,uCAAA;AzCwlKJ;;AyCplKA;EACE,wDAAA;EACA,uDAAA;AzCulKF;;AyCnlKA;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,4CAAA;ElC5IE,kDAAA;APmuKJ;;AyCnlKA;;;EAGE,WAAA;AzCslKF;;AyCnlKA;;ElC7II,2DAAA;EACA,4DAAA;APquKJ;;AyCplKA;;ElCpII,+DAAA;EACA,8DAAA;AP6tKJ;;AyC7kKE;EACE,2CAAA;AzCglKJ;;AcxsKI;E2BoHJ;IAQI,aAAA;IACA,mBAAA;EzCilKF;EyC9kKE;IACE,SAAA;IACA,gBAAA;EzCglKJ;EyC9kKI;IACE,sBAAA;IACA,sBAAA;EzCglKN;EyC3kKM;IlC5KJ,0BAAA;IACA,wBAAA;EP0vKF;EyC5kKQ;;IAGE,0BAAA;EzC6kKV;EyC3kKQ;;IAGE,6BAAA;EzC4kKV;EyCxkKM;IlC7KJ,4BAAA;IACA,0BAAA;EPwvKF;EyCzkKQ;;IAGE,yBAAA;EzC0kKV;EyCxkKQ;;IAGE,4BAAA;EzCykKV;AACF;A0C3yKA;EAEE,4CAAA;EACA,sCAAA;EACA,+KAAA;EACA,qDAAA;EACA,qDAAA;EACA,uDAAA;EACA,iHAAA;EACA,sCAAA;EACA,mCAAA;EACA,gDAAA;EACA,+CAAA;EACA,4RAAA;EACA,uCAAA;EACA,mDAAA;EACA,+DAAA;EACA,yEAAA;EACA,2EAAA;EACA,uCAAA;EACA,oCAAA;EACA,8DAAA;EACA,uDAAA;A1C4yKF;;A0CxyKA;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;EACA,8EAAA;EvCkQI,eALI;EuC3PR,qCAAA;EACA,iBAAA;EACA,6CAAA;EACA,SAAA;EnCzBE,gBAAA;EmC2BF,qBAAA;EtB/BI,2CsBgCJ;A1C2yKF;;AoBv0KM;EsBeN;ItBdQ,gBAAA;EpB20KN;AACF;A0C/yKE;EACE,wCAAA;EACA,gDAAA;EACA,oGAAA;A1CizKJ;;A0C/yKI;EACE,sDAAA;EACA,kDAAA;A1CkzKN;;A0C7yKE;EACE,cAAA;EACA,0CAAA;EACA,2CAAA;EACA,yBAAA;EACA,WAAA;EACA,+CAAA;EACA,4BAAA;EACA,oDAAA;EtBtDE,oDsBuDF;A1CgzKJ;;AoBn2KM;EsB0CJ;ItBzCM,gBAAA;EpBu2KN;AACF;A0CnzKE;EACE,UAAA;A1CqzKJ;;A0ClzKE;EACE,UAAA;EACA,UAAA;EACA,qDAAA;A1CqzKJ;;A0CjzKA;EACE,gBAAA;A1CozKF;;A0CjzKA;EACE,iCAAA;EACA,yCAAA;EACA,iFAAA;A1CozKF;;A0ClzKE;EnCjEE,0DAAA;EACA,2DAAA;APu3KJ;;A0CpzKI;EnCpEA,gEAAA;EACA,iEAAA;AP43KJ;;A0CpzKE;EACE,aAAA;A1CuzKJ;;A0CnzKE;EnChEE,8DAAA;EACA,6DAAA;APu3KJ;;A0CpzKM;EnCpEF,oEAAA;EACA,mEAAA;AP43KJ;;A0CpzKI;EnCzEA,8DAAA;EACA,6DAAA;APi4KJ;;A0CnzKA;EACE,gFAAA;A1CszKF;;A0C7yKE;EACE,eAAA;EACA,cAAA;EnClHA,gBAAA;APm6KJ;;A0C9yKI;EAAgB,aAAA;A1CkzKpB;;A0CjzKI;EAAe,gBAAA;A1CqzKnB;;A0ClzKI;;;EnCzHA,gBAAA;APi7KJ;;A0C7yKI;EACE,kEAAA;EACA,4VAAA;A1CgzKN;;A2Cv8KA;EAEE,6BAAA;EACA,6BAAA;EACA,oCAAA;EAEA,qBAAA;EACA,gCAAA;EACA,0DAAA;EACA,uCAAA;EACA,8DAAA;EAGA,aAAA;EACA,eAAA;EACA,wEAAA;EACA,kDAAA;ExCuRI,0CALI;EwChRR,gBAAA;EACA,0CAAA;EpCFE,kDAAA;APy8KJ;;A2Cj8KE;EACE,0DAAA;A3Co8KJ;;A2Cl8KI;EACE,mBAAA;EACA,wDAAA;EACA,0CAAA;EhB8CA,2CAAA;A3Bw5KN;;A2C57KE;EACE,8CAAA;A3C+7KJ;;A4Cv+KA;EAEE,mCAAA;EACA,oCAAA;EzCkSI,gCALI;EyC3RR,6CAAA;EACA,uCAAA;EACA,sDAAA;EACA,sDAAA;EACA,wDAAA;EACA,yDAAA;EACA,iDAAA;EACA,4DAAA;EACA,yDAAA;EACA,kDAAA;EACA,wEAAA;EACA,wDAAA;EACA,8CAAA;EACA,wDAAA;EACA,2DAAA;EACA,qDAAA;EACA,+DAAA;EAGA,aAAA;EnC5BA,uBAAA;EACA,gBAAA;ATogLF;;A4Cr+KA;EACE,kBAAA;EACA,cAAA;EACA,wEAAA;EzCsQI,0CALI;EyC/PR,kCAAA;EACA,qBAAA;EACA,0CAAA;EACA,mFAAA;ExBzBI,qIwB0BJ;A5Cw+KF;;AoB9/KM;EwBaN;IxBZQ,gBAAA;EpBkgLN;AACF;A4C5+KE;EACE,UAAA;EACA,wCAAA;EAGA,gDAAA;EACA,sDAAA;A5C4+KJ;;A4Cz+KE;EACE,UAAA;EACA,wCAAA;EACA,gDAAA;EACA,UtCo1CgC;EsCn1ChC,kDAAA;A5C4+KJ;;A4Cz+KE;EAEE,UAAA;EACA,yCAAA;EnB7DF,iDmB8DuB;EACrB,uDAAA;A5C2+KJ;;A4Cx+KE;EAEE,2CAAA;EACA,oBAAA;EACA,mDAAA;EACA,yDAAA;A5C0+KJ;;A4Cr+KE;EACE,uDtCuzCgC;ANirIpC;;A4Cn+KM;ErCnCF,8DAAA;EACA,4DAAA;AP0gLJ;;A4Cl+KM;ErCvDF,4DAAA;EACA,0DAAA;AP6hLJ;;A4Ct9KA;ECxGE,kCAAA;EACA,mCAAA;E1CqSI,mCALI;E0C9RR,2DAAA;A7CkkLF;;A4Cz9KA;EC5GE,kCAAA;EACA,mCAAA;E1CqSI,oCALI;E0C9RR,2DAAA;A7CykLF;;A8C1kLA;EAEE,6BAAA;EACA,6BAAA;E3CiSI,6BALI;E2C1RR,4BAAA;EACA,uBAAA;EACA,mDAAA;EAGA,qBAAA;EACA,8DAAA;E3CyRI,qCALI;E2ClRR,yCAAA;EACA,cAAA;EACA,6BAAA;EACA,kBAAA;EACA,mBAAA;EACA,wBAAA;EACA,gDAAA;A9C0kLF;;A8CtkLE;EACE,aAAA;A9CykLJ;;A8CpkLA;EACE,kBAAA;EACA,SAAA;A9CukLF;;A8ChkLA;EACE,4BAAA;EACA,4BAAA;E3C4PI,iBALI;AH60KV;;A+C7mLA;EAEE,2BAAA;EACA,2BAAA;EACA,2BAAA;EACA,+BAAA;EACA,0BAAA;EACA,qCAAA;EACA,+EAAA;EACA,mDAAA;EACA,+BAAA;EAGA,kBAAA;EACA,8DAAA;EACA,6CAAA;EACA,6BAAA;EACA,qCAAA;EACA,+BAAA;ExCHE,6CAAA;APinLJ;;A+CzmLA;EAEE,cAAA;A/C2mLF;;A+CvmLA;EACE,gBzCwnB4B;EyCvnB5B,kCAAA;A/C0mLF;;A+ClmLA;EACE,wBzC6oD8B;ANw9HhC;;A+ClmLE;EACE,kBAAA;EACA,mBAAA;EACA,MAAA;EACA,UAAA;EACA,qBAAA;A/CqmLJ;;A+C7lLE;EACE,mDAAA;EACA,4CAAA;EACA,0DAAA;EACA,wDAAA;A/CgmLJ;;A+CpmLE;EACE,qDAAA;EACA,8CAAA;EACA,4DAAA;EACA,0DAAA;A/CumLJ;;A+C3mLE;EACE,mDAAA;EACA,4CAAA;EACA,0DAAA;EACA,wDAAA;A/C8mLJ;;A+ClnLE;EACE,gDAAA;EACA,yCAAA;EACA,uDAAA;EACA,qDAAA;A/CqnLJ;;A+CznLE;EACE,mDAAA;EACA,4CAAA;EACA,0DAAA;EACA,wDAAA;A/C4nLJ;;A+ChoLE;EACE,kDAAA;EACA,2CAAA;EACA,yDAAA;EACA,uDAAA;A/CmoLJ;;A+CvoLE;EACE,iDAAA;EACA,0CAAA;EACA,wDAAA;EACA,sDAAA;A/C0oLJ;;A+C9oLE;EACE,gDAAA;EACA,yCAAA;EACA,uDAAA;EACA,qDAAA;A/CipLJ;;AgD1sLE;EACE;IAAK,iDAAA;EhD8sLP;AACF;AgD1sLA;;EAGE,2BAAA;E7CyRI,iCALI;E6ClRR,0CAAA;EACA,sDAAA;EACA,sDAAA;EACA,8BAAA;EACA,yCAAA;EACA,8CAAA;EAGA,aAAA;EACA,kCAAA;EACA,gBAAA;E7C6QI,wCALI;E6CtQR,wCAAA;EzCXE,gDAAA;APqtLJ;;AgDrsLA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,gBAAA;EACA,oCAAA;EACA,kBAAA;EACA,mBAAA;EACA,4CAAA;E5B5BI,8C4B6BJ;AhDwsLF;;AoBjuLM;E4BgBN;I5BfQ,gBAAA;EpBquLN;AACF;AgD3sLA;EvBLE,qMAAA;EuBOA,sEAAA;AhD6sLF;;AgD1sLA;EACE,iBAAA;AhD6sLF;;AgD1sLA;EACE,WAAA;AhD6sLF;;AgDzsLE;EACE,kDAAA;AhD4sLJ;;AgDzsLM;EAJJ;IAKM,eAAA;EhD6sLN;AACF;AgDxsLA;EACE,WAAA;AhD0sLF;;AgDtsLA;EACE,0CAAA;AhDysLF;;AgDxsLE;EACE,sB1ClEQ;AN6wLZ;;AgDvsLA;EACE,aAAA;EACA,mBAAA;EACA,mB1C+VO;AN22KT;;AgDvsLA;EACE,eAAA;EACA,kBAAA;AhD0sLF;;AgDvsLA;EACE,aAAA;EACA,gBAAA;EACA,mBAAA;EACA,sB1CsoDqC;ANokIvC;;AgDvsLA;EACE,YAAA;EACA,kBAAA;AhD0sLF;;AgDxsLE;EACE,kBAAA;AhD2sLJ;;AgDvsLA;EACE,gBAAA;AhD0sLF;;AiDrzLA;EAEE,6CAAA;EACA,uCAAA;EACA,sDAAA;EACA,sDAAA;EACA,wDAAA;EACA,qCAAA;EACA,uCAAA;EACA,yDAAA;EACA,8DAAA;EACA,wDAAA;EACA,2DAAA;EACA,0DAAA;EACA,2DAAA;EACA,gDAAA;EACA,wDAAA;EACA,8CAAA;EACA,wDAAA;EAGA,aAAA;EACA,sBAAA;EAGA,uBAAA;EACA,gBAAA;E1CZE,kDAAA;APg0LJ;;AiDhzLA;EACE,qBAAA;EACA,sBAAA;AjDmzLF;;AiDjzLE;EAEE,oCAAA;EACA,0BAAA;AjDmzLJ;;AiD3yLA;EACE,kBAAA;EACA,cAAA;EACA,kFAAA;EACA,kCAAA;EACA,qBAAA;EACA,0CAAA;EACA,mFAAA;AjD8yLF;;AiD5yLE;E1C/BE,+BAAA;EACA,gCAAA;AP+0LJ;;AiD7yLE;E1CrBE,mCAAA;EACA,kCAAA;APs0LJ;;AiD9yLE;EAEE,2CAAA;EACA,oBAAA;EACA,mDAAA;AjDgzLJ;;AiD5yLE;EACE,UAAA;EACA,yCAAA;EACA,iDAAA;EACA,uDAAA;AjD+yLJ;;AiD3yLE;EACE,mBAAA;AjD8yLJ;;AiD5yLI;EACE,yDAAA;EACA,oDAAA;AjD+yLN;;AiDryLA;EACE,WAAA;EACA,yCAAA;EACA,mBAAA;AjDwyLF;;AiDpyLI;EAEE,UAAA;EACA,+CAAA;EACA,qBAAA;EACA,uDAAA;AjDsyLN;;AiDnyLI;EACE,gDAAA;EACA,wDAAA;AjDsyLN;;AiDzxLI;EACE,mBAAA;AjD4xLN;;AiDzxLQ;E1C1DJ,4DAAA;EAZA,0BAAA;APo2LJ;;AiDzxLQ;E1C3EJ,4DAAA;EAYA,0BAAA;AP61LJ;;AiDzxLQ;EACE,aAAA;AjD4xLV;;AiDzxLQ;EACE,4BAAA;EACA,oDAAA;AjD4xLV;;AiD1xLU;EACE,kEAAA;EACA,6DAAA;AjD6xLZ;;Acj3LI;EmC4DA;IACE,mBAAA;EjDyzLJ;EiDtzLM;I1C1DJ,4DAAA;IAZA,0BAAA;EPg4LF;EiDrzLM;I1C3EJ,4DAAA;IAYA,0BAAA;EPw3LF;EiDpzLM;IACE,aAAA;EjDszLR;EiDnzLM;IACE,4BAAA;IACA,oDAAA;EjDqzLR;EiDnzLQ;IACE,kEAAA;IACA,6DAAA;EjDqzLV;AACF;Ac14LI;EmC4DA;IACE,mBAAA;EjDi1LJ;EiD90LM;I1C1DJ,4DAAA;IAZA,0BAAA;EPw5LF;EiD70LM;I1C3EJ,4DAAA;IAYA,0BAAA;EPg5LF;EiD50LM;IACE,aAAA;EjD80LR;EiD30LM;IACE,4BAAA;IACA,oDAAA;EjD60LR;EiD30LQ;IACE,kEAAA;IACA,6DAAA;EjD60LV;AACF;Acl6LI;EmC4DA;IACE,mBAAA;EjDy2LJ;EiDt2LM;I1C1DJ,4DAAA;IAZA,0BAAA;EPg7LF;EiDr2LM;I1C3EJ,4DAAA;IAYA,0BAAA;EPw6LF;EiDp2LM;IACE,aAAA;EjDs2LR;EiDn2LM;IACE,4BAAA;IACA,oDAAA;EjDq2LR;EiDn2LQ;IACE,kEAAA;IACA,6DAAA;EjDq2LV;AACF;Ac17LI;EmC4DA;IACE,mBAAA;EjDi4LJ;EiD93LM;I1C1DJ,4DAAA;IAZA,0BAAA;EPw8LF;EiD73LM;I1C3EJ,4DAAA;IAYA,0BAAA;EPg8LF;EiD53LM;IACE,aAAA;EjD83LR;EiD33LM;IACE,4BAAA;IACA,oDAAA;EjD63LR;EiD33LQ;IACE,kEAAA;IACA,6DAAA;EjD63LV;AACF;Acl9LI;EmC4DA;IACE,mBAAA;EjDy5LJ;EiDt5LM;I1C1DJ,4DAAA;IAZA,0BAAA;EPg+LF;EiDr5LM;I1C3EJ,4DAAA;IAYA,0BAAA;EPw9LF;EiDp5LM;IACE,aAAA;EjDs5LR;EiDn5LM;IACE,4BAAA;IACA,oDAAA;EjDq5LR;EiDn5LQ;IACE,kEAAA;IACA,6DAAA;EjDq5LV;AACF;AiDx4LA;E1CnJI,gBAAA;AP8hMJ;;AiDx4LE;EACE,oDAAA;AjD24LJ;;AiDz4LI;EACE,sBAAA;AjD44LN;;AiD/3LE;EACE,wDAAA;EACA,iDAAA;EACA,+DAAA;EACA,8DAAA;EACA,kEAAA;EACA,+DAAA;EACA,mEAAA;EACA,2DAAA;EACA,4DAAA;EACA,sEAAA;AjDk4LJ;;AiD54LE;EACE,0DAAA;EACA,mDAAA;EACA,iEAAA;EACA,8DAAA;EACA,oEAAA;EACA,+DAAA;EACA,qEAAA;EACA,6DAAA;EACA,8DAAA;EACA,wEAAA;AjD+4LJ;;AiDz5LE;EACE,wDAAA;EACA,iDAAA;EACA,+DAAA;EACA,8DAAA;EACA,kEAAA;EACA,+DAAA;EACA,mEAAA;EACA,2DAAA;EACA,4DAAA;EACA,sEAAA;AjD45LJ;;AiDt6LE;EACE,qDAAA;EACA,8CAAA;EACA,4DAAA;EACA,8DAAA;EACA,+DAAA;EACA,+DAAA;EACA,gEAAA;EACA,wDAAA;EACA,yDAAA;EACA,mEAAA;AjDy6LJ;;AiDn7LE;EACE,wDAAA;EACA,iDAAA;EACA,+DAAA;EACA,8DAAA;EACA,kEAAA;EACA,+DAAA;EACA,mEAAA;EACA,2DAAA;EACA,4DAAA;EACA,sEAAA;AjDs7LJ;;AiDh8LE;EACE,uDAAA;EACA,gDAAA;EACA,8DAAA;EACA,8DAAA;EACA,iEAAA;EACA,+DAAA;EACA,kEAAA;EACA,0DAAA;EACA,2DAAA;EACA,qEAAA;AjDm8LJ;;AiD78LE;EACE,sDAAA;EACA,+CAAA;EACA,6DAAA;EACA,8DAAA;EACA,gEAAA;EACA,+DAAA;EACA,iEAAA;EACA,yDAAA;EACA,0DAAA;EACA,oEAAA;AjDg9LJ;;AiD19LE;EACE,qDAAA;EACA,8CAAA;EACA,4DAAA;EACA,8DAAA;EACA,+DAAA;EACA,+DAAA;EACA,gEAAA;EACA,wDAAA;EACA,yDAAA;EACA,mEAAA;AjD69LJ;;AkD1pMA;EAEE,8BAAA;EACA,4DAAA;EACA,4BAAA;EACA,mCAAA;EACA,mEAAA;EACA,gCAAA;EACA,sCAAA;EAGA,uBAAA;EACA,U5C4/D2B;E4C3/D3B,W5C2/D2B;E4C1/D3B,sBAAA;EACA,iCAAA;EACA,yEAAA;EACA,mCAAA;EACA,SAAA;E3CNE,uBAAA;E2CQF,qCAAA;AlD0pMF;;AkDvpME;EACE,iCAAA;EACA,qBAAA;EACA,2CAAA;AlD0pMJ;;AkDvpME;EACE,UAAA;EACA,6CAAA;EACA,2CAAA;AlD0pMJ;;AkDvpME;EAEE,oBAAA;EACA,yBAAA;UAAA,iBAAA;EACA,8CAAA;AlDypMJ;;AkDjpMA;EAHE,kEAAA;AlDwpMF;;AkDjpMA;;EAEE,wBAAA;AlDopMF;;AInsMI;E8CsCF,kEAAA;AlDiqMF;;AmDptMA;EAEE,wBAAA;EACA,8BAAA;EACA,6BAAA;EACA,2BAAA;EACA,4BAAA;EhDmSI,+BALI;EgD5RR,mBAAA;EACA,kDAAA;EACA,iDAAA;EACA,6DAAA;EACA,mDAAA;EACA,6CAAA;EACA,oDAAA;EACA,yDAAA;EACA,oEAAA;EAGA,iCAAA;EACA,eAAA;EhDqRI,qCALI;EgD9QR,6BAAA;EACA,oBAAA;EACA,qCAAA;EACA,4BAAA;EACA,yEAAA;EACA,uCAAA;E5CRE,6CAAA;AP6tMJ;;AmDltME;EACE,UAAA;AnDqtMJ;;AmDltME;EACE,aAAA;AnDqtMJ;;AmDjtMA;EACE,wBAAA;EAEA,kBAAA;EACA,gCAAA;EACA,kBAAA;EACA,eAAA;EACA,oBAAA;AnDmtMF;;AmDjtME;EACE,uCAAA;AnDotMJ;;AmDhtMA;EACE,aAAA;EACA,mBAAA;EACA,8DAAA;EACA,oCAAA;EACA,4CAAA;EACA,4BAAA;EACA,uFAAA;E5ChCE,4FAAA;EACA,6FAAA;APovMJ;;AmDltME;EACE,iFAAA;AnDqtMJ;;AmDjtMA;EACE,mCAAA;EACA,qBAAA;AnDotMF;;AoD9wMA;EAEE,wBAAA;EACA,wBAAA;EACA,yBAAA;EACA,0BAAA;EACA,wCAAA;EACA,kCAAA;EACA,6DAAA;EACA,iDAAA;EACA,sDAAA;EACA,gDAAA;EACA,qGAAA;EACA,kCAAA;EACA,kCAAA;EACA,qCAAA;EACA,wDAAA;EACA,wDAAA;EACA,kCAAA;EACA,8BAAA;EACA,uBAAA;EACA,wDAAA;EACA,wDAAA;EAGA,eAAA;EACA,qBAAA;EACA,MAAA;EACA,gCAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EAGA,UAAA;ApD4wMF;;AoDrwMA;EACE,kBAAA;EACA,WAAA;EACA,+BAAA;EAEA,oBAAA;ApDuwMF;;AoDpwME;EACE,8B9CkjDgC;EcnmD9B,mCgCkDF;ApDuwMJ;;AoBrzMM;EgC4CJ;IhC3CM,gBAAA;EpByzMN;AACF;AoD3wME;EACE,e9C+iDgC;AN8tJpC;;AoDzwME;EACE,sB9C4iDgC;ANguJpC;;AoDxwMA;EACE,gDAAA;ApD2wMF;;AoDzwME;EACE,gBAAA;EACA,gBAAA;ApD4wMJ;;AoDzwME;EACE,gBAAA;ApD4wMJ;;AoDxwMA;EACE,aAAA;EACA,mBAAA;EACA,oDAAA;ApD2wMF;;AoDvwMA;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EAEA,6BAAA;EACA,oBAAA;EACA,qCAAA;EACA,4BAAA;EACA,yEAAA;E7CxFE,6CAAA;E6C4FF,UAAA;ApDuwMF;;AoDnwMA;EAEE,2BAAA;EACA,0BAAA;EACA,2BAAA;ECvHA,eAAA;EACA,MAAA;EACA,OAAA;EACA,mCDuH0B;ECtH1B,YAAA;EACA,aAAA;EACA,wCDoH4D;ApDywM9D;;AqD13ME;EAAS,UAAA;ArD83MX;;AqD73ME;EAAS,oCDgHiF;ApDixM5F;;AoD5wMA;EACE,aAAA;EACA,cAAA;EACA,mBAAA;EACA,wCAAA;EACA,8FAAA;E7CxGE,4DAAA;EACA,6DAAA;APw3MJ;;AoD9wME;EACE,oGAAA;EACA,yBAAA;EACA,iEAAA;EACA,0DAAA;EACA,6DAAA;ApDixMJ;;AoD5wMA;EACE,gBAAA;EACA,+CAAA;ApD+wMF;;AoD1wMA;EACE,kBAAA;EAGA,cAAA;EACA,iCAAA;ApD2wMF;;AoDvwMA;EACE,aAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;EACA,yBAAA;EACA,2EAAA;EACA,4CAAA;EACA,2FAAA;E7C/HE,gEAAA;EACA,+DAAA;AP04MJ;;AoDtwME;EACE,+CAAA;ApDywMJ;;Acr3MI;EsCkHF;IACE,2BAAA;IACA,6CAAA;EpDuwMF;EoDnwMA;IACE,iCAAA;IACA,kBAAA;IACA,iBAAA;EpDqwMF;EoDlwMA;IACE,wBAAA;EpDowMF;AACF;Acp4MI;EsCoIF;;IAEE,wBAAA;EpDmwMF;AACF;Ac14MI;EsC2IF;IACE,yBAAA;EpDkwMF;AACF;AoDxvMI;EACE,YAAA;EACA,eAAA;EACA,YAAA;EACA,SAAA;ApD0vMN;;AoDxvMM;EACE,YAAA;EACA,SAAA;E7ChNJ,gBAAA;AP48MJ;;AoDxvMM;;E7CpNF,gBAAA;APi9MJ;;AoDxvMM;EACE,gBAAA;ApD2vMR;;Acv5MI;EsC0IA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;EpDixMJ;EoD/wMI;IACE,YAAA;IACA,SAAA;I7ChNJ,gBAAA;EPk+MF;EoD9wMI;;I7CpNF,gBAAA;EPs+MF;EoD7wMI;IACE,gBAAA;EpD+wMN;AACF;Ac56MI;EsC0IA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;EpDqyMJ;EoDnyMI;IACE,YAAA;IACA,SAAA;I7ChNJ,gBAAA;EPs/MF;EoDlyMI;;I7CpNF,gBAAA;EP0/MF;EoDjyMI;IACE,gBAAA;EpDmyMN;AACF;Ach8MI;EsC0IA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;EpDyzMJ;EoDvzMI;IACE,YAAA;IACA,SAAA;I7ChNJ,gBAAA;EP0gNF;EoDtzMI;;I7CpNF,gBAAA;EP8gNF;EoDrzMI;IACE,gBAAA;EpDuzMN;AACF;Acp9MI;EsC0IA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;EpD60MJ;EoD30MI;IACE,YAAA;IACA,SAAA;I7ChNJ,gBAAA;EP8hNF;EoD10MI;;I7CpNF,gBAAA;EPkiNF;EoDz0MI;IACE,gBAAA;EpD20MN;AACF;Acx+MI;EsC0IA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;EpDi2MJ;EoD/1MI;IACE,YAAA;IACA,SAAA;I7ChNJ,gBAAA;EPkjNF;EoD91MI;;I7CpNF,gBAAA;EPsjNF;EoD71MI;IACE,gBAAA;EpD+1MN;AACF;AsD1kNA;EAEE,0BAAA;EACA,8BAAA;EACA,+BAAA;EACA,gCAAA;EACA,sBAAA;EnDgSI,iCALI;EmDzRR,uCAAA;EACA,2CAAA;EACA,qDAAA;EACA,0BAAA;EACA,iCAAA;EACA,kCAAA;EAGA,kCAAA;EACA,cAAA;EACA,iCAAA;ECtBA,uCjD4oB4B;EiD1oB5B,kBAAA;EACA,gBjDqpB4B;EiDppB5B,gBjD4pB4B;EiD3pB5B,iBAAA;EACA,qBAAA;EACA,iBAAA;EACA,oBAAA;EACA,sBAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,gBAAA;EpD6RI,uCALI;EmDxQR,qBAAA;EACA,UAAA;AtDilNF;;AsD/kNE;EAAS,mCAAA;AtDmlNX;;AsDjlNE;EACE,cAAA;EACA,qCAAA;EACA,uCAAA;AtDolNJ;;AsDllNI;EACE,kBAAA;EACA,WAAA;EACA,yBAAA;EACA,mBAAA;AtDqlNN;;AsDhlNA;EACE,kDAAA;AtDmlNF;;AsDjlNE;EACE,SAAA;EACA,0FAAA;EACA,uCAAA;AtDolNJ;;AsDhlNA,qBAAA;AACA;EACE,gDAAA;EACA,sCAAA;EACA,sCAAA;AtDmlNF;;AsDjlNE;EACE,WAAA;EACA,qIAAA;EACA,yCAAA;AtDolNJ;;AsDhlNA,mBAAA;AAEA;EACE,+CAAA;AtDklNF;;AsDhlNE;EACE,YAAA;EACA,0FAAA;EACA,0CAAA;AtDmlNJ;;AsD/kNA,qBAAA;AACA;EACE,iDAAA;EACA,sCAAA;EACA,sCAAA;AtDklNF;;AsDhlNE;EACE,UAAA;EACA,qIAAA;EACA,wCAAA;AtDmlNJ;;AsD/kNA,mBAAA;AAkBA;EACE,uCAAA;EACA,kEAAA;EACA,+BAAA;EACA,kBAAA;EACA,uCAAA;E/CnGE,+CAAA;APqqNJ;;AwDtrNA;EAEE,0BAAA;EACA,8BAAA;ErDoSI,iCALI;EqD7RR,oCAAA;EACA,mDAAA;EACA,+DAAA;EACA,wDAAA;EACA,2GAAA;EACA,+CAAA;EACA,oCAAA;EACA,sCAAA;ErD2RI,oCALI;EqDpRR,mCAAA;EACA,gDAAA;EACA,kCAAA;EACA,kCAAA;EACA,+CAAA;EACA,+BAAA;EACA,kCAAA;EACA,2DAAA;EAGA,kCAAA;EACA,cAAA;EACA,uCAAA;ED7BA,uCjD4oB4B;EiD1oB5B,kBAAA;EACA,gBjDqpB4B;EiDppB5B,gBjD4pB4B;EiD3pB5B,iBAAA;EACA,qBAAA;EACA,iBAAA;EACA,oBAAA;EACA,sBAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,gBAAA;EpD6RI,uCALI;EqDlQR,qBAAA;EACA,uCAAA;EACA,4BAAA;EACA,6EAAA;EjDlBE,+CAAA;APktNJ;;AwD5rNE;EACE,cAAA;EACA,qCAAA;EACA,uCAAA;AxD+rNJ;;AwD7rNI;EAEE,kBAAA;EACA,cAAA;EACA,WAAA;EACA,yBAAA;EACA,mBAAA;EACA,eAAA;AxD+rNN;;AwDzrNE;EACE,sFAAA;AxD4rNJ;;AwD1rNI;EAEE,0FAAA;AxD4rNN;;AwDzrNI;EACE,SAAA;EACA,iDAAA;AxD4rNN;;AwDzrNI;EACE,uCAAA;EACA,uCAAA;AxD4rNN;;AwDvrNA,qBAAA;AAEE;EACE,oFAAA;EACA,sCAAA;EACA,sCAAA;AxDyrNJ;;AwDvrNI;EAEE,qIAAA;AxDyrNN;;AwDtrNI;EACE,OAAA;EACA,mDAAA;AxDyrNN;;AwDtrNI;EACE,qCAAA;EACA,yCAAA;AxDyrNN;;AwDprNA,mBAAA;AAGE;EACE,mFAAA;AxDqrNJ;;AwDnrNI;EAEE,0FAAA;AxDqrNN;;AwDlrNI;EACE,MAAA;EACA,oDAAA;AxDqrNN;;AwDlrNI;EACE,oCAAA;EACA,0CAAA;AxDqrNN;;AwDhrNE;EACE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,cAAA;EACA,qCAAA;EACA,wDAAA;EACA,WAAA;EACA,iFAAA;AxDmrNJ;;AwD/qNA,qBAAA;AAEE;EACE,qFAAA;EACA,sCAAA;EACA,sCAAA;AxDirNJ;;AwD/qNI;EAEE,qIAAA;AxDirNN;;AwD9qNI;EACE,QAAA;EACA,kDAAA;AxDirNN;;AwD9qNI;EACE,sCAAA;EACA,wCAAA;AxDirNN;;AwD5qNA,mBAAA;AAkBA;EACE,gFAAA;EACA,gBAAA;ErDmHI,8CALI;EqD5GR,sCAAA;EACA,8CAAA;EACA,oFAAA;EjD9JE,8DAAA;EACA,+DAAA;AP6zNJ;;AwD7pNE;EACE,aAAA;AxDgqNJ;;AwD5pNA;EACE,4EAAA;EACA,oCAAA;AxD+pNF;;AyDl1NA;EACE,kBAAA;AzDq1NF;;AyDl1NA;EACE,mBAAA;AzDq1NF;;AyDl1NA;EACE,kBAAA;EACA,WAAA;EACA,gBAAA;AzDq1NF;;A0Dn3NE;EACE,cAAA;EACA,WAAA;EACA,WAAA;A1Ds3NJ;;AyDv1NA;EACE,kBAAA;EACA,aAAA;EACA,WAAA;EACA,WAAA;EACA,mBAAA;EACA,2BAAA;ErCvBI,sCqCwBJ;AzD01NF;;AoB92NM;EqCaN;IrCZQ,gBAAA;EpBk3NN;AACF;AyD71NA;;;EAGE,cAAA;AzD+1NF;;AyD51NA;;EAEE,2BAAA;AzD+1NF;;AyD51NA;;EAEE,4BAAA;AzD+1NF;;AyDt1NE;EACE,UAAA;EACA,4BAAA;EACA,eAAA;AzDy1NJ;;AyDt1NE;;;EAGE,UAAA;EACA,UAAA;AzDy1NJ;;AyDt1NE;;EAEE,UAAA;EACA,UAAA;ErCjEE,2BqCkEF;AzDy1NJ;;AoBv5NM;EqC0DJ;;IrCzDM,gBAAA;EpB45NN;AACF;AyDv1NA;;EAEE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,UAAA;EAEA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,UnDyvDmC;EmDxvDnC,UAAA;EACA,WnDxFU;EmDyFV,kBAAA;EACA,gBAAA;EACA,+CAAA;EACA,SAAA;EACA,YnDmvDmC;Ec/0D/B,8BqC6FJ;AzDw1NF;;AoBj7NM;EqCuEN;;IrCtEQ,gBAAA;EpBs7NN;AACF;AyD51NE;;;EAEE,WnDnGQ;EmDoGR,qBAAA;EACA,UAAA;EACA,YnD2uDiC;ANonKrC;;AyD51NA;EACE,OAAA;AzD+1NF;;AyD31NA;EACE,QAAA;AzD81NF;;AyDx1NA;;EAEE,qBAAA;EACA,WnD2uDmC;EmD1uDnC,YnD0uDmC;EmDzuDnC,4BAAA;EACA,wBAAA;EACA,0BAAA;AzD21NF;;AyDx1NA;E9BnBM,0DAAA;A3B+2NN;;AyDz1NA;E9BtBM,0DAAA;A3Bm3NN;;AyDp1NA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,UAAA;EACA,aAAA;EACA,uBAAA;EACA,UAAA;EAEA,iBnD0rDmC;EmDzrDnC,mBAAA;EACA,gBnDwrDmC;AN8pKrC;;AyDp1NE;EACE,uBAAA;EACA,cAAA;EACA,WnDyrDiC;EmDxrDjC,WnDyrDiC;EmDxrDjC,UAAA;EACA,iBnDyrDiC;EmDxrDjC,gBnDwrDiC;EmDvrDjC,mBAAA;EACA,eAAA;EACA,sBnDnKQ;EmDoKR,4BAAA;EACA,SAAA;EAEA,kCAAA;EACA,qCAAA;EACA,YnDgrDiC;Ecx1D/B,6BqCyKF;AzDs1NJ;;AoB3/NM;EqCoJJ;IrCnJM,gBAAA;EpB+/NN;AACF;AyDz1NE;EACE,UnD6qDiC;AN8qKrC;;AyDl1NA;EACE,kBAAA;EACA,UAAA;EACA,enDuqDmC;EmDtqDnC,SAAA;EACA,oBnDoqDmC;EmDnqDnC,uBnDmqDmC;EmDlqDnC,wCAAA;EACA,kBAAA;AzDq1NF;;AyD10NA;EALE,2CAAA;EACA,qCAAA;EACA,4DAAA;AzDm1NF;;AyD50NA;;EAEE,wCAAA;EACA,kCAAA;EACA,oCAAA;AzD+0NF;;AIliOI;EqDsMF,2CAAA;EACA,qCAAA;EACA,4DAAA;AzDg2NF;;A2DnjOA;;EAEE,qBAAA;EACA,cAAA;EACA,+BAAA;EACA,iCAAA;EACA,iDAAA;EAEA,kBAAA;EACA,+FAAA;A3DqjOF;;A2DjjOA;EACE;IAAK,0CAAA;E3DqjOL;AACF;A2DljOA;EAEE,yBAAA;EACA,0BAAA;EACA,sCAAA;EACA,kCAAA;EACA,oCAAA;EACA,4CAAA;EAGA,0DAAA;EACA,+BAAA;A3DijOF;;A2D9iOA;EAEE,yBAAA;EACA,0BAAA;EACA,iCAAA;A3DgjOF;;A2DviOA;EACE;IACE,mBAAA;E3D0iOF;E2DxiOA;IACE,UAAA;IACA,eAAA;E3D0iOF;AACF;A2DtiOA;EAEE,yBAAA;EACA,0BAAA;EACA,sCAAA;EACA,oCAAA;EACA,0CAAA;EAGA,8BAAA;EACA,UAAA;A3DqiOF;;A2DliOA;EACE,yBAAA;EACA,0BAAA;A3DqiOF;;A2DjiOE;EACE;;IAEE,mCAAA;E3DoiOJ;AACF;A4DhnOA;EAEE,4BAAA;EACA,4BAAA;EACA,4BAAA;EACA,+BAAA;EACA,+BAAA;EACA,4CAAA;EACA,sCAAA;EACA,qDAAA;EACA,iEAAA;EACA,oDAAA;EACA,sDAAA;EACA,sCAAA;A5DinOF;;AcljOI;E8C9CF;IAEI,eAAA;IACA,SAAA;IACA,oCAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,iCAAA;IACA,kBAAA;IACA,yCAAA;IACA,4BAAA;IACA,UAAA;IxChCA,2CwCkCA;E5DkmOJ;AACF;AoBjoOM;EwCgBJ;IxCfM,gBAAA;EpBooON;AACF;AcxkOI;E8C9BE;IACE,qBAAA;IACA,MAAA;IACA,iCAAA;IACA,4FAAA;IjCmEF,4BAAA;E3BuiOJ;E4DtmOI;IACE,mBAAA;IACA,MAAA;IACA,iCAAA;IACA,8FAAA;IACA,2BAAA;E5DwmON;E4DrmOI;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,mCAAA;IACA,gBAAA;IACA,wFAAA;IACA,4BAAA;E5DumON;E4DpmOI;IACE,QAAA;IACA,OAAA;IACA,mCAAA;IACA,gBAAA;IACA,qFAAA;IACA,2BAAA;E5DsmON;E4DnmOI;IAEE,0BAAA;E5DomON;E4DjmOI;IAGE,mBAAA;E5DimON;AACF;Ac5nOI;E8CjCF;IAiEM,4BAAA;IACA,+BAAA;IACA,wCAAA;E5DgmON;E4D9lOM;IACE,aAAA;E5DgmOR;E4D7lOM;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IAEA,wCAAA;E5D8lOR;AACF;AchoOI;E8C9CF;IAEI,eAAA;IACA,SAAA;IACA,oCAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,iCAAA;IACA,kBAAA;IACA,yCAAA;IACA,4BAAA;IACA,UAAA;IxChCA,2CwCkCA;E5D+qOJ;AACF;AoB9sOM;EwCgBJ;IxCfM,gBAAA;EpBitON;AACF;AcrpOI;E8C9BE;IACE,qBAAA;IACA,MAAA;IACA,iCAAA;IACA,4FAAA;IjCmEF,4BAAA;E3BonOJ;E4DnrOI;IACE,mBAAA;IACA,MAAA;IACA,iCAAA;IACA,8FAAA;IACA,2BAAA;E5DqrON;E4DlrOI;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,mCAAA;IACA,gBAAA;IACA,wFAAA;IACA,4BAAA;E5DorON;E4DjrOI;IACE,QAAA;IACA,OAAA;IACA,mCAAA;IACA,gBAAA;IACA,qFAAA;IACA,2BAAA;E5DmrON;E4DhrOI;IAEE,0BAAA;E5DirON;E4D9qOI;IAGE,mBAAA;E5D8qON;AACF;AczsOI;E8CjCF;IAiEM,4BAAA;IACA,+BAAA;IACA,wCAAA;E5D6qON;E4D3qOM;IACE,aAAA;E5D6qOR;E4D1qOM;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IAEA,wCAAA;E5D2qOR;AACF;Ac7sOI;E8C9CF;IAEI,eAAA;IACA,SAAA;IACA,oCAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,iCAAA;IACA,kBAAA;IACA,yCAAA;IACA,4BAAA;IACA,UAAA;IxChCA,2CwCkCA;E5D4vOJ;AACF;AoB3xOM;EwCgBJ;IxCfM,gBAAA;EpB8xON;AACF;AcluOI;E8C9BE;IACE,qBAAA;IACA,MAAA;IACA,iCAAA;IACA,4FAAA;IjCmEF,4BAAA;E3BisOJ;E4DhwOI;IACE,mBAAA;IACA,MAAA;IACA,iCAAA;IACA,8FAAA;IACA,2BAAA;E5DkwON;E4D/vOI;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,mCAAA;IACA,gBAAA;IACA,wFAAA;IACA,4BAAA;E5DiwON;E4D9vOI;IACE,QAAA;IACA,OAAA;IACA,mCAAA;IACA,gBAAA;IACA,qFAAA;IACA,2BAAA;E5DgwON;E4D7vOI;IAEE,0BAAA;E5D8vON;E4D3vOI;IAGE,mBAAA;E5D2vON;AACF;ActxOI;E8CjCF;IAiEM,4BAAA;IACA,+BAAA;IACA,wCAAA;E5D0vON;E4DxvOM;IACE,aAAA;E5D0vOR;E4DvvOM;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IAEA,wCAAA;E5DwvOR;AACF;Ac1xOI;E8C9CF;IAEI,eAAA;IACA,SAAA;IACA,oCAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,iCAAA;IACA,kBAAA;IACA,yCAAA;IACA,4BAAA;IACA,UAAA;IxChCA,2CwCkCA;E5Dy0OJ;AACF;AoBx2OM;EwCgBJ;IxCfM,gBAAA;EpB22ON;AACF;Ac/yOI;E8C9BE;IACE,qBAAA;IACA,MAAA;IACA,iCAAA;IACA,4FAAA;IjCmEF,4BAAA;E3B8wOJ;E4D70OI;IACE,mBAAA;IACA,MAAA;IACA,iCAAA;IACA,8FAAA;IACA,2BAAA;E5D+0ON;E4D50OI;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,mCAAA;IACA,gBAAA;IACA,wFAAA;IACA,4BAAA;E5D80ON;E4D30OI;IACE,QAAA;IACA,OAAA;IACA,mCAAA;IACA,gBAAA;IACA,qFAAA;IACA,2BAAA;E5D60ON;E4D10OI;IAEE,0BAAA;E5D20ON;E4Dx0OI;IAGE,mBAAA;E5Dw0ON;AACF;Acn2OI;E8CjCF;IAiEM,4BAAA;IACA,+BAAA;IACA,wCAAA;E5Du0ON;E4Dr0OM;IACE,aAAA;E5Du0OR;E4Dp0OM;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IAEA,wCAAA;E5Dq0OR;AACF;Acv2OI;E8C9CF;IAEI,eAAA;IACA,SAAA;IACA,oCAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,iCAAA;IACA,kBAAA;IACA,yCAAA;IACA,4BAAA;IACA,UAAA;IxChCA,2CwCkCA;E5Ds5OJ;AACF;AoBr7OM;EwCgBJ;IxCfM,gBAAA;EpBw7ON;AACF;Ac53OI;E8C9BE;IACE,qBAAA;IACA,MAAA;IACA,iCAAA;IACA,4FAAA;IjCmEF,4BAAA;E3B21OJ;E4D15OI;IACE,mBAAA;IACA,MAAA;IACA,iCAAA;IACA,8FAAA;IACA,2BAAA;E5D45ON;E4Dz5OI;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,mCAAA;IACA,gBAAA;IACA,wFAAA;IACA,4BAAA;E5D25ON;E4Dx5OI;IACE,QAAA;IACA,OAAA;IACA,mCAAA;IACA,gBAAA;IACA,qFAAA;IACA,2BAAA;E5D05ON;E4Dv5OI;IAEE,0BAAA;E5Dw5ON;E4Dr5OI;IAGE,mBAAA;E5Dq5ON;AACF;Ach7OI;E8CjCF;IAiEM,4BAAA;IACA,+BAAA;IACA,wCAAA;E5Do5ON;E4Dl5OM;IACE,aAAA;E5Do5OR;E4Dj5OM;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IAEA,wCAAA;E5Dk5OR;AACF;A4Dl+OE;EAEI,eAAA;EACA,SAAA;EACA,oCAAA;EACA,aAAA;EACA,sBAAA;EACA,eAAA;EACA,iCAAA;EACA,kBAAA;EACA,yCAAA;EACA,4BAAA;EACA,UAAA;ExChCA,2CwCkCA;A5Dk+ON;;AoBhgPM;EwCgBJ;IxCfM,gBAAA;EpBogPN;AACF;A4Dt+OM;EACE,qBAAA;EACA,MAAA;EACA,iCAAA;EACA,4FAAA;EjCmEF,4BAAA;A3Bs6ON;;A4Dr+OM;EACE,mBAAA;EACA,MAAA;EACA,iCAAA;EACA,8FAAA;EACA,2BAAA;A5Dw+OR;;A4Dr+OM;EACE,MAAA;EACA,QAAA;EACA,OAAA;EACA,mCAAA;EACA,gBAAA;EACA,wFAAA;EACA,4BAAA;A5Dw+OR;;A4Dr+OM;EACE,QAAA;EACA,OAAA;EACA,mCAAA;EACA,gBAAA;EACA,qFAAA;EACA,2BAAA;A5Dw+OR;;A4Dr+OM;EAEE,0BAAA;A5Du+OR;;A4Dp+OM;EAGE,mBAAA;A5Dq+OR;;A4D18OA;EPzHE,eAAA;EACA,MAAA;EACA,OAAA;EACA,a/CosCkC;E+CnsClC,YAAA;EACA,aAAA;EACA,2DOoHsD;A5Dm9OxD;;AqDpkPE;EAAS,UAAA;ArDwkPX;;AqDvkPE;EAAS,Y/CulDyB;ANo/LpC;;A4Dx9OA;EACE,aAAA;EACA,mBAAA;EACA,sEAAA;A5D29OF;;A4Dz9OE;EACE,8FAAA;EACA,yBAAA;EACA,8DAAA;EACA,uDAAA;EACA,0DAAA;A5D49OJ;;A4Dx9OA;EACE,gBAAA;EACA,mDAAA;A5D29OF;;A4Dx9OA;EACE,YAAA;EACA,sEAAA;EACA,gBAAA;A5D29OF;;A6DhnPA;EACE,qBAAA;EACA,eAAA;EACA,sBAAA;EACA,YAAA;EACA,8BAAA;EACA,YvDg6CkC;ANmtMpC;;A6DjnPE;EACE,qBAAA;EACA,WAAA;A7DonPJ;;A6D/mPA;EACE,iBAAA;A7DknPF;;A6D/mPA;EACE,iBAAA;A7DknPF;;A6D/mPA;EACE,iBAAA;A7DknPF;;A6D7mPE;EACE,mDAAA;A7DgnPJ;;A6D7mPM;EAJJ;IAKM,eAAA;E7DinPN;AACF;A6D5mPA;EACE;IACE,YvD63CgC;ENivMlC;AACF;A6D3mPA;EACE,qFAAA;EACA,oBAAA;EACA,8CAAA;A7D6mPF;;A6D1mPI;EANJ;IAOM,eAAA;E7D8mPJ;AACF;A6D1mPA;EACE;IACE,uBAAA;E7D4mPF;AACF;A8DvnPA;EAEE,0BAAA;EACA,8BAAA;EACA,yBAAA;EACA,8BAAA;EACA,2BAAA;EACA,uDAAA;EACA,4BAAA;EACA,iCAAA;EACA,0BAAA;EACA,4BAAA;EACA,+BAAA;EACA,kCAAA;EACA,gJAAA;EAEA,iEAAA;EACA,4DAAA;EACA,gDAAA;EACA,oCAAA;EAEA,uEAAA;EACA,0DAAA;EACA,2CAAA;EAEA,kEAAA;EACA,4FAAA;EACA,0CAAA;EAGA,oBAAA;EACA,wBAAA;EACA,mBAAA;EACA,8BAAA;EACA,yCAAA;EACA,oCAAA;EACA,wCAAA;EACA,4BAAA;EACA,qBAAA;EACA,mBAAA;EACA,sBAAA;EACA,oCAAA;EACA,uEAAA;EvDvEE,4CAAA;EaJE,sC0C6EJ;A9DmnPF;;AoB5rPM;E0C6BN;I1C5BQ,gBAAA;EpBgsPN;AACF;A8DvnPE;EACE,mCAAA;EACA,2CAAA;EACA,iDAAA;A9DynPJ;;A8DtnPE;EAEE,oBAAA;EACA,aAAA;A9DwnPJ;;A8DrnPE;EzCxGA,UAAA;EACA,kGAAA;ArBiuPF;;A8DtnPE;EACE,4CAAA;EACA,6CAAA;EAEA,kBAAA;A9DwnPJ;;A8DtnPI;EACE,8BAAA;A9DynPN;;A8DpnPA;EAEE,yDAAA;EACA,0BAAA;EACA,kEAAA;EACA,gGAAA;EACA,uEAAA;EACA,wEAAA;EACA,0DAAA;EACA,uEAAA;A9DsnPF;;A8DlnPA;EACE,eAAA;A9DqnPF;;A8DnnPE;EACE,kCAAA;EACA,0CAAA;EACA,gDAAA;A9DsnPJ;;A8DnnPE;EACE,mCAAA;EACA,2CAAA;EACA,YAAA;A9DsnPJ;;A8DlnPA;EACE,+BAAA;EACA,gCAAA;EvDtIE,gDAAA;AP4vPJ;;A8DnnPE;EACE,8BAAA;A9DsnPJ;;A8DlnPA;EACE,aAAA;EACA,cAAA;EACA,mBAAA;EACA,uBAAA;EACA,sDAAA;A9DqnPF;;A8DnnPE;EACE,cAAA;EACA,gCAAA;EACA,iCAAA;A9DsnPJ;;A8DnnPE;EACE,gCAAA;EACA,iCAAA;EACA,iBAAA;EvD9JA,gDAAA;APqxPJ;;A8DlnPA;EACE,aAAA;EACA,cAAA;EACA,mBAAA;EACA,uBAAA;EACA,sDAAA;A9DqnPF;;A8DnnPE;EACE,cAAA;EACA,gCAAA;EACA,iCAAA;A9DsnPJ;;A8DlnPA;EACE,aAAA;EACA,cAAA;EACA,mBAAA;EACA,uBAAA;EACA,iCAAA;EACA,kCAAA;EACA,UAAA;EACA,0DAAA;EACA,cAAA;EACA,eAAA;EACA,uBAAA;EACA,SAAA;EACA,uCAAA;E1ClMI,qC0CmMJ;A9DqnPF;;AoBpzPM;E0CiLN;I1ChLQ,gBAAA;EpBwzPN;AACF;A8DznPE;EACE,6CAAA;A9D2nPJ;;A8DxnPE;EACE,UAAA;EACA,UAAA;EzCxNF,UAAA;EACA,kGAAA;ArBo1PF;;A8DznPE;EACE,cAAA;EACA,kCAAA;EACA,mCAAA;A9D4nPJ;;A8DpnPA;;ECxOE,uBAAA;EACA,6BAAA;EACA,wBAAA;E5DsSI,0BALI;E4D/RR,4BAAA;EACA,4BAAA;EACA,gCAAA;A/Di2PF;;A8DlnPA;;ECrPE,yBAAA;EACA,8BAAA;EACA,uBAAA;E5DsSI,6BALI;E4D/RR,6BAAA;EACA,0BAAA;EACA,iCAAA;A/D42PF;;A8D9mPE;EACE,6CAAA;EACA,+BAAA;EACA,uCAAA;EACA,2CAAA;EACA,qDAAA;EACA,mFAAA;A9DinPJ;;A8DvnPE;EACE,+CAAA;EACA,iCAAA;EACA,yCAAA;EACA,6CAAA;EACA,uDAAA;EACA,qFAAA;A9D0nPJ;;A8DhoPE;EACE,6CAAA;EACA,+BAAA;EACA,uCAAA;EACA,2CAAA;EACA,qDAAA;EACA,mFAAA;A9DmoPJ;;A8DzoPE;EACE,0CAAA;EACA,4BAAA;EACA,oCAAA;EACA,wCAAA;EACA,kDAAA;EACA,gFAAA;A9D4oPJ;;A8DlpPE;EACE,6CAAA;EACA,+BAAA;EACA,uCAAA;EACA,2CAAA;EACA,qDAAA;EACA,mFAAA;A9DqpPJ;;A8D3pPE;EACE,4CAAA;EACA,8BAAA;EACA,sCAAA;EACA,0CAAA;EACA,oDAAA;EACA,kFAAA;A9D8pPJ;;A8DpqPE;EACE,2CAAA;EACA,6BAAA;EACA,qCAAA;EACA,yCAAA;EACA,mDAAA;EACA,iFAAA;A9DuqPJ;;A8D7qPE;EACE,0CAAA;EACA,4BAAA;EACA,oCAAA;EACA,wCAAA;EACA,kDAAA;EACA,gFAAA;A9DgrPJ;;AgEz7PA;EAEE,2BAAA;EAGA,aAAA;EACA,eAAA;EACA,4BAAA;AhEy7PF;;AiEj8PA;EAEE,wBAAA;EACA,yBAAA;EACA,8BAAA;EACA,gCAAA;EACA,iCAAA;EACA,kCAAA;EACA,uCAAA;EAGA,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,8BAAA;EACA,gCAAA;EACA,sCAAA;EACA,sBAAA;E1DAE,8CAAA;EaJE,wB6CMJ;AjEi8PF;;AoBn8PM;E6ClBN;I7CmBQ,gBAAA;EpBu8PN;AACF;AiEp8PA;EACE,WAAA;EACA,YAAA;E1DPE,8CAAA;AP88PJ;;AiEn8PA;EACE,kBAAA;EACA,mBAAA;EACA,SAAA;EACA,cAAA;EACA,qCAAA;EACA,uCAAA;EACA,sBAAA;E1DlBE,qDAAA;APy9PJ;;AiEl8PE;EACE,0BAAA;EACA,2BAAA;EACA,8BAAA;EACA,iCAAA;EACA,kCAAA;AjEq8PJ;;AiE18PE;EACE,0BAAA;EACA,2BAAA;EACA,4BAAA;EACA,iCAAA;EACA,kCAAA;AjE68PJ;;AiEl9PE;EACE,wBAAA;EACA,yBAAA;EACA,8BAAA;EACA,iCAAA;EACA,kCAAA;AjEq9PJ;;AiE19PE;EACE,wBAAA;EACA,yBAAA;EACA,8BAAA;EACA,+BAAA;EACA,gCAAA;AjE69PJ;;AiEz9PA;EACE,aAAA;AjE49PF;;AiE19PE;EACE,uDAAA;AjE69PJ;;AiE39PI;EACE,oBAAA;AjE89PN;;AiE39PI;EACE,oBAAA;AjE89PN;;AkE7hQA;EAEE,6BAAA;EACA,6BAAA;EACA,yBAAA;EACA,4BAAA;EACA,mDAAA;EACA,mDAAA;EACA,kEAAA;EACA,qDAAA;EAGA,kEAAA;EACA,+DAAA;EACA,6EAAA;EACA,+DAAA;EACA,+DAAA;E3DIE,+CAAA;AP0hQJ;;AkEvhQE;EACE,wCAAA;AlE0hQJ;;AkE3hQE;EACE,wCAAA;AlE8hQJ;;AkE/hQE;EACE,wCAAA;AlEkiQJ;;AkEniQE;EACE,wCAAA;AlEsiQJ;;AkEviQE;EACE,wCAAA;AlE0iQJ;;AkE3iQE;EACE,qCAAA;AlE8iQJ;;AkE/iQE;EACE,wCAAA;AlEkjQJ;;AkEnjQE;EACE,wCAAA;AlEsjQJ;;AmE/kQA;EAEE,6BAAA;EACA,4BAAA;EACA,8BAAA;EACA,yCAAA;EACA,uCAAA;EACA,kDAAA;EACA,iFAAA;EAGA,aAAA;EACA,eAAA;EACA,mBAAA;EACA,8BAAA;EACA,wCAAA;EACA,gEAAA;EACA,8BAAA;EACA,gCAAA;EACA,oCAAA;AnE+kQF;;AmE5kQA;EACE,eAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,a7D2qCkC;ANo6NpC;;AmE5kQA;EACE,gBAAA;EACA,SAAA;EACA,a7DqqCkC;AN06NpC;;AoE3mQA;EAEE,8BAAA;EACA,8BAAA;EACA,mCAAA;EACA,6DAAA;EACA,kDAAA;EACA,iFAAA;EACA,kEAAA;EACA,qEAAA;EACA,iEAAA;EACA,qDAAA;EACA,uCAAA;EACA,iCAAA;EACA,mFAAA;EACA,uCAAA;EACA,uCAAA;EACA,oCAAA;EACA,qEAAA;EACA,4DAAA;EACA,wEAAA;EACA,sEAAA;EACA,4EAAA;EACA,uCAAA;EACA,uCAAA;EACA,0DAAA;EACA,iGAAA;EAGA,kBAAA;EACA,aAAA;EACA,eAAA;EACA,mBAAA;EACA,8BAAA;EACA,gEAAA;EACA,gCAAA;EACA,uCAAA;EhDxBI,wCgDyBJ;ApE2mQF;;AoBhoQM;EgDhBN;IhDiBQ,gBAAA;EpBooQN;AACF;AoE5mQE;;EACE,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,8BAAA;ApE+mQJ;;AoEjmQE;EACE,gBAAA;EACA,MAAA;EACA,a9DioCgC;ANm+NpC;;AoEhmQA;EACE,wDAAA;EACA,SAAA;EACA,0EAAA;EACA,4CAAA;ApEmmQF;;AoE5lQA;EACE,8CAAA;EACA,iDAAA;EACA,uB9DysD8B;EHp/C1B,kBALI;EiE9MR,oCAAA;EACA,qBAAA;EACA,mBAAA;ApE+lQF;;AoE7lQE;EAEE,0CAAA;ApE+lQJ;;AoErlQA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,gBAAA;ApEwlQF;;AoEtlQE;EACE,kFAAA;EACA,8BAAA;ApEylQJ;;AoEvlQI;EAEE,oCAAA;ApEylQN;;AoEtlQI;EACE,uCAAA;ApEylQN;;AoErlQE;;EAEE,qCAAA;ApEwlQJ;;AoErlQE;EACE,kBAAA;ApEwlQJ;;AoE/kQA;EACE,iDAAA;EACA,oDAAA;EACA,8BAAA;ApEklQF;;AoEhlQE;EACE,qCAAA;ApEmlQJ;;AoEjlQI;EAEE,qCAAA;ApEmlQN;;AoE9kQA;EACE,gFAAA;EjE+II,kBALI;EiExIR,sCAAA;EACA,8CAAA;EACA,SAAA;E7D3IE,sDAAA;AP6tQJ;;AoE/kQE;EACE,4CAAA;EACA,qBAAA;ApEklQJ;;AoE/kQE;EACE,UAAA;ApEklQJ;;AoE9kQE;EACE,eAAA;ApEilQJ;;AoE7kQA;EACE,cAAA;EACA,iBAAA;EACA,mDAAA;EACA,4BAAA;EACA,kCAAA;EACA,0BAAA;ApEglQF;;AoE9kQE;EACE,yDAAA;ApEilQJ;;AqE3wQA;EACE,qBAAA;EACA,cAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;ArE8wQF;;AqE7wQE;ECPA,WhEkwBgB;EgEjwBhB,YhEiwBgB;EgEhwBhB,ehEgwBgB;ANwhPlB;;AqEhxQI;ECVF,WhEswBgB;EgErwBhB,YhEqwBgB;EgEpwBhB,ehEowBgB;AN0hPlB;;AqElxQI;ECdF,ahEqwBgB;EgEpwBhB,chEowBgB;EgEnwBhB,iBhEmwBgB;ANiiPlB;;AqEpxQI;EClBF,chEowBgB;EgEnwBhB,ehEmwBgB;EgElwBhB,kBhEkwBgB;ANwiPlB;;AqEtxQI;ECtBF,ehEmwBgB;EgElwBhB,gBhEkwBgB;EgEjwBhB,mBhEiwBgB;AN+iPlB;;AqEvxQM;EC3BJ,WD4ByB;EC3BzB,YD2ByB;EC1BzB,eD0ByB;ArE4xQ3B;;AqE7xQM;EC3BJ,WD4ByB;EC3BzB,YD2ByB;EC1BzB,eD0ByB;ArEkyQ3B;;AqEnyQM;EC3BJ,WD4ByB;EC3BzB,YD2ByB;EC1BzB,eD0ByB;ArEwyQ3B;;AqEzyQM;EC3BJ,WD4ByB;EC3BzB,YD2ByB;EC1BzB,eD0ByB;ArE8yQ3B;;AqE/yQM;EC3BJ,WD4ByB;EC3BzB,YD2ByB;EC1BzB,eD0ByB;ArEozQ3B;;AqErzQM;EC3BJ,WD4ByB;EC3BzB,YD2ByB;EC1BzB,eD0ByB;ArE0zQ3B;;AqE3zQM;EC3BJ,WD4ByB;EC3BzB,YD2ByB;EC1BzB,eD0ByB;ArEg0Q3B;;AuEvzQA;EAEE,qFAAA;EACA,sCAAA;EACA,iCAAA;EACA,mCAAA;EACA,oCAAA;EACA,qDAAA;EACA,0CAAA;EACA,yDAAA;EACA,yDAAA;EACA,2DAAA;EACA,2DAAA;EACA,4FAAA;EACA,sDAAA;EACA,gDAAA;EACA,0FAAA;EACA,2EAAA;EACA,uCAAA;EACA,qCAAA;EACA,qCAAA;EACA,sCAAA;EACA,+CAAA;EACA,0CAAA;EACA,kDAAA;EACA,kEAAA;EACA,0DAAA;EACA,2DAAA;EAGA,aAAA;EACA,mBAAA;EACA,uCAAA;EACA,kDAAA;EACA,iDAAA;EpEoOI,6CALI;EoE7NR,iDAAA;EACA,qCAAA;EACA,6CAAA;EACA,yFAAA;EhEvDE,qDAAA;EaJE,+CmD+DJ;AvEqzQF;;AoBh3QM;EmDgBN;InDfQ,gBAAA;EpBo3QN;AACF;AuEzzQE;EACE,2CAAA;EACA,mDAAA;EACA,yDAAA;EACA,UAAA;EAKE,qDAAA;AvEuzQN;;AuElzQA;EACE,yCAAA;EACA,0CAAA;AvEqzQF;;AuElzQA;EACE,oBAAA;EACA,sCAAA;EACA,yBAAA;AvEqzQF;;AuElzQA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,6CAAA;EACA,2CAAA;EACA,2DAAA;EACA,iDAAA;EACA,iDAAA;EhE9FE,yDAAA;APo5QJ;;AuEnzQE;EACE,wDAAA;AvEszQJ;;AuElzQA;EACE,iEAAA;AvEqzQF;;AwEz6QA;EAEE,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,6BAAA;EACA,6BAAA;EACA,0CAAA;EACA,gDAAA;EACA,4CAAA;EACA,oCAAA;EAGA,kBAAA;EACA,aAAA;EACA,kCAAA;EACA,sBAAA;EAEA,SAAA;EACA,+BAAA;EACA,+BAAA;EACA,iCAAA;EACA,gBAAA;EpDbI,yHoDcJ;AxEw6QF;;AoBl7QM;EoDbN;IpDcQ,gBAAA;EpBs7QN;AACF;AwE56QE;EACE,sBAAA;AxE86QJ;;AwE36QE;EACE,SAAA;EACA,oBAAA;AxE86QJ;;Ac/4QI;E0D1BE;IACE,iCAAA;ExE66QN;EwE36QI;IACE,+BAAA;ExE66QN;EwEx6QI;IACE,wDAAA;ExE06QN;EwEx6QI;IACE,sDAAA;ExE06QN;AACF;Acj5QI;E0D3EJ;IAyDI,qBAAA;IAEA,eAAA;IACA,MAAA;IACA,SAAA;IACA,kCAAA;ExEs6QF;EwEp6QE;IACE,qBAAA;ExEs6QJ;EwEp6QI;IACE,wDAAA;ExEs6QN;EwEl6QE;IACE,mBAAA;ExEo6QJ;EwEl6QI;IACE,sDAAA;ExEo6QN;AACF;AwE/5QA;EACE,eAAA;EACA,MAAA;EACA,SAAA;EACA,kCAAA;AxEi6QF;;AwE/5QE;EACE,qBAAA;AxEk6QJ;;AwE/5QE;EACE,mBAAA;AxEk6QJ;;AwE95QA;EAEE,wDAAA;AxEg6QF;;AwE35QE;EACE,wDAAA;AxE85QJ;;AwE35QE;EACE,sDAAA;AxE85QJ;;AwE35QE;EACE,kDAAA;AxE85QJ;;AwE55QI;EACE,sBAAA;AxE+5QN;;AwE55QI;EACE,oBAAA;AxE+5QN;;AwEz5QE;EACE,0BAAA;AxE45QJ;;Ac79QI;E0DqEI;IACE,iCAAA;ExE45QR;EwE15QM;IACE,+BAAA;ExE45QR;AACF;AwEt6QE;EACE,0BAAA;AxEw6QJ;;Acz+QI;E0DqEI;IACE,iCAAA;ExEw6QR;EwEt6QM;IACE,+BAAA;ExEw6QR;AACF;AwEl7QE;EACE,0BAAA;AxEo7QJ;;Acr/QI;E0DqEI;IACE,iCAAA;ExEo7QR;EwEl7QM;IACE,+BAAA;ExEo7QR;AACF;AwE96QA;EACE,qCAAA;EACA,mBAAA;AxEg7QF;;AwE76QA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,kEAAA;AxEg7QF;;AwE96QE;EACE,0FAAA;EACA,4DAAA;EACA,qDAAA;EACA,wDAAA;AxEi7QJ;;AwE76QA;EACE,kEAAA;AxEg7QF;;AwE76QA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,kEAAA;AxEg7QF;;AwE76QA;EAEE,mCAAA;EACA,qCAAA;EACA,sDAAA;EACA,oEAAA;EACA,6DAAA;EACA,yEAAA;EACA,6DAAA;EACA,iDAAA;EAGA,kBAAA;EACA,uBAAA;EACA,uCAAA;EACA,yCAAA;EACA,wBAAA;EACA,+CAAA;EACA,SAAA;EjEjLE,uBAAA;AP+lRJ;;AwE36QE;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,kDAAA;EACA,sDAAA;EpDhME,iDoDiMF;AxE86QJ;;AoB3mRM;EoDoLJ;IpDnLM,gBAAA;EpB+mRN;AACF;AwE76QE;EACE,qBAAA;AxE+6QJ;;AwE96QI;EACE,wDAAA;AxEi7QN;;AwE76QE;EACE,UAAA;EACA,mDAAA;AxEg7QJ;;AwE96QI;EACE,wDAAA;AxEi7QN;;AcnkRI;E0DiGJ;IAsDI,aAAA;ExEi7QF;AACF;AwE36QA;EAEE,2BAAA;EACA,0BAAA;EACA,2BAAA;AxE46QF;;Ac9kRI;E0D8JJ;InB/OE,eAAA;IACA,MAAA;IACA,OAAA;IACA,mCmBoP4B;InBnP5B,YAAA;IACA,aAAA;IACA,wCmBiP8D;ExEm7Q9D;EqDjqRA;IAAS,UAAA;ErDoqRT;EqDnqRA;IAAS,oCmB6OmF;ExEy7Q5F;AACF;AwEt7QA;EACE,2CAAA;EACA,sBAAA;EAEA,0BAAA;EAEA,+CAAA;EACA,2BAAA;EAEA,+CAAA;EACA,sEAAA;EAEA,2BAAA;AxEo7QF;;AyEzrRA;EAEE,mCAAA;EACA,mCAAA;EACA,0BAAA;EAEA,uCAAA;EACA,0CAAA;EACA,wCAAA;EACA,wDAAA;EAEA,sCAAA;EACA,yCAAA;EACA,mDAAA;EACA,sCAAA;EACA,gDAAA;EACA,8DAAA;EACA,sCAAA;EAEA,8DAAA;EACA,oEAAA;EACA,gEAAA;EACA,6DAAA;EACA,mEAAA;EAEA,2CAAA;EACA,4DAAA;EACA,0CAAA;EACA,2CAAA;EACA,8CAAA;EACA,mEAAA;EACA,qEAAA;EACA,8DAAA;EAEA,kDAAA;EACA,kDAAA;EACA,oDAAA;EACA,uDAAA;EACA,0EAAA;EACA,yDAAA;EACA,iFAAA;EACA,2DAAA;EACA,mFAAA;EACA,wDAAA;EACA,4EAAA;EAEA,uCAAA;EACA,uCAAA;EACA,+DAAA;EACA,iDAAA;EACA,0CAAA;EACA,0CAAA;EACA,kEAAA;EACA,gFAAA;EACA,wEAAA;EACA,sFAAA;EACA,gEAAA;EAGA,kBAAA;EACA,aAAA;EACA,SAAA;EACA,sBAAA;EACA,0EAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;AzEmrRF;;AyEjrRE;;;;;EAKE,sCAAA;AzEorRJ;;AyEjrRE;EACE,sFAAA;EACA,mDAAA;EACA,cAAA;EACA,gBAAA;EACA,yCAAA;EACA,yBAAA;ErDtEE,sCqDuEF;AzEorRJ;;AoBvvRM;EqD4DJ;IrD3DM,gBAAA;EpB2vRN;AACF;AyEvrRE;EACE,aAAA;EACA,SAAA;EACA,mBAAA;EACA,oFAAA;EACA,wCAAA;EACA,qBAAA;EACA,mBAAA;EACA,0CAAA;EACA,+FAAA;ElE/EA,wDAAA;EaJE,mEqDqFF;AzEyrRJ;;AoB1wRM;EqDsEJ;IrDrEM,gBAAA;EpB8wRN;AACF;AyE7rRI;EACE,+CAAA;EACA,iDAAA;AzE+rRN;;AyE7rRM;EACE,oDAAA;AzEgsRR;;AyE7rRM;EACE,6DAAA;EACA,yEAAA;AzEgsRR;;AyE5rRI;EACE,iDAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;AzE+rRN;;AyE7rRM;EACE,sDAAA;AzEgsRR;;AyE7rRM;EACE,+DAAA;EACA,2EAAA;AzEgsRR;;AyE5rRI;EACE;IACE,8CAAA;IACA,qBAAA;IACA,gDAAA;EzE+rRN;EyE7rRM;IACE,mDAAA;EzE+rRR;EyE5rRM;IACE,4DAAA;IACA,wEAAA;EzE8rRR;AACF;AyEzrRE;EACE,aAAA;EACA,gDAAA;EACA,mBAAA;EACA,uBAAA;EACA,+CAAA;EACA,0DAAA;EACA,qDAAA;EACA,6CAAA;EACA,kBAAA;EACA,oBAAA;EACA,kBAAA;ErDlJE,mBqDmJF;AzE2rRJ;;AoB10RM;EqDmIJ;IrDlIM,gBAAA;EpB80RN;AACF;AyE9rRE;EACE,qBAAA;EACA,mDAAA;EACA,oDAAA;EACA,sDAAA;EACA,uHAAA;EACA,oEAAA;AzEgsRJ;;AyE5rRE;EACE,gBAAA;AzE+rRJ;;AyE5rRE;EACE,iGAAA;ElEjKA,yDAAA;EaJE,wCqDuKF;AzE+rRJ;;AoBl2RM;EqDgKJ;IrD/JM,gBAAA;EpBs2RN;AACF;AyElsRM;;EAEE,aAAA;AzEosRR;;AyEhsRI;EACE,2CAAA;AzEmsRN;;AyEjsRM;EACE,qDAAA;AzEosRR;;AyEjsRM;EACE,yBAAA;AzEosRR;;AyEhsRM;EACE,aAAA;AzEmsRR;;AyE9rRE;EACE,eAAA;AzEisRJ;;AyE/rRI;EACE,cAAA;EACA,cAAA;EACA,YAAA;EACA,yBAAA;EACA,WAAA;EACA,8DAAA;EACA,uDAAA;ErD5MA,2BqD6MA;AzEksRN;;AoB34RM;EqDiMF;IrDhMI,gBAAA;EpB+4RN;AACF;AyErsRI;EACE;IACE,oEAAA;IACA,6DAAA;EzEusRN;AACF;AyEnsRE;EACE,yBAAA;EACA,mDAAA;AzEqsRJ;;AyElsRE;EACE,kGAAA;EACA,gBAAA;EACA,gBAAA;ErDhOE,6BqDiOF;AzEqsRJ;;AoBl6RM;EqDyNJ;IrDxNM,gBAAA;EpBs6RN;AACF;AyEzsRI;EACE,oJAAA;AzE2sRN;;AyExsRI;EACE,kHAAA;AzE2sRN;;AyErsRI;;EACE,2CAAA;AzEysRN;;AyErsRE;EAEE,kEAAA;EACA,8DAAA;EACA,oEAAA;EACA,qEAAA;AzEusRJ;;AyEpsRI;EAGE,kBAAA;EACA,UAAA;EACA,0JAJS;AzEysRf;;AyEnsRM;EACE,kBAAA;EACA,gKAAA;EACA,MAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,6EAAA;AzEssRR;;AyElsRM;EACE,8JAAA;AzEqsRR;;A0Ej+RA;EAEE,gCAAA;EACA,+BAAA;A1Em+RF;;Acn6RI;E4DnEJ;IAOI,yCAAA;IACA,sCAAA;IACA,iDAAA;IACA,iBAAA;E1Eo+RF;E0El+RE;IACE,uBAAA;IACA,iBAAA;E1Eo+RJ;E0Ej+RE;IACE,wCAAA;IACA,yCAAA;E1Em+RJ;E0Eh+RE;IACE,gBAAA;E1Ek+RJ;E0E/9RE;IACE,kIAAA;E1Ei+RJ;E0E99RE;;;;;;;IAIE,oBAAA;IACA,qBAAA;IACA,oBAAA;IACA,kBAAA;IACA,UAAA;E1Em+RJ;E0Eh+RE;;;;;IAGE,wBAAA;E1Eo+RJ;E0Ej+RE;I/C+BE,0BAAA;E3Bq8RJ;E0Eh+RE;IACE,uBAAA;E1Ek+RJ;AACF;A0E99RA;EAEE,iEAAA;A1E+9RF;;A0E59RE;EACE,wBAAA;A1E+9RJ;;A0Et9RE;EACE,2DAAA;A1Ey9RJ;;A0Ev9RI;E/CGE,0BAAA;A3Bw9RN;;A0Ev9RI;EACE,uBAAA;A1E09RN;;Acv+RI;E4DqBA;;IACE,gCAAA;E1Eu9RJ;E0Er9RE;;IACE,8BAAA;E1Ew9RJ;AACF;A0Ep9RA;;EAEE,wBAAA;A1Es9RF;;A0En9RA;EACE,wBAAA;A1Es9RF;;A0DhkSE;EACE,cAAA;EACA,WAAA;EACA,WAAA;A1DmkSJ;;A2EhkSE;EAEE,sBAAA;EAEA,mFAAA;A3EikSJ;;A2ErkSE;EAEE,sBAAA;EAEA,qFAAA;A3EskSJ;;A2E1kSE;EAEE,yBAAA;EAEA,mFAAA;A3E2kSJ;;A2E/kSE;EAEE,yBAAA;EAEA,gFAAA;A3EglSJ;;A2EplSE;EAEE,yBAAA;EAEA,mFAAA;A3EqlSJ;;A2EzlSE;EAEE,yBAAA;EAEA,kFAAA;A3E0lSJ;;A2E9lSE;EAEE,yBAAA;EAEA,iFAAA;A3E+lSJ;;A2EnmSE;EAEE,sBAAA;EAEA,gFAAA;A3EomSJ;;A2E5lSM;EAEE,sBAAA;EAEA,8EAAA;A3E6lSR;;A2EjmSM;EAEE,sBAAA;EAEA,0EAAA;A3EkmSR;;A2EtmSM;EAEE,yBAAA;EAEA,iFAAA;A3EumSR;;A2E3mSM;EAEE,yBAAA;EAEA,6EAAA;A3E4mSR;;A2EhnSM;EAEE,yBAAA;EAEA,+EAAA;A3EinSR;;A2ErnSM;EAEE,yBAAA;EAEA,8EAAA;A3EsnSR;;A2E1nSM;EAEE,yBAAA;EAEA,0EAAA;A3E2nSR;;A2E/nSM;EAEE,sBAAA;EAEA,uEAAA;A3EgoSR;;A4ElpSE;EAEE,0EAAA;EAEA,oGAAA;A5EmpSJ;;A4EhpSM;EAKE,qEAAA;EAEA,+FAAA;A5E8oSR;;A4E5pSE;EAEE,4EAAA;EAEA,sGAAA;A5E6pSJ;;A4E1pSM;EAKE,qEAAA;EAEA,+FAAA;A5EwpSR;;A4EtqSE;EAEE,0EAAA;EAEA,oGAAA;A5EuqSJ;;A4EpqSM;EAKE,sEAAA;EAEA,gGAAA;A5EkqSR;;A4EhrSE;EAEE,uEAAA;EAEA,iGAAA;A5EirSJ;;A4E9qSM;EAKE,oEAAA;EAEA,8FAAA;A5E4qSR;;A4E1rSE;EAEE,0EAAA;EAEA,oGAAA;A5E2rSJ;;A4ExrSM;EAKE,sEAAA;EAEA,gGAAA;A5EsrSR;;A4EpsSE;EAEE,yEAAA;EAEA,mGAAA;A5EqsSJ;;A4ElsSM;EAKE,uEAAA;EAEA,iGAAA;A5EgsSR;;A4E9sSE;EAEE,wEAAA;EAEA,kGAAA;A5E+sSJ;;A4E5sSM;EAKE,uEAAA;EAEA,iGAAA;A5E0sSR;;A4ExtSE;EAEE,uEAAA;EAEA,iGAAA;A5EytSJ;;A4EttSM;EAKE,oEAAA;EAEA,8FAAA;A5EotSR;;A4E7sSA;EAEE,iFAAA;EAEA,2GAAA;A5E8sSF;;A4E3sSI;EAGE,oFAAA;EAEA,8GAAA;A5E2sSN;;A6EhvSA;EACE,UAAA;EAEA,uJAAA;A7EkvSF;;A8EpvSA;EACE,oBAAA;EACA,axE2e4B;EwE1e5B,mBAAA;EACA,oFAAA;EACA,6BxEye4B;EwExe5B,2BAAA;A9EuvSF;;A8ErvSE;EACE,cAAA;EACA,UxEqe0B;EwEpe1B,WxEoe0B;EwEne1B,kBAAA;E1DIE,sC0DHF;A9EwvSJ;;AoBjvSM;E0DZJ;I1DaM,gBAAA;EpBqvSN;AACF;A8EvvSI;EACE,oEAAA;A9EyvSN;;A+E7wSA;EACE,kBAAA;EACA,WAAA;A/EgxSF;;A+E9wSE;EACE,cAAA;EACA,oCAAA;EACA,WAAA;A/EixSJ;;A+E9wSE;EACE,kBAAA;EACA,qBAAA;EACA,MAAA;EACA,WAAA;EACA,YAAA;A/EixSJ;;A+E5wSE;EACE,wBAAA;A/E+wSJ;;A+EhxSE;EACE,uBAAA;A/EmxSJ;;A+EpxSE;EACE,0BAAA;A/EuxSJ;;A+ExxSE;EACE,kCAAA;A/E2xSJ;;AgF9ySA;EACE,eAAA;EACA,MAAA;EACA,QAAA;EACA,OAAA;EACA,a1E6rCkC;ANonQpC;;AgF9ySA;EACE,eAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,a1EqrCkC;AN4nQpC;;AgFzySI;EACE,gBAAA;EACA,MAAA;EACA,a1EyqC8B;ANmoQpC;;AgFzySI;EACE,gBAAA;EACA,SAAA;EACA,a1EmqC8B;ANyoQpC;;AcxwSI;EkE7CA;IACE,gBAAA;IACA,MAAA;IACA,a1EyqC8B;ENgpQlC;EgFtzSE;IACE,gBAAA;IACA,SAAA;IACA,a1EmqC8B;ENqpQlC;AACF;AcrxSI;EkE7CA;IACE,gBAAA;IACA,MAAA;IACA,a1EyqC8B;EN4pQlC;EgFl0SE;IACE,gBAAA;IACA,SAAA;IACA,a1EmqC8B;ENiqQlC;AACF;AcjySI;EkE7CA;IACE,gBAAA;IACA,MAAA;IACA,a1EyqC8B;ENwqQlC;EgF90SE;IACE,gBAAA;IACA,SAAA;IACA,a1EmqC8B;EN6qQlC;AACF;Ac7ySI;EkE7CA;IACE,gBAAA;IACA,MAAA;IACA,a1EyqC8B;ENorQlC;EgF11SE;IACE,gBAAA;IACA,SAAA;IACA,a1EmqC8B;ENyrQlC;AACF;AczzSI;EkE7CA;IACE,gBAAA;IACA,MAAA;IACA,a1EyqC8B;ENgsQlC;EgFt2SE;IACE,gBAAA;IACA,SAAA;IACA,a1EmqC8B;ENqsQlC;AACF;AiF54SA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;AjF84SF;;AiF34SA;EACE,aAAA;EACA,cAAA;EACA,sBAAA;EACA,mBAAA;AjF84SF;;AkFp5SA;;ECEE,qBAAA;EACA,sBAAA;EACA,qBAAA;EACA,uBAAA;EACA,2BAAA;EACA,iCAAA;EACA,8BAAA;EACA,oBAAA;AnFu5SF;;AmFp5SE;;EACE,6BAAA;AnFw5SJ;;AmFp5SE;;EACE,2BAAA;AnFw5SJ;;AoFz6SE;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,U9E+dsC;E8E9dtC,WAAA;ApF46SJ;;AqFp7SA;ECFE,gBAAA;EACA,uBAAA;EACA,mBAAA;AtF07SF;;AuF97SA;EACE,qBAAA;EACA,mBAAA;EACA,8BjF8uB4B;EiF7uB5B,eAAA;EACA,UAAA;EACA,8BAAA;EACA,ajFuuB4B;AN0tR9B;;AwF91SU;EAeM,mCAAA;AxFm1ShB;;AwFl2SU;EAeM,8BAAA;AxFu1ShB;;AwFt2SU;EAeM,iCAAA;AxF21ShB;;AwF12SU;EAeM,iCAAA;AxF+1ShB;;AwF92SU;EAeM,sCAAA;AxFm2ShB;;AwFl3SU;EAeM,mCAAA;AxFu2ShB;;AwFt3SU;EAeM,8BAAA;AxF22ShB;;AwF13SU;EAeM,4BAAA;AxF+2ShB;;AwF93SU;EAeM,sBAAA;AxFm3ShB;;AwFl4SU;EAeM,8BAAA;AxFu3ShB;;AwFt4SU;EAeM,4BAAA;AxF23ShB;;AwF14SU;EAeM,2BAAA;AxF+3ShB;;AwF94SU;EAeM,iCAAA;AxFm4ShB;;AwFl5SU;EAeM,2BAAA;AxFu4ShB;;AwFt5SU;EAeM,qBAAA;AxF24ShB;;AwF15SU;EAeM,wBAAA;AxF+4ShB;;AwF95SU;EAeM,uBAAA;AxFm5ShB;;AwFl6SU;EAeM,wBAAA;AxFu5ShB;;AwFt6SU;EAeM,qBAAA;AxF25ShB;;AwF16SU;EAeM,yBAAA;AxF+5ShB;;AwF96SU;EAeM,2BAAA;AxFm6ShB;;AwFl7SU;EAeM,4BAAA;AxFu6ShB;;AwFt7SU;EAeM,2BAAA;AxF26ShB;;AwF17SU;EAeM,2BAAA;AxF+6ShB;;AwF97SU;EAeM,6BAAA;AxFm7ShB;;AwFl8SU;EAeM,8BAAA;AxFu7ShB;;AwFt8SU;EAeM,6BAAA;AxF27ShB;;AwF18SU;EAeM,2BAAA;AxF+7ShB;;AwF98SU;EAeM,6BAAA;AxFm8ShB;;AwFl9SU;EAeM,8BAAA;AxFu8ShB;;AwFt9SU;EAeM,6BAAA;AxF28ShB;;AwF19SU;EAeM,0BAAA;AxF+8ShB;;AwF99SU;EAeM,gCAAA;AxFm9ShB;;AwFl+SU;EAeM,yBAAA;AxFu9ShB;;AwFt+SU;EAeM,wBAAA;AxF29ShB;;AwF1+SU;EAeM,+BAAA;AxF+9ShB;;AwF9+SU;EAeM,yBAAA;AxFm+ShB;;AwFl/SU;EAeM,6BAAA;AxFu+ShB;;AwFt/SU;EAeM,8BAAA;AxF2+ShB;;AwF1/SU;EAeM,wBAAA;AxF++ShB;;AwF9/SU;EAeM,+BAAA;AxFm/ShB;;AwFlgTU;EAeM,wBAAA;AxFu/ShB;;AwFtgTU;EAeM,4CAAA;AxF2/ShB;;AwF1gTU;EAeM,+CAAA;AxF+/ShB;;AwF9gTU;EAeM,+CAAA;AxFmgThB;;AwFlhTU;EAeM,2BAAA;AxFugThB;;AwF/iTU;EACE,mFAAA;AxFkjTZ;;AwFnjTU;EACE,qFAAA;AxFsjTZ;;AwFvjTU;EACE,mFAAA;AxF0jTZ;;AwF3jTU;EACE,gFAAA;AxF8jTZ;;AwF/jTU;EACE,mFAAA;AxFkkTZ;;AwFnkTU;EACE,kFAAA;AxFskTZ;;AwFvkTU;EACE,iFAAA;AxF0kTZ;;AwF3kTU;EACE,gFAAA;AxF8kTZ;;AwFtjTU;EAeM,2BAAA;AxF2iThB;;AwF1jTU;EAeM,6BAAA;AxF+iThB;;AwF9jTU;EAeM,6BAAA;AxFmjThB;;AwFlkTU;EAeM,0BAAA;AxFujThB;;AwFtkTU;EAeM,2BAAA;AxF2jThB;;AwF1kTU;EAeM,iBAAA;AxF+jThB;;AwF9kTU;EAeM,mBAAA;AxFmkThB;;AwFllTU;EAeM,oBAAA;AxFukThB;;AwFtlTU;EAeM,oBAAA;AxF2kThB;;AwF1lTU;EAeM,sBAAA;AxF+kThB;;AwF9lTU;EAeM,uBAAA;AxFmlThB;;AwFlmTU;EAeM,gCAAA;AxFulThB;;AwFtmTU;EAeM,kCAAA;AxF2lThB;;AwF1mTU;EAeM,mCAAA;AxF+lThB;;AwF9mTU;EAeM,8BAAA;AxFmmThB;;AwFlnTU;EAeM,gCAAA;AxFumThB;;AwFtnTU;EAeM,iCAAA;AxF2mThB;;AwF1nTU;E7DzBJ,2CAAA;A3BupTN;;AwF9nTU;E7DzBJ,sCAAA;A3B2pTN;;AwFloTU;E7DzBJ,sCAAA;A3B+pTN;;AwFtoTU;EAeM,0FAAA;AxF2nThB;;AwF1oTU;EAeM,oBAAA;AxF+nThB;;AwF9oTU;EAeM,8FAAA;AxFmoThB;;AwFlpTU;EAeM,wBAAA;AxFuoThB;;AwFtpTU;EAeM,qGAAA;AxF2oThB;;AwF1pTU;EAeM,+BAAA;AxF+oThB;;AwF9pTU;EAeM,iGAAA;AxFmpThB;;AwFlqTU;EAeM,2BAAA;AxFupThB;;AwFtqTU;EAeM,uGAAA;AxF2pThB;;AwF1qTU;EAeM,iCAAA;AxF+pThB;;AwF9qTU;EAIQ,uBAAA;EAWF,gFAAA;AxFoqThB;;AwFnrTU;EAIQ,uBAAA;EAWF,kFAAA;AxFyqThB;;AwFxrTU;EAIQ,uBAAA;EAWF,gFAAA;AxF8qThB;;AwF7rTU;EAIQ,uBAAA;EAWF,6EAAA;AxFmrThB;;AwFlsTU;EAIQ,uBAAA;EAWF,gFAAA;AxFwrThB;;AwFvsTU;EAIQ,uBAAA;EAWF,+EAAA;AxF6rThB;;AwF5sTU;EAIQ,uBAAA;EAWF,8EAAA;AxFksThB;;AwFjtTU;EAIQ,uBAAA;EAWF,6EAAA;AxFusThB;;AwFttTU;EAIQ,uBAAA;EAWF,8EAAA;AxF4sThB;;AwF3tTU;EAIQ,uBAAA;EAWF,8EAAA;AxFitThB;;AwFhuTU;EAeM,oCAAA;AxFqtThB;;AwFpuTU;EAeM,oCAAA;AxFytThB;;AwFxuTU;EAeM,oCAAA;AxF6tThB;;AwF5uTU;EAeM,iCAAA;AxFiuThB;;AwFhvTU;EAeM,oCAAA;AxFquThB;;AwFpvTU;EAeM,oCAAA;AxFyuThB;;AwFxvTU;EAeM,oCAAA;AxF6uThB;;AwF5vTU;EAeM,oCAAA;AxFivThB;;AwFhwTU;EAeM,iCAAA;AxFqvThB;;AwFpwTU;EAeM,2CAAA;AxFyvThB;;AwFxwTU;EAeM,2CAAA;AxF6vThB;;AwF5wTU;EAeM,2CAAA;AxFiwThB;;AwFhxTU;EAeM,wCAAA;AxFqwThB;;AwFpxTU;EAeM,2CAAA;AxFywThB;;AwFxxTU;EAeM,2CAAA;AxF6wThB;;AwF5xTU;EAeM,2CAAA;AxFixThB;;AwFhyTU;EAeM,2CAAA;AxFqxThB;;AwFpyTU;EAeM,wCAAA;AxFyxThB;;AwFxyTU;EAeM,uCAAA;AxF6xThB;;AwF5yTU;EAeM,uCAAA;AxFiyThB;;AwFhzTU;EAeM,uCAAA;AxFqyThB;;AwFpzTU;EAeM,oCAAA;AxFyyThB;;AwFxzTU;EAeM,uCAAA;AxF6yThB;;AwF5zTU;EAeM,uCAAA;AxFizThB;;AwFh0TU;EAeM,uCAAA;AxFqzThB;;AwFp0TU;EAeM,uCAAA;AxFyzThB;;AwFx0TU;EAeM,oCAAA;AxF6zThB;;AwF50TU;EAeM,6CAAA;AxFi0ThB;;AwFh1TU;EAeM,6CAAA;AxFq0ThB;;AwFp1TU;EAeM,6CAAA;AxFy0ThB;;AwFx1TU;EAeM,0CAAA;AxF60ThB;;AwF51TU;EAeM,6CAAA;AxFi1ThB;;AwFh2TU;EAeM,6CAAA;AxFq1ThB;;AwFp2TU;EAeM,6CAAA;AxFy1ThB;;AwFx2TU;EAeM,6CAAA;AxF61ThB;;AwF52TU;EAeM,0CAAA;AxFi2ThB;;AwFh3TU;EAeM,4BAAA;AxFq2ThB;;AwFp3TU;EAeM,4BAAA;AxFy2ThB;;AwFx3TU;EAeM,4BAAA;AxF62ThB;;AwF53TU;EAeM,4BAAA;AxFi3ThB;;AwFh4TU;EAeM,4BAAA;AxFq3ThB;;AwFp4TU;EAeM,gCAAA;AxFy3ThB;;AwFx4TU;EAeM,gCAAA;AxF63ThB;;AwF54TU;EAeM,gCAAA;AxFi4ThB;;AwFh5TU;EAeM,gCAAA;AxFq4ThB;;AwFp5TU;EAeM,gCAAA;AxFy4ThB;;AwFx5TU;EAeM,uCAAA;AxF64ThB;;AwF55TU;EAeM,uCAAA;AxFi5ThB;;AwFh6TU;EAeM,uCAAA;AxFq5ThB;;AwFp6TU;EAeM,uCAAA;AxFy5ThB;;AwFx6TU;EAeM,uCAAA;AxF65ThB;;AwF56TU;EAeM,mCAAA;AxFi6ThB;;AwFh7TU;EAeM,mCAAA;AxFq6ThB;;AwFp7TU;EAeM,mCAAA;AxFy6ThB;;AwFx7TU;EAeM,mCAAA;AxF66ThB;;AwF57TU;EAeM,mCAAA;AxFi7ThB;;AwFh8TU;EAeM,yCAAA;AxFq7ThB;;AwFp8TU;EAeM,yCAAA;AxFy7ThB;;AwFx8TU;EAeM,yCAAA;AxF67ThB;;AwF58TU;EAeM,yCAAA;AxFi8ThB;;AwFh9TU;EAeM,yCAAA;AxFq8ThB;;AwFp9TU;EAeM,yDAAA;AxFy8ThB;;AwFx9TU;EAeM,2DAAA;AxF68ThB;;AwF59TU;EAeM,yDAAA;AxFi9ThB;;AwFh+TU;EAeM,sDAAA;AxFq9ThB;;AwFp+TU;EAeM,yDAAA;AxFy9ThB;;AwFx+TU;EAeM,wDAAA;AxF69ThB;;AwF5+TU;EAeM,uDAAA;AxFi+ThB;;AwFh/TU;EAeM,sDAAA;AxFq+ThB;;AwF7gUU;EACE,yBAAA;AxFghUZ;;AwFjhUU;EACE,0BAAA;AxFohUZ;;AwFrhUU;EACE,yBAAA;AxFwhUZ;;AwFzhUU;EACE,0BAAA;AxF4hUZ;;AwF7hUU;EACE,uBAAA;AxFgiUZ;;AwFxgUU;EAeM,qBAAA;AxF6/ThB;;AwF5gUU;EAeM,qBAAA;AxFigUhB;;AwFhhUU;EAeM,qBAAA;AxFqgUhB;;AwFphUU;EAeM,sBAAA;AxFygUhB;;AwFxhUU;EAeM,sBAAA;AxF6gUhB;;AwF5hUU;EAeM,0BAAA;AxFihUhB;;AwFhiUU;EAeM,uBAAA;AxFqhUhB;;AwFpiUU;EAeM,2BAAA;AxFyhUhB;;AwFxiUU;EAeM,sBAAA;AxF6hUhB;;AwF5iUU;EAeM,sBAAA;AxFiiUhB;;AwFhjUU;EAeM,sBAAA;AxFqiUhB;;AwFpjUU;EAeM,uBAAA;AxFyiUhB;;AwFxjUU;EAeM,uBAAA;AxF6iUhB;;AwF5jUU;EAeM,2BAAA;AxFijUhB;;AwFhkUU;EAeM,wBAAA;AxFqjUhB;;AwFpkUU;EAeM,4BAAA;AxFyjUhB;;AwFxkUU;EAeM,yBAAA;AxF6jUhB;;AwF5kUU;EAeM,8BAAA;AxFikUhB;;AwFhlUU;EAeM,iCAAA;AxFqkUhB;;AwFplUU;EAeM,sCAAA;AxFykUhB;;AwFxlUU;EAeM,yCAAA;AxF6kUhB;;AwF5lUU;EAeM,uBAAA;AxFilUhB;;AwFhmUU;EAeM,uBAAA;AxFqlUhB;;AwFpmUU;EAeM,yBAAA;AxFylUhB;;AwFxmUU;EAeM,yBAAA;AxF6lUhB;;AwF5mUU;EAeM,0BAAA;AxFimUhB;;AwFhnUU;EAeM,4BAAA;AxFqmUhB;;AwFpnUU;EAeM,kCAAA;AxFymUhB;;AwFxnUU;EAeM,sCAAA;AxF6mUhB;;AwF5nUU;EAeM,oCAAA;AxFinUhB;;AwFhoUU;EAeM,kCAAA;AxFqnUhB;;AwFpoUU;EAeM,yCAAA;AxFynUhB;;AwFxoUU;EAeM,wCAAA;AxF6nUhB;;AwF5oUU;EAeM,wCAAA;AxFioUhB;;AwFhpUU;EAeM,kCAAA;AxFqoUhB;;AwFppUU;EAeM,gCAAA;AxFyoUhB;;AwFxpUU;EAeM,8BAAA;AxF6oUhB;;AwF5pUU;EAeM,gCAAA;AxFipUhB;;AwFhqUU;EAeM,+BAAA;AxFqpUhB;;AwFpqUU;EAeM,oCAAA;AxFypUhB;;AwFxqUU;EAeM,kCAAA;AxF6pUhB;;AwF5qUU;EAeM,gCAAA;AxFiqUhB;;AwFhrUU;EAeM,uCAAA;AxFqqUhB;;AwFprUU;EAeM,sCAAA;AxFyqUhB;;AwFxrUU;EAeM,iCAAA;AxF6qUhB;;AwF5rUU;EAeM,2BAAA;AxFirUhB;;AwFhsUU;EAeM,iCAAA;AxFqrUhB;;AwFpsUU;EAeM,+BAAA;AxFyrUhB;;AwFxsUU;EAeM,6BAAA;AxF6rUhB;;AwF5sUU;EAeM,+BAAA;AxFisUhB;;AwFhtUU;EAeM,8BAAA;AxFqsUhB;;AwFptUU;EAeM,oBAAA;AxFysUhB;;AwFxtUU;EAeM,mBAAA;AxF6sUhB;;AwF5tUU;EAeM,mBAAA;AxFitUhB;;AwFhuUU;EAeM,mBAAA;AxFqtUhB;;AwFpuUU;EAeM,mBAAA;AxFytUhB;;AwFxuUU;EAeM,mBAAA;AxF6tUhB;;AwF5uUU;EAeM,mBAAA;AxFiuUhB;;AwFhvUU;EAeM,mBAAA;AxFquUhB;;AwFpvUU;EAeM,oBAAA;AxFyuUhB;;AwFxvUU;EAeM,0BAAA;AxF6uUhB;;AwF5vUU;EAeM,yBAAA;AxFivUhB;;AwFhwUU;EAeM,uBAAA;AxFqvUhB;;AwFpwUU;EAeM,yBAAA;AxFyvUhB;;AwFxwUU;EAeM,uBAAA;AxF6vUhB;;AwF5wUU;EAeM,uBAAA;AxFiwUhB;;AwFhxUU;EAeM,0BAAA;EAAA,yBAAA;AxFswUhB;;AwFrxUU;EAeM,gCAAA;EAAA,+BAAA;AxF2wUhB;;AwF1xUU;EAeM,+BAAA;EAAA,8BAAA;AxFgxUhB;;AwF/xUU;EAeM,6BAAA;EAAA,4BAAA;AxFqxUhB;;AwFpyUU;EAeM,+BAAA;EAAA,8BAAA;AxF0xUhB;;AwFzyUU;EAeM,6BAAA;EAAA,4BAAA;AxF+xUhB;;AwF9yUU;EAeM,6BAAA;EAAA,4BAAA;AxFoyUhB;;AwFnzUU;EAeM,wBAAA;EAAA,2BAAA;AxFyyUhB;;AwFxzUU;EAeM,8BAAA;EAAA,iCAAA;AxF8yUhB;;AwF7zUU;EAeM,6BAAA;EAAA,gCAAA;AxFmzUhB;;AwFl0UU;EAeM,2BAAA;EAAA,8BAAA;AxFwzUhB;;AwFv0UU;EAeM,6BAAA;EAAA,gCAAA;AxF6zUhB;;AwF50UU;EAeM,2BAAA;EAAA,8BAAA;AxFk0UhB;;AwFj1UU;EAeM,2BAAA;EAAA,8BAAA;AxFu0UhB;;AwFt1UU;EAeM,wBAAA;AxF20UhB;;AwF11UU;EAeM,8BAAA;AxF+0UhB;;AwF91UU;EAeM,6BAAA;AxFm1UhB;;AwFl2UU;EAeM,2BAAA;AxFu1UhB;;AwFt2UU;EAeM,6BAAA;AxF21UhB;;AwF12UU;EAeM,2BAAA;AxF+1UhB;;AwF92UU;EAeM,2BAAA;AxFm2UhB;;AwFl3UU;EAeM,+BAAA;AxFu2UhB;;AwFt3UU;EAeM,qCAAA;AxF22UhB;;AwF13UU;EAeM,oCAAA;AxF+2UhB;;AwF93UU;EAeM,kCAAA;AxFm3UhB;;AwFl4UU;EAeM,oCAAA;AxFu3UhB;;AwFt4UU;EAeM,kCAAA;AxF23UhB;;AwF14UU;EAeM,kCAAA;AxF+3UhB;;AwF94UU;EAeM,2BAAA;AxFm4UhB;;AwFl5UU;EAeM,iCAAA;AxFu4UhB;;AwFt5UU;EAeM,gCAAA;AxF24UhB;;AwF15UU;EAeM,8BAAA;AxF+4UhB;;AwF95UU;EAeM,gCAAA;AxFm5UhB;;AwFl6UU;EAeM,8BAAA;AxFu5UhB;;AwFt6UU;EAeM,8BAAA;AxF25UhB;;AwF16UU;EAeM,iCAAA;AxF+5UhB;;AwF96UU;EAeM,uCAAA;AxFm6UhB;;AwFl7UU;EAeM,sCAAA;AxFu6UhB;;AwFt7UU;EAeM,oCAAA;AxF26UhB;;AwF17UU;EAeM,sCAAA;AxF+6UhB;;AwF97UU;EAeM,oCAAA;AxFm7UhB;;AwFl8UU;EAeM,oCAAA;AxFu7UhB;;AwFt8UU;EAeM,qBAAA;AxF27UhB;;AwF18UU;EAeM,2BAAA;AxF+7UhB;;AwF98UU;EAeM,0BAAA;AxFm8UhB;;AwFl9UU;EAeM,wBAAA;AxFu8UhB;;AwFt9UU;EAeM,0BAAA;AxF28UhB;;AwF19UU;EAeM,wBAAA;AxF+8UhB;;AwF99UU;EAeM,2BAAA;EAAA,0BAAA;AxFo9UhB;;AwFn+UU;EAeM,iCAAA;EAAA,gCAAA;AxFy9UhB;;AwFx+UU;EAeM,gCAAA;EAAA,+BAAA;AxF89UhB;;AwF7+UU;EAeM,8BAAA;EAAA,6BAAA;AxFm+UhB;;AwFl/UU;EAeM,gCAAA;EAAA,+BAAA;AxFw+UhB;;AwFv/UU;EAeM,8BAAA;EAAA,6BAAA;AxF6+UhB;;AwF5/UU;EAeM,yBAAA;EAAA,4BAAA;AxFk/UhB;;AwFjgVU;EAeM,+BAAA;EAAA,kCAAA;AxFu/UhB;;AwFtgVU;EAeM,8BAAA;EAAA,iCAAA;AxF4/UhB;;AwF3gVU;EAeM,4BAAA;EAAA,+BAAA;AxFigVhB;;AwFhhVU;EAeM,8BAAA;EAAA,iCAAA;AxFsgVhB;;AwFrhVU;EAeM,4BAAA;EAAA,+BAAA;AxF2gVhB;;AwF1hVU;EAeM,yBAAA;AxF+gVhB;;AwF9hVU;EAeM,+BAAA;AxFmhVhB;;AwFliVU;EAeM,8BAAA;AxFuhVhB;;AwFtiVU;EAeM,4BAAA;AxF2hVhB;;AwF1iVU;EAeM,8BAAA;AxF+hVhB;;AwF9iVU;EAeM,4BAAA;AxFmiVhB;;AwFljVU;EAeM,gCAAA;AxFuiVhB;;AwFtjVU;EAeM,sCAAA;AxF2iVhB;;AwF1jVU;EAeM,qCAAA;AxF+iVhB;;AwF9jVU;EAeM,mCAAA;AxFmjVhB;;AwFlkVU;EAeM,qCAAA;AxFujVhB;;AwFtkVU;EAeM,mCAAA;AxF2jVhB;;AwF1kVU;EAeM,4BAAA;AxF+jVhB;;AwF9kVU;EAeM,kCAAA;AxFmkVhB;;AwFllVU;EAeM,iCAAA;AxFukVhB;;AwFtlVU;EAeM,+BAAA;AxF2kVhB;;AwF1lVU;EAeM,iCAAA;AxF+kVhB;;AwF9lVU;EAeM,+BAAA;AxFmlVhB;;AwFlmVU;EAeM,kCAAA;AxFulVhB;;AwFtmVU;EAeM,wCAAA;AxF2lVhB;;AwF1mVU;EAeM,uCAAA;AxF+lVhB;;AwF9mVU;EAeM,qCAAA;AxFmmVhB;;AwFlnVU;EAeM,uCAAA;AxFumVhB;;AwFtnVU;EAeM,qCAAA;AxF2mVhB;;AwF1nVU;EAeM,iBAAA;AxF+mVhB;;AwF9nVU;EAeM,uBAAA;AxFmnVhB;;AwFloVU;EAeM,sBAAA;AxFunVhB;;AwFtoVU;EAeM,oBAAA;AxF2nVhB;;AwF1oVU;EAeM,sBAAA;AxF+nVhB;;AwF9oVU;EAeM,oBAAA;AxFmoVhB;;AwFlpVU;EAeM,qBAAA;AxFuoVhB;;AwFtpVU;EAeM,2BAAA;AxF2oVhB;;AwF1pVU;EAeM,0BAAA;AxF+oVhB;;AwF9pVU;EAeM,wBAAA;AxFmpVhB;;AwFlqVU;EAeM,0BAAA;AxFupVhB;;AwFtqVU;EAeM,wBAAA;AxF2pVhB;;AwF1qVU;EAeM,wBAAA;AxF+pVhB;;AwF9qVU;EAeM,8BAAA;AxFmqVhB;;AwFlrVU;EAeM,6BAAA;AxFuqVhB;;AwFtrVU;EAeM,2BAAA;AxF2qVhB;;AwF1rVU;EAeM,6BAAA;AxF+qVhB;;AwF9rVU;EAeM,2BAAA;AxFmrVhB;;AwFlsVU;EAeM,iDAAA;AxFurVhB;;AwFtsVU;EAeM,4CAAA;AxF2rVhB;;AwF1sVU;EAeM,4CAAA;AxF+rVhB;;AwF9sVU;EAeM,0CAAA;AxFmsVhB;;AwFltVU;EAeM,4CAAA;AxFusVhB;;AwFttVU;EAeM,6BAAA;AxF2sVhB;;AwF1tVU;EAeM,0BAAA;AxF+sVhB;;AwF9tVU;EAeM,6BAAA;AxFmtVhB;;AwFluVU;EAeM,6BAAA;AxFutVhB;;AwFtuVU;EAeM,+BAAA;AxF2tVhB;;AwF1uVU;EAeM,2BAAA;AxF+tVhB;;AwF9uVU;EAeM,2BAAA;AxFmuVhB;;AwFlvVU;EAeM,2BAAA;AxFuuVhB;;AwFtvVU;EAeM,2BAAA;AxF2uVhB;;AwF1vVU;EAeM,2BAAA;AxF+uVhB;;AwF9vVU;EAeM,8BAAA;AxFmvVhB;;AwFlwVU;EAeM,yBAAA;AxFuvVhB;;AwFtwVU;EAeM,4BAAA;AxF2vVhB;;AwF1wVU;EAeM,2BAAA;AxF+vVhB;;AwF9wVU;EAeM,yBAAA;AxFmwVhB;;AwFlxVU;EAeM,4BAAA;AxFuwVhB;;AwFtxVU;EAeM,0BAAA;AxF2wVhB;;AwF1xVU;EAeM,6BAAA;AxF+wVhB;;AwF9xVU;EAeM,gCAAA;AxFmxVhB;;AwFlyVU;EAeM,qCAAA;AxFuxVhB;;AwFtyVU;EAeM,wCAAA;AxF2xVhB;;AwF1yVU;EAeM,oCAAA;AxF+xVhB;;AwF9yVU;EAeM,oCAAA;AxFmyVhB;;AwFlzVU;EAeM,qCAAA;AxFuyVhB;;AwFtzVU;EAeM,8BAAA;AxF2yVhB;;AwF1zVU;EAeM,8BAAA;AxF+yVhB;;AwFj2VQ,qBAAA;AAmCE;EAeM,gCAAA;EAAA,iCAAA;AxFqzVhB;;AwF/xVQ,mBAAA;AAlDE;;EAKQ,qBAAA;EAIJ,uEAAA;AxF+0Vd;;AwFx1VU;;EAKQ,qBAAA;EAIJ,yEAAA;AxFq1Vd;;AwF91VU;;EAKQ,qBAAA;EAIJ,uEAAA;AxF21Vd;;AwFp2VU;;EAKQ,qBAAA;EAIJ,oEAAA;AxFi2Vd;;AwF12VU;;EAKQ,qBAAA;EAIJ,uEAAA;AxFu2Vd;;AwFh3VU;;EAKQ,qBAAA;EAIJ,sEAAA;AxF62Vd;;AwFt3VU;;EAKQ,qBAAA;EAIJ,qEAAA;AxFm3Vd;;AwF53VU;;EAKQ,qBAAA;EAIJ,oEAAA;AxFy3Vd;;AwFl4VU;;EAKQ,qBAAA;EAIJ,qEAAA;AxF+3Vd;;AwFx4VU;;EAKQ,qBAAA;EAIJ,qEAAA;AxFq4Vd;;AwF94VU;;EAKQ,qBAAA;EAIJ,0EAAA;AxF24Vd;;AwFp5VU;;EAKQ,qBAAA;EAIJ,4CAAA;AxFi5Vd;;AwF15VU;;EAKQ,qBAAA;EAIJ,sCAAA;AxFu5Vd;;AwFh6VU;;EAKQ,qBAAA;EAIJ,0CAAA;AxF65Vd;;AwFt6VU;;EAKQ,qBAAA;EAIJ,4CAAA;AxFm6Vd;;AwF56VU;;EAKQ,qBAAA;EAIJ,2CAAA;AxFy6Vd;;AwFl7VU;;EAKQ,qBAAA;EAIJ,2CAAA;AxF+6Vd;;AwFx7VU;;EAKQ,qBAAA;EAIJ,yBAAA;AxFq7Vd;;AwF97VU;;EAKQ,qBAAA;EAIJ,kDAAA;AxF27Vd;;AwFp8VU;;EAKQ,qBAAA;EAIJ,oDAAA;AxFi8Vd;;AwF18VU;;EAKQ,qBAAA;EAIJ,6CAAA;AxFu8Vd;;AwFh9VU;;EAKQ,qBAAA;EAIJ,0CAAA;AxF68Vd;;AwFt9VU;;EAKQ,qBAAA;EAIJ,4CAAA;AxFm9Vd;;AwF59VU;;EAKQ,qBAAA;EAIJ,qCAAA;AxFy9Vd;;AwF9+VU;EACE,wBAAA;AxFi/VZ;;AwFl/VU;EACE,uBAAA;AxFq/VZ;;AwFt/VU;EACE,wBAAA;AxFy/VZ;;AwF1/VU;EACE,qBAAA;AxF6/VZ;;AwFr+VU;EAeM,kDAAA;AxF09VhB;;AwFz+VU;EAeM,oDAAA;AxF89VhB;;AwF7+VU;EAeM,kDAAA;AxFk+VhB;;AwFj/VU;EAeM,+CAAA;AxFs+VhB;;AwFr/VU;EAeM,kDAAA;AxF0+VhB;;AwFz/VU;EAeM,iDAAA;AxF8+VhB;;AwF7/VU;EAeM,gDAAA;AxFk/VhB;;AwFjgWU;EAeM,+CAAA;AxFs/VhB;;AwF9hWU;EACE,uBAAA;AxFiiWZ;;AwF5hWU;EACE,uBAAA;AxF+hWZ;;AwFtiWU;EACE,wBAAA;AxFyiWZ;;AwFpiWU;EACE,wBAAA;AxFuiWZ;;AwF9iWU;EACE,uBAAA;AxFijWZ;;AwF5iWU;EACE,uBAAA;AxF+iWZ;;AwFtjWU;EACE,wBAAA;AxFyjWZ;;AwFpjWU;EACE,wBAAA;AxFujWZ;;AwF9jWU;EACE,qBAAA;AxFikWZ;;AwF5jWU;EACE,qBAAA;AxF+jWZ;;AwF7iWU;EAeM,yCAAA;AxFkiWhB;;AwF3hWU;EAQI,yCAAA;AxFuhWd;;AwFrjWU;EAeM,wCAAA;AxF0iWhB;;AwFniWU;EAQI,wCAAA;AxF+hWd;;AwF7jWU;EAeM,yCAAA;AxFkjWhB;;AwF3iWU;EAQI,yCAAA;AxFuiWd;;AwFrkWU;EAIQ,+BAAA;EAWF,iGAAA;AxF2jWhB;;AwF1kWU;EAIQ,+BAAA;EAWF,mGAAA;AxFgkWhB;;AwF/kWU;EAIQ,+BAAA;EAWF,iGAAA;AxFqkWhB;;AwFplWU;EAIQ,+BAAA;EAWF,8FAAA;AxF0kWhB;;AwFzlWU;EAIQ,+BAAA;EAWF,iGAAA;AxF+kWhB;;AwF9lWU;EAIQ,+BAAA;EAWF,gGAAA;AxFolWhB;;AwFnmWU;EAIQ,+BAAA;EAWF,+FAAA;AxFylWhB;;AwFxmWU;EAIQ,+BAAA;EAWF,8FAAA;AxF8lWhB;;AwF7mWU;EAIQ,+BAAA;EAWF,uGAAA;AxFmmWhB;;AwF3oWU;EACE,+BAAA;AxF8oWZ;;AwFzoWU;EACE,+BAAA;AxF4oWZ;;AwFnpWU;EACE,iCAAA;AxFspWZ;;AwFjpWU;EACE,iCAAA;AxFopWZ;;AwF3pWU;EACE,kCAAA;AxF8pWZ;;AwFzpWU;EACE,kCAAA;AxF4pWZ;;AwFnqWU;EACE,iCAAA;AxFsqWZ;;AwFjqWU;EACE,iCAAA;AxFoqWZ;;AwF3qWU;EACE,kCAAA;AxF8qWZ;;AwFzqWU;EACE,kCAAA;AxF4qWZ;;AwFnrWU;EACE,+BAAA;AxFsrWZ;;AwFjrWU;EACE,+BAAA;AxForWZ;;AwF/qWU;;EAKQ,mBAAA;EAIJ,gFAAA;AxF4qWd;;AwFrrWU;;EAKQ,mBAAA;EAIJ,kFAAA;AxFkrWd;;AwF3rWU;;EAKQ,mBAAA;EAIJ,gFAAA;AxFwrWd;;AwFjsWU;;EAKQ,mBAAA;EAIJ,6EAAA;AxF8rWd;;AwFvsWU;;EAKQ,mBAAA;EAIJ,gFAAA;AxFosWd;;AwF7sWU;;EAKQ,mBAAA;EAIJ,+EAAA;AxF0sWd;;AwFntWU;;EAKQ,mBAAA;EAIJ,8EAAA;AxFgtWd;;AwFztWU;;EAKQ,mBAAA;EAIJ,6EAAA;AxFstWd;;AwF/tWU;;EAKQ,mBAAA;EAIJ,8EAAA;AxF4tWd;;AwFruWU;;EAKQ,mBAAA;EAIJ,8EAAA;AxFkuWd;;AwF3uWU;;EAKQ,mBAAA;EAIJ,gFAAA;AxFwuWd;;AwFjvWU;;EAKQ,mBAAA;EAIJ,wCAAA;AxF8uWd;;AwFvvWU;;EAKQ,mBAAA;EAIJ,qFAAA;AxFovWd;;AwF7vWU;;EAKQ,mBAAA;EAIJ,oFAAA;AxF0vWd;;AwF/wWU;EACE,qBAAA;AxFkxWZ;;AwFnxWU;EACE,sBAAA;AxFsxWZ;;AwFvxWU;EACE,qBAAA;AxF0xWZ;;AwF3xWU;EACE,sBAAA;AxF8xWZ;;AwF/xWU;EACE,mBAAA;AxFkyWZ;;AwFvxWU;;EASI,yDAAA;AxFmxWd;;AwF5xWU;;EASI,2DAAA;AxFwxWd;;AwFjyWU;;EASI,yDAAA;AxF6xWd;;AwFtyWU;;EASI,sDAAA;AxFkyWd;;AwF3yWU;;EASI,yDAAA;AxFuyWd;;AwFhzWU;;EASI,wDAAA;AxF4yWd;;AwFrzWU;;EASI,uDAAA;AxFizWd;;AwF1zWU;;EASI,sDAAA;AxFszWd;;AwFlzWU;EAeM,gDAAA;AxFuyWhB;;AwFtzWU;EAeM,mCAAA;UAAA,2BAAA;AxF2yWhB;;AwF1zWU;EAeM,oCAAA;UAAA,4BAAA;AxF+yWhB;;AwF9zWU;EAeM,oCAAA;UAAA,4BAAA;AxFmzWhB;;AwFl0WU;EAeM,+BAAA;AxFuzWhB;;AwFt0WU;EAeM,+BAAA;AxF2zWhB;;AwF10WU;EAeM,kDAAA;AxF+zWhB;;AwF90WU;EAeM,2BAAA;AxFm0WhB;;AwFl1WU;EAeM,qDAAA;AxFu0WhB;;AwFt1WU;EAeM,kDAAA;AxF20WhB;;AwF11WU;EAeM,qDAAA;AxF+0WhB;;AwF91WU;EAeM,qDAAA;AxFm1WhB;;AwFl2WU;EAeM,sDAAA;AxFu1WhB;;AwFt2WU;EAeM,6BAAA;AxF21WhB;;AwF12WU;EAeM,uDAAA;AxF+1WhB;;AwF92WU;EAeM,2DAAA;EAAA,4DAAA;AxFo2WhB;;AwFn3WU;EAeM,oCAAA;EAAA,qCAAA;AxFy2WhB;;AwFx3WU;EAeM,8DAAA;EAAA,+DAAA;AxF82WhB;;AwF73WU;EAeM,2DAAA;EAAA,4DAAA;AxFm3WhB;;AwFl4WU;EAeM,8DAAA;EAAA,+DAAA;AxFw3WhB;;AwFv4WU;EAeM,8DAAA;EAAA,+DAAA;AxF63WhB;;AwF54WU;EAeM,+DAAA;EAAA,gEAAA;AxFk4WhB;;AwFj5WU;EAeM,sCAAA;EAAA,uCAAA;AxFu4WhB;;AwFt5WU;EAeM,gEAAA;EAAA,iEAAA;AxF44WhB;;AwF35WU;EAeM,4DAAA;EAAA,0DAAA;AxFi5WhB;;AwFh6WU;EAeM,qCAAA;EAAA,mCAAA;AxFs5WhB;;AwFr6WU;EAeM,+DAAA;EAAA,6DAAA;AxF25WhB;;AwF16WU;EAeM,4DAAA;EAAA,0DAAA;AxFg6WhB;;AwF/6WU;EAeM,+DAAA;EAAA,6DAAA;AxFq6WhB;;AwFp7WU;EAeM,+DAAA;EAAA,6DAAA;AxF06WhB;;AwFz7WU;EAeM,gEAAA;EAAA,8DAAA;AxF+6WhB;;AwF97WU;EAeM,uCAAA;EAAA,qCAAA;AxFo7WhB;;AwFn8WU;EAeM,iEAAA;EAAA,+DAAA;AxFy7WhB;;AwFx8WU;EAeM,+DAAA;EAAA,8DAAA;AxF87WhB;;AwF78WU;EAeM,wCAAA;EAAA,uCAAA;AxFm8WhB;;AwFl9WU;EAeM,kEAAA;EAAA,iEAAA;AxFw8WhB;;AwFv9WU;EAeM,+DAAA;EAAA,8DAAA;AxF68WhB;;AwF59WU;EAeM,kEAAA;EAAA,iEAAA;AxFk9WhB;;AwFj+WU;EAeM,kEAAA;EAAA,iEAAA;AxFu9WhB;;AwFt+WU;EAeM,mEAAA;EAAA,kEAAA;AxF49WhB;;AwF3+WU;EAeM,0CAAA;EAAA,yCAAA;AxFi+WhB;;AwFh/WU;EAeM,oEAAA;EAAA,mEAAA;AxFs+WhB;;AwFr/WU;EAeM,4DAAA;EAAA,8DAAA;AxF2+WhB;;AwF1/WU;EAeM,qCAAA;EAAA,uCAAA;AxFg/WhB;;AwF//WU;EAeM,+DAAA;EAAA,iEAAA;AxFq/WhB;;AwFpgXU;EAeM,4DAAA;EAAA,8DAAA;AxF0/WhB;;AwFzgXU;EAeM,+DAAA;EAAA,iEAAA;AxF+/WhB;;AwF9gXU;EAeM,+DAAA;EAAA,iEAAA;AxFogXhB;;AwFnhXU;EAeM,gEAAA;EAAA,kEAAA;AxFygXhB;;AwFxhXU;EAeM,uCAAA;EAAA,yCAAA;AxF8gXhB;;AwF7hXU;EAeM,iEAAA;EAAA,mEAAA;AxFmhXhB;;AwFliXU;EAeM,8BAAA;AxFuhXhB;;AwFtiXU;EAeM,6BAAA;AxF2hXhB;;AwF1iXU;EAeM,sBAAA;AxF+hXhB;;AwF9iXU;EAeM,qBAAA;AxFmiXhB;;AwFljXU;EAeM,qBAAA;AxFuiXhB;;AwFtjXU;EAeM,qBAAA;AxF2iXhB;;AwF1jXU;EAeM,qBAAA;AxF+iXhB;;AclmXI;E0EoCM;IAeM,8BAAA;ExFojXd;EwFnkXQ;IAeM,4BAAA;ExFujXd;EwFtkXQ;IAeM,sBAAA;ExF0jXd;EwFzkXQ;IAeM,8BAAA;ExF6jXd;EwF5kXQ;IAeM,4BAAA;ExFgkXd;EwF/kXQ;IAeM,2BAAA;ExFmkXd;EwFllXQ;IAeM,iCAAA;ExFskXd;EwFrlXQ;IAeM,2BAAA;ExFykXd;EwFxlXQ;IAeM,0BAAA;ExF4kXd;EwF3lXQ;IAeM,gCAAA;ExF+kXd;EwF9lXQ;IAeM,yBAAA;ExFklXd;EwFjmXQ;IAeM,wBAAA;ExFqlXd;EwFpmXQ;IAeM,+BAAA;ExFwlXd;EwFvmXQ;IAeM,yBAAA;ExF2lXd;EwF1mXQ;IAeM,6BAAA;ExF8lXd;EwF7mXQ;IAeM,8BAAA;ExFimXd;EwFhnXQ;IAeM,wBAAA;ExFomXd;EwFnnXQ;IAeM,+BAAA;ExFumXd;EwFtnXQ;IAeM,wBAAA;ExF0mXd;EwFznXQ;IAeM,yBAAA;ExF6mXd;EwF5nXQ;IAeM,8BAAA;ExFgnXd;EwF/nXQ;IAeM,iCAAA;ExFmnXd;EwFloXQ;IAeM,sCAAA;ExFsnXd;EwFroXQ;IAeM,yCAAA;ExFynXd;EwFxoXQ;IAeM,uBAAA;ExF4nXd;EwF3oXQ;IAeM,uBAAA;ExF+nXd;EwF9oXQ;IAeM,yBAAA;ExFkoXd;EwFjpXQ;IAeM,yBAAA;ExFqoXd;EwFppXQ;IAeM,0BAAA;ExFwoXd;EwFvpXQ;IAeM,4BAAA;ExF2oXd;EwF1pXQ;IAeM,kCAAA;ExF8oXd;EwF7pXQ;IAeM,sCAAA;ExFipXd;EwFhqXQ;IAeM,oCAAA;ExFopXd;EwFnqXQ;IAeM,kCAAA;ExFupXd;EwFtqXQ;IAeM,yCAAA;ExF0pXd;EwFzqXQ;IAeM,wCAAA;ExF6pXd;EwF5qXQ;IAeM,wCAAA;ExFgqXd;EwF/qXQ;IAeM,kCAAA;ExFmqXd;EwFlrXQ;IAeM,gCAAA;ExFsqXd;EwFrrXQ;IAeM,8BAAA;ExFyqXd;EwFxrXQ;IAeM,gCAAA;ExF4qXd;EwF3rXQ;IAeM,+BAAA;ExF+qXd;EwF9rXQ;IAeM,oCAAA;ExFkrXd;EwFjsXQ;IAeM,kCAAA;ExFqrXd;EwFpsXQ;IAeM,gCAAA;ExFwrXd;EwFvsXQ;IAeM,uCAAA;ExF2rXd;EwF1sXQ;IAeM,sCAAA;ExF8rXd;EwF7sXQ;IAeM,iCAAA;ExFisXd;EwFhtXQ;IAeM,2BAAA;ExFosXd;EwFntXQ;IAeM,iCAAA;ExFusXd;EwFttXQ;IAeM,+BAAA;ExF0sXd;EwFztXQ;IAeM,6BAAA;ExF6sXd;EwF5tXQ;IAeM,+BAAA;ExFgtXd;EwF/tXQ;IAeM,8BAAA;ExFmtXd;EwFluXQ;IAeM,oBAAA;ExFstXd;EwFruXQ;IAeM,mBAAA;ExFytXd;EwFxuXQ;IAeM,mBAAA;ExF4tXd;EwF3uXQ;IAeM,mBAAA;ExF+tXd;EwF9uXQ;IAeM,mBAAA;ExFkuXd;EwFjvXQ;IAeM,mBAAA;ExFquXd;EwFpvXQ;IAeM,mBAAA;ExFwuXd;EwFvvXQ;IAeM,mBAAA;ExF2uXd;EwF1vXQ;IAeM,oBAAA;ExF8uXd;EwF7vXQ;IAeM,0BAAA;ExFivXd;EwFhwXQ;IAeM,yBAAA;ExFovXd;EwFnwXQ;IAeM,uBAAA;ExFuvXd;EwFtwXQ;IAeM,yBAAA;ExF0vXd;EwFzwXQ;IAeM,uBAAA;ExF6vXd;EwF5wXQ;IAeM,uBAAA;ExFgwXd;EwF/wXQ;IAeM,0BAAA;IAAA,yBAAA;ExFowXd;EwFnxXQ;IAeM,gCAAA;IAAA,+BAAA;ExFwwXd;EwFvxXQ;IAeM,+BAAA;IAAA,8BAAA;ExF4wXd;EwF3xXQ;IAeM,6BAAA;IAAA,4BAAA;ExFgxXd;EwF/xXQ;IAeM,+BAAA;IAAA,8BAAA;ExFoxXd;EwFnyXQ;IAeM,6BAAA;IAAA,4BAAA;ExFwxXd;EwFvyXQ;IAeM,6BAAA;IAAA,4BAAA;ExF4xXd;EwF3yXQ;IAeM,wBAAA;IAAA,2BAAA;ExFgyXd;EwF/yXQ;IAeM,8BAAA;IAAA,iCAAA;ExFoyXd;EwFnzXQ;IAeM,6BAAA;IAAA,gCAAA;ExFwyXd;EwFvzXQ;IAeM,2BAAA;IAAA,8BAAA;ExF4yXd;EwF3zXQ;IAeM,6BAAA;IAAA,gCAAA;ExFgzXd;EwF/zXQ;IAeM,2BAAA;IAAA,8BAAA;ExFozXd;EwFn0XQ;IAeM,2BAAA;IAAA,8BAAA;ExFwzXd;EwFv0XQ;IAeM,wBAAA;ExF2zXd;EwF10XQ;IAeM,8BAAA;ExF8zXd;EwF70XQ;IAeM,6BAAA;ExFi0Xd;EwFh1XQ;IAeM,2BAAA;ExFo0Xd;EwFn1XQ;IAeM,6BAAA;ExFu0Xd;EwFt1XQ;IAeM,2BAAA;ExF00Xd;EwFz1XQ;IAeM,2BAAA;ExF60Xd;EwF51XQ;IAeM,+BAAA;ExFg1Xd;EwF/1XQ;IAeM,qCAAA;ExFm1Xd;EwFl2XQ;IAeM,oCAAA;ExFs1Xd;EwFr2XQ;IAeM,kCAAA;ExFy1Xd;EwFx2XQ;IAeM,oCAAA;ExF41Xd;EwF32XQ;IAeM,kCAAA;ExF+1Xd;EwF92XQ;IAeM,kCAAA;ExFk2Xd;EwFj3XQ;IAeM,2BAAA;ExFq2Xd;EwFp3XQ;IAeM,iCAAA;ExFw2Xd;EwFv3XQ;IAeM,gCAAA;ExF22Xd;EwF13XQ;IAeM,8BAAA;ExF82Xd;EwF73XQ;IAeM,gCAAA;ExFi3Xd;EwFh4XQ;IAeM,8BAAA;ExFo3Xd;EwFn4XQ;IAeM,8BAAA;ExFu3Xd;EwFt4XQ;IAeM,iCAAA;ExF03Xd;EwFz4XQ;IAeM,uCAAA;ExF63Xd;EwF54XQ;IAeM,sCAAA;ExFg4Xd;EwF/4XQ;IAeM,oCAAA;ExFm4Xd;EwFl5XQ;IAeM,sCAAA;ExFs4Xd;EwFr5XQ;IAeM,oCAAA;ExFy4Xd;EwFx5XQ;IAeM,oCAAA;ExF44Xd;EwF35XQ;IAeM,qBAAA;ExF+4Xd;EwF95XQ;IAeM,2BAAA;ExFk5Xd;EwFj6XQ;IAeM,0BAAA;ExFq5Xd;EwFp6XQ;IAeM,wBAAA;ExFw5Xd;EwFv6XQ;IAeM,0BAAA;ExF25Xd;EwF16XQ;IAeM,wBAAA;ExF85Xd;EwF76XQ;IAeM,2BAAA;IAAA,0BAAA;ExFk6Xd;EwFj7XQ;IAeM,iCAAA;IAAA,gCAAA;ExFs6Xd;EwFr7XQ;IAeM,gCAAA;IAAA,+BAAA;ExF06Xd;EwFz7XQ;IAeM,8BAAA;IAAA,6BAAA;ExF86Xd;EwF77XQ;IAeM,gCAAA;IAAA,+BAAA;ExFk7Xd;EwFj8XQ;IAeM,8BAAA;IAAA,6BAAA;ExFs7Xd;EwFr8XQ;IAeM,yBAAA;IAAA,4BAAA;ExF07Xd;EwFz8XQ;IAeM,+BAAA;IAAA,kCAAA;ExF87Xd;EwF78XQ;IAeM,8BAAA;IAAA,iCAAA;ExFk8Xd;EwFj9XQ;IAeM,4BAAA;IAAA,+BAAA;ExFs8Xd;EwFr9XQ;IAeM,8BAAA;IAAA,iCAAA;ExF08Xd;EwFz9XQ;IAeM,4BAAA;IAAA,+BAAA;ExF88Xd;EwF79XQ;IAeM,yBAAA;ExFi9Xd;EwFh+XQ;IAeM,+BAAA;ExFo9Xd;EwFn+XQ;IAeM,8BAAA;ExFu9Xd;EwFt+XQ;IAeM,4BAAA;ExF09Xd;EwFz+XQ;IAeM,8BAAA;ExF69Xd;EwF5+XQ;IAeM,4BAAA;ExFg+Xd;EwF/+XQ;IAeM,gCAAA;ExFm+Xd;EwFl/XQ;IAeM,sCAAA;ExFs+Xd;EwFr/XQ;IAeM,qCAAA;ExFy+Xd;EwFx/XQ;IAeM,mCAAA;ExF4+Xd;EwF3/XQ;IAeM,qCAAA;ExF++Xd;EwF9/XQ;IAeM,mCAAA;ExFk/Xd;EwFjgYQ;IAeM,4BAAA;ExFq/Xd;EwFpgYQ;IAeM,kCAAA;ExFw/Xd;EwFvgYQ;IAeM,iCAAA;ExF2/Xd;EwF1gYQ;IAeM,+BAAA;ExF8/Xd;EwF7gYQ;IAeM,iCAAA;ExFigYd;EwFhhYQ;IAeM,+BAAA;ExFogYd;EwFnhYQ;IAeM,kCAAA;ExFugYd;EwFthYQ;IAeM,wCAAA;ExF0gYd;EwFzhYQ;IAeM,uCAAA;ExF6gYd;EwF5hYQ;IAeM,qCAAA;ExFghYd;EwF/hYQ;IAeM,uCAAA;ExFmhYd;EwFliYQ;IAeM,qCAAA;ExFshYd;EwFriYQ;IAeM,iBAAA;ExFyhYd;EwFxiYQ;IAeM,uBAAA;ExF4hYd;EwF3iYQ;IAeM,sBAAA;ExF+hYd;EwF9iYQ;IAeM,oBAAA;ExFkiYd;EwFjjYQ;IAeM,sBAAA;ExFqiYd;EwFpjYQ;IAeM,oBAAA;ExFwiYd;EwFvjYQ;IAeM,qBAAA;ExF2iYd;EwF1jYQ;IAeM,2BAAA;ExF8iYd;EwF7jYQ;IAeM,0BAAA;ExFijYd;EwFhkYQ;IAeM,wBAAA;ExFojYd;EwFnkYQ;IAeM,0BAAA;ExFujYd;EwFtkYQ;IAeM,wBAAA;ExF0jYd;EwFzkYQ;IAeM,wBAAA;ExF6jYd;EwF5kYQ;IAeM,8BAAA;ExFgkYd;EwF/kYQ;IAeM,6BAAA;ExFmkYd;EwFllYQ;IAeM,2BAAA;ExFskYd;EwFrlYQ;IAeM,6BAAA;ExFykYd;EwFxlYQ;IAeM,2BAAA;ExF4kYd;EwF3lYQ;IAeM,4BAAA;ExF+kYd;EwF9lYQ;IAeM,0BAAA;ExFklYd;EwFjmYQ;IAeM,6BAAA;ExFqlYd;AACF;AczoYI;E0EoCM;IAeM,8BAAA;ExF0lYd;EwFzmYQ;IAeM,4BAAA;ExF6lYd;EwF5mYQ;IAeM,sBAAA;ExFgmYd;EwF/mYQ;IAeM,8BAAA;ExFmmYd;EwFlnYQ;IAeM,4BAAA;ExFsmYd;EwFrnYQ;IAeM,2BAAA;ExFymYd;EwFxnYQ;IAeM,iCAAA;ExF4mYd;EwF3nYQ;IAeM,2BAAA;ExF+mYd;EwF9nYQ;IAeM,0BAAA;ExFknYd;EwFjoYQ;IAeM,gCAAA;ExFqnYd;EwFpoYQ;IAeM,yBAAA;ExFwnYd;EwFvoYQ;IAeM,wBAAA;ExF2nYd;EwF1oYQ;IAeM,+BAAA;ExF8nYd;EwF7oYQ;IAeM,yBAAA;ExFioYd;EwFhpYQ;IAeM,6BAAA;ExFooYd;EwFnpYQ;IAeM,8BAAA;ExFuoYd;EwFtpYQ;IAeM,wBAAA;ExF0oYd;EwFzpYQ;IAeM,+BAAA;ExF6oYd;EwF5pYQ;IAeM,wBAAA;ExFgpYd;EwF/pYQ;IAeM,yBAAA;ExFmpYd;EwFlqYQ;IAeM,8BAAA;ExFspYd;EwFrqYQ;IAeM,iCAAA;ExFypYd;EwFxqYQ;IAeM,sCAAA;ExF4pYd;EwF3qYQ;IAeM,yCAAA;ExF+pYd;EwF9qYQ;IAeM,uBAAA;ExFkqYd;EwFjrYQ;IAeM,uBAAA;ExFqqYd;EwFprYQ;IAeM,yBAAA;ExFwqYd;EwFvrYQ;IAeM,yBAAA;ExF2qYd;EwF1rYQ;IAeM,0BAAA;ExF8qYd;EwF7rYQ;IAeM,4BAAA;ExFirYd;EwFhsYQ;IAeM,kCAAA;ExForYd;EwFnsYQ;IAeM,sCAAA;ExFurYd;EwFtsYQ;IAeM,oCAAA;ExF0rYd;EwFzsYQ;IAeM,kCAAA;ExF6rYd;EwF5sYQ;IAeM,yCAAA;ExFgsYd;EwF/sYQ;IAeM,wCAAA;ExFmsYd;EwFltYQ;IAeM,wCAAA;ExFssYd;EwFrtYQ;IAeM,kCAAA;ExFysYd;EwFxtYQ;IAeM,gCAAA;ExF4sYd;EwF3tYQ;IAeM,8BAAA;ExF+sYd;EwF9tYQ;IAeM,gCAAA;ExFktYd;EwFjuYQ;IAeM,+BAAA;ExFqtYd;EwFpuYQ;IAeM,oCAAA;ExFwtYd;EwFvuYQ;IAeM,kCAAA;ExF2tYd;EwF1uYQ;IAeM,gCAAA;ExF8tYd;EwF7uYQ;IAeM,uCAAA;ExFiuYd;EwFhvYQ;IAeM,sCAAA;ExFouYd;EwFnvYQ;IAeM,iCAAA;ExFuuYd;EwFtvYQ;IAeM,2BAAA;ExF0uYd;EwFzvYQ;IAeM,iCAAA;ExF6uYd;EwF5vYQ;IAeM,+BAAA;ExFgvYd;EwF/vYQ;IAeM,6BAAA;ExFmvYd;EwFlwYQ;IAeM,+BAAA;ExFsvYd;EwFrwYQ;IAeM,8BAAA;ExFyvYd;EwFxwYQ;IAeM,oBAAA;ExF4vYd;EwF3wYQ;IAeM,mBAAA;ExF+vYd;EwF9wYQ;IAeM,mBAAA;ExFkwYd;EwFjxYQ;IAeM,mBAAA;ExFqwYd;EwFpxYQ;IAeM,mBAAA;ExFwwYd;EwFvxYQ;IAeM,mBAAA;ExF2wYd;EwF1xYQ;IAeM,mBAAA;ExF8wYd;EwF7xYQ;IAeM,mBAAA;ExFixYd;EwFhyYQ;IAeM,oBAAA;ExFoxYd;EwFnyYQ;IAeM,0BAAA;ExFuxYd;EwFtyYQ;IAeM,yBAAA;ExF0xYd;EwFzyYQ;IAeM,uBAAA;ExF6xYd;EwF5yYQ;IAeM,yBAAA;ExFgyYd;EwF/yYQ;IAeM,uBAAA;ExFmyYd;EwFlzYQ;IAeM,uBAAA;ExFsyYd;EwFrzYQ;IAeM,0BAAA;IAAA,yBAAA;ExF0yYd;EwFzzYQ;IAeM,gCAAA;IAAA,+BAAA;ExF8yYd;EwF7zYQ;IAeM,+BAAA;IAAA,8BAAA;ExFkzYd;EwFj0YQ;IAeM,6BAAA;IAAA,4BAAA;ExFszYd;EwFr0YQ;IAeM,+BAAA;IAAA,8BAAA;ExF0zYd;EwFz0YQ;IAeM,6BAAA;IAAA,4BAAA;ExF8zYd;EwF70YQ;IAeM,6BAAA;IAAA,4BAAA;ExFk0Yd;EwFj1YQ;IAeM,wBAAA;IAAA,2BAAA;ExFs0Yd;EwFr1YQ;IAeM,8BAAA;IAAA,iCAAA;ExF00Yd;EwFz1YQ;IAeM,6BAAA;IAAA,gCAAA;ExF80Yd;EwF71YQ;IAeM,2BAAA;IAAA,8BAAA;ExFk1Yd;EwFj2YQ;IAeM,6BAAA;IAAA,gCAAA;ExFs1Yd;EwFr2YQ;IAeM,2BAAA;IAAA,8BAAA;ExF01Yd;EwFz2YQ;IAeM,2BAAA;IAAA,8BAAA;ExF81Yd;EwF72YQ;IAeM,wBAAA;ExFi2Yd;EwFh3YQ;IAeM,8BAAA;ExFo2Yd;EwFn3YQ;IAeM,6BAAA;ExFu2Yd;EwFt3YQ;IAeM,2BAAA;ExF02Yd;EwFz3YQ;IAeM,6BAAA;ExF62Yd;EwF53YQ;IAeM,2BAAA;ExFg3Yd;EwF/3YQ;IAeM,2BAAA;ExFm3Yd;EwFl4YQ;IAeM,+BAAA;ExFs3Yd;EwFr4YQ;IAeM,qCAAA;ExFy3Yd;EwFx4YQ;IAeM,oCAAA;ExF43Yd;EwF34YQ;IAeM,kCAAA;ExF+3Yd;EwF94YQ;IAeM,oCAAA;ExFk4Yd;EwFj5YQ;IAeM,kCAAA;ExFq4Yd;EwFp5YQ;IAeM,kCAAA;ExFw4Yd;EwFv5YQ;IAeM,2BAAA;ExF24Yd;EwF15YQ;IAeM,iCAAA;ExF84Yd;EwF75YQ;IAeM,gCAAA;ExFi5Yd;EwFh6YQ;IAeM,8BAAA;ExFo5Yd;EwFn6YQ;IAeM,gCAAA;ExFu5Yd;EwFt6YQ;IAeM,8BAAA;ExF05Yd;EwFz6YQ;IAeM,8BAAA;ExF65Yd;EwF56YQ;IAeM,iCAAA;ExFg6Yd;EwF/6YQ;IAeM,uCAAA;ExFm6Yd;EwFl7YQ;IAeM,sCAAA;ExFs6Yd;EwFr7YQ;IAeM,oCAAA;ExFy6Yd;EwFx7YQ;IAeM,sCAAA;ExF46Yd;EwF37YQ;IAeM,oCAAA;ExF+6Yd;EwF97YQ;IAeM,oCAAA;ExFk7Yd;EwFj8YQ;IAeM,qBAAA;ExFq7Yd;EwFp8YQ;IAeM,2BAAA;ExFw7Yd;EwFv8YQ;IAeM,0BAAA;ExF27Yd;EwF18YQ;IAeM,wBAAA;ExF87Yd;EwF78YQ;IAeM,0BAAA;ExFi8Yd;EwFh9YQ;IAeM,wBAAA;ExFo8Yd;EwFn9YQ;IAeM,2BAAA;IAAA,0BAAA;ExFw8Yd;EwFv9YQ;IAeM,iCAAA;IAAA,gCAAA;ExF48Yd;EwF39YQ;IAeM,gCAAA;IAAA,+BAAA;ExFg9Yd;EwF/9YQ;IAeM,8BAAA;IAAA,6BAAA;ExFo9Yd;EwFn+YQ;IAeM,gCAAA;IAAA,+BAAA;ExFw9Yd;EwFv+YQ;IAeM,8BAAA;IAAA,6BAAA;ExF49Yd;EwF3+YQ;IAeM,yBAAA;IAAA,4BAAA;ExFg+Yd;EwF/+YQ;IAeM,+BAAA;IAAA,kCAAA;ExFo+Yd;EwFn/YQ;IAeM,8BAAA;IAAA,iCAAA;ExFw+Yd;EwFv/YQ;IAeM,4BAAA;IAAA,+BAAA;ExF4+Yd;EwF3/YQ;IAeM,8BAAA;IAAA,iCAAA;ExFg/Yd;EwF//YQ;IAeM,4BAAA;IAAA,+BAAA;ExFo/Yd;EwFngZQ;IAeM,yBAAA;ExFu/Yd;EwFtgZQ;IAeM,+BAAA;ExF0/Yd;EwFzgZQ;IAeM,8BAAA;ExF6/Yd;EwF5gZQ;IAeM,4BAAA;ExFggZd;EwF/gZQ;IAeM,8BAAA;ExFmgZd;EwFlhZQ;IAeM,4BAAA;ExFsgZd;EwFrhZQ;IAeM,gCAAA;ExFygZd;EwFxhZQ;IAeM,sCAAA;ExF4gZd;EwF3hZQ;IAeM,qCAAA;ExF+gZd;EwF9hZQ;IAeM,mCAAA;ExFkhZd;EwFjiZQ;IAeM,qCAAA;ExFqhZd;EwFpiZQ;IAeM,mCAAA;ExFwhZd;EwFviZQ;IAeM,4BAAA;ExF2hZd;EwF1iZQ;IAeM,kCAAA;ExF8hZd;EwF7iZQ;IAeM,iCAAA;ExFiiZd;EwFhjZQ;IAeM,+BAAA;ExFoiZd;EwFnjZQ;IAeM,iCAAA;ExFuiZd;EwFtjZQ;IAeM,+BAAA;ExF0iZd;EwFzjZQ;IAeM,kCAAA;ExF6iZd;EwF5jZQ;IAeM,wCAAA;ExFgjZd;EwF/jZQ;IAeM,uCAAA;ExFmjZd;EwFlkZQ;IAeM,qCAAA;ExFsjZd;EwFrkZQ;IAeM,uCAAA;ExFyjZd;EwFxkZQ;IAeM,qCAAA;ExF4jZd;EwF3kZQ;IAeM,iBAAA;ExF+jZd;EwF9kZQ;IAeM,uBAAA;ExFkkZd;EwFjlZQ;IAeM,sBAAA;ExFqkZd;EwFplZQ;IAeM,oBAAA;ExFwkZd;EwFvlZQ;IAeM,sBAAA;ExF2kZd;EwF1lZQ;IAeM,oBAAA;ExF8kZd;EwF7lZQ;IAeM,qBAAA;ExFilZd;EwFhmZQ;IAeM,2BAAA;ExFolZd;EwFnmZQ;IAeM,0BAAA;ExFulZd;EwFtmZQ;IAeM,wBAAA;ExF0lZd;EwFzmZQ;IAeM,0BAAA;ExF6lZd;EwF5mZQ;IAeM,wBAAA;ExFgmZd;EwF/mZQ;IAeM,wBAAA;ExFmmZd;EwFlnZQ;IAeM,8BAAA;ExFsmZd;EwFrnZQ;IAeM,6BAAA;ExFymZd;EwFxnZQ;IAeM,2BAAA;ExF4mZd;EwF3nZQ;IAeM,6BAAA;ExF+mZd;EwF9nZQ;IAeM,2BAAA;ExFknZd;EwFjoZQ;IAeM,4BAAA;ExFqnZd;EwFpoZQ;IAeM,0BAAA;ExFwnZd;EwFvoZQ;IAeM,6BAAA;ExF2nZd;AACF;Ac/qZI;E0EoCM;IAeM,8BAAA;ExFgoZd;EwF/oZQ;IAeM,4BAAA;ExFmoZd;EwFlpZQ;IAeM,sBAAA;ExFsoZd;EwFrpZQ;IAeM,8BAAA;ExFyoZd;EwFxpZQ;IAeM,4BAAA;ExF4oZd;EwF3pZQ;IAeM,2BAAA;ExF+oZd;EwF9pZQ;IAeM,iCAAA;ExFkpZd;EwFjqZQ;IAeM,2BAAA;ExFqpZd;EwFpqZQ;IAeM,0BAAA;ExFwpZd;EwFvqZQ;IAeM,gCAAA;ExF2pZd;EwF1qZQ;IAeM,yBAAA;ExF8pZd;EwF7qZQ;IAeM,wBAAA;ExFiqZd;EwFhrZQ;IAeM,+BAAA;ExFoqZd;EwFnrZQ;IAeM,yBAAA;ExFuqZd;EwFtrZQ;IAeM,6BAAA;ExF0qZd;EwFzrZQ;IAeM,8BAAA;ExF6qZd;EwF5rZQ;IAeM,wBAAA;ExFgrZd;EwF/rZQ;IAeM,+BAAA;ExFmrZd;EwFlsZQ;IAeM,wBAAA;ExFsrZd;EwFrsZQ;IAeM,yBAAA;ExFyrZd;EwFxsZQ;IAeM,8BAAA;ExF4rZd;EwF3sZQ;IAeM,iCAAA;ExF+rZd;EwF9sZQ;IAeM,sCAAA;ExFksZd;EwFjtZQ;IAeM,yCAAA;ExFqsZd;EwFptZQ;IAeM,uBAAA;ExFwsZd;EwFvtZQ;IAeM,uBAAA;ExF2sZd;EwF1tZQ;IAeM,yBAAA;ExF8sZd;EwF7tZQ;IAeM,yBAAA;ExFitZd;EwFhuZQ;IAeM,0BAAA;ExFotZd;EwFnuZQ;IAeM,4BAAA;ExFutZd;EwFtuZQ;IAeM,kCAAA;ExF0tZd;EwFzuZQ;IAeM,sCAAA;ExF6tZd;EwF5uZQ;IAeM,oCAAA;ExFguZd;EwF/uZQ;IAeM,kCAAA;ExFmuZd;EwFlvZQ;IAeM,yCAAA;ExFsuZd;EwFrvZQ;IAeM,wCAAA;ExFyuZd;EwFxvZQ;IAeM,wCAAA;ExF4uZd;EwF3vZQ;IAeM,kCAAA;ExF+uZd;EwF9vZQ;IAeM,gCAAA;ExFkvZd;EwFjwZQ;IAeM,8BAAA;ExFqvZd;EwFpwZQ;IAeM,gCAAA;ExFwvZd;EwFvwZQ;IAeM,+BAAA;ExF2vZd;EwF1wZQ;IAeM,oCAAA;ExF8vZd;EwF7wZQ;IAeM,kCAAA;ExFiwZd;EwFhxZQ;IAeM,gCAAA;ExFowZd;EwFnxZQ;IAeM,uCAAA;ExFuwZd;EwFtxZQ;IAeM,sCAAA;ExF0wZd;EwFzxZQ;IAeM,iCAAA;ExF6wZd;EwF5xZQ;IAeM,2BAAA;ExFgxZd;EwF/xZQ;IAeM,iCAAA;ExFmxZd;EwFlyZQ;IAeM,+BAAA;ExFsxZd;EwFryZQ;IAeM,6BAAA;ExFyxZd;EwFxyZQ;IAeM,+BAAA;ExF4xZd;EwF3yZQ;IAeM,8BAAA;ExF+xZd;EwF9yZQ;IAeM,oBAAA;ExFkyZd;EwFjzZQ;IAeM,mBAAA;ExFqyZd;EwFpzZQ;IAeM,mBAAA;ExFwyZd;EwFvzZQ;IAeM,mBAAA;ExF2yZd;EwF1zZQ;IAeM,mBAAA;ExF8yZd;EwF7zZQ;IAeM,mBAAA;ExFizZd;EwFh0ZQ;IAeM,mBAAA;ExFozZd;EwFn0ZQ;IAeM,mBAAA;ExFuzZd;EwFt0ZQ;IAeM,oBAAA;ExF0zZd;EwFz0ZQ;IAeM,0BAAA;ExF6zZd;EwF50ZQ;IAeM,yBAAA;ExFg0Zd;EwF/0ZQ;IAeM,uBAAA;ExFm0Zd;EwFl1ZQ;IAeM,yBAAA;ExFs0Zd;EwFr1ZQ;IAeM,uBAAA;ExFy0Zd;EwFx1ZQ;IAeM,uBAAA;ExF40Zd;EwF31ZQ;IAeM,0BAAA;IAAA,yBAAA;ExFg1Zd;EwF/1ZQ;IAeM,gCAAA;IAAA,+BAAA;ExFo1Zd;EwFn2ZQ;IAeM,+BAAA;IAAA,8BAAA;ExFw1Zd;EwFv2ZQ;IAeM,6BAAA;IAAA,4BAAA;ExF41Zd;EwF32ZQ;IAeM,+BAAA;IAAA,8BAAA;ExFg2Zd;EwF/2ZQ;IAeM,6BAAA;IAAA,4BAAA;ExFo2Zd;EwFn3ZQ;IAeM,6BAAA;IAAA,4BAAA;ExFw2Zd;EwFv3ZQ;IAeM,wBAAA;IAAA,2BAAA;ExF42Zd;EwF33ZQ;IAeM,8BAAA;IAAA,iCAAA;ExFg3Zd;EwF/3ZQ;IAeM,6BAAA;IAAA,gCAAA;ExFo3Zd;EwFn4ZQ;IAeM,2BAAA;IAAA,8BAAA;ExFw3Zd;EwFv4ZQ;IAeM,6BAAA;IAAA,gCAAA;ExF43Zd;EwF34ZQ;IAeM,2BAAA;IAAA,8BAAA;ExFg4Zd;EwF/4ZQ;IAeM,2BAAA;IAAA,8BAAA;ExFo4Zd;EwFn5ZQ;IAeM,wBAAA;ExFu4Zd;EwFt5ZQ;IAeM,8BAAA;ExF04Zd;EwFz5ZQ;IAeM,6BAAA;ExF64Zd;EwF55ZQ;IAeM,2BAAA;ExFg5Zd;EwF/5ZQ;IAeM,6BAAA;ExFm5Zd;EwFl6ZQ;IAeM,2BAAA;ExFs5Zd;EwFr6ZQ;IAeM,2BAAA;ExFy5Zd;EwFx6ZQ;IAeM,+BAAA;ExF45Zd;EwF36ZQ;IAeM,qCAAA;ExF+5Zd;EwF96ZQ;IAeM,oCAAA;ExFk6Zd;EwFj7ZQ;IAeM,kCAAA;ExFq6Zd;EwFp7ZQ;IAeM,oCAAA;ExFw6Zd;EwFv7ZQ;IAeM,kCAAA;ExF26Zd;EwF17ZQ;IAeM,kCAAA;ExF86Zd;EwF77ZQ;IAeM,2BAAA;ExFi7Zd;EwFh8ZQ;IAeM,iCAAA;ExFo7Zd;EwFn8ZQ;IAeM,gCAAA;ExFu7Zd;EwFt8ZQ;IAeM,8BAAA;ExF07Zd;EwFz8ZQ;IAeM,gCAAA;ExF67Zd;EwF58ZQ;IAeM,8BAAA;ExFg8Zd;EwF/8ZQ;IAeM,8BAAA;ExFm8Zd;EwFl9ZQ;IAeM,iCAAA;ExFs8Zd;EwFr9ZQ;IAeM,uCAAA;ExFy8Zd;EwFx9ZQ;IAeM,sCAAA;ExF48Zd;EwF39ZQ;IAeM,oCAAA;ExF+8Zd;EwF99ZQ;IAeM,sCAAA;ExFk9Zd;EwFj+ZQ;IAeM,oCAAA;ExFq9Zd;EwFp+ZQ;IAeM,oCAAA;ExFw9Zd;EwFv+ZQ;IAeM,qBAAA;ExF29Zd;EwF1+ZQ;IAeM,2BAAA;ExF89Zd;EwF7+ZQ;IAeM,0BAAA;ExFi+Zd;EwFh/ZQ;IAeM,wBAAA;ExFo+Zd;EwFn/ZQ;IAeM,0BAAA;ExFu+Zd;EwFt/ZQ;IAeM,wBAAA;ExF0+Zd;EwFz/ZQ;IAeM,2BAAA;IAAA,0BAAA;ExF8+Zd;EwF7/ZQ;IAeM,iCAAA;IAAA,gCAAA;ExFk/Zd;EwFjgaQ;IAeM,gCAAA;IAAA,+BAAA;ExFs/Zd;EwFrgaQ;IAeM,8BAAA;IAAA,6BAAA;ExF0/Zd;EwFzgaQ;IAeM,gCAAA;IAAA,+BAAA;ExF8/Zd;EwF7gaQ;IAeM,8BAAA;IAAA,6BAAA;ExFkgad;EwFjhaQ;IAeM,yBAAA;IAAA,4BAAA;ExFsgad;EwFrhaQ;IAeM,+BAAA;IAAA,kCAAA;ExF0gad;EwFzhaQ;IAeM,8BAAA;IAAA,iCAAA;ExF8gad;EwF7haQ;IAeM,4BAAA;IAAA,+BAAA;ExFkhad;EwFjiaQ;IAeM,8BAAA;IAAA,iCAAA;ExFshad;EwFriaQ;IAeM,4BAAA;IAAA,+BAAA;ExF0had;EwFziaQ;IAeM,yBAAA;ExF6had;EwF5iaQ;IAeM,+BAAA;ExFgiad;EwF/iaQ;IAeM,8BAAA;ExFmiad;EwFljaQ;IAeM,4BAAA;ExFsiad;EwFrjaQ;IAeM,8BAAA;ExFyiad;EwFxjaQ;IAeM,4BAAA;ExF4iad;EwF3jaQ;IAeM,gCAAA;ExF+iad;EwF9jaQ;IAeM,sCAAA;ExFkjad;EwFjkaQ;IAeM,qCAAA;ExFqjad;EwFpkaQ;IAeM,mCAAA;ExFwjad;EwFvkaQ;IAeM,qCAAA;ExF2jad;EwF1kaQ;IAeM,mCAAA;ExF8jad;EwF7kaQ;IAeM,4BAAA;ExFikad;EwFhlaQ;IAeM,kCAAA;ExFokad;EwFnlaQ;IAeM,iCAAA;ExFukad;EwFtlaQ;IAeM,+BAAA;ExF0kad;EwFzlaQ;IAeM,iCAAA;ExF6kad;EwF5laQ;IAeM,+BAAA;ExFglad;EwF/laQ;IAeM,kCAAA;ExFmlad;EwFlmaQ;IAeM,wCAAA;ExFslad;EwFrmaQ;IAeM,uCAAA;ExFylad;EwFxmaQ;IAeM,qCAAA;ExF4lad;EwF3maQ;IAeM,uCAAA;ExF+lad;EwF9maQ;IAeM,qCAAA;ExFkmad;EwFjnaQ;IAeM,iBAAA;ExFqmad;EwFpnaQ;IAeM,uBAAA;ExFwmad;EwFvnaQ;IAeM,sBAAA;ExF2mad;EwF1naQ;IAeM,oBAAA;ExF8mad;EwF7naQ;IAeM,sBAAA;ExFinad;EwFhoaQ;IAeM,oBAAA;ExFonad;EwFnoaQ;IAeM,qBAAA;ExFunad;EwFtoaQ;IAeM,2BAAA;ExF0nad;EwFzoaQ;IAeM,0BAAA;ExF6nad;EwF5oaQ;IAeM,wBAAA;ExFgoad;EwF/oaQ;IAeM,0BAAA;ExFmoad;EwFlpaQ;IAeM,wBAAA;ExFsoad;EwFrpaQ;IAeM,wBAAA;ExFyoad;EwFxpaQ;IAeM,8BAAA;ExF4oad;EwF3paQ;IAeM,6BAAA;ExF+oad;EwF9paQ;IAeM,2BAAA;ExFkpad;EwFjqaQ;IAeM,6BAAA;ExFqpad;EwFpqaQ;IAeM,2BAAA;ExFwpad;EwFvqaQ;IAeM,4BAAA;ExF2pad;EwF1qaQ;IAeM,0BAAA;ExF8pad;EwF7qaQ;IAeM,6BAAA;ExFiqad;AACF;AcrtaI;E0EoCM;IAeM,8BAAA;ExFsqad;EwFrraQ;IAeM,4BAAA;ExFyqad;EwFxraQ;IAeM,sBAAA;ExF4qad;EwF3raQ;IAeM,8BAAA;ExF+qad;EwF9raQ;IAeM,4BAAA;ExFkrad;EwFjsaQ;IAeM,2BAAA;ExFqrad;EwFpsaQ;IAeM,iCAAA;ExFwrad;EwFvsaQ;IAeM,2BAAA;ExF2rad;EwF1saQ;IAeM,0BAAA;ExF8rad;EwF7saQ;IAeM,gCAAA;ExFisad;EwFhtaQ;IAeM,yBAAA;ExFosad;EwFntaQ;IAeM,wBAAA;ExFusad;EwFttaQ;IAeM,+BAAA;ExF0sad;EwFztaQ;IAeM,yBAAA;ExF6sad;EwF5taQ;IAeM,6BAAA;ExFgtad;EwF/taQ;IAeM,8BAAA;ExFmtad;EwFluaQ;IAeM,wBAAA;ExFstad;EwFruaQ;IAeM,+BAAA;ExFytad;EwFxuaQ;IAeM,wBAAA;ExF4tad;EwF3uaQ;IAeM,yBAAA;ExF+tad;EwF9uaQ;IAeM,8BAAA;ExFkuad;EwFjvaQ;IAeM,iCAAA;ExFquad;EwFpvaQ;IAeM,sCAAA;ExFwuad;EwFvvaQ;IAeM,yCAAA;ExF2uad;EwF1vaQ;IAeM,uBAAA;ExF8uad;EwF7vaQ;IAeM,uBAAA;ExFivad;EwFhwaQ;IAeM,yBAAA;ExFovad;EwFnwaQ;IAeM,yBAAA;ExFuvad;EwFtwaQ;IAeM,0BAAA;ExF0vad;EwFzwaQ;IAeM,4BAAA;ExF6vad;EwF5waQ;IAeM,kCAAA;ExFgwad;EwF/waQ;IAeM,sCAAA;ExFmwad;EwFlxaQ;IAeM,oCAAA;ExFswad;EwFrxaQ;IAeM,kCAAA;ExFywad;EwFxxaQ;IAeM,yCAAA;ExF4wad;EwF3xaQ;IAeM,wCAAA;ExF+wad;EwF9xaQ;IAeM,wCAAA;ExFkxad;EwFjyaQ;IAeM,kCAAA;ExFqxad;EwFpyaQ;IAeM,gCAAA;ExFwxad;EwFvyaQ;IAeM,8BAAA;ExF2xad;EwF1yaQ;IAeM,gCAAA;ExF8xad;EwF7yaQ;IAeM,+BAAA;ExFiyad;EwFhzaQ;IAeM,oCAAA;ExFoyad;EwFnzaQ;IAeM,kCAAA;ExFuyad;EwFtzaQ;IAeM,gCAAA;ExF0yad;EwFzzaQ;IAeM,uCAAA;ExF6yad;EwF5zaQ;IAeM,sCAAA;ExFgzad;EwF/zaQ;IAeM,iCAAA;ExFmzad;EwFl0aQ;IAeM,2BAAA;ExFszad;EwFr0aQ;IAeM,iCAAA;ExFyzad;EwFx0aQ;IAeM,+BAAA;ExF4zad;EwF30aQ;IAeM,6BAAA;ExF+zad;EwF90aQ;IAeM,+BAAA;ExFk0ad;EwFj1aQ;IAeM,8BAAA;ExFq0ad;EwFp1aQ;IAeM,oBAAA;ExFw0ad;EwFv1aQ;IAeM,mBAAA;ExF20ad;EwF11aQ;IAeM,mBAAA;ExF80ad;EwF71aQ;IAeM,mBAAA;ExFi1ad;EwFh2aQ;IAeM,mBAAA;ExFo1ad;EwFn2aQ;IAeM,mBAAA;ExFu1ad;EwFt2aQ;IAeM,mBAAA;ExF01ad;EwFz2aQ;IAeM,mBAAA;ExF61ad;EwF52aQ;IAeM,oBAAA;ExFg2ad;EwF/2aQ;IAeM,0BAAA;ExFm2ad;EwFl3aQ;IAeM,yBAAA;ExFs2ad;EwFr3aQ;IAeM,uBAAA;ExFy2ad;EwFx3aQ;IAeM,yBAAA;ExF42ad;EwF33aQ;IAeM,uBAAA;ExF+2ad;EwF93aQ;IAeM,uBAAA;ExFk3ad;EwFj4aQ;IAeM,0BAAA;IAAA,yBAAA;ExFs3ad;EwFr4aQ;IAeM,gCAAA;IAAA,+BAAA;ExF03ad;EwFz4aQ;IAeM,+BAAA;IAAA,8BAAA;ExF83ad;EwF74aQ;IAeM,6BAAA;IAAA,4BAAA;ExFk4ad;EwFj5aQ;IAeM,+BAAA;IAAA,8BAAA;ExFs4ad;EwFr5aQ;IAeM,6BAAA;IAAA,4BAAA;ExF04ad;EwFz5aQ;IAeM,6BAAA;IAAA,4BAAA;ExF84ad;EwF75aQ;IAeM,wBAAA;IAAA,2BAAA;ExFk5ad;EwFj6aQ;IAeM,8BAAA;IAAA,iCAAA;ExFs5ad;EwFr6aQ;IAeM,6BAAA;IAAA,gCAAA;ExF05ad;EwFz6aQ;IAeM,2BAAA;IAAA,8BAAA;ExF85ad;EwF76aQ;IAeM,6BAAA;IAAA,gCAAA;ExFk6ad;EwFj7aQ;IAeM,2BAAA;IAAA,8BAAA;ExFs6ad;EwFr7aQ;IAeM,2BAAA;IAAA,8BAAA;ExF06ad;EwFz7aQ;IAeM,wBAAA;ExF66ad;EwF57aQ;IAeM,8BAAA;ExFg7ad;EwF/7aQ;IAeM,6BAAA;ExFm7ad;EwFl8aQ;IAeM,2BAAA;ExFs7ad;EwFr8aQ;IAeM,6BAAA;ExFy7ad;EwFx8aQ;IAeM,2BAAA;ExF47ad;EwF38aQ;IAeM,2BAAA;ExF+7ad;EwF98aQ;IAeM,+BAAA;ExFk8ad;EwFj9aQ;IAeM,qCAAA;ExFq8ad;EwFp9aQ;IAeM,oCAAA;ExFw8ad;EwFv9aQ;IAeM,kCAAA;ExF28ad;EwF19aQ;IAeM,oCAAA;ExF88ad;EwF79aQ;IAeM,kCAAA;ExFi9ad;EwFh+aQ;IAeM,kCAAA;ExFo9ad;EwFn+aQ;IAeM,2BAAA;ExFu9ad;EwFt+aQ;IAeM,iCAAA;ExF09ad;EwFz+aQ;IAeM,gCAAA;ExF69ad;EwF5+aQ;IAeM,8BAAA;ExFg+ad;EwF/+aQ;IAeM,gCAAA;ExFm+ad;EwFl/aQ;IAeM,8BAAA;ExFs+ad;EwFr/aQ;IAeM,8BAAA;ExFy+ad;EwFx/aQ;IAeM,iCAAA;ExF4+ad;EwF3/aQ;IAeM,uCAAA;ExF++ad;EwF9/aQ;IAeM,sCAAA;ExFk/ad;EwFjgbQ;IAeM,oCAAA;ExFq/ad;EwFpgbQ;IAeM,sCAAA;ExFw/ad;EwFvgbQ;IAeM,oCAAA;ExF2/ad;EwF1gbQ;IAeM,oCAAA;ExF8/ad;EwF7gbQ;IAeM,qBAAA;ExFigbd;EwFhhbQ;IAeM,2BAAA;ExFogbd;EwFnhbQ;IAeM,0BAAA;ExFugbd;EwFthbQ;IAeM,wBAAA;ExF0gbd;EwFzhbQ;IAeM,0BAAA;ExF6gbd;EwF5hbQ;IAeM,wBAAA;ExFghbd;EwF/hbQ;IAeM,2BAAA;IAAA,0BAAA;ExFohbd;EwFnibQ;IAeM,iCAAA;IAAA,gCAAA;ExFwhbd;EwFvibQ;IAeM,gCAAA;IAAA,+BAAA;ExF4hbd;EwF3ibQ;IAeM,8BAAA;IAAA,6BAAA;ExFgibd;EwF/ibQ;IAeM,gCAAA;IAAA,+BAAA;ExFoibd;EwFnjbQ;IAeM,8BAAA;IAAA,6BAAA;ExFwibd;EwFvjbQ;IAeM,yBAAA;IAAA,4BAAA;ExF4ibd;EwF3jbQ;IAeM,+BAAA;IAAA,kCAAA;ExFgjbd;EwF/jbQ;IAeM,8BAAA;IAAA,iCAAA;ExFojbd;EwFnkbQ;IAeM,4BAAA;IAAA,+BAAA;ExFwjbd;EwFvkbQ;IAeM,8BAAA;IAAA,iCAAA;ExF4jbd;EwF3kbQ;IAeM,4BAAA;IAAA,+BAAA;ExFgkbd;EwF/kbQ;IAeM,yBAAA;ExFmkbd;EwFllbQ;IAeM,+BAAA;ExFskbd;EwFrlbQ;IAeM,8BAAA;ExFykbd;EwFxlbQ;IAeM,4BAAA;ExF4kbd;EwF3lbQ;IAeM,8BAAA;ExF+kbd;EwF9lbQ;IAeM,4BAAA;ExFklbd;EwFjmbQ;IAeM,gCAAA;ExFqlbd;EwFpmbQ;IAeM,sCAAA;ExFwlbd;EwFvmbQ;IAeM,qCAAA;ExF2lbd;EwF1mbQ;IAeM,mCAAA;ExF8lbd;EwF7mbQ;IAeM,qCAAA;ExFimbd;EwFhnbQ;IAeM,mCAAA;ExFombd;EwFnnbQ;IAeM,4BAAA;ExFumbd;EwFtnbQ;IAeM,kCAAA;ExF0mbd;EwFznbQ;IAeM,iCAAA;ExF6mbd;EwF5nbQ;IAeM,+BAAA;ExFgnbd;EwF/nbQ;IAeM,iCAAA;ExFmnbd;EwFlobQ;IAeM,+BAAA;ExFsnbd;EwFrobQ;IAeM,kCAAA;ExFynbd;EwFxobQ;IAeM,wCAAA;ExF4nbd;EwF3obQ;IAeM,uCAAA;ExF+nbd;EwF9obQ;IAeM,qCAAA;ExFkobd;EwFjpbQ;IAeM,uCAAA;ExFqobd;EwFppbQ;IAeM,qCAAA;ExFwobd;EwFvpbQ;IAeM,iBAAA;ExF2obd;EwF1pbQ;IAeM,uBAAA;ExF8obd;EwF7pbQ;IAeM,sBAAA;ExFipbd;EwFhqbQ;IAeM,oBAAA;ExFopbd;EwFnqbQ;IAeM,sBAAA;ExFupbd;EwFtqbQ;IAeM,oBAAA;ExF0pbd;EwFzqbQ;IAeM,qBAAA;ExF6pbd;EwF5qbQ;IAeM,2BAAA;ExFgqbd;EwF/qbQ;IAeM,0BAAA;ExFmqbd;EwFlrbQ;IAeM,wBAAA;ExFsqbd;EwFrrbQ;IAeM,0BAAA;ExFyqbd;EwFxrbQ;IAeM,wBAAA;ExF4qbd;EwF3rbQ;IAeM,wBAAA;ExF+qbd;EwF9rbQ;IAeM,8BAAA;ExFkrbd;EwFjsbQ;IAeM,6BAAA;ExFqrbd;EwFpsbQ;IAeM,2BAAA;ExFwrbd;EwFvsbQ;IAeM,6BAAA;ExF2rbd;EwF1sbQ;IAeM,2BAAA;ExF8rbd;EwF7sbQ;IAeM,4BAAA;ExFisbd;EwFhtbQ;IAeM,0BAAA;ExFosbd;EwFntbQ;IAeM,6BAAA;ExFusbd;AACF;Ac3vbI;E0EoCM;IAeM,8BAAA;ExF4sbd;EwF3tbQ;IAeM,4BAAA;ExF+sbd;EwF9tbQ;IAeM,sBAAA;ExFktbd;EwFjubQ;IAeM,8BAAA;ExFqtbd;EwFpubQ;IAeM,4BAAA;ExFwtbd;EwFvubQ;IAeM,2BAAA;ExF2tbd;EwF1ubQ;IAeM,iCAAA;ExF8tbd;EwF7ubQ;IAeM,2BAAA;ExFiubd;EwFhvbQ;IAeM,0BAAA;ExFoubd;EwFnvbQ;IAeM,gCAAA;ExFuubd;EwFtvbQ;IAeM,yBAAA;ExF0ubd;EwFzvbQ;IAeM,wBAAA;ExF6ubd;EwF5vbQ;IAeM,+BAAA;ExFgvbd;EwF/vbQ;IAeM,yBAAA;ExFmvbd;EwFlwbQ;IAeM,6BAAA;ExFsvbd;EwFrwbQ;IAeM,8BAAA;ExFyvbd;EwFxwbQ;IAeM,wBAAA;ExF4vbd;EwF3wbQ;IAeM,+BAAA;ExF+vbd;EwF9wbQ;IAeM,wBAAA;ExFkwbd;EwFjxbQ;IAeM,yBAAA;ExFqwbd;EwFpxbQ;IAeM,8BAAA;ExFwwbd;EwFvxbQ;IAeM,iCAAA;ExF2wbd;EwF1xbQ;IAeM,sCAAA;ExF8wbd;EwF7xbQ;IAeM,yCAAA;ExFixbd;EwFhybQ;IAeM,uBAAA;ExFoxbd;EwFnybQ;IAeM,uBAAA;ExFuxbd;EwFtybQ;IAeM,yBAAA;ExF0xbd;EwFzybQ;IAeM,yBAAA;ExF6xbd;EwF5ybQ;IAeM,0BAAA;ExFgybd;EwF/ybQ;IAeM,4BAAA;ExFmybd;EwFlzbQ;IAeM,kCAAA;ExFsybd;EwFrzbQ;IAeM,sCAAA;ExFyybd;EwFxzbQ;IAeM,oCAAA;ExF4ybd;EwF3zbQ;IAeM,kCAAA;ExF+ybd;EwF9zbQ;IAeM,yCAAA;ExFkzbd;EwFj0bQ;IAeM,wCAAA;ExFqzbd;EwFp0bQ;IAeM,wCAAA;ExFwzbd;EwFv0bQ;IAeM,kCAAA;ExF2zbd;EwF10bQ;IAeM,gCAAA;ExF8zbd;EwF70bQ;IAeM,8BAAA;ExFi0bd;EwFh1bQ;IAeM,gCAAA;ExFo0bd;EwFn1bQ;IAeM,+BAAA;ExFu0bd;EwFt1bQ;IAeM,oCAAA;ExF00bd;EwFz1bQ;IAeM,kCAAA;ExF60bd;EwF51bQ;IAeM,gCAAA;ExFg1bd;EwF/1bQ;IAeM,uCAAA;ExFm1bd;EwFl2bQ;IAeM,sCAAA;ExFs1bd;EwFr2bQ;IAeM,iCAAA;ExFy1bd;EwFx2bQ;IAeM,2BAAA;ExF41bd;EwF32bQ;IAeM,iCAAA;ExF+1bd;EwF92bQ;IAeM,+BAAA;ExFk2bd;EwFj3bQ;IAeM,6BAAA;ExFq2bd;EwFp3bQ;IAeM,+BAAA;ExFw2bd;EwFv3bQ;IAeM,8BAAA;ExF22bd;EwF13bQ;IAeM,oBAAA;ExF82bd;EwF73bQ;IAeM,mBAAA;ExFi3bd;EwFh4bQ;IAeM,mBAAA;ExFo3bd;EwFn4bQ;IAeM,mBAAA;ExFu3bd;EwFt4bQ;IAeM,mBAAA;ExF03bd;EwFz4bQ;IAeM,mBAAA;ExF63bd;EwF54bQ;IAeM,mBAAA;ExFg4bd;EwF/4bQ;IAeM,mBAAA;ExFm4bd;EwFl5bQ;IAeM,oBAAA;ExFs4bd;EwFr5bQ;IAeM,0BAAA;ExFy4bd;EwFx5bQ;IAeM,yBAAA;ExF44bd;EwF35bQ;IAeM,uBAAA;ExF+4bd;EwF95bQ;IAeM,yBAAA;ExFk5bd;EwFj6bQ;IAeM,uBAAA;ExFq5bd;EwFp6bQ;IAeM,uBAAA;ExFw5bd;EwFv6bQ;IAeM,0BAAA;IAAA,yBAAA;ExF45bd;EwF36bQ;IAeM,gCAAA;IAAA,+BAAA;ExFg6bd;EwF/6bQ;IAeM,+BAAA;IAAA,8BAAA;ExFo6bd;EwFn7bQ;IAeM,6BAAA;IAAA,4BAAA;ExFw6bd;EwFv7bQ;IAeM,+BAAA;IAAA,8BAAA;ExF46bd;EwF37bQ;IAeM,6BAAA;IAAA,4BAAA;ExFg7bd;EwF/7bQ;IAeM,6BAAA;IAAA,4BAAA;ExFo7bd;EwFn8bQ;IAeM,wBAAA;IAAA,2BAAA;ExFw7bd;EwFv8bQ;IAeM,8BAAA;IAAA,iCAAA;ExF47bd;EwF38bQ;IAeM,6BAAA;IAAA,gCAAA;ExFg8bd;EwF/8bQ;IAeM,2BAAA;IAAA,8BAAA;ExFo8bd;EwFn9bQ;IAeM,6BAAA;IAAA,gCAAA;ExFw8bd;EwFv9bQ;IAeM,2BAAA;IAAA,8BAAA;ExF48bd;EwF39bQ;IAeM,2BAAA;IAAA,8BAAA;ExFg9bd;EwF/9bQ;IAeM,wBAAA;ExFm9bd;EwFl+bQ;IAeM,8BAAA;ExFs9bd;EwFr+bQ;IAeM,6BAAA;ExFy9bd;EwFx+bQ;IAeM,2BAAA;ExF49bd;EwF3+bQ;IAeM,6BAAA;ExF+9bd;EwF9+bQ;IAeM,2BAAA;ExFk+bd;EwFj/bQ;IAeM,2BAAA;ExFq+bd;EwFp/bQ;IAeM,+BAAA;ExFw+bd;EwFv/bQ;IAeM,qCAAA;ExF2+bd;EwF1/bQ;IAeM,oCAAA;ExF8+bd;EwF7/bQ;IAeM,kCAAA;ExFi/bd;EwFhgcQ;IAeM,oCAAA;ExFo/bd;EwFngcQ;IAeM,kCAAA;ExFu/bd;EwFtgcQ;IAeM,kCAAA;ExF0/bd;EwFzgcQ;IAeM,2BAAA;ExF6/bd;EwF5gcQ;IAeM,iCAAA;ExFggcd;EwF/gcQ;IAeM,gCAAA;ExFmgcd;EwFlhcQ;IAeM,8BAAA;ExFsgcd;EwFrhcQ;IAeM,gCAAA;ExFygcd;EwFxhcQ;IAeM,8BAAA;ExF4gcd;EwF3hcQ;IAeM,8BAAA;ExF+gcd;EwF9hcQ;IAeM,iCAAA;ExFkhcd;EwFjicQ;IAeM,uCAAA;ExFqhcd;EwFpicQ;IAeM,sCAAA;ExFwhcd;EwFvicQ;IAeM,oCAAA;ExF2hcd;EwF1icQ;IAeM,sCAAA;ExF8hcd;EwF7icQ;IAeM,oCAAA;ExFiicd;EwFhjcQ;IAeM,oCAAA;ExFoicd;EwFnjcQ;IAeM,qBAAA;ExFuicd;EwFtjcQ;IAeM,2BAAA;ExF0icd;EwFzjcQ;IAeM,0BAAA;ExF6icd;EwF5jcQ;IAeM,wBAAA;ExFgjcd;EwF/jcQ;IAeM,0BAAA;ExFmjcd;EwFlkcQ;IAeM,wBAAA;ExFsjcd;EwFrkcQ;IAeM,2BAAA;IAAA,0BAAA;ExF0jcd;EwFzkcQ;IAeM,iCAAA;IAAA,gCAAA;ExF8jcd;EwF7kcQ;IAeM,gCAAA;IAAA,+BAAA;ExFkkcd;EwFjlcQ;IAeM,8BAAA;IAAA,6BAAA;ExFskcd;EwFrlcQ;IAeM,gCAAA;IAAA,+BAAA;ExF0kcd;EwFzlcQ;IAeM,8BAAA;IAAA,6BAAA;ExF8kcd;EwF7lcQ;IAeM,yBAAA;IAAA,4BAAA;ExFklcd;EwFjmcQ;IAeM,+BAAA;IAAA,kCAAA;ExFslcd;EwFrmcQ;IAeM,8BAAA;IAAA,iCAAA;ExF0lcd;EwFzmcQ;IAeM,4BAAA;IAAA,+BAAA;ExF8lcd;EwF7mcQ;IAeM,8BAAA;IAAA,iCAAA;ExFkmcd;EwFjncQ;IAeM,4BAAA;IAAA,+BAAA;ExFsmcd;EwFrncQ;IAeM,yBAAA;ExFymcd;EwFxncQ;IAeM,+BAAA;ExF4mcd;EwF3ncQ;IAeM,8BAAA;ExF+mcd;EwF9ncQ;IAeM,4BAAA;ExFkncd;EwFjocQ;IAeM,8BAAA;ExFqncd;EwFpocQ;IAeM,4BAAA;ExFwncd;EwFvocQ;IAeM,gCAAA;ExF2ncd;EwF1ocQ;IAeM,sCAAA;ExF8ncd;EwF7ocQ;IAeM,qCAAA;ExFiocd;EwFhpcQ;IAeM,mCAAA;ExFoocd;EwFnpcQ;IAeM,qCAAA;ExFuocd;EwFtpcQ;IAeM,mCAAA;ExF0ocd;EwFzpcQ;IAeM,4BAAA;ExF6ocd;EwF5pcQ;IAeM,kCAAA;ExFgpcd;EwF/pcQ;IAeM,iCAAA;ExFmpcd;EwFlqcQ;IAeM,+BAAA;ExFspcd;EwFrqcQ;IAeM,iCAAA;ExFypcd;EwFxqcQ;IAeM,+BAAA;ExF4pcd;EwF3qcQ;IAeM,kCAAA;ExF+pcd;EwF9qcQ;IAeM,wCAAA;ExFkqcd;EwFjrcQ;IAeM,uCAAA;ExFqqcd;EwFprcQ;IAeM,qCAAA;ExFwqcd;EwFvrcQ;IAeM,uCAAA;ExF2qcd;EwF1rcQ;IAeM,qCAAA;ExF8qcd;EwF7rcQ;IAeM,iBAAA;ExFircd;EwFhscQ;IAeM,uBAAA;ExForcd;EwFnscQ;IAeM,sBAAA;ExFurcd;EwFtscQ;IAeM,oBAAA;ExF0rcd;EwFzscQ;IAeM,sBAAA;ExF6rcd;EwF5scQ;IAeM,oBAAA;ExFgscd;EwF/scQ;IAeM,qBAAA;ExFmscd;EwFltcQ;IAeM,2BAAA;ExFsscd;EwFrtcQ;IAeM,0BAAA;ExFyscd;EwFxtcQ;IAeM,wBAAA;ExF4scd;EwF3tcQ;IAeM,0BAAA;ExF+scd;EwF9tcQ;IAeM,wBAAA;ExFktcd;EwFjucQ;IAeM,wBAAA;ExFqtcd;EwFpucQ;IAeM,8BAAA;ExFwtcd;EwFvucQ;IAeM,6BAAA;ExF2tcd;EwF1ucQ;IAeM,2BAAA;ExF8tcd;EwF7ucQ;IAeM,6BAAA;ExFiucd;EwFhvcQ;IAeM,2BAAA;ExFoucd;EwFnvcQ;IAeM,4BAAA;ExFuucd;EwFtvcQ;IAeM,0BAAA;ExF0ucd;EwFzvcQ;IAeM,6BAAA;ExF6ucd;AACF;AyF90cA;EDiFU;IAeM,4BAAA;ExFkvcd;EwFjwcQ;IAeM,0BAAA;ExFqvcd;EwFpwcQ;IAeM,6BAAA;ExFwvcd;EwFvwcQ;IAeM,4BAAA;ExF2vcd;AACF;AyFz0cA;ED8DU;IAeM,0BAAA;ExFgwcd;EwF/wcQ;IAeM,gCAAA;ExFmwcd;EwFlxcQ;IAeM,yBAAA;ExFswcd;EwFrxcQ;IAeM,wBAAA;ExFywcd;EwFxxcQ;IAeM,+BAAA;ExF4wcd;EwF3xcQ;IAeM,yBAAA;ExF+wcd;EwF9xcQ;IAeM,6BAAA;ExFkxcd;EwFjycQ;IAeM,8BAAA;ExFqxcd;EwFpycQ;IAeM,wBAAA;ExFwxcd;EwFvycQ;IAeM,+BAAA;ExF2xcd;EwF1ycQ;IAeM,wBAAA;ExF8xcd;AACF;A0Fj5cA;EAEE,kCAAA;EACA,uCAAA;EACA,wCAAA;EACA,+CAAA;EACA,kEAAA;EACA,6DAAA;EACA,gDAAA;EACA,2CAAA;EACA,gDAAA;EACA,6CAAA;EACA,8CAAA;EACA,2CAAA;EAGA,kBAAA;EACA,0CAAA;EACA,kFAAA;EACA,uCAAA;EACA,oBAAA;EACA,yCAAA;EACA,UAAA;EACA,6BAAA;EnFTE,uDAAA;EaJE,iDsEeJ;A1Fg5cF;;AoB35cM;EsEdN;ItEeQ,gBAAA;EpB+5cN;AACF;A0Fn5cA;EACE,uDAAA;A1Fq5cF;;A0Fl5cA;EACE,sDAAA;EACA,0DAAA;A1Fq5cF;;A0Fl5cA;EACE,mBAAA;EACA,oDAAA;EACA,wDAAA;EACA,mBAAA;A1Fq5cF;;A2Fv8cA;EACE,aAAA;EACA,sBAAA;EACA,gBAAA;A3F08cF;;A4F78cA;EACE,wCAAA;A5Fg9cF;;A4F78cA;EACE,WAAA;EjE8EI,gDAAA;EAAA,+CAAA;EiE3EJ,iBAAA;ExEWI,yBwEVJ;A5Fg9cF;AoBl8cM;EwEnBN;IxEoBQ,gBAAA;EpBq8cN;AACF;;A4Fl9cA;;EAEE,4BAAA;A5Fq9cF;;A4Fl9cA;EACE,gBAAA;A5Fq9cF;;A4Fj9cE;EACE,+CAAA;EACA,iCAAA;A5Fo9cJ;A4Fj9cE;EACE,aAAA;EACA,mBAAA;EACA,4BAAA;A5Fm9cJ;;A4F/8cA;EjEiDM,iBAAA;A3Bk6cN;;A4F78cE;;EjE2CI,kBAAA;A3Bu6cN;;A4F78cA;EACE,gBAAA;A5Fg9cF;;A4F78cA;EACE,4BAAA;A5Fg9cF;;A4F38cI;EACE,2CAAA;A5F88cN;A4F38cI;EACE,mCAAA;A5F68cN;;AAv/cA;EACE,6DAAA;EACA,iBAAA;AA0/cF;;AAv/cA;EACE,8BAAA;EACA,4BAAA;EACA,4BAAA;EACA,oCAAA;AA0/cF;AAz/cE;EACE,2BAAA;EACA,qDAAA;AA2/cJ;;AAt/cE;EACE,8BAAA;EACA,yCAAA;AAy/cJ;;AAr/cA;EACE,gBAAA;EACA,8BAAA;EACA,oDAAA;EACA,gBAAA;AAw/cF;;AAn/cE;EACE,gBAAA;EACA,yBAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,yBAAA;EACA,gBAAA;EACA,SAAA;AAs/cJ;AAr/cI;EACE,2BAAA;EACA,0CAAA;EACA,qBAAA;AAu/cN;AAr/cI;EACE,qBAAA;EACA,0DAAA;EACA,6CAAA;AAu/cN;AAr/cI;EACE,YAAA;EACA,mBAAA;AAu/cN;AAt/cM;EAAU,eAAA;EAAiB,gBAAA;AA0/cjC;AAv/cE;EACE,WAAA;EAAa,YAAA;EACb,aAAA;EAAe,mBAAA;EAAqB,uBAAA;AA4/cxC;AA3/cI;EAAM,WAAA;EAAa,YAAA;EAAc,mBAAA;AAggdrC;AA9/cE;EACE,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,qBAAA;AAggdJ;AA9/cE;EACE,iBAAA;EACA,gBAAA;EACA,cAAA;AAggdJ;AA//cI;EAAe,iBAAA;EAAmB,gBAAA;EAAkB,cAAA;AAogdxD;;AA9/cE;EACE,2CAAA;AAigdJ;AAhgdI;EACE,6BAAA;EACA,gBAAA;EACA,yBAAA;EACA,4BAAA;EACA,uBAAA;EACA,kBAAA;EACA,2BAAA;AAkgdN;AAjgdM;EAAU,yBAAA;AAogdhB;AAngdM;EACE,yBAAA;EACA,kCAAA;AAqgdR;AApgdQ;EACE,WAAA;EACA,kBAAA;EACA,YAAA;EACA,OAAA;EAAS,QAAA;EACT,WAAA;EACA,mBAAA;EACA,0BAAA;AAugdV;;AA9/cE;EACE,6BAAA;EACA,oCAAA;EACA,6BAAA;EACA,4BAAA;AAigdJ;AAhgdI;EACE,gCAAA;EACA,uDAAA;AAkgdN;AA//cE;EACE,yBAAA;EACA,gBAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,yBAAA;AAigdJ;AAhgdI;EAAU,qBAAA;EAAuB,cAAA;EAAgB,mBAAA;AAqgdrD;AApgdI;EACE,mBAAA;EACA,WAAA;EACA,qBAAA;AAsgdN;;AA9/cI;EACE,8BAAA;EACA,6BAAA;EACA,qBAAA;EACA,yBAAA;EACA,yBAAA;EACA,2CAAA;AAigdN;AA7/cI;EACE,iCAAA;AA+/cN;AA9/cM;EAAU,8BAAA;AAigdhB;AAhgdM;EACE,8BAAA;EACA,8BAAA;AAkgdR;;AA3/cA;EACE,8BAAA;EACA,8BAAA;EACA,wDAAA;AA8/cF;;AA5/cA;EACE,8BAAA;EACA,8BAAA;EACA,wDAAA;AA+/cF;;AA3/cA;EACE,mBAAA;EACA,YAAA;EACA,0CAAA;EACA,yBAAA;EACA,gBAAA;AA8/cF;;AA3/cA;EAEE,eAAA;EACA,aAAA;EACA,6CAAA;AA6/cF;AA3/cE;EACE,2BAAA;EACA,yCAAA;AA6/cJ;AA1/cE;EACE,qCAAA;AA4/cJ;;AAx/cA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;AA2/cF;AAz/cE;EACE,gBAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;AA2/cJ;AAx/cE;EACE,WAAA;EACA,kBAAA;AA0/cJ;;AAt/cA;EACE,mBAAA;EACA,gBAAA;EACA,0CAAA;EACA,iBAAA;AAy/cF;;AAt/cA;EACE,WAAA;EACA,YAAA;EACA,6BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,UAAA;EACA,oBAAA;AAy/cF;AAv/cE;EACE,mBAAA;AAy/cJ;;AAn/cA;EACE,yBAAA;EACA,mBAAA;EAGA,aAAA;EACA,cAAA;EACA,aAAA;EACA,uBAAA;EACA,wCAAA;EACA,mBAAA;EACA,sCAAA;EACA,eAAA;AAo/cF;;AAj/cA;EACE,yBAAA;EACA,mBAAA;EACA,eAAA;AAo/cF;;AAj/cA;EACE,yBAAA;EACA,mBAAA;AAo/cF;;AAj/cA;EACE,yBAAA;AAo/cF;;AAj/cA;EACE,yBAAA;AAo/cF;;AAj/cA;EACE,yBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,qBAAA;EACA,cAAA;EAEA,gBAAA;AAm/cF;;AAh/cA;EACE,yBAAA;EACA,qBAAA;EACA,cAAA;AAm/cF;;AA/+cA;EACE,yBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,qBAAA;EACA,cAAA;AAk/cF;;AA9+cA;EACE,oCAAA;AAi/cF;;AA9+cA;EACE,yBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,qBAAA;EACA,cAAA;EAEA,gBAAA;AAg/cF;;AA7+cA;EACE,yBAAA;EACA,qBAAA;EACA,cAAA;AAg/cF;;AA5+cA;EACE,yBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,qBAAA;EACA,cAAA;AA++cF;;AA5+cA;EACE,yBAAA;EACA,qBAAA;EACA,gBAAA;EACA,iBAAA;AA++cF;;AA5+cA;EACE,yBAAA;EACA,qBAAA;EACA,iBAAA;AA++cF;;AA5+cA;EACE,yBAAA;EACA,qBAAA;EACA,iBAAA;AA++cF;;AA5+cA;EACE,yBAAA;EACA,qBAAA;EACA,gBAAA;EACA,iBAAA;AA++cF;;AA5+cA;EACE,yBAAA;EACA,qBAAA;EACA,iBAAA;AA++cF;;AA5+cA;EACE,yBAAA;EACA,qBAAA;EACA,iBAAA;AA++cF;;AA5+cA;EACE,yBAAA;EACA,qBAAA;EACA,gBAAA;EACA,YAAA;EACA,iBAAA;EACA,iBAAA;AA++cF;;AA3+cA;EACE,yBAAA;EACA,qBAAA;EACA,YAAA;EACA,iBAAA;EACA,iBAAA;AA8+cF;;AA3+cA;EACE,yBAAA;EAEA,gBAAA;EACA,YAAA;EAEA,iBAAA;AA4+cF;;AAx+cA;EACE,yBAAA;EAEA,YAAA;EAEA,iBAAA;AAy+cF;;AAt+cA;EACE,yBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,qBAAA;EACA,cAAA;EAEA,gBAAA;EACA,YAAA;EACA,iBAAA;EACA,iBAAA;AAw+cF;;AAr+cA;EACE,yBAAA;EACA,qBAAA;EACA,cAAA;EACA,YAAA;EACA,iBAAA;EACA,iBAAA;AAw+cF;;AAr+cA;EACE,yBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,qBAAA;EACA,cAAA;EACA,YAAA;AAw+cF;;AAr+cA;EACE,yBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,qBAAA;EACA,cAAA;EAEA,gBAAA;EACA,YAAA;EACA,iBAAA;EACA,iBAAA;AAu+cF;;AAp+cA;EACE,yBAAA;EACA,qBAAA;EACA,cAAA;EACA,YAAA;EACA,iBAAA;EACA,iBAAA;AAu+cF;;AAp+cA;EACE,yBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,qBAAA;EACA,cAAA;EACA,YAAA;AAu+cF;;AAp+cA;EACE,yBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,qBAAA;EACA,cAAA;EAEA,gBAAA;EACA,YAAA;EACA,iBAAA;EACA,iBAAA;EACA,YAAA;EACA,oCAAA;AAs+cF;;AAn+cA;EACE,yBAAA;EACA,qBAAA;EACA,cAAA;EACA,YAAA;EACA,iBAAA;EACA,iBAAA;AAs+cF;;AAn+cA;EACE,yBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,qBAAA;EACA,cAAA;EACA,YAAA;AAs+cF;;AAn+cA;EACE,yBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,qBAAA;EACA,cAAA;EAEA,gBAAA;EAEA,iBAAA;EACA,iBAAA;AAo+cF;;AAj+cA;EACE,yBAAA;EACA,qBAAA;EACA,cAAA;EAEA,iBAAA;EACA,iBAAA;AAm+cF;;AAh+cA;EACE,yBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,qBAAA;EACA,cAAA;AAm+cF;;AA/9cA;EACE,yBAAA;EACA,qBAAA;EACA,gBAAA;EACA,YAAA;EACA,iBAAA;EACA,iBAAA;EACA,gBAAA;AAk+cF;;AA99cA;EACE,yBAAA;EACA,qBAAA;EACA,YAAA;EACA,iBAAA;EACA,iBAAA;EACA,gBAAA;AAi+cF;;AA99cA;EACE,yBAAA;EACA,qBAAA;EACA,gBAAA;AAi+cF;;AA99cA;EACE,yBAAA;EACA,qBAAA;AAi+cF;;AA99cA;EACE,yBAAA;EACA,qBAAA;AAi+cF;;AA99cA;EACE,kBAAA;EACA,qBAAA;AAi+cF;;AA99cA;EAEE,yBAAA;AAg+cF;;AA79cA;EAEE,0BAAA;EACA,2BAAA;EACA,4BAAA;EACA,6BAAA;AA+9cF;;AA59cA;EACE,oCAAA;AA+9cF;;AA59cA;EACE,qEAAA;EACA,mCAAA;EACA,wBAAA;EACA,6CAAA;EACA,4BAAA;EACA,uCAAA;AA+9cF;;AA59cA;EACE,qEAAA;EACA,mCAAA;EACA,wBAAA;EACA,6CAAA;EACA,4BAAA;AA+9cF;;AA59cA;EACE,2BAAA;AA+9cF;;AA59cA;;EAEE,gBAAA;AA+9cF;;AA59cA;EACE,yBAAA;AA+9cF;;AA59cA;EACE,yBAAA;AA+9cF;;AA59cA;EACE,yBAAA;AA+9cF;;AA59cA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;EACA,mBAAA;EACA,6BAAA;EACA,cAAA;AA+9cF;;AA39cA;EACE,cAAA;EACA,+CAAA;EACA,eAAA;EACA,+CAAA;AA89cF;;AA39cA;EACE;IACE,wBAAA;EA89cF;AACF;AA39cA;EACE;IACE,wBAAA;EA69cF;AACF;AAt9cA;EACE;IACE,wBAAA;EAw9cF;AACF;AAr9cA;EACE;IACE,wBAAA;EAu9cF;AACF;AAp9cA;EACE;IACE,wBAAA;EAs9cF;AACF;AAn9cA;EACE,kBAAA;EACA,mBAAA;AAq9cF;;AAx8cA,gCAAA;AAOA,sDAAA;AAiCA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;AAq6cF;;AAl6cA;EACE,mBAAA;EACA,sBAAA;AAq6cF;;AAl6cA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;AAq6cF;;AAl6cA;EACE,eAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;AAq6cF;;AAl6cA;EACE,kBAAA;EACA,yBAAA;AAq6cF;;AAl6cA;EACE,YAAA;EACA,eAAA;AAq6cF;;AAl6cA;EACE,YAAA;AAq6cF;;AAl6cA;EACE,aAAA;EACA,iCAAA;EACA,wBAAA;EACA,SAAA;EACA,kBAAA;AAq6cF;;AAl6cA;EACE;IACE,0BAAA;EAq6cF;AACF;AAj6cA;EACE,aAAA;EACA,0BAAA;EACA,wBAAA;EACA,SAAA;AAm6cF;;AA95cA;EACE,aAAA;EACA,qCAAA;EACA,uCAAA;EACA,cAAA;EACA,iCAAA;EACA,aAAA;EACA,iCAAA;EACA,aAAA;EACA,eAAA;AAi6cF;;AA95cA;EAIE,yBAAA;EAEA,kBAAA;AA65cF;;AAx5cA;EACE,yBAAA;EACA,UAAA;EACA,cAAA;AA25cF;;AAv5cA;EACE,yBAAA;EACA,kBAAA;AA05cF;;AAv5cA;EACE,WAAA;EACA,aAAA;AA05cF;;AAv5cA;EACE,iBAAA;EACA,oBAAA;AA05cF;;AAv5cA;EAEE,kBAAA;EACA,gBAAA;AAy5cF;;AAt5cA;EACE,gBAAA;AAy5cF;;AA74cA;EACE,sBAAA;EACA,2BAAA;AAg5cF;;AA74cA;EACE,yBAAA;EACA,UAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AAg5cF;AA94cE;EARF;IASI,WAAA;IACA,aAAA;EAi5cF;AACF;;AA94cA;EACE,gBAAA;AAi5cF;;AA54cA;EACE,gBAAA;AA+4cF;;AA54cA;EACE,oCAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AA+4cF;;AA54cA;EACE,yBAAA;EACA,qBAAA;EACA,oBAAA;AA+4cF;;AA54cA;EAEE,yBAAA;EACA,kBAAA;AA84cF;;AA14cA;EACE,gBAAA;EACA,yBAAA;EACA,kBAAA;AA64cF;;AA14cA;EACE,kBAAA;EACA,mBAAA;AA64cF;;AA14cA;EACE,kBAAA;EACA,iBAAA;AA64cF;;AA14cA;EACE,gBAAA;AA64cF;;AA14cA;EAEE,WAAA;EACA,kBAAA;EACA,gBAAA;AA44cF;;AAz4cA;EAEE,WAAA;EACA,kBAAA;EACA,gBAAA;AA24cF;;AAx4cA;EACE,iBAAA;AA24cF;;AAv4cA;EACE,gCAAA;EACA,cAAA;AA04cF;;AAv4cA,oDAAA;AACA;EACE;IACE,iCAAA;EA04cF;EAv4cA;IACE,wBAAA;EAy4cF;EAt4cA;IACE,6BAAA;EAw4cF;AACF;AAp4cA;EACE,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;AAs4cF;;AAn4cA;EACE,aAAA;EACA,8BAAA;EACA,kCAAA;EACA,mBAAA;EACA,wBAAA;EACA,aAAA;EACA,oBAAA;AAs4cF;;AA93cA;EACE,iBAAA;EACA,sCAAA;AAi4cF;;AA93cA;EACE,cAAA;EACA,+BAAA;EAEA,gBAAA;AAg4cF;;AA73cA;EACE,gBAAA;EACA,+BAAA;EACA,cAAA;EACA,gCAAA;EACA,gBAAA;AAg4cF;;AA73cA;EACE,yBAAA;AAg4cF;;AA73cA;EACE,YAAA;AAg4cF;;AA73cA;EACE,oBAAA;AAg4cF;;AA73cA;EACE,+BAAA;EACA,mBAAA;EACA,4DAAA;EACA,cAAA;AAg4cF;;AA73cA;EACE,qBAAA;EAEA,iBAAA;EACA,cAAA;AA+3cF;;AA53cA;EACE,oBAAA;AA+3cF;;AA53cA;EACE,eAAA;EACA,iBAAA;AA+3cF;;AA53cA;EACE,iBAAA;EACA,iBAAA;AA+3cF;;AA53cA;EACE,cAAA;AA+3cF;;AA53cA;EACE,cAAA;AA+3cF;;AA53cA;EACE,cAAA;AA+3cF;;AA53cA;EACE,yBAAA;EACA,cAAA;AA+3cF;;AA53cA;EACE,qBAAA;AA+3cF;;AA53cA;EACE,kBAAA;AA+3cF;;AA53cA;EACE,WAAA;EACA,aAAA;EAEA,kBAAA;EACA,8BAAA;AA83cF;;AAz3cA;EACE,kDAAA;EAUA,WAAA;EACA,WAAA;EAEA,gBAAA;EACA,8BAAA;EAEA,qBAAA;AAi3cF;;AA92cA,gDAAA;AACA;EACE,aAAA;AAi3cF;;AA92cA,4CAAA;AACA;EACE,wBAAA;EACA,gBAAA;EACA,qBAAA;EACA,YAAA;AAi3cF;;AA92cA;EACE,aAAA;EACA,0BAAA;AAi3cF;;AA92cA;EACE,aAAA;EACA,kBAAA;AAi3cF;;AA92cA;EACE,iBAAA;EACA,eAAA;AAi3cF;;AA92cA;EACE,yBAAA;AAi3cF;;AA92cA;EACE,cAAA;AAi3cF;;AA92cA;EACE,wCAAA;AAi3cF;;AAv2cA;EACE,kBAAA;EACA,mBAAA;AA02cF;;AAv2cA;EACE,kBAAA;EACA,aAAA;EACA,oBAAA;AA02cF;;AAv2cA;EACE,SAAA;AA02cF;;AAv2cA;EACE,UAAA;AA02cF;;AAv2cA;EACE,kBAAA;AA02cF;;AAv2cA;EACE,mBAAA;AA02cF;;AAv2cA;EACE,uBAAA;AA02cF;;AAv2cA;EACE,uBAAA;EACA,UAAA;AA02cF;;AAv2cA;EACE,uBAAA;EACA,UAAA;AA02cF;;AAv2cA;EACE,2BAAA;EACA,4BAAA;EACA,6BAAA;EACA,8BAAA;AA02cF;;AAv2cA;EACE,2BAAA;EACA,4BAAA;EACA,6BAAA;EACA,8BAAA;AA02cF;;AAv2cA;EACE,kBAAA;AA02cF;;AAv2cA;EACE,kBAAA;AA02cF;;AAv2cA;EAEE,uCAAA;AAy2cF;;AAp2cA;EACE,6CAAA;AAu2cF;;AAn2cA;EACE,gDAAA;EACA,uCAAA;AAs2cF;;AAn2cA;EACE,kBAAA;AAs2cF;;AAn2cA;EACE,qBAAA;AAs2cF;;AAn2cA;EACE,4BAAA;AAs2cF;;AAn2cA;EACE,mBAAA;EACA,iDAAA;EACA,6CAAA;AAs2cF;;AAn2cA;EACE,kBAAA;EACA,iBAAA;EACA,4DAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;AAs2cF;;AAn2cA;EACE,kBAAA;EAEA,4DAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;AAq2cF;;AAj2cA;EACE,kBAAA;EACA,iBAAA;EACA,4DAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;AAo2cF;;AAj2cA;EACE,kBAAA;EACA,iBAAA;EACA,4DAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;AAo2cF;;AAj2cA;EACE,+CAAA;AAo2cF;;AAj2cA;EAEE,kBAAA;EACA,iDAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,uBAAA;EACA,kBAAA;EACA,aAAA;EACA,kBAAA;EACA,WAAA;AAm2cF;;AAh2cA,sCAAA;AACA;EACE,eAAA;EACA,4DAAA;AAm2cF;;AAh2cA;EACE,oBAAA;AAm2cF;;AAh2cA;EACE,yBAAA;EACA,mBAAA;EACA,eAAA;EACA,wBAAA;EACA,yBAAA;EACA,oBAAA;EACA,sBAAA;AAm2cF;;AAh2cA;EACE,yBAAA;EACA,mBAAA;EACA,gBAAA;EACA,wBAAA;EACA,yBAAA;EACA,oBAAA;EACA,sBAAA;AAm2cF;;AAh2cA;EACE,sBAAA;AAm2cF;;AA/1cA;EACE,aAAA;EACA,sBAAA;EACA,mCAAA;EACA,mBAAA;EACA,yCAAA;EACA,iBAAA;EACA,oBAAA;AAk2cF;;AA/1cA;EACE,aAAA;EACA,sBAAA;EACA,mCAAA;EACA,mBAAA;EACA,yCAAA;EACA,iBAAA;EACA,oBAAA;AAk2cF;;AA/1cA;EACE,aAAA;EACA,sBAAA;EACA,mCAAA;EACA,mBAAA;EACA,yCAAA;EACA,iBAAA;EACA,oBAAA;AAk2cF;;AA/1cA;EACE,YAAA;EACA,gCAAA;EACA,aAAA;EACA,kBAAA;EACA,4BAAA;EACA,gBAAA;EACA,+BAAA;EACA,mBAAA;EACA,iCAAA;AAk2cF;;AA/1cA;EACE,UAAA;EACA,gDAAA;EACA,WAAA;EACA,iBAAA;EACA,uDAAA;EACA,kBAAA;EACA,4BAAA;AAk2cF;;AA/1cA;EAGE,UAAA;EACA,WAAA;EACA,iBAAA;EACA,uDAAA;EACA,kBAAA;EACA,4BAAA;AAg2cF;;AA71cA;EACE,UAAA;EACA,gDAAA;EACA,WAAA;EACA,iBAAA;EACA,uDAAA;EACA,kBAAA;EACA,4BAAA;AAg2cF;;AA71cA;EACE,aAAA;EACA,sBAAA;EACA,mCAAA;EACA,mBAAA;EACA,yCAAA;EACA,iBAAA;EACA,oBAAA;EACA,eAAA;EACA,cAAA;EACA,4DAAA;AAg2cF;;AA71cA;EACE,aAAA;EACA,sBAAA;EACA,mCAAA;EACA,mBAAA;EACA,yCAAA;EACA,mBAAA;EACA,sBAAA;EACA,eAAA;AAg2cF;;AA71cA;EACE,UAAA;EACA,WAAA;EACA,yBAAA;EACA,mCAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,WAAA;AAg2cF;;AA71cA;EAGE,UAAA;EACA,WAAA;EACA,iBAAA;EACA,uDAAA;EACA,kBAAA;EACA,4BAAA;AA81cF;;AA31cA;EAOE,sBAAA;EACA,mCAAA;AAw1cF;;AAr1cA;EAGE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,uDAAA;EACA,kBAAA;EACA,4BAAA;AAs1cF;;AAn1cA;EAGE,UAAA;EACA,WAAA;EACA,iBAAA;EACA,uDAAA;EACA,kBAAA;EACA,4BAAA;EACA,kBAAA;AAo1cF;;AAj1cA;EAGE,UAAA;EACA,WAAA;AAk1cF;;AA70cA;EACE,aAAA;EACA,2CAAA;EACA,gBAAA;EACA,oCAAA;AAg1cF;;AAp0cA;EACE,YAAA;EACA,6BAAA;EACA,4BAAA;EACA,oBAAA;EACA,iBAAA;EACA,+BAAA;AAu0cF;;AAp0cA;EACE,WAAA;AAu0cF;;AAp0cA;EACE,iBAAA;AAu0cF;;AAn0cA;EACE,kBAAA;EACA,iBAAA;AAs0cF;;AAn0cA;EACE,uBAAA;AAs0cF;;AAn0cA;EACE,eAAA;EACA,cAAA;EACA,4DAAA;AAs0cF;;AAn0cA;EACE,yBAAA;EACA,0BAAA;EACA,4DAAA;EACA,iBAAA;AAs0cF;;AAn0cA;EACE,yBAAA;EACA,0BAAA;EACA,4DAAA;AAs0cF;;AAn0cA;EACE,yBAAA;EACA,0BAAA;EACA,4DAAA;AAs0cF;;AAn0cA;EACE,yBAAA;EACA,0BAAA;EACA,4DAAA;AAs0cF;;AAn0cA;EACE,yBAAA;EACA,0BAAA;EACA,4DAAA;EACA,iBAAA;AAs0cF;;AAn0cA;EACE,yBAAA;EACA,0BAAA;EACA,4DAAA;EACA,mBAAA;AAs0cF;;AAn0cA;EACE,yBAAA;EACA,0BAAA;EACA,4DAAA;EACA,iBAAA;AAs0cF;;AAn0cA;EACE,yBAAA;EACA,0BAAA;EACA,4DAAA;EACA,mBAAA;AAs0cF;;AAn0cA;EACE,yBAAA;EACA,0BAAA;EACA,4DAAA;EACA,iBAAA;EACA,mBAAA;AAs0cF;;AAn0cA;EACE,yBAAA;EACA,0BAAA;EACA,4DAAA;EACA,iBAAA;EACA,mBAAA;AAs0cF;;AAn0cA;EACE,yBAAA;EACA,0BAAA;EACA,4DAAA;AAs0cF;;AAn0cA;EACE,yBAAA;EACA,0BAAA;EACA,4DAAA;AAs0cF;;AAn0cA;EACE,yBAAA;EACA,0BAAA;EACA,4DAAA;EACA,kBAAA;AAs0cF;;AAn0cA;EACE,yBAAA;EACA,0BAAA;EACA,4DAAA;EACA,iBAAA;AAs0cF;;AAn0cA;EACE,qBAAA;AAs0cF;;AAn0cA;EACE,2BAAA;EACA,4BAAA;EACA,6BAAA;EACA,8BAAA;EACA,eAAA;EACA,4DAAA;EACA,yBAAA;AAs0cF;;AAn0cA;EACE,2BAAA;EACA,6BAAA;EACA,6BAAA;EACA,8BAAA;EACA,eAAA;EACA,4DAAA;EACA,yBAAA;AAs0cF;;AAn0cA;EACE,kBAAA;AAs0cF;;AAn0cA;EACE,aAAA;AAs0cF;;AAl0cA;EACE,UAAA;AAq0cF;;AAj0cA;EACE,aAAA;AAo0cF;;AAj0cA;EACE,sBAAA;EAEA,kBAAA;EACA,sBAAA;AAm0cF;;AA/zcA;EACE,iBAAA;EACA,kBAAA;EACA,mBAAA;AAk0cF;;AA9zcA;EACE,mBAAA;AAi0cF;;AA9zcA;EACE,gBAAA;EACA,MAAA;EACA,uBAAA;EACA,0BAAA;EACA,UAAA;EACA,8CAAA;EACA,4BAAA;EACA,wCAAA;AAi0cF;;AA9zcA;EACE,gBAAA;EACA,MAAA;EACA,uBAAA;EACA,0BAAA;EACA,UAAA;EACA,8CAAA;EACA,4BAAA;EACA,wCAAA;AAi0cF;;AA9zcA;EACE,gBAAA;EACA,MAAA;EACA,uBAAA;EACA,0BAAA;EACA,UAAA;EACA,8CAAA;AAi0cF;;AA5zcA;EACE,UAAA;AA+zcF;;AA5zcA;EACE,oCAAA;EAGA,eAAA;EACA,iBAAA;AA6zcF;;AA1zcA;EACE,oBAAA;AA6zcF;;AA1zcA;EACE,8BAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;AA6zcF;;AAvzcA;EACE,YAAA;EACA,uBAAA;EACA,WAAA;AA0zcF;;AAvzcA;EACE,aAAA;EACA,sBAAA;EACA,6CAAA;AA0zcF;;AAtzcA;EACE,iBAAA;AAyzcF;;AA/xcA;EACE,kBAAA;EACA,oBAAA;EAEA,eAAA;EACA,kCAAA;EACA,yBAAA;EACA,qBAAA;AAiycF;;AA9xcA;EACE,kBAAA;EACA,oBAAA;EAEA,eAAA;EACA,kCAAA;EACA,yBAAA;EACA,qBAAA;AAgycF;;AA7xcA;EACE,kBAAA;EACA,oBAAA;EAEA,eAAA;EACA,kCAAA;EACA,yBAAA;EACA,qBAAA;AA+xcF;;AA3xcA;EACE,kBAAA;AA8xcF;;AA3xcA;EACE,wCAAA;EACA,sBAAA;EACA,uBAAA;EACA,sBAAA;EACA,qBAAA;EACA,wBAAA;AA8xcF;;AA3xcA;EACE,wCAAA;AA8xcF;;AA3xcA;EACE,wBAAA;EACA,yBAAA;AA8xcF;;AA3xcA;EACE,wCAAA;EACA,sBAAA;EAGA,oBAAA;EACA,sBAAA;EAEA,YAAA;EACA,qBAAA;EAEA,kBAAA;EACA,uBAAA;EACA,eAAA;EACA,qCAAA;EACA,sCAAA;EACA,uCAAA;AA0xcF;;AAvxcA;EACE,wCAAA;EACA,6BAAA;EACA,yBAAA;AA0xcF;;AAvxcA;EACE,wBAAA;EACA,yBAAA;AA0xcF;;AAvxcA;EACE,iCAAA;AA0xcF;;AA5wcA;EACE,WAAA;EACA,YAAA;EACA,cAAA;EACA,cAAA;EACA,+BAAA;EACA,+BAAA;AA+wcF;;AA5wcA;EACE,qBAAA;EACA,0CAAA;AA+wcF;;AAxvcA;EACE;IACE,wBAAA;EA2vcF;AACF;AAxvcA;EACE;IACE,wBAAA;EA0vcF;AACF;AAvvcA;EACE;IACE,wBAAA;EAyvcF;AACF;AAtvcA;EACE;IACE,wBAAA;EAwvcF;AACF;AArvcA;EACE;IACE,wBAAA;EAuvcF;AACF;AA7tcA;EACE,kBAAA;EACA,uBAAA;EACA,YAAA;EACA,kBAAA;EACA,wCAAA;EACA,aAAA;EACA,WAAA;EACA,+DAAA;AA+tcF;;AA5tcA;EACE,cAAA;EACA,iDAAA;AA+tcF;;AA5tcA;EACE,WAAA;EACA,aAAA;EACA,QAAA;EACA,SAAA;EACA,kBAAA;AA+tcF;;AA5tcA;EACE,cAAA;EACA,iDAAA;AA+tcF;;AA3tcA;EACE,oCAAA;AA8tcF;;AA3tcA;EACE,oCAAA;AA8tcF;;AA3tcA;EACE,oCAAA;EACA,gCAAA;AA8tcF;;AA3tcA;EACE,yBAAA;EACA,oCAAA;EACA,gCAAA;AA8tcF;;AA3tcA;EACE,yBAAA;EAEA,oCAAA;EACA,gCAAA;AA6tcF;;AA1tcA;;EAEE,oCAAA;AA6tcF;;AA1tcA;EACE,oBAAA;AA6tcF;;AA1tcA;EACE,qBAAA;EACA,gBAAA;AA6tcF;;AA1tcA;EACE,iBAAA;EACA,wCAAA;AA6tcF;;AAztcA;EACE,kBAAA;EACA,iBAAA;EACA,gBAAA;AA4tcF;;AAztcA;EACE,UAAA;AA4tcF;;AAztcA;EACE,eAAA;AA4tcF;;AAztcA;EACE,aAAA;EACA,2DAAA;EACA,SAAA;EACA,YAAA;EACA,aAAA;EACA,YAAA;EACA,kDAAA;AA4tcF;;AAztcA;EACE,aAAA;EACA,sBAAA;EACA,8CAAA;AA4tcF;;AAztcA;EACE,aAAA;EACA,qCAAA;EACA,oDAAA;EACA,QAAA;EACA,+BAAA;EACA,WAAA;EACA,sCAAA;AA4tcF;;AAztcA;EACE,YAAA;EACA,qDAAA;AA4tcF;;AAztcA;EACE,0BAAA;EACA,qDAAA;EACA,iBAAA;EACA,kBAAA;EACA,sBAAA;EACA,uBAAA;EACA,wBAAA;EACA,yCAAA;EACA,kCAAA;EACA,4BAAA;EACA,8BAAA;EACA,0BAAA;EACA,+CAAA;EACA,4BAAA;EACA,wBAAA;EACA,mDAAA;AA4tcF;;AAztcA;EACE,aAAA;EACA,mBAAA;AA4tcF;;AAztcA;EACE,mBAAA;AA4tcF;;AAptcA;EACE,kBAAA;AAutcF;;AAptcA;EACE,mBAAA;AAutcF;;AAptcA;EACE,UAAA;EACA,WAAA;EACA,iBAAA;EACA,uDAAA;EACA,kBAAA;EACA,4BAAA;AAutcF;;AAptcA;EACE,aAAA;EACA,mBAAA;EACA,sCAAA;EACA,iBAAA;AAutcF;;AAptcA;EAEE,uBAAA;AAstcF;;AAntcA;EACE,kBAAA;EACA,yBAAA;EAEA,4DAAA;EACA,iBAAA;EACA,eAAA;AAqtcF;;AAjtcA;EACE,6BAAA;AAotcF;;AAjtcA;EACE,oCAAA;EACA,gCAAA;EACA,yBAAA;AAotcF;;AAjtcA;EACE,oCAAA;EACA,gCAAA;EACA,yBAAA;AAotcF;;AAjtcA,iDAAA;AACA;EACE,mDAAA;EACA,yCAAA;EACA,yBAAA;AAotcF;;AAjtcA;EACE,gCAAA;AAotcF;;AAjtcA,oCAAA;AAEE;EACE,mBAAA;EACA,gBAAA;EACA,YAAA;EACA,iDAAA;AAmtcJ;;AA/scA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAktcF;;AA/scA;EACE,aAAA;EACA,sBAAA;EACA,gBAAA;AAktcF;AAhtcE;EACE,kBAAA;EACA,yBAAA;EACA,qBAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;AAktcJ;AA/scE;EACE,eAAA;EACA,cAAA;EACA,gBAAA;AAitcJ;;AA7scA;EACE,WAAA;EACA,YAAA;EACA,qBAAA;EACA,wBAAA;EACA,8BAAA;EACA,kCAAA;EACA,6BAAA;EACA,4BAAA;EACA,oCAAA;EACA,+BAAA;AAgtcF;AA9scE;EACE,8BAAA;EACA,gCAAA;EACA,sCAAA;EACA,mDAAA;AAgtcJ;;AA5scA;EACE,8CAAA;AA+scF;;AA5scA;EACE,gBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;EACA,kBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,6BAAA;AA+scF;AA7scE;EACE,6CAAA;EACA,yBAAA;EACA,+CAAA;AA+scJ;;AA1scE;EACE,YAAA;AA6scJ","sourcesContent":["// If you want to override variables do it here\n@import \"variables\";\n\n// Import styles\n@import \"@coreui/coreui/scss/coreui\";\n@import \"@coreui/chartjs/scss/coreui-chartjs\";\n\n// Vendors\n@import \"vendors/simplebar\";\n\n// Custom styles for this theme\n@import \"theme\";\n\n// If you want to add custom CSS you can put it here\n@import \"custom\";\n\n// ----- Detail Page Premium Polish -----\n\n.detail-index-main-wrapper {\n  background: linear-gradient(180deg, #f8f9fc 0%, #ffffff 100%);\n  min-height: 100vh;\n}\n\n.modern-back-button {\n  border-radius: 10px !important;\n  font-size: 0.8rem !important;\n  padding: 6px 16px !important;\n  transition: all 0.2s ease !important;\n  &:hover {\n    transform: translateX(-2px);\n    box-shadow: 0 4px 12px rgba(0,0,0,0.08) !important;\n  }\n}\n\n.grid-container {\n  .leaflet-container {\n    border-radius: 12px !important;\n    box-shadow: 0 2px 8px rgba(0,0,0,0.06);\n  }\n}\n\n.video-container-card {\n  background: #fff;\n  border-radius: 12px !important;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.04) !important;\n  overflow: hidden;\n}\n\n// Stats cards premium\n.stats-cards-container {\n  .stats-card-premium {\n    background: #fff;\n    border: 1px solid #eef0f4;\n    border-radius: 12px;\n    padding: 12px 16px;\n    cursor: pointer;\n    transition: all 0.2s ease;\n    min-width: 130px;\n    flex: 1;\n    &:hover {\n      transform: translateY(-3px);\n      box-shadow: 0 8px 20px rgba(0,0,0,0.06);\n      border-color: #d0d4dd;\n    }\n    &.active {\n      border-color: #5856D6;\n      background: linear-gradient(135deg, #f8f6ff 0%, #fff 100%);\n      box-shadow: 0 4px 12px rgba(88,86,214,0.1);\n    }\n    &.disabled {\n      opacity: 0.5;\n      cursor: not-allowed;\n      &:hover { transform: none; box-shadow: none; }\n    }\n  }\n  .stats-card-icon-wrapper {\n    width: 32px; height: 32px;\n    display: flex; align-items: center; justify-content: center;\n    img { width: 22px; height: 22px; object-fit: contain; }\n  }\n  .stats-card-label {\n    font-size: 0.65rem;\n    font-weight: 600;\n    color: #6c757d;\n    letter-spacing: 0.3px;\n  }\n  .stats-card-value {\n    font-size: 1.1rem;\n    font-weight: 700;\n    color: #131133;\n    .total-label { font-size: 0.6rem; font-weight: 400; color: #adb5bd; }\n  }\n}\n\n// Tabs modernos\n.tab-list-container {\n  .tablist-map-component {\n    border-bottom: 1px solid #e9ecef !important;\n    .nav-link {\n      font-size: 0.75rem !important;\n      font-weight: 600;\n      color: #6c757d !important;\n      padding: 8px 20px !important;\n      border: none !important;\n      position: relative;\n      transition: color 0.2s ease;\n      &:hover { color: #131133 !important; }\n      &.active {\n        color: #5856D6 !important;\n        background: transparent !important;\n        &::after {\n          content: '';\n          position: absolute;\n          bottom: -1px;\n          left: 0; right: 0;\n          height: 2px;\n          background: #5856D6;\n          border-radius: 2px 2px 0 0;\n        }\n      }\n    }\n  }\n}\n\n// Buscador / Filtros\n.buscador-senales-container {\n  .search-input-custom {\n    border-radius: 8px !important;\n    border: 1px solid #e0e3e8 !important;\n    font-size: 0.75rem !important;\n    padding: 6px 12px !important;\n    &:focus {\n      border-color: #5856D6 !important;\n      box-shadow: 0 0 0 2px rgba(88,86,214,0.1) !important;\n    }\n  }\n  .btn-sub-filter-pill {\n    border: 1px solid #dee2e6;\n    background: #fff;\n    border-radius: 20px;\n    padding: 4px 14px;\n    font-size: 0.65rem;\n    font-weight: 500;\n    color: #495057;\n    cursor: pointer;\n    transition: all 0.2s ease;\n    &:hover { border-color: #5856D6; color: #5856D6; background: #f8f6ff; }\n    &.active {\n      background: #5856D6;\n      color: #fff;\n      border-color: #5856D6;\n    }\n  }\n}\n\n// Tabla premium\n.ctable-list {\n  thead {\n    th {\n      background: #f8f9fc !important;\n      font-size: 0.65rem !important;\n      letter-spacing: 0.3px;\n      text-transform: uppercase;\n      color: #6c757d !important;\n      border-bottom: 2px solid #e9ecef !important;\n    }\n  }\n  tbody {\n    tr {\n      transition: background 0.15s ease;\n      &:hover { background: #f8f6ff !important; }\n      &.row-viewed-highlight {\n        background: #eef2ff !important;\n        border-left: 3px solid #5856D6;\n      }\n    }\n  }\n}\n\n// Toasts premium\n.backgroundcolor-toast-exito {\n  background: #2eb85c !important;\n  border-radius: 10px !important;\n  box-shadow: 0 8px 24px rgba(46,184,92,0.3) !important;\n}\n.backgroundcolor-toast-error {\n  background: #e55353 !important;\n  border-radius: 10px !important;\n  box-shadow: 0 8px 24px rgba(229,83,83,0.3) !important;\n}\n\n// Modern UI Enhancements\n.premium-card {\n  border-radius: 12px;\n  border: none;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);\n  transition: all 0.3s ease;\n  background: #fff;\n}\n\n.stats-card {\n  @extend .premium-card;\n  cursor: pointer;\n  padding: 15px;\n  border-left: 6px solid transparent !important;\n\n  &:hover {\n    transform: translateY(-5px);\n    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);\n  }\n\n  &.active {\n    border-left-color: #fe5000 !important;\n  }\n}\n\n.info-item {\n  display: flex;\n  align-items: center;\n  margin-bottom: 12px;\n\n  .info-label {\n    min-width: 150px;\n    font-weight: 600;\n    color: #131133;\n    font-size: 0.85rem;\n  }\n\n  .info-value {\n    color: #666;\n    font-size: 0.85rem;\n  }\n}\n\n.modern-table-container {\n  border-radius: 12px;\n  overflow: hidden;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);\n  background: white;\n}\n\n.btn-action-round {\n  width: 32px;\n  height: 32px;\n  border-radius: 50% !important;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0;\n  transition: all 0.2s;\n\n  &:hover {\n    background: #f8f9fa;\n  }\n}\n\n\n\n.btn-collapse-orange {\n  background-color: #ffffff;\n  border-radius: 5rem;\n  // padding-right: 0.1rem;\n  // padding-left: 0.1rem;\n  width: 1.3rem;\n  height: 1.3rem;\n  display: flex;\n  justify-content: center;\n  /* Centra el contenido horizontalmente */\n  align-items: center;\n  /* Centra el contenido verticalmente */\n  padding: 0.1rem;\n}\n\n.btn-collapse-orange:active {\n  background-color: #ffffff;\n  border-radius: 5rem;\n  padding: 0.1rem;\n}\n\n.btn-collapse-orange:hover {\n  background-color: #ffffff;\n  border-radius: 5rem;\n}\n\n.bg-primary-orange {\n  background-color: #fe5000;\n}\n\n.btn-primary-orange-center {\n  background-color: #fe5000;\n}\n\n.btn-primary-orange {\n  background-color: #131133;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-color: #131133;\n  color: #ffffff;\n  // font-size: 1.0em;\n  font-size: 0.9em;\n}\n\n.btn-primary-orange:hover {\n  background-color: #131133;\n  border-color: #131133;\n  color: #ffffff;\n\n}\n\n.btn-primary-orange:focus {\n  background-color: #131133;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-color: #131133;\n  color: #ffffff;\n}\n\n\n.btn-primary-orange2 {\n  background-color: #ab3000 !important;\n}\n\n.btn-primary-login {\n  background-color: #1D3354;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-color: #1D3354;\n  color: #ffffff;\n  // font-size: 1.0em;\n  font-size: 0.9em;\n}\n\n.btn-primary-login:hover {\n  background-color: #1D3354;\n  border-color: #1D3354;\n  color: #ffffff;\n\n}\n\n.btn-primary-login:focus {\n  background-color: #1D3354;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-color: #1D3354;\n  color: #ffffff;\n}\n\n.btn-search-list {\n  background-color: #ffffff;\n  border-color: #131133;\n  font-size: 0.9em;\n  border-width: 2px;\n}\n\n.btn-search-list:hover {\n  background-color: #ffffff;\n  border-color: #131133;\n  border-width: 2px;\n}\n\n.btn-search-list:focus {\n  background-color: #ffffff;\n  border-color: #131133;\n  border-width: 2px;\n}\n\n.btn-descargar-list {\n  background-color: #ffffff;\n  border-color: #131133;\n  font-size: 0.9em;\n  border-width: 2px;\n}\n\n.btn-descargar-list:hover {\n  background-color: #ffffff;\n  border-color: #131133;\n  border-width: 2px;\n}\n\n.btn-descargar-list:focus {\n  background-color: #ffffff;\n  border-color: #131133;\n  border-width: 2px;\n}\n\n.btn-salir-footer {\n  background-color: #ffffff;\n  border-color: #131133;\n  font-size: 0.9em;\n  width: 120px;\n  border-width: 1px;\n  font-weight: bold;\n  // font-style: italic;\n}\n\n.btn-salir-footer:hover {\n  background-color: #ffffff;\n  border-color: #131133;\n  width: 120px;\n  border-width: 1px;\n  font-weight: bold;\n}\n\n.btn-guardar-footer {\n  background-color: #ffffff;\n  // border-color: #131133;\n  font-size: 0.9em;\n  width: 160px;\n  // border-width: 2px;\n  font-weight: bold;\n  // font-style: italic;\n}\n\n.btn-guardar-footer:hover {\n  background-color: #ffffff;\n  // border-color: #131133;\n  width: 160px;\n  // border-width: 2px;\n  font-weight: bold;\n}\n\n.btn-next-footer {\n  background-color: #131133;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-color: #131133;\n  color: #ffffff;\n  // font-size: 1.0em;\n  font-size: 0.9em;\n  width: 120px;\n  border-width: 1px;\n  font-weight: bold;\n}\n\n.btn-next-footer:hover {\n  background-color: #131133;\n  border-color: #131133;\n  color: #ffffff;\n  width: 120px;\n  border-width: 1px;\n  font-weight: bold;\n}\n\n.btn-next-footer:focus {\n  background-color: #131133;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-color: #131133;\n  color: #ffffff;\n  width: 120px;\n}\n\n.btn-formulario-ftp {\n  background-color: #131133;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-color: #131133;\n  color: #ffffff;\n  // font-size: 1.0em;\n  font-size: 0.9em;\n  width: 180px;\n  border-width: 1px;\n  font-weight: bold;\n}\n\n.btn-formulario-ftp:hover {\n  background-color: #131133;\n  border-color: #131133;\n  color: #ffffff;\n  width: 180px;\n  border-width: 1px;\n  font-weight: bold;\n}\n\n.btn-formulario-ftp:focus {\n  background-color: #131133;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-color: #131133;\n  color: #ffffff;\n  width: 180px;\n}\n\n.btn-next-footer-model {\n  background-color: #131133;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-color: #131133;\n  color: #ffffff;\n  // font-size: 1.0em;\n  font-size: 0.9em;\n  width: 120px;\n  border-width: 1px;\n  font-weight: bold;\n  margin: auto;\n  /* Centra horizontalmente el botón */\n}\n\n.btn-next-footer-model:hover {\n  background-color: #131133;\n  border-color: #131133;\n  color: #ffffff;\n  width: 120px;\n  border-width: 1px;\n  font-weight: bold;\n}\n\n.btn-next-footer-model:focus {\n  background-color: #131133;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-color: #131133;\n  color: #ffffff;\n  width: 120px;\n}\n\n.btn-model-procesar {\n  background-color: #131133;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-color: #131133;\n  color: #ffffff;\n  // font-size: 1.0em;\n  font-size: 0.9em;\n  // width: 120px;\n  border-width: 1px;\n  font-weight: bold;\n}\n\n.btn-model-procesar:hover {\n  background-color: #131133;\n  border-color: #131133;\n  color: #ffffff;\n  // width: 120px;\n  border-width: 1px;\n  font-weight: bold;\n}\n\n.btn-model-procesar:focus {\n  background-color: #131133;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-color: #131133;\n  color: #ffffff;\n  // width: 120px;\n}\n\n.btn-form-user {\n  background-color: #ffffff;\n  border-color: #131133;\n  font-size: 0.8em;\n  width: 180px;\n  border-width: 2px;\n  font-weight: bold;\n  margin-top: 14px;\n  // font-style: italic;\n}\n\n.btn-form-user:hover {\n  background-color: #ffffff;\n  border-color: #131133;\n  width: 180px;\n  border-width: 2px;\n  font-weight: bold;\n  margin-top: 14px;\n}\n\n.btn-form-video {\n  background-color: #ffffff;\n  border-color: #ffffff;\n  font-size: 0.9em;\n}\n\n.btn-form-video:hover {\n  background-color: #ffffff;\n  border-color: #ffffff;\n}\n\n.btn-form-video:focus {\n  background-color: #ffffff;\n  border-color: #ffffff;\n}\n\n.btn-dropdown-list {\n  border-style: none;\n  border-color: #e9e6e6;\n}\n\n.sidebar-bg-orange {\n  // background-color: #001efe;\n  background-color: #131133;\n}\n\n.sidebar-icono-recoger {\n  // padding: 5%!important;\n  padding-top: 5% !important;\n  padding-left: 5% !important;\n  padding-right: 5% !important;\n  padding-bottom: 0% !important;\n}\n\n.sidebar-nav .nav-link.active {\n  background-color: #fe5000 !important;\n}\n\n.sidebar-toggler-icon {\n  background-image: url(\"next2.png\") !important;\n  /* Reemplaza con la ruta a tu SVG */\n  background-size: contain;\n  /* Ajusta el tamaño del icono al contenedor */\n  background-repeat: no-repeat;\n  /* Agrega otros estilos para el icono */\n}\n\n.sidebar-narrow .sidebar-toggler-icon {\n  background-image: url(\"next.png\") !important;\n  /* Reemplaza con la ruta a tu SVG */\n  background-size: contain;\n  /* Ajusta el tamaño del icono al contenedor */\n  background-repeat: no-repeat;\n}\n\n.sidebar-narrow .sidebar-icono-recoger {\n  padding-top: 30% !important;\n}\n\n.sidebar-narrow .sidebar-toggler,\n.sidebar-narrow-unfoldable:not(:hover) .sidebar-toggle {\n  padding-top: 15%;\n}\n\n.sidebar-toggler-color {\n  background-color: #cbc9c9;\n}\n\n.sidebar-toggler-focus-color {\n  background-color: #db0c0c;\n}\n\n.sidebar-toggler-focus-shadow {\n  background-color: #f31010;\n}\n\n.image-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100% !important;\n  padding-bottom: 10%;\n  border-style: none !important;\n  margin-top: 8%;\n  // height: 100vh; /* Ocupa toda la altura de la ventana */\n}\n\n.image-container-img {\n  max-width: 60%;\n  /* Ajusta el porcentaje según tus necesidades */\n  max-height: 60%;\n  /* Ajusta el porcentaje según tus necesidades */\n}\n\n@media (min-width: 1200px) {\n  .card-image-login {\n    height: 560px !important;\n  }\n}\n\n@media (max-width: 1200px) {\n  .card-image-login {\n    height: 510px !important;\n  }\n}\n\n// .card-image-login {\n//   height: 560px;\n//   }\n\n@media (min-width: 1200px) {\n  .cardgroup-image-login {\n    height: 100px !important;\n  }\n}\n\n@media (max-width: 992px) {\n  .card-image-login {\n    height: 441px !important;\n  }\n}\n\n@media (max-width: 1200px) {\n  .cardgroup-image-login {\n    height: 451px !important;\n  }\n}\n\n.padding-car-login-externo {\n  padding-left: 10px;\n  padding-right: 10px;\n}\n\n//   @media (min-width: 768px) {\n//     .col-md-6 {\n//         flex: 0 0 auto;\n//         width: 45%!important;\n//     }\n// }\n// .image-container-img-login {\n//   width: 128%!important; /* Ajusta el porcentaje según tus necesidades */\n//   // max-height: 60%; /* Ajusta el porcentaje según tus necesidades */\n// }\n/* Estilos base para la imagen */\n// .image-container-img-login {\n//   width: 100%; /* Ancho del CCardImage al 100% del CCard */\n//   height: 100%; /* Ajusta la altura automáticamente para mantener la relación de aspecto */\n//   object-fit: cover; /* Ajusta la imagen para que cubra todo el espacio */\n// }\n\n/* Media queries para diferentes tamaños de pantalla */\n// @media (min-width: 1200px) { /* Para pantallas de 768px o más (tabletas y escritorios) */\n//   .quitar-padding .c-card {\n//     width: 100%; /* Define el ancho del CCard para pantallas más grandes */\n//     height: 100px;\n//   }\n// }\n\n// /* Media queries para diferentes tamaños de pantalla */\n// @media (min-width: 768px) { /* Para pantallas de 768px o más (tabletas y escritorios) */\n//   .quitar-padding .c-card {\n//     width: 100%; /* Define el ancho del CCard para pantallas más grandes */\n//     height: 1000px;\n//   }\n// }\n\n// @media (max-width: 767px) { /* Para pantallas de menos de 768px (móviles) */\n//   .quitar-padding .c-card {\n//     width: 300px; /* Define el ancho del CCard para pantallas más pequeñas */\n//     height: 600px;\n//   }\n// }\n\n// .quitar-padding .image-container-img-login {\n//   width: 100%; /* Ajusta el ancho del CCardImage al 100% del CCard */\n//   height: 100%;\n// }\n\n// .quitar-padding .c-card {\n//   width: 600px; /* Ajusta el ancho del CCard al tamaño de la imagen */\n//   height: 45%; /* Ajusta la altura del CCard al tamaño de la imagen */\n// }\n\n.currentImage {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.alert-acya {\n  padding-top: 0.3rem;\n  padding-bottom: 0.3rem;\n}\n\n.row-center {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.row-center-login-btn {\n  padding-top: 3%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding-right: 5px;\n}\n\n.titulo-card-center {\n  text-align: center;\n  background-color: #fe5000;\n}\n\n.row-list-field {\n  margin: 0.1%;\n  padding-top: 2%;\n}\n\n.row-map {\n  height: 50px;\n}\n\n.grid-container {\n  display: grid;\n  grid-template-columns: 1fr 0.35fr;\n  grid-template-rows: auto;\n  gap: 20px;\n  align-items: start;\n}\n\n@media (max-width: 1200px) {\n  .grid-container {\n    grid-template-columns: 1fr;\n  }\n}\n\n\n.grid-container-2 {\n  display: grid;\n  grid-template-columns: 1fr;\n  grid-template-rows: auto;\n  gap: 20px;\n}\n\n\n\n.grid-container-3 {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  /* O la cantidad de columnas que uses */\n  grid-gap: 15px;\n  /* Ajusta este valor a tu gusto */\n  padding: 10px;\n  /* Ajusta este valor a tu gusto */\n  display: flex;\n  flex-wrap: wrap;\n}\n\n.grid-item {\n  // background-color: #eee;\n  // padding: 5px;\n  // text-align: center;\n  background-color: #ffffff;\n  // padding: 5px;\n  text-align: center;\n  // min-height: 250px; /* Aquí se establece la altura mínima */\n  // border: 1px solid #ccc;\n}\n\n.video-container {\n  background-color: #ffffff;\n  width: 80%;\n  margin: 0 auto;\n  // padding-top: 10%;\n}\n\n.video-container-card {\n  background-color: #ffffff;\n  border-style: none;\n}\n\n.video-grande {\n  width: 100%;\n  height: 150px;\n}\n\n.btn-list {\n  padding-top: 1rem;\n  padding-left: 2.5rem;\n}\n\n.container-card-list {\n  // background-color: #eee;\n  border-style: none;\n  font-size: 0.7em;\n}\n\n.ctable-list {\n  font-size: 0.7em;\n  // overflow-x: auto;\n  // min-width: 10px;\n  // width: 10px;\n}\n\n// .ctable-list .fgh{\n//   // font-size: 0.7em;\n//   overflow-x: auto;\n//   min-width: 10px;\n// }\n\n.my-tall-cell {\n  height: 1vh !important;\n  padding-top: 0px !important;\n}\n\n.tab-list-container {\n  background-color: #ffffff;\n  width: 95%;\n  max-width: 100%;\n  margin: 0 auto;\n  padding-top: 2%;\n  font-size: 0.8em;\n  \n  @media (max-width: 768px) {\n    width: 100%;\n    padding: 10px;\n  }\n}\n\n.list-tab-group {\n  font-size: 0.9em;\n  // padding: 0;\n  // margin: 0;\n}\n\n.list-group-2 {\n  padding-top: 12%;\n}\n\n.list-group-item-2 {\n  background-color: #ffffff !important;\n  background-color: #ffffff;\n  border-style: none;\n  padding-top: 10%;\n  padding-left: 10%;\n}\n\n.titulo-grid-3 {\n  font-size: 0.8 !important;\n  padding-bottom: 0.1em;\n  margin-bottom: 0.3em;\n}\n\n.list-group-grid-4 {\n  // background-color: #d6d2d2!important;\n  background-color: #ffffff;\n  border-style: none;\n  // padding-top: 10%;\n}\n\n.titulo-grid-4 {\n  padding-top: 12%;\n  background-color: #ffffff;\n  border-style: none;\n}\n\n.titulo-grid-4-2 {\n  padding-top: 0.5em;\n  padding-left: 0.3em;\n}\n\n.p-grid-4-2 {\n  padding-top: 0.3em;\n  padding-left: 1em;\n}\n\n.text-grid-4-2 {\n  font-size: 0.8em;\n}\n\n.row-items-grid-4-1 {\n  // padding-left: 13%;\n  margin: 0px;\n  border-style: none;\n  font-size: 0.8em;\n}\n\n.row-items-grid-4-2 {\n  // padding-right: 13%;\n  margin: 0px;\n  border-style: none;\n  font-size: 0.8em;\n}\n\n.icon-grid-4 {\n  padding-right: 5%;\n\n}\n\n.separator {\n  border-bottom: 1px solid #cbc9c9;\n  margin: 20px 0;\n}\n\n/* Responsive adjustments for project detail items */\n@media (max-width: 768px) {\n  .tablist-map-component {\n    flex-direction: column !important;\n  }\n\n  .stats-card {\n    padding: 10px !important;\n  }\n\n  .h4 {\n    font-size: 1.25rem !important;\n  }\n}\n\n\n.container-card-grip-4 {\n  background-color: #ffffff;\n  border-style: none;\n  padding-top: 0.8em;\n  padding-left: 1.2em;\n  padding-right: 1.2em;\n}\n\n.sidebar-footer-content {\n  display: flex;\n  justify-content: space-between;\n  /* Espaciado entre las secciones */\n  align-items: center;\n  /* Alineación vertical */\n  padding: 10px;\n  /* Espacio interno */\n}\n\n\n// .sidebar-footer-left {\n\n// }\n\n.sidebar-footer-right {\n  text-align: right;\n  /* Alineación del texto a la derecha */\n}\n\n.sidebar-footer-name {\n  font-size: 1em;\n  /* Tamaño de letra del nombre */\n  // margin-bottom: 5px; /* Espacio entre el nombre y correo */\n  margin-left: 6px;\n}\n\n.sidebar-footer-email {\n  font-size: 0.8em;\n  /* Tamaño de letra del correo */\n  color: #d8d8d8;\n  /* Color del correo (opcional) */\n  margin-left: 5px;\n}\n\n.sidebar-nav-link-hover-bg {\n  background-color: #fe5000;\n}\n\n.margin-row-contenedor {\n  margin: 22px;\n}\n\n.padding-titulo-list-contenedor {\n  padding-bottom: 15px;\n}\n\n.margin-bottom-h5 {\n  margin-bottom: 0.1em !important;\n  padding-left: 0.5em;\n  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n  color: #131133;\n}\n\n.solid-col-list {\n  border-color: #fe5000;\n  // border-top-style: solid;\n  font-weight: bold;\n  padding: 0.2em;\n}\n\n.solid-col-list-2 {\n  padding-right: 0.2em;\n}\n\n.solid-col-list-3 {\n  margin-top: 2em;\n  padding-left: 1px;\n}\n\n.solid-col-list-4 {\n  margin-top: 0.9em;\n  padding-left: 1px;\n}\n\n.form-select-list-estado {\n  font-size: 1.0em;\n}\n\n.form-select-list-estado-2 {\n  font-size: 1.0em;\n}\n\n.form-select-list-estado-3 {\n  font-size: 1.0em;\n}\n\n.icon-background-orange {\n  background-color: #fe5000;\n  padding: 0.3em;\n}\n\n.contenedor-table-list-titulo {\n  padding-bottom: 0.6em;\n}\n\n.contenedor-table-list {\n  padding-top: 0.1em;\n}\n\n.scroll-contenedor-new-proyect {\n  width: 100%;\n  height: 800px;\n  // border: 1px dotted black;\n  overflow-y: scroll;\n  /* Add the ability to scroll */\n  // overflow-x: scroll; /* Add the ability to scroll */\n  // scrollbar-width: none;\n}\n\n.container-tabla {\n  /* Nombre de la clase del contenedor de tu tabla */\n  // overflow: auto;\n  // -ms-overflow-style: none;  /* IE and Edge */\n  // scrollbar-width: none;  /* Firefox */\n  // height: '1500px';\n  // width: '120%';\n  // background-color: #eee;\n  // width: 62rem;\n  // width: 160vh;\n  // width: 975px;\n  width: 100%;\n  height: 60%;\n  // border: 1px dotted black;\n  overflow: scroll;\n  /* Add the ability to scroll */\n  // overflow-x: scroll; /* Add the ability to scroll */\n  scrollbar-width: none;\n}\n\n/* Hide scrollbar for Chrome, Safari and Opera */\n.container-tabla::-webkit-scrollbar {\n  display: none;\n}\n\n/* Hide scrollbar for IE, Edge and Firefox */\n.container-tabla {\n  -ms-overflow-style: none;\n  /* IE and Edge */\n  scrollbar-width: none;\n  /* Firefox */\n}\n\n.container-tabla::-webkit-scrollbar {\n  display: none;\n  /* Chrome, Safari, Opera */\n}\n\n.dropdown-toggle-list::after {\n  border: 0.1em;\n  margin-left: 0.1em;\n}\n\n.dropdown-menu-list {\n  font-size: 0.7rem;\n  min-width: 7rem;\n}\n\n.dropdown-item:active {\n  background-color: #f0f0f0;\n}\n\n.fuente-letra-oscura {\n  color: #0c0c0c;\n}\n\n.fuente-letra-gris {\n  color: #7b8089f2;\n}\n\n// .nav-link.active {\n//   color: #fe5000!important;\n// }\n// .nav-link:hover {\n//   color: #fe5000!important;\n// }\n\n.inner-addon {\n  position: relative;\n  padding-top: 1.2rem;\n}\n\n.inner-addon .glyphicon {\n  position: absolute;\n  padding: 10px;\n  pointer-events: none;\n}\n\n.left-addon .glyphicon {\n  left: 0px;\n}\n\n.right-addon .glyphicon {\n  right: 75%;\n}\n\n.left-addon input {\n  padding-left: 30px;\n}\n\n.right-addon input {\n  padding-right: 30px;\n}\n\n.quitar-padding {\n  padding: 0px !important;\n}\n\n.quitar-padding-with {\n  padding: 0px !important;\n  width: 50%;\n}\n\n.quitar-padding-with-2 {\n  padding: 0px !important;\n  width: 53%;\n}\n\n.quitar-padding-map {\n  padding-top: 0px !important;\n  padding-left: 0px !important;\n  padding-right: 0px !important;\n  padding-bottom: 3px !important;\n}\n\n.padding-botoom-1 {\n  padding-top: 0px !important;\n  padding-left: 0px !important;\n  padding-right: 0px !important;\n  padding-bottom: 3px !important;\n}\n\n.padding-botones-model {\n  padding-left: 2rem;\n}\n\n.tablist-map-component {\n  margin-top: 1.1rem;\n}\n\n.asb:active {\n  // color: #000000ae!important;\n  border-bottom-color: #fe5000 !important;\n}\n\n\n\n.asb {\n  color: #000000ae !important;\n  // border-bottom-color:#fe5000!important;\n}\n\n.asb:hover {\n  color: #0b0b0bae !important;\n  border-bottom-color: #fe5000 !important;\n}\n\n.text-card-frame {\n  font-size: 0.75rem;\n}\n\n.margin-bottom-table {\n  margin-bottom: 0.4rem;\n}\n\n.tabpanel-aling-content {\n  text-align: start !important;\n}\n\n.button-modal-frame {\n  border-radius: 1rem;\n  background-color: #0075ff0d;\n  border-color: #0075ff0d;\n}\n\n.titulo-formulario-new-proyect {\n  margin-top: 1.5rem;\n  margin-left: 1rem;\n  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n  font-weight: bold;\n  color: #1D3354;\n  font-size: 18px;\n}\n\n.titulo-formulario-new-carretera {\n  margin-top: 0.1rem;\n  // margin-left: 1rem;\n  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n  font-weight: bold;\n  color: #1D3354;\n  font-size: 17px;\n}\n\n\n.titulo-formulario-new-user {\n  margin-top: 1.5rem;\n  margin-left: 1rem;\n  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n  font-weight: bold;\n  color: #1D3354;\n  font-size: 15px;\n}\n\n.titulo-formulario-new-video {\n  margin-top: 1.5rem;\n  margin-left: 1rem;\n  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n  font-weight: bold;\n  color: #1D3354;\n  font-size: 18px;\n}\n\n.delete-border-color {\n  border-color: #ffffff00 !important;\n}\n\n.footer-form-video-estilo {\n  // position: relative; /* Por defecto, el pie de página no estará fijo */\n  position: absolute;\n  /* Por defecto, el pie de página no estará fijo */\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  background-color: white;\n  border: 2px orange;\n  padding: 1rem;\n  text-align: center;\n  z-index: 90;\n}\n\n/* Estilo para el pie de página fijo */\n.footer-form-video-estilo.fixed {\n  position: fixed;\n  /* Fija el pie de página cuando se aplica la clase 'fixed' */\n}\n\n.footer-text-save-leave {\n  padding-right: 25rem;\n}\n\n.icon-save-leave {\n  background-color: #52CCA7;\n  border-radius: 40px;\n  padding: 0.3rem;\n  width: 1.7rem !important;\n  height: 1.7rem !important;\n  margin-right: 0.5rem;\n  vertical-align: middle;\n}\n\n.icon-add-item {\n  background-color: #1D3354;\n  border-radius: 40px;\n  padding: 0.35rem;\n  width: 1.3rem !important;\n  height: 1.3rem !important;\n  margin-right: 0.5rem;\n  vertical-align: middle;\n}\n\n.icon-button-upload {\n  padding-right: 0.35rem;\n}\n\n\n.image-uploader {\n  display: flex;\n  flex-direction: column;\n  /* Ordena elementos verticalmente */\n  align-items: center;\n  /* Centra horizontalmente los elementos */\n  padding-top: 3rem;\n  padding-bottom: 3rem;\n}\n\n.image-uploader-form-user {\n  display: flex;\n  flex-direction: column;\n  /* Ordena elementos verticalmente */\n  align-items: center;\n  /* Centra horizontalmente los elementos */\n  padding-top: 2rem;\n  padding-bottom: 2rem;\n}\n\n.image-uploader-form-video {\n  display: flex;\n  flex-direction: column;\n  /* Ordena elementos verticalmente */\n  align-items: center;\n  /* Centra horizontalmente los elementos */\n  padding-top: 1rem;\n  padding-bottom: 2rem;\n}\n\n.avatar-container {\n  width: 100px;\n  /* Ajusta el tamaño del avatar */\n  height: 100px;\n  border-radius: 50%;\n  /* Crea un avatar circular */\n  overflow: hidden;\n  /* Oculta el exceso de imagen */\n  margin-bottom: 3rem;\n  /* Espacio entre avatar y botón */\n}\n\n.avatar2 {\n  width: 15%;\n  /* Ajusta el tamaño de la imagen al contenedor */\n  height: 15%;\n  object-fit: cover;\n  /* Ajusta la imagen para que cubra todo el contenedor */\n  border-radius: 50%;\n  /* Crea un avatar circular */\n}\n\n.avatar2-video {\n  // width: 5%; /* Ajusta el tamaño de la imagen al contenedor */\n  // height: 5%;\n  width: 30%;\n  height: 30%;\n  object-fit: cover;\n  /* Ajusta la imagen para que cubra todo el contenedor */\n  border-radius: 50%;\n  /* Crea un avatar circular */\n}\n\n.avatar3 {\n  width: 50%;\n  /* Ajusta el tamaño de la imagen al contenedor */\n  height: 50%;\n  object-fit: cover;\n  /* Ajusta la imagen para que cubra todo el contenedor */\n  border-radius: 50%;\n  /* Crea un avatar circular */\n}\n\n.image-uploader-avatar3 {\n  display: flex;\n  flex-direction: column;\n  /* Ordena elementos verticalmente */\n  align-items: center;\n  /* Centra horizontalmente los elementos */\n  padding-top: 1rem;\n  padding-bottom: 1rem;\n  font-size: 12px;\n  color: #131133;\n  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n}\n\n.image-uploader-avatar3 strong {\n  display: flex;\n  flex-direction: column;\n  /* Ordena elementos verticalmente */\n  align-items: center;\n  /* Centra horizontalmente los elementos */\n  padding-top: 0.1rem;\n  padding-bottom: 0.1rem;\n  font-size: 14px;\n}\n\n.avatar-placeholder {\n  width: 15%;\n  height: 15%;\n  background-color: #ff0000;\n  /* Color de fondo del placeholder */\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 20px;\n  color: #666;\n}\n\n.icon-check {\n  // width: 5%; /* Ajusta el tamaño de la imagen al contenedor */\n  // height: 5%;\n  width: 17%;\n  height: 17%;\n  object-fit: cover;\n  /* Ajusta la imagen para que cubra todo el contenedor */\n  border-radius: 50%;\n  /* Crea un avatar circular */\n}\n\n.icon-arrow-down {\n  // width: 5%; /* Ajusta el tamaño de la imagen al contenedor */\n  // height: 5%;\n  // width: 30%;\n  // height: 30%;\n  // object-fit: cover; /* Ajusta la imagen para que cubra todo el contenedor */\n  // border-radius: 50%; /* Crea un avatar circular */\n  vertical-align: middle;\n  /* Centra verticalmente la imagen */\n}\n\n.icon-arrow-collapse {\n  // width: 5%; /* Ajusta el tamaño de la imagen al contenedor */\n  // height: 5%;\n  width: 120%;\n  height: 120%;\n  object-fit: cover;\n  /* Ajusta la imagen para que cubra todo el contenedor */\n  border-radius: 50%;\n  /* Crea un avatar circular */\n}\n\n.icon-delete-collapse {\n  // width: 5%; /* Ajusta el tamaño de la imagen al contenedor */\n  // height: 5%;\n  width: 70%;\n  height: 80%;\n  object-fit: cover;\n  /* Ajusta la imagen para que cubra todo el contenedor */\n  border-radius: 50%;\n  /* Crea un avatar circular */\n  margin-bottom: 8px;\n}\n\n.icon-add-form {\n  // width: 5%; /* Ajusta el tamaño de la imagen al contenedor */\n  // height: 5%;\n  width: 15%;\n  height: 15%;\n  // object-fit: cover; /* Ajusta la imagen para que cubra todo el contenedor */\n  // border-radius: 50%; /* Crea un avatar circular */\n}\n\n.file-input {\n  display: none;\n  /* Oculta el campo de entrada de archivos */\n  font-size: small;\n  background-color: #ab3000 !important;\n}\n\n// .select-button {\n//   padding: 8px 16px;\n//   background-color: #4CAF50; /* Color de fondo del botón */\n//   color: white;\n//   border: none;\n//   border-radius: 4px;\n//   cursor: pointer;\n// }\n\n.container-upload-file {\n  margin: 20px;\n  padding-right: 5px !important;\n  padding-left: 5px !important;\n  border-style: dotted;\n  border-width: 2px;\n  /* Aumenta el ancho del borde */\n}\n\n.container-upload-video {\n  margin: 5px;\n}\n\n.text-right-aling {\n  text-align: right;\n\n}\n\n.margin-button-forgot-pass {\n  margin-right: 20px;\n  font-size: 0.8rem;\n}\n\n.modal-backdrop {\n  opacity: 0.8 !important;\n}\n\n.letra-login {\n  font-size: 12px;\n  color: #1D3354;\n  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n}\n\n.letra-titulo-1 {\n  color: #1D3354 !important;\n  font-size: 15px !important;\n  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n  font-weight: bold;\n}\n\n.letra-titulo-2 {\n  color: #1D3354 !important;\n  font-size: 12px !important;\n  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n}\n\n.letra-titulo-3 {\n  color: #131133 !important;\n  font-size: 12px !important;\n  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n}\n\n.letra-contenido {\n  color: #1D3354 !important;\n  font-size: 12px !important;\n  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n}\n\n.letra-contenido-2 {\n  color: #1D3354 !important;\n  font-size: 12px !important;\n  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n  font-weight: bold;\n}\n\n.letra-contenido-3 {\n  color: #1D3354 !important;\n  font-size: 11px !important;\n  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n  font-weight: normal;\n}\n\n.letra-contenido-4 {\n  color: #1D3354 !important;\n  font-size: 14px !important;\n  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n  font-weight: bold;\n}\n\n.letra-contenido-5 {\n  color: #1D3354 !important;\n  font-size: 13px !important;\n  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n  font-weight: normal;\n}\n\n.letra-contenido-6 {\n  color: #e55353 !important;\n  font-size: 12px !important;\n  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n  font-weight: bold;\n  padding-right: 1rem;\n}\n\n.letra-contenido-7 {\n  color: #0fe016 !important;\n  font-size: 12px !important;\n  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n  font-weight: bold;\n  padding-right: 1rem;\n}\n\n.letra-titulo-modal {\n  color: #1D3354 !important;\n  font-size: 18px !important;\n  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n}\n\n.letra-contenido-modal {\n  color: #1D3354 !important;\n  font-size: 15px !important;\n  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n}\n\n.letra-contenido-modal-input {\n  color: #1D3354 !important;\n  font-size: 12px !important;\n  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n  font-style: italic;\n}\n\n.letra-btn-agregar {\n  color: #1D3354 !important;\n  font-size: 12px !important;\n  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n  font-weight: bold;\n}\n\n.with-column-dateuser {\n  width: 30% !important;\n}\n\n.titulo-table-padding {\n  padding-top: 0px !important;\n  padding-left: 0px !important;\n  padding-right: 0px !important;\n  padding-bottom: 7px !important;\n  font-size: 15px;\n  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n  color: #1D3354 !important;\n}\n\n.titulo-table-padding-password {\n  padding-top: 0px !important;\n  padding-left: 40px !important;\n  padding-right: 0px !important;\n  padding-bottom: 7px !important;\n  font-size: 15px;\n  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n  color: #1D3354 !important;\n}\n\n.padding-left-footer-next {\n  padding-left: 3rem;\n}\n\n.modal-width-content-img {\n  width: 1200px;\n}\n\n\n.width-hr-form-new-proyect {\n  width: 83%;\n}\n\n\n.quitar-margin-hr {\n  margin-top: 0;\n}\n\n.width-card-anotaciones {\n  width: 110% !important;\n  // margin-left: 30px; /* Elimina el margin */\n  margin-right: 30px;\n  /* Elimina el margin */\n\n}\n\n.rsd {\n  padding-top: 15px;\n  padding-left: 30px;\n  padding-right: 30px;\n\n}\n\n.rsd2 {\n  padding-bottom: 1px;\n}\n\n.sticky-header {\n  position: sticky;\n  top: 0;\n  background-color: white;\n  /* O el color que desees */\n  z-index: 1;\n  /* Asegura que esté por encima del contenido */\n  transform: translateY(-10px);\n  /* Ajusta el valor según sea necesario */\n}\n\n.sticky-header-modal {\n  position: sticky;\n  top: 0;\n  background-color: white;\n  /* O el color que desees */\n  z-index: 1;\n  /* Asegura que esté por encima del contenido */\n  transform: translateY(-18px);\n  /* Ajusta el valor según sea necesario */\n}\n\n.sticky-header-detail {\n  position: sticky;\n  top: 0;\n  background-color: white;\n  /* O el color que desees */\n  z-index: 1;\n  /* Asegura que esté por encima del contenido */\n  // transform: translateY(15px); /* Ajusta el valor según sea necesario */\n}\n\n\n.width-img-search {\n  width: 85%;\n}\n\n.btn-movie-nf {\n  background-color: #FD4F00 !important;\n  // width: 20%;\n  // height: 20%;\n  padding: 0.1rem;\n  font-size: 0.5rem;\n}\n\n.spam-file-movie {\n  padding-left: 0.5rem;\n}\n\n.table-spam-movie {\n  border-style: solid !important;\n  border: #d2d7e8;\n  border-width: 2px;\n  border-radius: 40px;\n\n\n}\n\n\n.my-tall-cell {\n  height: 10px;\n  padding: 0px !important;\n  margin: 0px;\n}\n\n.datePicker-container {\n  display: flex;\n  flex-direction: column;\n  /* Coloca los elementos uno encima del otro */\n}\n\n\n.card-detalles-map {\n  margin-left: 40px;\n}\n\n// .btn-round-small {\n//   border-radius: 50%; /* Crea un círculo */\n//   padding: 1px 6px; /* Ajusta el padding según tu necesidad */\n//   font-size: 10px; /* Ajusta el tamaño de la fuente */\n//   background-color: #C3D0DD;\n//   border-color: #C3D0DD;\n// }\n// .btn-round-small:focus {\n//   border-radius: 50%; /* Crea un círculo */\n//   padding: 1px 6px; /* Ajusta el padding según tu necesidad */\n//   font-size: 10px; /* Ajusta el tamaño de la fuente */\n//   background-color: #C3D0DD;\n//   border-color: #C3D0DD;\n// }\n\n// .btn-round-small:active {\n//   border-radius: 50%; /* Crea un círculo */\n//   padding: 1px 6px; /* Ajusta el padding según tu necesidad */\n//   font-size: 10px; /* Ajusta el tamaño de la fuente */\n//   background-color: #C3D0DD;\n//   border-color: #C3D0DD;\n// }\n\n.btn-round-small-find {\n  border-radius: 50%;\n  /* Crea un círculo */\n  // padding: 1px 6px; /* Ajusta el padding según tu necesidad */\n  font-size: 10px;\n  /* Ajusta el tamaño de la fuente */\n  background-color: #ffffff;\n  border-color: #131133;\n}\n\n.btn-round-small-find:focus {\n  border-radius: 50%;\n  /* Crea un círculo */\n  // padding: 1px 6px; /* Ajusta el padding según tu necesidad */\n  font-size: 10px;\n  /* Ajusta el tamaño de la fuente */\n  background-color: #ffffff;\n  border-color: #131133;\n}\n\n.btn-round-small-find:hover {\n  border-radius: 50%;\n  /* Crea un círculo */\n  // padding: 1px 6px; /* Ajusta el padding según tu necesidad */\n  font-size: 10px;\n  /* Ajusta el tamaño de la fuente */\n  background-color: #ffffff;\n  border-color: #131133;\n}\n\n\n.padding-tooltip {\n  padding-left: 15px;\n}\n\n.btn-ocultar-password {\n  background-color: transparent !important;\n  /* Eliminar el fondo */\n  border: none !important;\n  /* Eliminar el borde */\n  padding: 0 !important;\n  /* Eliminar el padding */\n}\n\n.btn-ocultar-password:hover {\n  background-color: transparent !important;\n}\n\n.btn-ocultar-password:focus {\n  outline: none !important;\n  /* Eliminar el contorno */\n}\n\n.btn-modal-process {\n  background-color: transparent !important;\n  /* Eliminar el fondo */\n  // border: none !important;   /* Eliminar el borde */\n  // // padding: 0 !important;     /* Eliminar el padding */\n  padding-left: 0.1rem;\n  /* Estilos del botón */\n  // background-color: #f0f0f0; /* Color de fondo */\n  border: none;\n  /* Elimina el borde */\n  // padding: 5px 10px; /* Espaciado interno */\n  border-radius: 5px;\n  /* Bordes redondeados */\n  cursor: pointer;\n  /* Cursor de mano al pasar el mouse */\n  transition: background-color 0.3s ease;\n  /* Transición suave al pasar el mouse */\n}\n\n.btn-modal-process:hover {\n  background-color: transparent !important;\n  /* Estilo al pasar el mouse */\n  background-color: #f00505;\n}\n\n.btn-modal-process:focus {\n  outline: none !important;\n  /* Eliminar el contorno */\n}\n\n.no-padding-x {\n  --cui-btn-padding-x: 0 !important;\n}\n\n// .btn-modal-process img {\n//   width: 35px;\n//   height: 35px;\n//   display: block;\n//   margin: 0 auto;\n//   transition: transform 0.2s ease; /* Añade una transición suave */\n// }\n\n// .btn-modal-process:hover img {\n//   transform: scale(1.1); /* Aumenta el tamaño de la imagen en 10% */\n// }\n.btn-modal-process img {\n  width: 35px;\n  height: 35px;\n  display: block;\n  margin: 0 auto;\n  transition: transform 0.2s ease;\n  /* Añade una transición suave */\n}\n\n.btn-modal-process:active img {\n  transform: scale(1.1);\n  /* Aumenta el tamaño de la imagen en 10% */\n}\n\n// .footer-form-video-estilo {\n//   display: flex; /* Activa flexbox en el footer */\n//   justify-content: space-between; /* Distribuye los elementos uniformemente */\n//   align-items: center; /* Alinea verticalmente los elementos */\n//   padding: 1rem; /* Agrega espacio interno */\n// }\n\n// .footer-form-video-estilo .btn-next-footer {\n//   margin-left: 1rem; /* Agrega espacio entre el botón siguiente y el botón cancelar */\n// }\n\n// .footer-text-save-leave {\n//   display: flex; /* Activa flexbox en el contenedor de texto */\n//   align-items: center; /* Alinea verticalmente los elementos */\n// }\n\n// .icon-save-leave {\n//   margin-right: 0.5rem; /* Agrega espacio entre el icono y el texto */\n// }\n\n@media (min-width: 1200px) {\n  .card-image-login {\n    height: 560px !important;\n  }\n}\n\n@media (max-width: 1200px) {\n  .card-image-login {\n    height: 510px !important;\n  }\n}\n\n@media (min-width: 1200px) {\n  .cardgroup-image-login {\n    height: 100px !important;\n  }\n}\n\n@media (max-width: 992px) {\n  .card-image-login {\n    height: 441px !important;\n  }\n}\n\n@media (max-width: 1200px) {\n  .cardgroup-image-login {\n    height: 451px !important;\n  }\n}\n\n// .contenedor-scroll-tabla-list {\n//   overflow: auto;\n//   height: 370px;\n//   width: 160vh;\n// }\n\n// @media (min-width: 1375px) {\n//   .contenedor-scroll-tabla-list {\n//     overflow: auto;\n//     height: 370px;\n//     width: 100%;\n//   }\n// }\n\n// @media (max-width: 1375px) {\n//   .contenedor-scroll-tabla-list {\n//     overflow: auto;\n//     height: 370px;\n//     width: 100%;\n//   }\n// }\n\n\n.tooltip-container {\n  position: absolute;\n  background-color: white;\n  padding: 5px;\n  border-radius: 5px;\n  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);\n  display: none;\n  z-index: 10;\n  /* Asegúrate de que el tooltip esté arriba de otros elementos */\n}\n\n.truncate-cell .truncate-text:hover .tooltip-container {\n  display: block;\n  /* Muestra el tooltip solo cuando está truncado */\n}\n\n.truncate-cell .truncate-text::before {\n  content: \"\";\n  display: none;\n  width: 0;\n  height: 0;\n  visibility: hidden;\n}\n\n.is-truncated .tooltip-container {\n  display: block;\n  /* Muestra el tooltip solo cuando está truncado */\n}\n\n\n.backgroundcolor-toast-exito {\n  background-color: #131133 !important;\n}\n\n.backgroundcolor-toast-error {\n  background-color: #e40101 !important;\n}\n\n.form-check-input:checked {\n  background-color: #131133 !important;\n  border-color: #131133 !important\n}\n\n.page-link {\n  color: #ffffff !important;\n  background-color: #131133 !important;\n  border-color: #131133 !important\n}\n\n.page-link:active {\n  color: #ffffff !important;\n  // background-color: #131133!important;\n  background-color: #fe5000 !important;\n  border-color: #131133 !important\n}\n\n.page-link.active,\n.active>.page-link {\n  background-color: #fe5000 !important;\n}\n\n.padding-separar-boton {\n  padding-left: 0.4rem;\n}\n\n.padding-separar-boton-descargar {\n  padding-left: 0.25rem;\n  line-height: 1.5;\n}\n\n.texto-desplazado {\n  margin-left: 1rem;\n  /* Ajusta el valor según sea necesario */\n\n}\n\n.align-inicio {\n  align-items: start;\n  padding-left: 0px;\n  margin-left: 0px;\n}\n\n.with-hr-form {\n  width: 50%;\n}\n\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.grid-container-4-cards {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n  gap: 10px;\n  height: 100%;\n  padding: 10px;\n  width: 97.5%;\n  /* Ajusta el ancho del contenedor general al 80% */\n}\n\n.card-4-cards {\n  display: flex;\n  flex-direction: column;\n  /* Para que las tarjetas ocupen todo el alto */\n}\n\n.grid-container-3-4-card {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  /* Repite 4 columnas, cada una con un tamaño igual */\n  gap: 1px;\n  /* Espacio entre las tarjetas */\n  width: 100%;\n  /* Ocupa todo el ancho de la tarjeta */\n}\n\n.width-card-anotaciones {\n  height: 100%;\n  /*  Ajusta el alto para que se ajuste a la columna  */\n}\n\n.loading-overlay {\n  position: fixed !important;\n  /* Posición fija para que esté siempre en la página */\n  top: 0 !important;\n  left: 0 !important;\n  width: 100% !important;\n  height: 100% !important;\n  display: flex !important;\n  /* Usar flexbox para centrar el spinner */\n  justify-content: center !important;\n  /* Centrar horizontalmente */\n  align-items: center !important;\n  /* Centrar verticalmente */\n  background-color: rgba(0, 0, 0, 0.5) !important;\n  /* Fondo semi-transparente */\n  z-index: 1000 !important;\n  /* Asegurar que el spinner esté al frente de todo */\n}\n\n.display-flex-icon {\n  display: flex;\n  align-items: center;\n}\n\n.customSpan {\n  margin: 0 0 4px 4px;\n}\n\n// .customIcon {\n//   // color:dodgerblue;\n//   font-size:25px;\n// }\n\n.texto-status-modal-procesar {\n  padding-left: 2rem;\n}\n\n.btns-modal-procesar {\n  padding-right: 2rem;\n}\n\n.icon-trash-collapse {\n  width: 80%;\n  height: 80%;\n  object-fit: cover;\n  /* Ajusta la imagen para que cubra todo el contenedor */\n  border-radius: 50%;\n  /* Crea un avatar circular */\n}\n\n.center {\n  display: grid;\n  place-items: center;\n  /* Centra horizontal y verticalmente */\n  padding-top: 2rem;\n}\n\n.modal-button-wrapper {\n  // display: flex;\n  justify-content: center;\n}\n\n.letra-contenido-8 {\n  font-size: 1.25rem;\n  color: #1D3354 !important;\n  // font-size: 12px!important;\n  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n  font-weight: bold;\n  padding-top: 5%;\n\n}\n\n.padding-right-card-detail {\n  padding-right: 3px !important;\n}\n\n.btn-color {\n  background-color: #131133 !important;\n  border-color: #131133 !important;\n  color: #ffffff !important;\n}\n\n.btn-color-secundario {\n  background-color: #ffffff !important;\n  border-color: #131133 !important;\n  color: #131133 !important;\n}\n\n/* Estilos para el resaltado de filas visitadas */\n.row-viewed-highlight {\n  background-color: rgba(254, 80, 0, 0.08) !important;\n  border-left: 4px solid #fe5000 !important;\n  transition: all 0.2s ease;\n}\n\n.transition-all {\n  transition: all 0.2s ease-in-out;\n}\n\n/* Modal Detalle Unificado Premium */\n.premium-modal-unified {\n  .modal-content {\n    border-radius: 16px;\n    overflow: hidden;\n    border: none;\n    box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);\n  }\n}\n\n.detalle-info-grid {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.info-modern-item {\n  display: flex;\n  flex-direction: column;\n  line-height: 1.4;\n\n  .info-modern-label {\n    font-size: 0.75rem;\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n    color: #6c757d;\n    font-weight: 600;\n    margin-bottom: 2px;\n  }\n\n  .info-modern-value {\n    font-size: 1rem;\n    color: #1d3354;\n    font-weight: 500;\n  }\n}\n\n.btn-action-round {\n  width: 32px;\n  height: 32px;\n  padding: 0 !important;\n  display: flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n  border-radius: 50% !important;\n  background: white !important;\n  border: 1px solid #dee2e6 !important;\n  transition: all 0.2s !important;\n\n  &:hover {\n    background: #f8f9fa !important;\n    border-color: #fe5000 !important;\n    transform: translateY(-2px) !important;\n    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1) !important;\n  }\n}\n\n.border-orange-soft {\n  border-color: rgba(254, 80, 0, 0.2) !important;\n}\n\n.badge-status {\n  padding: 4px 8px;\n  border-radius: 6px;\n  font-size: 0.7rem;\n  font-weight: 600;\n  background: #f1f3f5;\n  color: #adb5bd;\n  margin-bottom: 4px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  border: 1px solid transparent;\n\n  &.active {\n    background: rgba(25, 135, 84, 0.1) !important;\n    color: #198754 !important;\n    border-color: rgba(25, 135, 84, 0.2) !important;\n  }\n}\n\n.detail-options-grid {\n  hr {\n    opacity: 0.1;\n  }\n}","$file: \"\" !default;\n\n/*!\n * CoreUI #{$file} v5.9.1 (https://coreui.io)\n * Copyright (c) 2026 creativeLabs Łukasz Holeczek\n * Licensed under MIT (https://github.com/coreui/coreui/blob/main/LICENSE)\n */\n","@use \"sass:meta\";\n@use \"functions/color\" as *;\n@use \"functions/color-translucent\" as *;\n@use \"functions/to-rgb\" as *;\n@use \"mixins/color-mode\" as *;\n@use \"vendor/rfs\" as *;\n@use \"maps\" as *;\n@use \"variables\" as *;\n@use \"variables-dark\" as *;\n\n:root,\n[data#{$data-infix}theme=\"light\"] {\n  // Note: Custom variable values only support SassScript inside `#{}`.\n\n  // Colors\n  //\n  // Generate palettes for full colors, grays, and theme colors\n\n  @each $color, $value in $colors {\n    --#{$prefix}#{$color}: #{$value};\n  }\n\n  @each $color, $value in $grays {\n    --#{$prefix}gray-#{$color}: #{$value};\n  }\n\n  @each $color, $value in $theme-colors {\n    --#{$prefix}#{$color}: #{$value};\n  }\n\n  @each $color, $value in $theme-colors-rgb {\n    --#{$prefix}#{$color}-rgb: #{$value};\n  }\n\n  @each $color, $value in $theme-colors-text {\n    --#{$prefix}#{$color}-text-emphasis: #{$value};\n  }\n\n  @each $color, $value in $theme-colors-bg-subtle {\n    --#{$prefix}#{$color}-bg-subtle: #{$value};\n  }\n\n  @each $color, $value in $theme-colors-border-subtle {\n    --#{$prefix}#{$color}-border-subtle: #{$value};\n  }\n\n  @each $color, $value in $theme-colors-contrast {\n    --#{$prefix}#{$color}-contrast: #{$value};\n  }\n\n  --#{$prefix}white-rgb: #{to-rgb($white)};\n  --#{$prefix}black-rgb: #{to-rgb($black)};\n\n  // Fonts\n\n  // Note: Use `meta.inspect` for lists so that quoted items keep the quotes.\n  // See https://github.com/sass/sass/issues/2383#issuecomment-336349172\n  --#{$prefix}font-sans-serif: #{meta.inspect($font-family-sans-serif)};\n  --#{$prefix}font-monospace: #{meta.inspect($font-family-monospace)};\n  --#{$prefix}gradient: #{$gradient};\n\n  // Root and body\n  // scss-docs-start root-body-variables\n  @if $font-size-root != null {\n    --#{$prefix}root-font-size: #{$font-size-root};\n  }\n  --#{$prefix}body-font-family: #{meta.inspect($font-family-base)};\n  @include rfs($font-size-base, --#{$prefix}body-font-size);\n  --#{$prefix}body-font-weight: #{$font-weight-base};\n  --#{$prefix}body-line-height: #{$line-height-base};\n  @if $body-text-align != null {\n    --#{$prefix}body-text-align: #{$body-text-align};\n  }\n\n  --#{$prefix}body-color: #{$body-color};\n  --#{$prefix}body-color-rgb: #{to-rgb($body-color)};\n  --#{$prefix}body-bg: #{$body-bg};\n  --#{$prefix}body-bg-rgb: #{to-rgb($body-bg)};\n\n  --#{$prefix}emphasis-color: #{$body-emphasis-color};\n  --#{$prefix}emphasis-color-rgb: #{to-rgb($body-emphasis-color)};\n\n  --#{$prefix}secondary-color: #{$body-secondary-color};\n  --#{$prefix}secondary-color-rgb: #{to-rgb($body-secondary-color)};\n  --#{$prefix}secondary-bg: #{$body-secondary-bg};\n  --#{$prefix}secondary-bg-rgb: #{to-rgb($body-secondary-bg)};\n\n  --#{$prefix}tertiary-color: #{$body-tertiary-color};\n  --#{$prefix}tertiary-color-rgb: #{to-rgb($body-tertiary-color)};\n  --#{$prefix}tertiary-bg: #{$body-tertiary-bg};\n  --#{$prefix}tertiary-bg-rgb: #{to-rgb($body-tertiary-bg)};\n  --#{$prefix}tertiary-bg-translucent: #{color-translucent($body-tertiary-bg)};\n\n  --#{$prefix}body-color-dark: #{$body-color-dark};\n  --#{$prefix}body-color-rgb-dark: #{to-rgb($body-color-dark)};\n  --#{$prefix}body-bg-dark: #{$body-bg-dark};\n  --#{$prefix}body-bg-rgb-dark: #{to-rgb($body-bg-dark)};\n\n  --#{$prefix}emphasis-color-dark: #{$body-emphasis-color-dark};\n  --#{$prefix}emphasis-color-rgb-dark: #{to-rgb($body-emphasis-color-dark)};\n\n  --#{$prefix}secondary-color-dark: #{$body-secondary-color-dark};\n  --#{$prefix}secondary-color-rgb-dark: #{to-rgb($body-secondary-color-dark)};\n  --#{$prefix}secondary-bg-dark: #{$body-secondary-bg-dark};\n  --#{$prefix}secondary-bg-rgb-dark: #{to-rgb($body-secondary-bg-dark)};\n\n  --#{$prefix}tertiary-color-dark: #{$body-tertiary-color-dark};\n  --#{$prefix}tertiary-color-rgb-dark: #{to-rgb($body-tertiary-color-dark)};\n  --#{$prefix}tertiary-bg-dark: #{$body-tertiary-bg-dark};\n  --#{$prefix}tertiary-bg-rgb-dark: #{to-rgb($body-tertiary-bg-dark)};\n\n  --#{$prefix}high-emphasis: #{$high-emphasis}; // Deprecated in v5.0.0\n  --#{$prefix}medium-emphasis: #{$medium-emphasis}; // Deprecated in v5.0.0\n  --#{$prefix}disabled: #{$disabled}; // Deprecated in v5.0.0\n\n  --#{$prefix}high-emphasis-inverse: #{$high-emphasis-inverse}; // Deprecated in v5.0.0\n  --#{$prefix}medium-emphasis-inverse: #{$medium-emphasis-inverse}; // Deprecated in v5.0.0\n  --#{$prefix}disabled-inverse: #{$disabled-inverse}; // Deprecated in v5.0.0\n  // scss-docs-end root-body-variables\n\n  --#{$prefix}heading-color: #{$headings-color};\n\n  --#{$prefix}link-color: #{$link-color};\n  --#{$prefix}link-color-rgb: #{to-rgb($link-color)};\n  --#{$prefix}link-decoration: #{$link-decoration};\n\n  --#{$prefix}link-hover-color: #{$link-hover-color};\n  --#{$prefix}link-hover-color-rgb: #{to-rgb($link-hover-color)};\n\n  @if $link-hover-decoration != null {\n    --#{$prefix}link-hover-decoration: #{$link-hover-decoration};\n  }\n\n  --#{$prefix}code-color: #{$code-color};\n  --#{$prefix}highlight-color: #{$mark-color};\n  --#{$prefix}highlight-bg: #{$mark-bg};\n\n  // scss-docs-start root-border-var\n  --#{$prefix}border-width: #{$border-width};\n  --#{$prefix}border-style: #{$border-style};\n  --#{$prefix}border-color: #{$border-color};\n  --#{$prefix}border-color-translucent: #{$border-color-translucent};\n\n  --#{$prefix}border-radius: #{$border-radius};\n  --#{$prefix}border-radius-sm: #{$border-radius-sm};\n  --#{$prefix}border-radius-lg: #{$border-radius-lg};\n  --#{$prefix}border-radius-xl: #{$border-radius-xl};\n  --#{$prefix}border-radius-xxl: #{$border-radius-xxl};\n  --#{$prefix}border-radius-2xl: var(--#{$prefix}border-radius-xxl); // Deprecated in v5.0.0 for consistency\n  --#{$prefix}border-radius-pill: #{$border-radius-pill};\n  // scss-docs-end root-border-var\n\n  --#{$prefix}box-shadow: #{$box-shadow};\n  --#{$prefix}box-shadow-sm: #{$box-shadow-sm};\n  --#{$prefix}box-shadow-lg: #{$box-shadow-lg};\n  --#{$prefix}box-shadow-inset: #{$box-shadow-inset};\n\n  // Focus styles\n  // scss-docs-start root-focus-variables\n  --#{$prefix}focus-ring-width: #{$focus-ring-width};\n  --#{$prefix}focus-ring-opacity: #{$focus-ring-opacity};\n  --#{$prefix}focus-ring-color: #{$focus-ring-color};\n  --#{$prefix}focus-ring-blur: #{$focus-ring-blur};\n  // scss-docs-end root-focus-variables\n\n  // scss-docs-start root-form-validation-variables\n  --#{$prefix}form-valid-color: #{$form-valid-color};\n  --#{$prefix}form-valid-border-color: #{$form-valid-border-color};\n  --#{$prefix}form-invalid-color: #{$form-invalid-color};\n  --#{$prefix}form-invalid-border-color: #{$form-invalid-border-color};\n  // scss-docs-end root-form-validation-variables\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark, true) {\n    color-scheme: dark;\n\n    // scss-docs-start root-dark-mode-vars\n    --#{$prefix}body-color: #{$body-color-dark};\n    --#{$prefix}body-color-rgb: #{to-rgb($body-color-dark)};\n    --#{$prefix}body-bg: #{$body-bg-dark};\n    --#{$prefix}body-bg-rgb: #{to-rgb($body-bg-dark)};\n\n    --#{$prefix}emphasis-color: #{$body-emphasis-color-dark};\n    --#{$prefix}emphasis-color-rgb: #{to-rgb($body-emphasis-color-dark)};\n\n    --#{$prefix}secondary-color: #{$body-secondary-color-dark};\n    --#{$prefix}secondary-color-rgb: #{to-rgb($body-secondary-color-dark)};\n    --#{$prefix}secondary-bg: #{$body-secondary-bg-dark};\n    --#{$prefix}secondary-bg-rgb: #{to-rgb($body-secondary-bg-dark)};\n\n    --#{$prefix}tertiary-color: #{$body-tertiary-color-dark};\n    --#{$prefix}tertiary-color-rgb: #{to-rgb($body-tertiary-color-dark)};\n    --#{$prefix}tertiary-bg: #{$body-tertiary-bg-dark};\n    --#{$prefix}tertiary-bg-rgb: #{to-rgb($body-tertiary-bg-dark)};\n    --#{$prefix}tertiary-bg-translucent: #{color-translucent($body-tertiary-bg-dark, .1, $body-bg-dark)};\n\n    --#{$prefix}high-emphasis: #{$high-emphasis-dark}; // Deprecated in v5.0.0\n    --#{$prefix}medium-emphasis: #{$medium-emphasis-dark}; // Deprecated in v5.0.0\n    --#{$prefix}disabled: #{$disabled-dark}; // Deprecated in v5.0.0\n\n    @each $color, $value in $theme-colors-dark {\n      --#{$prefix}#{$color}: #{$value};\n    }\n\n    @each $color, $value in $grays-dark {\n      --#{$prefix}gray-#{$color}: #{$value};\n    }\n\n    @each $color, $value in $theme-colors-rgb-dark {\n      --#{$prefix}#{$color}-rgb: #{$value};\n    }\n\n    @each $color, $value in $theme-colors-text-dark {\n      --#{$prefix}#{$color}-text-emphasis: #{$value};\n    }\n\n    @each $color, $value in $theme-colors-bg-subtle-dark {\n      --#{$prefix}#{$color}-bg-subtle: #{$value};\n    }\n\n    @each $color, $value in $theme-colors-border-subtle-dark {\n      --#{$prefix}#{$color}-border-subtle: #{$value};\n    }\n\n    --#{$prefix}heading-color: #{$headings-color-dark};\n\n    --#{$prefix}link-color: #{$link-color-dark};\n    --#{$prefix}link-hover-color: #{$link-hover-color-dark};\n    --#{$prefix}link-color-rgb: #{to-rgb($link-color-dark)};\n    --#{$prefix}link-hover-color-rgb: #{to-rgb($link-hover-color-dark)};\n\n    --#{$prefix}code-color: #{$code-color-dark};\n    --#{$prefix}highlight-color: #{$mark-color-dark};\n    --#{$prefix}highlight-bg: #{$mark-bg-dark};\n\n    --#{$prefix}border-color: #{$border-color-dark};\n    --#{$prefix}border-color-translucent: #{$border-color-translucent-dark};\n\n    --#{$prefix}form-valid-color: #{$form-valid-color-dark};\n    --#{$prefix}form-valid-border-color: #{$form-valid-border-color-dark};\n    --#{$prefix}form-invalid-color: #{$form-invalid-color-dark};\n    --#{$prefix}form-invalid-border-color: #{$form-invalid-border-color-dark};\n    // scss-docs-end root-dark-mode-vars\n  }\n}\n","// stylelint-disable scss/dimension-no-non-numeric-values\n@use \"sass:map\";\n@use \"sass:math\";\n@use \"sass:meta\";\n@use \"sass:string\";\n\n@use \"../variables\" as *;\n\n// SCSS RFS mixin\n//\n// Automated responsive values for font sizes, paddings, margins and much more\n//\n// Licensed under MIT (https://github.com/twbs/rfs/blob/main/LICENSE)\n\n// Configuration\n\n// Base value\n$rfs-base-value: 1.25rem !default;\n$rfs-unit: rem !default;\n\n@if $rfs-unit != rem and $rfs-unit != px {\n  @error \"`#{$rfs-unit}` is not a valid unit for $rfs-unit. Use `px` or `rem`.\";\n}\n\n// Breakpoint at where values start decreasing if screen width is smaller\n$rfs-breakpoint: 1200px !default;\n$rfs-breakpoint-unit: px !default;\n\n@if $rfs-breakpoint-unit != px and $rfs-breakpoint-unit != em and $rfs-breakpoint-unit != rem {\n  @error \"`#{$rfs-breakpoint-unit}` is not a valid unit for $rfs-breakpoint-unit. Use `px`, `em` or `rem`.\";\n}\n\n// Resize values based on screen height and width\n$rfs-two-dimensional: false !default;\n\n// Factor of decrease\n$rfs-factor: 10 !default;\n\n@if meta.type-of($rfs-factor) != number or $rfs-factor <= 1 {\n  @error \"`#{$rfs-factor}` is not a valid  $rfs-factor, it must be greater than 1.\";\n}\n\n// Mode. Possibilities: \"min-media-query\", \"max-media-query\"\n$rfs-mode: min-media-query !default;\n\n// Generate enable or disable classes. Possibilities: false, \"enable\" or \"disable\"\n$rfs-class: false !default;\n\n// 1 rem = $rfs-rem-value px\n$rfs-rem-value: 16 !default;\n\n// Safari iframe resize bug: https://github.com/twbs/rfs/issues/14\n$rfs-safari-iframe-resize-bug-fix: false !default;\n\n// Disable RFS by setting $enable-rfs to false\n$enable-rfs: $enable-rfs !default;\n\n// Cache $rfs-base-value unit\n$rfs-base-value-unit: math.unit($rfs-base-value);\n\n@function rfs-divide($dividend, $divisor, $precision: 10) {\n  $sign: if(sass($dividend > 0 and $divisor > 0 or $dividend < 0 and $divisor < 0): 1; else: -1);\n  $dividend: abs($dividend);\n  $divisor: abs($divisor);\n  @if $dividend == 0 {\n    @return 0;\n  }\n  @if $divisor == 0 {\n    @error \"Cannot divide by 0\";\n  }\n  $remainder: $dividend;\n  $result: 0;\n  $factor: 10;\n  @while ($remainder > 0 and $precision >= 0) {\n    $quotient: 0;\n    @while ($remainder >= $divisor) {\n      $remainder: $remainder - $divisor;\n      $quotient: $quotient + 1;\n    }\n    $result: $result * 10 + $quotient;\n    $factor: $factor * .1;\n    $remainder: $remainder * 10;\n    $precision: $precision - 1;\n    @if ($precision < 0 and $remainder >= $divisor * 5) {\n      $result: $result + 1;\n    }\n  }\n  $result: $result * $factor * $sign;\n  $dividend-unit: math.unit($dividend);\n  $divisor-unit: math.unit($divisor);\n  $unit-map: (\n    \"px\": 1px,\n    \"rem\": 1rem,\n    \"em\": 1em,\n    \"%\": 1%\n  );\n  @if ($dividend-unit != $divisor-unit and map.has-key($unit-map, $dividend-unit)) {\n    $result: $result * map.get($unit-map, $dividend-unit);\n  }\n  @return $result;\n}\n\n// Remove px-unit from $rfs-base-value for calculations\n@if $rfs-base-value-unit == px {\n  $rfs-base-value: rfs-divide($rfs-base-value, $rfs-base-value * 0 + 1);\n}\n@else if $rfs-base-value-unit == rem {\n  $rfs-base-value: rfs-divide($rfs-base-value, rfs-divide($rfs-base-value * 0 + 1, $rfs-rem-value));\n}\n\n// Cache $rfs-breakpoint unit to prevent multiple calls\n$rfs-breakpoint-unit-cache: math.unit($rfs-breakpoint);\n\n// Remove unit from $rfs-breakpoint for calculations\n@if $rfs-breakpoint-unit-cache == px {\n  $rfs-breakpoint: rfs-divide($rfs-breakpoint, $rfs-breakpoint * 0 + 1);\n}\n@else if $rfs-breakpoint-unit-cache == rem or $rfs-breakpoint-unit-cache == \"em\" {\n  $rfs-breakpoint: rfs-divide($rfs-breakpoint, rfs-divide($rfs-breakpoint * 0 + 1, $rfs-rem-value));\n}\n\n// Calculate the media query value\n$rfs-mq-value: if(sass($rfs-breakpoint-unit == px): #{$rfs-breakpoint}px; else: #{rfs-divide($rfs-breakpoint, $rfs-rem-value)}#{$rfs-breakpoint-unit});\n$rfs-mq-property-width: if(sass($rfs-mode == max-media-query): max-width; else: min-width);\n$rfs-mq-property-height: if(sass($rfs-mode == max-media-query): max-height; else: min-height);\n\n// Internal mixin used to determine which media query needs to be used\n@mixin _rfs-media-query {\n  @if $rfs-two-dimensional {\n    @if $rfs-mode == max-media-query {\n      @media (#{$rfs-mq-property-width}: #{$rfs-mq-value}), (#{$rfs-mq-property-height}: #{$rfs-mq-value}) {\n        @content;\n      }\n    }\n    @else {\n      @media (#{$rfs-mq-property-width}: #{$rfs-mq-value}) and (#{$rfs-mq-property-height}: #{$rfs-mq-value}) {\n        @content;\n      }\n    }\n  }\n  @else {\n    @media (#{$rfs-mq-property-width}: #{$rfs-mq-value}) {\n      @content;\n    }\n  }\n}\n\n// Internal mixin that adds disable classes to the selector if needed.\n@mixin _rfs-rule {\n  @if $rfs-class == disable and $rfs-mode == max-media-query {\n    // Adding an extra class increases specificity, which prevents the media query to override the property\n    &,\n    .disable-rfs &,\n    &.disable-rfs {\n      @content;\n    }\n  }\n  @else if $rfs-class == enable and $rfs-mode == min-media-query {\n    .enable-rfs &,\n    &.enable-rfs {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Internal mixin that adds enable classes to the selector if needed.\n@mixin _rfs-media-query-rule {\n\n  @if $rfs-class == enable {\n    @if $rfs-mode == min-media-query {\n      @content;\n    }\n\n    @include _rfs-media-query () {\n      .enable-rfs &,\n      &.enable-rfs {\n        @content;\n      }\n    }\n  }\n  @else {\n    @if $rfs-class == disable and $rfs-mode == min-media-query {\n      .disable-rfs &,\n      &.disable-rfs {\n        @content;\n      }\n    }\n    @include _rfs-media-query () {\n      @content;\n    }\n  }\n}\n\n// Helper function to get the formatted non-responsive value\n@function rfs-value($values) {\n  // Convert to list\n  $values: if(sass(meta.type-of($values) != list): ($values,); else: $values);\n\n  $val: \"\";\n\n  // Loop over each value and calculate value\n  @each $value in $values {\n    @if $value == 0 {\n      $val: $val + \" 0\";\n    }\n    @else {\n      // Cache $value unit\n      $unit: false;\n      \n      @if meta.type-of($value) == \"number\" {\n        $unit: math.unit($value);\n      };\n\n      @if $unit == px {\n        // Convert to rem if needed\n        $val: $val + \" \" + if(sass($rfs-unit == rem): #{rfs-divide($value, $value * 0 + $rfs-rem-value)}rem; else: $value);\n      }\n      @else if $unit == rem {\n        // Convert to px if needed\n        $val: $val + \" \" + if(sass($rfs-unit == px): #{rfs-divide($value, $value * 0 + 1) * $rfs-rem-value}px; else: $value);\n      } @else {\n        // If $value isn't a number (like inherit) or $value has a unit (not px or rem, like 1.5em) or $ is 0, just print the value\n        $val: $val + \" \" + $value;\n      }\n    }\n  }\n\n  // Remove first space\n  @return string.unquote(string.slice($val, 2));\n}\n\n// Helper function to get the responsive value calculated by RFS\n@function rfs-fluid-value($values) {\n  // Convert to list\n  $values: if(sass(meta.type-of($values) != list): (($values,)); else: $values);\n\n  $val: \"\";\n\n  // Loop over each value and calculate value\n  @each $value in $values {\n    @if $value == 0 {\n      $val: $val + \" 0\";\n    } @else {\n      // Cache $value unit\n      $unit: false;\n\n      @if meta.type-of($value) == \"number\" {\n        $unit: math.unit($value);\n      };\n\n      // If $value isn't a number (like inherit) or $value has a unit (not px or rem, like 1.5em) or $ is 0, just print the value\n      @if not $unit or $unit != px and $unit != rem {\n        $val: $val + \" \" + $value;\n      } @else {\n        // Remove unit from $value for calculations\n        $value: rfs-divide($value, $value * 0 + if(sass($unit == px): 1; else: rfs-divide(1, $rfs-rem-value)));\n\n        // Only add the media query if the value is greater than the minimum value\n        @if abs($value) <= $rfs-base-value or not $enable-rfs {\n          $val: $val + \" \" + if(sass($rfs-unit == rem): #{rfs-divide($value, $rfs-rem-value)}rem; else: #{$value}px);\n        }\n        @else {\n          // Calculate the minimum value\n          $value-min: $rfs-base-value + rfs-divide(abs($value) - $rfs-base-value, $rfs-factor);\n\n          // Calculate difference between $value and the minimum value\n          $value-diff: abs($value) - $value-min;\n\n          // Base value formatting\n          $min-width: if(sass($rfs-unit == rem): #{rfs-divide($value-min, $rfs-rem-value)}rem; else: #{$value-min}px);\n\n          // Use negative value if needed\n          $min-width: if(sass($value < 0): -$min-width; else: $min-width);\n\n          // Use `vmin` if two-dimensional is enabled\n          $variable-unit: if(sass($rfs-two-dimensional): vmin; else: vw);\n\n          // Calculate the variable width between 0 and $rfs-breakpoint\n          $variable-width: #{rfs-divide($value-diff * 100, $rfs-breakpoint)}#{$variable-unit};\n\n          // Return the calculated value\n          $val: $val + \" calc(\" + $min-width + if(sass($value < 0): \" - \"; else: \" + \") + $variable-width + \")\";\n        }\n      }\n    }\n  }\n\n  // Remove first space\n  @return string.unquote(string.slice($val, 2));\n}\n\n// RFS mixin\n@mixin rfs($values, $property: font-size) {\n  @if $values != null {\n    $val: rfs-value($values);\n    $fluid-val: rfs-fluid-value($values);\n\n    // Do not print the media query if responsive & non-responsive values are the same\n    @if $val == $fluid-val {\n      #{$property}: $val;\n    }\n    @else {\n      @include _rfs-rule () {\n        #{$property}: if(sass($rfs-mode == max-media-query): $val; else: $fluid-val);\n\n        // Include safari iframe resize fix if needed\n        min-width: if(sass($rfs-safari-iframe-resize-bug-fix): (0 * 1vw); else: null);\n      }\n\n      @include _rfs-media-query-rule () {\n        #{$property}: if(sass($rfs-mode == max-media-query): $fluid-val; else: $val);\n      }\n    }\n  }\n}\n\n// Shorthand helper mixins\n@mixin font-size($value) {\n  @include rfs($value);\n}\n\n@mixin padding($value) {\n  @include rfs($value, padding);\n}\n\n@mixin padding-top($value) {\n  @include rfs($value, padding-top);\n}\n\n@mixin padding-right($value) {\n  @include rfs($value, padding-right);\n}\n\n@mixin padding-bottom($value) {\n  @include rfs($value, padding-bottom);\n}\n\n@mixin padding-left($value) {\n  @include rfs($value, padding-left);\n}\n\n@mixin margin($value) {\n  @include rfs($value, margin);\n}\n\n@mixin margin-top($value) {\n  @include rfs($value, margin-top);\n}\n\n@mixin margin-right($value) {\n  @include rfs($value, margin-right);\n}\n\n@mixin margin-bottom($value) {\n  @include rfs($value, margin-bottom);\n}\n\n@mixin margin-left($value) {\n  @include rfs($value, margin-left);\n}","@use \"../variables\" as *;\n\n// scss-docs-start color-mode-mixin\n@mixin color-mode($mode: light, $root: false) {\n  @if $color-mode-type == \"media-query\" {\n    @if $root == true {\n      @media (prefers-color-scheme: $mode) {\n        :root {\n          @content;\n        }\n      }\n    } @else {\n      @media (prefers-color-scheme: $mode) {\n        @content;\n      }\n    }\n  } @else {\n    [data#{$data-infix}theme=\"#{$mode}\"] {\n      @content;\n    }\n  }\n}\n// scss-docs-end color-mode-mixin\n","@use \"mixins/border-radius\" as *;\n@use \"vendor/rfs\" as *;\n@use \"variables\" as *;\n\n// stylelint-disable declaration-no-important, selector-no-qualifying-type, property-no-vendor-prefix\n\n\n// Reboot\n//\n// Normalization of HTML elements, manually forked from Normalize.css to remove\n// styles targeting irrelevant browsers while applying new styles.\n//\n// Normalize is licensed MIT. https://github.com/necolas/normalize.css\n\n\n// Document\n//\n// Change from `box-sizing: content-box` so that `width` is not affected by `padding` or `border`.\n\n*,\n*::before,\n*::after {\n  box-sizing: border-box;\n}\n\n\n// Root\n//\n// Ability to the value of the root font sizes, affecting the value of `rem`.\n// null by default, thus nothing is generated.\n\n:root {\n  @if $font-size-root != null {\n    @include font-size(var(--#{$prefix}root-font-size));\n  }\n\n  @if $enable-smooth-scroll {\n    @media (prefers-reduced-motion: no-preference) {\n      scroll-behavior: smooth;\n    }\n  }\n}\n\n\n// Body\n//\n// 1. Remove the margin in all browsers.\n// 2. As a best practice, apply a default `background-color`.\n// 3. Prevent adjustments of font size after orientation changes in iOS.\n// 4. Change the default tap highlight to be completely transparent in iOS.\n\n// scss-docs-start reboot-body-rules\nbody {\n  margin: 0; // 1\n  font-family: var(--#{$prefix}body-font-family);\n  @include font-size(var(--#{$prefix}body-font-size));\n  font-weight: var(--#{$prefix}body-font-weight);\n  line-height: var(--#{$prefix}body-line-height);\n  color: var(--#{$prefix}body-color);\n  text-align: var(--#{$prefix}body-text-align);\n  background-color: var(--#{$prefix}body-bg); // 2\n  -webkit-text-size-adjust: 100%; // 3\n  -webkit-tap-highlight-color: rgba($black, 0); // 4\n}\n// scss-docs-end reboot-body-rules\n\n\n// Content grouping\n//\n// 1. Reset Firefox's gray color\n\nhr {\n  margin: $hr-margin-y 0;\n  color: $hr-color; // 1\n  border: 0;\n  border-top: $hr-border-width solid $hr-border-color;\n  opacity: $hr-opacity;\n}\n\n\n// Typography\n//\n// 1. Remove top margins from headings\n//    By default, `<h1>`-`<h6>` all receive top and bottom margins. We nuke the top\n//    margin for easier control within type scales as it avoids margin collapsing.\n\n%heading {\n  margin-top: 0; // 1\n  margin-bottom: $headings-margin-bottom;\n  font-family: $headings-font-family;\n  font-style: $headings-font-style;\n  font-weight: $headings-font-weight;\n  line-height: $headings-line-height;\n  color: var(--#{$prefix}heading-color);\n}\n\nh1 {\n  @extend %heading;\n  @include font-size($h1-font-size);\n}\n\nh2 {\n  @extend %heading;\n  @include font-size($h2-font-size);\n}\n\nh3 {\n  @extend %heading;\n  @include font-size($h3-font-size);\n}\n\nh4 {\n  @extend %heading;\n  @include font-size($h4-font-size);\n}\n\nh5 {\n  @extend %heading;\n  @include font-size($h5-font-size);\n}\n\nh6 {\n  @extend %heading;\n  @include font-size($h6-font-size);\n}\n\n\n// Reset margins on paragraphs\n//\n// Similarly, the top margin on `<p>`s get reset. However, we also reset the\n// bottom margin to use `rem` units instead of `em`.\n\np {\n  margin-top: 0;\n  margin-bottom: $paragraph-margin-bottom;\n}\n\n\n// Abbreviations\n//\n// 1. Add the correct text decoration in Chrome, Edge, Opera, and Safari.\n// 2. Add explicit cursor to indicate changed behavior.\n// 3. Prevent the text-decoration to be skipped.\n\nabbr[title] {\n  text-decoration: underline dotted; // 1\n  cursor: help; // 2\n  text-decoration-skip-ink: none; // 3\n}\n\n\n// Address\n\naddress {\n  margin-bottom: 1rem;\n  font-style: normal;\n  line-height: inherit;\n}\n\n\n// Lists\n\nol,\nul {\n  padding-inline-start: 2rem;\n}\n\nol,\nul,\ndl {\n  margin-top: 0;\n  margin-bottom: 1rem;\n}\n\nol ol,\nul ul,\nol ul,\nul ol {\n  margin-bottom: 0;\n}\n\ndt {\n  font-weight: $dt-font-weight;\n}\n\n// 1. Undo browser default\n\ndd {\n  margin-inline-start: 0; // 1\n  margin-bottom: .5rem;\n}\n\n\n// Blockquote\n\nblockquote {\n  margin: 0 0 1rem;\n}\n\n\n// Strong\n//\n// Add the correct font weight in Chrome, Edge, and Safari\n\nb,\nstrong {\n  font-weight: $font-weight-bolder;\n}\n\n\n// Small\n//\n// Add the correct font size in all browsers\n\nsmall {\n  @include font-size($small-font-size);\n}\n\n\n// Mark\n\nmark {\n  padding: $mark-padding;\n  color: var(--#{$prefix}highlight-color);\n  background-color: var(--#{$prefix}highlight-bg);\n}\n\n\n// Sub and Sup\n//\n// Prevent `sub` and `sup` elements from affecting the line height in\n// all browsers.\n\nsub,\nsup {\n  position: relative;\n  @include font-size($sub-sup-font-size);\n  line-height: 0;\n  vertical-align: baseline;\n}\n\nsub { bottom: -.25em; }\nsup { top: -.5em; }\n\n\n// Links\n\na {\n  color: rgba(var(--#{$prefix}link-color-rgb), var(--#{$prefix}link-opacity, 1));\n  text-decoration: $link-decoration;\n\n  &:hover {\n    --#{$prefix}link-color-rgb: var(--#{$prefix}link-hover-color-rgb);\n    text-decoration: $link-hover-decoration;\n  }\n}\n// And undo these styles for placeholder links/named anchors (without href).\n// It would be more straightforward to just use a[href] in previous block, but that\n// causes specificity issues in many other styles that are too complex to fix.\n// See https://github.com/twbs/bootstrap/issues/19402\n\na:not([href]):not([class]) {\n  &,\n  &:hover {\n    color: inherit;\n    text-decoration: none;\n  }\n}\n\n\n// Code\n\npre,\ncode,\nkbd,\nsamp {\n  font-family: $font-family-code;\n  @include font-size(1em); // Correct the odd `em` font sizing in all browsers.\n}\n\n// 1. Remove browser default top margin\n// 2. Reset browser default of `1em` to use `rem`s\n// 3. Don't allow content to break outside\n\npre {\n  display: block;\n  margin-top: 0; // 1\n  margin-bottom: 1rem; // 2\n  overflow: auto; // 3\n  @include font-size($code-font-size);\n  color: var(--#{$prefix}pre-color, $pre-color);\n\n  // Account for some code outputs that place code tags in pre tags\n  code {\n    @include font-size(inherit);\n    color: inherit;\n    word-break: normal;\n  }\n}\n\ncode {\n  @include font-size($code-font-size);\n  color: var(--#{$prefix}code-color);\n  word-wrap: break-word;\n\n  // Streamline the style when inside anchors to avoid broken underline and more\n  a > & {\n    color: inherit;\n  }\n}\n\nkbd {\n  padding: $kbd-padding-y $kbd-padding-x;\n  @include font-size($kbd-font-size);\n  color: var(--#{$prefix}kbd-color, $kbd-color);\n  background-color: var(--#{$prefix}kbd-bg, $kbd-bg);\n  @include border-radius($border-radius-sm);\n\n  kbd {\n    padding: 0;\n    @include font-size(1em);\n    font-weight: $nested-kbd-font-weight;\n  }\n}\n\n\n// Figures\n//\n// Apply a consistent margin strategy (matches our type styles).\n\nfigure {\n  margin: 0 0 1rem;\n}\n\n\n// Images and content\n\nimg,\nsvg {\n  vertical-align: middle;\n}\n\n\n// Tables\n//\n// Prevent double borders\n\ntable {\n  caption-side: bottom;\n  border-collapse: collapse;\n}\n\ncaption {\n  padding-top: $table-cell-padding-y;\n  padding-bottom: $table-cell-padding-y;\n  color: var(--#{$prefix}table-caption-color, $table-caption-color);\n  text-align: start;\n}\n\n// 1. Removes font-weight bold by inheriting\n// 2. Matches default `<td>` alignment by inheriting `text-align`.\n// 3. Fix alignment for Safari\n\nth {\n  font-weight: $table-th-font-weight; // 1\n  text-align: inherit; // 2\n  text-align: -webkit-match-parent; // 3\n}\n\nthead,\ntbody,\ntfoot,\ntr,\ntd,\nth {\n  border-color: inherit;\n  border-style: solid;\n  border-width: 0;\n}\n\n\n// Forms\n//\n// 1. Allow labels to use `margin` for spacing.\n\nlabel {\n  display: inline-block; // 1\n}\n\n// Remove the default `border-radius` that macOS Chrome adds.\n// See https://github.com/twbs/bootstrap/issues/24093\n\nbutton {\n  // stylelint-disable-next-line property-disallowed-list\n  border-radius: 0;\n}\n\n// Explicitly remove focus outline in Chromium when it shouldn't be\n// visible (e.g. as result of mouse click or touch tap). It already\n// should be doing this automatically, but seems to currently be\n// confused and applies its very visible two-tone outline anyway.\n\nbutton:focus:not(:focus-visible) {\n  outline: 0;\n}\n\n// 1. Remove the margin in Firefox and Safari\n\ninput,\nbutton,\nselect,\noptgroup,\ntextarea {\n  margin: 0; // 1\n  font-family: inherit;\n  @include font-size(inherit);\n  line-height: inherit;\n}\n\n// Remove the inheritance of text transform in Firefox\nbutton,\nselect {\n  text-transform: none;\n}\n// Set the cursor for non-`<button>` buttons\n//\n// Details at https://github.com/twbs/bootstrap/pull/30562\n[role=\"button\"] {\n  cursor: pointer;\n}\n\nselect {\n  // Remove the inheritance of word-wrap in Safari.\n  // See https://github.com/twbs/bootstrap/issues/24990\n  word-wrap: normal;\n\n  // Undo the opacity change from Chrome\n  &:disabled {\n    opacity: 1;\n  }\n}\n\n// Remove the dropdown arrow only from text type inputs built with datalists in Chrome.\n// See https://stackoverflow.com/a/54997118\n\n[list]:not([type=\"date\"]):not([type=\"datetime-local\"]):not([type=\"month\"]):not([type=\"week\"]):not([type=\"time\"])::-webkit-calendar-picker-indicator {\n  display: none !important;\n}\n\n// 1. Prevent a WebKit bug where (2) destroys native `audio` and `video`\n//    controls in Android 4.\n// 2. Correct the inability to style clickable types in iOS and Safari.\n// 3. Opinionated: add \"hand\" cursor to non-disabled button elements.\n\nbutton,\n[type=\"button\"], // 1\n[type=\"reset\"],\n[type=\"submit\"] {\n  -webkit-appearance: button; // 2\n\n  @if $enable-button-pointers {\n    &:not(:disabled) {\n      cursor: pointer; // 3\n    }\n  }\n}\n\n// Remove inner border and padding from Firefox, but don't restore the outline like Normalize.\n\n::-moz-focus-inner {\n  padding: 0;\n  border-style: none;\n}\n\n// 1. Textareas should really only resize vertically so they don't break their (horizontal) containers.\n\ntextarea {\n  resize: vertical; // 1\n}\n\n// 1. Browsers set a default `min-width: min-content;` on fieldsets,\n//    unlike e.g. `<div>`s, which have `min-width: 0;` by default.\n//    So we reset that to ensure fieldsets behave more like a standard block element.\n//    See https://github.com/twbs/bootstrap/issues/12359\n//    and https://html.spec.whatwg.org/multipage/#the-fieldset-and-legend-elements\n// 2. Reset the default outline behavior of fieldsets so they don't affect page layout.\n\nfieldset {\n  min-width: 0; // 1\n  padding: 0; // 2\n  margin: 0; // 2\n  border: 0; // 2\n}\n\n// 1. By using `float: left`, the legend will behave like a block element.\n//    This way the border of a fieldset wraps around the legend if present.\n// 2. Fix wrapping bug.\n//    See https://github.com/twbs/bootstrap/issues/29712\n\nlegend {\n  float: inline-start; // 1\n  width: 100%;\n  padding: 0;\n  margin-bottom: $legend-margin-bottom;\n  font-weight: $legend-font-weight;\n  line-height: inherit;\n  @include font-size($legend-font-size);\n\n  + * {\n    clear: left; // 2\n  }\n}\n\n// Fix height of inputs with a type of datetime-local, date, month, week, or time\n// See https://github.com/twbs/bootstrap/issues/18842\n\n::-webkit-datetime-edit-fields-wrapper,\n::-webkit-datetime-edit-text,\n::-webkit-datetime-edit-minute,\n::-webkit-datetime-edit-hour-field,\n::-webkit-datetime-edit-day-field,\n::-webkit-datetime-edit-month-field,\n::-webkit-datetime-edit-year-field {\n  padding: 0;\n}\n\n::-webkit-inner-spin-button {\n  height: auto;\n}\n\n// 1. This overrides the extra rounded corners on search inputs in iOS so that our\n//    `.form-control` class can properly style them. Note that this cannot simply\n//    be added to `.form-control` as it's not specific enough. For details, see\n//    https://github.com/twbs/bootstrap/issues/11586.\n// 2. Correct the outline style in Safari.\n\n[type=\"search\"] {\n  -webkit-appearance: textfield; // 1\n  outline-offset: -2px; // 2\n\n  // 3. Better affordance and consistent appearance for search cancel button\n  &::-webkit-search-cancel-button {\n    cursor: pointer;\n    filter: grayscale(1);\n  }\n}\n\n// 1. A few input types should stay LTR\n// See https://rtlstyling.com/posts/rtl-styling#form-inputs\n\n*[dir=\"rtl\"] {\n  [type=\"tel\"],\n  [type=\"url\"],\n  [type=\"email\"],\n  [type=\"number\"] {\n    direction: ltr;\n  }\n}\n\n\n// Remove the inner padding in Chrome and Safari on macOS.\n\n::-webkit-search-decoration {\n  -webkit-appearance: none;\n}\n\n// Remove padding around color pickers in webkit browsers\n\n::-webkit-color-swatch-wrapper {\n  padding: 0;\n}\n\n\n// 1. Inherit font family and line height for file input buttons\n// 2. Correct the inability to style clickable types in iOS and Safari.\n\n::file-selector-button {\n  font: inherit; // 1\n  -webkit-appearance: button; // 2\n}\n\n// Correct element displays\n\noutput {\n  display: inline-block;\n}\n\n// Reset iframe color-scheme\n//\n// If the color scheme of an iframe differs from the parent document, the\n// iframe gets an opaque canvas background of its own (a white background on\n// a page in dark mode). Remove its border while we are here.\n\niframe {\n  color-scheme: light dark;\n  border: 0;\n}\n\n// Summary\n//\n// 1. Add the correct display in all browsers\n\nsummary {\n  display: list-item; // 1\n  cursor: pointer;\n}\n\n\n// Progress\n//\n// Add the correct vertical alignment in Chrome, Firefox, and Opera.\n\nprogress {\n  vertical-align: baseline;\n}\n\n\n// Hidden attribute\n//\n// Always hide an element with the `hidden` HTML attribute.\n\n[hidden] {\n  display: none !important;\n}\n","@use \"sass:color\";\n@use \"sass:string\";\n@use \"functions/assert-ascending\" as *;\n@use \"functions/assert-starts-at-zero\" as *;\n@use \"functions/color\" as *;\n@use \"functions/color-contrast-variables\" as *;\n@use \"functions/color-translucent\" as *;\n@use \"functions/math\" as *;\n@use \"functions/to-rgb\" as *;\n\n// Variables\n//\n// Variables should follow the `$component-state-property-size` formula for\n// consistent naming. Ex: $nav-link-disabled-color and $modal-content-box-shadow-xs.\n\n// Color system\n\n// scss-docs-start gray-color-variables\n$white:     #fff !default;\n$gray-base: #323a49 !default;\n$gray-100:  #f3f4f7 !default;\n$gray-200:  #e7eaee !default;\n$gray-300:  #dbdfe6 !default;\n$gray-400:  #cfd4de !default;\n$gray-500:  #aab3c5 !default;\n$gray-600:  #6d7d9c !default;\n$gray-700:  #4a566d !default;\n$gray-800:  #323a49 !default;\n$gray-900:  #212631 !default;\n$black:     #080a0c !default;\n// scss-docs-end gray-color-variables\n\n// fusv-disable\n// scss-docs-start gray-colors-map\n$grays: (\n  \"100\": $gray-100,\n  \"200\": $gray-200,\n  \"300\": $gray-300,\n  \"400\": $gray-400,\n  \"500\": $gray-500,\n  \"600\": $gray-600,\n  \"700\": $gray-700,\n  \"800\": $gray-800,\n  \"900\": $gray-900\n) !default;\n// scss-docs-end gray-colors-map\n// fusv-enable\n\n// fusv-disable\n$high-emphasis:            rgba(shift-color($gray-base, +26%), .95) !default; // Deprecated in 5.0.0\n$medium-emphasis:          rgba(shift-color($gray-base, +26%), .681) !default; // Deprecated in 5.0.0\n$disabled:                 rgba(shift-color($gray-base, +26%), .38) !default; // Deprecated in 5.0.0\n\n$high-emphasis-inverse:    rgba($white, .87) !default; // Deprecated in 5.0.0\n$medium-emphasis-inverse:  rgba($white, .6) !default; // Deprecated in 5.0.0\n$disabled-inverse:         rgba($white, .38) !default; // Deprecated in 5.0.0\n// fusv-enable\n\n// scss-docs-start color-variables\n$blue:    #0d6efd !default;\n$indigo:  #6610f2 !default;\n$purple:  #6f42c1 !default;\n$pink:    #d63384 !default;\n$red:     #dc3545 !default;\n$orange:  #fd7e14 !default;\n$yellow:  #ffc107 !default;\n$green:   #198754 !default;\n$teal:    #20c997 !default;\n$cyan:    #0dcaf0 !default;\n// scss-docs-end color-variables\n\n// scss-docs-start colors-map\n$colors: (\n  \"blue\":       $blue,\n  \"indigo\":     $indigo,\n  \"purple\":     $purple,\n  \"pink\":       $pink,\n  \"red\":        $red,\n  \"orange\":     $orange,\n  \"yellow\":     $yellow,\n  \"green\":      $green,\n  \"teal\":       $teal,\n  \"cyan\":       $cyan,\n  \"black\":      $black,\n  \"white\":      $white,\n  \"gray\":       $gray-600,\n  \"gray-dark\":  $gray-800\n) !default;\n// scss-docs-end colors-map\n\n// The contrast ratio to reach against white, to determine if color changes from \"light\" to \"dark\". Acceptable values for WCAG 2.2 are 3, 4.5 and 7.\n// See https://www.w3.org/TR/WCAG/#contrast-minimum\n$min-contrast-ratio:   4.5 !default;\n\n// Customize the light and dark text colors for use in our color contrast function.\n$color-contrast-dark:      $black !default;\n$color-contrast-light:     $white !default;\n\n\n// fusv-disable\n$blue-100: tint-color($blue, 80%) !default;\n$blue-200: tint-color($blue, 60%) !default;\n$blue-300: tint-color($blue, 40%) !default;\n$blue-400: tint-color($blue, 20%) !default;\n$blue-500: $blue !default;\n$blue-600: shade-color($blue, 20%) !default;\n$blue-700: shade-color($blue, 40%) !default;\n$blue-800: shade-color($blue, 60%) !default;\n$blue-900: shade-color($blue, 80%) !default;\n\n$indigo-100: tint-color($indigo, 80%) !default;\n$indigo-200: tint-color($indigo, 60%) !default;\n$indigo-300: tint-color($indigo, 40%) !default;\n$indigo-400: tint-color($indigo, 20%) !default;\n$indigo-500: $indigo !default;\n$indigo-600: shade-color($indigo, 20%) !default;\n$indigo-700: shade-color($indigo, 40%) !default;\n$indigo-800: shade-color($indigo, 60%) !default;\n$indigo-900: shade-color($indigo, 80%) !default;\n\n$purple-100: tint-color($purple, 80%) !default;\n$purple-200: tint-color($purple, 60%) !default;\n$purple-300: tint-color($purple, 40%) !default;\n$purple-400: tint-color($purple, 20%) !default;\n$purple-500: $purple !default;\n$purple-600: shade-color($purple, 20%) !default;\n$purple-700: shade-color($purple, 40%) !default;\n$purple-800: shade-color($purple, 60%) !default;\n$purple-900: shade-color($purple, 80%) !default;\n\n$pink-100: tint-color($pink, 80%) !default;\n$pink-200: tint-color($pink, 60%) !default;\n$pink-300: tint-color($pink, 40%) !default;\n$pink-400: tint-color($pink, 20%) !default;\n$pink-500: $pink !default;\n$pink-600: shade-color($pink, 20%) !default;\n$pink-700: shade-color($pink, 40%) !default;\n$pink-800: shade-color($pink, 60%) !default;\n$pink-900: shade-color($pink, 80%) !default;\n\n$red-100: tint-color($red, 80%) !default;\n$red-200: tint-color($red, 60%) !default;\n$red-300: tint-color($red, 40%) !default;\n$red-400: tint-color($red, 20%) !default;\n$red-500: $red !default;\n$red-600: shade-color($red, 20%) !default;\n$red-700: shade-color($red, 40%) !default;\n$red-800: shade-color($red, 60%) !default;\n$red-900: shade-color($red, 80%) !default;\n\n$orange-100: tint-color($orange, 80%) !default;\n$orange-200: tint-color($orange, 60%) !default;\n$orange-300: tint-color($orange, 40%) !default;\n$orange-400: tint-color($orange, 20%) !default;\n$orange-500: $orange !default;\n$orange-600: shade-color($orange, 20%) !default;\n$orange-700: shade-color($orange, 40%) !default;\n$orange-800: shade-color($orange, 60%) !default;\n$orange-900: shade-color($orange, 80%) !default;\n\n$yellow-100: tint-color($yellow, 80%) !default;\n$yellow-200: tint-color($yellow, 60%) !default;\n$yellow-300: tint-color($yellow, 40%) !default;\n$yellow-400: tint-color($yellow, 20%) !default;\n$yellow-500: $yellow !default;\n$yellow-600: shade-color($yellow, 20%) !default;\n$yellow-700: shade-color($yellow, 40%) !default;\n$yellow-800: shade-color($yellow, 60%) !default;\n$yellow-900: shade-color($yellow, 80%) !default;\n\n$green-100: tint-color($green, 80%) !default;\n$green-200: tint-color($green, 60%) !default;\n$green-300: tint-color($green, 40%) !default;\n$green-400: tint-color($green, 20%) !default;\n$green-500: $green !default;\n$green-600: shade-color($green, 20%) !default;\n$green-700: shade-color($green, 40%) !default;\n$green-800: shade-color($green, 60%) !default;\n$green-900: shade-color($green, 80%) !default;\n\n$teal-100: tint-color($teal, 80%) !default;\n$teal-200: tint-color($teal, 60%) !default;\n$teal-300: tint-color($teal, 40%) !default;\n$teal-400: tint-color($teal, 20%) !default;\n$teal-500: $teal !default;\n$teal-600: shade-color($teal, 20%) !default;\n$teal-700: shade-color($teal, 40%) !default;\n$teal-800: shade-color($teal, 60%) !default;\n$teal-900: shade-color($teal, 80%) !default;\n\n$cyan-100: tint-color($cyan, 80%) !default;\n$cyan-200: tint-color($cyan, 60%) !default;\n$cyan-300: tint-color($cyan, 40%) !default;\n$cyan-400: tint-color($cyan, 20%) !default;\n$cyan-500: $cyan !default;\n$cyan-600: shade-color($cyan, 20%) !default;\n$cyan-700: shade-color($cyan, 40%) !default;\n$cyan-800: shade-color($cyan, 60%) !default;\n$cyan-900: shade-color($cyan, 80%) !default;\n\n$blues: (\n  \"blue-100\": $blue-100,\n  \"blue-200\": $blue-200,\n  \"blue-300\": $blue-300,\n  \"blue-400\": $blue-400,\n  \"blue-500\": $blue-500,\n  \"blue-600\": $blue-600,\n  \"blue-700\": $blue-700,\n  \"blue-800\": $blue-800,\n  \"blue-900\": $blue-900\n) !default;\n\n$indigos: (\n  \"indigo-100\": $indigo-100,\n  \"indigo-200\": $indigo-200,\n  \"indigo-300\": $indigo-300,\n  \"indigo-400\": $indigo-400,\n  \"indigo-500\": $indigo-500,\n  \"indigo-600\": $indigo-600,\n  \"indigo-700\": $indigo-700,\n  \"indigo-800\": $indigo-800,\n  \"indigo-900\": $indigo-900\n) !default;\n\n$purples: (\n  \"purple-100\": $purple-100,\n  \"purple-200\": $purple-200,\n  \"purple-300\": $purple-300,\n  \"purple-400\": $purple-400,\n  \"purple-500\": $purple-500,\n  \"purple-600\": $purple-600,\n  \"purple-700\": $purple-700,\n  \"purple-800\": $purple-800,\n  \"purple-900\": $purple-900\n) !default;\n\n$pinks: (\n  \"pink-100\": $pink-100,\n  \"pink-200\": $pink-200,\n  \"pink-300\": $pink-300,\n  \"pink-400\": $pink-400,\n  \"pink-500\": $pink-500,\n  \"pink-600\": $pink-600,\n  \"pink-700\": $pink-700,\n  \"pink-800\": $pink-800,\n  \"pink-900\": $pink-900\n) !default;\n\n$reds: (\n  \"red-100\": $red-100,\n  \"red-200\": $red-200,\n  \"red-300\": $red-300,\n  \"red-400\": $red-400,\n  \"red-500\": $red-500,\n  \"red-600\": $red-600,\n  \"red-700\": $red-700,\n  \"red-800\": $red-800,\n  \"red-900\": $red-900\n) !default;\n\n$oranges: (\n  \"orange-100\": $orange-100,\n  \"orange-200\": $orange-200,\n  \"orange-300\": $orange-300,\n  \"orange-400\": $orange-400,\n  \"orange-500\": $orange-500,\n  \"orange-600\": $orange-600,\n  \"orange-700\": $orange-700,\n  \"orange-800\": $orange-800,\n  \"orange-900\": $orange-900\n) !default;\n\n$yellows: (\n  \"yellow-100\": $yellow-100,\n  \"yellow-200\": $yellow-200,\n  \"yellow-300\": $yellow-300,\n  \"yellow-400\": $yellow-400,\n  \"yellow-500\": $yellow-500,\n  \"yellow-600\": $yellow-600,\n  \"yellow-700\": $yellow-700,\n  \"yellow-800\": $yellow-800,\n  \"yellow-900\": $yellow-900\n) !default;\n\n$greens: (\n  \"green-100\": $green-100,\n  \"green-200\": $green-200,\n  \"green-300\": $green-300,\n  \"green-400\": $green-400,\n  \"green-500\": $green-500,\n  \"green-600\": $green-600,\n  \"green-700\": $green-700,\n  \"green-800\": $green-800,\n  \"green-900\": $green-900\n) !default;\n\n$teals: (\n  \"teal-100\": $teal-100,\n  \"teal-200\": $teal-200,\n  \"teal-300\": $teal-300,\n  \"teal-400\": $teal-400,\n  \"teal-500\": $teal-500,\n  \"teal-600\": $teal-600,\n  \"teal-700\": $teal-700,\n  \"teal-800\": $teal-800,\n  \"teal-900\": $teal-900\n) !default;\n\n$cyans: (\n  \"cyan-100\": $cyan-100,\n  \"cyan-200\": $cyan-200,\n  \"cyan-300\": $cyan-300,\n  \"cyan-400\": $cyan-400,\n  \"cyan-500\": $cyan-500,\n  \"cyan-600\": $cyan-600,\n  \"cyan-700\": $cyan-700,\n  \"cyan-800\": $cyan-800,\n  \"cyan-900\": $cyan-900\n) !default;\n// fusv-enable\n\n// scss-docs-start theme-color-variables\n$primary:       #5856d6 !default;\n$secondary:     #6b7785 !default;\n$success:       #1b9e3e !default;\n$info:          #39f !default;\n$warning:       #f9b115 !default;\n$danger:        #e55353 !default;\n$light:         $gray-100 !default;\n$dark:          $gray-900 !default;\n// scss-docs-end theme-color-variables\n\n// scss-docs-start theme-colors-map\n$theme-colors: (\n  \"primary\":    $primary,\n  \"secondary\":  $secondary,\n  \"success\":    $success,\n  \"info\":       $info,\n  \"warning\":    $warning,\n  \"danger\":     $danger,\n  \"light\":      $light,\n  \"dark\":       $dark\n) !default;\n// scss-docs-end theme-colors-map\n\n// scss-docs-start theme-text-variables\n$primary-text-emphasis:    #3634a3 !default;\n$secondary-text-emphasis:  #212233 !default;\n$success-text-emphasis:    #0f5722 !default;\n$info-text-emphasis:       #184c77 !default;\n$warning-text-emphasis:    #764705 !default;\n$danger-text-emphasis:     #671414 !default;\n$light-text-emphasis:      $gray-700 !default;\n$dark-text-emphasis:       $gray-800 !default;\n// scss-docs-end theme-text-variables\n\n// scss-docs-start theme-bg-subtle-variables\n$primary-bg-subtle:    #cfc7f3 !default;\n$secondary-bg-subtle:  #ced2d8 !default;\n$success-bg-subtle:    #cbedd6 !default;\n$info-bg-subtle:       #c0e6ff !default;\n$warning-bg-subtle:    #feecc5 !default;\n$danger-bg-subtle:     #f9d4d4 !default;\n$light-bg-subtle:      color.mix($gray-100, $white) !default;\n$dark-bg-subtle:       $gray-400 !default;\n// scss-docs-end theme-bg-subtle-variables\n\n// scss-docs-start theme-border-subtle-variables\n$primary-border-subtle:    #9d92e6 !default;\n$secondary-border-subtle:  #9da5b1 !default;\n$success-border-subtle:    #96dbad !default;\n$info-border-subtle:       #80c6ff !default;\n$warning-border-subtle:    #fcd88a !default;\n$danger-border-subtle:     #f2a9a9 !default;\n$light-border-subtle:      $gray-200 !default;\n$dark-border-subtle:       $gray-500 !default;\n// scss-docs-end theme-border-subtle-variables\n\n// Characters which are escaped by the escape-svg function\n$escaped-characters: (\n  (\"<\", \"%3c\"),\n  (\">\", \"%3e\"),\n  (\"#\", \"%23\"),\n  (\"(\", \"%28\"),\n  (\")\", \"%29\"),\n) !default;\n\n// Options\n//\n// Quickly modify global styling by enabling or disabling optional features.\n\n$enable-caret:                true !default;\n$enable-rounded:              true !default;\n$enable-shadows:              false !default;\n$enable-gradients:            false !default;\n$enable-transitions:          true !default;\n$enable-reduced-motion:       true !default;\n$enable-smooth-scroll:        true !default;\n$enable-grid-classes:         true !default;\n$enable-container-classes:    true !default;\n$enable-cssgrid:              false !default;\n$enable-button-pointers:      true !default;\n$enable-rfs:                  true !default;\n$enable-validation-icons:     true !default;\n$enable-negative-margins:     false !default;\n$enable-deprecation-messages: true !default;\n$enable-important-utilities:  true !default;\n$enable-ltr:                  true !default;\n$enable-rtl:                  false !default;\n$enable-container-queries:    false !default;\n\n$enable-dark-mode:            true !default;\n$color-mode-type:             data !default; // `data` or `media-query`\n\n// Prefix for :root CSS variables\n\n$variable-prefix:             cui- !default; // Deprecated in v4.2.6 for the shorter `$prefix`\n$prefix:                      $variable-prefix !default;\n\n// Prefix for data attributes\n\n$data-infix:                  -coreui- !default;\n\n// Set mobile breakpoint\n\n$mobile-breakpoint:           lg !default;\n\n// Gradient\n//\n// The gradient which is added to components if `$enable-gradients` is `true`\n// This gradient is also added to elements with `.bg-gradient`\n// scss-docs-start variable-gradient\n$gradient: linear-gradient(180deg, rgba($white, .15), rgba($white, 0)) !default;\n// scss-docs-end variable-gradient\n\n// Spacing\n//\n// Control the default styling of most Bootstrap elements by modifying these\n// variables. Mostly focused on spacing.\n// You can add more entries to the $spacers map, should you need more variation.\n\n// scss-docs-start spacer-variables-maps\n$spacer: 1rem !default;\n$spacers: (\n  0: 0,\n  1: $spacer * .25,\n  2: $spacer * .5,\n  3: $spacer,\n  4: $spacer * 1.5,\n  5: $spacer * 3,\n) !default;\n// scss-docs-end spacer-variables-maps\n\n// Position\n//\n// Define the edge positioning anchors of the position utilities.\n\n// scss-docs-start position-map\n$position-values: (\n  0: 0,\n  50: 50%,\n  100: 100%\n) !default;\n// scss-docs-end position-map\n\n// Body\n//\n// Settings for the `<body>` element.\n\n$body-text-align:           null !default;\n$body-color:                rgba(shift-color($gray-base, +26%), .95) !default;\n$body-bg:                   $white !default;\n\n$body-secondary-color:      rgba(shift-color($gray-base, +26%), .681) !default;\n$body-secondary-bg:         $gray-200 !default;\n\n$body-tertiary-color:       rgba(shift-color($gray-base, +26%), .38) !default;\n$body-tertiary-bg:          $gray-100 !default;\n\n$body-emphasis-color:       $black !default;\n\n// Links\n//\n// Style anchor elements.\n\n$link-color:                              $primary !default;\n$link-decoration:                         underline !default;\n$link-shade-percentage:                   20% !default;\n$link-hover-color:                        shift-color($link-color, $link-shade-percentage) !default;\n$link-hover-decoration:                   null !default;\n\n$stretched-link-pseudo-element:           after !default;\n$stretched-link-z-index:                  1 !default;\n\n// Icon links\n// scss-docs-start icon-link-variables\n$icon-link-gap:               .375rem !default;\n$icon-link-underline-offset:  .25em !default;\n$icon-link-icon-size:         1em !default;\n$icon-link-icon-transition:   .2s ease-in-out transform !default;\n$icon-link-icon-transform:    translate3d(.25em, 0, 0) !default;\n// scss-docs-end icon-link-variables\n\n// Paragraphs\n//\n// Style p element.\n\n$paragraph-margin-bottom:   1rem !default;\n\n\n// Grid breakpoints\n//\n// Define the minimum dimensions at which your layout will change,\n// adapting to different screen sizes, for use in media queries.\n\n// scss-docs-start grid-breakpoints\n$grid-breakpoints: (\n  xs: 0,\n  sm: 576px,\n  md: 768px,\n  lg: 992px,\n  xl: 1200px,\n  xxl: 1400px\n) !default;\n// scss-docs-end grid-breakpoints\n\n@include assert-ascending($grid-breakpoints, \"$grid-breakpoints\");\n@include assert-starts-at-zero($grid-breakpoints, \"$grid-breakpoints\");\n\n// scss-docs-start cq-grid-breakpoints\n$cq-grid-breakpoints: (\n  xs: 0,\n  sm: 576px,\n  md: 768px,\n  lg: 992px,\n  xl: 1200px,\n  xxl: 1400px\n) !default;\n\n@include assert-ascending($cq-grid-breakpoints, \"$cq-grid-breakpoints\");\n@include assert-starts-at-zero($cq-grid-breakpoints, \"$cq-grid-breakpoints\");\n// scss-docs-end cq-grid-breakpoints\n\n// Grid containers\n//\n// Define the maximum width of `.container` for different screen sizes.\n\n// scss-docs-start container-max-widths\n$container-max-widths: (\n  sm: 540px,\n  md: 720px,\n  lg: 960px,\n  xl: 1140px,\n  xxl: 1320px\n) !default;\n// scss-docs-end container-max-widths\n\n@include assert-ascending($container-max-widths, \"$container-max-widths\");\n\n\n// Grid columns\n//\n// Set the number of columns and specify the width of the gutters.\n\n$grid-columns:                12 !default;\n$grid-gutter-width:           1.5rem !default;\n$grid-row-columns:            6 !default;\n\n// Container padding\n\n$container-padding-x: $grid-gutter-width !default;\n\n\n// Components\n//\n// Define common padding and border radius sizes and more.\n\n// scss-docs-start border-variables\n$border-width:                1px !default;\n$border-widths: (\n  1: 1px,\n  2: 2px,\n  3: 3px,\n  4: 4px,\n  5: 5px\n) !default;\n\n$border-style:                solid !default;\n$border-color:                $gray-300 !default;\n$border-color-translucent:    color-translucent($gray-300, .175) !default;\n// scss-docs-end border-variables\n\n// scss-docs-start border-radius-variables\n$border-radius:               .375rem !default;\n$border-radius-sm:            .25rem !default;\n$border-radius-lg:            .5rem !default;\n$border-radius-xl:            1rem !default;\n$border-radius-xxl:           2rem !default;\n$border-radius-pill:          50rem !default;\n// scss-docs-end border-radius-variables\n// fusv-disable\n$border-radius-2xl:           $border-radius-xxl !default; // Deprecated in v5.0.0\n// fusv-enable\n\n// scss-docs-start box-shadow-variables\n$box-shadow:                  0 .5rem 1rem rgba($black, .15) !default;\n$box-shadow-sm:               0 .125rem .25rem rgba($black, .075) !default;\n$box-shadow-lg:               0 1rem 3rem rgba($black, .175) !default;\n$box-shadow-inset:            inset 0 1px 2px rgba($black, .075) !default;\n// scss-docs-end box-shadow-variables\n\n$component-active-color:      rgba($white, .87) !default;\n$component-active-bg:         var(--#{$prefix}primary) !default;\n\n// scss-docs-start focus-ring-variables\n$focus-ring-width:      .25rem !default;\n$focus-ring-opacity:    .25 !default;\n$focus-ring-color:      rgba($primary, $focus-ring-opacity) !default;\n$focus-ring-blur:       0 !default;\n$focus-ring-box-shadow: 0 0 $focus-ring-blur $focus-ring-width $focus-ring-color !default;\n// scss-docs-end focus-ring-variables\n\n// scss-docs-start caret-variables\n$caret-width:                 .3em !default;\n$caret-vertical-align:        $caret-width * .85 !default;\n$caret-spacing:               $caret-width * .85 !default;\n// scss-docs-end caret-variables\n\n$transition-base:             all .2s ease-in-out !default;\n$transition-fade:             opacity .15s linear !default;\n// scss-docs-start collapse-transition\n$transition-collapse:         height .35s ease !default;\n$transition-collapse-width:   width .35s ease !default;\n// scss-docs-end collapse-transition\n\n// stylelint-disable function-disallowed-list\n// scss-docs-start aspect-ratios\n$aspect-ratios: (\n  \"1x1\": 100%,\n  \"4x3\": calc(3 / 4 * 100%),\n  \"16x9\": calc(9 / 16 * 100%),\n  \"21x9\": calc(9 / 21 * 100%)\n) !default;\n// scss-docs-end aspect-ratios\n// stylelint-enable function-disallowed-list\n\n// Typography\n//\n// Font, line-height, and color for body text, headings, and more.\n\n// scss-docs-start font-variables\n// stylelint-disable value-keyword-case\n$font-family-sans-serif:      system-ui, -apple-system, \"Segoe UI\", Roboto, \"Helvetica Neue\", \"Noto Sans\", \"Liberation Sans\", Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\" !default;\n$font-family-monospace:       SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace !default;\n// stylelint-enable value-keyword-case\n$font-family-base:            var(--#{$prefix}font-sans-serif) !default;\n$font-family-code:            var(--#{$prefix}font-monospace) !default;\n\n// $font-size-root affects the value of `rem`, which is used for as well font sizes, paddings, and margins\n// $font-size-base affects the font size of the body text\n$font-size-root:              null !default;\n$font-size-base:              1rem !default; // Assumes the browser default, typically `16px`\n$font-size-sm:                $font-size-base * .875 !default;\n$font-size-lg:                $font-size-base * 1.25 !default;\n\n$font-weight-lighter:         lighter !default;\n$font-weight-light:           300 !default;\n$font-weight-normal:          400 !default;\n$font-weight-medium:          500 !default;\n$font-weight-semibold:        600 !default;\n$font-weight-bold:            700 !default;\n$font-weight-bolder:          bolder !default;\n\n$font-weight-base:            $font-weight-normal !default;\n\n$line-height-base:            1.5 !default;\n$line-height-sm:              1.25 !default;\n$line-height-lg:              2 !default;\n\n$h1-font-size:                $font-size-base * 2.5 !default;\n$h2-font-size:                $font-size-base * 2 !default;\n$h3-font-size:                $font-size-base * 1.75 !default;\n$h4-font-size:                $font-size-base * 1.5 !default;\n$h5-font-size:                $font-size-base * 1.25 !default;\n$h6-font-size:                $font-size-base !default;\n// scss-docs-end font-variables\n\n// scss-docs-start font-sizes\n$font-sizes: (\n  1: $h1-font-size,\n  2: $h2-font-size,\n  3: $h3-font-size,\n  4: $h4-font-size,\n  5: $h5-font-size,\n  6: $h6-font-size\n) !default;\n// scss-docs-end font-sizes\n\n// scss-docs-start headings-variables\n$headings-margin-bottom:      $spacer * .5 !default;\n$headings-font-family:        null !default;\n$headings-font-style:         null !default;\n$headings-font-weight:        500 !default;\n$headings-line-height:        1.2 !default;\n$headings-color:              inherit !default;\n// scss-docs-end headings-variables\n\n// scss-docs-start display-headings\n$display-font-sizes: (\n  1: 5rem,\n  2: 4.5rem,\n  3: 4rem,\n  4: 3.5rem,\n  5: 3rem,\n  6: 2.5rem\n) !default;\n\n$display-font-family: null !default;\n$display-font-style:  null !default;\n$display-font-weight: 300 !default;\n$display-line-height: $headings-line-height !default;\n// scss-docs-end display-headings\n\n// scss-docs-start type-variables\n$lead-font-size:                $font-size-base * 1.25 !default;\n$lead-font-weight:              300 !default;\n\n$small-font-size:               .875em !default;\n\n$sub-sup-font-size:             .75em !default;\n\n// fusv-disable\n$text-muted:                  var(--#{$prefix}secondary-color) !default; // Deprecated in 5.0.0\n// fusv-enable\n\n$initialism-font-size:        $small-font-size !default;\n\n$blockquote-margin-y:         $spacer !default;\n$blockquote-font-size:        $font-size-base * 1.25 !default;\n$blockquote-footer-color:     $gray-600 !default;\n$blockquote-footer-font-size: $small-font-size !default;\n\n$hr-margin-y:                 $spacer !default;\n$hr-color:                    inherit !default;\n\n// fusv-disable\n$hr-bg-color:                 null !default; // Deprecated in v4.2.6\n$hr-height:                   null !default; // Deprecated in v4.2.6\n// fusv-enable\n\n$hr-border-color:             null !default; // Allows for inherited colors\n$hr-border-width:             var(--#{$prefix}border-width) !default;\n$hr-opacity:                  .25 !default;\n\n// scss-docs-start vr-variables\n$vr-border-width:             var(--#{$prefix}border-width) !default;\n// scss-docs-end vr-variables\n\n$legend-margin-bottom:        .5rem !default;\n$legend-font-size:            1.5rem !default;\n$legend-font-weight:          null !default;\n\n$dt-font-weight:              $font-weight-bold !default;\n\n$list-inline-padding:         .5rem !default;\n\n$mark-padding:                .1875em !default;\n$mark-color:                  $body-color !default;\n$mark-bg:                     $yellow-100 !default;\n// scss-docs-end type-variables\n\n// Icons\n$icon-size-base:  1rem !default;\n$icon-size-sm:    $icon-size-base * .875 !default;\n$icon-size-lg:    $icon-size-base * 1.25 !default;\n$icon-size-xl:    $icon-size-base * 1.5 !default;\n$icon-size-xxl:   $icon-size-base * 2 !default;\n\n\n// Tables\n//\n// Customizes the `.table` component with basic values, each used across all table variations.\n\n// scss-docs-start table-variables\n$table-cell-padding-y:        .5rem !default;\n$table-cell-padding-x:        .5rem !default;\n$table-cell-padding-y-sm:     .25rem !default;\n$table-cell-padding-x-sm:     .25rem !default;\n\n$table-cell-vertical-align:   top !default;\n\n$table-color:                 var(--#{$prefix}emphasis-color) !default;\n$table-bg:                    var(--#{$prefix}body-bg) !default;\n$table-accent-bg:             transparent !default;\n\n$table-th-font-weight:        null !default;\n\n$table-striped-color:         $table-color !default;\n$table-striped-bg-factor:     .05 !default;\n$table-striped-bg:            rgba(var(--#{$prefix}emphasis-color-rgb), $table-striped-bg-factor) !default;\n\n$table-active-color:          $table-color !default;\n$table-active-bg-factor:      .1 !default;\n$table-active-bg:             rgba(var(--#{$prefix}emphasis-color-rgb), $table-active-bg-factor) !default;\n\n$table-hover-color:           $table-color !default;\n$table-hover-bg-factor:       .075 !default;\n$table-hover-bg:              rgba(var(--#{$prefix}emphasis-color-rgb), $table-hover-bg-factor) !default;\n\n$table-border-factor:         .2 !default;\n$table-border-width:          var(--#{$prefix}border-width) !default;\n$table-border-color:          var(--#{$prefix}border-color) !default;\n\n$table-striped-order:         odd !default;\n$table-striped-columns-order: even !default;\n\n$table-group-separator-color: currentcolor !default;\n\n$table-caption-color:         var(--#{$prefix}secondary-color) !default;\n\n$table-bg-scale:              -80% !default;\n// scss-docs-end table-variables\n\n// scss-docs-start table-loop\n$table-variants: (\n  \"primary\":    shift-color($primary, $table-bg-scale),\n  \"secondary\":  shift-color($secondary, $table-bg-scale),\n  \"success\":    shift-color($success, $table-bg-scale),\n  \"info\":       shift-color($info, $table-bg-scale),\n  \"warning\":    shift-color($warning, $table-bg-scale),\n  \"danger\":     shift-color($danger, $table-bg-scale),\n  \"light\":      $light,\n  \"dark\":       $dark,\n) !default;\n// scss-docs-end table-loop\n\n\n// Buttons + Forms\n//\n// Shared variables that are reassigned to `$input-` and `$btn-` specific variables.\n\n// scss-docs-start input-btn-variables\n$input-btn-padding-y:         .375rem !default;\n$input-btn-padding-x:         .75rem !default;\n$input-btn-font-family:       null !default;\n$input-btn-font-size:         $font-size-base !default;\n$input-btn-line-height:       $line-height-base !default;\n\n$input-btn-focus-width:         $focus-ring-width !default;\n$input-btn-focus-color-opacity: $focus-ring-opacity !default;\n$input-btn-focus-color:         $focus-ring-color !default;\n$input-btn-focus-blur:          $focus-ring-blur !default;\n$input-btn-focus-box-shadow:    $focus-ring-box-shadow !default;\n\n$input-btn-padding-y-sm:      .25rem !default;\n$input-btn-padding-x-sm:      .5rem !default;\n$input-btn-font-size-sm:      $font-size-sm !default;\n\n$input-btn-padding-y-lg:      .5rem !default;\n$input-btn-padding-x-lg:      1rem !default;\n$input-btn-font-size-lg:      $font-size-lg !default;\n\n$input-btn-border-width:      var(--#{$prefix}border-width) !default;\n// scss-docs-end input-btn-variables\n\n\n// Buttons\n//\n// For each of Bootstrap's buttons, define text, background, and border color.\n\n// scss-docs-start btn-variables\n$btn-color:                   var(--#{$prefix}body-color) !default;\n$btn-padding-y:               $input-btn-padding-y !default;\n$btn-padding-x:               $input-btn-padding-x !default;\n$btn-font-family:             $input-btn-font-family !default;\n$btn-font-size:               $input-btn-font-size !default;\n$btn-line-height:             $input-btn-line-height !default;\n$btn-white-space:             null !default; // Set to `nowrap` to prevent text wrapping\n\n$btn-padding-y-sm:            $input-btn-padding-y-sm !default;\n$btn-padding-x-sm:            $input-btn-padding-x-sm !default;\n$btn-font-size-sm:            $input-btn-font-size-sm !default;\n\n$btn-padding-y-lg:            $input-btn-padding-y-lg !default;\n$btn-padding-x-lg:            $input-btn-padding-x-lg !default;\n$btn-font-size-lg:            $input-btn-font-size-lg !default;\n\n$btn-border-width:            $input-btn-border-width !default;\n\n$btn-font-weight:             $font-weight-normal !default;\n$btn-box-shadow:              inset 0 1px 0 rgba($white, .15), 0 1px 1px rgba($black, .075) !default;\n$btn-focus-width:             $input-btn-focus-width !default;\n$btn-focus-box-shadow:        $input-btn-focus-box-shadow !default;\n$btn-disabled-opacity:        .65 !default;\n$btn-active-box-shadow:       inset 0 3px 5px rgba($black, .125) !default;\n\n$btn-link-color:              var(--#{$prefix}link-color) !default;\n$btn-link-hover-color:        var(--#{$prefix}link-hover-color) !default;\n$btn-link-disabled-color:     $gray-600 !default;\n$btn-link-focus-shadow-rgb:   to-rgb(color.mix(color-contrast-variables($link-color, $color-contrast-dark, $color-contrast-light, $white, $black, $min-contrast-ratio), $link-color, 15%)) !default;\n\n// Allows for customizing button radius independently from global border radius\n$btn-border-radius:           var(--#{$prefix}border-radius) !default;\n$btn-border-radius-sm:        var(--#{$prefix}border-radius-sm) !default;\n$btn-border-radius-lg:        var(--#{$prefix}border-radius-lg) !default;\n\n$btn-transition:              color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n\n$btn-hover-bg-shade-amount:       15% !default;\n$btn-hover-bg-tint-amount:        15% !default;\n$btn-hover-border-shade-amount:   20% !default;\n$btn-hover-border-tint-amount:    10% !default;\n$btn-active-bg-shade-amount:      20% !default;\n$btn-active-bg-tint-amount:       20% !default;\n$btn-active-border-shade-amount:  25% !default;\n$btn-active-border-tint-amount:   10% !default;\n// scss-docs-end btn-variables\n\n// scss-docs-start btn-outline-variables\n$btn-outline-color: var(--#{$prefix}secondary-color) !default;\n$btn-outline-border-color: var(--#{$prefix}border-color) !default;\n$btn-outline-active-color: var(--#{$prefix}body-color) !default;\n$btn-outline-active-bg: var(--#{$prefix}tertiary-bg) !default;\n$btn-outline-active-border-color: var(--#{$prefix}border-color) !default;\n$btn-outline-disabled-color: var(--#{$prefix}secondary-color) !default;\n$btn-outline-disabled-border-color: var(--#{$prefix}border-color) !default;\n$btn-outline-hover-color: var(--#{$prefix}body-color) !default;\n$btn-outline-hover-bg: var(--#{$prefix}tertiary-bg) !default;\n$btn-outline-hover-border-color: var(--#{$prefix}border-color) !default;\n$btn-outline-focus-shadow-rgb: var(--#{$prefix}tertiary-bg-rgb) !default;\n// scss-docs-end btn-outline-variables\n\n// scss-docs-start btn-ghost-variables\n$btn-ghost-color: var(--#{$prefix}secondary-color) !default;\n$btn-ghost-active-color: var(--#{$prefix}body-color) !default;\n$btn-ghost-active-bg: var(--#{$prefix}tertiary-bg) !default;\n$btn-ghost-disabled-color: var(--#{$prefix}secondary-color) !default;\n$btn-ghost-hover-color: var(--#{$prefix}body-color) !default;\n$btn-ghost-hover-bg: var(--#{$prefix}tertiary-bg) !default;\n$btn-ghost-focus-shadow-rgb: var(--#{$prefix}tertiary-bg-rgb) !default;\n// scss-docs-end btn-ghost-variables\n\n// Forms\n\n// scss-docs-start form-text-variables\n$form-text-margin-top:                  .25rem !default;\n$form-text-font-size:                   $small-font-size !default;\n$form-text-font-style:                  null !default;\n$form-text-font-weight:                 null !default;\n$form-text-color:                       var(--#{$prefix}secondary-color) !default;\n// scss-docs-end form-text-variables\n\n// scss-docs-start form-label-variables\n$form-label-margin-bottom:              .5rem !default;\n$form-label-font-size:                  null !default;\n$form-label-font-style:                 null !default;\n$form-label-font-weight:                null !default;\n$form-label-color:                      null !default;\n// scss-docs-end form-label-variables\n\n// scss-docs-start form-input-variables\n$input-padding-y:                       $input-btn-padding-y !default;\n$input-padding-x:                       $input-btn-padding-x !default;\n$input-font-family:                     $input-btn-font-family !default;\n$input-font-size:                       $input-btn-font-size !default;\n$input-font-weight:                     $font-weight-base !default;\n$input-line-height:                     $input-btn-line-height !default;\n\n$input-padding-y-sm:                    $input-btn-padding-y-sm !default;\n$input-padding-x-sm:                    $input-btn-padding-x-sm !default;\n$input-font-size-sm:                    $input-btn-font-size-sm !default;\n\n$input-padding-y-lg:                    $input-btn-padding-y-lg !default;\n$input-padding-x-lg:                    $input-btn-padding-x-lg !default;\n$input-font-size-lg:                    $input-btn-font-size-lg !default;\n\n$input-bg:                              var(--#{$prefix}body-bg) !default;\n$input-disabled-color:                  null !default;\n$input-disabled-bg:                     var(--#{$prefix}secondary-bg) !default;\n$input-disabled-border-color:           null !default;\n\n$input-color:                           var(--#{$prefix}body-color) !default;\n$input-border-color:                    var(--#{$prefix}border-color) !default;\n$input-border-width:                    $input-btn-border-width !default;\n$input-box-shadow:                      var(--#{$prefix}box-shadow-inset) !default;\n\n$input-border-radius:                   var(--#{$prefix}border-radius) !default;\n$input-border-radius-sm:                var(--#{$prefix}border-radius-sm) !default;\n$input-border-radius-lg:                var(--#{$prefix}border-radius-lg) !default;\n\n$input-focus-bg:                        $input-bg !default;\n$input-focus-border-color:              tint-color($primary, 50%) !default;\n$input-focus-color:                     $input-color !default;\n$input-focus-width:                     $input-btn-focus-width !default;\n$input-focus-box-shadow:                $input-btn-focus-box-shadow !default;\n\n$input-placeholder-color:               var(--#{$prefix}secondary-color) !default;\n$input-plaintext-color:                 var(--#{$prefix}body-color) !default;\n\n$input-height-border:                   calc(#{$input-border-width} * 2) !default; // stylelint-disable-line function-disallowed-list\n\n$input-height-inner:                    add($input-line-height * 1em, $input-padding-y * 2) !default;\n$input-height-inner-half:               add($input-line-height * .5em, $input-padding-y) !default;\n$input-height-inner-quarter:            add($input-line-height * .25em, $input-padding-y * .5) !default;\n\n$input-height:                          add($input-line-height * 1em, add($input-padding-y * 2, $input-height-border, false)) !default;\n$input-height-sm:                       add($input-line-height * 1em, add($input-padding-y-sm * 2, $input-height-border, false)) !default;\n$input-height-lg:                       add($input-line-height * 1em, add($input-padding-y-lg * 2, $input-height-border, false)) !default;\n\n$input-transition:                      border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n\n$form-color-width:                      3rem !default;\n// scss-docs-end form-input-variables\n\n// scss-docs-start form-check-variables\n$form-check-input-width:                  1em !default;\n$form-check-min-height:                   $font-size-base * $line-height-base !default;\n$form-check-padding-start:                $form-check-input-width + .5em !default;\n$form-check-margin-bottom:                .125rem !default;\n$form-check-label-color:                  null !default;\n$form-check-label-cursor:                 null !default;\n$form-check-transition:                   null !default;\n\n$form-check-input-active-filter:          brightness(90%) !default;\n\n$form-check-input-bg:                     $input-bg !default;\n$form-check-input-border:                 var(--#{$prefix}border-width) solid var(--#{$prefix}border-color) !default;\n$form-check-input-border-radius:          .25em !default;\n$form-check-radio-border-radius:          50% !default;\n$form-check-input-focus-border:           $input-focus-border-color !default;\n$form-check-input-focus-box-shadow:       $focus-ring-box-shadow !default;\n\n$form-check-input-checked-color:          $component-active-color !default;\n$form-check-input-checked-bg-color:       $component-active-bg !default;\n$form-check-input-checked-border-color:   $form-check-input-checked-bg-color !default;\n$form-check-input-checked-bg-image:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'><path fill='none' stroke='#{$form-check-input-checked-color}' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='m6 10 3 3 6-6'/></svg>\") !default;\n$form-check-radio-checked-bg-image:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='2' fill='#{$form-check-input-checked-color}'/></svg>\") !default;\n\n$form-check-input-indeterminate-color:          $component-active-color !default;\n$form-check-input-indeterminate-bg-color:       $component-active-bg !default;\n$form-check-input-indeterminate-border-color:   $form-check-input-indeterminate-bg-color !default;\n$form-check-input-indeterminate-bg-image:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'><path fill='none' stroke='#{$form-check-input-indeterminate-color}' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='M6 10h8'/></svg>\") !default;\n\n$form-check-input-disabled-opacity:        .5 !default;\n$form-check-label-disabled-opacity:        $form-check-input-disabled-opacity !default;\n$form-check-btn-check-disabled-opacity:    $btn-disabled-opacity !default;\n\n$form-check-inline-margin-end:    1rem !default;\n// scss-docs-end form-check-variables\n\n// scss-docs-start form-switch-variables\n$form-switch-color:               rgba($black, .25) !default;\n$form-switch-width:               2em !default;\n$form-switch-padding-start:       $form-switch-width + .5em !default;\n$form-switch-bg-image:            url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-color}'/></svg>\") !default;\n$form-switch-border-radius:       $form-switch-width !default;\n$form-switch-transition:          background-position .15s ease-in-out !default;\n\n$form-switch-focus-color:         $input-focus-border-color !default;\n$form-switch-focus-bg-image:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-focus-color}'/></svg>\") !default;\n\n$form-switch-checked-color:       $component-active-color !default;\n$form-switch-checked-bg-image:    url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-checked-color}'/></svg>\") !default;\n$form-switch-checked-bg-position: right center !default;\n\n$form-switch-widths: (\n  lg: (\n    width: 2.5em,\n    height: 1.25em\n  ),\n  xl: (\n    width: 3em,\n    height: 1.5em\n  )\n) !default;\n// scss-docs-end form-switch-variables\n\n$form-check-inline-margin-end:    1rem !default;\n\n// scss-docs-start input-group-variables\n$input-group-addon-padding-y:           $input-padding-y !default;\n$input-group-addon-padding-x:           $input-padding-x !default;\n$input-group-addon-font-weight:         $input-font-weight !default;\n$input-group-addon-color:               $input-color !default;\n$input-group-addon-bg:                  var(--#{$prefix}tertiary-bg) !default;\n$input-group-addon-border-color:        $input-border-color !default;\n// scss-docs-end input-group-variables\n\n// scss-docs-start form-select-variables\n$form-select-padding-y:             $input-padding-y !default;\n$form-select-padding-x:             $input-padding-x !default;\n$form-select-font-family:           $input-font-family !default;\n$form-select-font-size:             $input-font-size !default;\n$form-select-indicator-padding:     $form-select-padding-x * 3 !default; // Extra padding for background-image\n$form-select-font-weight:           $input-font-weight !default;\n$form-select-line-height:           $input-line-height !default;\n$form-select-color:                 $input-color !default;\n$form-select-bg:                    $input-bg !default;\n$form-select-disabled-color:        null !default;\n$form-select-disabled-bg:           $input-disabled-bg !default;\n$form-select-disabled-border-color: $input-disabled-border-color !default;\n$form-select-bg-position:           right $form-select-padding-x center !default;\n$form-select-bg-size:               16px 12px !default; // In pixels because image dimensions\n$form-select-indicator-color:       $gray-800 !default;\n$form-select-indicator:             url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'><path fill='none' stroke='#{$form-select-indicator-color}' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='m2 5 6 6 6-6'/></svg>\") !default;\n\n$form-select-feedback-icon-padding-end: $form-select-padding-x * 2.5 + $form-select-indicator-padding !default;\n$form-select-feedback-icon-position:    center right $form-select-indicator-padding !default;\n$form-select-feedback-icon-size:        $input-height-inner-half $input-height-inner-half !default;\n\n$form-select-border-width:        $input-border-width !default;\n$form-select-border-color:        $input-border-color !default;\n$form-select-border-radius:       $input-border-radius !default;\n$form-select-box-shadow:          var(--#{$prefix}box-shadow-inset) !default;\n\n$form-select-focus-border-color:  $input-focus-border-color !default;\n$form-select-focus-width:         $input-focus-width !default;\n$form-select-focus-box-shadow:    0 0 0 $form-select-focus-width $input-btn-focus-color !default;\n\n$form-select-padding-y-sm:        $input-padding-y-sm !default;\n$form-select-padding-x-sm:        $input-padding-x-sm !default;\n$form-select-font-size-sm:        $input-font-size-sm !default;\n$form-select-border-radius-sm:    $input-border-radius-sm !default;\n\n$form-select-padding-y-lg:        $input-padding-y-lg !default;\n$form-select-padding-x-lg:        $input-padding-x-lg !default;\n$form-select-font-size-lg:        $input-font-size-lg !default;\n$form-select-border-radius-lg:    $input-border-radius-lg !default;\n\n$form-select-transition:          $input-transition !default;\n// scss-docs-end form-select-variables\n\n// scss-docs-start form-range-variables\n$form-range-track-width:          100% !default;\n$form-range-track-height:         .5rem !default;\n$form-range-track-cursor:         pointer !default;\n$form-range-track-bg:             var(--#{$prefix}secondary-bg) !default;\n$form-range-track-border-radius:  1rem !default;\n$form-range-track-box-shadow:     var(--#{$prefix}box-shadow-inset) !default;\n\n$form-range-thumb-width:                   1rem !default;\n$form-range-thumb-height:                  $form-range-thumb-width !default;\n$form-range-thumb-bg:                      $component-active-bg !default;\n$form-range-thumb-border:                  0 !default;\n$form-range-thumb-border-radius:           1rem !default;\n$form-range-thumb-box-shadow:              0 .1rem .25rem rgba($black, .1) !default;\n$form-range-thumb-focus-box-shadow:        0 0 0 1px $body-bg, $input-focus-box-shadow !default;\n$form-range-thumb-focus-box-shadow-width:  $input-focus-width !default; // For focus box shadow issue in Edge\n$form-range-thumb-active-bg:               tint-color($primary, 70%) !default;\n$form-range-thumb-disabled-bg:             var(--#{$prefix}secondary-color) !default;\n$form-range-thumb-transition:              background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n// scss-docs-end form-range-variables\n\n// scss-docs-start form-file-variables\n$form-file-button-color:          $input-color !default;\n$form-file-button-bg:             var(--#{$prefix}tertiary-bg) !default;\n$form-file-button-hover-bg:       var(--#{$prefix}secondary-bg) !default;\n// scss-docs-end form-file-variables\n\n// scss-docs-start form-floating-variables\n$form-floating-height:                  add(3.5rem, $input-height-border) !default;\n$form-floating-line-height:             1.25 !default;\n$form-floating-padding-x:               $input-padding-x !default;\n$form-floating-padding-y:               1rem !default;\n$form-floating-input-padding-t:         1.625rem !default;\n$form-floating-input-padding-b:         .625rem !default;\n$form-floating-label-height:            1.5em !default;\n$form-floating-label-opacity:           .65 !default;\n$form-floating-label-transform:         scale(.85) translateY(-.5rem) translateX(.15rem) !default;\n$form-floating-label-disabled-color:    $gray-600 !default;\n$form-floating-transition:              opacity .1s ease-in-out, transform .1s ease-in-out !default;\n// scss-docs-end form-floating-variables\n\n// Form validation\n\n// scss-docs-start form-feedback-variables\n$form-feedback-margin-top:          $form-text-margin-top !default;\n$form-feedback-font-size:           $form-text-font-size !default;\n$form-feedback-font-style:          $form-text-font-style !default;\n$form-feedback-valid-color:         $success !default;\n$form-feedback-invalid-color:       $danger !default;\n\n$form-feedback-icon-valid-color:    $form-feedback-valid-color !default;\n$form-feedback-icon-valid:          url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'><path fill='#{$form-feedback-icon-valid-color}' d='M2.3 6.73.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1'/></svg>\") !default;\n$form-feedback-icon-invalid-color:  $form-feedback-invalid-color !default;\n$form-feedback-icon-invalid:        url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12' width='12' height='12' fill='none' stroke='#{$form-feedback-icon-invalid-color}'><circle cx='6' cy='6' r='4.5'/><path stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/><circle cx='6' cy='8.2' r='.6' fill='#{$form-feedback-icon-invalid-color}' stroke='none'/></svg>\") !default;\n// scss-docs-end form-feedback-variables\n\n// scss-docs-start form-validation-colors\n$form-valid-color:                  $form-feedback-valid-color !default;\n$form-valid-border-color:           $form-feedback-valid-color !default;\n$form-invalid-color:                $form-feedback-invalid-color !default;\n$form-invalid-border-color:         $form-feedback-invalid-color !default;\n// scss-docs-end form-validation-colors\n\n// scss-docs-start form-validation-states\n$form-validation-states: (\n  \"valid\": (\n    \"color\": var(--#{$prefix}form-valid-color),\n    \"icon\": $form-feedback-icon-valid,\n    \"tooltip-color\": #fff,\n    \"tooltip-bg-color\": var(--#{$prefix}success),\n    \"focus-box-shadow\": 0 0 $input-btn-focus-blur $input-focus-width rgba(var(--#{$prefix}success-rgb), $input-btn-focus-color-opacity),\n    \"border-color\": var(--#{$prefix}form-valid-border-color),\n  ),\n  \"invalid\": (\n    \"color\": var(--#{$prefix}form-invalid-color),\n    \"icon\": $form-feedback-icon-invalid,\n    \"tooltip-color\": #fff,\n    \"tooltip-bg-color\": var(--#{$prefix}danger),\n    \"focus-box-shadow\": 0 0 $input-btn-focus-blur $input-focus-width rgba(var(--#{$prefix}danger-rgb), $input-btn-focus-color-opacity),\n    \"border-color\": var(--#{$prefix}form-invalid-border-color),\n  )\n) !default;\n// scss-docs-end form-validation-states\n\n// Z-index master list\n//\n// Warning: Avoid customizing these values. They're used for a bird's eye view\n// of components dependent on the z-axis and are designed to all work together.\n\n// scss-docs-start zindex-stack\n$zindex-dropdown:                   1000 !default;\n$zindex-sticky:                     1020 !default;\n$zindex-fixed:                      1030 !default;\n$zindex-sidebar-backdrop:           1034 !default;\n$zindex-sidebar:                    1035 !default;\n$zindex-offcanvas-backdrop:         1040 !default;\n$zindex-offcanvas:                  1045 !default;\n$zindex-modal-backdrop:             1050 !default;\n$zindex-modal:                      1055 !default;\n$zindex-popover:                    1070 !default;\n$zindex-tooltip:                    1080 !default;\n$zindex-toast:                      1090 !default;\n// scss-docs-end zindex-stack\n\n// scss-docs-start zindex-levels-map\n$zindex-levels: (\n  n1: -1,\n  0: 0,\n  1: 1,\n  2: 2,\n  3: 3\n) !default;\n// scss-docs-end zindex-levels-map\n\n\n// Navs\n\n// scss-docs-start nav-variables\n$nav-link-padding-y:                .5rem !default;\n$nav-link-padding-x:                1rem !default;\n$nav-link-font-size:                null !default;\n$nav-link-font-weight:              null !default;\n$nav-link-color:                    var(--#{$prefix}link-color) !default;\n$nav-link-hover-color:              var(--#{$prefix}link-hover-color) !default;\n$nav-link-transition:               color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out !default;\n$nav-link-disabled-color:           var(--#{$prefix}secondary-color) !default;\n$nav-link-focus-box-shadow:         $focus-ring-box-shadow !default;\n\n$nav-tabs-border-color:             var(--#{$prefix}border-color) !default;\n$nav-tabs-border-width:             var(--#{$prefix}border-width) !default;\n$nav-tabs-border-radius:            var(--#{$prefix}border-radius) !default;\n$nav-tabs-link-hover-border-color:  var(--#{$prefix}secondary-bg) var(--#{$prefix}secondary-bg) $nav-tabs-border-color !default;\n$nav-tabs-link-active-color:        var(--#{$prefix}emphasis-color) !default;\n$nav-tabs-link-active-bg:           var(--#{$prefix}body-bg) !default;\n$nav-tabs-link-active-border-color: var(--#{$prefix}border-color) var(--#{$prefix}border-color) $nav-tabs-link-active-bg !default;\n\n$nav-pills-border-radius:           var(--#{$prefix}border-radius) !default;\n$nav-pills-link-active-color:       $component-active-color !default;\n$nav-pills-link-active-bg:          $component-active-bg !default;\n\n$nav-underline-gap:                 1rem !default;\n$nav-underline-border-width:        .125rem !default;\n$nav-underline-link-active-color:   var(--#{$prefix}emphasis-color) !default;\n\n$nav-underline-border-gap:                  .5rem !default;\n$nav-underline-border-border-color:         var(--#{$prefix}border-color) !default;\n$nav-underline-border-border-width:         .125rem !default;\n$nav-underline-border-link-padding-y:       .5rem !default;\n$nav-underline-border-link-padding-x:       .5rem !default;\n$nav-underline-border-link-color:           var(--#{$prefix}secondary-color) !default;\n$nav-underline-border-link-active-color:    var(--#{$prefix}primary) !default;\n$nav-underline-border-link-disabled-color:  var(--#{$prefix}tertiary-color) !default;\n\n$nav-enclosed-padding:                   .125rem !default;\n$nav-enclosed-bg:                        var(--#{$prefix}tertiary-bg) !default;\n$nav-enclosed-border-radius:             $border-radius-lg !default;\n$nav-enclosed-link-padding-y:            .375rem !default;\n$nav-enclosed-link-padding-x:            .875rem !default;\n$nav-enclosed-link-color:                var(--#{$prefix}body-color) !default;\n$nav-enclosed-link-border-width:         1px !default;\n$nav-enclosed-link-active-color:         var(--#{$prefix}body-color) !default;\n$nav-enclosed-link-active-bg:            var(--#{$prefix}body-bg) !default;\n$nav-enclosed-link-active-border-color:  var(--#{$prefix}border-color) !default;\n$nav-enclosed-link-hover-box-shadow:     var(--#{$prefix}box-shadow-sm) !default;\n$nav-enclosed-link-disabled-color:       var(--#{$prefix}secondary-color) !default;\n// scss-docs-end nav-variables\n\n\n// Navbar\n\n// scss-docs-start navbar-variables\n$navbar-padding-y:                  $spacer * .5 !default;\n$navbar-padding-x:                  null !default;\n\n$navbar-nav-link-padding-x:         .5rem !default;\n\n$navbar-brand-font-size:            $font-size-lg !default;\n// Compute the navbar-brand padding-y so the navbar-brand will have the same height as navbar-text and nav-link\n$nav-link-height:                   $font-size-base * $line-height-base + $nav-link-padding-y * 2 !default;\n$navbar-brand-height:               $navbar-brand-font-size * $line-height-base !default;\n$navbar-brand-padding-y:            ($nav-link-height - $navbar-brand-height) * .5 !default;\n$navbar-brand-margin-end:           1rem !default;\n\n$navbar-toggler-padding-y:          .25rem !default;\n$navbar-toggler-padding-x:          .75rem !default;\n$navbar-toggler-font-size:          $font-size-lg !default;\n$navbar-toggler-border-radius:      $btn-border-radius !default;\n$navbar-toggler-focus-width:        $btn-focus-width !default;\n$navbar-toggler-transition:         box-shadow .15s ease-in-out !default;\n\n$navbar-light-color:                rgba(var(--#{$prefix}emphasis-color-rgb), .65) !default;\n$navbar-light-hover-color:          rgba(var(--#{$prefix}emphasis-color-rgb), .8) !default;\n$navbar-light-active-color:         rgba(var(--#{$prefix}emphasis-color-rgb), 1) !default;\n$navbar-light-disabled-color:       rgba(var(--#{$prefix}emphasis-color-rgb), .3) !default;\n$navbar-light-icon-color:           rgba($body-color, .75) !default;\n$navbar-light-toggler-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'><path stroke='#{$navbar-light-icon-color}' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/></svg>\") !default;\n$navbar-light-toggler-border-color: rgba(var(--#{$prefix}emphasis-color-rgb), .15) !default;\n$navbar-light-brand-color:          $navbar-light-active-color !default;\n$navbar-light-brand-hover-color:    $navbar-light-active-color !default;\n// scss-docs-end navbar-variables\n\n// scss-docs-start navbar-dark-variables\n$navbar-dark-color:                 rgba($white, .55) !default;\n$navbar-dark-hover-color:           rgba($white, .75) !default;\n$navbar-dark-active-color:          $white !default;\n$navbar-dark-disabled-color:        rgba($white, .25) !default;\n$navbar-dark-icon-color:            $navbar-dark-color !default;\n$navbar-dark-toggler-icon-bg:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'><path stroke='#{$navbar-dark-icon-color}' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/></svg>\") !default;\n$navbar-dark-toggler-border-color:  rgba($white, .1) !default;$navbar-dark-toggler-border-color:  rgba($white, .1) !default;\n$navbar-dark-brand-color:           $navbar-dark-active-color !default;\n$navbar-dark-brand-hover-color:     $navbar-dark-active-color !default;\n// scss-docs-end navbar-dark-variables\n\n\n// Dropdowns\n//\n// Dropdown menu container and contents.\n\n// scss-docs-start dropdown-variables\n$dropdown-min-width:                10rem !default;\n$dropdown-padding-x:                0 !default;\n$dropdown-padding-y:                .5rem !default;\n$dropdown-spacer:                   .125rem !default;\n$dropdown-font-size:                $font-size-base !default;\n$dropdown-color:                    var(--#{$prefix}body-color) !default;\n$dropdown-bg:                       var(--#{$prefix}body-bg) !default;\n$dropdown-border-color:             var(--#{$prefix}border-color-translucent) !default;\n$dropdown-border-radius:            var(--#{$prefix}border-radius) !default;\n$dropdown-border-width:             var(--#{$prefix}border-width) !default;\n$dropdown-inner-border-radius:      calc(var(--#{$prefix}dropdown-border-radius) - var(--#{$prefix}dropdown-border-width)) !default; // stylelint-disable-line function-disallowed-list\n$dropdown-divider-bg:               $dropdown-border-color !default;\n$dropdown-divider-margin-y:         $spacer * .5 !default;\n$dropdown-box-shadow:               var(--#{$prefix}box-shadow) !default;\n\n$dropdown-link-color:               var(--#{$prefix}body-color) !default;\n$dropdown-link-hover-color:         $dropdown-link-color !default;\n$dropdown-link-hover-bg:            var(--#{$prefix}tertiary-bg) !default;\n\n$dropdown-link-active-color:        $component-active-color !default;\n$dropdown-link-active-bg:           $component-active-bg !default;\n\n$dropdown-link-disabled-color:      var(--#{$prefix}tertiary-color) !default;\n\n$dropdown-item-padding-y:           $spacer * .25 !default;\n$dropdown-item-padding-x:           $spacer !default;\n\n$dropdown-header-color:             $gray-600 !default;\n$dropdown-header-padding-x:         $dropdown-item-padding-x !default;\n$dropdown-header-padding-y:         $dropdown-padding-y !default;\n// fusv-disable\n$dropdown-header-padding:           $dropdown-header-padding-y $dropdown-header-padding-x !default; // Deprecated in v4.2.6\n// fusv-enable\n// scss-docs-end dropdown-variables\n\n// scss-docs-start dropdown-dark-variables\n$dropdown-dark-color:               $gray-300 !default;\n$dropdown-dark-bg:                  $gray-800 !default;\n$dropdown-dark-border-color:        $dropdown-border-color !default;\n$dropdown-dark-divider-bg:          $dropdown-divider-bg !default;\n$dropdown-dark-box-shadow:          null !default;\n$dropdown-dark-link-color:          $dropdown-dark-color !default;\n$dropdown-dark-link-hover-color:    $white !default;\n$dropdown-dark-link-hover-bg:       rgba($white, .15) !default;\n$dropdown-dark-link-active-color:   $dropdown-link-active-color !default;\n$dropdown-dark-link-active-bg:      $dropdown-link-active-bg !default;\n$dropdown-dark-link-disabled-color: $gray-500 !default;\n$dropdown-dark-header-color:        $gray-500 !default;\n// scss-docs-end dropdown-dark-variables\n\n\n// Pagination\n\n// scss-docs-start pagination-variables\n$pagination-padding-y:              .375rem !default;\n$pagination-padding-x:              .75rem !default;\n$pagination-padding-y-sm:           .25rem !default;\n$pagination-padding-x-sm:           .5rem !default;\n$pagination-padding-y-lg:           .75rem !default;\n$pagination-padding-x-lg:           1.5rem !default;\n\n$pagination-font-size:              $font-size-base !default;\n\n$pagination-color:                  var(--#{$prefix}link-color) !default;\n$pagination-bg:                     var(--#{$prefix}body-bg) !default;\n$pagination-border-radius:          var(--#{$prefix}border-radius) !default;\n$pagination-border-width:           var(--#{$prefix}border-width) !default;\n$pagination-margin-start:           calc(-1 * #{$pagination-border-width}) !default; // stylelint-disable-line function-disallowed-list\n$pagination-border-color:           var(--#{$prefix}border-color) !default;\n\n$pagination-focus-color:            var(--#{$prefix}link-hover-color) !default;\n$pagination-focus-bg:               var(--#{$prefix}secondary-bg) !default;\n$pagination-focus-box-shadow:       $focus-ring-box-shadow !default;\n$pagination-focus-outline:          0 !default;\n\n$pagination-hover-color:            var(--#{$prefix}link-hover-color) !default;\n$pagination-hover-bg:               var(--#{$prefix}tertiary-bg) !default;\n$pagination-hover-border-color:     var(--#{$prefix}border-color) !default; // Todo in v6: remove this?\n\n$pagination-active-color:           $component-active-color !default;\n$pagination-active-bg:              $component-active-bg !default;\n$pagination-active-border-color:    $component-active-bg !default;\n\n$pagination-disabled-color:         var(--#{$prefix}secondary-color) !default;\n$pagination-disabled-bg:            var(--#{$prefix}secondary-bg) !default;\n$pagination-disabled-border-color:  var(--#{$prefix}border-color) !default;\n\n$pagination-transition:              color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n\n$pagination-border-radius-sm:       var(--#{$prefix}border-radius-sm) !default;\n$pagination-border-radius-lg:       var(--#{$prefix}border-radius-lg) !default;\n// scss-docs-end pagination-variables\n\n\n// Placeholders\n\n// scss-docs-start placeholders\n$placeholder-opacity-max:           .5 !default;\n$placeholder-opacity-min:           .2 !default;\n// scss-docs-end placeholders\n\n// Cards\n\n// scss-docs-start card-variables\n$card-spacer-y:                     $spacer !default;\n$card-spacer-x:                     $spacer !default;\n$card-title-spacer-y:               $spacer * .5 !default;\n$card-title-color:                  null !default;\n$card-subtitle-color:               null !default;\n$card-border-width:                 var(--#{$prefix}border-width) !default;\n$card-border-color:                 var(--#{$prefix}border-color-translucent) !default;\n$card-border-radius:                var(--#{$prefix}border-radius) !default;\n$card-box-shadow:                   null !default;\n$card-inner-border-radius:          calc(var(--#{$prefix}card-border-radius) - var(--#{$prefix}card-border-width)) !default; // stylelint-disable-line function-disallowed-list\n$card-cap-padding-y:                $card-spacer-y * .5 !default;\n$card-cap-padding-x:                $card-spacer-x !default;\n$card-cap-bg:                       rgba(var(--#{$prefix}body-color-rgb), .03) !default;\n$card-cap-color:                    null !default;\n$card-height:                       null !default;\n$card-color:                        null !default;\n$card-bg:                           var(--#{$prefix}body-bg) !default;\n$card-img-overlay-padding:          $spacer !default;\n$card-group-margin:                 $grid-gutter-width * .5 !default;\n// scss-docs-end card-variables\n\n// Accordion\n\n// scss-docs-start accordion-variables\n$accordion-padding-y:                     1rem !default;\n$accordion-padding-x:                     1.25rem !default;\n$accordion-color:                         var(--#{$prefix}body-color) !default;\n$accordion-bg:                            var(--#{$prefix}body-bg) !default;\n$accordion-border-width:                  var(--#{$prefix}border-width) !default;\n$accordion-border-color:                  var(--#{$prefix}border-color) !default;\n$accordion-border-radius:                 var(--#{$prefix}border-radius) !default;\n$accordion-inner-border-radius:           calc(var(--#{$prefix}accordion-border-radius) - var(--#{$prefix}accordion-border-width)) !default; // stylelint-disable-line function-disallowed-list\n\n$accordion-body-padding-y:                $accordion-padding-y !default;\n$accordion-body-padding-x:                $accordion-padding-x !default;\n\n$accordion-button-padding-y:              $accordion-padding-y !default;\n$accordion-button-padding-x:              $accordion-padding-x !default;\n$accordion-button-color:                  var(--#{$prefix}body-color) !default;\n$accordion-button-bg:                     var(--#{$prefix}accordion-bg) !default;\n$accordion-transition:                    $btn-transition, border-radius .15s ease !default;\n$accordion-button-active-bg:              var(--#{$prefix}primary-bg-subtle) !default;\n$accordion-button-active-color:           var(--#{$prefix}primary-text-emphasis) !default;\n\n// fusv-disable\n$accordion-button-focus-border-color:     $input-focus-border-color !default; // Deprecated in v5.0.0\n// fusv-enable\n$accordion-button-focus-box-shadow:       $btn-focus-box-shadow !default;\n\n$accordion-icon-width:                    1.25rem !default;\n$accordion-icon-color:                    $body-color !default;\n$accordion-icon-active-color:             $primary-text-emphasis !default;\n$accordion-icon-transition:               transform .2s ease-in-out !default;\n$accordion-icon-transform:                rotate(-180deg) !default;\n\n$accordion-button-icon:         url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='none' stroke='#{$accordion-icon-color}' stroke-linecap='round' stroke-linejoin='round'><path d='m2 5 6 6 6-6'/></svg>\") !default;\n$accordion-button-active-icon:  url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='none' stroke='#{$accordion-icon-active-color}' stroke-linecap='round' stroke-linejoin='round'><path d='m2 5 6 6 6-6'/></svg>\") !default;\n// scss-docs-end accordion-variables\n\n// Tooltips\n\n// scss-docs-start tooltip-variables\n$tooltip-font-size:                 $font-size-sm !default;\n$tooltip-max-width:                 200px !default;\n$tooltip-color:                     var(--#{$prefix}body-bg) !default;\n$tooltip-bg:                        var(--#{$prefix}emphasis-color) !default;\n$tooltip-border-radius:             var(--#{$prefix}border-radius) !default;\n$tooltip-opacity:                   .9 !default;\n$tooltip-padding-y:                 $spacer * .25 !default;\n$tooltip-padding-x:                 $spacer * .5 !default;\n$tooltip-margin:                    null !default; // TODO: remove this in v6\n\n$tooltip-arrow-width:               .8rem !default;\n$tooltip-arrow-height:              .4rem !default;\n// fusv-disable\n$tooltip-arrow-color:               null !default; // Deprecated in 4.2.0 for CSS variables\n// fusv-enable\n// scss-docs-end tooltip-variables\n\n// Form tooltips must come after regular tooltips\n// scss-docs-start tooltip-feedback-variables\n$form-feedback-tooltip-padding-y:     $tooltip-padding-y !default;\n$form-feedback-tooltip-padding-x:     $tooltip-padding-x !default;\n$form-feedback-tooltip-font-size:     $tooltip-font-size !default;\n$form-feedback-tooltip-line-height:   null !default;\n$form-feedback-tooltip-opacity:       $tooltip-opacity !default;\n$form-feedback-tooltip-border-radius: $tooltip-border-radius !default;\n// scss-docs-end tooltip-feedback-variables\n\n\n// Popovers\n\n// scss-docs-start popover-variables\n$popover-font-size:                 $font-size-sm !default;\n$popover-bg:                        var(--#{$prefix}body-bg) !default;\n$popover-max-width:                 276px !default;\n$popover-border-width:              var(--#{$prefix}border-width) !default;\n$popover-border-color:              var(--#{$prefix}border-color-translucent) !default;\n$popover-border-radius:             var(--#{$prefix}border-radius-lg) !default;\n$popover-inner-border-radius:       calc(var(--#{$prefix}popover-border-radius) - var(--#{$prefix}popover-border-width)) !default; // stylelint-disable-line function-disallowed-list\n$popover-box-shadow:                var(--#{$prefix}box-shadow) !default;\n\n$popover-header-font-size:          $font-size-base !default;\n$popover-header-bg:                 var(--#{$prefix}secondary-bg) !default;\n$popover-header-color:              $headings-color !default;\n$popover-header-padding-y:          .5rem !default;\n$popover-header-padding-x:          $spacer !default;\n\n$popover-body-color:                var(--#{$prefix}body-color) !default;\n$popover-body-padding-y:            $spacer !default;\n$popover-body-padding-x:            $spacer !default;\n\n$popover-arrow-width:               1rem !default;\n$popover-arrow-height:              .5rem !default;\n// scss-docs-end popover-variables\n\n// fusv-disable\n// Deprecated in 4.2.0 for CSS variables\n$popover-arrow-color:               $popover-bg !default;\n$popover-arrow-outer-color:         var(--#{$prefix}border-color-translucent) !default;\n// fusv-enable\n\n\n// Toasts\n\n// scss-docs-start toast-variables\n$toast-max-width:                   350px !default;\n$toast-padding-x:                   .75rem !default;\n$toast-padding-y:                   .5rem !default;\n$toast-font-size:                   .875rem !default;\n$toast-color:                       null !default;\n$toast-background-color:            rgba(var(--#{$prefix}body-bg-rgb), .85) !default;\n$toast-border-width:                var(--#{$prefix}border-width) !default;\n$toast-border-color:                var(--#{$prefix}border-color-translucent) !default;\n$toast-border-radius:               var(--#{$prefix}border-radius) !default;\n$toast-box-shadow:                  var(--#{$prefix}box-shadow) !default;\n$toast-spacing:                     $container-padding-x !default;\n\n$toast-header-color:                var(--#{$prefix}secondary-color) !default;\n$toast-header-background-color:     rgba(var(--#{$prefix}body-bg-rgb), .85) !default;\n$toast-header-border-color:         $toast-border-color !default;\n// scss-docs-end toast-variables\n\n\n// Badges\n\n// scss-docs-start badge-variables\n$badge-font-size:                   .75em !default;\n$badge-font-weight:                 $font-weight-bold !default;\n$badge-color:                       $white !default;\n$badge-padding-y:                   .35em !default;\n$badge-padding-x:                   .65em !default;\n$badge-border-radius:               var(--#{$prefix}border-radius) !default;\n\n$badge-font-size-sm:                .65em !default;\n$badge-padding-y-sm:                .3em !default;\n$badge-padding-x-sm:                .5em !default;\n// scss-docs-end badge-variables\n\n\n// Modals\n\n// scss-docs-start modal-variables\n$modal-inner-padding:               $spacer !default;\n\n$modal-footer-margin-between:       .5rem !default;\n\n$modal-dialog-margin:               .5rem !default;\n$modal-dialog-margin-y-sm-up:       1.75rem !default;\n\n$modal-title-line-height:           $line-height-base !default;\n\n$modal-content-color:               var(--#{$prefix}body-color) !default;\n$modal-content-bg:                  var(--#{$prefix}body-bg) !default;\n$modal-content-border-color:        var(--#{$prefix}border-color-translucent) !default;\n$modal-content-border-width:        var(--#{$prefix}border-width) !default;\n$modal-content-border-radius:       var(--#{$prefix}border-radius-lg) !default;\n$modal-content-inner-border-radius: calc(var(--#{$prefix}modal-border-radius) - var(--#{$prefix}modal-border-width)) !default; // stylelint-disable-line function-disallowed-list\n$modal-content-box-shadow-xs:       var(--#{$prefix}box-shadow-sm) !default;\n$modal-content-box-shadow-sm-up:    var(--#{$prefix}box-shadow) !default;\n\n$modal-backdrop-bg:                 $black !default;\n$modal-backdrop-opacity:            .5 !default;\n\n$modal-header-border-color:         var(--#{$prefix}border-color) !default;\n$modal-header-border-width:         $modal-content-border-width !default;\n$modal-header-padding-y:            $modal-inner-padding !default;\n$modal-header-padding-x:            $modal-inner-padding !default;\n$modal-header-padding:              $modal-header-padding-y $modal-header-padding-x !default; // Keep this for backwards compatibility\n\n$modal-footer-bg:                   null !default;\n$modal-footer-border-color:         $modal-header-border-color !default;\n$modal-footer-border-width:         $modal-header-border-width !default;\n\n$modal-sm:                          300px !default;\n$modal-md:                          500px !default;\n$modal-lg:                          800px !default;\n$modal-xl:                          1140px !default;\n\n$modal-fade-transform:              translate(0, -50px) !default;\n$modal-show-transform:              none !default;\n$modal-transition:                  transform .3s ease-out !default;\n$modal-scale-transform:             scale(1.02) !default;\n// scss-docs-end modal-variables\n\n\n// Avatars\n// scss-docs-start avatar-variables\n$avatar-width:                 2rem !default;\n$avatar-height:                2rem !default;\n$avatar-font-size:             .8rem !default;\n$avatar-border-radius:         50em !default;\n$avatar-status-width:          .5rem !default;\n$avatar-status-height:         .5rem !default;\n$avatar-status-border-radius:  50em !default;\n$avatar-transition:            margin .15s !default;\n\n$avatar-sizes: (\n  sm: (\n    width: 1.5rem,\n    height: 1.5rem,\n    font-size: .6rem,\n    status-width: .4rem,\n    status-height: .4rem\n  ),\n  md: (\n    width: 2.5rem,\n    height: 2.5rem,\n    font-size: 1rem,\n    status-width: .7rem,\n    status-height: .7rem\n  ),\n  lg: (\n    width: 3rem,\n    height: 3rem,\n    font-size: 1.2rem,\n    status-width: .8rem,\n    status-height: .8rem\n  ),\n  xl: (\n    width: 4rem,\n    height: 4rem,\n    font-size: 1.6rem,\n    status-width: 1rem,\n    status-height: 1rem\n  ),\n) !default;\n// scss-docs-end avatar-variables\n\n// fusv-disable\n// Deprecated in 5.1.0 for CSS variables\n$avatar-widths: (\n  sm: 1.5rem,\n  md: 2.5rem,\n  lg: 3rem,\n  xl: 4rem\n) !default;\n// fusv-enable\n\n// Alerts\n//\n// Define alert colors, border radius, and padding.\n\n// scss-docs-start alert-variables\n$alert-padding-y:               $spacer !default;\n$alert-padding-x:               $spacer !default;\n$alert-margin-bottom:           1rem !default;\n$alert-border-radius:           var(--#{$prefix}border-radius) !default;\n$alert-link-font-weight:        $font-weight-bold !default;\n$alert-border-width:            var(--#{$prefix}border-width) !default;\n$alert-dismissible-padding-r:   $alert-padding-x * 3 !default; // 3x covers width of x plus default padding on either side\n// scss-docs-end alert-variables\n\n// fusv-disable\n$alert-bg-scale:                -80% !default; // Deprecated in v4.2.0, to be removed in v6\n$alert-border-scale:            -70% !default; // Deprecated in v4.2.0, to be removed in v6\n$alert-color-scale:             40% !default; // Deprecated in v4.2.0, to be removed in v6\n// fusv-enable\n\n// Callouts\n// scss-docs-start callout-variables\n$callout-padding-y:                 $spacer !default;\n$callout-padding-x:                 $spacer !default;\n$callout-margin-y:                  $spacer !default;\n$callout-margin-x:                  0 !default;\n$callout-border-radius:             var(--#{$prefix}border-radius) !default;\n$callout-border-width:              var(--#{$prefix}border-width) !default;\n$callout-border-color:              var(--#{$prefix}border-color) !default;\n$callout-border-left-width:         calc(#{$callout-border-width} * 4) !default; // stylelint-disable-line function-disallowed-list\n\n$callout-variants: (\n  \"primary\":    $primary,\n  \"secondary\":  $secondary,\n  \"success\":    $success,\n  \"danger\":     $danger,\n  \"warning\":    $warning,\n  \"info\":       $info,\n  \"light\":      $light,\n  \"dark\":       $dark\n) !default;\n// scss-docs-end callout-variables\n\n\n// Progress bars\n\n// scss-docs-start progress-variables\n$progress-height:                   1rem !default;\n$progress-font-size:                $font-size-base * .75 !default;\n$progress-bg:                       var(--#{$prefix}secondary-bg) !default;\n$progress-border-radius:            var(--#{$prefix}border-radius) !default;\n$progress-box-shadow:               var(--#{$prefix}box-shadow-inset) !default;\n$progress-bar-color:                $white !default;\n$progress-bar-bg:                   var(--#{$prefix}primary) !default;\n$progress-bar-animation-timing:     1s linear infinite !default;\n$progress-bar-transition:           width .6s ease !default;\n\n// TODO: clean-up ???\n$progress-group-margin-bottom:         $spacer !default;\n$progress-group-header-margin-bottom:  $spacer * .25 !default;\n// scss-docs-end progress-variables\n\n// List group\n// scss-docs-start list-group-variables\n$list-group-color:                  var(--#{$prefix}body-color) !default;\n$list-group-bg:                     var(--#{$prefix}body-bg) !default;\n$list-group-border-color:           var(--#{$prefix}border-color) !default;\n$list-group-border-width:           var(--#{$prefix}border-width) !default;\n$list-group-border-radius:          var(--#{$prefix}border-radius) !default;\n\n$list-group-item-padding-y:         $spacer * .5 !default;\n$list-group-item-padding-x:         $spacer !default;\n// fusv-disable\n$list-group-item-bg-scale:          -80% !default; // Deprecated in v5.0.0\n$list-group-item-color-scale:       40% !default; // Deprecated in v5.0.0\n// fusv-enable\n\n$list-group-hover-bg:               var(--#{$prefix}tertiary-bg) !default;\n$list-group-active-color:           $component-active-color !default;\n$list-group-active-bg:              $component-active-bg !default;\n$list-group-active-border-color:    $list-group-active-bg !default;\n\n$list-group-disabled-color:         var(--#{$prefix}secondary-color) !default;\n$list-group-disabled-bg:            $list-group-bg !default;\n\n$list-group-action-color:           var(--#{$prefix}secondary-color) !default;\n$list-group-action-hover-color:     var(--#{$prefix}emphasis-color) !default;\n\n$list-group-action-active-color:    var(--#{$prefix}body-color) !default;\n$list-group-action-active-bg:       var(--#{$prefix}secondary-bg) !default;\n// scss-docs-end list-group-variables\n\n\n// Header\n// scss-docs-start header-variables\n$header-padding-y:              $spacer * .5 !default;\n$header-padding-x:              $spacer * .5 !default;\n$header-brand-font-size:        $font-size-lg !default;\n$header-color:                  rgba(var(--#{$prefix}emphasis-color-rgb), .65) !default;\n$header-bg:                     var(--#{$prefix}body-bg) !default;\n$header-border-color:           var(--#{$prefix}border-color) !default;\n$header-border-width:           var(--#{$prefix}border-width) !default;\n$header-hover-color:            rgba(var(--#{$prefix}emphasis-color-rgb), .8) !default;\n$header-active-color:           rgba(var(--#{$prefix}emphasis-color-rgb), 1) !default;\n$header-disabled-color:         rgba(var(--#{$prefix}emphasis-color-rgb), .3) !default;\n$header-transition:             box-shadow .15s ease-in-out !default;\n\n// Compute the header-brand padding-y so the header-brand will have the same height as header-text and nav-link\n$nav-link-height:               $font-size-base * $line-height-base + $nav-link-padding-y * 2 !default;\n$header-brand-height:           $header-brand-font-size * $line-height-base !default;\n$header-brand-padding-y:        ($nav-link-height - $header-brand-height) * .5 !default;\n$header-brand-margin-end:       1rem !default;\n$header-brand-font-size:        $font-size-lg !default;\n$header-brand-color:            $gray-900 !default;\n$header-brand-hover-color:      shade-color($gray-900, 10%) !default;\n\n$header-toggler-padding-y:      .25rem !default;\n$header-toggler-padding-x:      .75rem !default;\n$header-toggler-font-size:      $font-size-lg !default;\n$header-toggler-color:          rgba(var(--#{$prefix}emphasis-color-rgb), .65) !default;\n$header-toggler-bg:             transparent !default;\n$header-toggler-border-radius:  $btn-border-radius !default;\n$header-toggler-hover-color:    rgba(var(--#{$prefix}emphasis-color-rgb), 1) !default;\n\n$header-toggler-icon-bg:        url(\"data:image/svg+xml;charset=utf8,%3Csvg viewBox='0 0 30 30' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath stroke='#{$header-color}' stroke-width='2.25' stroke-linecap='round' stroke-miterlimit='10' d='M4 7h22M4 15h22M4 23h22'/%3E%3C/svg%3E\") !default;\n$header-toggler-hover-icon-bg:  url(\"data:image/svg+xml;charset=utf8,%3Csvg viewBox='0 0 30 30' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath stroke='#{$header-hover-color}' stroke-width='2.25' stroke-linecap='round' stroke-miterlimit='10' d='M4 7h22M4 15h22M4 23h22'/%3E%3C/svg%3E\") !default;\n\n$header-nav-link-padding-x:     .5rem !default;\n$header-nav-link-padding-y:     .5rem !default;\n\n$header-divider-border-width:   var(--#{$prefix}border-width) !default;\n$header-divider-border-color:   var(--#{$prefix}border-color) !default;\n// scss-docs-end header-variables\n\n\n// Image thumbnails\n\n// scss-docs-start thumbnail-variables\n$thumbnail-padding:                 .25rem !default;\n$thumbnail-bg:                      var(--#{$prefix}body-bg) !default;\n$thumbnail-border-width:            var(--#{$prefix}border-width) !default;\n$thumbnail-border-color:            var(--#{$prefix}border-color) !default;\n$thumbnail-border-radius:           var(--#{$prefix}border-radius) !default;\n$thumbnail-box-shadow:              var(--#{$prefix}box-shadow-sm) !default;\n// scss-docs-end thumbnail-variables\n\n\n// Figures\n\n// scss-docs-start figure-variables\n$figure-caption-font-size:          $small-font-size !default;\n$figure-caption-color:              var(--#{$prefix}secondary-color) !default;\n// scss-docs-end figure-variables\n\n\n// Breadcrumbs\n\n// scss-docs-start breadcrumb-variables\n$breadcrumb-font-size:              null !default;\n$breadcrumb-padding-y:              0 !default;\n$breadcrumb-padding-x:              0 !default;\n$breadcrumb-item-padding-x:         .5rem !default;\n$breadcrumb-margin-bottom:          1rem !default;\n$breadcrumb-bg:                     null !default;\n$breadcrumb-divider-color:          var(--#{$prefix}secondary-color) !default;\n$breadcrumb-active-color:           var(--#{$prefix}secondary-color) !default;\n$breadcrumb-divider:                string.quote(\"/\") !default;\n$breadcrumb-divider-flipped:        $breadcrumb-divider !default;\n$breadcrumb-border-radius:          null !default;\n// scss-docs-end breadcrumb-variables\n\n// Carousel\n\n// scss-docs-start carousel-variables\n$carousel-control-color:             $white !default;\n$carousel-control-width:             15% !default;\n$carousel-control-opacity:           .5 !default;\n$carousel-control-hover-opacity:     .9 !default;\n$carousel-control-transition:        opacity .15s ease !default;\n$carousel-control-icon-filter:       null !default;\n\n$carousel-indicator-width:           30px !default;\n$carousel-indicator-height:          3px !default;\n$carousel-indicator-hit-area-height: 10px !default;\n$carousel-indicator-spacer:          3px !default;\n$carousel-indicator-opacity:         .5 !default;\n$carousel-indicator-active-bg:       $white !default;\n$carousel-indicator-active-opacity:  1 !default;\n$carousel-indicator-transition:      opacity .6s ease !default;\n\n$carousel-caption-width:             70% !default;\n$carousel-caption-color:             $white !default;\n$carousel-caption-padding-y:         1.25rem !default;\n$carousel-caption-spacer:            1.25rem !default;\n\n$carousel-control-icon-width:        2rem !default;\n\n$carousel-control-prev-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$carousel-control-color}'><path d='M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0'/></svg>\") !default;\n$carousel-control-next-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$carousel-control-color}'><path d='M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708'/></svg>\") !default;\n\n$carousel-transition-duration:       .6s !default;\n$carousel-transition:                transform $carousel-transition-duration ease-in-out !default; // Define transform transition first if using multiple transitions (e.g., `transform 2s ease, opacity .5s ease-out`)\n// scss-docs-end carousel-variables\n\n// scss-docs-start carousel-dark-variables\n$carousel-dark-indicator-active-bg:  $black !default; // Deprecated in v5.3.2\n$carousel-dark-caption-color:        $black !default; // Deprecated in v5.3.2\n$carousel-dark-control-icon-filter:  invert(1) grayscale(100) !default; // Deprecated in v5.3.2\n// scss-docs-end carousel-dark-variables\n\n// scss-docs-start sidebar-variables\n$sidebar-width:                            16rem !default;\n$sidebar-widths: (\n  sm: 12rem,\n  lg: 20rem,\n  xl: 24rem\n) !default;\n$sidebar-padding-y:                        $spacer !default;\n$sidebar-padding-x:                        $spacer !default;\n$sidebar-color:                            var(--#{$prefix}body-color) !default;\n$sidebar-bg:                               var(--#{$prefix}body-bg) !default;\n$sidebar-transition:                       margin-left .15s, margin-right .15s, box-shadow .075s, transform .15s, width .15s, z-index 0s ease .15s !default;\n$sidebar-brand-color:                      var(--#{$prefix}body-color) !default;\n$sidebar-brand-bg:                         rgba($black, .2) !default;\n$sidebar-backdrop-bg:                      $black !default;\n$sidebar-backdrop-opacity:                 .5 !default;\n$sidebar-overlaid-box-shadow:              var(--#{$prefix}box-shadow) !default;\n\n$sidebar-narrow-width:                     4rem !default;\n$sidebar-narrow-padding-x:                 .5rem !default;\n$sidebar-narrow-unfoldable-box-shadow:     var(--#{$prefix}box-shadow) !default;\n// scss-docs-end sidebar-variables\n\n// scss-docs-start sidebar-nav-variables\n$sidebar-nav-padding-y:                       $sidebar-padding-y * .5 !default;\n$sidebar-nav-padding-x:                       $sidebar-padding-x * .5 !default;\n$sidebar-nav-gap:                             1px !default;\n\n$sidebar-nav-title-padding-y:                 .75rem !default;\n$sidebar-nav-title-padding-x:                 1rem !default;\n$sidebar-nav-title-margin-top:                1rem !default;\n$sidebar-nav-title-color:                     var(--#{$prefix}tertiary-color) !default;\n$sidebar-nav-title-transition:                height .15s, margin .15s !default;\n\n$sidebar-nav-link-padding-y:                  .75rem !default;\n$sidebar-nav-link-padding-x:                  1rem !default;\n$sidebar-nav-link-color:                      var(--#{$prefix}body-color) !default;\n$sidebar-nav-link-bg:                         transparent !default;\n$sidebar-nav-link-border-width:               0 !default;\n$sidebar-nav-link-border-color:               transparent !default;\n$sidebar-nav-link-border-radius:              var(--#{$prefix}border-radius) !default;\n$sidebar-nav-link-transition:                 background .15s ease, color .15s ease, gap .15s ease !default;\n\n$sidebar-compact-nav-link-padding-y:          .5625rem !default;\n\n$sidebar-narrow-nav-link-padding-y:           .75rem !default;\n$sidebar-narrow-nav-link-padding-x:           .5rem !default;\n\n$sidebar-nav-link-icon-margin:                .75rem !default;\n$sidebar-nav-link-icon-color:                 var(--#{$prefix}tertiary-color) !default;\n$sidebar-nav-link-icon-width:                 1.25rem !default;\n$sidebar-nav-link-icon-height:                1.25rem !default;\n$sidebar-nav-link-icon-font-size:             $sidebar-nav-link-icon-height !default;\n\n$sidebar-nav-link-icon-bullet-size:           .3125rem !default;\n$sidebar-nav-link-icon-bullet-bg:             transparent !default;\n$sidebar-nav-link-icon-bullet-border-width:   1px !default;\n$sidebar-nav-link-icon-bullet-border-color:   var(--#{$prefix}tertiary-color) !default;\n$sidebar-nav-link-icon-bullet-border-radius:  50rem !default;\n\n$sidebar-nav-link-hover-color:                        var(--#{$prefix}emphasis-color) !default;\n$sidebar-nav-link-hover-bg:                           var(--#{$prefix}tertiary-bg-translucent) !default;\n$sidebar-nav-link-hover-icon-color:                   var(--#{$prefix}body-color) !default;\n$sidebar-nav-link-hover-icon-bullet-bg:               transparent !default;\n$sidebar-nav-link-hover-icon-bullet-border-color:     var(--#{$prefix}body-color) !default;\n\n$sidebar-nav-link-active-color:                       var(--#{$prefix}emphasis-color) !default;\n$sidebar-nav-link-active-bg:                          var(--#{$prefix}tertiary-bg-translucent) !default;\n$sidebar-nav-link-active-icon-color:                  var(--#{$prefix}emphasis-color) !default;\n$sidebar-nav-link-active-icon-bullet-bg:              transparent !default;\n$sidebar-nav-link-active-icon-bullet-border-color:    var(--#{$prefix}emphasis-color) !default;\n\n$sidebar-nav-link-disabled-color:                     var(--#{$prefix}tertiary-color) !default;\n$sidebar-nav-link-disabled-icon-color:                var(--#{$prefix}tertiary-color) !default;\n$sidebar-nav-link-disabled-icon-bullet-bg:            transparent !default;\n$sidebar-nav-link-disabled-icon-bullet-border-color:  var(--#{$prefix}tertiary-color) !default;\n\n$sidebar-nav-group-bg:                        transparent !default;\n$sidebar-nav-group-border-width:              0 !default;\n$sidebar-nav-group-border-color:              transparent !default;\n$sidebar-nav-group-border-radius:             var(--#{$prefix}border-radius) !default;\n$sidebar-nav-group-transition:                background .15s ease-in-out !default;\n$sidebar-nav-group-toggle-show-color:         $sidebar-nav-link-color !default;\n\n$sidebar-nav-group-items-padding-y:           0 !default;\n$sidebar-nav-group-items-padding-x:           0 !default;\n$sidebar-nav-group-items-transition:          height .15s ease !default;\n\n$sidebar-nav-group-indicator-color:           var(--#{$prefix}tertiary-color) !default;\n$sidebar-nav-group-indicator-icon:            url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'><path fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708'/></svg>\") !default;\n$sidebar-nav-group-indicator-hover-color:     $sidebar-nav-link-hover-color !default;\n$sidebar-nav-group-indicator-hover-icon:      $sidebar-nav-group-indicator-icon !default;\n$sidebar-nav-group-indicator-transition:      transform .15s !default;\n\n$sidebar-nav-tree-group-border-color:          var(--#{$prefix}border-color) !default;\n$sidebar-nav-tree-link-icon-bullet-bg:         var(--#{$prefix}border-color) !default;\n$sidebar-nav-tree-link-hover-icon-bullet-bg:   var(--#{$prefix}border-color) !default;\n$sidebar-nav-tree-link-active-icon-bullet-bg:  var(--#{$prefix}border-color) !default;\n// scss-docs-end sidebar-nav-variables\n\n// scss-docs-start sidebar-toggler\n$sidebar-toggler-width:             .5rem !default;\n$sidebar-toggler-height:            .5rem !default;\n$sidebar-toggler-padding-x:         .25rem !default;\n$sidebar-toggler-padding-y:         .25rem !default;\n$sidebar-toggler-bg:                transparent !default;\n$sidebar-toggler-color:             var(--#{$prefix}tertiary-color) !default;\n$sidebar-toggler-icon:              url(\"data:image/svg+xml,%0A%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512'%3E%3Cg xmlns='http://www.w3.org/2000/svg' transform='matrix(-1 0 0 -1 512 512)'%3E%3Cpath fill='%23000' d='M472,16H40A24.028,24.028,0,0,0,16,40V200H48V48H464V464H48V304H16V472a24.028,24.028,0,0,0,24,24H472a24.028,24.028,0,0,0,24-24V40A24.028,24.028,0,0,0,472,16Z'/%3E%3Cpolygon fill='%23000' points='209.377 363.306 232.004 385.933 366.627 251.31 232.004 116.687 209.377 139.313 305.374 235.311 16 235.311 16 267.311 305.372 267.311 209.377 363.306'/%3E%3C/g%3E%3C/svg%3E\") !default;\n$sidebar-toggler-focus-shadow:      $focus-ring-box-shadow !default;\n$sidebar-toggler-hover-color:       var(--#{$prefix}secondary-color) !default;\n$sidebar-toggler-focus-color:       var(--#{$prefix}secondary-color) !default;\n$sidebar-toggler-transition:        transform .15s !default;\n// scss-docs-end sidebar-toggler\n\n// Footer\n// scss-docs-start footer-variables\n$footer-min-height:    3rem !default;\n$footer-padding-y:     $spacer * .5 !default;\n$footer-padding-x:     $spacer !default;\n$footer-bg:            var(--#{$prefix}tertiary-bg) !default;\n$footer-color:         var(--#{$prefix}body-color) !default;\n$footer-border-width:  var(--#{$prefix}border-width) !default;\n$footer-border-color:  var(--#{$prefix}border-color) !default;\n// scss-docs-end footer-variables\n\n// Spinners\n\n// scss-docs-start spinner-variables\n$spinner-width:           2rem !default;\n$spinner-height:          $spinner-width !default;\n$spinner-vertical-align:  -.125em !default;\n$spinner-border-width:    .25em !default;\n$spinner-animation-speed: .75s !default;\n\n$spinner-width-sm:        1rem !default;\n$spinner-height-sm:       $spinner-width-sm !default;\n$spinner-border-width-sm: .2em !default;\n// scss-docs-end spinner-variables\n\n\n// Close\n\n// scss-docs-start close-variables\n$btn-close-width:            1em !default;\n$btn-close-height:           $btn-close-width !default;\n$btn-close-padding-x:        .25em !default;\n$btn-close-padding-y:        $btn-close-padding-x !default;\n$btn-close-color:            $black !default;\n$btn-close-bg:               url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$btn-close-color}'><path d='M.293.293a1 1 0 0 1 1.414 0L8 6.586 14.293.293a1 1 0 1 1 1.414 1.414L9.414 8l6.293 6.293a1 1 0 0 1-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 0 1-1.414-1.414L6.586 8 .293 1.707a1 1 0 0 1 0-1.414'/></svg>\") !default;\n$btn-close-focus-shadow:     $focus-ring-box-shadow !default;\n$btn-close-opacity:          .5 !default;\n$btn-close-hover-opacity:    .75 !default;\n$btn-close-focus-opacity:    1 !default;\n$btn-close-disabled-opacity: .25 !default;\n$btn-close-filter:           null !default;\n$btn-close-white-filter:     invert(1) grayscale(100%) brightness(200%) !default; // Deprecated in v5.3.2\n// scss-docs-end close-variables\n\n\n// Offcanvas\n\n// scss-docs-start offcanvas-variables\n$offcanvas-padding-y:               $modal-inner-padding !default;\n$offcanvas-padding-x:               $modal-inner-padding !default;\n$offcanvas-horizontal-width:        400px !default;\n$offcanvas-vertical-height:         30vh !default;\n$offcanvas-transition-duration:     .3s !default;\n$offcanvas-border-color:            $modal-content-border-color !default;\n$offcanvas-border-width:            $modal-content-border-width !default;\n$offcanvas-title-line-height:       $modal-title-line-height !default;\n$offcanvas-bg-color:                var(--#{$prefix}body-bg) !default;\n$offcanvas-color:                   var(--#{$prefix}body-color) !default;\n$offcanvas-box-shadow:              $modal-content-box-shadow-xs !default;\n$offcanvas-backdrop-bg:             $modal-backdrop-bg !default;\n$offcanvas-backdrop-opacity:        $modal-backdrop-opacity !default;\n// scss-docs-end offcanvas-variables\n\n// Code\n\n$code-font-size:                    $small-font-size !default;\n$code-color:                        $pink !default;\n\n$kbd-padding-y:                     .1875rem !default;\n$kbd-padding-x:                     .375rem !default;\n$kbd-font-size:                     $code-font-size !default;\n$kbd-color:                         var(--#{$prefix}body-bg) !default;\n$kbd-bg:                            var(--#{$prefix}body-color) !default;\n$nested-kbd-font-weight:            null !default; // Deprecated in v4.2.6, removing in v6\n\n$pre-color:                         null !default;\n","// stylelint-disable property-disallowed-list\n@use \"sass:list\";\n@use \"sass:meta\";\n@use \"../variables\" as *;\n\n// Single side border-radius\n\n// Helper function to replace negative values with 0\n@function valid-radius($radius) {\n  $return: ();\n  @each $value in $radius {\n    @if meta.type-of($value) == number {\n      $return: list.append($return, max($value, 0));\n    } @else {\n      $return: list.append($return, $value);\n    }\n  }\n  @return $return;\n}\n\n// scss-docs-start border-radius-mixins\n@mixin border-radius($radius: $border-radius, $fallback-border-radius: false) {\n  @if $enable-rounded {\n    border-radius: valid-radius($radius);\n  }\n  @else if $fallback-border-radius != false {\n    border-radius: $fallback-border-radius;\n  }\n}\n\n@mixin border-top-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-left-radius: valid-radius($radius);\n    border-top-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-end-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-start-end-radius: valid-radius($radius);\n    border-end-end-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-bottom-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-bottom-right-radius: valid-radius($radius);\n    border-bottom-left-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-start-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-start-start-radius: valid-radius($radius);\n    border-end-start-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-top-start-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-start-start-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-top-end-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-start-end-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-bottom-end-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-end-end-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-bottom-start-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-end-start-radius: valid-radius($radius);\n  }\n}\n// scss-docs-end border-radius-mixins\n","@use \"mixins/lists\" as *;\n@use \"vendor/rfs\" as *;\n@use \"reboot\" as *;\n@use \"variables\" as *;\n\n//\n// Headings\n//\n.h1 {\n  @extend h1;\n}\n\n.h2 {\n  @extend h2;\n}\n\n.h3 {\n  @extend h3;\n}\n\n.h4 {\n  @extend h4;\n}\n\n.h5 {\n  @extend h5;\n}\n\n.h6 {\n  @extend h6;\n}\n\n\n.lead {\n  @include font-size($lead-font-size);\n  font-weight: $lead-font-weight;\n}\n\n// Type display classes\n@each $display, $font-size in $display-font-sizes {\n  .display-#{$display} {\n    font-family: $display-font-family;\n    font-style: $display-font-style;\n    font-weight: $display-font-weight;\n    line-height: $display-line-height;\n    @include font-size($font-size);\n  }\n}\n\n//\n// Emphasis\n//\n.small {\n  @extend small;\n}\n\n.mark {\n  @extend mark;\n}\n\n//\n// Lists\n//\n\n.list-unstyled {\n  @include list-unstyled();\n}\n\n// Inline turns list items into inline-block\n.list-inline {\n  @include list-unstyled();\n}\n.list-inline-item {\n  display: inline-block;\n\n  &:not(:last-child) {\n    margin-inline-end: $list-inline-padding;\n  }\n}\n\n\n//\n// Misc\n//\n\n// Builds on `abbr`\n.initialism {\n  @include font-size($initialism-font-size);\n  text-transform: uppercase;\n}\n\n// Blockquotes\n.blockquote {\n  margin-bottom: $blockquote-margin-y;\n  @include font-size($blockquote-font-size);\n\n  > :last-child {\n    margin-bottom: 0;\n  }\n}\n\n.blockquote-footer {\n  margin-top: -$blockquote-margin-y;\n  margin-bottom: $blockquote-margin-y;\n  @include font-size($blockquote-footer-font-size);\n  color: $blockquote-footer-color;\n\n  &::before {\n    content: \"\\2014\\00A0\"; // em dash, nbsp\n  }\n}\n","// Lists\n\n// Unstyled keeps list items block level, just removes default browser padding and list-style\n@mixin list-unstyled {\n  padding-inline-start: 0;\n  list-style: none;\n}\n","@use \"mixins/border-radius\" as *;\n@use \"mixins/box-shadow\" as *;\n@use \"mixins/image\" as *;\n@use \"vendor/rfs\" as *;\n@use \"variables\" as *;\n\n// Responsive images (ensure images don't scale beyond their parents)\n//\n// This is purposefully opt-in via an explicit class rather than being the default for all `<img>`s.\n// We previously tried the \"images are responsive by default\" approach in Bootstrap v2,\n// and abandoned it in Bootstrap v3 because it breaks lots of third-party widgets (including Google Maps)\n// which weren't expecting the images within themselves to be involuntarily resized.\n// See also https://github.com/twbs/bootstrap/issues/18178\n.img-fluid {\n  @include img-fluid();\n}\n\n\n// Image thumbnails\n.img-thumbnail {\n  padding: $thumbnail-padding;\n  background-color: var(--#{$prefix}thumbnail-bg, $thumbnail-bg);\n  border: $thumbnail-border-width solid var(--#{$prefix}thumbnail-border-color, $thumbnail-border-color);\n  @include border-radius($thumbnail-border-radius);\n  @include box-shadow($thumbnail-box-shadow);\n\n  // Keep them at most 100% wide\n  @include img-fluid();\n}\n\n//\n// Figures\n//\n\n.figure {\n  // Ensures the caption's text aligns with the image.\n  display: inline-block;\n}\n\n.figure-img {\n  margin-bottom: $spacer * .5;\n  line-height: 1;\n}\n\n.figure-caption {\n  @include font-size($figure-caption-font-size);\n  color: var(--#{$prefix}figure-caption-color, $figure-caption-color);\n}\n","// Image Mixins\n// - Responsive image\n// - Retina image\n\n\n// Responsive image\n//\n// Keep images from scaling beyond the width of their parents.\n\n@mixin img-fluid {\n  // Part 1: Set a maximum relative to the parent\n  max-width: 100%;\n  // Part 2: Override the height to auto, otherwise images will be stretched\n  // when setting a width and height attribute on the img element.\n  height: auto;\n}\n","@use \"mixins/breakpoints\" as *;\n@use \"mixins/container\" as *;\n@use \"variables\" as *;\n\n// Container widths\n//\n// Set the container width, and override it for fixed navbars in media queries.\n\n@if $enable-container-classes {\n  // Single container class with breakpoint max-widths\n  .container,\n  // 100% wide container at all breakpoints\n  .container-fluid {\n    @include make-container();\n  }\n\n  // Responsive containers that are 100% wide until a breakpoint\n  @each $breakpoint, $container-max-width in $container-max-widths {\n    .container-#{$breakpoint} {\n      @extend .container-fluid;\n    }\n\n    @include media-breakpoint-up($breakpoint, $grid-breakpoints) {\n      %responsive-container-#{$breakpoint} {\n        max-width: $container-max-width;\n      }\n\n      // Extend each breakpoint which is smaller or equal to the current breakpoint\n      $extend-breakpoint: true;\n\n      @each $name, $width in $grid-breakpoints {\n        @if ($extend-breakpoint) {\n          .container#{breakpoint-infix($name, $grid-breakpoints)} {\n            @extend %responsive-container-#{$breakpoint};\n          }\n\n          // Once the current breakpoint is reached, stop extending\n          @if ($breakpoint == $name) {\n            $extend-breakpoint: false;\n          }\n        }\n      }\n    }\n  }\n}\n","@use \"../variables\" as *;\n\n// Container mixins\n\n@mixin make-container($gutter: $container-padding-x) {\n  --#{$prefix}gutter-x: #{$gutter};\n  --#{$prefix}gutter-y: 0;\n  width: 100%;\n  padding-right: calc(var(--#{$prefix}gutter-x) * .5); // stylelint-disable-line function-disallowed-list\n  padding-left: calc(var(--#{$prefix}gutter-x) * .5); // stylelint-disable-line function-disallowed-list\n  margin-right: auto;\n  margin-left: auto;\n}\n","@use \"sass:list\";\n@use \"sass:map\";\n@use \"../variables\" as *;\n\n// Breakpoint viewport sizes and media queries.\n//\n// Breakpoints are defined as a map of (name: minimum width), order from small to large:\n//\n//    (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px)\n//\n// The map defined in the `$grid-breakpoints` global variable is used as the `$breakpoints` argument by default.\n\n// Name of the next breakpoint, or null for the last breakpoint.\n//\n//    >> breakpoint-next(sm)\n//    md\n//    >> breakpoint-next(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    md\n//    >> breakpoint-next(sm, $breakpoint-names: (xs sm md lg xl xxl))\n//    md\n@function breakpoint-next($name, $breakpoints: $grid-breakpoints, $breakpoint-names: map.keys($breakpoints)) {\n  $n: list.index($breakpoint-names, $name);\n  @if not $n {\n    @error \"breakpoint `#{$name}` not found in `#{$breakpoints}`\";\n  }\n  // Use @if/@else because list.nth would error if evaluated when $n equals list length\n  @if $n < list.length($breakpoint-names) {\n    @return list.nth($breakpoint-names, $n + 1);\n  } @else {\n    @return null;\n  }\n}\n\n// Minimum breakpoint width. Null for the smallest (first) breakpoint.\n//\n//    >> breakpoint-min(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    576px\n@function breakpoint-min($name, $breakpoints: $grid-breakpoints) {\n  $min: map.get($breakpoints, $name);\n  @return if(sass($min != 0): $min; else: null);\n}\n\n// Maximum breakpoint width.\n// The maximum value is reduced by 0.02px to work around the limitations of\n// `min-` and `max-` prefixes and viewports with fractional widths.\n// See https://www.w3.org/TR/mediaqueries-4/#mq-min-max\n// Uses 0.02px rather than 0.01px to work around a current rounding bug in Safari.\n// See https://bugs.webkit.org/show_bug.cgi?id=178261\n//\n//    >> breakpoint-max(md, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    767.98px\n@function breakpoint-max($name, $breakpoints: $grid-breakpoints) {\n  $max: map.get($breakpoints, $name);\n  @return if(sass($max and $max > 0): $max - .02; else: null);\n}\n\n// Returns a blank string if smallest breakpoint, otherwise returns the name with a dash in front.\n// Useful for making responsive utilities.\n//\n//    >> breakpoint-infix(xs, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    \"\"  (Returns a blank string)\n//    >> breakpoint-infix(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    \"-sm\"\n@function breakpoint-infix($name, $breakpoints: $grid-breakpoints) {\n  @return if(sass(breakpoint-min($name, $breakpoints) == null): \"\"; else: \"-#{$name}\");\n}\n\n// Media of at least the minimum breakpoint width. No query for the smallest breakpoint.\n// Makes the @content apply to the given breakpoint and wider.\n@mixin media-breakpoint-up($name, $breakpoints: $grid-breakpoints) {\n  $min: breakpoint-min($name, $breakpoints);\n  @if $min {\n    @media (min-width: $min) {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Media of at most the maximum breakpoint width. No query for the largest breakpoint.\n// Makes the @content apply to the given breakpoint and narrower.\n@mixin media-breakpoint-down($name, $breakpoints: $grid-breakpoints) {\n  $max: breakpoint-max($name, $breakpoints);\n  @if $max {\n    @media (max-width: $max) {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Media that spans multiple breakpoint widths.\n// Makes the @content apply between the min and max breakpoints\n@mixin media-breakpoint-between($lower, $upper, $breakpoints: $grid-breakpoints) {\n  $min: breakpoint-min($lower, $breakpoints);\n  $max: breakpoint-max($upper, $breakpoints);\n\n  @if $min != null and $max != null {\n    @media (min-width: $min) and (max-width: $max) {\n      @content;\n    }\n  } @else if $max == null {\n    @include media-breakpoint-up($lower, $breakpoints) {\n      @content;\n    }\n  } @else if $min == null {\n    @include media-breakpoint-down($upper, $breakpoints) {\n      @content;\n    }\n  }\n}\n\n// Media between the breakpoint's minimum and maximum widths.\n// No minimum for the smallest breakpoint, and no maximum for the largest one.\n// Makes the @content apply only to the given breakpoint, not viewports any wider or narrower.\n@mixin media-breakpoint-only($name, $breakpoints: $grid-breakpoints) {\n  $min:  breakpoint-min($name, $breakpoints);\n  $next: breakpoint-next($name, $breakpoints);\n  $max:  breakpoint-max($next, $breakpoints);\n\n  @if $min != null and $max != null {\n    @media (min-width: $min) and (max-width: $max) {\n      @content;\n    }\n  } @else if $max == null {\n    @include media-breakpoint-up($name, $breakpoints) {\n      @content;\n    }\n  } @else if $min == null {\n    @include media-breakpoint-down($next, $breakpoints) {\n      @content;\n    }\n  }\n}\n\n//\n// Container query mixins\n//\n\n// Container query for applying styles when the container’s inline size is at least the breakpoint’s minimum width.\n@mixin container-breakpoint-up($name, $breakpoints: $cq-grid-breakpoints) {\n  $min: breakpoint-min($name, $breakpoints);\n  @if $min {\n    @container (min-width: #{$min}) {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Container query for applying styles when the container’s inline size is at most the breakpoint’s maximum width.\n@mixin container-breakpoint-down($name, $breakpoints: $cq-grid-breakpoints) {\n  $max: breakpoint-max($name, $breakpoints);\n  @if $max {\n    @container (max-width: #{$max}) {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Container query for applying styles between two breakpoints.\n@mixin container-breakpoint-between($lower, $upper, $breakpoints: $cq-grid-breakpoints) {\n  $min: breakpoint-min($lower, $breakpoints);\n  $max: breakpoint-max($upper, $breakpoints);\n\n  @if $min != null and $max != null {\n    @container (min-width: #{$min}) and (max-width: #{$max}) {\n      @content;\n    }\n  } @else if $max == null {\n    // When the upper breakpoint is the last one.\n    @include container-breakpoint-up($lower, $breakpoints) {\n      @content;\n    }\n  } @else if $min == null {\n    // When the lower breakpoint is the smallest.\n    @include container-breakpoint-down($upper, $breakpoints) {\n      @content;\n    }\n  }\n}\n\n// Container query for applying styles only within a single breakpoint range.\n@mixin container-breakpoint-only($name, $breakpoints: $cq-grid-breakpoints) {\n  $min: breakpoint-min($name, $breakpoints);\n  $next: breakpoint-next($name, $breakpoints);\n  $max: breakpoint-max($next, $breakpoints);\n\n  @if $min != null and $max != null {\n    @container (min-width: #{$min}) and (max-width: #{$max}) {\n      @content;\n    }\n  } @else if $max == null {\n    // Last breakpoint – no maximum query.\n    @include container-breakpoint-up($name, $breakpoints) {\n      @content;\n    }\n  } @else if $min == null {\n    // First breakpoint – no minimum query.\n    @include container-breakpoint-down($next, $breakpoints) {\n      @content;\n    }\n  }\n}\n","@use \"mixins/grid\" as *;\n@use \"variables\" as *;\n\n$include-column-box-sizing: false !default;\n\n// Row\n//\n// Rows contain your columns.\n\n:root {\n  @each $name, $value in $grid-breakpoints {\n    --#{$prefix}breakpoint-#{$name}: #{$value};\n  }\n\n  --#{$prefix}mobile-breakpoint: #{$mobile-breakpoint};\n}\n\n@if $enable-grid-classes {\n  .row {\n    @include make-row();\n\n    > * {\n      @include make-col-ready($include-column-box-sizing);\n    }\n  }\n}\n\n@if $enable-cssgrid {\n  .grid {\n    display: grid;\n    grid-template-rows: repeat(var(--#{$prefix}rows, 1), 1fr);\n    grid-template-columns: repeat(var(--#{$prefix}columns, #{$grid-columns}), 1fr);\n    gap: var(--#{$prefix}gap, #{$grid-gutter-width});\n\n    @include make-cssgrid();\n  }\n}\n\n\n// Columns\n//\n// Common styles for small and large grid columns\n\n@if $enable-grid-classes {\n  @include make-grid-columns();\n}\n\n@if $enable-container-queries {\n  .cq-container {\n    container-type: inline-size;\n  }\n\n  .cq-row {\n    container-type: inline-size;\n    @include make-row();\n\n    > * {\n      @include make-col-ready($include-column-box-sizing);\n    }\n  }\n\n  @include make-c-grid-columns();\n}\n","@use \"sass:map\";\n@use \"sass:math\";\n@use \"sass:meta\";\n@use \"breakpoints\" as *;\n@use \"../functions/math\" as *;\n@use \"../maps\" as *;\n@use \"../variables\" as *;\n\n// Grid system\n//\n// Generate semantic grid columns with these mixins.\n\n@mixin make-row($gutter: $grid-gutter-width) {\n  --#{$prefix}gutter-x: #{$gutter};\n  --#{$prefix}gutter-y: 0;\n  display: flex;\n  flex-wrap: wrap;\n  // TODO: Revisit calc order after https://github.com/react-bootstrap/react-bootstrap/issues/6039 is fixed\n  margin-top: calc(-1 * var(--#{$prefix}gutter-y)); // stylelint-disable-line function-disallowed-list\n  margin-right: calc(-.5 * var(--#{$prefix}gutter-x)); // stylelint-disable-line function-disallowed-list\n  margin-left: calc(-.5 * var(--#{$prefix}gutter-x)); // stylelint-disable-line function-disallowed-list\n}\n\n@mixin make-col-ready($include-column-box-sizing: false) {\n  // Add box sizing if only the grid is loaded\n  // stylelint-disable-next-line scss/at-function-named-arguments\n  box-sizing: if(sass(meta.variable-exists(include-column-box-sizing) and $include-column-box-sizing): border-box);\n  // Prevent columns from becoming too narrow when at smaller grid tiers by\n  // always setting `width: 100%;`. This works because we set the width\n  // later on to override this initial width.\n  flex-shrink: 0;\n  width: 100%;\n  max-width: 100%; // Prevent `.col-auto`, `.col` (& responsive variants) from breaking out the grid\n  padding-right: calc(var(--#{$prefix}gutter-x) * .5); // stylelint-disable-line function-disallowed-list\n  padding-left: calc(var(--#{$prefix}gutter-x) * .5); // stylelint-disable-line function-disallowed-list\n  margin-top: var(--#{$prefix}gutter-y);\n}\n\n@mixin make-col($size: false, $columns: $grid-columns) {\n  @if $size {\n    flex: 0 0 auto;\n    width: math.percentage(divide($size, $columns));\n\n  } @else {\n    flex: 1 1 0;\n    max-width: 100%;\n  }\n}\n\n@mixin make-col-auto() {\n  flex: 0 0 auto;\n  width: auto;\n}\n\n@mixin make-col-offset($size, $columns: $grid-columns) {\n  $num: divide($size, $columns);\n  // stylelint-disable-next-line scss/at-function-named-arguments\n  margin-inline-start: if(sass($num == 0): 0; else: math.percentage($num));\n}\n\n// Row columns\n//\n// Specify on a parent element(e.g., .row) to force immediate children into NN\n// number of columns. Supports wrapping to new lines, but does not do a Masonry\n// style grid.\n@mixin row-cols($count) {\n  > * {\n    flex: 0 0 auto;\n    width: math.percentage(divide(1, $count));\n  }\n}\n\n// Framework grid generation\n//\n// Used only by Bootstrap to generate the correct number of grid classes given\n// any value of `$grid-columns`.\n\n@mixin make-grid-columns($columns: $grid-columns, $gutter: $grid-gutter-width, $breakpoints: $grid-breakpoints) {\n  @each $breakpoint in map.keys($breakpoints) {\n    $infix: breakpoint-infix($breakpoint, $breakpoints);\n\n    @include media-breakpoint-up($breakpoint, $breakpoints) {\n      // Provide basic `.col-{bp}` classes for equal-width flexbox columns\n      .col#{$infix} {\n        flex: 1 0 0;\n      }\n\n      .row-cols#{$infix}-auto > * {\n        @include make-col-auto();\n      }\n\n      @if $grid-row-columns > 0 {\n        @for $i from 1 through $grid-row-columns {\n          .row-cols#{$infix}-#{$i} {\n            @include row-cols($i);\n          }\n        }\n      }\n\n      .col#{$infix}-auto {\n        @include make-col-auto();\n      }\n\n      @if $columns > 0 {\n        @for $i from 1 through $columns {\n          .col#{$infix}-#{$i} {\n            @include make-col($i, $columns);\n          }\n        }\n\n        // `$columns - 1` because offsetting by the width of an entire row isn't possible\n        @for $i from 0 through ($columns - 1) {\n          @if not ($infix == \"\" and $i == 0) { // Avoid emitting useless .offset-0\n            .offset#{$infix}-#{$i} {\n              @include make-col-offset($i, $columns);\n            }\n          }\n        }\n      }\n\n      // Gutters\n      //\n      // Make use of `.g-*`, `.gx-*` or `.gy-*` utilities to change spacing between the columns.\n      @each $key, $value in $gutters {\n        .g#{$infix}-#{$key},\n        .gx#{$infix}-#{$key} {\n          --#{$prefix}gutter-x: #{$value};\n        }\n\n        .g#{$infix}-#{$key},\n        .gy#{$infix}-#{$key} {\n          --#{$prefix}gutter-y: #{$value};\n        }\n      }\n    }\n  }\n}\n\n@mixin make-cssgrid($columns: $grid-columns, $breakpoints: $grid-breakpoints) {\n  @each $breakpoint in map.keys($breakpoints) {\n    $infix: breakpoint-infix($breakpoint, $breakpoints);\n\n    @include media-breakpoint-up($breakpoint, $breakpoints) {\n      @if $columns > 0 {\n        @for $i from 1 through $columns {\n          .g-col#{$infix}-#{$i} {\n            grid-column: auto / span $i;\n          }\n        }\n\n        // Start with `1` because `0` is an invalid value.\n        // Ends with `$columns - 1` because offsetting by the width of an entire row isn't possible.\n        @for $i from 1 through ($columns - 1) {\n          .g-start#{$infix}-#{$i} {\n            grid-column-start: $i;\n          }\n        }\n      }\n    }\n  }\n}\n\n@mixin make-c-grid-columns($columns: $grid-columns, $gutter: $grid-gutter-width, $breakpoints: $grid-breakpoints) {\n  @each $breakpoint in map.keys($breakpoints) {\n    $infix: breakpoint-infix($breakpoint, $breakpoints);\n\n    @include container-breakpoint-up($breakpoint, $breakpoints) {\n      // Provide basic `.cq-col-{bp}` classes for equal-width flexbox columns\n      .cq-col#{$infix} {\n        flex: 1 0 0;\n      }\n\n      .cq-row-cols#{$infix}-auto > * {\n        @include make-col-auto();\n      }\n\n      @if $grid-row-columns > 0 {\n        @for $i from 1 through $grid-row-columns {\n          .cq-row-cols#{$infix}-#{$i} {\n            @include row-cols($i);\n          }\n        }\n      }\n\n      .cq-col#{$infix}-auto {\n        @include make-col-auto();\n      }\n\n      @if $columns > 0 {\n        @for $i from 1 through $columns {\n          .cq-col#{$infix}-#{$i} {\n            @include make-col($i, $columns);\n          }\n        }\n\n        // `$columns - 1` because offsetting by the width of an entire row isn't possible\n        @for $i from 0 through ($columns - 1) {\n          @if not ($infix == \"\" and $i == 0) { // Avoid emitting useless .offset-0\n            .cq-offset#{$infix}-#{$i} {\n              @include make-col-offset($i, $columns);\n            }\n          }\n        }\n      }\n\n      // Gutters\n      //\n      // Make use of `.cq-g-*`, `.cq-gx-*` or `.cq-gy-*` utilities to change spacing between the columns.\n      @each $key, $value in $gutters {\n        .cq-g#{$infix}-#{$key},\n        .cq-gx#{$infix}-#{$key} {\n          --#{$prefix}gutter-x: #{$value};\n        }\n\n        .cq-g#{$infix}-#{$key},\n        .cq-gy#{$infix}-#{$key} {\n          --#{$prefix}gutter-y: #{$value};\n        }\n      }\n    }\n  }\n}\n","@use \"sass:map\";\n@use \"mixins/breakpoints\" as *;\n@use \"mixins/table-variants\" as *;\n@use \"variables\" as *;\n\n//\n// Basic Bootstrap table\n//\n\n.table {\n  // Reset needed for nesting tables\n  --#{$prefix}table-color-type: initial;\n  --#{$prefix}table-bg-type: initial;\n  --#{$prefix}table-color-state: initial;\n  --#{$prefix}table-bg-state: initial;\n  // End of reset\n  --#{$prefix}table-color: #{$table-color};\n  --#{$prefix}table-bg: #{$table-bg};\n  --#{$prefix}table-border-color: #{$table-border-color};\n  --#{$prefix}table-accent-bg: #{$table-accent-bg};\n  --#{$prefix}table-striped-color: #{$table-striped-color};\n  --#{$prefix}table-striped-bg: #{$table-striped-bg};\n  --#{$prefix}table-active-color: #{$table-active-color};\n  --#{$prefix}table-active-bg: #{$table-active-bg};\n  --#{$prefix}table-hover-color: #{$table-hover-color};\n  --#{$prefix}table-hover-bg: #{$table-hover-bg};\n\n  width: 100%;\n  margin-bottom: $spacer;\n  vertical-align: $table-cell-vertical-align;\n  border-color: var(--#{$prefix}table-border-color);\n\n  // Target th & td\n  // We need the child combinator to prevent styles leaking to nested tables which doesn't have a `.table` class.\n  // We use the universal selectors here to simplify the selector (else we would need 6 different selectors).\n  // Another advantage is that this generates less code and makes the selector less specific making it easier to override.\n  // stylelint-disable-next-line selector-max-universal\n  > :not(caption) > * > * {\n    padding: $table-cell-padding-y $table-cell-padding-x;\n    // Following the precept of cascades: https://codepen.io/miriamsuzanne/full/vYNgodb\n    color: var(--#{$prefix}table-color-state, var(--#{$prefix}table-color-type, var(--#{$prefix}table-color)));\n    background-color: var(--#{$prefix}table-bg);\n    border-bottom-width: $table-border-width;\n    box-shadow: inset 0 0 0 9999px var(--#{$prefix}table-bg-state, var(--#{$prefix}table-bg-type, var(--#{$prefix}table-accent-bg)));\n  }\n\n  > tbody {\n    vertical-align: inherit;\n  }\n\n  > thead {\n    vertical-align: bottom;\n  }\n}\n\n.table-group-divider {\n  border-top: calc(#{$table-border-width} * 2) solid $table-group-separator-color; // stylelint-disable-line function-disallowed-list\n}\n\n//\n// Change placement of captions with a class\n//\n\n.caption-top {\n  caption-side: top;\n}\n\n\n//\n// Condensed table w/ half padding\n//\n\n.table-sm {\n  // stylelint-disable-next-line selector-max-universal\n  > :not(caption) > * > * {\n    padding: $table-cell-padding-y-sm $table-cell-padding-x-sm;\n  }\n}\n\n\n// Border versions\n//\n// Add or remove borders all around the table and between all the columns.\n//\n// When borders are added on all sides of the cells, the corners can render odd when\n// these borders do not have the same color or if they are semi-transparent.\n// Therefore we add top and border bottoms to the `tr`s and left and right borders\n// to the `td`s or `th`s\n\n.table-bordered {\n  > :not(caption) > * {\n    border-width: $table-border-width 0;\n\n    // stylelint-disable-next-line selector-max-universal\n    > * {\n      border-width: 0 $table-border-width;\n    }\n  }\n}\n\n.table-borderless {\n  // stylelint-disable-next-line selector-max-universal\n  > :not(caption) > * > * {\n    border-bottom-width: 0;\n  }\n\n  > :not(:first-child) {\n    border-top-width: 0;\n  }\n}\n\n// Zebra-striping\n//\n// Default zebra-stripe styles (alternating gray and transparent backgrounds)\n\n// For rows\n.table-striped {\n  > tbody > tr:nth-of-type(#{$table-striped-order}) > * {\n    --#{$prefix}table-color-type: var(--#{$prefix}table-striped-color);\n    --#{$prefix}table-bg-type: var(--#{$prefix}table-striped-bg);\n  }\n}\n\n// For columns\n.table-striped-columns {\n  > :not(caption) > tr > :nth-child(#{$table-striped-columns-order}) {\n    --#{$prefix}table-color-type: var(--#{$prefix}table-striped-color);\n    --#{$prefix}table-bg-type: var(--#{$prefix}table-striped-bg);\n  }\n}\n\n// Active table\n//\n// The `.table-active` class can be added to highlight rows or cells\n\n.table-active {\n  --#{$prefix}table-color-state: var(--#{$prefix}table-active-color);\n  --#{$prefix}table-bg-state: var(--#{$prefix}table-active-bg);\n}\n\n// Hover effect\n//\n// Placed here since it has to come after the potential zebra striping\n\n.table-hover {\n  > tbody > tr:hover > * {\n    --#{$prefix}table-color-state: var(--#{$prefix}table-hover-color);\n    --#{$prefix}table-bg-state: var(--#{$prefix}table-hover-bg);\n  }\n}\n\n\n// Table variants\n//\n// Table variants set the table cell backgrounds, border colors\n// and the colors of the striped, hovered & active tables\n\n@each $color, $value in $table-variants {\n  @include table-variant($color, $value);\n}\n\n// Responsive tables\n//\n// Generate series of `.table-responsive-*` classes for configuring the screen\n// size of where your table will overflow.\n\n@each $breakpoint in map.keys($grid-breakpoints) {\n  $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n  @include media-breakpoint-down($breakpoint) {\n    .table-responsive#{$infix} {\n      overflow-x: auto;\n      -webkit-overflow-scrolling: touch;\n    }\n  }\n}\n","@use \"sass:color\";\n@use \"sass:math\";\n@use \"../functions/color-contrast\" as *;\n@use \"../functions/contrast-ratio\" as *;\n@use \"../variables\" as *;\n\n// scss-docs-start table-variant\n@mixin table-variant($state, $background) {\n  .table-#{$state} {\n    $color: color-contrast(opaque($body-bg, $background));\n    $hover-bg: color.mix($color, $background, math.percentage($table-hover-bg-factor));\n    $striped-bg: color.mix($color, $background, math.percentage($table-striped-bg-factor));\n    $active-bg: color.mix($color, $background, math.percentage($table-active-bg-factor));\n    $table-border-color: color.mix($color, $background, math.percentage($table-border-factor));\n    $striped-color: color-contrast($striped-bg);\n    $active-color: color-contrast($active-bg);\n    $hover-color: color-contrast($hover-bg);\n\n    --#{$prefix}table-color: #{$color};\n    --#{$prefix}table-bg: #{$background};\n    --#{$prefix}table-border-color: #{$table-border-color};\n    --#{$prefix}table-striped-bg: #{$striped-bg};\n    --#{$prefix}table-striped-color: #{$striped-color};\n    --#{$prefix}table-active-bg: #{$active-bg};\n    --#{$prefix}table-active-color: #{$active-color};\n    --#{$prefix}table-hover-bg: #{$hover-bg};\n    --#{$prefix}table-hover-color: #{$hover-color};\n    color: var(--#{$prefix}table-color);\n    border-color: var(--#{$prefix}table-border-color);\n  }\n}\n// scss-docs-end table-variant\n","@use \"../mixins/border-radius\" as *;\n@use \"../mixins/box-shadow\" as *;\n@use \"../mixins/focus-ring\" as *;\n@use \"../mixins/transition\" as *;\n@use \"../vendor/rfs\" as *;\n@use \"../variables\" as *;\n\n// scss-docs-start chip-input-variables\n$chip-input-min-height:        $input-height !default;\n$chip-input-padding-y:         .25rem !default;\n$chip-input-padding-x:         .75rem !default;\n$chip-input-font-size:         $input-font-size !default;\n$chip-input-bg:                var(--#{$prefix}body-bg) !default;\n$chip-input-color:             var(--#{$prefix}body-color) !default;\n$chip-input-border-width:      var(--#{$prefix}border-width) !default;\n$chip-input-border-color:      var(--#{$prefix}border-color) !default;\n$chip-input-border-radius:     var(--#{$prefix}border-radius) !default;\n$chip-input-gap:               .375rem !default;\n$chip-input-transition:        $input-transition !default;\n\n$chip-input-min-height-sm:     $input-height-sm !default;\n$chip-input-padding-y-sm:      .125rem !default;\n$chip-input-padding-x-sm:      .5rem !default;\n$chip-input-font-size-sm:      $input-font-size-sm !default;\n$chip-input-border-radius-sm:  var(--#{$prefix}border-radius-sm) !default;\n$chip-input-gap-sm:            .125rem !default;\n\n$chip-input-min-height-lg:     $input-height-lg !default;\n$chip-input-padding-y-lg:      .375rem !default;\n$chip-input-padding-x-lg:      1rem !default;\n$chip-input-font-size-lg:      $input-font-size-lg !default;\n$chip-input-border-radius-lg:  var(--#{$prefix}border-radius-lg) !default;\n$chip-input-gap-lg:            .5rem !default;\n// scss-docs-end chip-input-variables\n\n.chip-input {\n  // scss-docs-start chip-input-css-vars\n  --#{$prefix}chip-input-min-height: #{$chip-input-min-height};\n  --#{$prefix}chip-input-padding-y: #{$chip-input-padding-y};\n  --#{$prefix}chip-input-padding-x: #{$chip-input-padding-x};\n  --#{$prefix}chip-input-font-size: #{$chip-input-font-size};\n  --#{$prefix}chip-input-bg: #{$chip-input-bg};\n  --#{$prefix}chip-input-color: #{$chip-input-color};\n  --#{$prefix}chip-input-border-width: #{$chip-input-border-width};\n  --#{$prefix}chip-input-border-color: #{$chip-input-border-color};\n  --#{$prefix}chip-input-border-radius: #{$chip-input-border-radius};\n  --#{$prefix}chip-input-gap: #{$chip-input-gap};\n  --#{$prefix}chip-input-transition: #{$chip-input-transition};\n  // scss-docs-end chip-input-css-vars\n\n  display: flex;\n  flex-wrap: wrap;\n  gap: var(--#{$prefix}chip-input-gap);\n  align-items: center;\n  min-height: var(--#{$prefix}chip-input-min-height);\n  padding: var(--#{$prefix}chip-input-padding-y) var(--#{$prefix}chip-input-padding-x);\n  @include font-size(var(--#{$prefix}chip-input-font-size));\n  color: var(--#{$prefix}chip-input-color);\n  background-color: var(--#{$prefix}chip-input-bg);\n  border: var(--#{$prefix}chip-input-border-width) solid var(--#{$prefix}chip-input-border-color);\n  @include border-radius(var(--#{$prefix}chip-input-border-radius), 0);\n  @include transition(var(--#{$prefix}chip-input-transition));\n\n  // Focus state when ghost input is focused\n  &:focus-within {\n    border-color: $input-focus-border-color;\n    @include focus-ring();\n  }\n\n  // Disabled state\n  &.disabled {\n    background-color: $input-disabled-bg;\n    opacity: 1;\n\n    > .chip {\n      opacity: .65;\n\n      .chip-dismiss {\n        pointer-events: none;\n      }\n    }\n  }\n}\n\n.chip-input-field {\n  flex: 1 1 auto;\n  margin: 0;\n  border: 0;\n  outline: 0;\n}\n\n// Sizing variants\n.chip-input-lg {\n  --#{$prefix}chip-input-min-height: #{$chip-input-min-height-lg};\n  --#{$prefix}chip-input-padding-y: #{$chip-input-padding-y-lg};\n  --#{$prefix}chip-input-padding-x: #{$chip-input-padding-x-lg};\n  --#{$prefix}chip-input-border-radius: #{$chip-input-border-radius-lg};\n  --#{$prefix}chip-input-font-size: #{$chip-input-font-size-lg};\n  --#{$prefix}chip-input-gap: #{$chip-input-gap-lg};\n}\n\n.chip-input-sm {\n  --#{$prefix}chip-input-min-height: #{$chip-input-min-height-sm};\n  --#{$prefix}chip-input-padding-y: #{$chip-input-padding-y-sm};\n  --#{$prefix}chip-input-padding-x: #{$chip-input-padding-x-sm};\n  --#{$prefix}chip-input-border-radius: #{$chip-input-border-radius-sm};\n  --#{$prefix}chip-input-font-size: #{$chip-input-font-size-sm};\n  --#{$prefix}chip-input-gap: #{$chip-input-gap-sm};\n}\n","// stylelint-disable property-disallowed-list\n@use \"sass:list\";\n@use \"../variables\" as *;\n\n@mixin transition($transition...) {\n  @if list.length($transition) == 0 {\n    $transition: $transition-base;\n  }\n\n  @if list.length($transition) > 1 {\n    @each $value in $transition {\n      @if $value == null or $value == none {\n        @warn \"The keyword 'none' or 'null' must be used as a single argument.\";\n      }\n    }\n  }\n\n  @if $enable-transitions {\n    @if list.nth($transition, 1) != null {\n      transition: $transition;\n    }\n\n    @if $enable-reduced-motion and list.nth($transition, 1) != null and list.nth($transition, 1) != none {\n      @media (prefers-reduced-motion: reduce) {\n        transition: none;\n      }\n    }\n  }\n}\n","@use \"../variables\" as *;\n\n@mixin focus-ring($color: null) {\n  @if $color != null {\n    --#{$prefix}focus-ring-color: #{$color};\n  }\n  outline: 0;\n  box-shadow: 0 0 var(--#{$prefix}focus-ring-blur) var(--#{$prefix}focus-ring-width) var(--#{$prefix}focus-ring-color);\n}\n","@use \"../functions/math\" as *;\n@use \"../vendor/rfs\" as *;\n@use \"../variables\" as *;\n\n//\n// Labels\n//\n\n.form-label {\n  margin-bottom: $form-label-margin-bottom;\n  @include font-size($form-label-font-size);\n  font-style: $form-label-font-style;\n  font-weight: $form-label-font-weight;\n  color: $form-label-color;\n}\n\n// For use with horizontal and inline forms, when you need the label (or legend)\n// text to align with the form controls.\n.col-form-label {\n  padding-top: add($input-padding-y, $input-border-width);\n  padding-bottom: add($input-padding-y, $input-border-width);\n  margin-bottom: 0; // Override the `<legend>` default\n  @include font-size(inherit); // Override the `<legend>` default\n  font-style: $form-label-font-style;\n  font-weight: $form-label-font-weight;\n  line-height: $input-line-height;\n  color: $form-label-color;\n}\n\n.col-form-label-lg {\n  padding-top: add($input-padding-y-lg, $input-border-width);\n  padding-bottom: add($input-padding-y-lg, $input-border-width);\n  @include font-size($input-font-size-lg);\n}\n\n.col-form-label-sm {\n  padding-top: add($input-padding-y-sm, $input-border-width);\n  padding-bottom: add($input-padding-y-sm, $input-border-width);\n  @include font-size($input-font-size-sm);\n}\n","@use \"../vendor/rfs\" as *;\n@use \"../variables\" as *;\n\n//\n// Form text\n//\n\n.form-text {\n  margin-top: $form-text-margin-top;\n  @include font-size($form-text-font-size);\n  font-style: $form-text-font-style;\n  font-weight: $form-text-font-weight;\n  color: $form-text-color;\n}\n","@use \"sass:math\";\n@use \"../mixins/border-radius\" as *;\n@use \"../mixins/box-shadow\" as *;\n@use \"../mixins/gradients\" as *;\n@use \"../mixins/transition\" as *;\n@use \"../vendor/rfs\" as *;\n@use \"../variables\" as *;\n\n//\n// General form controls (plus a few specific high-level interventions)\n//\n\n.form-control {\n  display: block;\n  width: 100%;\n  padding: $input-padding-y $input-padding-x;\n  font-family: $input-font-family;\n  @include font-size($input-font-size);\n  font-weight: $input-font-weight;\n  line-height: $input-line-height;\n  color: $input-color;\n  appearance: none; // Fix appearance for date inputs in Safari\n  background-color: $input-bg;\n  background-clip: padding-box;\n  border: $input-border-width solid $input-border-color;\n\n  // Note: This has no effect on <select>s in some browsers, due to the limited stylability of `<select>`s in CSS.\n  @include border-radius($input-border-radius, 0);\n\n  @include box-shadow($input-box-shadow);\n  @include transition($input-transition);\n\n  &[type=\"file\"] {\n    overflow: hidden; // prevent pseudo element button overlap\n\n    &:not(:disabled):not([readonly]) {\n      cursor: pointer;\n    }\n  }\n\n  // Customize the `:focus` state to imitate native WebKit styles.\n  &:focus {\n    color: $input-focus-color;\n    background-color: $input-focus-bg;\n    border-color: $input-focus-border-color;\n    outline: 0;\n    @if $enable-shadows {\n      @include box-shadow($input-box-shadow, $input-focus-box-shadow);\n    } @else {\n      // Avoid using mixin so we can pass custom focus shadow properly\n      box-shadow: $input-focus-box-shadow;\n    }\n  }\n\n  &::-webkit-date-and-time-value {\n    // On Android Chrome, form-control's \"width: 100%\" makes the input width too small\n    // Tested under Android 11 / Chrome 89, Android 12 / Chrome 100, Android 13 / Chrome 109\n    //\n    // On iOS Safari, form-control's \"appearance: none\" + \"width: 100%\" makes the input width too small\n    // Tested under iOS 16.2 / Safari 16.2\n    min-width: 85px; // Seems to be a good minimum safe width\n\n    // Add some height to date inputs on iOS\n    // https://github.com/twbs/bootstrap/issues/23307\n    // TODO: we can remove this workaround once https://bugs.webkit.org/show_bug.cgi?id=198959 is resolved\n    // Multiply line-height by 1em if it has no unit\n    // stylelint-disable-next-line scss/at-function-named-arguments\n    height: if(sass(math.unit($input-line-height) == \"\"): $input-line-height * 1em; else: $input-line-height);\n\n    // Android Chrome type=\"date\" is taller than the other inputs\n    // because of \"margin: 1px 24px 1px 4px\" inside the shadow DOM\n    // Tested under Android 11 / Chrome 89, Android 12 / Chrome 100, Android 13 / Chrome 109\n    margin: 0;\n  }\n\n  // Prevent excessive date input height in Webkit\n  // https://github.com/twbs/bootstrap/issues/34433\n  &::-webkit-datetime-edit {\n    display: block;\n    padding: 0;\n  }\n\n  // Placeholder\n  &::placeholder {\n    color: var(--#{$prefix}input-placeholder-color, $input-placeholder-color);\n    // Override Firefox's unusual default opacity; see https://github.com/twbs/bootstrap/pull/11526.\n    opacity: 1;\n  }\n\n  // Disabled inputs\n  //\n  // HTML5 says that controls under a fieldset > legend:first-child won't be\n  // disabled if the fieldset is disabled. Due to implementation difficulty, we\n  // don't honor that edge case; we style them as disabled anyway.\n  &:disabled {\n    color: $input-disabled-color;\n    background-color: $input-disabled-bg;\n    border-color: $input-disabled-border-color;\n    // iOS fix for unreadable disabled content; see https://github.com/twbs/bootstrap/issues/11655.\n    opacity: 1;\n  }\n\n  // File input buttons theming\n  &::file-selector-button {\n    padding: $input-padding-y $input-padding-x;\n    margin: (-$input-padding-y) (-$input-padding-x);\n    margin-inline-end: $input-padding-x;\n    color: $form-file-button-color;\n    @include gradient-bg($form-file-button-bg);\n    pointer-events: none;\n    border-color: inherit;\n    border-style: solid;\n    border-width: 0;\n    border-inline-end-width: $input-border-width;\n    border-radius: 0; // stylelint-disable-line property-disallowed-list\n    @include transition($btn-transition);\n  }\n\n  &:hover:not(:disabled):not([readonly])::file-selector-button {\n    background-color: $form-file-button-hover-bg;\n  }\n}\n\n// Readonly controls as plain text\n//\n// Apply class to a readonly input to make it appear like regular plain\n// text (without any border, background color, focus indicator)\n\n.form-control-plaintext {\n  display: block;\n  width: 100%;\n  padding: $input-padding-y 0;\n  margin-bottom: 0; // match inputs if this class comes on inputs with default margins\n  line-height: $input-line-height;\n  color: $input-plaintext-color;\n  background-color: transparent;\n  border: solid transparent;\n  border-width: $input-border-width 0;\n\n  &:focus {\n    outline: 0;\n  }\n\n  &.form-control-sm,\n  &.form-control-lg {\n    padding-right: 0;\n    padding-left: 0;\n  }\n}\n\n// Form control sizing\n//\n// Build on `.form-control` with modifier classes to decrease or increase the\n// height and font-size of form controls.\n//\n// Repeated in `_input_group.scss` to avoid Sass extend issues.\n\n.form-control-sm {\n  min-height: $input-height-sm;\n  padding: $input-padding-y-sm $input-padding-x-sm;\n  @include font-size($input-font-size-sm);\n  @include border-radius($input-border-radius-sm);\n\n  &::file-selector-button {\n    padding: $input-padding-y-sm $input-padding-x-sm;\n    margin: (-$input-padding-y-sm) (-$input-padding-x-sm);\n    margin-inline-end: $input-padding-x-sm;\n  }\n}\n\n.form-control-lg {\n  min-height: $input-height-lg;\n  padding: $input-padding-y-lg $input-padding-x-lg;\n  @include font-size($input-font-size-lg);\n  @include border-radius($input-border-radius-lg);\n\n  &::file-selector-button {\n    padding: $input-padding-y-lg $input-padding-x-lg;\n    margin: (-$input-padding-y-lg) (-$input-padding-x-lg);\n    margin-inline-end: $input-padding-x-lg;\n  }\n}\n\n// Make sure textareas don't shrink too much when resized\n// https://github.com/twbs/bootstrap/pull/29124\n// stylelint-disable selector-no-qualifying-type\ntextarea {\n  &.form-control {\n    min-height: $input-height;\n  }\n\n  &.form-control-sm {\n    min-height: $input-height-sm;\n  }\n\n  &.form-control-lg {\n    min-height: $input-height-lg;\n  }\n}\n// stylelint-enable selector-no-qualifying-type\n\n.form-control-color {\n  width: $form-color-width;\n  height: $input-height;\n  padding: $input-padding-y;\n\n  &:not(:disabled):not([readonly]) {\n    cursor: pointer;\n  }\n\n  &::-moz-color-swatch {\n    border: 0 !important; // stylelint-disable-line declaration-no-important\n    @include border-radius($input-border-radius);\n  }\n\n  &::-webkit-color-swatch {\n    border: 0 !important; // stylelint-disable-line declaration-no-important\n    @include border-radius($input-border-radius);\n  }\n\n  &.form-control-sm { height: $input-height-sm; }\n  &.form-control-lg { height: $input-height-lg; }\n}\n","@use \"../variables\" as *;\n\n// Gradients\n\n// scss-docs-start gradient-bg-mixin\n@mixin gradient-bg($color: null) {\n  background-color: $color;\n\n  @if $enable-gradients {\n    background-image: var(--#{$prefix}gradient);\n  }\n}\n// scss-docs-end gradient-bg-mixin\n\n// scss-docs-start gradient-mixins\n// Horizontal gradient, from left to right\n//\n// Creates two color stops, start and end, by specifying a color and position for each color stop.\n@mixin gradient-x($start-color: $gray-700, $end-color: $gray-800, $start-percent: 0%, $end-percent: 100%) {\n  background-image: linear-gradient(to right, $start-color $start-percent, $end-color $end-percent);\n}\n\n// Vertical gradient, from top to bottom\n//\n// Creates two color stops, start and end, by specifying a color and position for each color stop.\n@mixin gradient-y($start-color: $gray-700, $end-color: $gray-800, $start-percent: null, $end-percent: null) {\n  background-image: linear-gradient(to bottom, $start-color $start-percent, $end-color $end-percent);\n}\n\n@mixin gradient-directional($start-color: $gray-700, $end-color: $gray-800, $deg: 45deg) {\n  background-image: linear-gradient($deg, $start-color, $end-color);\n}\n\n@mixin gradient-x-three-colors($start-color: $blue, $mid-color: $purple, $color-stop: 50%, $end-color: $red) {\n  background-image: linear-gradient(to right, $start-color, $mid-color $color-stop, $end-color);\n}\n\n@mixin gradient-y-three-colors($start-color: $blue, $mid-color: $purple, $color-stop: 50%, $end-color: $red) {\n  background-image: linear-gradient($start-color, $mid-color $color-stop, $end-color);\n}\n\n@mixin gradient-radial($inner-color: $gray-700, $outer-color: $gray-800) {\n  background-image: radial-gradient(circle, $inner-color, $outer-color);\n}\n\n@mixin gradient-striped($color: rgba($white, .15), $angle: 45deg) {\n  background-image: linear-gradient($angle, $color 25%, transparent 25%, transparent 50%, $color 50%, $color 75%, transparent 75%, transparent);\n}\n// scss-docs-end gradient-mixins\n","@use \"../functions/escape-svg\" as *;\n@use \"../mixins/border-radius\" as *;\n@use \"../mixins/box-shadow\" as *;\n@use \"../mixins/color-mode\" as *;\n@use \"../mixins/ltr-rtl\" as *;\n@use \"../mixins/transition\" as *;\n@use \"../vendor/rfs\" as *;\n@use \"../variables\" as *;\n@use \"../variables-dark\" as *;\n\n// Select\n//\n// Replaces the browser default select with a custom one, mostly pulled from\n// https://primer.github.io/.\n\n.form-select {\n  --#{$prefix}form-select-bg-img: #{escape-svg($form-select-indicator)};\n\n  display: block;\n  width: 100%;\n  padding-inline-start: $form-select-padding-x;\n  padding-inline-end: $form-select-indicator-padding;\n  padding-top: $form-select-padding-y;\n  padding-bottom: $form-select-padding-y;\n  font-family: $form-select-font-family;\n  @include font-size($form-select-font-size);\n  font-weight: $form-select-font-weight;\n  line-height: $form-select-line-height;\n  color: $form-select-color;\n  appearance: none;\n  background-color: $form-select-bg;\n  background-image: var(--#{$prefix}form-select-bg-img), var(--#{$prefix}form-select-bg-icon, none);\n  background-repeat: no-repeat;\n  @include ltr-rtl-value-only(\"background-position\", $form-select-bg-position);\n  background-size: $form-select-bg-size;\n  border: $form-select-border-width solid $form-select-border-color;\n  @include border-radius($form-select-border-radius, 0);\n  @include box-shadow($form-select-box-shadow);\n  @include transition($form-select-transition);\n\n  &:focus {\n    border-color: $form-select-focus-border-color;\n    outline: 0;\n    @if $enable-shadows {\n      @include box-shadow($form-select-box-shadow, $form-select-focus-box-shadow);\n    } @else {\n      // Avoid using mixin so we can pass custom focus shadow properly\n      box-shadow: $form-select-focus-box-shadow;\n    }\n  }\n\n  &[multiple],\n  &[size]:not([size=\"1\"]) {\n    padding-inline-end: $form-select-padding-x;\n    background-image: none;\n  }\n\n  &:disabled {\n    color: $form-select-disabled-color;\n    background-color: $form-select-disabled-bg;\n    border-color: $form-select-disabled-border-color;\n  }\n\n  // Remove outline from select box in FF\n  &:-moz-focusring {\n    color: transparent;\n    text-shadow: 0 0 0 $form-select-color;\n  }\n}\n\n.form-select-sm {\n  padding-inline-start: $form-select-padding-x-sm;\n  padding-top: $form-select-padding-y-sm;\n  padding-bottom: $form-select-padding-y-sm;\n  @include font-size($form-select-font-size-sm);\n  @include border-radius($form-select-border-radius-sm);\n}\n\n.form-select-lg {\n  padding-inline-start: $form-select-padding-x-lg;\n  padding-top: $form-select-padding-y-lg;\n  padding-bottom: $form-select-padding-y-lg;\n  @include font-size($form-select-font-size-lg);\n  @include border-radius($form-select-border-radius-lg);\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark) {\n    .form-select {\n      --#{$prefix}form-select-bg-img: #{escape-svg($form-select-indicator-dark)};\n    }\n  }\n}\n","@use \"sass:string\";\n@use \"../functions/str-replace\" as *;\n@use \"../variables\" as *;\n\n// Applies styles only when LTR is enabled and the HTML does NOT have the \"rtl\"\n// attribute (i.e., left-to-right contexts).\n\n@mixin ltr {\n  @if $enable-ltr {\n    html:not([dir=\"rtl\"]) & {\n      @content;\n    }\n  }\n}\n\n// Applies styles only when RTL is enabled and the element is within an RTL\n// context (i.e., the element is a descendant of an element with dir=\"rtl\").\n\n@mixin rtl {\n  @if $enable-rtl {\n    *[dir=\"rtl\"] & {\n      @content;\n    }\n  }\n}\n\n// This function takes an element (or string) and returns its \"mirrored\" version.\n// For example, it will replace \"left\" with \"right\" and vice versa.\n\n@function reflect($element) {\n  $string: #{$element};\n  @if string.index($string, \"left\") {\n    @return str-replace($string, \"left\", \"right\");\n  }\n  @if string.index($string, \"right\") {\n    @return str-replace($string, \"right\", \"left\");\n  }\n\n  @return string.unquote($string);\n}\n\n// Generates CSS for a given property with different values for LTR and RTL\n// contexts. Allows an optional custom property name and value for RTL.\n//\n// @param {String} $property - The CSS property for LTR context (e.g., margin-left).\n// @param {String} $value - The value for the property in LTR context.\n// @param {String} $property-rtl - Optional custom property name for RTL context.\n// @param {String} $value-rtl - Optional custom value for RTL context.\n// @param {Boolean} $important - Optional \"!important\" flag.\n\n@mixin ltr-rtl($property, $value, $property-rtl: null, $value-rtl: null, $important: false) {\n  $property-reflected: reflect($property);\n  $value-reflected: reflect($value);\n\n  @if $enable-ltr and $enable-rtl {\n    @include ltr() {\n      // stylelint-disable-next-line scss/at-function-named-arguments\n      #{$property}: $value if(sass($important): !important);\n    }\n    @include rtl() {\n      @if $value-rtl {\n        // stylelint-disable-next-line scss/at-function-named-arguments\n        #{$property-reflected}: $value-rtl if(sass($important): !important);\n      }\n      @else {\n        // stylelint-disable-next-line scss/at-function-named-arguments\n        #{$property-reflected}: $value-reflected if(sass($important): !important);\n      }\n    }\n  }\n  @else {\n    @if $enable-rtl {\n      @if $value-rtl {\n        // stylelint-disable-next-line scss/at-function-named-arguments\n        #{$property-reflected}: $value-rtl if(sass($important): !important);\n      }\n      @else {\n        // stylelint-disable-next-line scss/at-function-named-arguments\n        #{$property-reflected}: $value-reflected if(sass($important): !important);\n      }\n    }\n    @else {\n      // stylelint-disable-next-line scss/at-function-named-arguments\n      #{$property}: $value if(sass($important): !important);\n    }\n  }\n}\n\n// Similar to ltr-rtl but assumes the property name is the same for both\n// contexts. It only mirrors the value for RTL if a custom RTL value is not\n// provided.\n//\n// @param {String} $property - The CSS property to apply.\n// @param {String} $value - The value for the property in LTR context.\n// @param {String} $value-rtl - Optional custom value for RTL context.\n// @param {Boolean} $important - Optional \"!important\" flag.\n\n@mixin ltr-rtl-value-only($property, $value, $value-rtl: null, $important: false) {\n  $value-reflected: reflect($value);\n\n  @if $enable-ltr and $enable-rtl {\n    @include ltr() {\n      // stylelint-disable-next-line scss/at-function-named-arguments\n      #{$property}: $value if(sass($important): !important);\n    }\n    @include rtl() {\n      @if $value-rtl {\n        // stylelint-disable-next-line scss/at-function-named-arguments\n        #{$property}: $value-rtl if(sass($important): !important);\n      } @else {\n        // stylelint-disable-next-line scss/at-function-named-arguments\n        #{$property}: $value-reflected if(sass($important): !important);\n      }\n    }\n  }\n  @else {\n    @if $enable-rtl {\n      @if $value-rtl {\n        // stylelint-disable-next-line scss/at-function-named-arguments\n        #{$property}: $value-rtl if(sass($important): !important);\n      } @else {\n        // stylelint-disable-next-line scss/at-function-named-arguments\n        #{$property}: $value-reflected if(sass($important): !important);\n      }\n    } @else {\n      // stylelint-disable-next-line scss/at-function-named-arguments\n      #{$property}: $value if(sass($important): !important);\n    }\n  }\n}\n","@use \"sass:map\";\n@use \"../functions/escape-svg\" as *;\n@use \"../mixins/border-radius\" as *;\n@use \"../mixins/color-mode\" as *;\n@use \"../mixins/transition\" as *;\n@use \"../variables\" as *;\n@use \"../variables-dark\" as *;\n\n//\n// Check/radio\n//\n\n.form-check {\n  display: block;\n  min-height: $form-check-min-height;\n  padding-inline-start: $form-check-padding-start;\n  margin-bottom: $form-check-margin-bottom;\n\n  .form-check-input {\n    float: inline-start;\n    margin-inline-start: $form-check-padding-start * -1;\n  }\n}\n\n.form-check-reverse {\n  padding-inline: 0 $form-check-padding-start;\n  text-align: end;\n\n  .form-check-input {\n    float: inline-end;\n    margin-inline: 0 $form-check-padding-start * -1;\n  }\n}\n\n.form-check-input {\n  --#{$prefix}form-check-bg: #{$form-check-input-bg};\n\n  flex-shrink: 0;\n  width: $form-check-input-width;\n  height: $form-check-input-width;\n  margin-top: ($line-height-base - $form-check-input-width) * .5; // line-height minus check height\n  vertical-align: top;\n  appearance: none;\n  background-color: var(--#{$prefix}form-check-bg);\n  background-image: var(--#{$prefix}form-check-bg-image);\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: contain;\n  border: $form-check-input-border;\n  print-color-adjust: exact; // Keep themed appearance for print\n  @include transition($form-check-transition);\n\n  &[type=\"checkbox\"] {\n    @include border-radius($form-check-input-border-radius);\n  }\n\n  &[type=\"radio\"] {\n    // stylelint-disable-next-line property-disallowed-list\n    border-radius: $form-check-radio-border-radius;\n  }\n\n  &:active {\n    filter: $form-check-input-active-filter;\n  }\n\n  &:focus {\n    border-color: $form-check-input-focus-border;\n    outline: 0;\n    box-shadow: $form-check-input-focus-box-shadow;\n  }\n\n  &:checked {\n    background-color: var(--#{$prefix}form-check-input-checked-bg-color, $form-check-input-checked-bg-color);\n    border-color: var(--#{$prefix}form-check-input-checked-border-color, $form-check-input-checked-border-color);\n\n    &[type=\"checkbox\"] {\n      @if $enable-gradients {\n        --#{$prefix}form-check-bg-image: #{escape-svg($form-check-input-checked-bg-image)}, var(--#{$prefix}gradient);\n      } @else {\n        --#{$prefix}form-check-bg-image: #{escape-svg($form-check-input-checked-bg-image)};\n      }\n    }\n\n    &[type=\"radio\"] {\n      @if $enable-gradients {\n        --#{$prefix}form-check-bg-image: #{escape-svg($form-check-radio-checked-bg-image)}, var(--#{$prefix}gradient);\n      } @else {\n        --#{$prefix}form-check-bg-image: #{escape-svg($form-check-radio-checked-bg-image)};\n      }\n    }\n  }\n\n  &[type=\"checkbox\"]:indeterminate {\n    background-color: $form-check-input-indeterminate-bg-color;\n    border-color: $form-check-input-indeterminate-border-color;\n\n    @if $enable-gradients {\n      --#{$prefix}form-check-bg-image: #{escape-svg($form-check-input-indeterminate-bg-image)}, var(--#{$prefix}gradient);\n    } @else {\n      --#{$prefix}form-check-bg-image: #{escape-svg($form-check-input-indeterminate-bg-image)};\n    }\n  }\n\n  &:disabled {\n    pointer-events: none;\n    filter: none;\n    opacity: $form-check-input-disabled-opacity;\n  }\n\n  // Use disabled attribute in addition of :disabled pseudo-class\n  // See: https://github.com/twbs/bootstrap/issues/28247\n  &[disabled],\n  &:disabled {\n    ~ .form-check-label {\n      cursor: default;\n      opacity: $form-check-label-disabled-opacity;\n    }\n  }\n}\n\n.form-check-label {\n  color: var(--#{$prefix}form-check-label-color, $form-check-label-color);\n  cursor: $form-check-label-cursor;\n}\n\n//\n// Switch\n//\n\n.form-switch {\n  padding-inline-start: $form-switch-padding-start;\n\n  .form-check-input {\n    --#{$prefix}form-switch-bg: #{escape-svg($form-switch-bg-image)};\n\n    width: $form-switch-width;\n    margin-inline-start: $form-switch-padding-start * -1;\n    background-image: var(--#{$prefix}form-switch-bg);\n    background-position: left center;\n    @include border-radius($form-switch-border-radius, 0);\n    @include transition($form-switch-transition);\n\n    &:focus {\n      --#{$prefix}form-switch-bg: #{escape-svg($form-switch-focus-bg-image)};\n    }\n\n    &:checked {\n      background-position: $form-switch-checked-bg-position;\n\n      @if $enable-gradients {\n        --#{$prefix}form-switch-bg: #{escape-svg($form-switch-checked-bg-image)}, var(--#{$prefix}gradient);\n      } @else {\n        --#{$prefix}form-switch-bg: #{escape-svg($form-switch-checked-bg-image)};\n      }\n    }\n  }\n\n  &.form-check-reverse {\n    padding-inline: 0 $form-switch-padding-start;\n\n    .form-check-input {\n      margin-inline: 0 $form-switch-padding-start * -1;\n    }\n  }\n}\n\n@each $size, $map in $form-switch-widths {\n  $width: map.get($map, \"width\");\n  $height: map.get($map, \"height\");\n\n  .form-switch-#{$size} {\n    min-height: $height;\n    padding-inline-start: $width + .5em;\n\n    .form-check-input {\n      width: $width;\n      height: $height;\n      margin-inline-start: ($width + .5em) * -1;\n    }\n\n    .form-check-label {\n      // stylelint-disable-next-line function-disallowed-list\n      padding-top: calc((#{$height} - #{$font-size-base}) / 2);\n    }\n  }\n}\n\n.form-check-inline {\n  display: inline-block;\n  margin-inline-end: $form-check-inline-margin-end;\n}\n\n.btn-check {\n  position: absolute;\n  clip: rect(0, 0, 0, 0);\n  pointer-events: none;\n\n  &[disabled],\n  &:disabled {\n    + .btn {\n      pointer-events: none;\n      filter: none;\n      opacity: $form-check-btn-check-disabled-opacity;\n    }\n  }\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark) {\n    .form-switch .form-check-input:not(:checked):not(:focus) {\n      --#{$prefix}form-switch-bg: #{escape-svg($form-switch-bg-image-dark)};\n    }\n  }\n}\n","@use \"../functions/math\" as *;\n@use \"../mixins/border-radius\" as *;\n@use \"../mixins/box-shadow\" as *;\n@use \"../mixins/gradients\" as *;\n@use \"../mixins/transition\" as *;\n@use \"../variables\" as *;\n\n// Range\n//\n// Style range inputs the same across browsers. Vendor-specific rules for pseudo\n// elements cannot be mixed. As such, there are no shared styles for focus or\n// active states on prefixed selectors.\n\n.form-range {\n  width: 100%;\n  height: add($form-range-thumb-height, $form-range-thumb-focus-box-shadow-width * 2);\n  padding: 0; // Need to reset padding\n  appearance: none;\n  background-color: transparent;\n\n  &:focus {\n    outline: 0;\n\n    // Pseudo-elements must be split across multiple rulesets to have an effect.\n    // No box-shadow() mixin for focus accessibility.\n    &::-webkit-slider-thumb { box-shadow: $form-range-thumb-focus-box-shadow; }\n    &::-moz-range-thumb     { box-shadow: $form-range-thumb-focus-box-shadow; }\n  }\n\n  &::-moz-focus-outer {\n    border: 0;\n  }\n\n  &::-webkit-slider-thumb {\n    width: $form-range-thumb-width;\n    height: $form-range-thumb-height;\n    margin-top: ($form-range-track-height - $form-range-thumb-height) * .5; // Webkit specific\n    appearance: none;\n    @include gradient-bg($form-range-thumb-bg);\n    border: $form-range-thumb-border;\n    @include border-radius($form-range-thumb-border-radius);\n    @include box-shadow($form-range-thumb-box-shadow);\n    @include transition($form-range-thumb-transition);\n\n    &:active {\n      @include gradient-bg($form-range-thumb-active-bg);\n    }\n  }\n\n  &::-webkit-slider-runnable-track {\n    width: $form-range-track-width;\n    height: $form-range-track-height;\n    color: transparent; // Why?\n    cursor: $form-range-track-cursor;\n    background-color: $form-range-track-bg;\n    border-color: transparent;\n    @include border-radius($form-range-track-border-radius);\n    @include box-shadow($form-range-track-box-shadow);\n  }\n\n  &::-moz-range-thumb {\n    width: $form-range-thumb-width;\n    height: $form-range-thumb-height;\n    appearance: none;\n    @include gradient-bg($form-range-thumb-bg);\n    border: $form-range-thumb-border;\n    @include border-radius($form-range-thumb-border-radius);\n    @include box-shadow($form-range-thumb-box-shadow);\n    @include transition($form-range-thumb-transition);\n\n    &:active {\n      @include gradient-bg($form-range-thumb-active-bg);\n    }\n  }\n\n  &::-moz-range-track {\n    width: $form-range-track-width;\n    height: $form-range-track-height;\n    color: transparent;\n    cursor: $form-range-track-cursor;\n    background-color: $form-range-track-bg;\n    border-color: transparent; // Firefox specific?\n    @include border-radius($form-range-track-border-radius);\n    @include box-shadow($form-range-track-box-shadow);\n  }\n\n  &:disabled {\n    pointer-events: none;\n\n    &::-webkit-slider-thumb {\n      background-color: $form-range-thumb-disabled-bg;\n    }\n\n    &::-moz-range-thumb {\n      background-color: $form-range-thumb-disabled-bg;\n    }\n  }\n}\n","@use \"../mixins/border-radius\" as *;\n@use \"../mixins/transition\" as *;\n@use \"../variables\" as *;\n\n.form-floating {\n  position: relative;\n\n  > .form-control,\n  > .form-control-plaintext,\n  > .form-select {\n    height: $form-floating-height;\n    min-height: $form-floating-height;\n    line-height: $form-floating-line-height;\n  }\n\n  > label {\n    position: absolute;\n    inset-inline-start: 0;\n    top: 0;\n    z-index: 2;\n    max-width: 100%;\n    height: 100%; // allow textareas\n    padding: $form-floating-padding-y $form-floating-padding-x;\n    overflow: hidden;\n    color: rgba(var(--#{$prefix}body-color-rgb), #{$form-floating-label-opacity});\n    text-align: start;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    pointer-events: none;\n    border: $input-border-width solid transparent; // Required for aligning label's text with the input as it affects inner box model\n    transform-origin: 0 0;\n    @include transition($form-floating-transition);\n  }\n\n  > .form-control,\n  > .form-control-plaintext {\n    padding: $form-floating-padding-y $form-floating-padding-x;\n\n    &::placeholder {\n      color: transparent;\n    }\n\n    &:focus,\n    &:not(:placeholder-shown) {\n      padding-top: $form-floating-input-padding-t;\n      padding-bottom: $form-floating-input-padding-b;\n    }\n    // Duplicated because `:-webkit-autofill` invalidates other selectors when grouped\n    &:-webkit-autofill {\n      padding-top: $form-floating-input-padding-t;\n      padding-bottom: $form-floating-input-padding-b;\n    }\n  }\n\n  > .form-select {\n    padding-inline-start: $form-floating-padding-x;\n    padding-top: $form-floating-input-padding-t;\n    padding-bottom: $form-floating-input-padding-b;\n  }\n\n  > .form-control:focus,\n  > .form-control:not(:placeholder-shown),\n  > .form-control-plaintext,\n  > .form-select {\n    ~ label {\n      transform: $form-floating-label-transform;\n    }\n  }\n  // Duplicated because `:-webkit-autofill` invalidates other selectors when grouped\n  > .form-control:-webkit-autofill {\n    ~ label {\n      transform: $form-floating-label-transform;\n    }\n  }\n  > textarea:focus,\n  > textarea:not(:placeholder-shown) {\n    ~ label::after {\n      position: absolute;\n      inset: $form-floating-padding-y ($form-floating-padding-x * .5);\n      z-index: -1;\n      height: $form-floating-label-height;\n      content: \"\";\n      background-color: $input-bg;\n      @include border-radius($input-border-radius);\n    }\n  }\n  > textarea:disabled ~ label::after {\n    background-color: $input-disabled-bg;\n  }\n\n  > .form-control-plaintext {\n    ~ label {\n      border-width: $input-border-width 0; // Required to properly position label text - as explained above\n    }\n  }\n\n  > :disabled ~ label,\n  > .form-control:disabled ~ label { // Required for `.form-control`s because of specificity\n    color: $form-floating-label-disabled-color;\n  }\n}\n","@use \"sass:map\";\n@use \"sass:string\";\n@use \"../mixins/border-radius\" as *;\n@use \"../vendor/rfs\" as *;\n@use \"../variables\" as *;\n\n//\n// Base styles\n//\n\n.input-group {\n  position: relative;\n  display: flex;\n  flex-wrap: wrap; // For form validation feedback\n  align-items: stretch;\n  width: 100%;\n\n  > .form-control,\n  > .form-select,\n  > .form-floating {\n    position: relative; // For focus state's z-index\n    flex: 1 1 auto;\n    width: 1%;\n    min-width: 0; // https://stackoverflow.com/questions/36247140/why-dont-flex-items-shrink-past-content-size\n  }\n\n  // Bring the \"active\" form control to the top of surrounding elements\n  > .form-control:focus,\n  > .form-select:focus,\n  > .form-floating:focus-within {\n    z-index: 5;\n  }\n\n  // Ensure buttons are always above inputs for more visually pleasing borders.\n  // This isn't needed for `.input-group-text` since it shares the same border-color\n  // as our inputs.\n  .btn {\n    position: relative;\n    z-index: 2;\n\n    &:focus {\n      z-index: 5;\n    }\n  }\n}\n\n\n// Textual addons\n//\n// Serves as a catch-all element for any text or radio/checkbox input you wish\n// to prepend or append to an input.\n\n.input-group-text {\n  display: flex;\n  align-items: center;\n  padding: $input-group-addon-padding-y $input-group-addon-padding-x;\n  @include font-size($input-font-size); // Match inputs\n  font-weight: $input-group-addon-font-weight;\n  line-height: $input-line-height;\n  color: var(--#{$prefix}input-group-addon-color, $input-group-addon-color);\n  text-align: center;\n  white-space: nowrap;\n  background-color: var(--#{$prefix}input-group-addon-bg, $input-group-addon-bg);\n  border: $input-border-width solid var(--#{$prefix}input-group-addon-border-color, $input-group-addon-border-color);\n  @include border-radius($input-border-radius);\n}\n\n\n// Sizing\n//\n// Remix the default form control sizing classes into new ones for easier\n// manipulation.\n\n.input-group-lg > .form-control,\n.input-group-lg > .form-select,\n.input-group-lg > .input-group-text,\n.input-group-lg > .btn {\n  padding: $input-padding-y-lg $input-padding-x-lg;\n  @include font-size($input-font-size-lg);\n  @include border-radius($input-border-radius-lg);\n}\n\n.input-group-sm > .form-control,\n.input-group-sm > .form-select,\n.input-group-sm > .input-group-text,\n.input-group-sm > .btn {\n  padding: $input-padding-y-sm $input-padding-x-sm;\n  @include font-size($input-font-size-sm);\n  @include border-radius($input-border-radius-sm);\n}\n\n.input-group-lg > .form-select,\n.input-group-sm > .form-select {\n  padding-inline-end: $form-select-padding-x + $form-select-indicator-padding;\n}\n\n\n// Rounded corners\n//\n// These rulesets must come after the sizing ones to properly override sm and lg\n// border-radius values when extending. They're more specific than we'd like\n// with the `.input-group >` part, but without it, we cannot override the sizing.\n\n// stylelint-disable-next-line no-duplicate-selectors\n.input-group {\n  &:not(.has-validation) {\n    > :not(:last-child):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),\n    > .dropdown-toggle:nth-last-child(n + 3),\n    > .form-floating:not(:last-child) > .form-control,\n    > .form-floating:not(:last-child) > .form-select {\n      @include border-end-radius(0);\n    }\n  }\n\n  &.has-validation {\n    > :nth-last-child(n + 3):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),\n    > .dropdown-toggle:nth-last-child(n + 4),\n    > .form-floating:nth-last-child(n + 3) > .form-control,\n    > .form-floating:nth-last-child(n + 3) > .form-select {\n      @include border-end-radius(0);\n    }\n  }\n\n  $validation-messages: \"\";\n  @each $state in map.keys($form-validation-states) {\n    $validation-messages: $validation-messages + \":not(.\" + string.unquote($state) + \"-tooltip)\" + \":not(.\" + string.unquote($state) + \"-feedback)\";\n  }\n\n  > :not(:first-child):not(.dropdown-menu)#{$validation-messages} {\n    margin-inline-start: calc(-1 * #{$input-border-width}); // stylelint-disable-line function-disallowed-list\n    @include border-start-radius(0);\n  }\n\n  > .form-floating:not(:first-child) > .form-control,\n  > .form-floating:not(:first-child) > .form-select {\n    @include border-start-radius(0);\n  }\n}\n","@use \"../functions/escape-svg\" as *;\n@use \"../functions/math\" as *;\n@use \"../mixins/border-radius\" as *;\n@use \"../mixins/box-shadow\" as *;\n@use \"../mixins/ltr-rtl\" as *;\n@use \"../vendor/rfs\" as *;\n@use \"../variables\" as *;\n\n// This mixin uses an `if()` technique to be compatible with Dart Sass\n// See https://github.com/sass/sass/issues/1873#issuecomment-152293725 for more details\n\n// scss-docs-start form-validation-mixins\n@mixin form-validation-state-selector($state) {\n  @if ($state == \"valid\" or $state == \"invalid\") {\n    .was-validated #{if(sass(&): \"&\"; else: \"\")}:#{$state},\n    #{if(sass(&): \"&\"; else: \"\")}.is-#{$state} {\n      @content;\n    }\n  } @else {\n    #{if(sass(&): \"&\"; else: \"\")}.is-#{$state} {\n      @content;\n    }\n  }\n}\n\n@mixin form-validation-state(\n  $state,\n  $color,\n  $icon,\n  $tooltip-color: color-contrast($color, $color-contrast-dark, $color-contrast-light, $white, $black, $min-contrast-ratio),\n  $tooltip-bg-color: rgba($color, $form-feedback-tooltip-opacity),\n  $focus-box-shadow: 0 0 $input-btn-focus-blur $input-focus-width rgba($color, $input-btn-focus-color-opacity),\n  $border-color: $color\n) {\n  .#{$state}-feedback {\n    display: none;\n    width: 100%;\n    margin-top: $form-feedback-margin-top;\n    @include font-size($form-feedback-font-size);\n    font-style: $form-feedback-font-style;\n    color: $color;\n  }\n\n  .#{$state}-tooltip {\n    position: absolute;\n    top: 100%;\n    z-index: 5;\n    display: none;\n    max-width: 100%; // Contain to parent when possible\n    padding: $form-feedback-tooltip-padding-y $form-feedback-tooltip-padding-x;\n    margin-top: .1rem;\n    @include font-size($form-feedback-tooltip-font-size);\n    line-height: $form-feedback-tooltip-line-height;\n    color: $tooltip-color;\n    background-color: $tooltip-bg-color;\n    @include border-radius($form-feedback-tooltip-border-radius);\n  }\n\n  @include form-validation-state-selector($state) {\n    ~ .#{$state}-feedback,\n    ~ .#{$state}-tooltip {\n      display: block;\n    }\n  }\n\n  .form-control {\n    @include form-validation-state-selector($state) {\n      border-color: $border-color;\n\n      @if $enable-validation-icons {\n        padding-inline-end: $input-height-inner;\n        background-image: escape-svg($icon);\n        background-repeat: no-repeat;\n        @include ltr-rtl-value-only(\"background-position\", right $input-height-inner-quarter center, left $input-height-inner-quarter center);\n        background-size: $input-height-inner-half $input-height-inner-half;\n      }\n\n      &:focus {\n        border-color: $border-color;\n        @if $enable-shadows {\n          @include box-shadow($input-box-shadow, $focus-box-shadow);\n        } @else {\n          // Avoid using mixin so we can pass custom focus shadow properly\n          box-shadow: $focus-box-shadow;\n        }\n      }\n    }\n  }\n\n  // stylelint-disable-next-line selector-no-qualifying-type\n  textarea.form-control {\n    @include form-validation-state-selector($state) {\n      @if $enable-validation-icons {\n        padding-inline-end: $input-height-inner;\n        @include ltr-rtl-value-only(\"background-position\", top $input-height-inner-quarter right $input-height-inner-quarter, top $input-height-inner-quarter left $input-height-inner-quarter);\n      }\n    }\n  }\n\n  .form-select {\n    @include form-validation-state-selector($state) {\n      border-color: $border-color;\n\n      @if $enable-validation-icons {\n        &:not([multiple]):not([size]),\n        &:not([multiple])[size=\"1\"] {\n          --#{$prefix}form-select-bg-icon: #{escape-svg($icon)};\n          padding-inline-end: $form-select-feedback-icon-padding-end;\n          @include ltr-rtl-value-only(\"background-position\", #{$form-select-bg-position, $form-select-feedback-icon-position});\n          background-size: $form-select-bg-size, $form-select-feedback-icon-size;\n        }\n      }\n\n      &:focus {\n        border-color: $border-color;\n        @if $enable-shadows {\n          @include box-shadow($form-select-box-shadow, $focus-box-shadow);\n        } @else {\n          // Avoid using mixin so we can pass custom focus shadow properly\n          box-shadow: $focus-box-shadow;\n        }\n      }\n    }\n  }\n\n  .form-control-color {\n    @include form-validation-state-selector($state) {\n      @if $enable-validation-icons {\n        width: add($form-color-width, $input-height-inner);\n      }\n    }\n  }\n\n  .form-check-input {\n    @include form-validation-state-selector($state) {\n      border-color: $border-color;\n\n      &:checked {\n        background-color: $color;\n      }\n\n      &:focus {\n        box-shadow: $focus-box-shadow;\n      }\n\n      ~ .form-check-label {\n        color: $color;\n      }\n    }\n  }\n  .form-check-inline .form-check-input {\n    ~ .#{$state}-feedback {\n      margin-inline-start: .5em;\n    }\n  }\n\n  .input-group {\n    > .form-control:not(:focus),\n    > .form-select:not(:focus),\n    > .form-floating:not(:focus-within) {\n      @include form-validation-state-selector($state) {\n        @if $state == \"valid\" {\n          z-index: 3;\n        } @else if $state == \"invalid\" {\n          z-index: 4;\n        }\n      }\n    }\n  }\n}\n// scss-docs-end form-validation-mixins\n","@use \"functions/color\" as *;\n@use \"mixins/border-radius\" as *;\n@use \"mixins/box-shadow\" as *;\n@use \"mixins/buttons\" as *;\n@use \"mixins/color-mode\" as *;\n@use \"mixins/gradients\" as *;\n@use \"mixins/transition\" as *;\n@use \"vendor/rfs\" as *;\n@use \"variables\" as *;\n@use \"variables-dark\" as *;\n\n//\n// Base styles\n//\n\n.btn {\n  // scss-docs-start btn-css-vars\n  --#{$prefix}btn-padding-x: #{$btn-padding-x};\n  --#{$prefix}btn-padding-y: #{$btn-padding-y};\n  --#{$prefix}btn-font-family: #{$btn-font-family};\n  @include rfs($btn-font-size, --#{$prefix}btn-font-size);\n  --#{$prefix}btn-font-weight: #{$btn-font-weight};\n  --#{$prefix}btn-line-height: #{$btn-line-height};\n  --#{$prefix}btn-color: #{$btn-color};\n  --#{$prefix}btn-bg: transparent;\n  --#{$prefix}btn-border-width: #{$btn-border-width};\n  --#{$prefix}btn-border-color: transparent;\n  --#{$prefix}btn-border-radius: #{$btn-border-radius};\n  --#{$prefix}btn-hover-border-color: transparent;\n  --#{$prefix}btn-box-shadow: #{$btn-box-shadow};\n  --#{$prefix}btn-disabled-opacity: #{$btn-disabled-opacity};\n  --#{$prefix}btn-focus-box-shadow: 0 0 0 #{$btn-focus-width} rgba(var(--#{$prefix}btn-focus-shadow-rgb), .5);\n  // scss-docs-end btn-css-vars\n\n  display: inline-block;\n  padding: var(--#{$prefix}btn-padding-y) var(--#{$prefix}btn-padding-x);\n  font-family: var(--#{$prefix}btn-font-family);\n  @include font-size(var(--#{$prefix}btn-font-size));\n  font-weight: var(--#{$prefix}btn-font-weight);\n  line-height: var(--#{$prefix}btn-line-height);\n  color: var(--#{$prefix}btn-color);\n  text-align: center;\n  text-decoration: if(not sass($link-decoration == none): none);\n  white-space: $btn-white-space;\n  vertical-align: middle;\n  // stylelint-disable-next-line scss/at-function-named-arguments\n  cursor: if(sass($enable-button-pointers): pointer);\n  user-select: none;\n  border: var(--#{$prefix}btn-border-width) solid var(--#{$prefix}btn-border-color);\n  @include border-radius(var(--#{$prefix}btn-border-radius));\n  @include gradient-bg(var(--#{$prefix}btn-bg));\n  @include box-shadow(var(--#{$prefix}btn-box-shadow));\n  @include transition($btn-transition);\n\n  &:hover {\n    color: var(--#{$prefix}btn-hover-color);\n    // stylelint-disable-next-line scss/at-function-named-arguments\n    text-decoration: if(sass($link-hover-decoration == underline): none);\n    background-color: var(--#{$prefix}btn-hover-bg);\n    border-color: var(--#{$prefix}btn-hover-border-color);\n  }\n\n  .btn-check + &:hover {\n    // override for the checkbox/radio buttons\n    color: var(--#{$prefix}btn-color);\n    background-color: var(--#{$prefix}btn-bg);\n    border-color: var(--#{$prefix}btn-border-color);\n  }\n\n  &:focus-visible {\n    color: var(--#{$prefix}btn-hover-color);\n    @include gradient-bg(var(--#{$prefix}btn-hover-bg));\n    border-color: var(--#{$prefix}btn-hover-border-color);\n    outline: 0;\n    // Avoid using mixin so we can pass custom focus shadow properly\n    @if $enable-shadows {\n      box-shadow: var(--#{$prefix}btn-box-shadow), var(--#{$prefix}btn-focus-box-shadow);\n    } @else {\n      box-shadow: var(--#{$prefix}btn-focus-box-shadow);\n    }\n  }\n\n  .btn-check:focus-visible + & {\n    border-color: var(--#{$prefix}btn-hover-border-color);\n    outline: 0;\n    // Avoid using mixin so we can pass custom focus shadow properly\n    @if $enable-shadows {\n      box-shadow: var(--#{$prefix}btn-box-shadow), var(--#{$prefix}btn-focus-box-shadow);\n    } @else {\n      box-shadow: var(--#{$prefix}btn-focus-box-shadow);\n    }\n  }\n\n  .btn-check:checked + &,\n  :not(.btn-check) + &:active,\n  &:first-child:active,\n  &.active,\n  &.show {\n    color: var(--#{$prefix}btn-active-color);\n    background-color: var(--#{$prefix}btn-active-bg);\n    // Remove CSS gradients if they're enabled\n    // stylelint-disable-next-line scss/at-function-named-arguments\n    background-image: if(sass($enable-gradients): none);\n    border-color: var(--#{$prefix}btn-active-border-color);\n    @include box-shadow(var(--#{$prefix}btn-active-shadow));\n\n    &:focus-visible {\n      // Avoid using mixin so we can pass custom focus shadow properly\n      @if $enable-shadows {\n        box-shadow: var(--#{$prefix}btn-active-shadow), var(--#{$prefix}btn-focus-box-shadow);\n      } @else {\n        box-shadow: var(--#{$prefix}btn-focus-box-shadow);\n      }\n    }\n  }\n\n  .btn-check:checked:focus-visible + & {\n    // Avoid using mixin so we can pass custom focus shadow properly\n    @if $enable-shadows {\n      box-shadow: var(--#{$prefix}btn-active-shadow), var(--#{$prefix}btn-focus-box-shadow);\n    } @else {\n      box-shadow: var(--#{$prefix}btn-focus-box-shadow);\n    }\n  }\n\n  &:disabled,\n  &.disabled,\n  fieldset:disabled & {\n    color: var(--#{$prefix}btn-disabled-color);\n    pointer-events: none;\n    background-color: var(--#{$prefix}btn-disabled-bg);\n    // stylelint-disable-next-line scss/at-function-named-arguments\n    background-image: if(sass($enable-gradients): none);\n    border-color: var(--#{$prefix}btn-disabled-border-color);\n    opacity: var(--#{$prefix}btn-disabled-opacity);\n    @include box-shadow(none);\n  }\n}\n\n\n//\n// Alternate buttons\n//\n\n.btn-ghost {\n  // scss-docs-start btn-ghost-css-vars\n  --#{$prefix}btn-color: #{$btn-ghost-color};\n  --#{$prefix}btn-border-color: #{transparent};\n  --#{$prefix}btn-active-color: #{$btn-ghost-active-color};\n  --#{$prefix}btn-active-bg: #{$btn-ghost-active-bg};\n  --#{$prefix}btn-active-border-color: #{$btn-ghost-active-bg};\n  --#{$prefix}btn-disabled-color: #{$btn-ghost-disabled-color};\n  --#{$prefix}btn-disabled-border-color: #{transparent};\n  --#{$prefix}btn-hover-color: #{$btn-ghost-hover-color};\n  --#{$prefix}btn-hover-bg: #{$btn-ghost-hover-bg};\n  --#{$prefix}btn-hover-border-color: #{$btn-ghost-hover-bg};\n  --#{$prefix}btn-focus-box-shadow: 0 0 0 #{$btn-focus-width} rgba(#{$btn-outline-focus-shadow-rgb}, .5);\n  // scss-docs-end btn-ghost-css-vars\n}\n\n.btn-outline {\n  // scss-docs-start btn-outline-css-vars\n  --#{$prefix}btn-color: #{$btn-outline-color};\n  --#{$prefix}btn-border-color: #{$btn-outline-border-color};\n  --#{$prefix}btn-active-color: #{$btn-outline-active-color};\n  --#{$prefix}btn-active-bg: #{$btn-outline-active-bg};\n  --#{$prefix}btn-active-border-color: #{$btn-outline-active-border-color};\n  --#{$prefix}btn-disabled-color: #{$btn-outline-disabled-color};\n  --#{$prefix}btn-disabled-border-color: #{$btn-outline-disabled-border-color};\n  --#{$prefix}btn-hover-color: #{$btn-outline-hover-color};\n  --#{$prefix}btn-hover-bg: #{$btn-outline-hover-bg};\n  --#{$prefix}btn-hover-border-color: #{$btn-outline-hover-border-color};\n  --#{$prefix}btn-focus-box-shadow: 0 0 0 #{$btn-focus-width} rgba(#{$btn-ghost-focus-shadow-rgb}, .5);\n  // scss-docs-end btn-outline-css-vars\n}\n\n.btn-transparent {\n  --#{$prefix}btn-active-border-color: transparent;\n  --#{$prefix}btn-disabled-border-color: transparent;\n  --#{$prefix}btn-hover-border-color: transparent;\n}\n\n// scss-docs-start btn-variant-loops\n@each $color, $value in $theme-colors {\n  .btn-#{$color} {\n    @if $color == \"light\" {\n      @include button-variant(\n        $value,\n        $value,\n        $hover-background: shade-color($value, $btn-hover-bg-shade-amount),\n        $hover-border: shade-color($value, $btn-hover-border-shade-amount),\n        $active-background: shade-color($value, $btn-active-bg-shade-amount),\n        $active-border: shade-color($value, $btn-active-border-shade-amount)\n      );\n    } @else if $color == \"dark\" {\n      @include button-variant(\n        $value,\n        $value,\n        $hover-background: tint-color($value, $btn-hover-bg-tint-amount),\n        $hover-border: tint-color($value, $btn-hover-border-tint-amount),\n        $active-background: tint-color($value, $btn-active-bg-tint-amount),\n        $active-border: tint-color($value, $btn-active-border-tint-amount)\n      );\n    } @else {\n      @include button-variant($value, $value);\n    }\n  }\n}\n\n@each $color, $value in $theme-colors {\n  .btn-outline-#{$color} {\n    @include button-outline-variant($value);\n  }\n}\n\n@each $color, $value in $theme-colors {\n  .btn-ghost-#{$color} {\n    @include button-ghost-variant($value);\n  }\n}\n// scss-docs-end btn-variant-loops\n\n\n//\n// Link buttons\n//\n\n// Make a button look and behave like a link\n.btn-link {\n  --#{$prefix}btn-font-weight: #{$font-weight-normal};\n  --#{$prefix}btn-color: #{$btn-link-color};\n  --#{$prefix}btn-bg: transparent;\n  --#{$prefix}btn-border-color: transparent;\n  --#{$prefix}btn-hover-color: #{$btn-link-hover-color};\n  --#{$prefix}btn-hover-border-color: transparent;\n  --#{$prefix}btn-active-border-color: transparent;\n  --#{$prefix}btn-disabled-color: #{$btn-link-disabled-color};\n  --#{$prefix}btn-disabled-border-color: transparent;\n  --#{$prefix}btn-box-shadow: none;\n  --#{$prefix}btn-focus-shadow-rgb: #{$btn-link-focus-shadow-rgb};\n\n  text-decoration: $link-decoration;\n  @if $enable-gradients {\n    background-image: none;\n  }\n\n  &:hover,\n  &:focus-visible {\n    text-decoration: $link-hover-decoration;\n  }\n\n  &:focus-visible {\n    color: var(--#{$prefix}btn-color);\n  }\n\n  // No need for an active state here\n}\n\n\n//\n// Button Sizes\n//\n\n.btn-lg {\n  @include button-size($btn-padding-y-lg, $btn-padding-x-lg, $btn-font-size-lg, $btn-border-radius-lg);\n}\n\n.btn-sm {\n  @include button-size($btn-padding-y-sm, $btn-padding-x-sm, $btn-font-size-sm, $btn-border-radius-sm);\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark) {\n    @each $color, $value in $theme-colors-dark {\n      .btn-#{$color} {\n        @include button-variant($value, $value);\n      }\n    }\n\n    @each $color, $value in $theme-colors-dark {\n      .btn-outline-#{$color} {\n        @include button-outline-variant($value);\n      }\n    }\n\n    @each $color, $value in $theme-colors-dark {\n      .btn-ghost-#{$color} {\n        @include button-ghost-variant($value);\n      }\n    }\n  }\n}\n","@use \"sass:color\";\n@use \"../functions/color\" as *;\n@use \"../functions/color-contrast\" as *;\n@use \"../functions/to-rgb\" as *;\n@use \"../vendor/rfs\" as *;\n@use \"../variables\" as *;\n\n// Button variants\n//\n// Easily pump out default styles, as well as :hover, :focus, :active,\n// and disabled options for all buttons\n\n// scss-docs-start btn-variant-mixin\n@mixin button-variant(\n  $background,\n  $border,\n  $color: color-contrast($background),\n  $hover-background: if(sass($color == $color-contrast-light): shade-color($background, $btn-hover-bg-shade-amount); else: tint-color($background, $btn-hover-bg-tint-amount)),\n  $hover-border: if(sass($color == $color-contrast-light): shade-color($border, $btn-hover-border-shade-amount); else: tint-color($border, $btn-hover-border-tint-amount)),\n  $hover-color: color-contrast($hover-background),\n  $active-background: if(sass($color == $color-contrast-light): shade-color($background, $btn-active-bg-shade-amount); else: tint-color($background, $btn-active-bg-tint-amount)),\n  $active-border: if(sass($color == $color-contrast-light): shade-color($border, $btn-active-border-shade-amount); else: tint-color($border, $btn-active-border-tint-amount)),\n  $active-color: color-contrast($active-background),\n  $disabled-background: $background,\n  $disabled-border: $border,\n  $disabled-color: color-contrast($disabled-background)\n) {\n  --#{$prefix}btn-color: #{$color};\n  --#{$prefix}btn-bg: #{$background};\n  --#{$prefix}btn-border-color: #{$border};\n  --#{$prefix}btn-hover-color: #{$hover-color};\n  --#{$prefix}btn-hover-bg: #{$hover-background};\n  --#{$prefix}btn-hover-border-color: #{$hover-border};\n  --#{$prefix}btn-focus-shadow-rgb: #{to-rgb(color.mix($color, $border, 15%))};\n  --#{$prefix}btn-active-color: #{$active-color};\n  --#{$prefix}btn-active-bg: #{$active-background};\n  --#{$prefix}btn-active-border-color: #{$active-border};\n  --#{$prefix}btn-active-shadow: #{$btn-active-box-shadow};\n  --#{$prefix}btn-disabled-color: #{$disabled-color};\n  --#{$prefix}btn-disabled-bg: #{$disabled-background};\n  --#{$prefix}btn-disabled-border-color: #{$disabled-border};\n}\n// scss-docs-end btn-variant-mixin\n\n// scss-docs-start btn-outline-variant-mixin\n@mixin button-outline-variant(\n  $color,\n  $color-hover: color-contrast($color),\n  $active-background: $color,\n  $active-border: $color,\n  $active-color: color-contrast($active-background)\n) {\n  --#{$prefix}btn-color: #{$color};\n  --#{$prefix}btn-border-color: #{$color};\n  --#{$prefix}btn-hover-color: #{$color-hover};\n  --#{$prefix}btn-hover-bg: #{$active-background};\n  --#{$prefix}btn-hover-border-color: #{$active-border};\n  --#{$prefix}btn-focus-shadow-rgb: #{to-rgb($color)};\n  --#{$prefix}btn-active-color: #{$active-color};\n  --#{$prefix}btn-active-bg: #{$active-background};\n  --#{$prefix}btn-active-border-color: #{$active-border};\n  --#{$prefix}btn-active-shadow: #{$btn-active-box-shadow};\n  --#{$prefix}btn-disabled-color: #{$color};\n  --#{$prefix}btn-disabled-bg: transparent;\n  --#{$prefix}btn-disabled-border-color: #{$color};\n  --#{$prefix}gradient: none;\n}\n// scss-docs-end btn-outline-variant-mixin\n\n// scss-docs-start btn-ghost-variant-mixin\n@mixin button-ghost-variant(\n  $color,\n  $color-hover: color-contrast($color),\n  $hover-background: $color,\n  $hover-border: $color,\n  $hover-color: color-contrast($color),\n  $active-background: $color,\n  $active-border: $color,\n  $active-color: color-contrast($color)\n) {\n  --#{$prefix}btn-color: #{$color};\n  --#{$prefix}btn-border-color: transparent;\n  --#{$prefix}btn-hover-bg: #{$hover-background};\n  --#{$prefix}btn-hover-border-color: #{$hover-border};\n  --#{$prefix}btn-hover-color: #{$color-hover};\n  --#{$prefix}btn-active-bg: #{$active-background};\n  --#{$prefix}btn-active-border-color: #{$active-border};\n  --#{$prefix}btn-active-color: #{$active-color};\n  --#{$prefix}btn-disabled-color: #{$color};\n  --#{$prefix}btn-disabled-bg: transparent;\n  --#{$prefix}btn-disabled-border-color: transparent;\n}\n// scss-docs-end btn-ghost-variant-mixin\n\n// Button sizes\n// scss-docs-start btn-size-mixin\n@mixin button-size($padding-y, $padding-x, $font-size, $border-radius) {\n  --#{$prefix}btn-padding-y: #{$padding-y};\n  --#{$prefix}btn-padding-x: #{$padding-x};\n  @include rfs($font-size, --#{$prefix}btn-font-size);\n  --#{$prefix}btn-border-radius: #{$border-radius};\n}\n// scss-docs-end btn-size-mixin\n","@use \"mixins/transition\" as *;\n@use \"variables\" as *;\n\n.fade {\n  @include transition($transition-fade);\n\n  &:not(.show) {\n    opacity: 0;\n  }\n}\n\n// scss-docs-start collapse-classes\n.collapse {\n  &:not(.show) {\n    display: none;\n  }\n}\n\n.collapsing {\n  height: 0;\n  overflow: hidden;\n  @include transition($transition-collapse);\n\n  &.collapse-horizontal {\n    width: 0;\n    height: auto;\n    @include transition($transition-collapse-width);\n  }\n}\n// scss-docs-end collapse-classes\n","@use \"sass:map\";\n@use \"mixins/border-radius\" as *;\n@use \"mixins/box-shadow\" as *;\n@use \"mixins/breakpoints\" as *;\n@use \"mixins/caret\" as *;\n@use \"mixins/gradients\" as *;\n@use \"vendor/rfs\" as *;\n@use \"variables\" as *;\n\n// The dropdown wrapper (`<div>`)\n.dropup,\n.dropend,\n.dropdown,\n.dropstart,\n.dropup-center,\n.dropdown-center {\n  position: relative;\n}\n\n.dropdown-toggle {\n  white-space: nowrap;\n\n  // Generate the caret automatically\n  @include caret();\n}\n\n// The dropdown menu\n.dropdown-menu {\n  // scss-docs-start dropdown-css-vars\n  --#{$prefix}dropdown-zindex: #{$zindex-dropdown};\n  --#{$prefix}dropdown-min-width: #{$dropdown-min-width};\n  --#{$prefix}dropdown-padding-x: #{$dropdown-padding-x};\n  --#{$prefix}dropdown-padding-y: #{$dropdown-padding-y};\n  --#{$prefix}dropdown-spacer: #{$dropdown-spacer};\n  @include rfs($dropdown-font-size, --#{$prefix}dropdown-font-size);\n  --#{$prefix}dropdown-color: #{$dropdown-color};\n  --#{$prefix}dropdown-bg: #{$dropdown-bg};\n  --#{$prefix}dropdown-border-color: #{$dropdown-border-color};\n  --#{$prefix}dropdown-border-radius: #{$dropdown-border-radius};\n  --#{$prefix}dropdown-border-width: #{$dropdown-border-width};\n  --#{$prefix}dropdown-inner-border-radius: #{$dropdown-inner-border-radius};\n  --#{$prefix}dropdown-divider-bg: #{$dropdown-divider-bg};\n  --#{$prefix}dropdown-divider-margin-y: #{$dropdown-divider-margin-y};\n  --#{$prefix}dropdown-box-shadow: #{$dropdown-box-shadow};\n  --#{$prefix}dropdown-link-color: #{$dropdown-link-color};\n  --#{$prefix}dropdown-link-hover-color: #{$dropdown-link-hover-color};\n  --#{$prefix}dropdown-link-hover-bg: #{$dropdown-link-hover-bg};\n  --#{$prefix}dropdown-link-active-color: #{$dropdown-link-active-color};\n  --#{$prefix}dropdown-link-active-bg: #{$dropdown-link-active-bg};\n  --#{$prefix}dropdown-link-disabled-color: #{$dropdown-link-disabled-color};\n  --#{$prefix}dropdown-item-padding-x: #{$dropdown-item-padding-x};\n  --#{$prefix}dropdown-item-padding-y: #{$dropdown-item-padding-y};\n  --#{$prefix}dropdown-header-color: #{$dropdown-header-color};\n  --#{$prefix}dropdown-header-padding-x: #{$dropdown-header-padding-x};\n  --#{$prefix}dropdown-header-padding-y: #{$dropdown-header-padding-y};\n  // scss-docs-end dropdown-css-vars\n\n  position: absolute;\n  z-index: var(--#{$prefix}dropdown-zindex);\n  display: none; // none by default, but block on \"open\" of the menu\n  min-width: var(--#{$prefix}dropdown-min-width);\n  padding: var(--#{$prefix}dropdown-padding-y) var(--#{$prefix}dropdown-padding-x);\n  margin: 0; // Override default margin of ul\n  @include font-size(var(--#{$prefix}dropdown-font-size));\n  color: var(--#{$prefix}dropdown-color);\n  text-align: start; // Ensures proper alignment if parent has it changed (e.g., modal footer)\n  list-style: none;\n  background-color: var(--#{$prefix}dropdown-bg);\n  background-clip: padding-box;\n  border: var(--#{$prefix}dropdown-border-width) solid var(--#{$prefix}dropdown-border-color);\n  @include border-radius(var(--#{$prefix}dropdown-border-radius));\n  @include box-shadow(var(--#{$prefix}dropdown-box-shadow));\n\n  &[data#{$data-infix}popper] {\n    inset-inline-start: 0;\n    top: 100%;\n    margin-top: var(--#{$prefix}dropdown-spacer);\n  }\n\n  @if $dropdown-padding-y == 0 {\n    > .dropdown-item:first-child,\n    > li:first-child .dropdown-item {\n      @include border-top-radius(var(--#{$prefix}dropdown-inner-border-radius));\n    }\n\n    > .dropdown-item:last-child,\n    > li:last-child .dropdown-item {\n      @include border-bottom-radius(var(--#{$prefix}dropdown-inner-border-radius));\n    }\n  }\n}\n\n// scss-docs-start responsive-breakpoints\n// We deliberately hardcode the `cui-` prefix because we check\n// this custom property in JS to determine Popper's positioning\n\n@each $breakpoint in map.keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .dropdown-menu#{$infix}-start {\n      --#{$prefix}position: start;\n\n      &[data#{$data-infix}popper] {\n        inset-inline-start: 0;\n        inset-inline-end: auto;\n      }\n    }\n\n    .dropdown-menu#{$infix}-end {\n      --#{$prefix}position: end;\n\n      &[data#{$data-infix}popper] {\n        inset-inline-start: auto;\n        inset-inline-end: 0;\n      }\n    }\n  }\n}\n// scss-docs-end responsive-breakpoints\n\n// Allow for dropdowns to go bottom up (aka, dropup-menu)\n// Just add .dropup after the standard .dropdown class and you're set.\n.dropup {\n  .dropdown-menu[data#{$data-infix}popper] {\n    top: auto;\n    bottom: 100%;\n    margin-top: 0;\n    margin-bottom: var(--#{$prefix}dropdown-spacer);\n  }\n\n  .dropdown-toggle {\n    @include caret(up);\n  }\n}\n\n.dropend {\n  .dropdown-menu[data#{$data-infix}popper] {\n    inset-inline-start: 100%;\n    inset-inline-end: auto;\n    top: 0;\n    margin-inline-start: var(--#{$prefix}dropdown-spacer);\n    margin-top: 0;\n  }\n\n  .dropdown-toggle {\n    @include caret(end);\n    &::after {\n      vertical-align: 0;\n    }\n  }\n}\n\n.dropstart {\n  .dropdown-menu[data#{$data-infix}popper] {\n    inset-inline-start: auto;\n    inset-inline-end: 100%;\n    top: 0;\n    margin-inline-end: var(--#{$prefix}dropdown-spacer);\n    margin-top: 0;\n  }\n\n  .dropdown-toggle {\n    @include caret(start);\n    &::before {\n      vertical-align: 0;\n    }\n  }\n}\n\n\n// Dividers (basically an `<hr>`) within the dropdown\n.dropdown-divider {\n  height: 0;\n  margin: var(--#{$prefix}dropdown-divider-margin-y) 0;\n  overflow: hidden;\n  border-top: 1px solid var(--#{$prefix}dropdown-divider-bg);\n  opacity: 1; // Revisit in v6 to de-dupe styles that conflict with <hr> element\n}\n\n// Links, buttons, and more within the dropdown menu\n//\n// `<button>`-specific styles are denoted with `// For <button>s`\n.dropdown-item {\n  display: block;\n  width: 100%; // For `<button>`s\n  padding: var(--#{$prefix}dropdown-item-padding-y) var(--#{$prefix}dropdown-item-padding-x);\n  clear: both;\n  font-weight: $font-weight-normal;\n  color: var(--#{$prefix}dropdown-link-color);\n  text-align: inherit; // For `<button>`s\n  text-decoration: if(not sass($link-decoration == none): none);\n  white-space: nowrap; // prevent links from randomly breaking onto new lines\n  background-color: transparent; // For `<button>`s\n  border: 0; // For `<button>`s\n  @include border-radius(var(--#{$prefix}dropdown-item-border-radius, 0));\n\n  &:hover,\n  &:focus {\n    color: var(--#{$prefix}dropdown-link-hover-color);\n    // stylelint-disable-next-line scss/at-function-named-arguments\n    text-decoration: if(sass($link-hover-decoration == underline): none);\n    @include gradient-bg(var(--#{$prefix}dropdown-link-hover-bg));\n  }\n\n  &.active,\n  &:active {\n    color: var(--#{$prefix}dropdown-link-active-color);\n    text-decoration: none;\n    @include gradient-bg(var(--#{$prefix}dropdown-link-active-bg));\n  }\n\n  &.disabled,\n  &:disabled {\n    color: var(--#{$prefix}dropdown-link-disabled-color);\n    pointer-events: none;\n    background-color: transparent;\n    // Remove CSS gradients if they're enabled\n    // stylelint-disable-next-line scss/at-function-named-arguments\n    background-image: if(sass($enable-gradients): none);\n  }\n}\n\n.dropdown-menu.show {\n  display: block;\n}\n\n// Dropdown section headers\n.dropdown-header {\n  display: block;\n  padding: var(--#{$prefix}dropdown-header-padding-y) var(--#{$prefix}dropdown-header-padding-x);\n  margin-bottom: 0; // for use with heading elements\n  @include font-size($font-size-sm);\n  color: var(--#{$prefix}dropdown-header-color);\n  white-space: nowrap; // as with > li > a\n}\n\n// Dropdown text\n.dropdown-item-text {\n  display: block;\n  padding: var(--#{$prefix}dropdown-item-padding-y) var(--#{$prefix}dropdown-item-padding-x);\n  color: var(--#{$prefix}dropdown-link-color);\n}\n\n// Dark dropdowns\n.dropdown-menu-dark {\n  // scss-docs-start dropdown-dark-css-vars\n  --#{$prefix}dropdown-color: #{$dropdown-dark-color};\n  --#{$prefix}dropdown-bg: #{$dropdown-dark-bg};\n  --#{$prefix}dropdown-border-color: #{$dropdown-dark-border-color};\n  --#{$prefix}dropdown-box-shadow: #{$dropdown-dark-box-shadow};\n  --#{$prefix}dropdown-link-color: #{$dropdown-dark-link-color};\n  --#{$prefix}dropdown-link-hover-color: #{$dropdown-dark-link-hover-color};\n  --#{$prefix}dropdown-divider-bg: #{$dropdown-dark-divider-bg};\n  --#{$prefix}dropdown-link-hover-bg: #{$dropdown-dark-link-hover-bg};\n  --#{$prefix}dropdown-link-active-color: #{$dropdown-dark-link-active-color};\n  --#{$prefix}dropdown-link-active-bg: #{$dropdown-dark-link-active-bg};\n  --#{$prefix}dropdown-link-disabled-color: #{$dropdown-dark-link-disabled-color};\n  --#{$prefix}dropdown-header-color: #{$dropdown-dark-header-color};\n  // scss-docs-end dropdown-dark-css-vars\n}\n","@use \"../variables\" as *;\n\n// scss-docs-start caret-mixins\n@mixin caret-down($width: $caret-width) {\n  border-top: $width solid;\n  border-right: $width solid transparent;\n  border-bottom: 0;\n  border-left: $width solid transparent;\n}\n\n@mixin caret-up($width: $caret-width) {\n  border-top: 0;\n  border-right: $width solid transparent;\n  border-bottom: $width solid;\n  border-left: $width solid transparent;\n}\n\n@mixin caret-end($width: $caret-width) {\n  border-top: $width solid transparent;\n  border-right: 0;\n  border-bottom: $width solid transparent;\n  border-left: $width solid;\n}\n\n@mixin caret-start($width: $caret-width) {\n  border-top: $width solid transparent;\n  border-right: $width solid;\n  border-bottom: $width solid transparent;\n}\n\n@mixin caret(\n  $direction: down,\n  $width: $caret-width,\n  $spacing: $caret-spacing,\n  $vertical-align: $caret-vertical-align\n) {\n  @if $enable-caret {\n    &::after {\n      display: inline-block;\n      margin-inline-start: $spacing;\n      vertical-align: $vertical-align;\n      content: \"\";\n      @if $direction == down {\n        @include caret-down($width);\n      } @else if $direction == up {\n        @include caret-up($width);\n      } @else if $direction == end {\n        @include caret-end($width);\n      }\n    }\n\n    @if $direction == start {\n      &::after {\n        display: none;\n      }\n\n      &::before {\n        display: inline-block;\n        margin-inline-end: $spacing;\n        vertical-align: $vertical-align;\n        content: \"\";\n        @include caret-start($width);\n      }\n    }\n\n    &:empty::after {\n      margin-inline-start: 0;\n    }\n  }\n}\n// scss-docs-end caret-mixins\n","@use \"mixins/border-radius\" as *;\n@use \"mixins/box-shadow\" as *;\n@use \"buttons\" as *;\n@use \"variables\" as *;\n\n// Make the div behave like a button\n.btn-group,\n.btn-group-vertical {\n  position: relative;\n  display: inline-flex;\n  vertical-align: middle; // match .btn alignment given font-size hack above\n\n  > .btn {\n    position: relative;\n    flex: 1 1 auto;\n  }\n\n  // Bring the hover, focused, and \"active\" buttons to the front to overlay\n  // the borders properly\n  > .btn-check:checked + .btn,\n  > .btn-check:focus + .btn,\n  > .btn:hover,\n  > .btn:focus,\n  > .btn:active,\n  > .btn.active {\n    z-index: 1;\n  }\n}\n\n// Optional: Group multiple button groups together for a toolbar\n.btn-toolbar {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-start;\n\n  .input-group {\n    width: auto;\n  }\n}\n\n.btn-group {\n  @include border-radius($btn-border-radius);\n\n  // Prevent double borders when buttons are next to each other\n  > :not(.btn-check:first-child) + .btn,\n  > .btn-group:not(:first-child) {\n    margin-inline-start: calc(-1 * #{$btn-border-width}); // stylelint-disable-line function-disallowed-list\n  }\n\n  // Reset rounded corners\n  > .btn:not(:last-child):not(.dropdown-toggle),\n  > .btn.dropdown-toggle-split:first-child,\n  > .btn-group:not(:last-child) > .btn {\n    @include border-end-radius(0);\n  }\n\n  // The left radius should be 0 if the button is:\n  // - the \"third or more\" child\n  // - the second child and the previous element isn't `.btn-check` (making it the first child visually)\n  // - part of a btn-group which isn't the first child\n  > .btn:nth-child(n + 3),\n  > :not(.btn-check) + .btn,\n  > .btn-group:not(:first-child) > .btn {\n    @include border-start-radius(0);\n  }\n}\n\n// Sizing\n//\n// Remix the default button sizing classes into new ones for easier manipulation.\n\n.btn-group-sm > .btn { @extend .btn-sm; }\n.btn-group-lg > .btn { @extend .btn-lg; }\n\n\n//\n// Split button dropdowns\n//\n\n.dropdown-toggle-split {\n  padding-right: $btn-padding-x * .75;\n  padding-left: $btn-padding-x * .75;\n\n  &::after,\n  .dropup &::after,\n  .dropend &::after {\n    margin-inline-start: 0;\n  }\n\n  .dropstart &::before {\n    margin-inline-end: 0;\n  }\n}\n\n.btn-sm + .dropdown-toggle-split {\n  padding-right: $btn-padding-x-sm * .75;\n  padding-left: $btn-padding-x-sm * .75;\n}\n\n.btn-lg + .dropdown-toggle-split {\n  padding-right: $btn-padding-x-lg * .75;\n  padding-left: $btn-padding-x-lg * .75;\n}\n\n\n// The clickable button for toggling the menu\n// Set the same inset shadow as the :active state\n.btn-group.show .dropdown-toggle {\n  @include box-shadow($btn-active-box-shadow);\n\n  // Show no shadow for `.btn-link` since it has no other button styles.\n  &.btn-link {\n    @include box-shadow(none);\n  }\n}\n\n\n//\n// Vertical button groups\n//\n\n.btn-group-vertical {\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: center;\n\n  > .btn,\n  > .btn-group {\n    width: 100%;\n  }\n\n  > .btn:not(:first-child),\n  > .btn-group:not(:first-child) {\n    margin-top: calc(-1 * #{$btn-border-width}); // stylelint-disable-line function-disallowed-list\n  }\n\n  // Reset rounded corners\n  > .btn:not(:last-child):not(.dropdown-toggle),\n  > .btn-group:not(:last-child) > .btn {\n    @include border-bottom-radius(0);\n  }\n\n  // The top radius should be 0 if the button is:\n  // - the \"third or more\" child\n  // - the second child and the previous element isn't `.btn-check` (making it the first child visually)\n  // - part of a btn-group which isn't the first child\n  > .btn:nth-child(n + 3),\n  > :not(.btn-check) + .btn,\n  > .btn-group:not(:first-child) > .btn {\n    @include border-top-radius(0);\n  }\n}\n","@use \"mixins/border-radius\" as *;\n@use \"mixins/gradients\" as *;\n@use \"mixins/transition\" as *;\n@use \"vendor/rfs\" as *;\n@use \"variables\" as *;\n\n// Base class\n//\n// Kickstart any navigation component with a set of style resets. Works with\n// `<nav>`s, `<ul>`s or `<ol>`s.\n\n.nav {\n  // scss-docs-start nav-css-vars\n  --#{$prefix}nav-link-padding-x: #{$nav-link-padding-x};\n  --#{$prefix}nav-link-padding-y: #{$nav-link-padding-y};\n  @include rfs($nav-link-font-size, --#{$prefix}nav-link-font-size);\n  --#{$prefix}nav-link-font-weight: #{$nav-link-font-weight};\n  --#{$prefix}nav-link-color: #{$nav-link-color};\n  --#{$prefix}nav-link-hover-color: #{$nav-link-hover-color};\n  --#{$prefix}nav-link-disabled-color: #{$nav-link-disabled-color};\n  // scss-docs-end nav-css-vars\n\n  display: flex;\n  flex-wrap: wrap;\n  padding-inline-start: 0;\n  margin-bottom: 0;\n  list-style: none;\n}\n\n.nav-link {\n  display: block;\n  padding: var(--#{$prefix}nav-link-padding-y) var(--#{$prefix}nav-link-padding-x);\n  @include font-size(var(--#{$prefix}nav-link-font-size));\n  font-weight: var(--#{$prefix}nav-link-font-weight);\n  color: var(--#{$prefix}nav-link-color);\n  text-decoration: if(not sass($link-decoration == none): none);\n  background: none;\n  border: 0;\n  @include transition($nav-link-transition);\n\n  &:hover,\n  &:focus {\n    color: var(--#{$prefix}nav-link-hover-color);\n    // stylelint-disable-next-line scss/at-function-named-arguments\n    text-decoration: if(sass($link-hover-decoration == underline): none);\n  }\n\n  &:focus-visible {\n    outline: 0;\n    box-shadow: $nav-link-focus-box-shadow;\n  }\n\n  // Disabled state lightens text\n  &.disabled,\n  &:disabled {\n    color: var(--#{$prefix}nav-link-disabled-color);\n    pointer-events: none;\n    cursor: default;\n  }\n}\n\n//\n// Tabs\n//\n\n.nav-tabs {\n  // scss-docs-start nav-tabs-css-vars\n  --#{$prefix}nav-tabs-border-width: #{$nav-tabs-border-width};\n  --#{$prefix}nav-tabs-border-color: #{$nav-tabs-border-color};\n  --#{$prefix}nav-tabs-border-radius: #{$nav-tabs-border-radius};\n  --#{$prefix}nav-tabs-link-hover-border-color: #{$nav-tabs-link-hover-border-color};\n  --#{$prefix}nav-tabs-link-active-color: #{$nav-tabs-link-active-color};\n  --#{$prefix}nav-tabs-link-active-bg: #{$nav-tabs-link-active-bg};\n  --#{$prefix}nav-tabs-link-active-border-color: #{$nav-tabs-link-active-border-color};\n  // scss-docs-end nav-tabs-css-vars\n\n  border-bottom: var(--#{$prefix}nav-tabs-border-width) solid var(--#{$prefix}nav-tabs-border-color);\n\n  .nav-link {\n    margin-bottom: calc(-1 * var(--#{$prefix}nav-tabs-border-width)); // stylelint-disable-line function-disallowed-list\n    border: var(--#{$prefix}nav-tabs-border-width) solid transparent;\n    @include border-top-radius(var(--#{$prefix}nav-tabs-border-radius));\n\n    &:hover,\n    &:focus {\n      // Prevents active .nav-link tab overlapping focus outline of previous/next .nav-link\n      isolation: isolate;\n      border-color: var(--#{$prefix}nav-tabs-link-hover-border-color);\n    }\n  }\n\n  .nav-link.active,\n  .nav-item.show .nav-link {\n    color: var(--#{$prefix}nav-tabs-link-active-color);\n    background-color: var(--#{$prefix}nav-tabs-link-active-bg);\n    border-color: var(--#{$prefix}nav-tabs-link-active-border-color);\n  }\n\n  .dropdown-menu {\n    // Make dropdown border overlap tab border\n    margin-top: calc(-1 * var(--#{$prefix}nav-tabs-border-width)); // stylelint-disable-line function-disallowed-list\n    // Remove the top rounded corners here since there is a hard edge above the menu\n    @include border-top-radius(0);\n  }\n}\n\n\n//\n// Pills\n//\n\n.nav-pills {\n  // scss-docs-start nav-pills-css-vars\n  --#{$prefix}nav-pills-border-radius: #{$nav-pills-border-radius};\n  --#{$prefix}nav-pills-link-active-color: #{$nav-pills-link-active-color};\n  --#{$prefix}nav-pills-link-active-bg: #{$nav-pills-link-active-bg};\n  // scss-docs-end nav-pills-css-vars\n\n  .nav-link {\n    @include border-radius(var(--#{$prefix}nav-pills-border-radius));\n  }\n\n  .nav-link.active,\n  .show > .nav-link {\n    color: var(--#{$prefix}nav-pills-link-active-color);\n    @include gradient-bg(var(--#{$prefix}nav-pills-link-active-bg));\n  }\n}\n\n\n//\n// Underline\n//\n\n.nav-underline {\n  // scss-docs-start nav-underline-css-vars\n  --#{$prefix}nav-underline-gap: #{$nav-underline-gap};\n  --#{$prefix}nav-underline-border-width: #{$nav-underline-border-width};\n  --#{$prefix}nav-underline-link-active-color: #{$nav-underline-link-active-color};\n  // scss-docs-end nav-underline-css-vars\n\n  gap: var(--#{$prefix}nav-underline-gap);\n\n  .nav-link {\n    padding-right: 0;\n    padding-left: 0;\n    border-bottom: var(--#{$prefix}nav-underline-border-width) solid transparent;\n\n    &:hover,\n    &:focus {\n      border-bottom-color: currentcolor;\n    }\n  }\n\n  .nav-link.active,\n  .show > .nav-link {\n    font-weight: $font-weight-bold;\n    color: var(--#{$prefix}nav-underline-link-active-color);\n    border-bottom-color: currentcolor;\n  }\n}\n\n\n//\n// Underline border\n//\n\n.nav-underline-border {\n  // scss-docs-start nav-underline-border-css-vars\n  --#{$prefix}nav-underline-border-gap: #{$nav-underline-border-gap};\n  --#{$prefix}nav-underline-border-border-color: #{$nav-underline-border-border-color};\n  --#{$prefix}nav-underline-border-border-width: #{$nav-underline-border-border-width};\n  --#{$prefix}nav-underline-border-link-padding-x: #{$nav-underline-border-link-padding-x};\n  --#{$prefix}nav-underline-border-link-padding-y: #{$nav-underline-border-link-padding-y};\n  --#{$prefix}nav-underline-border-link-color: #{$nav-underline-border-link-color};\n  --#{$prefix}nav-underline-border-link-active-color: #{$nav-underline-border-link-active-color};\n  --#{$prefix}nav-underline-border-link-disabled-color: #{$nav-underline-border-link-disabled-color};\n  // scss-docs-end nav-underline-border-css-vars\n\n  --#{$prefix}nav-link-color: var(--#{$prefix}nav-underline-border-link-color);\n  --#{$prefix}nav-link-disabled-color: var(--#{$prefix}nav-underline-border-link-disabled-color);\n\n  gap: var(--#{$prefix}nav-underline-border-gap);\n  border-bottom: var(--#{$prefix}nav-underline-border-border-width) solid var(--#{$prefix}nav-underline-border-border-color);\n\n  .nav-link {\n    padding: var(--#{$prefix}nav-underline-border-link-padding-y) var(--#{$prefix}nav-underline-border-link-padding-x);\n    margin-bottom: calc(-1 * var(--#{$prefix}nav-underline-border-border-width)); // stylelint-disable-line function-disallowed-list\n    border-bottom: var(--#{$prefix}nav-underline-border-border-width) solid transparent;\n\n    &:hover,\n    &:focus {\n      border-bottom-color: currentcolor;\n    }\n  }\n\n  .nav-link.active,\n  .show > .nav-link {\n    font-weight: $font-weight-bold;\n    color: var(--#{$prefix}nav-underline-border-link-active-color);\n    border-bottom-color: currentcolor;\n  }\n}\n\n\n//\n// Enclosed\n//\n\n.nav-enclosed {\n  --#{$prefix}nav-enclosed-padding: #{$nav-enclosed-padding};\n  --#{$prefix}nav-enclosed-bg: #{$nav-enclosed-bg};\n  --#{$prefix}nav-enclosed-border-radius: #{$nav-enclosed-border-radius};\n  --#{$prefix}nav-enclosed-link-padding-x: #{$nav-enclosed-link-padding-x};\n  --#{$prefix}nav-enclosed-link-padding-y: #{$nav-enclosed-link-padding-y};\n  --#{$prefix}nav-enclosed-link-color: #{$nav-enclosed-link-color};\n  --#{$prefix}nav-enclosed-link-border-width: #{$nav-enclosed-link-border-width};\n  --#{$prefix}nav-enclosed-link-active-color: #{$nav-enclosed-link-active-color};\n  --#{$prefix}nav-enclosed-link-active-bg: #{$nav-enclosed-link-active-bg};\n  --#{$prefix}nav-enclosed-link-active-border-color: #{$nav-enclosed-link-active-border-color};\n  --#{$prefix}nav-enclosed-link-hover-box-shadow: #{$nav-enclosed-link-hover-box-shadow};\n  --#{$prefix}nav-enclosed-link-disabled-color: #{$nav-enclosed-link-disabled-color};\n\n  display: inline-flex;\n  padding: var(--#{$prefix}nav-enclosed-padding);\n  background-color: var(--#{$prefix}nav-enclosed-bg);\n  @include border-radius(var(--#{$prefix}nav-enclosed-border-radius));\n\n  .nav-link {\n    padding: calc(var(--#{$prefix}nav-enclosed-link-padding-y) - var(--#{$prefix}nav-enclosed-link-border-width)) calc(var(--#{$prefix}nav-enclosed-link-padding-x) - var(--#{$prefix}nav-enclosed-link-border-width)); // stylelint-disable-line function-disallowed-list\n    color: var(--#{$prefix}nav-enclosed-link-color);\n    border: var(--#{$prefix}nav-enclosed-link-border-width) solid transparent;\n    @include border-radius(calc(var(--#{$prefix}nav-enclosed-border-radius) - var(--#{$prefix}nav-enclosed-padding)));\n\n    &.disabled,\n    &:disabled {\n      color: var(--#{$prefix}nav-enclosed-link-disabled-color);\n    }\n  }\n\n  .nav-link.active,\n  .show > .nav-link {\n    color: var(--#{$prefix}nav-enclosed-link-active-color);\n    background-color: var(--#{$prefix}nav-enclosed-link-active-bg);\n    border: 1px solid var(--#{$prefix}nav-enclosed-link-active-border-color);\n\n    &:not(:focus-visible) {\n      box-shadow: var(--#{$prefix}nav-enclosed-link-hover-box-shadow);\n    }\n  }\n}\n\n// Enclosed pills\n\n.nav-enclosed-pills {\n  --#{$prefix}nav-enclosed-border-radius: #{$border-radius-pill};\n}\n\n\n//\n// Justified variants\n//\n\n.nav-fill {\n  > .nav-link,\n  .nav-item {\n    flex: 1 1 auto;\n    text-align: center;\n  }\n}\n\n.nav-justified {\n  > .nav-link,\n  .nav-item {\n    flex-grow: 1;\n    flex-basis: 0;\n    text-align: center;\n  }\n}\n\n.nav-fill,\n.nav-justified {\n  .nav-item .nav-link {\n    width: 100%; // Make sure button will grow\n  }\n}\n\n\n// Tabbable tabs\n//\n// Hide tabbable panes to start, show them when `.active`\n\n.tab-content {\n  > .tab-pane {\n    display: none;\n  }\n  > .active {\n    display: block;\n  }\n}\n","@use \"sass:map\";\n@use \"functions/escape-svg\" as *;\n@use \"mixins/border-radius\" as *;\n@use \"mixins/box-shadow\" as *;\n@use \"mixins/breakpoints\" as *;\n@use \"mixins/color-mode\" as *;\n@use \"mixins/deprecate\" as *;\n@use \"mixins/gradients\" as *;\n@use \"mixins/transition\" as *;\n@use \"vendor/rfs\" as *;\n@use \"variables\" as *;\n\n// Navbar\n//\n// Provide a static navbar from which we expand to create full-width, fixed, and\n// other navbar variations.\n\n.navbar {\n  // scss-docs-start navbar-css-vars\n  // stylelint-disable-next-line scss/at-function-named-arguments\n  --#{$prefix}navbar-padding-x: #{if(sass($navbar-padding-x == null): 0; else: $navbar-padding-x)};\n  --#{$prefix}navbar-padding-y: #{$navbar-padding-y};\n  --#{$prefix}navbar-color: #{$navbar-light-color};\n  --#{$prefix}navbar-hover-color: #{$navbar-light-hover-color};\n  --#{$prefix}navbar-disabled-color: #{$navbar-light-disabled-color};\n  --#{$prefix}navbar-active-color: #{$navbar-light-active-color};\n  --#{$prefix}navbar-brand-padding-y: #{$navbar-brand-padding-y};\n  --#{$prefix}navbar-brand-margin-end: #{$navbar-brand-margin-end};\n  --#{$prefix}navbar-brand-font-size: #{$navbar-brand-font-size};\n  --#{$prefix}navbar-brand-color: #{$navbar-light-brand-color};\n  --#{$prefix}navbar-brand-hover-color: #{$navbar-light-brand-hover-color};\n  --#{$prefix}navbar-nav-link-padding-x: #{$navbar-nav-link-padding-x};\n  --#{$prefix}navbar-toggler-padding-y: #{$navbar-toggler-padding-y};\n  --#{$prefix}navbar-toggler-padding-x: #{$navbar-toggler-padding-x};\n  --#{$prefix}navbar-toggler-font-size: #{$navbar-toggler-font-size};\n  --#{$prefix}navbar-toggler-icon-bg: #{escape-svg($navbar-light-toggler-icon-bg)};\n  --#{$prefix}navbar-toggler-border-color: #{$navbar-light-toggler-border-color};\n  --#{$prefix}navbar-toggler-border-radius: #{$navbar-toggler-border-radius};\n  --#{$prefix}navbar-toggler-focus-width: #{$navbar-toggler-focus-width};\n  --#{$prefix}navbar-toggler-transition: #{$navbar-toggler-transition};\n  // scss-docs-end navbar-css-vars\n\n  position: relative;\n  display: flex;\n  flex-wrap: wrap; // allow us to do the line break for collapsing content\n  align-items: center;\n  justify-content: space-between; // space out brand from logo\n  padding: var(--#{$prefix}navbar-padding-y) var(--#{$prefix}navbar-padding-x);\n  @include gradient-bg();\n\n  // Because flex properties aren't inherited, we need to redeclare these first\n  // few properties so that content nested within behave properly.\n  // The `flex-wrap` property is inherited to simplify the expanded navbars\n  %container-flex-properties {\n    display: flex;\n    flex-wrap: inherit;\n    align-items: center;\n    justify-content: space-between;\n  }\n\n  > .container,\n  > .container-fluid {\n    @extend %container-flex-properties;\n  }\n\n  @each $breakpoint, $container-max-width in $container-max-widths {\n    > .container#{breakpoint-infix($breakpoint, $container-max-widths)} {\n      @extend %container-flex-properties;\n    }\n  }\n}\n\n\n// Navbar brand\n//\n// Used for brand, project, or site names.\n\n.navbar-brand {\n  padding-top: var(--#{$prefix}navbar-brand-padding-y);\n  padding-bottom: var(--#{$prefix}navbar-brand-padding-y);\n  margin-inline-end: var(--#{$prefix}navbar-brand-margin-end);\n  @include font-size(var(--#{$prefix}navbar-brand-font-size));\n  color: var(--#{$prefix}navbar-brand-color);\n  text-decoration: if(not sass($link-decoration == none): none);\n  white-space: nowrap;\n\n  &:hover,\n  &:focus {\n    color: var(--#{$prefix}navbar-brand-hover-color);\n    // stylelint-disable-next-line scss/at-function-named-arguments\n    text-decoration: if(sass($link-hover-decoration == underline): none);\n  }\n}\n\n\n// Navbar nav\n//\n// Custom navbar navigation (doesn't require `.nav`, but does make use of `.nav-link`).\n\n.navbar-nav {\n  // scss-docs-start navbar-nav-css-vars\n  --#{$prefix}nav-link-padding-x: 0;\n  --#{$prefix}nav-link-padding-y: #{$nav-link-padding-y};\n  @include rfs($nav-link-font-size, --#{$prefix}nav-link-font-size);\n  --#{$prefix}nav-link-font-weight: #{$nav-link-font-weight};\n  --#{$prefix}nav-link-color: var(--#{$prefix}navbar-color);\n  --#{$prefix}nav-link-hover-color: var(--#{$prefix}navbar-hover-color);\n  --#{$prefix}nav-link-disabled-color: var(--#{$prefix}navbar-disabled-color);\n  // scss-docs-end navbar-nav-css-vars\n\n  display: flex;\n  flex-direction: column; // cannot use `inherit` to get the `.navbar`s value\n  padding-inline-start: 0;\n  margin-bottom: 0;\n  list-style: none;\n\n  .nav-link {\n    &.active,\n    &.show {\n      color: var(--#{$prefix}navbar-active-color);\n    }\n  }\n\n  .dropdown-menu {\n    position: static;\n  }\n}\n\n\n// Navbar text\n//\n//\n\n.navbar-text {\n  padding-top: $nav-link-padding-y;\n  padding-bottom: $nav-link-padding-y;\n  color: var(--#{$prefix}navbar-color);\n\n  a,\n  a:hover,\n  a:focus  {\n    color: var(--#{$prefix}navbar-active-color);\n  }\n}\n\n\n// Responsive navbar\n//\n// Custom styles for responsive collapsing and toggling of navbar contents.\n// Powered by the collapse Bootstrap JavaScript plugin.\n\n// When collapsed, prevent the toggleable navbar contents from appearing in\n// the default flexbox row orientation. Requires the use of `flex-wrap: wrap`\n// on the `.navbar` parent.\n.navbar-collapse {\n  flex-grow: 1;\n  flex-basis: 100%;\n  // For always expanded or extra full navbars, ensure content aligns itself\n  // properly vertically. Can be easily overridden with flex utilities.\n  align-items: center;\n}\n\n// Button for toggling the navbar when in its collapsed state\n.navbar-toggler {\n  padding: var(--#{$prefix}navbar-toggler-padding-y) var(--#{$prefix}navbar-toggler-padding-x);\n  @include font-size(var(--#{$prefix}navbar-toggler-font-size));\n  line-height: 1;\n  color: var(--#{$prefix}navbar-color);\n  background-color: transparent; // remove default button style\n  border: var(--#{$prefix}border-width) solid var(--#{$prefix}navbar-toggler-border-color); // remove default button style\n  @include border-radius(var(--#{$prefix}navbar-toggler-border-radius));\n  @include transition(var(--#{$prefix}navbar-toggler-transition));\n\n  &:hover {\n    text-decoration: none;\n  }\n\n  &:focus {\n    text-decoration: none;\n    outline: 0;\n    box-shadow: 0 0 0 var(--#{$prefix}navbar-toggler-focus-width);\n  }\n}\n\n// Keep as a separate element so folks can easily override it with another icon\n// or image file as needed.\n.navbar-toggler-icon {\n  display: inline-block;\n  width: 1.5em;\n  height: 1.5em;\n  vertical-align: middle;\n  background-image: var(--#{$prefix}navbar-toggler-icon-bg);\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: 100%;\n}\n\n.navbar-nav-scroll {\n  max-height: var(--#{$prefix}scroll-height, 75vh);\n  overflow-y: auto;\n}\n\n// scss-docs-start navbar-expand-loop\n// Generate series of `.navbar-expand-*` responsive classes for configuring\n// where your navbar collapses.\n.navbar-expand {\n  @each $breakpoint in map.keys($grid-breakpoints) {\n    $next: breakpoint-next($breakpoint, $grid-breakpoints);\n    $infix: breakpoint-infix($next, $grid-breakpoints);\n\n    // stylelint-disable-next-line scss/selector-no-union-class-name\n    &#{$infix} {\n      @include media-breakpoint-up($next) {\n        flex-wrap: nowrap;\n        justify-content: flex-start;\n\n        .navbar-nav {\n          flex-direction: row;\n\n          .dropdown-menu {\n            position: absolute;\n          }\n\n          .nav-link {\n            padding-right: var(--#{$prefix}navbar-nav-link-padding-x);\n            padding-left: var(--#{$prefix}navbar-nav-link-padding-x);\n          }\n        }\n\n        .navbar-nav-scroll {\n          overflow: visible;\n        }\n\n        .navbar-collapse {\n          display: flex !important; // stylelint-disable-line declaration-no-important\n          flex-basis: auto;\n        }\n\n        .navbar-toggler {\n          display: none;\n        }\n\n        .offcanvas {\n          // stylelint-disable declaration-no-important\n          position: static;\n          z-index: auto;\n          flex-grow: 1;\n          width: auto !important;\n          height: auto !important;\n          visibility: visible !important;\n          background-color: transparent !important;\n          border: 0 !important;\n          transform: none !important;\n          @include box-shadow(none);\n          @include transition(none);\n          // stylelint-enable declaration-no-important\n\n          .offcanvas-header {\n            display: none;\n          }\n\n          .offcanvas-body {\n            display: flex;\n            flex-grow: 0;\n            padding: 0;\n            overflow-y: visible;\n          }\n        }\n      }\n    }\n  }\n}\n// scss-docs-end navbar-expand-loop\n\n// Navbar themes\n//\n// Styles for switching between navbars with light or dark background.\n\n.navbar-light {\n  @include deprecate(\"`.navbar-light`\", \"v4.2.6\", \"v6.0.0\", true);\n}\n\n.navbar-dark,\n.navbar[data#{$data-infix}theme=\"dark\"] {\n  // scss-docs-start navbar-dark-css-vars\n  --#{$prefix}navbar-color: #{$navbar-dark-color};\n  --#{$prefix}navbar-hover-color: #{$navbar-dark-hover-color};\n  --#{$prefix}navbar-disabled-color: #{$navbar-dark-disabled-color};\n  --#{$prefix}navbar-active-color: #{$navbar-dark-active-color};\n  --#{$prefix}navbar-brand-color: #{$navbar-dark-brand-color};\n  --#{$prefix}navbar-brand-hover-color: #{$navbar-dark-brand-hover-color};\n  --#{$prefix}navbar-toggler-border-color: #{$navbar-dark-toggler-border-color};\n  --#{$prefix}navbar-toggler-icon-bg: #{escape-svg($navbar-dark-toggler-icon-bg)};\n  // scss-docs-end navbar-dark-css-vars\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark) {\n    .navbar-toggler-icon {\n      --#{$prefix}navbar-toggler-icon-bg: #{escape-svg($navbar-dark-toggler-icon-bg)};\n    }\n  }\n}\n","@use \"mixins/border-radius\" as *;\n@use \"mixins/box-shadow\" as *;\n@use \"mixins/breakpoints\" as *;\n@use \"variables\" as *;\n\n//\n// Base styles\n//\n\n.card {\n  // scss-docs-start card-css-vars\n  --#{$prefix}card-spacer-y: #{$card-spacer-y};\n  --#{$prefix}card-spacer-x: #{$card-spacer-x};\n  --#{$prefix}card-title-spacer-y: #{$card-title-spacer-y};\n  --#{$prefix}card-title-color: #{$card-title-color};\n  --#{$prefix}card-subtitle-color: #{$card-subtitle-color};\n  --#{$prefix}card-border-width: #{$card-border-width};\n  --#{$prefix}card-border-color: #{$card-border-color};\n  --#{$prefix}card-border-radius: #{$card-border-radius};\n  --#{$prefix}card-box-shadow: #{$card-box-shadow};\n  --#{$prefix}card-inner-border-radius: #{$card-inner-border-radius};\n  --#{$prefix}card-cap-padding-y: #{$card-cap-padding-y};\n  --#{$prefix}card-cap-padding-x: #{$card-cap-padding-x};\n  --#{$prefix}card-cap-bg: #{$card-cap-bg};\n  --#{$prefix}card-cap-color: #{$card-cap-color};\n  --#{$prefix}card-height: #{$card-height};\n  --#{$prefix}card-color: #{$card-color};\n  --#{$prefix}card-bg: #{$card-bg};\n  --#{$prefix}card-img-overlay-padding: #{$card-img-overlay-padding};\n  --#{$prefix}card-group-margin: #{$card-group-margin};\n  // scss-docs-end card-css-vars\n\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  min-width: 0; // See https://github.com/twbs/bootstrap/pull/22740#issuecomment-305868106\n  height: var(--#{$prefix}card-height);\n  color: var(--#{$prefix}body-color);\n  word-wrap: break-word;\n  background-color: var(--#{$prefix}card-bg);\n  background-clip: border-box;\n  border: var(--#{$prefix}card-border-width) solid var(--#{$prefix}card-border-color);\n  @include border-radius(var(--#{$prefix}card-border-radius));\n  @include box-shadow(var(--#{$prefix}card-box-shadow));\n\n  > hr {\n    margin-right: 0;\n    margin-left: 0;\n  }\n\n  > .list-group {\n    border-top: inherit;\n    border-bottom: inherit;\n\n    &:first-child {\n      border-top-width: 0;\n      @include border-top-radius(var(--#{$prefix}card-inner-border-radius));\n    }\n\n    &:last-child  {\n      border-bottom-width: 0;\n      @include border-bottom-radius(var(--#{$prefix}card-inner-border-radius));\n    }\n  }\n\n  // Due to specificity of the above selector (`.card > .list-group`), we must\n  // use a child selector here to prevent double borders.\n  > .card-header + .list-group,\n  > .list-group + .card-footer {\n    border-top: 0;\n  }\n}\n\n.card-body {\n  // Enable `flex-grow: 1` for decks and groups so that card blocks take up\n  // as much space as possible, ensuring footers are aligned to the bottom.\n  flex: 1 1 auto;\n  padding: var(--#{$prefix}card-spacer-y) var(--#{$prefix}card-spacer-x);\n  color: var(--#{$prefix}card-color);\n}\n\n.card-title {\n  margin-bottom: var(--#{$prefix}card-title-spacer-y);\n  color: var(--#{$prefix}card-title-color);\n}\n\n.card-subtitle {\n  margin-top: calc(-.5 * var(--#{$prefix}card-title-spacer-y)); // stylelint-disable-line function-disallowed-list\n  margin-bottom: 0;\n  color: var(--#{$prefix}card-subtitle-color);\n}\n\n.card-text:last-child {\n  margin-bottom: 0;\n}\n\n.card-link {\n  &:hover {\n    // stylelint-disable-next-line scss/at-function-named-arguments\n    text-decoration: if(sass($link-hover-decoration == underline): none);\n  }\n\n  + .card-link {\n    margin-inline-start: var(--#{$prefix}card-spacer-x);\n  }\n}\n\n//\n// Optional textual caps\n//\n\n.card-header {\n  padding: var(--#{$prefix}card-cap-padding-y) var(--#{$prefix}card-cap-padding-x);\n  margin-bottom: 0; // Removes the default margin-bottom of <hN>\n  color: var(--#{$prefix}card-cap-color);\n  background-color: var(--#{$prefix}card-cap-bg);\n  border-bottom: var(--#{$prefix}card-border-width) solid var(--#{$prefix}card-border-color);\n\n  &:first-child {\n    @include border-radius(var(--#{$prefix}card-inner-border-radius) var(--#{$prefix}card-inner-border-radius) 0 0);\n  }\n}\n\n.card-footer {\n  padding: var(--#{$prefix}card-cap-padding-y) var(--#{$prefix}card-cap-padding-x);\n  color: var(--#{$prefix}card-cap-color);\n  background-color: var(--#{$prefix}card-cap-bg);\n  border-top: var(--#{$prefix}card-border-width) solid var(--#{$prefix}card-border-color);\n\n  &:last-child {\n    @include border-radius(0 0 var(--#{$prefix}card-inner-border-radius) var(--#{$prefix}card-inner-border-radius));\n  }\n}\n\n\n//\n// Header navs\n//\n\n.card-header-tabs {\n  margin-right: calc(-.5 * var(--#{$prefix}card-cap-padding-x)); // stylelint-disable-line function-disallowed-list\n  margin-bottom: calc(-1 * var(--#{$prefix}card-cap-padding-y)); // stylelint-disable-line function-disallowed-list\n  margin-left: calc(-.5 * var(--#{$prefix}card-cap-padding-x)); // stylelint-disable-line function-disallowed-list\n  border-bottom: 0;\n\n  .nav-link.active {\n    background-color: var(--#{$prefix}card-bg);\n    border-bottom-color: var(--#{$prefix}card-bg);\n  }\n}\n\n.card-header-pills {\n  margin-right: calc(-.5 * var(--#{$prefix}card-cap-padding-x)); // stylelint-disable-line function-disallowed-list\n  margin-left: calc(-.5 * var(--#{$prefix}card-cap-padding-x)); // stylelint-disable-line function-disallowed-list\n}\n\n// Card image\n.card-img-overlay {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  padding: var(--#{$prefix}card-img-overlay-padding);\n  @include border-radius(var(--#{$prefix}card-inner-border-radius));\n}\n\n.card-img,\n.card-img-top,\n.card-img-bottom {\n  width: 100%; // Required because we use flexbox and this inherently applies align-self: stretch\n}\n\n.card-img,\n.card-img-top {\n  @include border-top-radius(var(--#{$prefix}card-inner-border-radius));\n}\n\n.card-img,\n.card-img-bottom {\n  @include border-bottom-radius(var(--#{$prefix}card-inner-border-radius));\n}\n\n\n//\n// Card groups\n//\n\n.card-group {\n  // The child selector allows nested `.card` within `.card-group`\n  // to display properly.\n  > .card {\n    margin-bottom: var(--#{$prefix}card-group-margin);\n  }\n\n  @include media-breakpoint-up(sm) {\n    display: flex;\n    flex-flow: row wrap;\n    // The child selector allows nested `.card` within `.card-group`\n    // to display properly.\n    > .card {\n      flex: 1 0 0;\n      margin-bottom: 0;\n\n      + .card {\n        margin-inline-start: 0;\n        border-inline-start: 0;\n      }\n\n      // Handle rounded corners\n      @if $enable-rounded {\n        &:not(:last-child) {\n          @include border-end-radius(0);\n\n          > .card-img-top,\n          > .card-header {\n            // stylelint-disable-next-line property-disallowed-list\n            border-top-right-radius: 0;\n          }\n          > .card-img-bottom,\n          > .card-footer {\n            // stylelint-disable-next-line property-disallowed-list\n            border-bottom-right-radius: 0;\n          }\n        }\n\n        &:not(:first-child) {\n          @include border-start-radius(0);\n\n          > .card-img-top,\n          > .card-header {\n            // stylelint-disable-next-line property-disallowed-list\n            border-top-left-radius: 0;\n          }\n          > .card-img-bottom,\n          > .card-footer {\n            // stylelint-disable-next-line property-disallowed-list\n            border-bottom-left-radius: 0;\n          }\n        }\n      }\n    }\n  }\n}\n","@use \"functions/escape-svg\" as *;\n@use \"mixins/border-radius\" as *;\n@use \"mixins/color-mode\" as *;\n@use \"mixins/transition\" as *;\n@use \"vendor/rfs\" as *;\n@use \"variables\" as *;\n@use \"variables-dark\" as *;\n\n//\n// Base styles\n//\n\n.accordion {\n  // scss-docs-start accordion-css-vars\n  --#{$prefix}accordion-color: #{$accordion-color};\n  --#{$prefix}accordion-bg: #{$accordion-bg};\n  --#{$prefix}accordion-transition: #{$accordion-transition};\n  --#{$prefix}accordion-border-color: #{$accordion-border-color};\n  --#{$prefix}accordion-border-width: #{$accordion-border-width};\n  --#{$prefix}accordion-border-radius: #{$accordion-border-radius};\n  --#{$prefix}accordion-inner-border-radius: #{$accordion-inner-border-radius};\n  --#{$prefix}accordion-btn-padding-x: #{$accordion-button-padding-x};\n  --#{$prefix}accordion-btn-padding-y: #{$accordion-button-padding-y};\n  --#{$prefix}accordion-btn-color: #{$accordion-button-color};\n  --#{$prefix}accordion-btn-bg: #{$accordion-button-bg};\n  --#{$prefix}accordion-btn-icon: #{escape-svg($accordion-button-icon)};\n  --#{$prefix}accordion-btn-icon-width: #{$accordion-icon-width};\n  --#{$prefix}accordion-btn-icon-transform: #{$accordion-icon-transform};\n  --#{$prefix}accordion-btn-icon-transition: #{$accordion-icon-transition};\n  --#{$prefix}accordion-btn-active-icon: #{escape-svg($accordion-button-active-icon)};\n  --#{$prefix}accordion-btn-focus-box-shadow: #{$accordion-button-focus-box-shadow};\n  --#{$prefix}accordion-body-padding-x: #{$accordion-body-padding-x};\n  --#{$prefix}accordion-body-padding-y: #{$accordion-body-padding-y};\n  --#{$prefix}accordion-active-color: #{$accordion-button-active-color};\n  --#{$prefix}accordion-active-bg: #{$accordion-button-active-bg};\n  // scss-docs-end accordion-css-vars\n}\n\n.accordion-button {\n  position: relative;\n  display: flex;\n  align-items: center;\n  width: 100%;\n  padding: var(--#{$prefix}accordion-btn-padding-y) var(--#{$prefix}accordion-btn-padding-x);\n  @include font-size($font-size-base);\n  color: var(--#{$prefix}accordion-btn-color);\n  text-align: start; // Reset button style\n  background-color: var(--#{$prefix}accordion-btn-bg);\n  border: 0;\n  @include border-radius(0);\n  overflow-anchor: none;\n  @include transition(var(--#{$prefix}accordion-transition));\n\n  &:not(.collapsed) {\n    color: var(--#{$prefix}accordion-active-color);\n    background-color: var(--#{$prefix}accordion-active-bg);\n    box-shadow: inset 0 calc(-1 * var(--#{$prefix}accordion-border-width)) 0 var(--#{$prefix}accordion-border-color); // stylelint-disable-line function-disallowed-list\n\n    &::after {\n      background-image: var(--#{$prefix}accordion-btn-active-icon);\n      transform: var(--#{$prefix}accordion-btn-icon-transform);\n    }\n  }\n\n  // Accordion icon\n  &::after {\n    flex-shrink: 0;\n    width: var(--#{$prefix}accordion-btn-icon-width);\n    height: var(--#{$prefix}accordion-btn-icon-width);\n    margin-inline-start: auto;\n    content: \"\";\n    background-image: var(--#{$prefix}accordion-btn-icon);\n    background-repeat: no-repeat;\n    background-size: var(--#{$prefix}accordion-btn-icon-width);\n    @include transition(var(--#{$prefix}accordion-btn-icon-transition));\n  }\n\n  &:hover {\n    z-index: 2;\n  }\n\n  &:focus {\n    z-index: 3;\n    outline: 0;\n    box-shadow: var(--#{$prefix}accordion-btn-focus-box-shadow);\n  }\n}\n\n.accordion-header {\n  margin-bottom: 0;\n}\n\n.accordion-item {\n  color: var(--#{$prefix}accordion-color);\n  background-color: var(--#{$prefix}accordion-bg);\n  border: var(--#{$prefix}accordion-border-width) solid var(--#{$prefix}accordion-border-color);\n\n  &:first-of-type {\n    @include border-top-radius(var(--#{$prefix}accordion-border-radius));\n\n    > .accordion-header .accordion-button {\n      @include border-top-radius(var(--#{$prefix}accordion-inner-border-radius));\n    }\n  }\n\n  &:not(:first-of-type) {\n    border-top: 0;\n  }\n\n  // Only set a border-radius on the last item if the accordion is collapsed\n  &:last-of-type {\n    @include border-bottom-radius(var(--#{$prefix}accordion-border-radius));\n\n    > .accordion-header .accordion-button {\n      &.collapsed {\n        @include border-bottom-radius(var(--#{$prefix}accordion-inner-border-radius));\n      }\n    }\n\n    > .accordion-collapse {\n      @include border-bottom-radius(var(--#{$prefix}accordion-border-radius));\n    }\n  }\n}\n\n.accordion-body {\n  padding: var(--#{$prefix}accordion-body-padding-y) var(--#{$prefix}accordion-body-padding-x);\n}\n\n\n// Flush accordion items\n//\n// Remove borders and border-radius to keep accordion items edge-to-edge.\n\n.accordion-flush {\n  > .accordion-item {\n    border-right: 0;\n    border-left: 0;\n    @include border-radius(0);\n\n    &:first-child { border-top: 0; }\n    &:last-child { border-bottom: 0; }\n\n    // stylelint-disable selector-max-class\n    > .accordion-collapse,\n    > .accordion-header .accordion-button,\n    > .accordion-header .accordion-button.collapsed {\n      @include border-radius(0);\n    }\n    // stylelint-enable selector-max-class\n  }\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark) {\n    .accordion-button::after {\n      --#{$prefix}accordion-btn-icon: #{escape-svg($accordion-button-icon-dark)};\n      --#{$prefix}accordion-btn-active-icon: #{escape-svg($accordion-button-active-icon-dark)};\n    }\n  }\n}\n","@use \"functions/escape-svg\" as *;\n@use \"mixins/border-radius\" as *;\n@use \"mixins/ltr-rtl\" as *;\n@use \"vendor/rfs\" as *;\n@use \"variables\" as *;\n\n.breadcrumb {\n  // scss-docs-start breadcrumb-css-vars\n  --#{$prefix}breadcrumb-padding-x: #{$breadcrumb-padding-x};\n  --#{$prefix}breadcrumb-padding-y: #{$breadcrumb-padding-y};\n  --#{$prefix}breadcrumb-margin-bottom: #{$breadcrumb-margin-bottom};\n  @include rfs($breadcrumb-font-size, --#{$prefix}breadcrumb-font-size);\n  --#{$prefix}breadcrumb-bg: #{$breadcrumb-bg};\n  --#{$prefix}breadcrumb-border-radius: #{$breadcrumb-border-radius};\n  --#{$prefix}breadcrumb-divider-color: #{$breadcrumb-divider-color};\n  --#{$prefix}breadcrumb-item-padding-x: #{$breadcrumb-item-padding-x};\n  --#{$prefix}breadcrumb-item-active-color: #{$breadcrumb-active-color};\n  // scss-docs-end breadcrumb-css-vars\n\n  display: flex;\n  flex-wrap: wrap;\n  padding: var(--#{$prefix}breadcrumb-padding-y) var(--#{$prefix}breadcrumb-padding-x);\n  margin-bottom: var(--#{$prefix}breadcrumb-margin-bottom);\n  @include font-size(var(--#{$prefix}breadcrumb-font-size));\n  list-style: none;\n  background-color: var(--#{$prefix}breadcrumb-bg);\n  @include border-radius(var(--#{$prefix}breadcrumb-border-radius));\n}\n\n.breadcrumb-item {\n  // The separator between breadcrumbs (by default, a forward-slash: \"/\")\n  + .breadcrumb-item {\n    padding-inline-start: var(--#{$prefix}breadcrumb-item-padding-x);\n\n    &::before {\n      float: inline-start; // Suppress inline spacings and underlining of the separator\n      padding-inline-end: var(--#{$prefix}breadcrumb-item-padding-x);\n      color: var(--#{$prefix}breadcrumb-divider-color);\n      @include ltr-rtl(\n        \"content\",\n        var(--#{$prefix}breadcrumb-divider, escape-svg($breadcrumb-divider)),\n        null,\n        var(--#{$prefix}breadcrumb-divider-flipped, escape-svg($breadcrumb-divider-flipped))\n      );\n    }\n  }\n\n  &.active {\n    color: var(--#{$prefix}breadcrumb-item-active-color);\n  }\n}\n","@use \"mixins/border-radius\" as *;\n@use \"mixins/gradients\" as *;\n@use \"mixins/lists\" as *;\n@use \"mixins/pagination\" as *;\n@use \"mixins/transition\" as *;\n@use \"vendor/rfs\" as *;\n@use \"variables\" as *;\n\n.pagination {\n  // scss-docs-start pagination-css-vars\n  --#{$prefix}pagination-padding-x: #{$pagination-padding-x};\n  --#{$prefix}pagination-padding-y: #{$pagination-padding-y};\n  @include rfs($pagination-font-size, --#{$prefix}pagination-font-size);\n  --#{$prefix}pagination-color: #{$pagination-color};\n  --#{$prefix}pagination-bg: #{$pagination-bg};\n  --#{$prefix}pagination-border-width: #{$pagination-border-width};\n  --#{$prefix}pagination-border-color: #{$pagination-border-color};\n  --#{$prefix}pagination-border-radius: #{$pagination-border-radius};\n  --#{$prefix}pagination-hover-color: #{$pagination-hover-color};\n  --#{$prefix}pagination-hover-bg: #{$pagination-hover-bg};\n  --#{$prefix}pagination-hover-border-color: #{$pagination-hover-border-color};\n  --#{$prefix}pagination-focus-color: #{$pagination-focus-color};\n  --#{$prefix}pagination-focus-bg: #{$pagination-focus-bg};\n  --#{$prefix}pagination-focus-box-shadow: #{$pagination-focus-box-shadow};\n  --#{$prefix}pagination-active-color: #{$pagination-active-color};\n  --#{$prefix}pagination-active-bg: #{$pagination-active-bg};\n  --#{$prefix}pagination-active-border-color: #{$pagination-active-border-color};\n  --#{$prefix}pagination-disabled-color: #{$pagination-disabled-color};\n  --#{$prefix}pagination-disabled-bg: #{$pagination-disabled-bg};\n  --#{$prefix}pagination-disabled-border-color: #{$pagination-disabled-border-color};\n  // scss-docs-end pagination-css-vars\n\n  display: flex;\n  @include list-unstyled();\n}\n\n.page-link {\n  position: relative;\n  display: block;\n  padding: var(--#{$prefix}pagination-padding-y) var(--#{$prefix}pagination-padding-x);\n  @include font-size(var(--#{$prefix}pagination-font-size));\n  color: var(--#{$prefix}pagination-color);\n  text-decoration: if(not sass($link-decoration == none): none);\n  background-color: var(--#{$prefix}pagination-bg);\n  border: var(--#{$prefix}pagination-border-width) solid var(--#{$prefix}pagination-border-color);\n  @include transition($pagination-transition);\n\n  &:hover {\n    z-index: 2;\n    color: var(--#{$prefix}pagination-hover-color);\n    // stylelint-disable-next-line scss/at-function-named-arguments\n    text-decoration: if(sass($link-hover-decoration == underline): none);\n    background-color: var(--#{$prefix}pagination-hover-bg);\n    border-color: var(--#{$prefix}pagination-hover-border-color);\n  }\n\n  &:focus {\n    z-index: 3;\n    color: var(--#{$prefix}pagination-focus-color);\n    background-color: var(--#{$prefix}pagination-focus-bg);\n    outline: $pagination-focus-outline;\n    box-shadow: var(--#{$prefix}pagination-focus-box-shadow);\n  }\n\n  &.active,\n  .active > & {\n    z-index: 3;\n    color: var(--#{$prefix}pagination-active-color);\n    @include gradient-bg(var(--#{$prefix}pagination-active-bg));\n    border-color: var(--#{$prefix}pagination-active-border-color);\n  }\n\n  &.disabled,\n  .disabled > & {\n    color: var(--#{$prefix}pagination-disabled-color);\n    pointer-events: none;\n    background-color: var(--#{$prefix}pagination-disabled-bg);\n    border-color: var(--#{$prefix}pagination-disabled-border-color);\n  }\n}\n\n.page-item {\n  &:not(:first-child) .page-link {\n    margin-inline-start: $pagination-margin-start;\n  }\n\n  @if $pagination-margin-start == calc(-1 * #{$pagination-border-width}) {\n    &:first-child {\n      .page-link {\n        @include border-start-radius(var(--#{$prefix}pagination-border-radius));\n      }\n    }\n\n    &:last-child {\n      .page-link {\n        @include border-end-radius(var(--#{$prefix}pagination-border-radius));\n      }\n    }\n  } @else {\n    // Add border-radius to all pageLinks in case they have left margin\n    .page-link {\n      @include border-radius(var(--#{$prefix}pagination-border-radius));\n    }\n  }\n}\n\n\n//\n// Sizing\n//\n\n.pagination-lg {\n  @include pagination-size($pagination-padding-y-lg, $pagination-padding-x-lg, $font-size-lg, $pagination-border-radius-lg);\n}\n\n.pagination-sm {\n  @include pagination-size($pagination-padding-y-sm, $pagination-padding-x-sm, $font-size-sm, $pagination-border-radius-sm);\n}\n","@use \"../vendor/rfs\" as *;\n@use \"../variables\" as *;\n\n// Pagination\n\n// scss-docs-start pagination-mixin\n@mixin pagination-size($padding-y, $padding-x, $font-size, $border-radius) {\n  --#{$prefix}pagination-padding-x: #{$padding-x};\n  --#{$prefix}pagination-padding-y: #{$padding-y};\n  @include rfs($font-size, --#{$prefix}pagination-font-size);\n  --#{$prefix}pagination-border-radius: #{$border-radius};\n}\n// scss-docs-end pagination-mixin\n","@use \"mixins/gradients\" as *;\n@use \"vendor/rfs\" as *;\n@use \"variables\" as *;\n\n// Base class\n//\n// Requires one of the contextual, color modifier classes for `color` and\n// `background-color`.\n\n.badge {\n  // scss-docs-start badge-css-vars\n  --#{$prefix}badge-padding-x: #{$badge-padding-x};\n  --#{$prefix}badge-padding-y: #{$badge-padding-y};\n  @include rfs($badge-font-size, --#{$prefix}badge-font-size);\n  --#{$prefix}badge-font-weight: #{$badge-font-weight};\n  --#{$prefix}badge-color: #{$badge-color};\n  --#{$prefix}badge-border-radius: #{$badge-border-radius};\n  // scss-docs-end badge-css-vars\n\n  display: inline-block;\n  padding: var(--#{$prefix}badge-padding-y) var(--#{$prefix}badge-padding-x);\n  @include font-size(var(--#{$prefix}badge-font-size));\n  font-weight: var(--#{$prefix}badge-font-weight);\n  line-height: 1;\n  color: var(--#{$prefix}badge-color);\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: baseline;\n  border-radius: var(--#{$prefix}badge-border-radius, 0); // stylelint-disable-line property-disallowed-list\n  @include gradient-bg();\n\n  // Empty badges collapse automatically\n  &:empty {\n    display: none;\n  }\n}\n\n// Quick fix for badges in buttons\n.btn .badge {\n  position: relative;\n  top: -1px;\n}\n\n//\n// Badge Sizes\n//\n\n.badge-sm {\n  --#{$prefix}badge-padding-x: #{$badge-padding-x-sm};\n  --#{$prefix}badge-padding-y: #{$badge-padding-y-sm};\n  @include font-size($badge-font-size-sm);\n}\n","@use \"sass:map\";\n@use \"mixins/border-radius\" as *;\n@use \"variables\" as *;\n\n//\n// Base styles\n//\n\n.alert {\n  // scss-docs-start alert-css-vars\n  --#{$prefix}alert-bg: transparent;\n  --#{$prefix}alert-padding-x: #{$alert-padding-x};\n  --#{$prefix}alert-padding-y: #{$alert-padding-y};\n  --#{$prefix}alert-margin-bottom: #{$alert-margin-bottom};\n  --#{$prefix}alert-color: inherit;\n  --#{$prefix}alert-border-color: transparent;\n  --#{$prefix}alert-border: #{$alert-border-width} solid var(--#{$prefix}alert-border-color);\n  --#{$prefix}alert-border-radius: #{$alert-border-radius};\n  --#{$prefix}alert-link-color: inherit;\n  // scss-docs-end alert-css-vars\n\n  position: relative;\n  padding: var(--#{$prefix}alert-padding-y) var(--#{$prefix}alert-padding-x);\n  margin-bottom: var(--#{$prefix}alert-margin-bottom);\n  color: var(--#{$prefix}alert-color);\n  background-color: var(--#{$prefix}alert-bg);\n  border: var(--#{$prefix}alert-border);\n  @include border-radius(var(--#{$prefix}alert-border-radius));\n}\n\n// Headings for larger alerts\n.alert-heading {\n  // Specified to prevent conflicts of changing $headings-color\n  color: inherit;\n}\n\n// Provide class for links that match alerts\n.alert-link {\n  font-weight: $alert-link-font-weight;\n  color: var(--#{$prefix}alert-link-color);\n}\n\n\n// Dismissible alerts\n//\n// Expand the right padding and account for the close button's positioning.\n\n.alert-dismissible {\n  padding-inline-end: $alert-dismissible-padding-r;\n\n  // Adjust close link position\n  .btn-close {\n    position: absolute;\n    inset-inline-end: 0;\n    top: 0;\n    z-index: $stretched-link-z-index + 1;\n    padding: $alert-padding-y * 1.25 $alert-padding-x;\n  }\n}\n\n\n// scss-docs-start alert-modifiers\n// Generate contextual modifier classes for colorizing the alert.\n@each $state in map.keys($theme-colors) {\n  .alert-#{$state} {\n    --#{$prefix}alert-color: var(--#{$prefix}#{$state}-text-emphasis);\n    --#{$prefix}alert-bg: var(--#{$prefix}#{$state}-bg-subtle);\n    --#{$prefix}alert-border-color: var(--#{$prefix}#{$state}-border-subtle);\n    --#{$prefix}alert-link-color: var(--#{$prefix}#{$state}-text-emphasis);\n  }\n}\n// scss-docs-end alert-modifiers\n","@use \"mixins/border-radius\" as *;\n@use \"mixins/box-shadow\" as *;\n@use \"mixins/gradients\" as *;\n@use \"mixins/transition\" as *;\n@use \"vendor/rfs\" as *;\n@use \"variables\" as *;\n\n// Disable animation if transitions are disabled\n\n// scss-docs-start progress-keyframes\n@if $enable-transitions {\n  @keyframes progress-bar-stripes {\n    0% { background-position-x: var(--#{$prefix}progress-height); }\n  }\n}\n// scss-docs-end progress-keyframes\n\n.progress,\n.progress-stacked {\n  // scss-docs-start progress-css-vars\n  --#{$prefix}progress-height: #{$progress-height};\n  @include rfs($progress-font-size, --#{$prefix}progress-font-size);\n  --#{$prefix}progress-bg: #{$progress-bg};\n  --#{$prefix}progress-border-radius: #{$progress-border-radius};\n  --#{$prefix}progress-box-shadow: #{$progress-box-shadow};\n  --#{$prefix}progress-bar-color: #{$progress-bar-color};\n  --#{$prefix}progress-bar-bg: #{$progress-bar-bg};\n  --#{$prefix}progress-bar-transition: #{$progress-bar-transition};\n  // scss-docs-end progress-css-vars\n\n  display: flex;\n  height: var(--#{$prefix}progress-height);\n  overflow: hidden; // force rounded corners by cropping it\n  @include font-size(var(--#{$prefix}progress-font-size));\n  background-color: var(--#{$prefix}progress-bg);\n  @include border-radius(var(--#{$prefix}progress-border-radius));\n  @include box-shadow(var(--#{$prefix}progress-box-shadow));\n}\n\n.progress-bar {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  overflow: hidden;\n  color: var(--#{$prefix}progress-bar-color);\n  text-align: center;\n  white-space: nowrap;\n  background-color: var(--#{$prefix}progress-bar-bg);\n  @include transition(var(--#{$prefix}progress-bar-transition));\n}\n\n.progress-bar-striped {\n  @include gradient-striped();\n  background-size: var(--#{$prefix}progress-height) var(--#{$prefix}progress-height);\n}\n\n.progress-stacked > .progress {\n  overflow: visible;\n}\n\n.progress-stacked > .progress > .progress-bar {\n  width: 100%;\n}\n\n@if $enable-transitions {\n  .progress-bar-animated {\n    animation: $progress-bar-animation-timing progress-bar-stripes;\n\n    @if $enable-reduced-motion {\n      @media (prefers-reduced-motion: reduce) {\n        animation: none;\n      }\n    }\n  }\n}\n\n.progress-thin {\n  height: 4px;\n}\n\n// White progress bar\n.progress.progress-white {\n  background-color: rgba(255, 255, 255, .2);\n  .progress-bar {\n    background-color: $white;\n  }\n}\n\n.progress-group {\n  display: flex;\n  flex-flow: row wrap;\n  margin-bottom: $progress-group-margin-bottom;\n}\n\n.progress-group-prepend {\n  flex: 0 0 100px;\n  align-self: center;\n}\n\n.progress-group-header {\n  display: flex;\n  flex-basis: 100%;\n  align-items: center;\n  margin-bottom: $progress-group-header-margin-bottom;\n}\n\n.progress-group-bars {\n  flex-grow: 1;\n  align-self: center;\n\n  .progress:not(:last-child) {\n    margin-bottom: 2px;\n  }\n}\n\n.progress-group-header + .progress-group-bars {\n  flex-basis: 100%;\n}\n","@use \"sass:map\";\n@use \"mixins/border-radius\" as *;\n@use \"mixins/breakpoints\" as *;\n@use \"variables\" as *;\n\n// Base class\n//\n// Easily usable on <ul>, <ol>, or <div>.\n\n.list-group {\n  // scss-docs-start list-group-css-vars\n  --#{$prefix}list-group-color: #{$list-group-color};\n  --#{$prefix}list-group-bg: #{$list-group-bg};\n  --#{$prefix}list-group-border-color: #{$list-group-border-color};\n  --#{$prefix}list-group-border-width: #{$list-group-border-width};\n  --#{$prefix}list-group-border-radius: #{$list-group-border-radius};\n  --#{$prefix}list-group-item-padding-x: #{$list-group-item-padding-x};\n  --#{$prefix}list-group-item-padding-y: #{$list-group-item-padding-y};\n  --#{$prefix}list-group-action-color: #{$list-group-action-color};\n  --#{$prefix}list-group-action-hover-color: #{$list-group-action-hover-color};\n  --#{$prefix}list-group-action-hover-bg: #{$list-group-hover-bg};\n  --#{$prefix}list-group-action-active-color: #{$list-group-action-active-color};\n  --#{$prefix}list-group-action-active-bg: #{$list-group-action-active-bg};\n  --#{$prefix}list-group-disabled-color: #{$list-group-disabled-color};\n  --#{$prefix}list-group-disabled-bg: #{$list-group-disabled-bg};\n  --#{$prefix}list-group-active-color: #{$list-group-active-color};\n  --#{$prefix}list-group-active-bg: #{$list-group-active-bg};\n  --#{$prefix}list-group-active-border-color: #{$list-group-active-border-color};\n  // scss-docs-end list-group-css-vars\n\n  display: flex;\n  flex-direction: column;\n\n  // No need to set list-style: none; since .list-group-item is block level\n  padding-inline-start: 0; // reset padding because ul and ol\n  margin-bottom: 0;\n  @include border-radius(var(--#{$prefix}list-group-border-radius));\n}\n\n.list-group-numbered {\n  list-style-type: none;\n  counter-reset: section;\n\n  > .list-group-item::before {\n    // Increments only this instance of the section counter\n    content: counters(section, \".\") \". \";\n    counter-increment: section;\n  }\n}\n\n// Individual list items\n//\n// Use on `li`s or `div`s within the `.list-group` parent.\n\n.list-group-item {\n  position: relative;\n  display: block;\n  padding: var(--#{$prefix}list-group-item-padding-y) var(--#{$prefix}list-group-item-padding-x);\n  color: var(--#{$prefix}list-group-color);\n  text-decoration: if(not sass($link-decoration == none): none);\n  background-color: var(--#{$prefix}list-group-bg);\n  border: var(--#{$prefix}list-group-border-width) solid var(--#{$prefix}list-group-border-color);\n\n  &:first-child {\n    @include border-top-radius(inherit);\n  }\n\n  &:last-child {\n    @include border-bottom-radius(inherit);\n  }\n\n  &.disabled,\n  &:disabled {\n    color: var(--#{$prefix}list-group-disabled-color);\n    pointer-events: none;\n    background-color: var(--#{$prefix}list-group-disabled-bg);\n  }\n\n  // Include both here for `<a>`s and `<button>`s\n  &.active {\n    z-index: 2; // Place active items above their siblings for proper border styling\n    color: var(--#{$prefix}list-group-active-color);\n    background-color: var(--#{$prefix}list-group-active-bg);\n    border-color: var(--#{$prefix}list-group-active-border-color);\n  }\n\n  // stylelint-disable-next-line scss/selector-no-redundant-nesting-selector\n  & + .list-group-item {\n    border-top-width: 0;\n\n    &.active {\n      margin-top: calc(-1 * var(--#{$prefix}list-group-border-width)); // stylelint-disable-line function-disallowed-list\n      border-top-width: var(--#{$prefix}list-group-border-width);\n    }\n  }\n}\n\n// Interactive list items\n//\n// Use anchor or button elements instead of `li`s or `div`s to create interactive\n// list items. Includes an extra `.active` modifier class for selected items.\n\n.list-group-item-action {\n  width: 100%; // For `<button>`s (anchors become 100% by default though)\n  color: var(--#{$prefix}list-group-action-color);\n  text-align: inherit; // For `<button>`s (anchors inherit)\n\n  &:not(.active) {\n    // Hover state\n    &:hover,\n    &:focus {\n      z-index: 1; // Place hover/focus items above their siblings for proper border styling\n      color: var(--#{$prefix}list-group-action-hover-color);\n      text-decoration: none;\n      background-color: var(--#{$prefix}list-group-action-hover-bg);\n    }\n\n    &:active {\n      color: var(--#{$prefix}list-group-action-active-color);\n      background-color: var(--#{$prefix}list-group-action-active-bg);\n    }\n  }\n}\n\n// Horizontal\n//\n// Change the layout of list group items from vertical (default) to horizontal.\n\n@each $breakpoint in map.keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .list-group-horizontal#{$infix} {\n      flex-direction: row;\n\n      > .list-group-item {\n        &:first-child:not(:last-child) {\n          @include border-bottom-start-radius(var(--#{$prefix}list-group-border-radius));\n          @include border-top-end-radius(0);\n        }\n\n        &:last-child:not(:first-child) {\n          @include border-top-end-radius(var(--#{$prefix}list-group-border-radius));\n          @include border-bottom-start-radius(0);\n        }\n\n        &.active {\n          margin-top: 0;\n        }\n\n        + .list-group-item {\n          border-inline-start-width: 0;\n          border-top-width: var(--#{$prefix}list-group-border-width);\n\n          &.active {\n            margin-inline-start: calc(-1 * var(--#{$prefix}list-group-border-width)); // stylelint-disable-line function-disallowed-list\n            border-inline-start-width: var(--#{$prefix}list-group-border-width);\n          }\n        }\n      }\n    }\n  }\n}\n\n\n// Flush list items\n//\n// Remove borders and border-radius to keep list group items edge-to-edge. Most\n// useful within other components (e.g., cards).\n\n.list-group-flush {\n  @include border-radius(0);\n\n  > .list-group-item {\n    border-width: 0 0 var(--#{$prefix}list-group-border-width);\n\n    &:last-child {\n      border-bottom-width: 0;\n    }\n  }\n}\n\n\n// scss-docs-start list-group-modifiers\n// List group contextual variants\n//\n// Add modifier classes to change text and background color on individual items.\n// Organizationally, this must come after the `:hover` states.\n\n@each $state in map.keys($theme-colors) {\n  .list-group-item-#{$state} {\n    --#{$prefix}list-group-color: var(--#{$prefix}#{$state}-text-emphasis);\n    --#{$prefix}list-group-bg: var(--#{$prefix}#{$state}-bg-subtle);\n    --#{$prefix}list-group-border-color: var(--#{$prefix}#{$state}-border-subtle);\n    --#{$prefix}list-group-action-hover-color: var(--#{$prefix}emphasis-color);\n    --#{$prefix}list-group-action-hover-bg: var(--#{$prefix}#{$state}-border-subtle);\n    --#{$prefix}list-group-action-active-color: var(--#{$prefix}emphasis-color);\n    --#{$prefix}list-group-action-active-bg: var(--#{$prefix}#{$state}-border-subtle);\n    --#{$prefix}list-group-active-color: var(--#{$prefix}#{$state}-bg-subtle);\n    --#{$prefix}list-group-active-bg: var(--#{$prefix}#{$state}-text-emphasis);\n    --#{$prefix}list-group-active-border-color: var(--#{$prefix}#{$state}-text-emphasis);\n  }\n}\n// scss-docs-end list-group-modifiers\n","@use \"functions/escape-svg\" as *;\n@use \"mixins/border-radius\" as *;\n@use \"mixins/color-mode\" as *;\n@use \"variables\" as *;\n@use \"variables-dark\" as *;\n\n// Transparent background and border properties included for button version.\n// iOS requires the button element instead of an anchor tag.\n// If you want the anchor version, it requires `href=\"#\"`.\n// See https://developer.mozilla.org/en-US/docs/Web/Events/click#Safari_Mobile\n\n.btn-close {\n  // scss-docs-start close-css-vars\n  --#{$prefix}btn-close-color: #{$btn-close-color};\n  --#{$prefix}btn-close-bg: #{ escape-svg($btn-close-bg) };\n  --#{$prefix}btn-close-opacity: #{$btn-close-opacity};\n  --#{$prefix}btn-close-hover-opacity: #{$btn-close-hover-opacity};\n  --#{$prefix}btn-close-focus-shadow: #{$btn-close-focus-shadow};\n  --#{$prefix}btn-close-focus-opacity: #{$btn-close-focus-opacity};\n  --#{$prefix}btn-close-disabled-opacity: #{$btn-close-disabled-opacity};\n  // scss-docs-end close-css-vars\n\n  box-sizing: content-box;\n  width: $btn-close-width;\n  height: $btn-close-height;\n  padding: $btn-close-padding-y $btn-close-padding-x;\n  color: var(--#{$prefix}btn-close-color);\n  background: transparent var(--#{$prefix}btn-close-bg) center / $btn-close-width auto no-repeat; // include transparent for button elements\n  filter: var(--#{$prefix}btn-close-filter);\n  border: 0; // for button elements\n  @include border-radius();\n  opacity: var(--#{$prefix}btn-close-opacity);\n\n  // Override <a>'s hover style\n  &:hover {\n    color: var(--#{$prefix}btn-close-color);\n    text-decoration: none;\n    opacity: var(--#{$prefix}btn-close-hover-opacity);\n  }\n\n  &:focus {\n    outline: 0;\n    box-shadow: var(--#{$prefix}btn-close-focus-shadow);\n    opacity: var(--#{$prefix}btn-close-focus-opacity);\n  }\n\n  &:disabled,\n  &.disabled {\n    pointer-events: none;\n    user-select: none;\n    opacity: var(--#{$prefix}btn-close-disabled-opacity);\n  }\n}\n\n@mixin btn-close-white() {\n  --#{$prefix}btn-close-filter: #{$btn-close-filter-dark};\n}\n\n.btn-close-white {\n  @include btn-close-white();\n}\n\n:root,\n[data#{$data-infix}theme=\"light\"] {\n  --#{$prefix}btn-close-filter: #{$btn-close-filter};\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark, true) {\n    @include btn-close-white();\n  }\n}\n","@use \"mixins/border-radius\" as *;\n@use \"vendor/rfs\" as *;\n@use \"variables\" as *;\n\n.toast {\n  // scss-docs-start toast-css-vars\n  --#{$prefix}toast-zindex: #{$zindex-toast};\n  --#{$prefix}toast-padding-x: #{$toast-padding-x};\n  --#{$prefix}toast-padding-y: #{$toast-padding-y};\n  --#{$prefix}toast-spacing: #{$toast-spacing};\n  --#{$prefix}toast-max-width: #{$toast-max-width};\n  @include rfs($toast-font-size, --#{$prefix}toast-font-size);\n  --#{$prefix}toast-color: #{$toast-color};\n  --#{$prefix}toast-bg: #{$toast-background-color};\n  --#{$prefix}toast-border-width: #{$toast-border-width};\n  --#{$prefix}toast-border-color: #{$toast-border-color};\n  --#{$prefix}toast-border-radius: #{$toast-border-radius};\n  --#{$prefix}toast-box-shadow: #{$toast-box-shadow};\n  --#{$prefix}toast-header-color: #{$toast-header-color};\n  --#{$prefix}toast-header-bg: #{$toast-header-background-color};\n  --#{$prefix}toast-header-border-color: #{$toast-header-border-color};\n  // scss-docs-end toast-css-vars\n\n  width: var(--#{$prefix}toast-max-width);\n  max-width: 100%;\n  @include font-size(var(--#{$prefix}toast-font-size));\n  color: var(--#{$prefix}toast-color);\n  pointer-events: auto;\n  background-color: var(--#{$prefix}toast-bg);\n  background-clip: padding-box;\n  border: var(--#{$prefix}toast-border-width) solid var(--#{$prefix}toast-border-color);\n  box-shadow: var(--#{$prefix}toast-box-shadow);\n  @include border-radius(var(--#{$prefix}toast-border-radius));\n\n  &.showing {\n    opacity: 0;\n  }\n\n  &:not(.show) {\n    display: none;\n  }\n}\n\n.toast-container {\n  --#{$prefix}toast-zindex: #{$zindex-toast};\n\n  position: absolute;\n  z-index: var(--#{$prefix}toast-zindex);\n  width: max-content;\n  max-width: 100%;\n  pointer-events: none;\n\n  > :not(:last-child) {\n    margin-bottom: var(--#{$prefix}toast-spacing);\n  }\n}\n\n.toast-header {\n  display: flex;\n  align-items: center;\n  padding: var(--#{$prefix}toast-padding-y) var(--#{$prefix}toast-padding-x);\n  color: var(--#{$prefix}toast-header-color);\n  background-color: var(--#{$prefix}toast-header-bg);\n  background-clip: padding-box;\n  border-bottom: var(--#{$prefix}toast-border-width) solid var(--#{$prefix}toast-header-border-color);\n  @include border-top-radius(calc(var(--#{$prefix}toast-border-radius) - var(--#{$prefix}toast-border-width)));\n\n  .btn-close {\n    margin-inline: var(--#{$prefix}toast-padding-x) calc(-.5 * var(--#{$prefix}toast-padding-x)); // stylelint-disable-line function-disallowed-list\n  }\n}\n\n.toast-body {\n  padding: var(--#{$prefix}toast-padding-x);\n  word-wrap: break-word;\n}\n","// stylelint-disable function-disallowed-list\n@use \"sass:map\";\n@use \"mixins/backdrop\" as *;\n@use \"mixins/border-radius\" as *;\n@use \"mixins/box-shadow\" as *;\n@use \"mixins/breakpoints\" as *;\n@use \"mixins/transition\" as *;\n@use \"variables\" as *;\n\n// .modal-open      - body class for killing the scroll\n// .modal           - container to scroll within\n// .modal-dialog    - positioning shell for the actual modal\n// .modal-content   - actual modal w/ bg and corners and stuff\n\n\n// Container that the modal scrolls within\n.modal {\n  // scss-docs-start modal-css-vars\n  --#{$prefix}modal-zindex: #{$zindex-modal};\n  --#{$prefix}modal-width: #{$modal-md};\n  --#{$prefix}modal-padding: #{$modal-inner-padding};\n  --#{$prefix}modal-margin: #{$modal-dialog-margin};\n  --#{$prefix}modal-color: #{$modal-content-color};\n  --#{$prefix}modal-bg: #{$modal-content-bg};\n  --#{$prefix}modal-border-color: #{$modal-content-border-color};\n  --#{$prefix}modal-border-width: #{$modal-content-border-width};\n  --#{$prefix}modal-border-radius: #{$modal-content-border-radius};\n  --#{$prefix}modal-box-shadow: #{$modal-content-box-shadow-xs};\n  --#{$prefix}modal-inner-border-radius: #{$modal-content-inner-border-radius};\n  --#{$prefix}modal-header-padding-x: #{$modal-header-padding-x};\n  --#{$prefix}modal-header-padding-y: #{$modal-header-padding-y};\n  --#{$prefix}modal-header-padding: #{$modal-header-padding}; // Todo in v6: Split this padding into x and y\n  --#{$prefix}modal-header-border-color: #{$modal-header-border-color};\n  --#{$prefix}modal-header-border-width: #{$modal-header-border-width};\n  --#{$prefix}modal-title-line-height: #{$modal-title-line-height};\n  --#{$prefix}modal-footer-gap: #{$modal-footer-margin-between};\n  --#{$prefix}modal-footer-bg: #{$modal-footer-bg};\n  --#{$prefix}modal-footer-border-color: #{$modal-footer-border-color};\n  --#{$prefix}modal-footer-border-width: #{$modal-footer-border-width};\n  // scss-docs-end modal-css-vars\n\n  position: fixed;\n  inset-inline-start: 0;\n  top: 0;\n  z-index: var(--#{$prefix}modal-zindex);\n  display: none;\n  width: 100%;\n  height: 100%;\n  overflow-x: hidden;\n  overflow-y: auto;\n  // Prevent Chrome on Windows from adding a focus outline. For details, see\n  // https://github.com/twbs/bootstrap/pull/10951.\n  outline: 0;\n  // We deliberately don't use `-webkit-overflow-scrolling: touch;` due to a\n  // gnarly iOS Safari bug: https://bugs.webkit.org/show_bug.cgi?id=158342\n  // See also https://github.com/twbs/bootstrap/issues/17695\n}\n\n// Shell div to position the modal with bottom padding\n.modal-dialog {\n  position: relative;\n  width: auto;\n  margin: var(--#{$prefix}modal-margin);\n  // allow clicks to pass through for custom click handling to close modal\n  pointer-events: none;\n\n  // When fading in the modal, animate it to slide down\n  .modal.fade & {\n    transform: $modal-fade-transform;\n    @include transition($modal-transition);\n  }\n  .modal.show & {\n    transform: $modal-show-transform;\n  }\n\n  // When trying to close, animate focus to scale\n  .modal.modal-static & {\n    transform: $modal-scale-transform;\n  }\n}\n\n.modal-dialog-scrollable {\n  height: calc(100% - var(--#{$prefix}modal-margin) * 2);\n\n  .modal-content {\n    max-height: 100%;\n    overflow: hidden;\n  }\n\n  .modal-body {\n    overflow-y: auto;\n  }\n}\n\n.modal-dialog-centered {\n  display: flex;\n  align-items: center;\n  min-height: calc(100% - var(--#{$prefix}modal-margin) * 2);\n}\n\n// Actual modal\n.modal-content {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  width: 100%; // Ensure `.modal-content` extends the full width of the parent `.modal-dialog`\n  // counteract the pointer-events: none; in the .modal-dialog\n  color: var(--#{$prefix}modal-color);\n  pointer-events: auto;\n  background-color: var(--#{$prefix}modal-bg);\n  background-clip: padding-box;\n  border: var(--#{$prefix}modal-border-width) solid var(--#{$prefix}modal-border-color);\n  @include border-radius(var(--#{$prefix}modal-border-radius));\n  @include box-shadow(var(--#{$prefix}modal-box-shadow));\n  // Remove focus outline from opened modal\n  outline: 0;\n}\n\n// Modal background\n.modal-backdrop {\n  // scss-docs-start modal-backdrop-css-vars\n  --#{$prefix}backdrop-zindex: #{$zindex-modal-backdrop};\n  --#{$prefix}backdrop-bg: #{$modal-backdrop-bg};\n  --#{$prefix}backdrop-opacity: #{$modal-backdrop-opacity};\n  // scss-docs-end modal-backdrop-css-vars\n\n  @include overlay-backdrop(var(--#{$prefix}backdrop-zindex), var(--#{$prefix}backdrop-bg), var(--#{$prefix}backdrop-opacity));\n}\n\n// Modal header\n// Top section of the modal w/ title and dismiss\n.modal-header {\n  display: flex;\n  flex-shrink: 0;\n  align-items: center;\n  padding: var(--#{$prefix}modal-header-padding);\n  border-bottom: var(--#{$prefix}modal-header-border-width) solid var(--#{$prefix}modal-header-border-color);\n  @include border-top-radius(var(--#{$prefix}modal-inner-border-radius));\n\n  .btn-close {\n    padding: calc(var(--#{$prefix}modal-header-padding-y) * .5) calc(var(--#{$prefix}modal-header-padding-x) * .5);\n    margin-inline-start: auto;\n    margin-inline-end: calc(-.5 * var(--#{$prefix}modal-header-padding-x));\n    margin-top: calc(-.5 * var(--#{$prefix}modal-header-padding-y));\n    margin-bottom: calc(-.5 * var(--#{$prefix}modal-header-padding-y));\n  }\n}\n\n// Title text within header\n.modal-title {\n  margin-bottom: 0;\n  line-height: var(--#{$prefix}modal-title-line-height);\n}\n\n// Modal body\n// Where all modal content resides (sibling of .modal-header and .modal-footer)\n.modal-body {\n  position: relative;\n  // Enable `flex-grow: 1` so that the body take up as much space as possible\n  // when there should be a fixed height on `.modal-dialog`.\n  flex: 1 1 auto;\n  padding: var(--#{$prefix}modal-padding);\n}\n\n// Footer (for actions)\n.modal-footer {\n  display: flex;\n  flex-shrink: 0;\n  flex-wrap: wrap;\n  align-items: center; // vertically center\n  justify-content: flex-end; // Right align buttons with flex property because text-align doesn't work on flex items\n  padding: calc(var(--#{$prefix}modal-padding) - var(--#{$prefix}modal-footer-gap) * .5);\n  background-color: var(--#{$prefix}modal-footer-bg);\n  border-top: var(--#{$prefix}modal-footer-border-width) solid var(--#{$prefix}modal-footer-border-color);\n  @include border-bottom-radius(var(--#{$prefix}modal-inner-border-radius));\n\n  // Place margin between footer elements\n  // This solution is far from ideal because of the universal selector usage,\n  // but is needed to fix https://github.com/twbs/bootstrap/issues/24800\n  > * {\n    margin: calc(var(--#{$prefix}modal-footer-gap) * .5); // Todo in v6: replace with gap on parent class\n  }\n}\n\n// Scale up the modal\n@include media-breakpoint-up(sm) {\n  .modal {\n    --#{$prefix}modal-margin: #{$modal-dialog-margin-y-sm-up};\n    --#{$prefix}modal-box-shadow: #{$modal-content-box-shadow-sm-up};\n  }\n\n  // Automatically set modal's width for larger viewports\n  .modal-dialog {\n    max-width: var(--#{$prefix}modal-width);\n    margin-right: auto;\n    margin-left: auto;\n  }\n\n  .modal-sm {\n    --#{$prefix}modal-width: #{$modal-sm};\n  }\n}\n\n@include media-breakpoint-up(lg) {\n  .modal-lg,\n  .modal-xl {\n    --#{$prefix}modal-width: #{$modal-lg};\n  }\n}\n\n@include media-breakpoint-up(xl) {\n  .modal-xl {\n    --#{$prefix}modal-width: #{$modal-xl};\n  }\n}\n\n// scss-docs-start modal-fullscreen-loop\n@each $breakpoint in map.keys($grid-breakpoints) {\n  $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n  // stylelint-disable-next-line scss/at-function-named-arguments\n  $postfix: if(sass($infix != \"\"): $infix + \"-down\"; else: \"\");\n\n  @include media-breakpoint-down($breakpoint) {\n    .modal-fullscreen#{$postfix} {\n      width: 100vw;\n      max-width: none;\n      height: 100%;\n      margin: 0;\n\n      .modal-content {\n        height: 100%;\n        border: 0;\n        @include border-radius(0);\n      }\n\n      .modal-header,\n      .modal-footer {\n        @include border-radius(0);\n      }\n\n      .modal-body {\n        overflow-y: auto;\n      }\n    }\n  }\n}\n// scss-docs-end modal-fullscreen-loop\n","@use \"../variables\" as *;\n\n// Shared between modals and offcanvases\n@mixin overlay-backdrop($zindex, $backdrop-bg, $backdrop-opacity) {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: $zindex;\n  width: 100vw;\n  height: 100vh;\n  background-color: $backdrop-bg;\n\n  // Fade for backdrop\n  &.fade { opacity: 0; }\n  &.show { opacity: $backdrop-opacity; }\n}\n","@use \"mixins/border-radius\" as *;\n@use \"mixins/deprecate\" as *;\n@use \"mixins/reset-text\" as *;\n@use \"vendor/rfs\" as *;\n@use \"variables\" as *;\n\n// Base class\n.tooltip {\n  // scss-docs-start tooltip-css-vars\n  --#{$prefix}tooltip-zindex: #{$zindex-tooltip};\n  --#{$prefix}tooltip-max-width: #{$tooltip-max-width};\n  --#{$prefix}tooltip-padding-x: #{$tooltip-padding-x};\n  --#{$prefix}tooltip-padding-y: #{$tooltip-padding-y};\n  --#{$prefix}tooltip-margin: #{$tooltip-margin};\n  @include rfs($tooltip-font-size, --#{$prefix}tooltip-font-size);\n  --#{$prefix}tooltip-color: #{$tooltip-color};\n  --#{$prefix}tooltip-bg: #{$tooltip-bg};\n  --#{$prefix}tooltip-border-radius: #{$tooltip-border-radius};\n  --#{$prefix}tooltip-opacity: #{$tooltip-opacity};\n  --#{$prefix}tooltip-arrow-width: #{$tooltip-arrow-width};\n  --#{$prefix}tooltip-arrow-height: #{$tooltip-arrow-height};\n  // scss-docs-end tooltip-css-vars\n\n  z-index: var(--#{$prefix}tooltip-zindex);\n  display: block;\n  margin: var(--#{$prefix}tooltip-margin);\n  @include deprecate(\"`$tooltip-margin`\", \"v4\", \"v4.x\", true);\n  // Our parent element can be arbitrary since tooltips are by default inserted as a sibling of their target element.\n  // So reset our font and text properties to avoid inheriting weird values.\n  @include reset-text();\n  @include font-size(var(--#{$prefix}tooltip-font-size));\n  // Allow breaking very long words so they don't overflow the tooltip's bounds\n  word-wrap: break-word;\n  opacity: 0;\n\n  &.show { opacity: var(--#{$prefix}tooltip-opacity); }\n\n  .tooltip-arrow {\n    display: block;\n    width: var(--#{$prefix}tooltip-arrow-width);\n    height: var(--#{$prefix}tooltip-arrow-height);\n\n    &::before {\n      position: absolute;\n      content: \"\";\n      border-color: transparent;\n      border-style: solid;\n    }\n  }\n}\n\n.bs-tooltip-top .tooltip-arrow {\n  bottom: calc(-1 * var(--#{$prefix}tooltip-arrow-height)); // stylelint-disable-line function-disallowed-list\n\n  &::before {\n    top: -1px;\n    border-width: var(--#{$prefix}tooltip-arrow-height) calc(var(--#{$prefix}tooltip-arrow-width) * .5) 0; // stylelint-disable-line function-disallowed-list\n    border-top-color: var(--#{$prefix}tooltip-bg);\n  }\n}\n\n/* rtl:begin:ignore */\n.bs-tooltip-end .tooltip-arrow {\n  left: calc(-1 * var(--#{$prefix}tooltip-arrow-height)); // stylelint-disable-line function-disallowed-list\n  width: var(--#{$prefix}tooltip-arrow-height);\n  height: var(--#{$prefix}tooltip-arrow-width);\n\n  &::before {\n    right: -1px;\n    border-width: calc(var(--#{$prefix}tooltip-arrow-width) * .5) var(--#{$prefix}tooltip-arrow-height) calc(var(--#{$prefix}tooltip-arrow-width) * .5) 0; // stylelint-disable-line function-disallowed-list\n    border-right-color: var(--#{$prefix}tooltip-bg);\n  }\n}\n\n/* rtl:end:ignore */\n\n.bs-tooltip-bottom .tooltip-arrow {\n  top: calc(-1 * var(--#{$prefix}tooltip-arrow-height)); // stylelint-disable-line function-disallowed-list\n\n  &::before {\n    bottom: -1px;\n    border-width: 0 calc(var(--#{$prefix}tooltip-arrow-width) * .5) var(--#{$prefix}tooltip-arrow-height); // stylelint-disable-line function-disallowed-list\n    border-bottom-color: var(--#{$prefix}tooltip-bg);\n  }\n}\n\n/* rtl:begin:ignore */\n.bs-tooltip-start .tooltip-arrow {\n  right: calc(-1 * var(--#{$prefix}tooltip-arrow-height)); // stylelint-disable-line function-disallowed-list\n  width: var(--#{$prefix}tooltip-arrow-height);\n  height: var(--#{$prefix}tooltip-arrow-width);\n\n  &::before {\n    left: -1px;\n    border-width: calc(var(--#{$prefix}tooltip-arrow-width) * .5) 0 calc(var(--#{$prefix}tooltip-arrow-width) * .5) var(--#{$prefix}tooltip-arrow-height); // stylelint-disable-line function-disallowed-list\n    border-left-color: var(--#{$prefix}tooltip-bg);\n  }\n}\n\n/* rtl:end:ignore */\n\n.bs-tooltip-auto {\n  &[data-popper-placement^=\"top\"] {\n    @extend .bs-tooltip-top;\n  }\n  &[data-popper-placement^=\"right\"] {\n    @extend .bs-tooltip-end;\n  }\n  &[data-popper-placement^=\"bottom\"] {\n    @extend .bs-tooltip-bottom;\n  }\n  &[data-popper-placement^=\"left\"] {\n    @extend .bs-tooltip-start;\n  }\n}\n\n// Wrapper for the tooltip content\n.tooltip-inner {\n  max-width: var(--#{$prefix}tooltip-max-width);\n  padding: var(--#{$prefix}tooltip-padding-y) var(--#{$prefix}tooltip-padding-x);\n  color: var(--#{$prefix}tooltip-color);\n  text-align: center;\n  background-color: var(--#{$prefix}tooltip-bg);\n  @include border-radius(var(--#{$prefix}tooltip-border-radius));\n}\n","@use \"../variables\" as *;\n\n@mixin reset-text {\n  font-family: $font-family-base;\n  // We deliberately do NOT reset font-size or overflow-wrap / word-wrap.\n  font-style: normal;\n  font-weight: $font-weight-normal;\n  line-height: $line-height-base;\n  text-align: start;\n  text-decoration: none;\n  text-shadow: none;\n  text-transform: none;\n  letter-spacing: normal;\n  word-break: normal;\n  white-space: normal;\n  word-spacing: normal;\n  line-break: auto;\n}\n","@use \"mixins/border-radius\" as *;\n@use \"mixins/box-shadow\" as *;\n@use \"mixins/reset-text\" as *;\n@use \"vendor/rfs\" as *;\n@use \"variables\" as *;\n\n.popover {\n  // scss-docs-start popover-css-vars\n  --#{$prefix}popover-zindex: #{$zindex-popover};\n  --#{$prefix}popover-max-width: #{$popover-max-width};\n  @include rfs($popover-font-size, --#{$prefix}popover-font-size);\n  --#{$prefix}popover-bg: #{$popover-bg};\n  --#{$prefix}popover-border-width: #{$popover-border-width};\n  --#{$prefix}popover-border-color: #{$popover-border-color};\n  --#{$prefix}popover-border-radius: #{$popover-border-radius};\n  --#{$prefix}popover-inner-border-radius: #{$popover-inner-border-radius};\n  --#{$prefix}popover-box-shadow: #{$popover-box-shadow};\n  --#{$prefix}popover-header-padding-x: #{$popover-header-padding-x};\n  --#{$prefix}popover-header-padding-y: #{$popover-header-padding-y};\n  @include rfs($popover-header-font-size, --#{$prefix}popover-header-font-size);\n  --#{$prefix}popover-header-color: #{$popover-header-color};\n  --#{$prefix}popover-header-bg: #{$popover-header-bg};\n  --#{$prefix}popover-body-padding-x: #{$popover-body-padding-x};\n  --#{$prefix}popover-body-padding-y: #{$popover-body-padding-y};\n  --#{$prefix}popover-body-color: #{$popover-body-color};\n  --#{$prefix}popover-arrow-width: #{$popover-arrow-width};\n  --#{$prefix}popover-arrow-height: #{$popover-arrow-height};\n  --#{$prefix}popover-arrow-border: var(--#{$prefix}popover-border-color);\n  // scss-docs-end popover-css-vars\n\n  z-index: var(--#{$prefix}popover-zindex);\n  display: block;\n  max-width: var(--#{$prefix}popover-max-width);\n  // Our parent element can be arbitrary since tooltips are by default inserted as a sibling of their target element.\n  // So reset our font and text properties to avoid inheriting weird values.\n  @include reset-text();\n  @include font-size(var(--#{$prefix}popover-font-size));\n  // Allow breaking very long words so they don't overflow the popover's bounds\n  word-wrap: break-word;\n  background-color: var(--#{$prefix}popover-bg);\n  background-clip: padding-box;\n  border: var(--#{$prefix}popover-border-width) solid var(--#{$prefix}popover-border-color);\n  @include border-radius(var(--#{$prefix}popover-border-radius));\n  @include box-shadow(var(--#{$prefix}popover-box-shadow));\n\n  .popover-arrow {\n    display: block;\n    width: var(--#{$prefix}popover-arrow-width);\n    height: var(--#{$prefix}popover-arrow-height);\n\n    &::before,\n    &::after {\n      position: absolute;\n      display: block;\n      content: \"\";\n      border-color: transparent;\n      border-style: solid;\n      border-width: 0;\n    }\n  }\n}\n\n.bs-popover-top {\n  > .popover-arrow {\n    bottom: calc(-1 * (var(--#{$prefix}popover-arrow-height)) - var(--#{$prefix}popover-border-width)); // stylelint-disable-line function-disallowed-list\n\n    &::before,\n    &::after {\n      border-width: var(--#{$prefix}popover-arrow-height) calc(var(--#{$prefix}popover-arrow-width) * .5) 0; // stylelint-disable-line function-disallowed-list\n    }\n\n    &::before {\n      bottom: 0;\n      border-top-color: var(--#{$prefix}popover-arrow-border);\n    }\n\n    &::after {\n      bottom: var(--#{$prefix}popover-border-width);\n      border-top-color: var(--#{$prefix}popover-bg);\n    }\n  }\n}\n\n/* rtl:begin:ignore */\n.bs-popover-end {\n  > .popover-arrow {\n    left: calc(-1 * (var(--#{$prefix}popover-arrow-height)) - var(--#{$prefix}popover-border-width)); // stylelint-disable-line function-disallowed-list\n    width: var(--#{$prefix}popover-arrow-height);\n    height: var(--#{$prefix}popover-arrow-width);\n\n    &::before,\n    &::after {\n      border-width: calc(var(--#{$prefix}popover-arrow-width) * .5) var(--#{$prefix}popover-arrow-height) calc(var(--#{$prefix}popover-arrow-width) * .5) 0; // stylelint-disable-line function-disallowed-list\n    }\n\n    &::before {\n      left: 0;\n      border-right-color: var(--#{$prefix}popover-arrow-border);\n    }\n\n    &::after {\n      left: var(--#{$prefix}popover-border-width);\n      border-right-color: var(--#{$prefix}popover-bg);\n    }\n  }\n}\n\n/* rtl:end:ignore */\n\n.bs-popover-bottom {\n  > .popover-arrow {\n    top: calc(-1 * (var(--#{$prefix}popover-arrow-height)) - var(--#{$prefix}popover-border-width)); // stylelint-disable-line function-disallowed-list\n\n    &::before,\n    &::after {\n      border-width: 0 calc(var(--#{$prefix}popover-arrow-width) * .5) var(--#{$prefix}popover-arrow-height); // stylelint-disable-line function-disallowed-list\n    }\n\n    &::before {\n      top: 0;\n      border-bottom-color: var(--#{$prefix}popover-arrow-border);\n    }\n\n    &::after {\n      top: var(--#{$prefix}popover-border-width);\n      border-bottom-color: var(--#{$prefix}popover-bg);\n    }\n  }\n\n  // This will remove the popover-header's border just below the arrow\n  .popover-header::before {\n    position: absolute;\n    top: 0;\n    left: 50%;\n    display: block;\n    width: var(--#{$prefix}popover-arrow-width);\n    margin-left: calc(-.5 * var(--#{$prefix}popover-arrow-width)); // stylelint-disable-line function-disallowed-list\n    content: \"\";\n    border-bottom: var(--#{$prefix}popover-border-width) solid var(--#{$prefix}popover-header-bg);\n  }\n}\n\n/* rtl:begin:ignore */\n.bs-popover-start {\n  > .popover-arrow {\n    right: calc(-1 * (var(--#{$prefix}popover-arrow-height)) - var(--#{$prefix}popover-border-width)); // stylelint-disable-line function-disallowed-list\n    width: var(--#{$prefix}popover-arrow-height);\n    height: var(--#{$prefix}popover-arrow-width);\n\n    &::before,\n    &::after {\n      border-width: calc(var(--#{$prefix}popover-arrow-width) * .5) 0 calc(var(--#{$prefix}popover-arrow-width) * .5) var(--#{$prefix}popover-arrow-height); // stylelint-disable-line function-disallowed-list\n    }\n\n    &::before {\n      right: 0;\n      border-left-color: var(--#{$prefix}popover-arrow-border);\n    }\n\n    &::after {\n      right: var(--#{$prefix}popover-border-width);\n      border-left-color: var(--#{$prefix}popover-bg);\n    }\n  }\n}\n\n/* rtl:end:ignore */\n\n.bs-popover-auto {\n  &[data-popper-placement^=\"top\"] {\n    @extend .bs-popover-top;\n  }\n  &[data-popper-placement^=\"right\"] {\n    @extend .bs-popover-end;\n  }\n  &[data-popper-placement^=\"bottom\"] {\n    @extend .bs-popover-bottom;\n  }\n  &[data-popper-placement^=\"left\"] {\n    @extend .bs-popover-start;\n  }\n}\n\n// Offset the popover to account for the popover arrow\n.popover-header {\n  padding: var(--#{$prefix}popover-header-padding-y) var(--#{$prefix}popover-header-padding-x);\n  margin-bottom: 0; // Reset the default from Reboot\n  @include font-size(var(--#{$prefix}popover-header-font-size));\n  color: var(--#{$prefix}popover-header-color);\n  background-color: var(--#{$prefix}popover-header-bg);\n  border-bottom: var(--#{$prefix}popover-border-width) solid var(--#{$prefix}popover-border-color);\n  @include border-top-radius(var(--#{$prefix}popover-inner-border-radius));\n\n  &:empty {\n    display: none;\n  }\n}\n\n.popover-body {\n  padding: var(--#{$prefix}popover-body-padding-y) var(--#{$prefix}popover-body-padding-x);\n  color: var(--#{$prefix}popover-body-color);\n}\n","@use \"functions/escape-svg\" as *;\n@use \"mixins/clearfix\" as *;\n@use \"mixins/color-mode\" as *;\n@use \"mixins/ltr-rtl\" as *;\n@use \"mixins/transition\" as *;\n@use \"variables\" as *;\n@use \"variables-dark\" as *;\n\n// Notes on the classes:\n//\n// 1. .carousel.pointer-event should ideally be pan-y (to allow for users to scroll vertically)\n//    even when their scroll action started on a carousel, but for compatibility (with Firefox)\n//    we're preventing all actions instead\n// 2. The .carousel-item-start and .carousel-item-end is used to indicate where\n//    the active slide is heading.\n// 3. .active.carousel-item is the current slide.\n// 4. .active.carousel-item-start and .active.carousel-item-end is the current\n//    slide in its in-transition state. Only one of these occurs at a time.\n// 5. .carousel-item-next.carousel-item-start and .carousel-item-prev.carousel-item-end\n//    is the upcoming slide in transition.\n\n.carousel {\n  position: relative;\n}\n\n.carousel.pointer-event {\n  touch-action: pan-y;\n}\n\n.carousel-inner {\n  position: relative;\n  width: 100%;\n  overflow: hidden;\n  @include clearfix();\n}\n\n.carousel-item {\n  position: relative;\n  display: none;\n  float: left;\n  width: 100%;\n  margin-right: -100%;\n  backface-visibility: hidden;\n  @include transition($carousel-transition);\n}\n\n.carousel-item.active,\n.carousel-item-next,\n.carousel-item-prev {\n  display: block;\n}\n\n.carousel-item-next:not(.carousel-item-start),\n.active.carousel-item-end {\n  transform: translateX(100%);\n}\n\n.carousel-item-prev:not(.carousel-item-end),\n.active.carousel-item-start {\n  transform: translateX(-100%);\n}\n\n\n//\n// Alternate transitions\n//\n\n.carousel-fade {\n  .carousel-item {\n    opacity: 0;\n    transition-property: opacity;\n    transform: none;\n  }\n\n  .carousel-item.active,\n  .carousel-item-next.carousel-item-start,\n  .carousel-item-prev.carousel-item-end {\n    z-index: 1;\n    opacity: 1;\n  }\n\n  .active.carousel-item-start,\n  .active.carousel-item-end {\n    z-index: 0;\n    opacity: 0;\n    @include transition(opacity 0s $carousel-transition-duration);\n  }\n}\n\n\n//\n// Left/right controls for nav\n//\n\n.carousel-control-prev,\n.carousel-control-next {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  z-index: 1;\n  // Use flex for alignment (1-3)\n  display: flex; // 1. allow flex styles\n  align-items: center; // 2. vertically center contents\n  justify-content: center; // 3. horizontally center contents\n  width: $carousel-control-width;\n  padding: 0;\n  color: $carousel-control-color;\n  text-align: center;\n  background: none;\n  filter: var(--#{$prefix}carousel-control-icon-filter);\n  border: 0;\n  opacity: $carousel-control-opacity;\n  @include transition($carousel-control-transition);\n\n  // Hover/focus state\n  &:hover,\n  &:focus {\n    color: $carousel-control-color;\n    text-decoration: none;\n    outline: 0;\n    opacity: $carousel-control-hover-opacity;\n  }\n}\n.carousel-control-prev {\n  left: 0;\n  // stylelint-disable-next-line scss/at-function-named-arguments\n  background-image: if(sass($enable-gradients): linear-gradient(90deg, rgba($black, .25), rgba($black, .001)));\n}\n.carousel-control-next {\n  right: 0;\n  // stylelint-disable-next-line scss/at-function-named-arguments\n  background-image: if(sass($enable-gradients): linear-gradient(270deg, rgba($black, .25), rgba($black, .001)));\n}\n\n// Icons for within\n.carousel-control-prev-icon,\n.carousel-control-next-icon {\n  display: inline-block;\n  width: $carousel-control-icon-width;\n  height: $carousel-control-icon-width;\n  background-repeat: no-repeat;\n  background-position: 50%;\n  background-size: 100% 100%;\n}\n\n.carousel-control-prev-icon {\n  @include ltr-rtl-value-only(\"background-image\", escape-svg($carousel-control-prev-icon-bg), escape-svg($carousel-control-next-icon-bg));\n}\n.carousel-control-next-icon {\n  @include ltr-rtl-value-only(\"background-image\", escape-svg($carousel-control-next-icon-bg), escape-svg($carousel-control-prev-icon-bg));\n}\n\n// Optional indicator pips/controls\n//\n// Add a container (such as a list) with the following class and add an item (ideally a focusable control,\n// like a button) with data#{$data-infix}target for each slide your carousel holds.\n\n.carousel-indicators {\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 2;\n  display: flex;\n  justify-content: center;\n  padding: 0;\n  // Use the .carousel-control's width as margin so we don't overlay those\n  margin-right: $carousel-control-width;\n  margin-bottom: 1rem;\n  margin-left: $carousel-control-width;\n\n  [data#{$data-infix}target] {\n    box-sizing: content-box;\n    flex: 0 1 auto;\n    width: $carousel-indicator-width;\n    height: $carousel-indicator-height;\n    padding: 0;\n    margin-right: $carousel-indicator-spacer;\n    margin-left: $carousel-indicator-spacer;\n    text-indent: -999px;\n    cursor: pointer;\n    background-color: $carousel-indicator-active-bg;\n    background-clip: padding-box;\n    border: 0;\n    // Use transparent borders to increase the hit area by 10px on top and bottom.\n    border-top: $carousel-indicator-hit-area-height solid transparent;\n    border-bottom: $carousel-indicator-hit-area-height solid transparent;\n    opacity: $carousel-indicator-opacity;\n    @include transition($carousel-indicator-transition);\n  }\n\n  .active {\n    opacity: $carousel-indicator-active-opacity;\n  }\n}\n\n\n// Optional captions\n//\n//\n\n.carousel-caption {\n  position: absolute;\n  right: (100% - $carousel-caption-width) * .5;\n  bottom: $carousel-caption-spacer;\n  left: (100% - $carousel-caption-width) * .5;\n  padding-top: $carousel-caption-padding-y;\n  padding-bottom: $carousel-caption-padding-y;\n  color: var(--#{$prefix}carousel-caption-color);\n  text-align: center;\n}\n\n// Dark mode carousel\n\n@mixin carousel-dark() {\n  --#{$prefix}carousel-indicator-active-bg: #{$carousel-indicator-active-bg-dark};\n  --#{$prefix}carousel-caption-color: #{$carousel-caption-color-dark};\n  --#{$prefix}carousel-control-icon-filter: #{$carousel-control-icon-filter-dark};\n}\n\n.carousel-dark {\n  @include carousel-dark();\n}\n\n:root,\n[data#{$data-infix}theme=\"light\"] {\n  --#{$prefix}carousel-indicator-active-bg: #{$carousel-indicator-active-bg};\n  --#{$prefix}carousel-caption-color: #{$carousel-caption-color};\n  --#{$prefix}carousel-control-icon-filter: #{$carousel-control-icon-filter};\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark, true) {\n    @include carousel-dark();\n  }\n}\n","// scss-docs-start clearfix\n@mixin clearfix() {\n  &::after {\n    display: block;\n    clear: both;\n    content: \"\";\n  }\n}\n// scss-docs-end clearfix\n","@use \"variables\" as *;\n\n//\n// Rotating border\n//\n\n.spinner-grow,\n.spinner-border {\n  display: inline-block;\n  flex-shrink: 0;\n  width: var(--#{$prefix}spinner-width);\n  height: var(--#{$prefix}spinner-height);\n  vertical-align: var(--#{$prefix}spinner-vertical-align);\n  // stylelint-disable-next-line property-disallowed-list\n  border-radius: 50%;\n  animation: var(--#{$prefix}spinner-animation-speed) linear infinite var(--#{$prefix}spinner-animation-name);\n}\n\n// scss-docs-start spinner-border-keyframes\n@keyframes spinner-border {\n  to { transform: rotate(360deg) #{\"/* rtl:ignore */\"}; }\n}\n// scss-docs-end spinner-border-keyframes\n\n.spinner-border {\n  // scss-docs-start spinner-border-css-vars\n  --#{$prefix}spinner-width: #{$spinner-width};\n  --#{$prefix}spinner-height: #{$spinner-height};\n  --#{$prefix}spinner-vertical-align: #{$spinner-vertical-align};\n  --#{$prefix}spinner-border-width: #{$spinner-border-width};\n  --#{$prefix}spinner-animation-speed: #{$spinner-animation-speed};\n  --#{$prefix}spinner-animation-name: spinner-border;\n  // scss-docs-end spinner-border-css-vars\n\n  border: var(--#{$prefix}spinner-border-width) solid currentcolor;\n  border-right-color: transparent;\n}\n\n.spinner-border-sm {\n  // scss-docs-start spinner-border-sm-css-vars\n  --#{$prefix}spinner-width: #{$spinner-width-sm};\n  --#{$prefix}spinner-height: #{$spinner-height-sm};\n  --#{$prefix}spinner-border-width: #{$spinner-border-width-sm};\n  // scss-docs-end spinner-border-sm-css-vars\n}\n\n//\n// Growing circle\n//\n\n// scss-docs-start spinner-grow-keyframes\n@keyframes spinner-grow {\n  0% {\n    transform: scale(0);\n  }\n  50% {\n    opacity: 1;\n    transform: none;\n  }\n}\n// scss-docs-end spinner-grow-keyframes\n\n.spinner-grow {\n  // scss-docs-start spinner-grow-css-vars\n  --#{$prefix}spinner-width: #{$spinner-width};\n  --#{$prefix}spinner-height: #{$spinner-height};\n  --#{$prefix}spinner-vertical-align: #{$spinner-vertical-align};\n  --#{$prefix}spinner-animation-speed: #{$spinner-animation-speed};\n  --#{$prefix}spinner-animation-name: spinner-grow;\n  // scss-docs-end spinner-grow-css-vars\n\n  background-color: currentcolor;\n  opacity: 0;\n}\n\n.spinner-grow-sm {\n  --#{$prefix}spinner-width: #{$spinner-width-sm};\n  --#{$prefix}spinner-height: #{$spinner-height-sm};\n}\n\n@if $enable-reduced-motion {\n  @media (prefers-reduced-motion: reduce) {\n    .spinner-border,\n    .spinner-grow {\n      --#{$prefix}spinner-animation-speed: #{$spinner-animation-speed * 2};\n    }\n  }\n}\n","// stylelint-disable function-disallowed-list\n@use \"sass:map\";\n@use \"mixins/backdrop\" as *;\n@use \"mixins/box-shadow\" as *;\n@use \"mixins/breakpoints\" as *;\n@use \"mixins/ltr-rtl\" as *;\n@use \"mixins/transition\" as *;\n@use \"variables\" as *;\n\n%offcanvas-css-vars {\n  // scss-docs-start offcanvas-css-vars\n  --#{$prefix}offcanvas-zindex: #{$zindex-offcanvas};\n  --#{$prefix}offcanvas-width: #{$offcanvas-horizontal-width};\n  --#{$prefix}offcanvas-height: #{$offcanvas-vertical-height};\n  --#{$prefix}offcanvas-padding-x: #{$offcanvas-padding-x};\n  --#{$prefix}offcanvas-padding-y: #{$offcanvas-padding-y};\n  --#{$prefix}offcanvas-color: #{$offcanvas-color};\n  --#{$prefix}offcanvas-bg: #{$offcanvas-bg-color};\n  --#{$prefix}offcanvas-border-width: #{$offcanvas-border-width};\n  --#{$prefix}offcanvas-border-color: #{$offcanvas-border-color};\n  --#{$prefix}offcanvas-box-shadow: #{$offcanvas-box-shadow};\n  --#{$prefix}offcanvas-transition: #{transform $offcanvas-transition-duration ease-in-out};\n  --#{$prefix}offcanvas-title-line-height: #{$offcanvas-title-line-height};\n  // scss-docs-end offcanvas-css-vars\n}\n\n@each $breakpoint in map.keys($grid-breakpoints) {\n  $next: breakpoint-next($breakpoint, $grid-breakpoints);\n  $infix: breakpoint-infix($next, $grid-breakpoints);\n\n  .offcanvas#{$infix} {\n    @extend %offcanvas-css-vars;\n  }\n}\n\n@each $breakpoint in map.keys($grid-breakpoints) {\n  $next: breakpoint-next($breakpoint, $grid-breakpoints);\n  $infix: breakpoint-infix($next, $grid-breakpoints);\n\n  .offcanvas#{$infix} {\n    @include media-breakpoint-down($next) {\n      position: fixed;\n      bottom: 0;\n      z-index: var(--#{$prefix}offcanvas-zindex);\n      display: flex;\n      flex-direction: column;\n      max-width: 100%;\n      color: var(--#{$prefix}offcanvas-color);\n      visibility: hidden;\n      background-color: var(--#{$prefix}offcanvas-bg);\n      background-clip: padding-box;\n      outline: 0;\n      @include box-shadow(var(--#{$prefix}offcanvas-box-shadow));\n      @include transition(var(--#{$prefix}offcanvas-transition));\n\n      &.offcanvas-start {\n        inset-inline-start: 0;\n        top: 0;\n        width: var(--#{$prefix}offcanvas-width);\n        border-inline-end: var(--#{$prefix}offcanvas-border-width) solid var(--#{$prefix}offcanvas-border-color);\n        @include ltr-rtl-value-only(\"transform\", translateX(-100%), translateX(100%));\n      }\n\n      &.offcanvas-end {\n        inset-inline-end: 0;\n        top: 0;\n        width: var(--#{$prefix}offcanvas-width);\n        border-inline-start: var(--#{$prefix}offcanvas-border-width) solid var(--#{$prefix}offcanvas-border-color);\n        transform: translateX(100%);\n      }\n\n      &.offcanvas-top {\n        top: 0;\n        right: 0;\n        left: 0;\n        height: var(--#{$prefix}offcanvas-height);\n        max-height: 100%;\n        border-bottom: var(--#{$prefix}offcanvas-border-width) solid var(--#{$prefix}offcanvas-border-color);\n        transform: translateY(-100%);\n      }\n\n      &.offcanvas-bottom {\n        right: 0;\n        left: 0;\n        height: var(--#{$prefix}offcanvas-height);\n        max-height: 100%;\n        border-top: var(--#{$prefix}offcanvas-border-width) solid var(--#{$prefix}offcanvas-border-color);\n        transform: translateY(100%);\n      }\n\n      &.showing,\n      &.show:not(.hiding) {\n        transform: none !important; // stylelint-disable-line declaration-no-important\n      }\n\n      &.showing,\n      &.hiding,\n      &.show {\n        visibility: visible;\n      }\n    }\n\n    @if not ($infix == \"\") {\n      @include media-breakpoint-up($next) {\n        --#{$prefix}offcanvas-height: auto;\n        --#{$prefix}offcanvas-border-width: 0;\n        background-color: transparent !important; // stylelint-disable-line declaration-no-important\n\n        .offcanvas-header {\n          display: none;\n        }\n\n        .offcanvas-body {\n          display: flex;\n          flex-grow: 0;\n          padding: 0;\n          overflow-y: visible;\n          // Reset `background-color` in case `.bg-*` classes are used in offcanvas\n          background-color: transparent !important; // stylelint-disable-line declaration-no-important\n        }\n      }\n    }\n  }\n}\n\n.offcanvas-backdrop {\n  @include overlay-backdrop($zindex-offcanvas-backdrop, var(--#{$prefix}offcanvas-backdrop-bg, $offcanvas-backdrop-bg), $offcanvas-backdrop-opacity);\n}\n\n.offcanvas-header {\n  display: flex;\n  align-items: center;\n  padding: var(--#{$prefix}offcanvas-padding-y) var(--#{$prefix}offcanvas-padding-x);\n\n  .btn-close {\n    padding: calc(var(--#{$prefix}offcanvas-padding-y) * .5) calc(var(--#{$prefix}offcanvas-padding-x) * .5);\n    margin-inline-start: auto;\n    margin-inline-end: calc(-.5 * var(--#{$prefix}offcanvas-padding-x));\n    margin-top: calc(-.5 * var(--#{$prefix}offcanvas-padding-y));\n    margin-bottom: calc(-.5 * var(--#{$prefix}offcanvas-padding-y));\n  }\n}\n\n.offcanvas-title {\n  margin-bottom: 0;\n  line-height: var(--#{$prefix}offcanvas-title-line-height);\n}\n\n.offcanvas-body {\n  flex-grow: 1;\n  padding: var(--#{$prefix}offcanvas-padding-y) var(--#{$prefix}offcanvas-padding-x);\n  overflow-y: auto;\n}\n","@use \"variables\" as *;\n\n.placeholder {\n  display: inline-block;\n  min-height: 1em;\n  vertical-align: middle;\n  cursor: wait;\n  background-color: currentcolor;\n  opacity: $placeholder-opacity-max;\n\n  &.btn::before {\n    display: inline-block;\n    content: \"\";\n  }\n}\n\n// Sizing\n.placeholder-xs {\n  min-height: .6em;\n}\n\n.placeholder-sm {\n  min-height: .8em;\n}\n\n.placeholder-lg {\n  min-height: 1.2em;\n}\n\n// Animation\n.placeholder-glow {\n  .placeholder {\n    animation: placeholder-glow 2s ease-in-out infinite;\n\n    @if $enable-reduced-motion {\n      @media (prefers-reduced-motion: reduce) {\n        animation: none;\n      }\n    }\n  }\n}\n\n@keyframes placeholder-glow {\n  50% {\n    opacity: $placeholder-opacity-min;\n  }\n}\n\n.placeholder-wave {\n  mask-image: linear-gradient(130deg, $black 55%, rgba(0, 0, 0, (1 - $placeholder-opacity-min)) 75%, $black 95%);\n  mask-size: 200% 100%;\n  animation: placeholder-wave 2s linear infinite;\n\n  @if $enable-reduced-motion {\n    @media (prefers-reduced-motion: reduce) {\n      animation: none;\n    }\n  }\n}\n\n@keyframes placeholder-wave {\n  100% {\n    mask-position: -200% 0%;\n  }\n}\n","@use \"sass:map\";\n@use \"mixins/border-radius\" as *;\n@use \"mixins/chip\" as *;\n@use \"mixins/focus-ring\" as *;\n@use \"mixins/transition\" as *;\n@use \"variables\" as *;\n\n// scss-docs-start chip-variables\n$chip-font-size:             .875rem !default;\n$chip-font-weight:           $font-weight-normal !default;\n$chip-height:                1.75rem !default;\n$chip-padding-x:             .625rem !default;\n$chip-gap:                   .3125rem !default;\n$chip-border-radius:         var(--#{$prefix}border-radius-pill) !default;\n$chip-icon-size:             1rem !default;\n$chip-img-size:              1.25rem !default;\n$chip-img-border-radius:     50% !default;\n$chip-remove-size:           1rem !default;\n$chip-remove-opacity:        .65 !default;\n$chip-remove-hover-opacity:  1 !default;\n$chip-transition:            background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out, color .15s ease-in-out !default;\n\n$chip-color:                 var(--#{$prefix}body-color) !default;\n$chip-bg:                    var(--#{$prefix}secondary-bg) !default;\n$chip-border-width:          var(--#{$prefix}border-width) !default;\n$chip-border-color:          transparent !default;\n\n$chip-active-color:          rgba($white, .87) !default;\n$chip-active-bg:             var(--#{$prefix}primary) !default;\n$chip-active-border-color:   transparent !default;\n\n$chip-hover-color:           $chip-color !default;\n$chip-hover-bg:              color-mix(in srgb, var(--#{$prefix}secondary-bg) 95%, #000) !default;\n$chip-hover-border-color:    transparent !default;\n\n$chip-font-size-sm:          .75rem !default;\n$chip-height-sm:             1.5rem !default;\n$chip-padding-x-sm:          .625rem !default;\n$chip-gap-sm:                .25rem !default;\n$chip-icon-size-sm:          .875rem !default;\n$chip-img-size-sm:           1rem !default;\n$chip-remove-size-sm:        .875rem !default;\n\n$chip-font-size-lg:          1rem !default;\n$chip-height-lg:             2rem !default;\n$chip-padding-x-lg:          .75rem !default;\n$chip-gap-lg:                .375rem !default;\n$chip-icon-size-lg:          1.25rem !default;\n$chip-img-size-lg:           1.5rem !default;\n$chip-remove-size-lg:        1.25rem !default;\n// scss-docs-end chip-variables\n\n.chip {\n  // scss-docs-start chip-css-vars\n  --#{$prefix}chip-height: #{$chip-height};\n  --#{$prefix}chip-padding-x: #{$chip-padding-x};\n  --#{$prefix}chip-gap: #{$chip-gap};\n  --#{$prefix}chip-font-size: #{$chip-font-size};\n  --#{$prefix}chip-font-weight: #{$chip-font-weight};\n  --#{$prefix}chip-border-radius: #{$chip-border-radius};\n  --#{$prefix}chip-img-size: #{$chip-img-size};\n  --#{$prefix}chip-img-border-radius: #{$chip-img-border-radius};\n  --#{$prefix}chip-icon-size: #{$chip-icon-size};\n  --#{$prefix}chip-remove-size: #{$chip-remove-size};\n  --#{$prefix}chip-remove-opacity: #{$chip-remove-opacity};\n  --#{$prefix}chip-remove-hover-opacity: #{$chip-remove-hover-opacity};\n  --#{$prefix}chip-transition: #{$chip-transition};\n\n  --#{$prefix}chip-color: var(--#{$prefix}text-emphasis, #{$chip-color});\n  --#{$prefix}chip-bg: var(--#{$prefix}bg-subtle, #{$chip-bg});\n  --#{$prefix}chip-border-width: #{$chip-border-width};\n  --#{$prefix}chip-border-color: #{$chip-border-color};\n\n  --#{$prefix}chip-active-color: var(--#{$prefix}contrast, #{$chip-active-color});\n  --#{$prefix}chip-active-bg: var(--#{$prefix}color, #{$chip-active-bg});\n  --#{$prefix}chip-active-border-color: #{$chip-active-border-color};\n\n  --#{$prefix}chip-hover-color: var(--#{$prefix}contrast, #{$chip-hover-color});\n  --#{$prefix}chip-hover-bg: var(--#{$prefix}color, #{$chip-hover-bg});\n  --#{$prefix}chip-hover-border-color: #{$chip-hover-border-color};\n  // scss-docs-end chip-css-vars\n\n  display: inline-flex;\n  gap: var(--#{$prefix}chip-gap);\n  align-items: center;\n  height: var(--#{$prefix}chip-height);\n  padding-inline: var(--#{$prefix}chip-padding-x);\n  font-size: var(--#{$prefix}chip-font-size);\n  font-weight: var(--#{$prefix}chip-font-weight);\n  color: var(--#{$prefix}chip-color);\n  text-decoration: none;\n  white-space: nowrap;\n  vertical-align: middle;\n  background-color: var(--#{$prefix}chip-bg);\n  border: var(--#{$prefix}chip-border-width) solid var(--#{$prefix}chip-border-color);\n  @include border-radius(var(--#{$prefix}chip-border-radius));\n  @include transition(var(--#{$prefix}chip-transition));\n\n  &.active {\n    color: var(--#{$prefix}chip-active-color);\n    background-color: var(--#{$prefix}chip-active-bg);\n    border-color: var(--#{$prefix}chip-active-border-color);\n  }\n\n  &.disabled,\n  &:disabled {\n    pointer-events: none;\n    opacity: .65;\n  }\n\n  &:focus-visible {\n    @include focus-ring();\n  }\n\n  .avatar {\n    --#{$prefix}avatar-width: var(--#{$prefix}chip-img-size);\n    --#{$prefix}avatar-height: var(--#{$prefix}chip-img-size);\n\n    font-size: inherit;\n\n    &:first-child {\n      margin-inline-start: -.375rem;\n    }\n  }\n}\n\n.chip-outline {\n  // scss-docs-start chip-outline-css-vars\n  --#{$prefix}chip-color: var(--#{$prefix}color, var(--#{$prefix}body-color));\n  --#{$prefix}chip-bg: transparent;\n  --#{$prefix}chip-border-color: var(--#{$prefix}color, var(--#{$prefix}border-color));\n  --#{$prefix}chip-hover-bg: var(--#{$prefix}bg-subtle, #{$chip-hover-bg});\n  --#{$prefix}chip-hover-color: var(--#{$prefix}text-emphasis, #{$chip-color});\n  --#{$prefix}chip-hover-border-color: var(--#{$prefix}color, var(--#{$prefix}border-color));\n  --#{$prefix}chip-active-bg: var(--#{$prefix}color, #{$chip-active-bg});\n  --#{$prefix}chip-active-color: var(--#{$prefix}contrast, #{$chip-active-color});\n  // scss-docs-end chip-outline-css-vars\n}\n\n.chip-clickable {\n  cursor: pointer;\n\n  &:hover {\n    color: var(--#{$prefix}chip-hover-color);\n    background-color: var(--#{$prefix}chip-hover-bg);\n    border-color: var(--#{$prefix}chip-hover-border-color);\n  }\n\n  &.active:hover {\n    color: var(--#{$prefix}chip-active-color);\n    background-color: var(--#{$prefix}chip-active-bg);\n    opacity: .9;\n  }\n}\n\n.chip-img {\n  width: var(--#{$prefix}chip-img-size);\n  height: var(--#{$prefix}chip-img-size);\n  @include border-radius(var(--#{$prefix}chip-img-border-radius));\n\n  &:first-child {\n    margin-inline-start: -.375rem;\n  }\n}\n\n.chip-icon {\n  display: flex;\n  flex-shrink: 0;\n  align-items: center;\n  justify-content: center;\n  margin-inline-start: calc(var(--#{$prefix}chip-gap) * -.25); // stylelint-disable-line function-disallowed-list\n\n  > svg {\n    display: block; // Prevents baseline alignment issues\n    width: var(--#{$prefix}chip-icon-size);\n    height: var(--#{$prefix}chip-icon-size);\n  }\n\n  > img {\n    width: var(--#{$prefix}chip-icon-size);\n    height: var(--#{$prefix}chip-icon-size);\n    object-fit: cover;\n    @include border-radius(var(--#{$prefix}chip-img-border-radius));\n  }\n}\n\n.chip-check {\n  display: flex;\n  flex-shrink: 0;\n  align-items: center;\n  justify-content: center;\n  margin-inline-start: calc(var(--#{$prefix}chip-gap) * -.25); // stylelint-disable-line function-disallowed-list\n\n  > svg {\n    display: block; // Prevents baseline alignment issues\n    width: var(--#{$prefix}chip-icon-size);\n    height: var(--#{$prefix}chip-icon-size);\n  }\n}\n\n.chip-remove {\n  display: flex;\n  flex-shrink: 0;\n  align-items: center;\n  justify-content: center;\n  width: var(--#{$prefix}chip-min-height);\n  height: var(--#{$prefix}chip-min-height);\n  padding: 0;\n  margin-inline-end: calc(var(--#{$prefix}chip-padding-x) * -.25); // stylelint-disable-line function-disallowed-list\n  color: inherit;\n  cursor: pointer;\n  background: transparent;\n  border: 0;\n  opacity: var(--#{$prefix}chip-remove-opacity);\n  @include transition(opacity .15s ease-in-out);\n\n  &:hover {\n    opacity: var(--#{$prefix}chip-remove-hover-opacity);\n  }\n\n  &:focus-visible {\n    outline: 0;\n    opacity: 1;\n    @include focus-ring();\n  }\n\n  > svg {\n    display: block; // Prevents baseline alignment issues\n    width: var(--#{$prefix}chip-remove-size);\n    height: var(--#{$prefix}chip-remove-size);\n  }\n}\n\n//\n// Chip sizes\n//\n\n.chip-lg,\n.chip-input-lg .chip {\n  @include chip-size(\n    $chip-height-lg,\n    $chip-padding-x-lg,\n    $chip-gap-lg,\n    $chip-font-size-lg,\n    $chip-icon-size-lg,\n    $chip-img-size-lg,\n    $chip-remove-size-lg\n  );\n}\n\n.chip-sm,\n.chip-input-sm .chip {\n  @include chip-size(\n    $chip-height-sm,\n    $chip-padding-x-sm,\n    $chip-gap-sm,\n    $chip-font-size-sm,\n    $chip-icon-size-sm,\n    $chip-img-size-sm,\n    $chip-remove-size-sm\n  );\n}\n\n// scss-docs-start chip-modifiers\n@each $state in map.keys($theme-colors) {\n  .chip-#{$state} {\n    --#{$prefix}bg-subtle: var(--#{$prefix}#{$state}-bg-subtle);\n    --#{$prefix}color: var(--#{$prefix}#{$state});\n    --#{$prefix}color-rgb: var(--#{$prefix}#{$state}-rgb);\n    --#{$prefix}contrast: var(--#{$prefix}#{$state}-contrast);\n    --#{$prefix}text-emphasis: var(--#{$prefix}#{$state}-text-emphasis);\n    --#{$prefix}focus-ring-color: rgba(var(--#{$prefix}#{$state}-rgb), var(--#{$prefix}focus-ring-opacity));\n  }\n}\n// scss-docs-end chip-modifiers\n","@use \"../vendor/rfs\" as *;\n@use \"../variables\" as *;\n\n// scss-docs-start chip-mixin\n@mixin chip-size($height, $padding-x, $chip-gap, $font-size, $img-size, $icon-size, $dismiss-size) {\n  --#{$prefix}chip-height: #{$height};\n  --#{$prefix}chip-padding-x: #{$padding-x};\n  --#{$prefix}chip-gap: #{$chip-gap};\n  @include rfs($font-size, --#{$prefix}chip-font-size);\n  --#{$prefix}chip-img-size: #{$img-size};\n  --#{$prefix}chip-icon-size: #{$icon-size};\n  --#{$prefix}chip-dismiss-size: #{$dismiss-size};\n}\n// scss-docs-end chip-mixin\n","@use \"variables\" as *;\n\n// scss-docs-start chip-set-variables\n$chip-set-gap: .25rem !default;\n// scss-docs-end chip-set-variables\n\n.chip-set {\n  // scss-docs-start chip-set-css-vars\n  --#{$prefix}chip-set-gap: #{$chip-set-gap};\n  // scss-docs-end chip-set-css-vars\n\n  display: flex;\n  flex-wrap: wrap;\n  gap: var(--#{$prefix}chip-set-gap);\n}\n","@use \"sass:map\";\n@use \"mixins/border-radius\" as *;\n@use \"mixins/transition\" as *;\n@use \"variables\" as *;\n\n.avatar {\n  // scss-docs-start avatar-css-vars\n  --#{$prefix}avatar-width: #{$avatar-width};\n  --#{$prefix}avatar-height: #{$avatar-height};\n  --#{$prefix}avatar-font-size: #{$avatar-font-size};\n  --#{$prefix}avatar-border-radius: #{$avatar-border-radius};\n  --#{$prefix}avatar-status-width: #{$avatar-status-width};\n  --#{$prefix}avatar-status-height: #{$avatar-status-height};\n  --#{$prefix}avatar-status-border-radius: #{$avatar-status-border-radius};\n  // scss-docs-end avatar-css-vars\n\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: var(--#{$prefix}avatar-width);\n  height: var(--#{$prefix}avatar-height);\n  font-size: var(--#{$prefix}avatar-font-size);\n  vertical-align: middle;\n  @include border-radius(var(--#{$prefix}avatar-border-radius));\n  @include transition($avatar-transition);\n}\n\n.avatar-img {\n  width: 100%;\n  height: auto;\n  @include border-radius(var(--#{$prefix}avatar-border-radius));\n}\n\n.avatar-status {\n  position: absolute;\n  inset-inline-end: 0;\n  bottom: 0;\n  display: block;\n  width: var(--#{$prefix}avatar-status-width);\n  height: var(--#{$prefix}avatar-status-height);\n  border: 1px solid $white;\n  @include border-radius(var(--#{$prefix}avatar-status-border-radius));\n}\n\n@each $size, $map in $avatar-sizes {\n  .avatar-#{$size} {\n    --#{$prefix}avatar-width: #{map.get($map, \"width\")};\n    --#{$prefix}avatar-height: #{map.get($map, \"height\")};\n    --#{$prefix}avatar-font-size: #{map.get($map, \"font-size\")};\n    --#{$prefix}avatar-status-width: #{map.get($map, \"status-width\")};\n    --#{$prefix}avatar-status-height: #{map.get($map, \"status-height\")};\n  }\n}\n\n.avatars-stack {\n  display: flex;\n\n  .avatar {\n    margin-inline-end: calc(-.4 * var(--#{$prefix}avatar-width)); // stylelint-disable-line function-disallowed-list\n\n    &:last-child {\n      margin-inline-end: 0;\n    }\n\n    &:hover {\n      margin-inline-end: 0;\n    }\n  }\n}\n","@use \"mixins/border-radius\" as *;\n@use \"variables\" as *;\n\n.callout {\n  // scss-docs-start callout-css-vars\n  --#{$prefix}callout-padding-x: #{$callout-padding-x};\n  --#{$prefix}callout-padding-y: #{$callout-padding-y};\n  --#{$prefix}callout-margin-x: #{$callout-margin-x};\n  --#{$prefix}callout-margin-y: #{$callout-margin-y};\n  --#{$prefix}callout-border-width: #{$callout-border-width};\n  --#{$prefix}callout-border-color: #{$callout-border-color};\n  --#{$prefix}callout-border-left-width: #{$callout-border-left-width};\n  --#{$prefix}callout-border-radius: #{$callout-border-radius};\n  // scss-docs-end callout-css-vars\n\n  padding: var(--#{$prefix}callout-padding-y) var(--#{$prefix}callout-padding-x);\n  margin: var(--#{$prefix}callout-margin-y) var(--#{$prefix}callout-margin-x);\n  border: var(--#{$prefix}callout-border-width) solid var(--#{$prefix}callout-border-color);\n  border-inline-start-color: var(--#{$prefix}callout-border-left-color);\n  border-inline-start-width: var(--#{$prefix}callout-border-left-width);\n  @include border-radius(var(--#{$prefix}callout-border-radius));\n}\n\n// scss-docs-start callout-modifiers\n// Generate contextual modifier classes for colorizing the collor.\n@each $state, $value in $callout-variants {\n  .callout-#{$state} {\n    --#{$prefix}callout-border-left-color: #{$value};\n  }\n}\n// scss-docs-end callout-modifiers\n","@use \"variables\" as *;\n\n.footer {\n  // scss-docs-start footer-css-vars\n  --#{$prefix}footer-min-height: #{$footer-min-height};\n  --#{$prefix}footer-padding-x: #{$footer-padding-x};\n  --#{$prefix}footer-padding-y: #{$footer-padding-y};\n  --#{$prefix}footer-color: #{$footer-color};\n  --#{$prefix}footer-bg: #{$footer-bg};\n  --#{$prefix}footer-border-color: #{$footer-border-color};\n  --#{$prefix}footer-border: #{$footer-border-width} solid var(--#{$prefix}footer-border-color);\n  // scss-docs-end footer-css-vars\n\n  display: flex;\n  flex-wrap: wrap; // allow us to do the line break for collapsing content\n  align-items: center;\n  justify-content: space-between;\n  min-height: var(--#{$prefix}footer-min-height);\n  padding: var(--#{$prefix}footer-padding-y) var(--#{$prefix}footer-padding-x);\n  color: var(--#{$prefix}footer-color);\n  background: var(--#{$prefix}footer-bg);\n  border-top: var(--#{$prefix}footer-border);\n}\n\n.footer-fixed {\n  position: fixed;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: $zindex-fixed;\n}\n\n.footer-sticky {\n  position: sticky;\n  bottom: 0;\n  z-index: $zindex-fixed;\n}\n","@use \"functions/escape-svg\" as *;\n@use \"mixins/border-radius\" as *;\n@use \"mixins/breakpoints\" as *;\n@use \"mixins/transition\" as *;\n@use \"vendor/rfs\" as *;\n@use \"variables\" as *;\n\n.header {\n  // scss-docs-start header-css-vars\n  --#{$prefix}header-padding-x: #{$header-padding-x};\n  --#{$prefix}header-padding-y: #{$header-padding-y};\n  --#{$prefix}header-bg: #{$header-bg};\n  --#{$prefix}header-color: #{$header-color};\n  --#{$prefix}header-border-color: #{$header-border-color};\n  --#{$prefix}header-border: #{$header-border-width} solid var(--#{$prefix}header-border-color);\n  --#{$prefix}header-hover-color: #{$header-hover-color};\n  --#{$prefix}header-disabled-color: #{$header-disabled-color};\n  --#{$prefix}header-active-color: #{$header-active-color};\n  --#{$prefix}header-transition: #{$header-transition};\n  --#{$prefix}header-brand-padding-y: #{$header-brand-padding-y};\n  --#{$prefix}header-brand-color: #{$header-brand-color};\n  --#{$prefix}header-brand-hover-color: #{$header-brand-hover-color};\n  --#{$prefix}header-toggler-padding-x: #{$header-toggler-padding-x};\n  --#{$prefix}header-toggler-padding-y: #{$header-toggler-padding-y};\n  --#{$prefix}header-toggler-bg: #{$header-toggler-bg};\n  --#{$prefix}header-toggler-color: #{$header-toggler-color};\n  --#{$prefix}header-toggler-border-radius: #{$header-toggler-border-radius};\n  --#{$prefix}header-toggler-hover-color: #{$header-toggler-hover-color};\n  --#{$prefix}header-toggler-icon-bg: #{escape-svg($header-toggler-icon-bg)};\n  --#{$prefix}header-toggler-hover-icon-bg: #{escape-svg($header-toggler-hover-icon-bg)};\n  --#{$prefix}header-nav-link-padding-x: #{$header-nav-link-padding-x};\n  --#{$prefix}header-nav-link-padding-y: #{$header-nav-link-padding-y};\n  --#{$prefix}header-divider-border-color: #{$header-divider-border-color};\n  --#{$prefix}header-divider-border: #{$header-divider-border-width} solid var(--#{$prefix}header-divider-border-color);\n  // scss-docs-end header-css-vars\n\n  position: relative;\n  display: flex;\n  flex-wrap: wrap; // allow us to do the line break for collapsing content\n  align-items: center;\n  justify-content: space-between; // space out brand from logo\n  padding: var(--#{$prefix}header-padding-y) var(--#{$prefix}header-padding-x);\n  background: var(--#{$prefix}header-bg);\n  border-bottom: var(--#{$prefix}header-border);\n  @include transition(var(--#{$prefix}header-transition));\n\n  // Because flex properties aren't inherited, we need to redeclare these first\n  // few properties so that content nested within behave properly.\n  // The `flex-wrap` property is inherited to simplify the expanded navbars\n  %container-flex-properties {\n    display: flex;\n    flex-wrap: inherit;\n    align-items: center;\n    justify-content: space-between;\n  }\n\n  > .container,\n  > .container-fluid {\n    @extend %container-flex-properties;\n  }\n\n  @each $breakpoint, $container-max-width in $container-max-widths {\n    > .container#{breakpoint-infix($breakpoint, $container-max-widths)} {\n      @extend %container-flex-properties;\n    }\n  }\n\n  &.header-sticky {\n    position: sticky;\n    top: 0;\n    z-index: $zindex-sticky;\n  }\n}\n\n.header-divider {\n  flex-basis: calc(100% + (2 * var(--#{$prefix}header-padding-x))); // stylelint-disable-line function-disallowed-list\n  height: 0;\n  margin: var(--#{$prefix}header-padding-y) calc(-1 * var(--#{$prefix}header-padding-x)); // stylelint-disable-line function-disallowed-list\n  border-top: var(--#{$prefix}header-divider-border);\n}\n\n// Header brand\n//\n// Used for brand, project, or site names.\n\n.header-brand {\n  padding-top: var(--#{$prefix}header-brand-padding-y);\n  padding-bottom: var(--#{$prefix}header-brand-padding-y);\n  margin-inline-end: $header-brand-margin-end;\n  @include font-size($header-brand-font-size);\n  color: var(--#{$prefix}header-brand-color);\n  text-decoration: if(not sass($link-decoration == none): none);\n  white-space: nowrap;\n\n  &:hover,\n  &:focus {\n    color: var(--#{$prefix}header-brand-hover-color);\n    // stylelint-disable-next-line scss/at-function-named-arguments\n    text-decoration: if(sass($link-hover-decoration == underline): none);\n  }\n}\n\n// Header nav\n//\n// Custom navbar navigation (doesn't require `.nav`, but does make use of `.nav-link`).\n\n.header-nav {\n  display: flex;\n  flex-direction: row; // cannot use `inherit` to get the `.header`s value\n  padding-inline-start: 0;\n  margin-bottom: 0;\n  list-style: none;\n\n  .nav-link {\n    padding: var(--#{$prefix}header-nav-link-padding-y) var(--#{$prefix}header-nav-link-padding-x);\n    color: var(--#{$prefix}header-color);\n\n    &:hover,\n    &:focus {\n      color: var(--#{$prefix}header-hover-color);\n    }\n\n    &.disabled {\n      color: var(--#{$prefix}header-disabled-color);\n    }\n  }\n\n  .show > .nav-link,\n  .nav-link.active {\n    color: var(--#{$prefix}header-active-color);\n  }\n\n  .dropdown-menu {\n    position: absolute;\n  }\n}\n\n\n// Header text\n//\n//\n\n.header-text {\n  padding-top: var(--#{$prefix}header-nav-link-padding-y);\n  padding-bottom: var(--#{$prefix}header-nav-link-padding-y);\n  color: var(--#{$prefix}header-color);\n\n  a {\n    color: var(--#{$prefix}header-active-color);\n\n    &:hover,\n    &:focus {\n      color: var(--#{$prefix}header-active-color);\n    }\n  }\n}\n\n.header-toggler {\n  padding: var(--#{$prefix}header-toggler-padding-y) var(--#{$prefix}header-toggler-padding-x);\n  @include font-size($header-toggler-font-size);\n  color: var(--#{$prefix}header-toggler-color);\n  background-color: var(--#{$prefix}header-toggler-bg);\n  border: 0; // remove default button style\n  @include border-radius(var(--#{$prefix}header-toggler-border-radius));\n\n  &:hover {\n    color: var(--#{$prefix}header-toggler-hover-color);\n    text-decoration: none;\n  }\n\n  &:focus {\n    outline: 0;\n  }\n\n  // Opinionated: add \"hand\" cursor to non-disabled .navbar-toggler elements\n  &:not(:disabled) {\n    cursor: pointer;\n  }\n}\n\n.header-toggler-icon {\n  display: block;\n  height: $header-toggler-font-size * 1.25;\n  background-image: var(--#{$prefix}header-toggler-icon-bg);\n  background-repeat: no-repeat;\n  background-position: center center;\n  background-size: 100% 100%;\n\n  &:hover {\n    background-image: var(--#{$prefix}header-toggler-hover-icon-bg);\n  }\n}\n","@use \"mixins/icon\" as *;\n@use \"variables\" as *;\n\n.icon {\n  display: inline-block;\n  color: inherit;\n  text-align: center;\n  vertical-align: -.125rem; // Fix the position of icon\n  fill: currentcolor;\n  &:not(.icon-c-s):not(.icon-custom-size) {\n    @include icon-size($icon-size-base);\n\n    &.icon-xxl {\n      @include icon-size($icon-size-xxl);\n    }\n\n    &.icon-xl {\n      @include icon-size($icon-size-xl);\n    }\n\n    &.icon-lg {\n      @include icon-size($icon-size-lg);\n    }\n\n    &.icon-sm {\n      @include icon-size($icon-size-sm);\n    }\n\n    @for $i from 3 through 9 {\n      &.icon-#{$i}xl {\n        @include icon-size($i * $icon-size-base);\n      }\n    }\n  }\n}\n","// Icon sizes\n@mixin icon-size($icon-size) {\n  width: $icon-size;\n  height: $icon-size;\n  font-size: $icon-size;\n}\n","@use \"variables\" as *;\n@use \"mixins/border-radius\" as *;\n@use \"mixins/box-shadow\" as *;\n@use \"mixins/transition\" as *;\n@use \"vendor/rfs\" as *;\n\n// scss-docs-start search-button-variables\n$search-button-height:              $input-height !default;\n$search-button-padding-x:           $input-padding-x !default;\n$search-button-font-family:         $input-font-family !default;\n$search-button-font-size:           $input-font-size !default;\n$search-button-font-weight:         $input-font-weight !default;\n$search-button-color:               $input-placeholder-color !default;\n$search-button-bg:                  $input-bg !default;\n$search-button-border-width:        $input-border-width !default;\n$search-button-border-color:        $input-border-color !default;\n$search-button-border-radius:       $input-border-radius !default;\n$search-button-box-shadow:          $input-box-shadow !default;\n$search-button-transition:          $input-transition !default;\n\n$search-button-focus-color:         $input-focus-color !default;\n$search-button-focus-bg:            $input-focus-bg !default;\n$search-button-focus-border-color:  $input-focus-border-color !default;\n$search-button-focus-box-shadow:    $input-focus-box-shadow !default;\n\n$search-button-icon-size:           1.125rem !default;\n\n$search-button-keys-gap:            .25rem !default;\n$search-button-key-width:           1.5rem !default;\n$search-button-key-height:          1.5rem !default;\n$search-button-key-padding-inline:  .25rem !default;\n$search-button-key-font-size:       .75rem !default;\n$search-button-key-bg:              var(--#{$prefix}tertiary-bg) !default;\n$search-button-key-border-radius:   var(--#{$prefix}border-radius-sm) !default;\n$search-button-key-active-bg:       var(--#{$prefix}secondary-bg) !default;\n\n$search-button-placeholder-margin-inline:  .55rem 2rem !default;\n// scss-docs-end search-button-variables\n\n.search-button {\n  // scss-docs-start search-button-css-vars\n  --#{$prefix}search-button-height: #{$search-button-height};\n  --#{$prefix}search-button-padding-x: #{$search-button-padding-x};\n  --#{$prefix}search-button-font-family: #{$search-button-font-family};\n  --#{$prefix}search-button-font-size: #{$search-button-font-size};\n  --#{$prefix}search-button-font-weight: #{$search-button-font-weight};\n  --#{$prefix}search-button-color: #{$search-button-color};\n  --#{$prefix}search-button-bg: #{$search-button-bg};\n  --#{$prefix}search-button-border-width: #{$search-button-border-width};\n  --#{$prefix}search-button-border-color: #{$search-button-border-color};\n  --#{$prefix}search-button-border-radius: #{$search-button-border-radius};\n  --#{$prefix}search-button-box-shadow: #{$search-button-box-shadow};\n  --#{$prefix}search-button-transition: #{$search-button-transition};\n  --#{$prefix}search-button-focus-color: #{$search-button-focus-color};\n  --#{$prefix}search-button-focus-bg: #{$search-button-focus-bg};\n  --#{$prefix}search-button-focus-border-color: #{$search-button-focus-border-color};\n  --#{$prefix}search-button-focus-box-shadow: #{$search-button-focus-box-shadow};\n  --#{$prefix}search-button-icon-size: #{$search-button-icon-size};\n  --#{$prefix}search-button-keys-gap: #{$search-button-keys-gap};\n  --#{$prefix}search-button-key-width: #{$search-button-key-width};\n  --#{$prefix}search-button-key-height: #{$search-button-key-height};\n  --#{$prefix}search-button-key-padding-inline: #{$search-button-key-padding-inline};\n  --#{$prefix}search-button-key-font-size: #{$search-button-key-font-size};\n  --#{$prefix}search-button-key-bg: #{$search-button-key-bg};\n  --#{$prefix}search-button-key-border-radius: #{$search-button-key-border-radius};\n  --#{$prefix}search-button-key-active-bg: #{$search-button-key-active-bg};\n  --#{$prefix}search-button-placeholder-margin-inline: #{$search-button-placeholder-margin-inline};\n  // scss-docs-end search-button-css-vars\n\n  display: flex;\n  align-items: center;\n  height: var(--#{$prefix}search-button-height);\n  padding-inline: var(--#{$prefix}search-button-padding-x);\n  font-family: var(--#{$prefix}search-button-font-family);\n  @include font-size(var(--#{$prefix}search-button-font-size));\n  font-weight: var(--#{$prefix}search-button-font-weight);\n  color: var(--#{$prefix}search-button-color);\n  background-color: var(--#{$prefix}search-button-bg);\n  border: var(--#{$prefix}search-button-border-width) solid var(--#{$prefix}search-button-border-color);\n\n  @include border-radius(var(--#{$prefix}search-button-border-radius), 0);\n  @include box-shadow(var(--#{$prefix}search-button-box-shadow));\n  @include transition(var(--#{$prefix}search-button-transition));\n\n  &:focus {\n    color: var(--#{$prefix}search-button-focus-color);\n    background-color: var(--#{$prefix}search-button-focus-bg);\n    border-color: var(--#{$prefix}search-button-focus-border-color);\n    outline: 0;\n    @if $enable-shadows {\n      @include box-shadow(var(--#{$prefix}search-button-box-shadow), var(--#{$prefix}search-button-focus-box-shadow));\n    } @else {\n      // Avoid using mixin so we can pass custom focus shadow properly\n      box-shadow: var(--#{$prefix}search-button-focus-box-shadow);\n    }\n  }\n}\n\n.search-button-icon {\n  width: var(--#{$prefix}search-button-icon-size);\n  height: var(--#{$prefix}search-button-icon-size);\n}\n\n.search-button-keys {\n  display: inline-flex;\n  gap: var(--#{$prefix}search-button-keys-gap);\n  margin-inline-start: auto;\n}\n\n.search-button-key {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-width: var(--#{$prefix}search-button-key-width);\n  height: var(--#{$prefix}search-button-key-height);\n  padding-inline: var(--#{$prefix}search-button-key-padding-inline);\n  font-size: var(--#{$prefix}search-button-key-font-size);\n  background-color: var(--#{$prefix}search-button-key-bg);\n  @include border-radius(var(--#{$prefix}search-button-key-border-radius));\n\n  &.active {\n    background-color: var(--#{$prefix}search-button-key-active-bg);\n  }\n}\n\n.search-button-placeholder {\n  margin-inline: var(--#{$prefix}search-button-placeholder-margin-inline);\n}\n","// stylelint-disable function-disallowed-list\n@use \"../functions/escape-svg\" as *;\n@use \"../mixins/backdrop\" as *;\n@use \"../mixins/border-radius\" as *;\n@use \"../mixins/breakpoints\" as *;\n@use \"../mixins/ltr-rtl\" as *;\n@use \"../mixins/transition\" as *;\n@use \"../variables\" as *;\n@use \"../variables-dark\" as *;\n\n.sidebar {\n  // scss-docs-start sidebar-css-vars\n  --#{$prefix}sidebar-zindex: #{$zindex-sidebar};\n  --#{$prefix}sidebar-width: #{$sidebar-width};\n  --#{$prefix}sidebar-bg: #{$sidebar-bg};\n  --#{$prefix}sidebar-padding-x: #{$sidebar-padding-x};\n  --#{$prefix}sidebar-padding-y: #{$sidebar-padding-y};\n  --#{$prefix}sidebar-color: #{$sidebar-color};\n  --#{$prefix}sidebar-brand-color: #{$sidebar-brand-color};\n  --#{$prefix}sidebar-brand-bg: #{$sidebar-brand-bg};\n  --#{$prefix}sidebar-toggler-height: #{$sidebar-toggler-height};\n  // scss-docs-end sidebar-css-vars\n\n  position: relative;\n  display: flex;\n  flex: 0 0 var(--#{$prefix}sidebar-width);\n  flex-direction: column;\n  // put the nav on the left\n  order: -1;\n  width: var(--#{$prefix}sidebar-width);\n  color: var(--#{$prefix}sidebar-color);\n  background: var(--#{$prefix}sidebar-bg);\n  box-shadow: none;\n  @include transition($sidebar-transition);\n\n  &:not(.sidebar-end) {\n    margin-inline-start: 0;\n  }\n\n  &.sidebar-end {\n    order: 99;\n    margin-inline-end: 0;\n  }\n\n  @include media-breakpoint-up($mobile-breakpoint) {\n    &:not(.hide):not(.sidebar-narrow):not(.sidebar-narrow-unfoldable):not(.sidebar-overlaid) {\n      &:not(.sidebar-end) ~ * {\n        --#{$prefix}sidebar-occupy-start: #{$sidebar-width};\n      }\n      &.sidebar-end ~ * {\n        --#{$prefix}sidebar-occupy-end: #{$sidebar-width};\n      }\n    }\n\n    &.hide {\n      &:not(.sidebar-end) {\n        margin-inline-start: calc(-1 * var(--#{$prefix}sidebar-width));\n      }\n      &.sidebar-end {\n        margin-inline-end: calc(-1 * var(--#{$prefix}sidebar-width));\n\n      }\n    }\n  }\n\n  @include media-breakpoint-down($mobile-breakpoint) {\n    // Some of our components use this property to detect if the sidebar has mobile behavior.\n    --#{$prefix}is-mobile: true;\n\n    position: fixed;\n    top: 0;\n    bottom: 0;\n    z-index: var(--#{$prefix}sidebar-zindex);\n\n    &:not(.sidebar-end) {\n      inset-inline-start: 0;\n\n      &:not(.show) {\n        margin-inline-start: calc(-1 * var(--#{$prefix}sidebar-width));\n      }\n    }\n\n    &.sidebar-end {\n      inset-inline-end: 0;\n\n      &:not(.show) {\n        margin-inline-end: calc(-1 * var(--#{$prefix}sidebar-width));\n      }\n    }\n  }\n}\n\n.sidebar-fixed {\n  position: fixed;\n  top: 0;\n  bottom: 0;\n  z-index: var(--#{$prefix}sidebar-zindex);\n\n  &:not(.sidebar-end) {\n    inset-inline-start: 0;\n  }\n\n  &.sidebar-end {\n    inset-inline-end: 0;\n  }\n}\n\n.sidebar-overlaid {\n  // scss-docs-start sidebar-overlaid-css-vars\n  --#{$prefix}sidebar-overlaid-box-shadow: #{$sidebar-overlaid-box-shadow};\n  // scss-docs-end sidebar-overlaid-css-vars\n\n  @extend .sidebar-fixed;\n\n  &:not(.sidebar-end){\n    margin-inline-start: calc(-1 * var(--#{$prefix}sidebar-width));\n  }\n\n  &.sidebar-end {\n    margin-inline-end: calc(-1 * var(--#{$prefix}sidebar-width));\n  }\n\n  &.show {\n    box-shadow: var(--#{$prefix}sidebar-overlaid-box-shadow);\n\n    &:not(.sidebar-end) {\n      margin-inline-start: 0;\n    }\n\n    &.sidebar-end {\n      margin-inline-end: 0;\n    }\n  }\n}\n\n@each $width, $value in $sidebar-widths {\n  .sidebar-#{$width} {\n    --#{$prefix}sidebar-width: #{$value};\n\n    @include media-breakpoint-up($mobile-breakpoint) {\n      &:not(.hide):not(.sidebar-narrow):not(.sidebar-narrow-unfoldable):not(.sidebar-overlaid) {\n        &:not(.sidebar-end) ~ * {\n          --#{$prefix}sidebar-occupy-start: #{$value};\n        }\n        &.sidebar-end ~ * {\n          --#{$prefix}sidebar-occupy-end: #{$value};\n        }\n      }\n    }\n  }\n}\n\n.sidebar-brand {\n  color: var(--#{$prefix}sidebar-brand-color);\n  white-space: nowrap;\n}\n\n.sidebar-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: var(--#{$prefix}sidebar-padding-y) var(--#{$prefix}sidebar-padding-x);\n\n  .btn-close {\n    padding: calc(var(--#{$prefix}sidebar-padding-y) * .5) calc(var(--#{$prefix}sidebar-padding-x) * .5);\n    margin-inline-end: calc(-.5 * var(--#{$prefix}sidebar-padding-x));\n    margin-top: calc(-.5 * var(--#{$prefix}sidebar-padding-y));\n    margin-bottom: calc(-.5 * var(--#{$prefix}sidebar-padding-y));\n  }\n}\n\n.sidebar-body {\n  padding: var(--#{$prefix}sidebar-padding-y) var(--#{$prefix}sidebar-padding-x);\n}\n\n.sidebar-footer {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: var(--#{$prefix}sidebar-padding-y) var(--#{$prefix}sidebar-padding-x);\n}\n\n.sidebar-toggler {\n  // scss-docs-start sidebar-toggler-css-vars\n  --#{$prefix}sidebar-toggler-width: #{$sidebar-toggler-width};\n  --#{$prefix}sidebar-toggler-bg: #{$sidebar-toggler-bg};\n  --#{$prefix}sidebar-toggler-color: #{$sidebar-toggler-color};\n  --#{$prefix}sidebar-toggler-icon: #{escape-svg($sidebar-toggler-icon)};\n  --#{$prefix}sidebar-toggler-hover-color: #{$sidebar-toggler-hover-color};\n  --#{$prefix}sidebar-toggler-focus-shadow: #{$sidebar-toggler-focus-shadow};\n  --#{$prefix}sidebar-toggler-focus-color: #{$sidebar-toggler-focus-color};\n  --#{$prefix}sidebar-toggler-transition: #{$sidebar-toggler-transition};\n  // scss-docs-end sidebar-toggler-css-vars\n\n  position: relative;\n  box-sizing: content-box;\n  width: var(--#{$prefix}sidebar-toggler-width);\n  height: var(--#{$prefix}sidebar-toggler-height);\n  padding: $sidebar-toggler-padding-y $sidebar-toggler-padding-x;\n  background-color: var(--#{$prefix}sidebar-toggler-bg);\n  border: 0;\n  @include border-radius();\n\n  &::before {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    content: \"\";\n    background-color: var(--#{$prefix}sidebar-toggler-color);\n    mask: var(--#{$prefix}sidebar-toggler-icon) no-repeat center;\n    @include transition(var(--#{$prefix}sidebar-toggler-transition));\n    @include rtl() {\n      transform: rotate(-180deg);\n    }\n  }\n\n  // Override <a>'s hover style\n  &:hover {\n    text-decoration: none;\n    &::before {\n      background-color: var(--#{$prefix}sidebar-toggler-hover-color);\n    }\n  }\n\n  &:focus {\n    outline: 0;\n    box-shadow: var(--#{$prefix}sidebar-toggler-focus-shadow);\n\n    &::before {\n      background-color: var(--#{$prefix}sidebar-toggler-focus-color);\n    }\n  }\n\n  @include media-breakpoint-down($mobile-breakpoint) {\n    display: none;\n  }\n}\n\n\n// Backdrop background\n\n.sidebar-backdrop {\n  // scss-docs-start sidebar-backdrop-css-vars\n  --#{$prefix}backdrop-zindex: #{$zindex-sidebar-backdrop};\n  --#{$prefix}backdrop-bg: #{$sidebar-backdrop-bg};\n  --#{$prefix}backdrop-opacity: #{$sidebar-backdrop-opacity};\n  // scss-docs-end sidebar-backdrop-css-vars\n\n  @include media-breakpoint-down($mobile-breakpoint) {\n    @include overlay-backdrop(var(--#{$prefix}backdrop-zindex), var(--#{$prefix}backdrop-bg), var(--#{$prefix}backdrop-opacity));\n  }\n}\n\n.sidebar-dark {\n  --#{$prefix}body-color: #{$body-color-dark};\n  --#{$prefix}body-bg: #{$body-bg-dark};\n\n  --#{$prefix}emphasis-color: #{$body-emphasis-color-dark};\n\n  --#{$prefix}secondary-color: #{$body-secondary-color-dark};\n  --#{$prefix}secondary-bg: #{$body-secondary-bg-dark};\n\n  --#{$prefix}tertiary-color: #{$body-tertiary-color-dark};\n  --#{$prefix}tertiary-bg: #{$body-tertiary-bg-dark};\n\n  --#{$prefix}border-color: #{$border-color-dark};\n}\n","// Sidebar navigation\n@use \"../functions/escape-svg\" as *;\n@use \"../mixins/border-radius\" as *;\n@use \"../mixins/transition\" as *;\n@use \"../variables\" as *;\n\n.sidebar-nav {\n  // scss-docs-start sidebar-nav-css-vars\n  --#{$prefix}sidebar-nav-padding-x: #{$sidebar-nav-padding-x};\n  --#{$prefix}sidebar-nav-padding-y: #{$sidebar-nav-padding-y};\n  --#{$prefix}sidebar-nav-gap: #{$sidebar-nav-gap};\n\n  --#{$prefix}sidebar-nav-title-padding-x: #{$sidebar-nav-title-padding-x};\n  --#{$prefix}sidebar-nav-title-padding-y: #{$sidebar-nav-title-padding-y};\n  --#{$prefix}sidebar-nav-title-margin-top: #{$sidebar-nav-title-margin-top};\n  --#{$prefix}sidebar-nav-title-color: #{$sidebar-nav-title-color};\n\n  --#{$prefix}sidebar-nav-link-padding-x: #{$sidebar-nav-link-padding-x};\n  --#{$prefix}sidebar-nav-link-padding-y: #{$sidebar-nav-link-padding-y};\n  --#{$prefix}sidebar-nav-link-color: #{$sidebar-nav-link-color};\n  --#{$prefix}sidebar-nav-link-bg: #{$sidebar-nav-link-bg};\n  --#{$prefix}sidebar-nav-link-border-color: #{$sidebar-nav-link-border-color};\n  --#{$prefix}sidebar-nav-link-border-radius: #{$sidebar-nav-link-border-radius};\n  --#{$prefix}sidebar-nav-link-border-width: #{$sidebar-nav-link-border-width};\n\n  --#{$prefix}sidebar-nav-link-active-color: #{$sidebar-nav-link-active-color};\n  --#{$prefix}sidebar-nav-link-active-bg: #{$sidebar-nav-link-active-bg};\n  --#{$prefix}sidebar-nav-link-disabled-color: #{$sidebar-nav-link-disabled-color};\n  --#{$prefix}sidebar-nav-link-hover-color: #{$sidebar-nav-link-hover-color};\n  --#{$prefix}sidebar-nav-link-hover-bg: #{$sidebar-nav-link-hover-bg};\n\n  --#{$prefix}sidebar-nav-link-icon-margin: #{$sidebar-nav-link-icon-margin};\n  --#{$prefix}sidebar-nav-link-icon-color: #{$sidebar-nav-link-icon-color};\n  --#{$prefix}sidebar-nav-link-icon-width: #{$sidebar-nav-link-icon-width};\n  --#{$prefix}sidebar-nav-link-icon-height: #{$sidebar-nav-link-icon-height};\n  --#{$prefix}sidebar-nav-link-icon-font-size: #{$sidebar-nav-link-icon-font-size};\n  --#{$prefix}sidebar-nav-link-active-icon-color: #{$sidebar-nav-link-active-icon-color};\n  --#{$prefix}sidebar-nav-link-disabled-icon-color: #{$sidebar-nav-link-disabled-icon-color};\n  --#{$prefix}sidebar-nav-link-hover-icon-color: #{$sidebar-nav-link-hover-icon-color};\n\n  --#{$prefix}sidebar-nav-link-icon-bullet-size: #{$sidebar-nav-link-icon-bullet-size};\n  --#{$prefix}sidebar-nav-link-icon-bullet-bg: #{$sidebar-nav-link-icon-bullet-bg};\n  --#{$prefix}sidebar-nav-link-icon-bullet-border-width: #{$sidebar-nav-link-icon-bullet-border-width};\n  --#{$prefix}sidebar-nav-link-icon-bullet-border-radius: #{$sidebar-nav-link-icon-bullet-border-radius};\n  --#{$prefix}sidebar-nav-link-icon-bullet-border-color: #{$sidebar-nav-link-icon-bullet-border-color};\n  --#{$prefix}sidebar-nav-link-active-icon-bullet-bg: #{$sidebar-nav-link-active-icon-bullet-bg};\n  --#{$prefix}sidebar-nav-link-active-icon-bullet-border-color: #{$sidebar-nav-link-active-icon-bullet-border-color};\n  --#{$prefix}sidebar-nav-link-disabled-icon-bullet-bg: #{$sidebar-nav-link-disabled-icon-bullet-bg};\n  --#{$prefix}sidebar-nav-link-disabled-icon-bullet-border-color: #{$sidebar-nav-link-disabled-icon-bullet-border-color};\n  --#{$prefix}sidebar-nav-link-hover-icon-bullet-bg: #{$sidebar-nav-link-hover-icon-bullet-bg};\n  --#{$prefix}sidebar-nav-link-hover-icon-bullet-border-color: #{$sidebar-nav-link-hover-icon-bullet-border-color};\n\n  --#{$prefix}sidebar-nav-group-bg: #{$sidebar-nav-group-bg};\n  --#{$prefix}sidebar-nav-group-border-width: #{$sidebar-nav-group-border-width};\n  --#{$prefix}sidebar-nav-group-border-radius: #{$sidebar-nav-group-border-radius};\n  --#{$prefix}sidebar-nav-group-border-color: #{$sidebar-nav-group-border-color};\n  --#{$prefix}sidebar-nav-group-items-padding-y: #{$sidebar-nav-group-items-padding-y};\n  --#{$prefix}sidebar-nav-group-items-padding-x: #{$sidebar-nav-group-items-padding-x};\n  --#{$prefix}sidebar-nav-group-indicator-color: #{$sidebar-nav-group-indicator-color};\n  --#{$prefix}sidebar-nav-group-indicator-icon: #{escape-svg($sidebar-nav-group-indicator-icon)};\n  --#{$prefix}sidebar-nav-group-indicator-hover-color: #{$sidebar-nav-group-indicator-hover-color};\n  --#{$prefix}sidebar-nav-group-indicator-hover-icon: #{escape-svg($sidebar-nav-group-indicator-hover-icon)};\n  --#{$prefix}sidebar-nav-group-toggle-show-color: #{$sidebar-nav-group-toggle-show-color};\n  // scss-docs-end sidebar-nav-css-vars\n\n  position: relative;\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  padding: var(--#{$prefix}sidebar-nav-padding-y) var(--#{$prefix}sidebar-nav-padding-x);\n  margin-bottom: 0;\n  overflow-x: hidden;\n  overflow-y: auto;\n  list-style: none;\n\n  .nav-item + .nav-item,\n  .nav-item + .nav-group,\n  .nav-group + .nav-item,\n  .nav-group + .nav-group,\n  .nav-group-items {\n    margin-top: var(--#{$prefix}sidebar-nav-gap);\n  }\n\n  .nav-title {\n    padding: var(--#{$prefix}sidebar-nav-title-padding-y) var(--#{$prefix}sidebar-nav-title-padding-x);\n    margin-top: var(--#{$prefix}sidebar-nav-title-margin-top);\n    font-size: 80%;\n    font-weight: 700;\n    color: var(--#{$prefix}sidebar-nav-title-color);\n    text-transform: uppercase;\n    @include transition($sidebar-nav-title-transition);\n  }\n\n  .nav-link {\n    display: flex;\n    flex: 1;\n    align-items: center;\n    padding: var(--#{$prefix}sidebar-nav-link-padding-y) var(--#{$prefix}sidebar-nav-link-padding-x);\n    color: var(--#{$prefix}sidebar-nav-link-color);\n    text-decoration: none;\n    white-space: nowrap;\n    background: var(--#{$prefix}sidebar-nav-link-bg);\n    border: var(--#{$prefix}sidebar-nav-link-border-width) solid var(--#{$prefix}sidebar-nav-link-border-color);\n    @include border-radius(var(--#{$prefix}sidebar-nav-link-border-radius));\n    @include transition($sidebar-nav-link-transition);\n\n    &.active {\n      color: var(--#{$prefix}sidebar-nav-link-active-color);\n      background: var(--#{$prefix}sidebar-nav-link-active-bg);\n\n      .nav-icon {\n        color: var(--#{$prefix}sidebar-nav-link-active-icon-color);\n      }\n\n      .nav-icon-bullet {\n        background: var(--#{$prefix}sidebar-nav-link-active-icon-bullet-bg);\n        border-color: var(--#{$prefix}sidebar-nav-link-active-icon-bullet-border-color);\n      }\n    }\n\n    &.disabled {\n      color: var(--#{$prefix}sidebar-nav-link-disabled-color);\n      pointer-events: none;\n      cursor: not-allowed;\n      background: transparent;\n\n      .nav-icon {\n        color: var(--#{$prefix}sidebar-nav-link-disabled-icon-color);\n      }\n\n      .nav-icon-bullet {\n        background: var(--#{$prefix}sidebar-nav-link-disabled-icon-bullet-bg);\n        border-color: var(--#{$prefix}sidebar-nav-link-disabled-icon-bullet-border-color);\n      }\n    }\n\n    @media (hover: hover), (-ms-high-contrast: none) {\n      &:hover {\n        color: var(--#{$prefix}sidebar-nav-link-hover-color);\n        text-decoration: none;\n        background: var(--#{$prefix}sidebar-nav-link-hover-bg);\n\n        .nav-icon {\n          color: var(--#{$prefix}sidebar-nav-link-hover-icon-color);\n        }\n\n        .nav-icon-bullet {\n          background: var(--#{$prefix}sidebar-nav-link-hover-icon-bullet-bg);\n          border-color: var(--#{$prefix}sidebar-nav-link-hover-icon-bullet-border-color);\n        }\n      }\n    }\n  }\n\n  .nav-icon {\n    display: flex;\n    flex: 0 0 var(--#{$prefix}sidebar-nav-link-icon-width);\n    align-items: center;\n    justify-content: center;\n    height: var(--#{$prefix}sidebar-nav-link-icon-height);\n    margin-inline-end: var(--#{$prefix}sidebar-nav-link-icon-margin);\n    font-size: var(--#{$prefix}sidebar-nav-link-icon-font-size);\n    color: var(--#{$prefix}sidebar-nav-link-icon-color);\n    text-align: center;\n    pointer-events: none;\n    fill: currentcolor;\n    @include transition(inherit);\n  }\n\n  .nav-icon-bullet {\n    display: inline-block;\n    width: var(--#{$prefix}sidebar-nav-link-icon-bullet-size);\n    height: var(--#{$prefix}sidebar-nav-link-icon-bullet-size);\n    background: var(--#{$prefix}sidebar-nav-link-icon-bullet-bg);\n    border: var(--#{$prefix}sidebar-nav-link-icon-bullet-border-width) solid var(--#{$prefix}sidebar-nav-link-icon-bullet-border-color);\n    border-radius: var(--#{$prefix}sidebar-nav-link-icon-bullet-border-radius); // stylelint-disable-line property-disallowed-list\n  }\n\n  // stylelint-disable-next-line selector-no-qualifying-type\n  svg.nav-icon {\n    overflow: hidden; // fix chrome 105+ width issue\n  }\n\n  .nav-group {\n    border: var(--#{$prefix}sidebar-nav-group-border-width) solid var(--#{$prefix}sidebar-nav-group-border-color);\n    @include border-radius(var(--#{$prefix}sidebar-nav-group-border-radius));\n    @include transition($sidebar-nav-group-transition);\n\n    &:not(.show) {\n      .nav-group-items,\n      .nav-group-toggle-indicator .show {\n        display: none;\n      }\n    }\n\n    &.show {\n      background: var(--#{$prefix}sidebar-nav-group-bg);\n\n      .nav-group-toggle {\n        color: var(--#{$prefix}sidebar-nav-group-toggle-show-color);\n      }\n\n      > .nav-group-toggle:not(:has(.nav-group-toggle-indicator))::after {\n        transform: rotate(180deg);\n      }\n\n      // stylelint-disable-next-line selector-max-class, selector-max-compound-selectors\n      > .nav-group-toggle .nav-group-toggle-indicator .hide {\n        display: none;\n      }\n    }\n  }\n\n  .nav-group-toggle {\n    cursor: pointer;\n\n    &:not(:has(.nav-group-toggle-indicator))::after {\n      display: block;\n      flex: 0 12px;\n      height: 12px;\n      margin-inline-start: auto;\n      content: \"\";\n      background-color: var(--#{$prefix}sidebar-nav-group-indicator-color);\n      mask-image: var(--#{$prefix}sidebar-nav-group-indicator-icon);\n      @include transition($sidebar-nav-group-indicator-transition);\n    }\n\n    @media (hover: hover), (-ms-high-contrast: none) {\n      &:hover:not(:has(.nav-group-toggle-indicator))::after {\n        background-color: var(--#{$prefix}sidebar-nav-group-indicator-hover-color);\n        mask-image: var(--#{$prefix}sidebar-nav-group-indicator-hover-icon);\n      }\n    }\n  }\n\n  .nav-group-toggle-indicator {\n    margin-inline-start: auto;\n    color: var(--#{$prefix}sidebar-nav-group-indicator-color);\n  }\n\n  .nav-group-items {\n    padding: var(--#{$prefix}sidebar-nav-group-items-padding-y) var(--#{$prefix}sidebar-nav-group-items-padding-x);\n    overflow: hidden;\n    list-style: none;\n    @include transition($sidebar-nav-group-items-transition);\n\n    .nav-link {\n      padding-inline-start: calc(var(--#{$prefix}sidebar-nav-link-padding-x) + var(--#{$prefix}sidebar-nav-link-icon-width) + var(--#{$prefix}sidebar-nav-link-icon-margin)); // stylelint-disable-line function-disallowed-list\n    }\n\n    .nav-icon {\n      margin-inline-start: calc(-1 * (var(--#{$prefix}sidebar-nav-link-icon-width) + var(--#{$prefix}sidebar-nav-link-icon-margin))); // stylelint-disable-line function-disallowed-list\n    }\n  }\n\n  &.compact,\n  .compact {\n    .nav-link {\n      --#{$prefix}sidebar-nav-link-padding-y: #{$sidebar-compact-nav-link-padding-y};\n    }\n  }\n\n  &.sidebar-nav-tree {\n    // scss-docs-start sidebar-nav-tree-css-vars\n    --#{$prefix}sidebar-nav-tree-group-border-color: #{$sidebar-nav-tree-group-border-color};\n    --#{$prefix}sidebar-nav-link-icon-bullet-bg: #{$sidebar-nav-tree-link-icon-bullet-bg};\n    --#{$prefix}sidebar-nav-link-hover-icon-bullet-bg: #{$sidebar-nav-tree-link-hover-icon-bullet-bg};\n    --#{$prefix}sidebar-nav-link-active-icon-bullet-bg: #{$sidebar-nav-tree-link-active-icon-bullet-bg};\n    // scss-docs-end sidebar-nav-tree-css-vars\n\n    .nav-group .nav-group-items {\n      $indent: calc((var(--#{$prefix}sidebar-nav-link-padding-x) + var(--#{$prefix}sidebar-nav-link-icon-width) + var(--#{$prefix}sidebar-nav-link-icon-margin)) / 2); // stylelint-disable-line function-disallowed-list\n\n      position: relative;\n      z-index: 0;\n      padding-inline-start: $indent;\n\n      &::before {\n        position: absolute;\n        inset-inline-start: calc($indent + 1.5px); // stylelint-disable-line function-disallowed-list\n        top: 0;\n        z-index: -1;\n        height: 100%;\n        content: \"\";\n        border-inline-start: 1px solid var(--#{$prefix}sidebar-nav-tree-group-border-color);\n      }\n\n      // stylelint-disable-next-line selector-max-class\n      .nav-link {\n        margin-inline-start: calc(-1 * $indent); // stylelint-disable-line function-disallowed-list\n      }\n    }\n  }\n}\n","@use \"../mixins/breakpoints\" as *;\n@use \"../mixins/ltr-rtl\" as *;\n@use \"../variables\" as *;\n@use \"sidebar\" as *;\n\n.sidebar-narrow {\n  // scss-docs-start sidebar-narrow-css-vars\n  --#{$prefix}sidebar-narrow-width: #{$sidebar-narrow-width};\n  --#{$prefix}sidebar-padding-x: #{$sidebar-narrow-padding-x};\n  // scss-docs-end sidebar-narrow-css-vars\n\n  @include media-breakpoint-up($mobile-breakpoint) {\n    flex: 0 0 var(--#{$prefix}sidebar-narrow-width);\n    width: var(--#{$prefix}sidebar-narrow-width);\n    padding-bottom: var(--#{$prefix}sidebar-toggler-height);\n    overflow: visible;\n\n    .sidebar-header {\n      justify-content: center;\n      padding-inline: 0;\n    }\n\n    .sidebar-nav {\n      --#{$prefix}sidebar-nav-link-padding-x: #{$sidebar-narrow-nav-link-padding-x};\n      --#{$prefix}sidebar-nav-link-padding-y: #{$sidebar-narrow-nav-link-padding-y};\n    }\n\n    .nav-link {\n      overflow: hidden;\n    }\n\n    .nav-icon {\n      flex: 0 0 calc(var(--#{$prefix}sidebar-narrow-width) - (var(--#{$prefix}sidebar-nav-padding-x) * 2) - (var(--#{$prefix}sidebar-nav-link-padding-x) * 2)); // stylelint-disable-line function-disallowed-list\n    }\n\n    .nav-label,\n    .nav-title,\n    .nav-group-items,\n    .sidebar-form {\n      height: 0 !important; // stylelint-disable-line declaration-no-important\n      padding: 0 !important; // stylelint-disable-line declaration-no-important\n      margin: 0 !important; // stylelint-disable-line declaration-no-important\n      visibility: hidden;\n      opacity: 0;\n    }\n\n    .d-narrow-none, // deprecated, TODO: remove in v6.0.0\n    .sidebar-brand-full, // deprecated, TODO: remove in v6.0.0\n    .d-sidebar-narrow-none {\n      display: none !important // stylelint-disable-line declaration-no-important\n    }\n\n    .sidebar-toggler::before {\n      @include ltr-rtl(\"transform\", rotate(-180deg), null, rotate(0deg));\n    }\n\n    &.sidebar-end .sidebar-toggler::before {\n      transform: rotate(0deg);\n    }\n  }\n}\n\n.sidebar-narrow-unfoldable {\n  // scss-docs-start sidebar-narrow-unfoldable-css-vars\n  --#{$prefix}sidebar-narrow-unfoldable-box-shadow: #{$sidebar-narrow-unfoldable-box-shadow};\n  // scss-docs-end sidebar-narrow-unfoldable-css-vars\n\n  .d-sidebar-narrow-unfoldable-none {\n    display: none !important // stylelint-disable-line declaration-no-important\n  }\n\n  @extend .sidebar-fixed;\n\n  &:not(:hover) {\n    @extend .sidebar-narrow;\n  }\n\n  &:hover {\n    box-shadow: var(--#{$prefix}sidebar-narrow-unfoldable-box-shadow);\n\n    .sidebar-toggler::before {\n      @include ltr-rtl(\"transform\", rotate(-180deg), null, rotate(0deg));\n    }\n\n    &.sidebar-end .sidebar-toggler::before {\n      transform: rotate(0deg);\n    }\n  }\n}\n\n.sidebar-narrow,\n.sidebar-narrow-unfoldable {\n  @include media-breakpoint-up($mobile-breakpoint) {\n    &:not(.sidebar-end):not(.hide) ~ * {\n      --#{$prefix}sidebar-occupy-start: #{$sidebar-narrow-width};\n    }\n    &.sidebar-end:not(.hide) ~ * {\n      --#{$prefix}sidebar-occupy-end: #{$sidebar-narrow-width};\n    }\n  }\n}\n\n.sidebar:not(.sidebar-narrow) .sidebar-brand-narrow, // deprecated, TODO: remove in v6.0.0\n.sidebar:not(.sidebar-narrow) .d-sidebar-narrow {\n  display: none !important; // stylelint-disable-line declaration-no-important\n}\n\n.sidebar:not(.sidebar-narrow-unfoldable) .d-sidebar-narrow-unfoldable {\n  display: none !important; // stylelint-disable-line declaration-no-important\n}\n","@use \"../functions/color\" as *;\n@use \"../functions/color-contrast\" as *;\n@use \"../functions/to-rgb\" as *;\n@use \"../mixins/color-mode\" as *;\n@use \"../variables\" as *;\n@use \"../variables-dark\" as *;\n\n@each $color, $value in $theme-colors {\n  .text-bg-#{$color} {\n    // stylelint-disable-next-line scss/at-function-named-arguments\n    color: color-contrast($value) if(sass($enable-important-utilities): !important);\n    // stylelint-disable-next-line scss/at-function-named-arguments\n    background-color: rgba(var(--#{$prefix}#{$color}-rgb), var(--#{$prefix}bg-opacity, 1)) if(sass($enable-important-utilities): !important);\n  }\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark) {\n    @each $color, $value in $theme-colors-dark {\n      $color-rgb: to-rgb($value);\n      .text-bg-#{$color} {\n        // stylelint-disable-next-line scss/at-function-named-arguments\n        color: color-contrast($value) if(sass($enable-important-utilities): !important);\n        // stylelint-disable-next-line scss/at-function-named-arguments\n        background-color: rgba($color-rgb, var(--#{$prefix}bg-opacity, 1)) if(sass($enable-important-utilities): !important);\n      }\n    }\n  }\n}\n","@use \"../functions/color\" as *;\n@use \"../functions/color-contrast\" as *;\n@use \"../functions/to-rgb\" as *;\n@use \"../variables\" as *;\n\n@each $color, $value in $theme-colors {\n  .link-#{$color} {\n    // stylelint-disable-next-line scss/at-function-named-arguments\n    color: rgba(var(--#{$prefix}#{$color}-rgb), var(--#{$prefix}link-opacity, 1)) if(sass($enable-important-utilities): !important);\n    // stylelint-disable-next-line scss/at-function-named-arguments\n    text-decoration-color: rgba(var(--#{$prefix}#{$color}-rgb), var(--#{$prefix}link-underline-opacity, 1)) if(sass($enable-important-utilities): !important);\n\n    @if $link-shade-percentage != 0 {\n      &:hover,\n      &:focus {\n        // stylelint-disable-next-line scss/at-function-named-arguments, @stylistic/function-whitespace-after\n        $hover-color: if(sass(color-contrast($value) == $color-contrast-light): shade-color($value, $link-shade-percentage); else: tint-color($value, $link-shade-percentage));\n        // stylelint-disable-next-line scss/at-function-named-arguments\n        color: rgba(#{to-rgb($hover-color)}, var(--#{$prefix}link-opacity, 1)) if(sass($enable-important-utilities): !important);\n        // stylelint-disable-next-line scss/at-function-named-arguments\n        text-decoration-color: rgba(to-rgb($hover-color), var(--#{$prefix}link-underline-opacity, 1)) if(sass($enable-important-utilities): !important);\n      }\n    }\n  }\n}\n\n// One-off special link helper as a bridge until v6\n.link-body-emphasis {\n  // stylelint-disable-next-line scss/at-function-named-arguments\n  color: rgba(var(--#{$prefix}emphasis-color-rgb), var(--#{$prefix}link-opacity, 1)) if(sass($enable-important-utilities): !important);\n  // stylelint-disable-next-line scss/at-function-named-arguments\n  text-decoration-color: rgba(var(--#{$prefix}emphasis-color-rgb), var(--#{$prefix}link-underline-opacity, 1)) if(sass($enable-important-utilities): !important);\n\n  @if $link-shade-percentage != 0 {\n    &:hover,\n    &:focus {\n      // stylelint-disable-next-line scss/at-function-named-arguments\n      color: rgba(var(--#{$prefix}emphasis-color-rgb), var(--#{$prefix}link-opacity, .75)) if(sass($enable-important-utilities): !important);\n      // stylelint-disable-next-line scss/at-function-named-arguments\n      text-decoration-color: rgba(var(--#{$prefix}emphasis-color-rgb), var(--#{$prefix}link-underline-opacity, .75)) if(sass($enable-important-utilities): !important);\n    }\n  }\n}\n","@use \"../variables\" as *;\n\n.focus-ring:focus {\n  outline: 0;\n  // By default, there is no `--cui-focus-ring-x`, `--cui-focus-ring-y`, or `--cui-focus-ring-blur`, but we provide CSS variables with fallbacks to initial `0` values\n  box-shadow: var(--#{$prefix}focus-ring-x, 0) var(--#{$prefix}focus-ring-y, 0) var(--#{$prefix}focus-ring-blur, 0) var(--#{$prefix}focus-ring-width) var(--#{$prefix}focus-ring-color);\n}\n","@use \"../mixins/transition\" as *;\n@use \"../variables\" as *;\n\n.icon-link {\n  display: inline-flex;\n  gap: $icon-link-gap;\n  align-items: center;\n  text-decoration-color: rgba(var(--#{$prefix}link-color-rgb), var(--#{$prefix}link-opacity, .5));\n  text-underline-offset: $icon-link-underline-offset;\n  backface-visibility: hidden;\n\n  > .bi {\n    flex-shrink: 0;\n    width: $icon-link-icon-size;\n    height: $icon-link-icon-size;\n    fill: currentcolor;\n    @include transition($icon-link-icon-transition);\n  }\n}\n\n.icon-link-hover {\n  &:hover,\n  &:focus-visible {\n    > .bi {\n      transform: var(--#{$prefix}icon-link-transform, $icon-link-icon-transform);\n    }\n  }\n}\n","@use \"../variables\" as *;\n\n// Credit: Nicolas Gallagher and SUIT CSS.\n\n.ratio {\n  position: relative;\n  width: 100%;\n\n  &::before {\n    display: block;\n    padding-top: var(--#{$prefix}aspect-ratio);\n    content: \"\";\n  }\n\n  > * {\n    position: absolute;\n    inset-inline-start: 0;\n    top: 0;\n    width: 100%;\n    height: 100%;\n  }\n}\n\n@each $key, $ratio in $aspect-ratios {\n  .ratio-#{$key} {\n    --#{$prefix}aspect-ratio: #{$ratio};\n  }\n}\n","@use \"sass:map\";\n@use \"../mixins/breakpoints\" as *;\n@use \"../variables\" as *;\n\n// Shorthand\n\n.fixed-top {\n  position: fixed;\n  top: 0;\n  right: 0;\n  left: 0;\n  z-index: $zindex-fixed;\n}\n\n.fixed-bottom {\n  position: fixed;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: $zindex-fixed;\n}\n\n// Responsive sticky top and bottom\n@each $breakpoint in map.keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .sticky#{$infix}-top {\n      position: sticky;\n      top: 0;\n      z-index: $zindex-sticky;\n    }\n\n    .sticky#{$infix}-bottom {\n      position: sticky;\n      bottom: 0;\n      z-index: $zindex-sticky;\n    }\n  }\n}\n","// scss-docs-start stacks\n.hstack {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  align-self: stretch;\n}\n\n.vstack {\n  display: flex;\n  flex: 1 1 auto;\n  flex-direction: column;\n  align-self: stretch;\n}\n// scss-docs-end stacks\n","@use \"../mixins/visually-hidden\" as *;\n\n//\n// Visually hidden\n//\n\n.visually-hidden,\n.visually-hidden-focusable:not(:focus):not(:focus-within) {\n  @include visually-hidden();\n}\n","// stylelint-disable declaration-no-important\n\n// Hide content visually while keeping it accessible to assistive technologies\n//\n// See: https://www.a11yproject.com/posts/2013-01-11-how-to-hide-content/\n// See: https://kittygiraudel.com/2016/10/13/css-hide-and-seek/\n\n@mixin visually-hidden() {\n  width: 1px !important;\n  height: 1px !important;\n  padding: 0 !important;\n  margin: -1px !important; // Fix for https://github.com/twbs/bootstrap/issues/25686\n  overflow: hidden !important;\n  clip: rect(0, 0, 0, 0) !important;\n  white-space: nowrap !important;\n  border: 0 !important;\n\n  // Fix for positioned table caption that could become anonymous cells\n  &:not(caption) {\n    position: absolute !important;\n  }\n\n  // Fix to prevent overflowing children to become focusable\n  * {\n    overflow: hidden !important;\n  }\n}\n\n// Use to only display content when it's focused, or one of its child elements is focused\n// (i.e. when focus is within the element/container that the class was applied to)\n//\n// Useful for \"Skip to main content\" links; see https://www.w3.org/WAI/WCAG22/Techniques/general/G1.html\n\n@mixin visually-hidden-focusable() {\n  &:not(:focus):not(:focus-within) {\n    @include visually-hidden();\n  }\n}\n","@use \"../variables\" as *;\n\n//\n// Stretched link\n//\n\n.stretched-link {\n  &::#{$stretched-link-pseudo-element} {\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    z-index: $stretched-link-z-index;\n    content: \"\";\n  }\n}\n","@use \"../mixins/text-truncate\" as *;\n\n//\n// Text truncation\n//\n\n.text-truncate {\n  @include text-truncate();\n}\n","// Text truncate\n// Requires inline-block or block for proper styling\n\n@mixin text-truncate() {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n","@use \"../variables\" as *;\n\n.vr {\n  display: inline-block;\n  align-self: stretch;\n  width: $vr-border-width;\n  min-height: 1em;\n  padding: 0;\n  background-color: currentcolor;\n  opacity: $hr-opacity;\n}\n","@use \"sass:list\";\n@use \"sass:map\";\n@use \"sass:meta\";\n@use \"sass:string\";\n@use \"../variables\" as *;\n@use \"../vendor/rfs\" as *;\n@use \"ltr-rtl\" as *;\n\n// Generate selectors for theme variants\n@function theme-prefix($theme, $selector) {\n  @return #{\"[data\" + $data-infix + \"theme=\"$theme + \"] .\" + $theme + \"\\\\:\" + $selector + \", [data\" + $data-infix + \"theme=\"$theme + \"] .\" + $theme + \"\\\\:\" + $selector + \":not([class*='#{$theme}:'])\"};\n}\n\n// Utility generator\n// Used to generate utilities & print utilities\n@mixin generate-utility($utility, $infix: \"\", $is-rfs-media-query: false) {\n  $values: map.get($utility, values);\n\n  // If the values are a list or string, convert it into a map\n  @if meta.type-of($values) == \"string\" or meta.type-of(list.nth($values, 1)) != \"list\" {\n    $values: list.zip($values, $values);\n  }\n\n  @each $key, $value in $values {\n    $properties: map.get($utility, property);\n\n    // Multiple properties are possible, for example with vertical or horizontal margins or paddings\n    @if meta.type-of($properties) == \"string\" {\n      $properties: list.append((), $properties);\n    }\n\n    // Use custom class if present\n    // stylelint-disable-next-line scss/at-function-named-arguments, @stylistic/function-whitespace-after\n    $property-class: if(sass(map.has-key($utility, class)): map.get($utility, class); else: list.nth($properties, 1));\n    // stylelint-disable-next-line scss/at-function-named-arguments\n    $property-class: if(sass($property-class == null): \"\"; else: $property-class);\n\n    // Use custom CSS variable name if present, otherwise default to `class`\n    // stylelint-disable-next-line scss/at-function-named-arguments, @stylistic/function-whitespace-after\n    $css-variable-name: if(sass(map.has-key($utility, css-variable-name)): map.get($utility, css-variable-name); else: map.get($utility, class));\n\n    // State params to generate pseudo-classes\n    // stylelint-disable-next-line scss/at-function-named-arguments, @stylistic/function-whitespace-after\n    $state: if(sass(map.has-key($utility, state)): map.get($utility, state); else: ());\n\n    // stylelint-disable-next-line scss/at-function-named-arguments, @stylistic/function-whitespace-after\n    $infix: if(sass($property-class == \"\" and string.slice($infix, 1, 1) == \"-\"): string.slice($infix, 2); else: $infix);\n\n    // Don't prefix if value key is null (e.g. with shadow class)\n    // stylelint-disable-next-line scss/at-function-named-arguments\n    $property-class-modifier: if(sass($key): if(sass($property-class == \"\" and $infix == \"\"): \"\"; else: \"-\") + $key; else: \"\");\n\n    @if map.get($utility, rfs) {\n      // Inside the media query\n      @if $is-rfs-media-query {\n        $val: rfs-value($value);\n\n        // Do not render anything if fluid and non fluid values are the same\n        // stylelint-disable-next-line scss/at-function-named-arguments\n        $value: if(sass($val == rfs-fluid-value($value)): null; else: $val);\n      }\n      @else {\n        $value: rfs-fluid-value($value);\n      }\n    }\n\n    $is-css-var: map.get($utility, css-var);\n    $is-dark-mode: map.get($utility, dark-mode);\n    $is-local-vars: map.get($utility, local-vars);\n    $is-rtl: map.get($utility, rtl);\n\n    @if $value != null {\n      @if $is-rtl == false {\n        /* rtl:begin:remove */\n      }\n\n      @if $is-css-var {\n        @if $enable-dark-mode and $is-dark-mode {\n          #{theme-prefix(\"dark\", \"#{$property-class + $infix + $property-class-modifier}\")},\n          .#{$property-class + $infix + $property-class-modifier} {\n            --#{$prefix}#{$css-variable-name}: #{$value};\n          }\n        } @else {\n          .#{$property-class + $infix + $property-class-modifier} {\n            --#{$prefix}#{$css-variable-name}: #{$value};\n          }\n        }\n\n        @each $pseudo in $state {\n          .#{$property-class + $infix + $property-class-modifier}-#{$pseudo}:#{$pseudo} {\n            --#{$prefix}#{$css-variable-name}: #{$value};\n          }\n        }\n      } @else {\n        @if $enable-dark-mode and $is-dark-mode {\n          #{theme-prefix(\"dark\", \"#{$property-class + $infix + $property-class-modifier}\")},\n          .#{$property-class + $infix + $property-class-modifier} {\n            @each $property in $properties {\n              @if $is-local-vars {\n                @each $local-var, $variable in $is-local-vars {\n                  --#{$prefix}#{$local-var}: #{$variable};\n                }\n              }\n              // stylelint-disable-next-line scss/at-function-named-arguments\n              #{$property}: $value if(sass($enable-important-utilities): !important);\n            }\n          }\n        } @else {\n          .#{$property-class + $infix + $property-class-modifier} {\n            @each $property in $properties {\n              @if $is-local-vars {\n                @each $local-var, $variable in $is-local-vars {\n                  --#{$prefix}#{$local-var}: #{$variable};\n                }\n              }\n              @if $is-rtl == true {\n                @if (meta.type-of($value) == \"map\") {\n                  @include ltr-rtl($property, map.get($value, \"ltr\"), null, map.get($value, \"rtl\"), if(sass($enable-important-utilities): !important));\n                } @else {\n                  @include ltr-rtl($property, $value, null, null, if(sass($enable-important-utilities): !important));\n                }\n              } @else {\n                // stylelint-disable-next-line scss/at-function-named-arguments\n                #{$property}: $value if(sass($enable-important-utilities): !important);\n              }\n            }\n          }\n        }\n\n        @each $pseudo in $state {\n          .#{$property-class + $infix + $property-class-modifier}-#{$pseudo}:#{$pseudo} {\n            @each $property in $properties {\n              @if $is-local-vars {\n                @each $local-var, $variable in $is-local-vars {\n                  --#{$prefix}#{$local-var}: #{$variable};\n                }\n              }\n              // stylelint-disable-next-line scss/at-function-named-arguments\n              #{$property}: $value if(sass($enable-important-utilities): !important);\n            }\n          }\n        }\n      }\n\n      @if $is-rtl == false {\n        /* rtl:end:remove */\n      }\n    }\n  }\n}\n","@use \"sass:map\";\n@use \"sass:meta\";\n@use \"../utilities\" as *;\n@use \"../mixins/breakpoints\" as *;\n@use \"../mixins/utilities\" as *;\n@use \"../vendor/rfs\" as *;\n@use \"../variables\" as *;\n\n// Loop over each breakpoint\n@each $breakpoint in map.keys($grid-breakpoints) {\n\n  // Generate media query if needed\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    // Loop over each utility property\n    @each $key, $utility in $utilities {\n      // The utility can be disabled with `false`, thus check if the utility is a map first\n      // Only proceed if responsive media queries are enabled or if it's the base media query\n      @if meta.type-of($utility) == \"map\" and (map.get($utility, responsive) or $infix == \"\") {\n        @include generate-utility($utility, $infix);\n      }\n    }\n  }\n}\n\n// RFS rescaling\n@media (min-width: $rfs-mq-value) {\n  @each $breakpoint in map.keys($grid-breakpoints) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    @if (map.get($grid-breakpoints, $breakpoint) < $rfs-breakpoint) {\n      // Loop over each utility property\n      @each $key, $utility in $utilities {\n        // The utility can be disabled with `false`, thus check if the utility is a map first\n        // Only proceed if responsive media queries are enabled or if it's the base media query\n        @if meta.type-of($utility) == \"map\" and map.get($utility, rfs) and (map.get($utility, responsive) or $infix == \"\") {\n          @include generate-utility($utility, $infix, true);\n        }\n      }\n    }\n  }\n}\n\n\n// Print utilities\n@media print {\n  @each $key, $utility in $utilities {\n    // The utility can be disabled with `false`, thus check if the utility is a map first\n    // Then check if the utility needs print styles\n    @if meta.type-of($utility) == \"map\" and map.get($utility, print) == true {\n      @include generate-utility($utility, \"-print\");\n    }\n  }\n}\n","@use \"@coreui/coreui/scss/mixins/border-radius\" as *;\n@use \"@coreui/coreui/scss/mixins/transition\" as *;\n@use \"@coreui/coreui/scss/variables\" as *;\n@use \"variables\" as *;\n\n//\n// Chart.js custom tooltips\n//\n\n.chartjs-tooltip {\n  // scss-docs-start chartjs-tooltip-css-vars\n  --#{$prefix}chartjs-tooltip-zindex: #{$chartjs-tooltip-zindex};\n  --#{$prefix}chartjs-tooltip-padding-x: #{$chartjs-tooltip-padding-x};\n  --#{$prefix}chartjs-tooltip-padding-y: #{$chartjs-tooltip-padding-y};\n  --#{$prefix}chartjs-tooltip-color: #{$chartjs-tooltip-color};\n  --#{$prefix}chartjs-tooltip-bg: #{$chartjs-tooltip-bg};\n  --#{$prefix}chartjs-tooltip-border-radius: #{$chartjs-tooltip-border-radius};\n  --#{$prefix}chartjs-tooltip-transition: #{$chartjs-tooltip-transition};\n  --#{$prefix}chartjs-tooltip-header-margin: #{$chartjs-tooltip-header-margin};\n  --#{$prefix}chartjs-tooltip-header-font-size: #{$chartjs-tooltip-header-font-size};\n  --#{$prefix}chartjs-tooltip-header-font-weight: #{$chartjs-tooltip-header-font-weight};\n  --#{$prefix}chartjs-tooltip-body-font-size: #{$chartjs-tooltip-body-font-size};\n  --#{$prefix}chartjs-tooltip-body-font-weight: #{$chartjs-tooltip-body-font-weight};\n  // scss-docs-end chartjs-tooltip-css-vars\n\n  position: absolute;\n  z-index: var(--#{$prefix}chartjs-tooltip-zindex);\n  padding: var(--#{$prefix}chartjs-tooltip-padding-y) var(--#{$prefix}chartjs-tooltip-padding-x);\n  color: var(--#{$prefix}chartjs-tooltip-color);\n  pointer-events: none;\n  background: var(--#{$prefix}chartjs-tooltip-bg);\n  opacity: 0;\n  transform: translate(-50%, 0);\n  @include border-radius(var(--#{$prefix}chartjs-tooltip-border-radius));\n  @include transition(var(--#{$prefix}chartjs-tooltip-transition));\n}\n\n.chartjs-tooltip-header {\n  margin-bottom: var(--#{$prefix}chartjs-tooltip-header-margin);\n}\n\n.chartjs-tooltip-header-item {\n  font-size: var(--#{$prefix}chartjs-tooltip-header-font-size);\n  font-weight: var(--#{$prefix}chartjs-tooltip-header-font-weight);\n}\n\n.chartjs-tooltip-body-item {\n  align-items: center;\n  font-size: var(--#{$prefix}chartjs-tooltip-body-font-size);\n  font-weight: var(--#{$prefix}chartjs-tooltip-body-font-weight);\n  white-space: nowrap;\n}\n",".simplebar-content {\n  display: flex;\n  flex-direction: column;\n  min-height: 100%;\n}\n","body {\n  background-color: var(--cui-tertiary-bg);\n}\n\n.wrapper {\n  width: 100%;\n  @include ltr-rtl(\"padding-left\", var(--cui-sidebar-occupy-start, 0));\n  @include ltr-rtl(\"padding-right\", var(--cui-sidebar-occupy-end, 0));\n  will-change: auto;\n  @include transition(padding .15s);\n}\n\n.header > .container-fluid,\n.sidebar-header {\n  min-height: calc(4rem + 1px); // stylelint-disable-line function-disallowed-list\n}\n\n.sidebar-brand-full {\n  margin-left: 3px;\n}\n\n.sidebar-header {\n  .nav-underline-border {\n    --cui-nav-underline-border-link-padding-x: 1rem;\n    --cui-nav-underline-border-gap: 0;\n  }\n\n  .nav-link {\n    display: flex;\n    align-items: center;\n    min-height: calc(4rem + 1px); // stylelint-disable-line function-disallowed-list\n  }\n}\n\n.sidebar-toggler {\n  @include ltr-rtl(\"margin-left\", auto);\n}\n\n.sidebar-narrow,\n.sidebar-narrow-unfoldable:not(:hover) {\n  .sidebar-toggler {\n    @include ltr-rtl(\"margin-right\", auto);\n  }\n}\n\n.header > .container-fluid + .container-fluid {\n  min-height: 3rem;\n}\n\n.footer {\n  min-height: calc(3rem + 1px); // stylelint-disable-line function-disallowed-list\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark) {\n    body {\n      background-color: var(--cui-dark-bg-subtle);\n    }\n\n    .footer {\n      --cui-footer-bg: var(--cui-body-bg);\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
